(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1ee4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1ee4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jVQ79", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createApi = $e82bc407ca0fa51b$var$createApi;
parcelRequire("5qEhx");
var $7smOd = parcelRequire("7smOd");

var $7tXKo = parcelRequire("7tXKo");

var $jM2ZR = parcelRequire("jM2ZR");

var $kbizf = parcelRequire("kbizf");
const $e82bc407ca0fa51b$var$FALLBACK_PRECISION = 17;
const $e82bc407ca0fa51b$var$asyncMutex = new $7smOd.default();
function $e82bc407ca0fa51b$var$isCoercibleRational(obj) {
    // prettier-ignore
    const r = obj !== null && (typeof obj === 'object' || typeof obj === 'function') && obj.numerator !== null && (typeof obj.numerator === 'number' || typeof obj.numerator === 'bigint') && obj.denominator !== null && (typeof obj.denominator === 'number' || typeof obj.denominator === 'bigint');
    r && (0, $kbizf.assert)((typeof obj.numerator !== 'number' || Number.isSafeInteger(obj.numerator)) && (typeof obj.denominator !== 'number' || Number.isSafeInteger(obj.denominator)), 'Fraction numerator and denominator must be integers');
    return r;
}
function $e82bc407ca0fa51b$var$createApi(Z3, em) {
    // TODO(ritave): Create a custom linting rule that checks if the provided callbacks to cleanup
    //               Don't capture `this`
    const cleanup = new FinalizationRegistry((callback)=>callback());
    function enableTrace(tag) {
        Z3.enable_trace(tag);
    }
    function disableTrace(tag) {
        Z3.disable_trace(tag);
    }
    function getVersion() {
        return Z3.get_version();
    }
    function getVersionString() {
        const { major: major, minor: minor, build_number: build_number } = Z3.get_version();
        return `${major}.${minor}.${build_number}`;
    }
    function getFullVersion() {
        return Z3.get_full_version();
    }
    function openLog(filename) {
        return Z3.open_log(filename);
    }
    function appendLog(s) {
        Z3.append_log(s);
    }
    function setParam(key, value) {
        if (typeof key === 'string') Z3.global_param_set(key, value.toString());
        else {
            (0, $kbizf.assert)(value === undefined, "Can't provide a Record and second parameter to set_param at the same time");
            Object.entries(key).forEach(([key, value])=>setParam(key, value));
        }
    }
    function resetParams() {
        Z3.global_param_reset_all();
    }
    function getParam(name) {
        return Z3.global_param_get(name);
    }
    function createContext(name, options) {
        const cfg = Z3.mk_config();
        if (options != null) Object.entries(options).forEach(([key, value])=>check(Z3.set_param_value(cfg, key, value.toString())));
        const contextPtr = Z3.mk_context_rc(cfg);
        Z3.set_ast_print_mode(contextPtr, $7tXKo.Z3_ast_print_mode.Z3_PRINT_SMTLIB2_COMPLIANT);
        Z3.del_config(cfg);
        function _assertContext(...ctxs) {
            ctxs.forEach((other)=>(0, $kbizf.assert)('ctx' in other ? ctx === other.ctx : ctx === other, 'Context mismatch'));
        }
        function _assertPtr(ptr) {
            if (ptr == null) throw new TypeError('Expected non-null pointer');
        }
        // call this after every nontrivial call to the underlying API
        function throwIfError() {
            if (Z3.get_error_code(contextPtr) !== $7tXKo.Z3_error_code.Z3_OK) throw new Error(Z3.get_error_msg(ctx.ptr, Z3.get_error_code(ctx.ptr)));
        }
        function check(val) {
            throwIfError();
            return val;
        }
        /////////////
        // Private //
        /////////////
        function _toSymbol(s) {
            if (typeof s === 'number') return check(Z3.mk_int_symbol(contextPtr, s));
            else return check(Z3.mk_string_symbol(contextPtr, s));
        }
        function _fromSymbol(sym) {
            const kind = check(Z3.get_symbol_kind(contextPtr, sym));
            switch(kind){
                case $7tXKo.Z3_symbol_kind.Z3_INT_SYMBOL:
                    return Z3.get_symbol_int(contextPtr, sym);
                case $7tXKo.Z3_symbol_kind.Z3_STRING_SYMBOL:
                    return Z3.get_symbol_string(contextPtr, sym);
                default:
                    (0, $kbizf.assertExhaustive)(kind);
            }
        }
        function _toParams(key, value) {
            const params = Z3.mk_params(contextPtr);
            Z3.params_inc_ref(contextPtr, params);
            // If value is a boolean
            if (typeof value === 'boolean') Z3.params_set_bool(contextPtr, params, _toSymbol(key), value);
            else if (typeof value === 'number') {
                // If value is a uint
                if (Number.isInteger(value)) check(Z3.params_set_uint(contextPtr, params, _toSymbol(key), value));
                else // If value is a double
                check(Z3.params_set_double(contextPtr, params, _toSymbol(key), value));
            } else if (typeof value === 'string') check(Z3.params_set_symbol(contextPtr, params, _toSymbol(key), _toSymbol(value)));
            return params;
        }
        function _toAst(ast) {
            switch(check(Z3.get_ast_kind(contextPtr, ast))){
                case $7tXKo.Z3_ast_kind.Z3_SORT_AST:
                    return _toSort(ast);
                case $7tXKo.Z3_ast_kind.Z3_FUNC_DECL_AST:
                    return new FuncDeclImpl(ast);
                default:
                    return _toExpr(ast);
            }
        }
        function _toSort(ast) {
            switch(check(Z3.get_sort_kind(contextPtr, ast))){
                case $7tXKo.Z3_sort_kind.Z3_BOOL_SORT:
                    return new BoolSortImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_INT_SORT:
                case $7tXKo.Z3_sort_kind.Z3_REAL_SORT:
                    return new ArithSortImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_BV_SORT:
                    return new BitVecSortImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_FLOATING_POINT_SORT:
                    return new FPSortImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_ROUNDING_MODE_SORT:
                    return new FPRMSortImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_SEQ_SORT:
                    return new SeqSortImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_RE_SORT:
                    return new ReSortImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_ARRAY_SORT:
                    return new ArraySortImpl(ast);
                default:
                    if (Z3.is_finite_set_sort(contextPtr, ast)) return new FiniteSetSortImpl(ast);
                    return new SortImpl(ast);
            }
        }
        function _toExpr(ast) {
            const kind = check(Z3.get_ast_kind(contextPtr, ast));
            if (kind === $7tXKo.Z3_ast_kind.Z3_QUANTIFIER_AST) {
                if (Z3.is_lambda(contextPtr, ast)) return new LambdaImpl(ast);
                return new NonLambdaQuantifierImpl(ast);
            }
            const sortKind = check(Z3.get_sort_kind(contextPtr, Z3.get_sort(contextPtr, ast)));
            switch(sortKind){
                case $7tXKo.Z3_sort_kind.Z3_BOOL_SORT:
                    return new BoolImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_INT_SORT:
                    if (kind === $7tXKo.Z3_ast_kind.Z3_NUMERAL_AST) return new IntNumImpl(ast);
                    return new ArithImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_REAL_SORT:
                    if (kind === $7tXKo.Z3_ast_kind.Z3_NUMERAL_AST) return new RatNumImpl(ast);
                    return new ArithImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_BV_SORT:
                    if (kind === $7tXKo.Z3_ast_kind.Z3_NUMERAL_AST) return new BitVecNumImpl(ast);
                    return new BitVecImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_FLOATING_POINT_SORT:
                    if (kind === $7tXKo.Z3_ast_kind.Z3_NUMERAL_AST || kind === $7tXKo.Z3_ast_kind.Z3_APP_AST) return new FPNumImpl(ast);
                    return new FPImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_ROUNDING_MODE_SORT:
                    return new FPRMImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_SEQ_SORT:
                    return new SeqImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_RE_SORT:
                    return new ReImpl(ast);
                case $7tXKo.Z3_sort_kind.Z3_ARRAY_SORT:
                    return new ArrayImpl(ast);
                default:
                    if (Z3.is_finite_set_sort(contextPtr, Z3.get_sort(contextPtr, ast))) return new FiniteSetImpl(ast);
                    return new ExprImpl(ast);
            }
        }
        function _flattenArgs(args) {
            const result = [];
            for (const arg of args)if (isAstVector(arg)) result.push(...arg.values());
            else result.push(arg);
            return result;
        }
        function _toProbe(p) {
            if (isProbe(p)) return p;
            return new ProbeImpl(p);
        }
        function _probeNary(f, args) {
            (0, $kbizf.assert)(args.length > 0, 'At least one argument expected');
            let r = _toProbe(args[0]);
            for(let i = 1; i < args.length; i++)r = new ProbeImpl(check(f(contextPtr, r.ptr, _toProbe(args[i]).ptr)));
            return r;
        }
        ///////////////
        // Functions //
        ///////////////
        function interrupt() {
            check(Z3.interrupt(contextPtr));
        }
        function setPrintMode(mode) {
            Z3.set_ast_print_mode(contextPtr, mode);
        }
        function isModel(obj) {
            const r = obj instanceof ModelImpl;
            r && _assertContext(obj);
            return r;
        }
        function isAst(obj) {
            const r = obj instanceof AstImpl;
            r && _assertContext(obj);
            return r;
        }
        function isSort(obj) {
            const r = obj instanceof SortImpl;
            r && _assertContext(obj);
            return r;
        }
        function isFuncDecl(obj) {
            const r = obj instanceof FuncDeclImpl;
            r && _assertContext(obj);
            return r;
        }
        function isFuncInterp(obj) {
            const r = obj instanceof FuncInterpImpl;
            r && _assertContext(obj);
            return r;
        }
        function isApp(obj) {
            if (!isExpr(obj)) return false;
            const kind = check(Z3.get_ast_kind(contextPtr, obj.ast));
            return kind === $7tXKo.Z3_ast_kind.Z3_NUMERAL_AST || kind === $7tXKo.Z3_ast_kind.Z3_APP_AST;
        }
        function isConst(obj) {
            return isExpr(obj) && isApp(obj) && obj.numArgs() === 0;
        }
        function isExpr(obj) {
            const r = obj instanceof ExprImpl;
            r && _assertContext(obj);
            return r;
        }
        function isVar(obj) {
            return isExpr(obj) && check(Z3.get_ast_kind(contextPtr, obj.ast)) === $7tXKo.Z3_ast_kind.Z3_VAR_AST;
        }
        function isAppOf(obj, kind) {
            return isExpr(obj) && isApp(obj) && obj.decl().kind() === kind;
        }
        function isBool(obj) {
            const r = obj instanceof ExprImpl && obj.sort.kind() === $7tXKo.Z3_sort_kind.Z3_BOOL_SORT;
            r && _assertContext(obj);
            return r;
        }
        function isTrue(obj) {
            return isAppOf(obj, $7tXKo.Z3_decl_kind.Z3_OP_TRUE);
        }
        function isFalse(obj) {
            return isAppOf(obj, $7tXKo.Z3_decl_kind.Z3_OP_FALSE);
        }
        function isAnd(obj) {
            return isAppOf(obj, $7tXKo.Z3_decl_kind.Z3_OP_AND);
        }
        function isOr(obj) {
            return isAppOf(obj, $7tXKo.Z3_decl_kind.Z3_OP_OR);
        }
        function isImplies(obj) {
            return isAppOf(obj, $7tXKo.Z3_decl_kind.Z3_OP_IMPLIES);
        }
        function isNot(obj) {
            return isAppOf(obj, $7tXKo.Z3_decl_kind.Z3_OP_NOT);
        }
        function isEq(obj) {
            return isAppOf(obj, $7tXKo.Z3_decl_kind.Z3_OP_EQ);
        }
        function isDistinct(obj) {
            return isAppOf(obj, $7tXKo.Z3_decl_kind.Z3_OP_DISTINCT);
        }
        function isQuantifier(obj) {
            const r = obj instanceof QuantifierImpl;
            r && _assertContext(obj);
            return r;
        }
        function isArith(obj) {
            const r = obj instanceof ArithImpl;
            r && _assertContext(obj);
            return r;
        }
        function isArithSort(obj) {
            const r = obj instanceof ArithSortImpl;
            r && _assertContext(obj);
            return r;
        }
        function isInt(obj) {
            return isArith(obj) && isIntSort(obj.sort);
        }
        function isIntVal(obj) {
            const r = obj instanceof IntNumImpl;
            r && _assertContext(obj);
            return r;
        }
        function isIntSort(obj) {
            return isSort(obj) && obj.kind() === $7tXKo.Z3_sort_kind.Z3_INT_SORT;
        }
        function isReal(obj) {
            return isArith(obj) && isRealSort(obj.sort);
        }
        function isRealVal(obj) {
            const r = obj instanceof RatNumImpl;
            r && _assertContext(obj);
            return r;
        }
        function isRealSort(obj) {
            return isSort(obj) && obj.kind() === $7tXKo.Z3_sort_kind.Z3_REAL_SORT;
        }
        function isRCFNum(obj) {
            const r = obj instanceof RCFNumImpl;
            r && _assertContext(obj);
            return r;
        }
        function isBitVecSort(obj) {
            const r = obj instanceof BitVecSortImpl;
            r && _assertContext(obj);
            return r;
        }
        function isBitVec(obj) {
            const r = obj instanceof BitVecImpl;
            r && _assertContext(obj);
            return r;
        }
        function isBitVecVal(obj) {
            const r = obj instanceof BitVecNumImpl;
            r && _assertContext(obj);
            return r;
        }
        function isArraySort(obj) {
            const r = obj instanceof ArraySortImpl;
            r && _assertContext(obj);
            return r;
        }
        function isArray(obj) {
            const r = obj instanceof ArrayImpl;
            r && _assertContext(obj);
            return r;
        }
        function isConstArray(obj) {
            return isAppOf(obj, $7tXKo.Z3_decl_kind.Z3_OP_CONST_ARRAY);
        }
        function isFPRMSort(obj) {
            const r = obj instanceof FPRMSortImpl;
            r && _assertContext(obj);
            return r;
        }
        function isFPRM(obj) {
            const r = obj instanceof FPRMImpl;
            r && _assertContext(obj);
            return r;
        }
        function isFPSort(obj) {
            const r = obj instanceof FPSortImpl;
            r && _assertContext(obj);
            return r;
        }
        function isFP(obj) {
            const r = obj instanceof FPImpl;
            r && _assertContext(obj);
            return r;
        }
        function isFPVal(obj) {
            const r = obj instanceof FPNumImpl;
            r && _assertContext(obj);
            return r;
        }
        function isSeqSort(obj) {
            const r = obj instanceof SeqSortImpl;
            r && _assertContext(obj);
            return r;
        }
        function isSeq(obj) {
            const r = obj instanceof SeqImpl;
            r && _assertContext(obj);
            return r;
        }
        function isReSort(obj) {
            const r = obj instanceof ReSortImpl;
            r && _assertContext(obj);
            return r;
        }
        function isRe(obj) {
            const r = obj instanceof ReImpl;
            r && _assertContext(obj);
            return r;
        }
        function isStringSort(obj) {
            return isSeqSort(obj) && obj.isString();
        }
        function isString(obj) {
            return isSeq(obj) && obj.isString();
        }
        function isFiniteSetSort(obj) {
            const r = obj instanceof FiniteSetSortImpl;
            r && _assertContext(obj);
            return r;
        }
        function isFiniteSet(obj) {
            const r = obj instanceof FiniteSetImpl;
            r && _assertContext(obj);
            return r;
        }
        function isProbe(obj) {
            const r = obj instanceof ProbeImpl;
            r && _assertContext(obj);
            return r;
        }
        function isTactic(obj) {
            const r = obj instanceof TacticImpl;
            r && _assertContext(obj);
            return r;
        }
        function isGoal(obj) {
            const r = obj instanceof GoalImpl;
            r && _assertContext(obj);
            return r;
        }
        function isAstVector(obj) {
            const r = obj instanceof AstVectorImpl;
            r && _assertContext(obj);
            return r;
        }
        function eqIdentity(a, b) {
            return a.eqIdentity(b);
        }
        function getVarIndex(obj) {
            (0, $kbizf.assert)(isVar(obj), 'Z3 bound variable expected');
            return Z3.get_index_value(contextPtr, obj.ast);
        }
        function from(value) {
            if (typeof value === 'boolean') return Bool.val(value);
            else if (typeof value === 'number') {
                if (!Number.isFinite(value)) throw new Error(`cannot represent infinity/NaN (got ${value})`);
                if (Math.floor(value) === value) return Int.val(value);
                return Real.val(value);
            } else if ($e82bc407ca0fa51b$var$isCoercibleRational(value)) return Real.val(value);
            else if (typeof value === 'bigint') return Int.val(value);
            else if (isExpr(value)) return value;
            (0, $kbizf.assert)(false);
        }
        async function solve(...assertions) {
            const solver = new ctx.Solver();
            solver.add(...assertions);
            const result = await solver.check();
            if (result === 'sat') return solver.model();
            return result;
        }
        ///////////////////////////////
        // expression simplification //
        ///////////////////////////////
        async function simplify(e) {
            const result = await Z3.simplify(contextPtr, e.ast);
            return _toExpr(check(result));
        }
        /////////////
        // Objects //
        /////////////
        const Sort = {
            declare: (name)=>new SortImpl(Z3.mk_uninterpreted_sort(contextPtr, _toSymbol(name)))
        };
        const Function = {
            declare: (name, ...signature)=>{
                const arity = signature.length - 1;
                const rng = signature[arity];
                _assertContext(rng);
                const dom = [];
                for(let i = 0; i < arity; i++){
                    _assertContext(signature[i]);
                    dom.push(signature[i].ptr);
                }
                return new FuncDeclImpl(Z3.mk_func_decl(contextPtr, _toSymbol(name), dom, rng.ptr));
            },
            fresh: (...signature)=>{
                const arity = signature.length - 1;
                const rng = signature[arity];
                _assertContext(rng);
                const dom = [];
                for(let i = 0; i < arity; i++){
                    _assertContext(signature[i]);
                    dom.push(signature[i].ptr);
                }
                return new FuncDeclImpl(Z3.mk_fresh_func_decl(contextPtr, 'f', dom, rng.ptr));
            }
        };
        const RecFunc = {
            declare: (name, ...signature)=>{
                const arity = signature.length - 1;
                const rng = signature[arity];
                _assertContext(rng);
                const dom = [];
                for(let i = 0; i < arity; i++){
                    _assertContext(signature[i]);
                    dom.push(signature[i].ptr);
                }
                return new FuncDeclImpl(Z3.mk_rec_func_decl(contextPtr, _toSymbol(name), dom, rng.ptr));
            },
            addDefinition: (f, args, body)=>{
                _assertContext(f, ...args, body);
                check(Z3.add_rec_def(contextPtr, f.ptr, args.map((arg)=>arg.ast), body.ast));
            }
        };
        const Bool = {
            sort: ()=>new BoolSortImpl(Z3.mk_bool_sort(contextPtr)),
            const: (name)=>new BoolImpl(Z3.mk_const(contextPtr, _toSymbol(name), Bool.sort().ptr)),
            consts: (names)=>{
                if (typeof names === 'string') names = names.split(' ');
                return names.map((name)=>Bool.const(name));
            },
            vector: (prefix, count)=>{
                const result = [];
                for(let i = 0; i < count; i++)result.push(Bool.const(`${prefix}__${i}`));
                return result;
            },
            fresh: (prefix = 'b')=>new BoolImpl(Z3.mk_fresh_const(contextPtr, prefix, Bool.sort().ptr)),
            val: (value)=>{
                if (value) return new BoolImpl(Z3.mk_true(contextPtr));
                return new BoolImpl(Z3.mk_false(contextPtr));
            }
        };
        const Int = {
            sort: ()=>new ArithSortImpl(Z3.mk_int_sort(contextPtr)),
            const: (name)=>new ArithImpl(Z3.mk_const(contextPtr, _toSymbol(name), Int.sort().ptr)),
            consts: (names)=>{
                if (typeof names === 'string') names = names.split(' ');
                return names.map((name)=>Int.const(name));
            },
            vector: (prefix, count)=>{
                const result = [];
                for(let i = 0; i < count; i++)result.push(Int.const(`${prefix}__${i}`));
                return result;
            },
            fresh: (prefix = 'x')=>new ArithImpl(Z3.mk_fresh_const(contextPtr, prefix, Int.sort().ptr)),
            val: (value)=>{
                (0, $kbizf.assert)(typeof value === 'bigint' || typeof value === 'string' || Number.isSafeInteger(value));
                return new IntNumImpl(check(Z3.mk_numeral(contextPtr, value.toString(), Int.sort().ptr)));
            }
        };
        const Real = {
            sort: ()=>new ArithSortImpl(Z3.mk_real_sort(contextPtr)),
            const: (name)=>new ArithImpl(check(Z3.mk_const(contextPtr, _toSymbol(name), Real.sort().ptr))),
            consts: (names)=>{
                if (typeof names === 'string') names = names.split(' ');
                return names.map((name)=>Real.const(name));
            },
            vector: (prefix, count)=>{
                const result = [];
                for(let i = 0; i < count; i++)result.push(Real.const(`${prefix}__${i}`));
                return result;
            },
            fresh: (prefix = 'b')=>new ArithImpl(Z3.mk_fresh_const(contextPtr, prefix, Real.sort().ptr)),
            val: (value)=>{
                if ($e82bc407ca0fa51b$var$isCoercibleRational(value)) value = `${value.numerator}/${value.denominator}`;
                return new RatNumImpl(Z3.mk_numeral(contextPtr, value.toString(), Real.sort().ptr));
            }
        };
        const RCFNum = Object.assign((value)=>new RCFNumImpl(value), {
            pi: ()=>new RCFNumImpl(check(Z3.rcf_mk_pi(contextPtr))),
            e: ()=>new RCFNumImpl(check(Z3.rcf_mk_e(contextPtr))),
            infinitesimal: ()=>new RCFNumImpl(check(Z3.rcf_mk_infinitesimal(contextPtr))),
            roots: (coefficients)=>{
                (0, $kbizf.assert)(coefficients.length > 0, 'Polynomial coefficients cannot be empty');
                const coeffPtrs = coefficients.map((c)=>c.ptr);
                const { rv: numRoots, roots: rootPtrs } = Z3.rcf_mk_roots(contextPtr, coeffPtrs);
                const result = [];
                for(let i = 0; i < numRoots; i++)result.push(new RCFNumImpl(rootPtrs[i]));
                return result;
            }
        });
        const BitVec = {
            sort (bits) {
                (0, $kbizf.assert)(Number.isSafeInteger(bits), 'number of bits must be an integer');
                return new BitVecSortImpl(Z3.mk_bv_sort(contextPtr, bits));
            },
            const (name, bits) {
                return new BitVecImpl(check(Z3.mk_const(contextPtr, _toSymbol(name), isBitVecSort(bits) ? bits.ptr : BitVec.sort(bits).ptr)));
            },
            consts (names, bits) {
                if (typeof names === 'string') names = names.split(' ');
                return names.map((name)=>BitVec.const(name, bits));
            },
            val (value, bits) {
                if (value === true) return BitVec.val(1, bits);
                else if (value === false) return BitVec.val(0, bits);
                return new BitVecNumImpl(check(Z3.mk_numeral(contextPtr, value.toString(), isBitVecSort(bits) ? bits.ptr : BitVec.sort(bits).ptr)));
            }
        };
        const Float = {
            sort (ebits, sbits) {
                (0, $kbizf.assert)(Number.isSafeInteger(ebits) && ebits > 0, 'ebits must be a positive integer');
                (0, $kbizf.assert)(Number.isSafeInteger(sbits) && sbits > 0, 'sbits must be a positive integer');
                return new FPSortImpl(Z3.mk_fpa_sort(contextPtr, ebits, sbits));
            },
            sort16 () {
                return new FPSortImpl(Z3.mk_fpa_sort_16(contextPtr));
            },
            sort32 () {
                return new FPSortImpl(Z3.mk_fpa_sort_32(contextPtr));
            },
            sort64 () {
                return new FPSortImpl(Z3.mk_fpa_sort_64(contextPtr));
            },
            sort128 () {
                return new FPSortImpl(Z3.mk_fpa_sort_128(contextPtr));
            },
            const (name, sort) {
                return new FPImpl(check(Z3.mk_const(contextPtr, _toSymbol(name), sort.ptr)));
            },
            consts (names, sort) {
                if (typeof names === 'string') names = names.split(' ');
                return names.map((name)=>Float.const(name, sort));
            },
            val (value, sort) {
                return new FPNumImpl(check(Z3.mk_fpa_numeral_double(contextPtr, value, sort.ptr)));
            },
            NaN (sort) {
                return new FPNumImpl(check(Z3.mk_fpa_nan(contextPtr, sort.ptr)));
            },
            inf (sort, negative = false) {
                return new FPNumImpl(check(Z3.mk_fpa_inf(contextPtr, sort.ptr, negative)));
            },
            zero (sort, negative = false) {
                return new FPNumImpl(check(Z3.mk_fpa_zero(contextPtr, sort.ptr, negative)));
            }
        };
        const FloatRM = {
            sort () {
                return new FPRMSortImpl(Z3.mk_fpa_rounding_mode_sort(contextPtr));
            },
            RNE () {
                return new FPRMImpl(check(Z3.mk_fpa_rne(contextPtr)));
            },
            RNA () {
                return new FPRMImpl(check(Z3.mk_fpa_rna(contextPtr)));
            },
            RTP () {
                return new FPRMImpl(check(Z3.mk_fpa_rtp(contextPtr)));
            },
            RTN () {
                return new FPRMImpl(check(Z3.mk_fpa_rtn(contextPtr)));
            },
            RTZ () {
                return new FPRMImpl(check(Z3.mk_fpa_rtz(contextPtr)));
            }
        };
        const String = {
            sort () {
                return new SeqSortImpl(Z3.mk_string_sort(contextPtr));
            },
            const (name) {
                return new SeqImpl(check(Z3.mk_const(contextPtr, _toSymbol(name), String.sort().ptr)));
            },
            consts (names) {
                if (typeof names === 'string') names = names.split(' ');
                return names.map((name)=>String.const(name));
            },
            val (value) {
                return new SeqImpl(check(Z3.mk_string(contextPtr, value)));
            },
            fromCode (code) {
                const codeExpr = isArith(code) ? code : Int.val(code);
                return new SeqImpl(check(Z3.mk_string_from_code(contextPtr, codeExpr.ast)));
            },
            fromInt (n) {
                const nExpr = isArith(n) ? n : Int.val(n);
                return new SeqImpl(check(Z3.mk_int_to_str(contextPtr, nExpr.ast)));
            }
        };
        const Seq = {
            sort (elemSort) {
                return new SeqSortImpl(Z3.mk_seq_sort(contextPtr, elemSort.ptr));
            },
            empty (elemSort) {
                return new SeqImpl(check(Z3.mk_seq_empty(contextPtr, Seq.sort(elemSort).ptr)));
            },
            unit (elem) {
                return new SeqImpl(check(Z3.mk_seq_unit(contextPtr, elem.ast)));
            }
        };
        const Re = {
            sort (seqSort) {
                return new ReSortImpl(Z3.mk_re_sort(contextPtr, seqSort.ptr));
            },
            toRe (seq) {
                const seqExpr = isSeq(seq) ? seq : String.val(seq);
                return new ReImpl(check(Z3.mk_seq_to_re(contextPtr, seqExpr.ast)));
            }
        };
        const Array = {
            sort (...sig) {
                const arity = sig.length - 1;
                const r = sig[arity];
                const d = sig[0];
                if (arity === 1) return new ArraySortImpl(Z3.mk_array_sort(contextPtr, d.ptr, r.ptr));
                const dom = sig.slice(0, arity);
                return new ArraySortImpl(Z3.mk_array_sort_n(contextPtr, dom.map((s)=>s.ptr), r.ptr));
            },
            const (name, ...sig) {
                return new ArrayImpl(check(Z3.mk_const(contextPtr, _toSymbol(name), Array.sort(...sig).ptr)));
            },
            consts (names, ...sig) {
                if (typeof names === 'string') names = names.split(' ');
                return names.map((name)=>Array.const(name, ...sig));
            },
            K (domain, value) {
                return new ArrayImpl(check(Z3.mk_const_array(contextPtr, domain.ptr, value.ptr)));
            },
            fromFunc (f) {
                return new ArrayImpl(check(Z3.mk_as_array(contextPtr, f.ptr)));
            }
        };
        const Set = {
            // reference: https://z3prover.github.io/api/html/namespacez3py.html#a545f894afeb24caa1b88b7f2a324ee7e
            sort (sort) {
                return Array.sort(sort, Bool.sort());
            },
            const (name, sort) {
                return new SetImpl(check(Z3.mk_const(contextPtr, _toSymbol(name), Array.sort(sort, Bool.sort()).ptr)));
            },
            consts (names, sort) {
                if (typeof names === 'string') names = names.split(' ');
                return names.map((name)=>Set.const(name, sort));
            },
            empty (sort) {
                return EmptySet(sort);
            },
            val (values, sort) {
                var result = EmptySet(sort);
                for (const value of values)result = SetAdd(result, value);
                return result;
            }
        };
        const FiniteSet = {
            sort (elemSort) {
                return new FiniteSetSortImpl(check(Z3.mk_finite_set_sort(contextPtr, elemSort.ptr)));
            },
            const (name, elemSort) {
                return new FiniteSetImpl(check(Z3.mk_const(contextPtr, _toSymbol(name), FiniteSet.sort(elemSort).ptr)));
            },
            consts (names, elemSort) {
                if (typeof names === 'string') names = names.split(' ');
                return names.map((name)=>FiniteSet.const(name, elemSort));
            },
            empty (sort) {
                return new FiniteSetImpl(check(Z3.mk_finite_set_empty(contextPtr, FiniteSet.sort(sort).ptr)));
            },
            singleton (elem) {
                return new FiniteSetImpl(check(Z3.mk_finite_set_singleton(contextPtr, elem.ast)));
            },
            range (low, high) {
                return new FiniteSetImpl(check(Z3.mk_finite_set_range(contextPtr, low.ast, high.ast)));
            }
        };
        const Datatype = Object.assign((name)=>{
            return new DatatypeImpl(ctx, name);
        }, {
            createDatatypes (...datatypes) {
                return createDatatypes(...datatypes);
            },
            createPolymorphicDatatype (typeParams, datatype) {
                return createPolymorphicDatatype(typeParams, datatype);
            }
        });
        function TypeVariable(name) {
            return new SortImpl(check(Z3.mk_type_variable(contextPtr, Z3.mk_string_symbol(contextPtr, name))));
        }
        function If(condition, onTrue, onFalse) {
            if (isProbe(condition) && isTactic(onTrue) && isTactic(onFalse)) return Cond(condition, onTrue, onFalse);
            (0, $kbizf.assert)(!isProbe(condition) && !isTactic(onTrue) && !isTactic(onFalse), 'Mixed expressions and goals');
            if (typeof condition === 'boolean') condition = Bool.val(condition);
            onTrue = from(onTrue);
            onFalse = from(onFalse);
            return _toExpr(check(Z3.mk_ite(contextPtr, condition.ptr, onTrue.ast, onFalse.ast)));
        }
        function Distinct(...exprs) {
            (0, $kbizf.assert)(exprs.length > 0, "Can't make Distinct ouf of nothing");
            return new BoolImpl(check(Z3.mk_distinct(contextPtr, exprs.map((expr)=>{
                expr = from(expr);
                _assertContext(expr);
                return expr.ast;
            }))));
        }
        function Const(name, sort) {
            _assertContext(sort);
            return _toExpr(check(Z3.mk_const(contextPtr, _toSymbol(name), sort.ptr)));
        }
        function Consts(names, sort) {
            _assertContext(sort);
            if (typeof names === 'string') names = names.split(' ');
            return names.map((name)=>Const(name, sort));
        }
        function FreshConst(sort, prefix = 'c') {
            _assertContext(sort);
            return _toExpr(Z3.mk_fresh_const(sort.ctx.ptr, prefix, sort.ptr));
        }
        function Var(idx, sort) {
            _assertContext(sort);
            return _toExpr(Z3.mk_bound(sort.ctx.ptr, idx, sort.ptr));
        }
        function Implies(a, b) {
            a = from(a);
            b = from(b);
            _assertContext(a, b);
            return new BoolImpl(check(Z3.mk_implies(contextPtr, a.ptr, b.ptr)));
        }
        function Iff(a, b) {
            a = from(a);
            b = from(b);
            _assertContext(a, b);
            return new BoolImpl(check(Z3.mk_iff(contextPtr, a.ptr, b.ptr)));
        }
        function Eq(a, b) {
            a = from(a);
            b = from(b);
            _assertContext(a, b);
            return a.eq(b);
        }
        function Xor(a, b) {
            a = from(a);
            b = from(b);
            _assertContext(a, b);
            return new BoolImpl(check(Z3.mk_xor(contextPtr, a.ptr, b.ptr)));
        }
        function Not(a) {
            if (typeof a === 'boolean') a = from(a);
            _assertContext(a);
            if (isProbe(a)) return new ProbeImpl(check(Z3.probe_not(contextPtr, a.ptr)));
            return new BoolImpl(check(Z3.mk_not(contextPtr, a.ptr)));
        }
        function And(...args) {
            if (args.length == 1 && args[0] instanceof ctx.AstVector) {
                args = [
                    ...args[0].values()
                ];
                (0, $kbizf.assert)((0, $kbizf.allSatisfy)(args, isBool) ?? true, 'AstVector containing not bools');
            }
            const allProbes = (0, $kbizf.allSatisfy)(args, isProbe) ?? false;
            if (allProbes) return _probeNary(Z3.probe_and, args);
            else {
                const castArgs = args.map(from);
                _assertContext(...castArgs);
                return new BoolImpl(check(Z3.mk_and(contextPtr, castArgs.map((arg)=>arg.ptr))));
            }
        }
        function Or(...args) {
            if (args.length == 1 && args[0] instanceof ctx.AstVector) {
                args = [
                    ...args[0].values()
                ];
                (0, $kbizf.assert)((0, $kbizf.allSatisfy)(args, isBool) ?? true, 'AstVector containing not bools');
            }
            const allProbes = (0, $kbizf.allSatisfy)(args, isProbe) ?? false;
            if (allProbes) return _probeNary(Z3.probe_or, args);
            else {
                const castArgs = args.map(from);
                _assertContext(...castArgs);
                return new BoolImpl(check(Z3.mk_or(contextPtr, castArgs.map((arg)=>arg.ptr))));
            }
        }
        function PbEq(args, coeffs, k) {
            _assertContext(...args);
            if (args.length !== coeffs.length) throw new Error('Number of arguments and coefficients must match');
            return new BoolImpl(check(Z3.mk_pbeq(contextPtr, args.map((arg)=>arg.ast), coeffs, k)));
        }
        function PbGe(args, coeffs, k) {
            _assertContext(...args);
            if (args.length !== coeffs.length) throw new Error('Number of arguments and coefficients must match');
            return new BoolImpl(check(Z3.mk_pbge(contextPtr, args.map((arg)=>arg.ast), coeffs, k)));
        }
        function PbLe(args, coeffs, k) {
            _assertContext(...args);
            if (args.length !== coeffs.length) throw new Error('Number of arguments and coefficients must match');
            return new BoolImpl(check(Z3.mk_pble(contextPtr, args.map((arg)=>arg.ast), coeffs, k)));
        }
        function AtMost(args, k) {
            _assertContext(...args);
            return new BoolImpl(check(Z3.mk_atmost(contextPtr, args.map((arg)=>arg.ast), k)));
        }
        function AtLeast(args, k) {
            _assertContext(...args);
            return new BoolImpl(check(Z3.mk_atleast(contextPtr, args.map((arg)=>arg.ast), k)));
        }
        function ForAll(quantifiers, body, weight = 1) {
            // Verify all quantifiers are constants
            if (!(0, $kbizf.allSatisfy)(quantifiers, isConst)) throw new Error('Quantifier variables must be constants');
            return new NonLambdaQuantifierImpl(check(Z3.mk_quantifier_const_ex(contextPtr, true, weight, _toSymbol(''), _toSymbol(''), quantifiers.map((q)=>q.ptr), [], [], body.ptr)));
        }
        function Exists(quantifiers, body, weight = 1) {
            // Verify all quantifiers are constants
            if (!(0, $kbizf.allSatisfy)(quantifiers, isConst)) throw new Error('Quantifier variables must be constants');
            return new NonLambdaQuantifierImpl(check(Z3.mk_quantifier_const_ex(contextPtr, false, weight, _toSymbol(''), _toSymbol(''), quantifiers.map((q)=>q.ptr), [], [], body.ptr)));
        }
        function Lambda(quantifiers, expr) {
            // TODO(walden): For some reason LambdaImpl<DomainSort, RangeSort> leads to type issues
            //    and Typescript won't build. I'm not sure why since the types seem to all match
            //    up. For now, we just use any for the domain sort
            // Verify all quantifiers are constants
            if (!(0, $kbizf.allSatisfy)(quantifiers, isConst)) throw new Error('Quantifier variables must be constants');
            return new LambdaImpl(check(Z3.mk_lambda_const(contextPtr, quantifiers.map((q)=>q.ptr), expr.ptr)));
        }
        function ToReal(expr) {
            expr = from(expr);
            _assertContext(expr);
            (0, $kbizf.assert)(isInt(expr), 'Int expression expected');
            return new ArithImpl(check(Z3.mk_int2real(contextPtr, expr.ast)));
        }
        function ToInt(expr) {
            if (!isExpr(expr)) expr = Real.val(expr);
            _assertContext(expr);
            (0, $kbizf.assert)(isReal(expr), 'Real expression expected');
            return new ArithImpl(check(Z3.mk_real2int(contextPtr, expr.ast)));
        }
        function IsInt(expr) {
            if (!isExpr(expr)) expr = Real.val(expr);
            _assertContext(expr);
            (0, $kbizf.assert)(isReal(expr), 'Real expression expected');
            return new BoolImpl(check(Z3.mk_is_int(contextPtr, expr.ast)));
        }
        function Sqrt(a) {
            if (!isExpr(a)) a = Real.val(a);
            return a.pow('1/2');
        }
        function Cbrt(a) {
            if (!isExpr(a)) a = Real.val(a);
            return a.pow('1/3');
        }
        function BV2Int(a, isSigned) {
            _assertContext(a);
            return new ArithImpl(check(Z3.mk_bv2int(contextPtr, a.ast, isSigned)));
        }
        function Int2BV(a, bits) {
            if (isArith(a)) (0, $kbizf.assert)(isInt(a), 'parameter must be an integer');
            else {
                (0, $kbizf.assert)(typeof a !== 'number' || Number.isSafeInteger(a), 'parameter must not have decimal places');
                a = Int.val(a);
            }
            return new BitVecImpl(check(Z3.mk_int2bv(contextPtr, bits, a.ast)));
        }
        function Concat(...bitvecs) {
            _assertContext(...bitvecs);
            return bitvecs.reduce((prev, curr)=>new BitVecImpl(check(Z3.mk_concat(contextPtr, prev.ast, curr.ast))));
        }
        function Cond(probe, onTrue, onFalse) {
            _assertContext(probe, onTrue, onFalse);
            return new TacticImpl(check(Z3.tactic_cond(contextPtr, probe.ptr, onTrue.ptr, onFalse.ptr)));
        }
        function _toTactic(t) {
            return typeof t === 'string' ? new TacticImpl(t) : t;
        }
        function AndThen(t1, t2, ...ts) {
            let result = _toTactic(t1);
            let current = _toTactic(t2);
            _assertContext(result, current);
            result = new TacticImpl(check(Z3.tactic_and_then(contextPtr, result.ptr, current.ptr)));
            for (const t of ts){
                current = _toTactic(t);
                _assertContext(result, current);
                result = new TacticImpl(check(Z3.tactic_and_then(contextPtr, result.ptr, current.ptr)));
            }
            return result;
        }
        function OrElse(t1, t2, ...ts) {
            let result = _toTactic(t1);
            let current = _toTactic(t2);
            _assertContext(result, current);
            result = new TacticImpl(check(Z3.tactic_or_else(contextPtr, result.ptr, current.ptr)));
            for (const t of ts){
                current = _toTactic(t);
                _assertContext(result, current);
                result = new TacticImpl(check(Z3.tactic_or_else(contextPtr, result.ptr, current.ptr)));
            }
            return result;
        }
        const UINT_MAX = 4294967295;
        function Repeat(t, max) {
            const tactic = _toTactic(t);
            _assertContext(tactic);
            const maxVal = max !== undefined ? max : UINT_MAX;
            return new TacticImpl(check(Z3.tactic_repeat(contextPtr, tactic.ptr, maxVal)));
        }
        function TryFor(t, ms) {
            const tactic = _toTactic(t);
            _assertContext(tactic);
            return new TacticImpl(check(Z3.tactic_try_for(contextPtr, tactic.ptr, ms)));
        }
        function When(p, t) {
            const tactic = _toTactic(t);
            _assertContext(p, tactic);
            return new TacticImpl(check(Z3.tactic_when(contextPtr, p.ptr, tactic.ptr)));
        }
        function Skip() {
            return new TacticImpl(check(Z3.tactic_skip(contextPtr)));
        }
        function Fail() {
            return new TacticImpl(check(Z3.tactic_fail(contextPtr)));
        }
        function FailIf(p) {
            _assertContext(p);
            return new TacticImpl(check(Z3.tactic_fail_if(contextPtr, p.ptr)));
        }
        function ParOr(...tactics) {
            (0, $kbizf.assert)(tactics.length > 0, 'ParOr requires at least one tactic');
            const tacticImpls = tactics.map((t)=>_toTactic(t));
            _assertContext(...tacticImpls);
            const tacticPtrs = tacticImpls.map((t)=>t.ptr);
            return new TacticImpl(check(Z3.tactic_par_or(contextPtr, tacticPtrs)));
        }
        function ParAndThen(t1, t2) {
            const tactic1 = _toTactic(t1);
            const tactic2 = _toTactic(t2);
            _assertContext(tactic1, tactic2);
            return new TacticImpl(check(Z3.tactic_par_and_then(contextPtr, tactic1.ptr, tactic2.ptr)));
        }
        function With(t, params) {
            const tactic = _toTactic(t);
            _assertContext(tactic);
            // Convert params to Z3_params
            const z3params = check(Z3.mk_params(contextPtr));
            Z3.params_inc_ref(contextPtr, z3params);
            try {
                for (const [key, value] of Object.entries(params)){
                    const sym = _toSymbol(key);
                    if (typeof value === 'boolean') Z3.params_set_bool(contextPtr, z3params, sym, value);
                    else if (typeof value === 'number') {
                        if (Number.isInteger(value)) Z3.params_set_uint(contextPtr, z3params, sym, value);
                        else Z3.params_set_double(contextPtr, z3params, sym, value);
                    } else if (typeof value === 'string') Z3.params_set_symbol(contextPtr, z3params, sym, _toSymbol(value));
                    else throw new Error(`Unsupported parameter type for ${key}`);
                }
                const result = new TacticImpl(check(Z3.tactic_using_params(contextPtr, tactic.ptr, z3params)));
                return result;
            } finally{
                Z3.params_dec_ref(contextPtr, z3params);
            }
        }
        function LT(a, b) {
            return new BoolImpl(check(Z3.mk_lt(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function GT(a, b) {
            return new BoolImpl(check(Z3.mk_gt(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function LE(a, b) {
            return new BoolImpl(check(Z3.mk_le(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function GE(a, b) {
            return new BoolImpl(check(Z3.mk_ge(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function ULT(a, b) {
            return new BoolImpl(check(Z3.mk_bvult(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function UGT(a, b) {
            return new BoolImpl(check(Z3.mk_bvugt(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function ULE(a, b) {
            return new BoolImpl(check(Z3.mk_bvule(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function UGE(a, b) {
            return new BoolImpl(check(Z3.mk_bvuge(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function SLT(a, b) {
            return new BoolImpl(check(Z3.mk_bvslt(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function SGT(a, b) {
            return new BoolImpl(check(Z3.mk_bvsgt(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function SLE(a, b) {
            return new BoolImpl(check(Z3.mk_bvsle(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function SGE(a, b) {
            return new BoolImpl(check(Z3.mk_bvsge(contextPtr, a.ast, a.sort.cast(b).ast)));
        }
        function Extract(hi, lo, val) {
            return new BitVecImpl(check(Z3.mk_extract(contextPtr, hi, lo, val.ast)));
        }
        function Select(array, ...indices) {
            const args = indices.map((arg, i)=>array.domain_n(i).cast(arg));
            if (args.length === 1) return _toExpr(check(Z3.mk_select(contextPtr, array.ast, args[0].ast)));
            const _args = args.map((arg)=>arg.ast);
            return _toExpr(check(Z3.mk_select_n(contextPtr, array.ast, _args)));
        }
        function Store(array, ...indicesAndValue) {
            const args = indicesAndValue.map((arg, i)=>{
                if (i === indicesAndValue.length - 1) return array.range().cast(arg);
                return array.domain_n(i).cast(arg);
            });
            if (args.length <= 1) throw new Error('Array store requires both index and value arguments');
            if (args.length === 2) return _toExpr(check(Z3.mk_store(contextPtr, array.ast, args[0].ast, args[1].ast)));
            const _idxs = args.slice(0, args.length - 1).map((arg)=>arg.ast);
            return _toExpr(check(Z3.mk_store_n(contextPtr, array.ast, _idxs, args[args.length - 1].ast)));
        }
        /**
         * Create array extensionality index given two arrays with the same sort.
         * The meaning is given by the axiom:
         * (=> (= (select A (array-ext A B)) (select B (array-ext A B))) (= A B))
         * Two arrays are equal if and only if they are equal on the index returned by this function.
         */ function Ext(a, b) {
            return _toExpr(check(Z3.mk_array_ext(contextPtr, a.ast, b.ast)));
        }
        function SetUnion(...args) {
            return new SetImpl(check(Z3.mk_set_union(contextPtr, args.map((arg)=>arg.ast))));
        }
        function SetIntersect(...args) {
            return new SetImpl(check(Z3.mk_set_intersect(contextPtr, args.map((arg)=>arg.ast))));
        }
        function SetDifference(a, b) {
            return new SetImpl(check(Z3.mk_set_difference(contextPtr, a.ast, b.ast)));
        }
        function SetAdd(set, elem) {
            const arg = set.elemSort().cast(elem);
            return new SetImpl(check(Z3.mk_set_add(contextPtr, set.ast, arg.ast)));
        }
        function SetDel(set, elem) {
            const arg = set.elemSort().cast(elem);
            return new SetImpl(check(Z3.mk_set_del(contextPtr, set.ast, arg.ast)));
        }
        function SetComplement(set) {
            return new SetImpl(check(Z3.mk_set_complement(contextPtr, set.ast)));
        }
        function EmptySet(sort) {
            return new SetImpl(check(Z3.mk_empty_set(contextPtr, sort.ptr)));
        }
        function FullSet(sort) {
            return new SetImpl(check(Z3.mk_full_set(contextPtr, sort.ptr)));
        }
        function isMember(elem, set) {
            const arg = set.elemSort().cast(elem);
            return new BoolImpl(check(Z3.mk_set_member(contextPtr, arg.ast, set.ast)));
        }
        function isSubset(a, b) {
            return new BoolImpl(check(Z3.mk_set_subset(contextPtr, a.ast, b.ast)));
        }
        //////////////////////
        // Regular Expressions
        //////////////////////
        function InRe(seq, re) {
            const seqExpr = isSeq(seq) ? seq : String.val(seq);
            return new BoolImpl(check(Z3.mk_seq_in_re(contextPtr, seqExpr.ast, re.ast)));
        }
        function Union(...res) {
            if (res.length === 0) throw new Error('Union requires at least one argument');
            if (res.length === 1) return res[0];
            return new ReImpl(check(Z3.mk_re_union(contextPtr, res.map((r)=>r.ast))));
        }
        function Intersect(...res) {
            if (res.length === 0) throw new Error('Intersect requires at least one argument');
            if (res.length === 1) return res[0];
            return new ReImpl(check(Z3.mk_re_intersect(contextPtr, res.map((r)=>r.ast))));
        }
        function ReConcat(...res) {
            if (res.length === 0) throw new Error('ReConcat requires at least one argument');
            if (res.length === 1) return res[0];
            return new ReImpl(check(Z3.mk_re_concat(contextPtr, res.map((r)=>r.ast))));
        }
        function Plus(re) {
            return new ReImpl(check(Z3.mk_re_plus(contextPtr, re.ast)));
        }
        function Star(re) {
            return new ReImpl(check(Z3.mk_re_star(contextPtr, re.ast)));
        }
        function Option(re) {
            return new ReImpl(check(Z3.mk_re_option(contextPtr, re.ast)));
        }
        function Complement(re) {
            return new ReImpl(check(Z3.mk_re_complement(contextPtr, re.ast)));
        }
        function Diff(a, b) {
            return new ReImpl(check(Z3.mk_re_diff(contextPtr, a.ast, b.ast)));
        }
        function Range(lo, hi) {
            const loSeq = isSeq(lo) ? lo : String.val(lo);
            const hiSeq = isSeq(hi) ? hi : String.val(hi);
            return new ReImpl(check(Z3.mk_re_range(contextPtr, loSeq.ast, hiSeq.ast)));
        }
        /**
         * Create a bounded repetition regex.
         * @param re The regex to repeat
         * @param lo Minimum number of repetitions
         * @param hi Maximum number of repetitions (0 means unbounded, i.e., at least lo)
         */ function Loop(re, lo, hi = 0) {
            return new ReImpl(check(Z3.mk_re_loop(contextPtr, re.ast, lo, hi)));
        }
        function Power(re, n) {
            return new ReImpl(check(Z3.mk_re_power(contextPtr, re.ast, n)));
        }
        function AllChar(reSort) {
            return new ReImpl(check(Z3.mk_re_allchar(contextPtr, reSort.ptr)));
        }
        function Empty(reSort) {
            return new ReImpl(check(Z3.mk_re_empty(contextPtr, reSort.ptr)));
        }
        function Full(reSort) {
            return new ReImpl(check(Z3.mk_re_full(contextPtr, reSort.ptr)));
        }
        function mkPartialOrder(sort, index) {
            return new FuncDeclImpl(check(Z3.mk_partial_order(contextPtr, sort.ptr, index)));
        }
        function mkLinearOrder(sort, index) {
            return new FuncDeclImpl(check(Z3.mk_linear_order(contextPtr, sort.ptr, index)));
        }
        function mkPiecewiseLinearOrder(sort, index) {
            return new FuncDeclImpl(check(Z3.mk_piecewise_linear_order(contextPtr, sort.ptr, index)));
        }
        function mkTreeOrder(sort, index) {
            return new FuncDeclImpl(check(Z3.mk_tree_order(contextPtr, sort.ptr, index)));
        }
        function mkTransitiveClosure(f) {
            return new FuncDeclImpl(check(Z3.mk_transitive_closure(contextPtr, f.ptr)));
        }
        function mkChar(ch) {
            return new ExprImpl(check(Z3.mk_char(contextPtr, ch)));
        }
        function mkCharLe(ch1, ch2) {
            return new BoolImpl(check(Z3.mk_char_le(contextPtr, ch1.ast, ch2.ast)));
        }
        function mkCharToInt(ch) {
            return new ArithImpl(check(Z3.mk_char_to_int(contextPtr, ch.ast)));
        }
        function mkCharToBV(ch) {
            return new ExprImpl(check(Z3.mk_char_to_bv(contextPtr, ch.ast)));
        }
        function mkCharFromBV(bv) {
            return new ExprImpl(check(Z3.mk_char_from_bv(contextPtr, bv.ast)));
        }
        function mkCharIsDigit(ch) {
            return new BoolImpl(check(Z3.mk_char_is_digit(contextPtr, ch.ast)));
        }
        async function polynomialSubresultants(p, q, x) {
            const result = await Z3.polynomial_subresultants(contextPtr, p.ast, q.ast, x.ast);
            return new AstVectorImpl(check(result));
        }
        class AstImpl {
            constructor(ptr){
                this.ptr = ptr;
                this.ctx = ctx;
                const myAst = this.ast;
                Z3.inc_ref(contextPtr, myAst);
                cleanup.register(this, ()=>Z3.dec_ref(contextPtr, myAst), this);
            }
            get ast() {
                return this.ptr;
            }
            id() {
                return Z3.get_ast_id(contextPtr, this.ast);
            }
            eqIdentity(other) {
                _assertContext(other);
                return check(Z3.is_eq_ast(contextPtr, this.ast, other.ast));
            }
            neqIdentity(other) {
                _assertContext(other);
                return !this.eqIdentity(other);
            }
            sexpr() {
                return Z3.ast_to_string(contextPtr, this.ast);
            }
            hash() {
                return Z3.get_ast_hash(contextPtr, this.ast);
            }
            toString() {
                return this.sexpr();
            }
        }
        class SolverImpl {
            get ptr() {
                _assertPtr(this._ptr);
                return this._ptr;
            }
            constructor(ptr = Z3.mk_solver(contextPtr)){
                this.ctx = ctx;
                let myPtr;
                if (typeof ptr === 'string') myPtr = check(Z3.mk_solver_for_logic(contextPtr, _toSymbol(ptr)));
                else myPtr = ptr;
                this._ptr = myPtr;
                Z3.solver_inc_ref(contextPtr, myPtr);
                // Shared mutable holder so registerOnClause and the cleanup closure see the same slot
                const onClauseCallbackIdx = {
                    value: null
                };
                this._onClauseCallbackIdx = onClauseCallbackIdx;
                cleanup.register(this, ()=>{
                    Z3.solver_dec_ref(contextPtr, myPtr);
                    if (onClauseCallbackIdx.value !== null && em) {
                        em.removeFunction(onClauseCallbackIdx.value);
                        onClauseCallbackIdx.value = null;
                    }
                }, this);
            }
            set(key, value) {
                Z3.solver_set_params(contextPtr, this.ptr, _toParams(key, value));
            }
            push() {
                Z3.solver_push(contextPtr, this.ptr);
            }
            pop(num = 1) {
                Z3.solver_pop(contextPtr, this.ptr, num);
            }
            numScopes() {
                return Z3.solver_get_num_scopes(contextPtr, this.ptr);
            }
            reset() {
                Z3.solver_reset(contextPtr, this.ptr);
            }
            add(...exprs) {
                _flattenArgs(exprs).forEach((expr)=>{
                    _assertContext(expr);
                    check(Z3.solver_assert(contextPtr, this.ptr, expr.ast));
                });
            }
            addAndTrack(expr, constant) {
                if (typeof constant === 'string') constant = Bool.const(constant);
                (0, $kbizf.assert)(isConst(constant), 'Provided expression that is not a constant to addAndTrack');
                check(Z3.solver_assert_and_track(contextPtr, this.ptr, expr.ast, constant.ast));
            }
            addSimplifier(simplifier) {
                _assertContext(simplifier);
                check(Z3.solver_add_simplifier(contextPtr, this.ptr, simplifier.ptr));
            }
            assertions() {
                return new AstVectorImpl(check(Z3.solver_get_assertions(contextPtr, this.ptr)));
            }
            async check(...exprs) {
                const assumptions = _flattenArgs(exprs).map((expr)=>{
                    _assertContext(expr);
                    return expr.ast;
                });
                const result = await $e82bc407ca0fa51b$var$asyncMutex.runExclusive(()=>check(Z3.solver_check_assumptions(contextPtr, this.ptr, assumptions)));
                switch(result){
                    case $7tXKo.Z3_lbool.Z3_L_FALSE:
                        return 'unsat';
                    case $7tXKo.Z3_lbool.Z3_L_TRUE:
                        return 'sat';
                    case $7tXKo.Z3_lbool.Z3_L_UNDEF:
                        return 'unknown';
                    default:
                        (0, $kbizf.assertExhaustive)(result);
                }
            }
            unsatCore() {
                return new AstVectorImpl(check(Z3.solver_get_unsat_core(contextPtr, this.ptr)));
            }
            model() {
                return new ModelImpl(check(Z3.solver_get_model(contextPtr, this.ptr)));
            }
            statistics() {
                return new StatisticsImpl(check(Z3.solver_get_statistics(contextPtr, this.ptr)));
            }
            reasonUnknown() {
                return check(Z3.solver_get_reason_unknown(contextPtr, this.ptr));
            }
            toString() {
                return check(Z3.solver_to_string(contextPtr, this.ptr));
            }
            toSmtlib2(status = 'unknown') {
                const assertionsVec = this.assertions();
                const numAssertions = assertionsVec.length();
                let formula;
                let assumptions;
                if (numAssertions > 0) {
                    // Use last assertion as formula and rest as assumptions
                    assumptions = [];
                    for(let i = 0; i < numAssertions - 1; i++)assumptions.push(assertionsVec.get(i).ast);
                    formula = assertionsVec.get(numAssertions - 1).ast;
                } else {
                    // No assertions, use true
                    assumptions = [];
                    formula = ctx.Bool.val(true).ast;
                }
                return check(Z3.benchmark_to_smtlib_string(contextPtr, '', '', status, '', assumptions, formula));
            }
            dimacs(includeNames = true) {
                return check(Z3.solver_to_dimacs_string(contextPtr, this.ptr, includeNames));
            }
            translate(target) {
                const ptr = check(Z3.solver_translate(contextPtr, this.ptr, target.ptr));
                return new target.Solver(ptr);
            }
            proof() {
                const result = Z3.solver_get_proof(contextPtr, this.ptr);
                throwIfError();
                if (!result) return null;
                return _toExpr(result);
            }
            fromString(s) {
                Z3.solver_from_string(contextPtr, this.ptr, s);
                throwIfError();
            }
            units() {
                return new AstVectorImpl(check(Z3.solver_get_units(contextPtr, this.ptr)));
            }
            nonUnits() {
                return new AstVectorImpl(check(Z3.solver_get_non_units(contextPtr, this.ptr)));
            }
            trail() {
                return new AstVectorImpl(check(Z3.solver_get_trail(contextPtr, this.ptr)));
            }
            trailLevels() {
                const trailVec = check(Z3.solver_get_trail(contextPtr, this.ptr));
                const n = Z3.ast_vector_size(contextPtr, trailVec);
                return check(Z3.solver_get_levels(contextPtr, this.ptr, trailVec, n));
            }
            async cube(vars, cutoff = 0xFFFFFFFF) {
                const tempVars = vars ?? new AstVectorImpl();
                const result = await $e82bc407ca0fa51b$var$asyncMutex.runExclusive(()=>check(Z3.solver_cube(contextPtr, this.ptr, tempVars.ptr, cutoff)));
                return new AstVectorImpl(result);
            }
            async getConsequences(assumptions, variables) {
                const asmsVec = new AstVectorImpl();
                const varsVec = new AstVectorImpl();
                const consVec = new AstVectorImpl();
                _flattenArgs(assumptions).forEach((expr)=>{
                    _assertContext(expr);
                    Z3.ast_vector_push(contextPtr, asmsVec.ptr, expr.ast);
                });
                variables.forEach((v)=>{
                    _assertContext(v);
                    Z3.ast_vector_push(contextPtr, varsVec.ptr, v.ast);
                });
                const r = await $e82bc407ca0fa51b$var$asyncMutex.runExclusive(()=>check(Z3.solver_get_consequences(contextPtr, this.ptr, asmsVec.ptr, varsVec.ptr, consVec.ptr)));
                let status;
                switch(r){
                    case $7tXKo.Z3_lbool.Z3_L_FALSE:
                        status = 'unsat';
                        break;
                    case $7tXKo.Z3_lbool.Z3_L_TRUE:
                        status = 'sat';
                        break;
                    default:
                        status = 'unknown';
                }
                return [
                    status,
                    consVec
                ];
            }
            solveFor(variables, terms, guards) {
                const varsVec = new AstVectorImpl();
                const termsVec = new AstVectorImpl();
                const guardsVec = new AstVectorImpl();
                variables.forEach((v)=>{
                    _assertContext(v);
                    Z3.ast_vector_push(contextPtr, varsVec.ptr, v.ast);
                });
                terms.forEach((t)=>{
                    _assertContext(t);
                    Z3.ast_vector_push(contextPtr, termsVec.ptr, t.ast);
                });
                guards.forEach((g)=>{
                    _assertContext(g);
                    Z3.ast_vector_push(contextPtr, guardsVec.ptr, g.ast);
                });
                Z3.solver_solve_for(contextPtr, this.ptr, varsVec.ptr, termsVec.ptr, guardsVec.ptr);
                throwIfError();
            }
            setInitialValue(variable, value) {
                _assertContext(variable);
                _assertContext(value);
                Z3.solver_set_initial_value(contextPtr, this.ptr, variable.ast, value.ast);
                throwIfError();
            }
            congruenceRoot(expr) {
                _assertContext(expr);
                return _toExpr(check(Z3.solver_congruence_root(contextPtr, this.ptr, expr.ast)));
            }
            congruenceNext(expr) {
                _assertContext(expr);
                return _toExpr(check(Z3.solver_congruence_next(contextPtr, this.ptr, expr.ast)));
            }
            congruenceExplain(a, b) {
                _assertContext(a);
                _assertContext(b);
                return _toExpr(check(Z3.solver_congruence_explain(contextPtr, this.ptr, a.ast, b.ast)));
            }
            fromFile(filename) {
                Z3.solver_from_file(contextPtr, this.ptr, filename);
                throwIfError();
            }
            release() {
                // Clean up any registered on_clause callback
                if (this._onClauseCallbackIdx.value !== null && em) {
                    em.removeFunction(this._onClauseCallbackIdx.value);
                    this._onClauseCallbackIdx.value = null;
                }
                Z3.solver_dec_ref(contextPtr, this.ptr);
                // Mark the ptr as null to prevent double free
                this._ptr = null;
                cleanup.unregister(this);
            }
            registerOnClause(callback) {
                if (!em) throw new Error('registerOnClause requires the Emscripten module; pass it to createApi');
                // Remove any previously registered callback before registering a new one
                if (this._onClauseCallbackIdx.value !== null) {
                    em.removeFunction(this._onClauseCallbackIdx.value);
                    this._onClauseCallbackIdx.value = null;
                }
                // Signature: void(void* ctx, Z3_ast proof_hint, unsigned n, const unsigned* deps, Z3_ast_vector literals)
                const cCallback = em.addFunction((_ctxPtr, proofHintPtr, n, depsPtr, literalsPtr)=>{
                    const proofHint = proofHintPtr ? _toExpr(proofHintPtr) : null;
                    const deps = [];
                    for(let i = 0; i < n; i++)deps.push(em.HEAPU32[(depsPtr >> 2) + i]);
                    const clause = new AstVectorImpl(literalsPtr);
                    callback(proofHint, deps, clause);
                }, 'viiiii');
                this._onClauseCallbackIdx.value = cCallback;
                // solver_register_on_clause is not auto-wrapped (has void* and fnptr params),
                // so we call the raw Emscripten export directly.
                em._Z3_solver_register_on_clause(contextPtr, this.ptr, 0, cCallback);
            }
        }
        class OptimizeImpl {
            get ptr() {
                _assertPtr(this._ptr);
                return this._ptr;
            }
            constructor(ptr = Z3.mk_optimize(contextPtr)){
                this.ctx = ctx;
                let myPtr;
                myPtr = ptr;
                this._ptr = myPtr;
                Z3.optimize_inc_ref(contextPtr, myPtr);
                cleanup.register(this, ()=>Z3.optimize_dec_ref(contextPtr, myPtr), this);
            }
            set(key, value) {
                Z3.optimize_set_params(contextPtr, this.ptr, _toParams(key, value));
            }
            push() {
                Z3.optimize_push(contextPtr, this.ptr);
            }
            pop() {
                Z3.optimize_pop(contextPtr, this.ptr);
            }
            add(...exprs) {
                _flattenArgs(exprs).forEach((expr)=>{
                    _assertContext(expr);
                    check(Z3.optimize_assert(contextPtr, this.ptr, expr.ast));
                });
            }
            addSoft(expr, weight, id = '') {
                if ($e82bc407ca0fa51b$var$isCoercibleRational(weight)) weight = `${weight.numerator}/${weight.denominator}`;
                check(Z3.optimize_assert_soft(contextPtr, this.ptr, expr.ast, weight.toString(), _toSymbol(id)));
            }
            addAndTrack(expr, constant) {
                if (typeof constant === 'string') constant = Bool.const(constant);
                (0, $kbizf.assert)(isConst(constant), 'Provided expression that is not a constant to addAndTrack');
                check(Z3.optimize_assert_and_track(contextPtr, this.ptr, expr.ast, constant.ast));
            }
            assertions() {
                return new AstVectorImpl(check(Z3.optimize_get_assertions(contextPtr, this.ptr)));
            }
            maximize(expr) {
                return check(Z3.optimize_maximize(contextPtr, this.ptr, expr.ast));
            }
            minimize(expr) {
                return check(Z3.optimize_minimize(contextPtr, this.ptr, expr.ast));
            }
            getLower(index) {
                return _toExpr(check(Z3.optimize_get_lower(contextPtr, this.ptr, index)));
            }
            getUpper(index) {
                return _toExpr(check(Z3.optimize_get_upper(contextPtr, this.ptr, index)));
            }
            getLowerAsVector(index) {
                return new AstVectorImpl(check(Z3.optimize_get_lower_as_vector(contextPtr, this.ptr, index)));
            }
            getUpperAsVector(index) {
                return new AstVectorImpl(check(Z3.optimize_get_upper_as_vector(contextPtr, this.ptr, index)));
            }
            unsatCore() {
                return new AstVectorImpl(check(Z3.optimize_get_unsat_core(contextPtr, this.ptr)));
            }
            objectives() {
                return new AstVectorImpl(check(Z3.optimize_get_objectives(contextPtr, this.ptr)));
            }
            reasonUnknown() {
                return check(Z3.optimize_get_reason_unknown(contextPtr, this.ptr));
            }
            fromFile(filename) {
                Z3.optimize_from_file(contextPtr, this.ptr, filename);
                throwIfError();
            }
            translate(target) {
                const ptr = check(Z3.optimize_translate(contextPtr, this.ptr, target.ptr));
                return new target.Optimize(ptr);
            }
            async check(...exprs) {
                const assumptions = _flattenArgs(exprs).map((expr)=>{
                    _assertContext(expr);
                    return expr.ast;
                });
                const result = await $e82bc407ca0fa51b$var$asyncMutex.runExclusive(()=>check(Z3.optimize_check(contextPtr, this.ptr, assumptions)));
                switch(result){
                    case $7tXKo.Z3_lbool.Z3_L_FALSE:
                        return 'unsat';
                    case $7tXKo.Z3_lbool.Z3_L_TRUE:
                        return 'sat';
                    case $7tXKo.Z3_lbool.Z3_L_UNDEF:
                        return 'unknown';
                    default:
                        (0, $kbizf.assertExhaustive)(result);
                }
            }
            model() {
                return new ModelImpl(check(Z3.optimize_get_model(contextPtr, this.ptr)));
            }
            statistics() {
                return new StatisticsImpl(check(Z3.optimize_get_statistics(contextPtr, this.ptr)));
            }
            setInitialValue(variable, value) {
                _assertContext(variable);
                _assertContext(value);
                Z3.optimize_set_initial_value(contextPtr, this.ptr, variable.ast, value.ast);
                throwIfError();
            }
            toString() {
                return check(Z3.optimize_to_string(contextPtr, this.ptr));
            }
            fromString(s) {
                Z3.optimize_from_string(contextPtr, this.ptr, s);
                throwIfError();
            }
            release() {
                Z3.optimize_dec_ref(contextPtr, this.ptr);
                this._ptr = null;
                cleanup.unregister(this);
            }
        }
        class FixedpointImpl {
            get ptr() {
                _assertPtr(this._ptr);
                return this._ptr;
            }
            constructor(ptr = Z3.mk_fixedpoint(contextPtr)){
                this.ctx = ctx;
                let myPtr;
                myPtr = ptr;
                this._ptr = myPtr;
                Z3.fixedpoint_inc_ref(contextPtr, myPtr);
                cleanup.register(this, ()=>Z3.fixedpoint_dec_ref(contextPtr, myPtr), this);
            }
            set(key, value) {
                Z3.fixedpoint_set_params(contextPtr, this.ptr, _toParams(key, value));
            }
            help() {
                return check(Z3.fixedpoint_get_help(contextPtr, this.ptr));
            }
            add(...constraints) {
                constraints.forEach((constraint)=>{
                    _assertContext(constraint);
                    check(Z3.fixedpoint_assert(contextPtr, this.ptr, constraint.ast));
                });
            }
            registerRelation(pred) {
                _assertContext(pred);
                check(Z3.fixedpoint_register_relation(contextPtr, this.ptr, pred.ptr));
            }
            addRule(rule, name) {
                _assertContext(rule);
                const symbol = _toSymbol(name ?? '');
                check(Z3.fixedpoint_add_rule(contextPtr, this.ptr, rule.ast, symbol));
            }
            addFact(pred, ...args) {
                _assertContext(pred);
                check(Z3.fixedpoint_add_fact(contextPtr, this.ptr, pred.ptr, args));
            }
            updateRule(rule, name) {
                _assertContext(rule);
                const symbol = _toSymbol(name);
                check(Z3.fixedpoint_update_rule(contextPtr, this.ptr, rule.ast, symbol));
            }
            async query(query) {
                _assertContext(query);
                const result = await $e82bc407ca0fa51b$var$asyncMutex.runExclusive(()=>check(Z3.fixedpoint_query(contextPtr, this.ptr, query.ast)));
                switch(result){
                    case $7tXKo.Z3_lbool.Z3_L_FALSE:
                        return 'unsat';
                    case $7tXKo.Z3_lbool.Z3_L_TRUE:
                        return 'sat';
                    case $7tXKo.Z3_lbool.Z3_L_UNDEF:
                        return 'unknown';
                    default:
                        (0, $kbizf.assertExhaustive)(result);
                }
            }
            async queryRelations(...relations) {
                relations.forEach((rel)=>_assertContext(rel));
                const decls = relations.map((rel)=>rel.ptr);
                const result = await $e82bc407ca0fa51b$var$asyncMutex.runExclusive(()=>check(Z3.fixedpoint_query_relations(contextPtr, this.ptr, decls)));
                switch(result){
                    case $7tXKo.Z3_lbool.Z3_L_FALSE:
                        return 'unsat';
                    case $7tXKo.Z3_lbool.Z3_L_TRUE:
                        return 'sat';
                    case $7tXKo.Z3_lbool.Z3_L_UNDEF:
                        return 'unknown';
                    default:
                        (0, $kbizf.assertExhaustive)(result);
                }
            }
            getAnswer() {
                const ans = check(Z3.fixedpoint_get_answer(contextPtr, this.ptr));
                return ans ? _toExpr(ans) : null;
            }
            getReasonUnknown() {
                return check(Z3.fixedpoint_get_reason_unknown(contextPtr, this.ptr));
            }
            getNumLevels(pred) {
                _assertContext(pred);
                return check(Z3.fixedpoint_get_num_levels(contextPtr, this.ptr, pred.ptr));
            }
            getCoverDelta(level, pred) {
                _assertContext(pred);
                const res = check(Z3.fixedpoint_get_cover_delta(contextPtr, this.ptr, level, pred.ptr));
                return res ? _toExpr(res) : null;
            }
            addCover(level, pred, property) {
                _assertContext(pred);
                _assertContext(property);
                check(Z3.fixedpoint_add_cover(contextPtr, this.ptr, level, pred.ptr, property.ast));
            }
            getRules() {
                return new AstVectorImpl(check(Z3.fixedpoint_get_rules(contextPtr, this.ptr)));
            }
            getAssertions() {
                return new AstVectorImpl(check(Z3.fixedpoint_get_assertions(contextPtr, this.ptr)));
            }
            setPredicateRepresentation(pred, kinds) {
                _assertContext(pred);
                const symbols = kinds.map((kind)=>_toSymbol(kind));
                check(Z3.fixedpoint_set_predicate_representation(contextPtr, this.ptr, pred.ptr, symbols));
            }
            toString() {
                return check(Z3.fixedpoint_to_string(contextPtr, this.ptr, []));
            }
            fromString(s) {
                const av = check(Z3.fixedpoint_from_string(contextPtr, this.ptr, s));
                return new AstVectorImpl(av);
            }
            fromFile(file) {
                const av = check(Z3.fixedpoint_from_file(contextPtr, this.ptr, file));
                return new AstVectorImpl(av);
            }
            statistics() {
                return new StatisticsImpl(check(Z3.fixedpoint_get_statistics(contextPtr, this.ptr)));
            }
            release() {
                Z3.fixedpoint_dec_ref(contextPtr, this.ptr);
                this._ptr = null;
                cleanup.unregister(this);
            }
        }
        class ModelImpl {
            get ptr() {
                _assertPtr(this._ptr);
                return this._ptr;
            }
            constructor(ptr = Z3.mk_model(contextPtr)){
                this.ctx = ctx;
                this._ptr = ptr;
                Z3.model_inc_ref(contextPtr, ptr);
                cleanup.register(this, ()=>Z3.model_dec_ref(contextPtr, ptr), this);
            }
            length() {
                return Z3.model_get_num_consts(contextPtr, this.ptr) + Z3.model_get_num_funcs(contextPtr, this.ptr);
            }
            [Symbol.iterator]() {
                return this.values();
            }
            *entries() {
                const length = this.length();
                for(let i = 0; i < length; i++)yield [
                    i,
                    this.get(i)
                ];
            }
            *keys() {
                for (const [key] of this.entries())yield key;
            }
            *values() {
                for (const [, value] of this.entries())yield value;
            }
            decls() {
                return [
                    ...this.values()
                ];
            }
            sexpr() {
                return check(Z3.model_to_string(contextPtr, this.ptr));
            }
            toString() {
                return this.sexpr();
            }
            eval(expr, modelCompletion = false) {
                _assertContext(expr);
                const r = check(Z3.model_eval(contextPtr, this.ptr, expr.ast, modelCompletion));
                if (r === null) throw new $jM2ZR.Z3Error('Failed to evaluate expression in the model');
                return _toExpr(r);
            }
            get(i, to) {
                (0, $kbizf.assert)(to === undefined || typeof i === 'number');
                if (typeof i === 'number') {
                    const length = this.length();
                    if (i >= length) throw new RangeError(`expected index ${i} to be less than length ${length}`);
                    if (to === undefined) {
                        const numConsts = check(Z3.model_get_num_consts(contextPtr, this.ptr));
                        if (i < numConsts) return new FuncDeclImpl(check(Z3.model_get_const_decl(contextPtr, this.ptr, i)));
                        else return new FuncDeclImpl(check(Z3.model_get_func_decl(contextPtr, this.ptr, i - numConsts)));
                    }
                    if (to < 0) to += length;
                    if (to >= length) throw new RangeError(`expected index ${to} to be less than length ${length}`);
                    const result = [];
                    for(let j = i; j < to; j++)result.push(this.get(j));
                    return result;
                } else if (isFuncDecl(i) || isExpr(i) && isConst(i)) {
                    const result = this.getInterp(i);
                    (0, $kbizf.assert)(result !== null);
                    return result;
                } else if (isSort(i)) return this.getUniverse(i);
                (0, $kbizf.assert)(false, 'Number, declaration or constant expected');
            }
            updateValue(decl, a) {
                _assertContext(decl);
                _assertContext(a);
                if (isExpr(decl)) decl = decl.decl();
                if (isFuncDecl(decl) && decl.arity() !== 0 && isFuncInterp(a)) {
                    const funcInterp = this.addFuncInterp(decl, a.elseValue());
                    for(let i = 0; i < a.numEntries(); i++){
                        const e = a.entry(i);
                        const n = e.numArgs();
                        const args = globalThis.Array.from({
                            length: n
                        }, (_, i)=>e.argValue(i));
                        funcInterp.addEntry(args, e.value());
                    }
                    return;
                }
                if (!isFuncDecl(decl) || decl.arity() !== 0) throw new $jM2ZR.Z3Error('Expecting 0-ary function or constant expression');
                if (!isAst(a)) throw new $jM2ZR.Z3Error('Only func declarations can be assigned to func interpretations');
                check(Z3.add_const_interp(contextPtr, this.ptr, decl.ptr, a.ast));
            }
            addFuncInterp(decl, defaultValue) {
                const fi = check(Z3.add_func_interp(contextPtr, this.ptr, decl.ptr, decl.range().cast(defaultValue).ptr));
                return new FuncInterpImpl(fi);
            }
            getInterp(expr) {
                (0, $kbizf.assert)(isFuncDecl(expr) || isConst(expr), 'Declaration expected');
                if (isConst(expr)) {
                    (0, $kbizf.assert)(isExpr(expr));
                    expr = expr.decl();
                }
                (0, $kbizf.assert)(isFuncDecl(expr));
                if (expr.arity() === 0) {
                    const result = check(Z3.model_get_const_interp(contextPtr, this.ptr, expr.ptr));
                    if (result === null) return null;
                    return _toExpr(result);
                } else {
                    const interp = check(Z3.model_get_func_interp(contextPtr, this.ptr, expr.ptr));
                    if (interp === null) return null;
                    return new FuncInterpImpl(interp);
                }
            }
            getUniverse(sort) {
                _assertContext(sort);
                return new AstVectorImpl(check(Z3.model_get_sort_universe(contextPtr, this.ptr, sort.ptr)));
            }
            numSorts() {
                return check(Z3.model_get_num_sorts(contextPtr, this.ptr));
            }
            getSort(i) {
                return _toSort(check(Z3.model_get_sort(contextPtr, this.ptr, i)));
            }
            getSorts() {
                const n = this.numSorts();
                const result = [];
                for(let i = 0; i < n; i++)result.push(this.getSort(i));
                return result;
            }
            sortUniverse(sort) {
                return this.getUniverse(sort);
            }
            translate(target) {
                const ptr = check(Z3.model_translate(contextPtr, this.ptr, target.ptr));
                return new target.Model(ptr);
            }
            release() {
                Z3.model_dec_ref(contextPtr, this.ptr);
                this._ptr = null;
                cleanup.unregister(this);
            }
        }
        class StatisticsImpl {
            get ptr() {
                _assertPtr(this._ptr);
                return this._ptr;
            }
            constructor(ptr){
                this.ctx = ctx;
                this._ptr = ptr;
                Z3.stats_inc_ref(contextPtr, ptr);
                cleanup.register(this, ()=>Z3.stats_dec_ref(contextPtr, ptr), this);
            }
            size() {
                return Z3.stats_size(contextPtr, this.ptr);
            }
            keys() {
                const result = [];
                const sz = this.size();
                for(let i = 0; i < sz; i++)result.push(Z3.stats_get_key(contextPtr, this.ptr, i));
                return result;
            }
            get(key) {
                const sz = this.size();
                for(let i = 0; i < sz; i++)if (Z3.stats_get_key(contextPtr, this.ptr, i) === key) {
                    if (Z3.stats_is_uint(contextPtr, this.ptr, i)) return Z3.stats_get_uint_value(contextPtr, this.ptr, i);
                    else return Z3.stats_get_double_value(contextPtr, this.ptr, i);
                }
                throw new Error(`Statistics key not found: ${key}`);
            }
            entries() {
                const result = [];
                const sz = this.size();
                for(let i = 0; i < sz; i++){
                    const key = Z3.stats_get_key(contextPtr, this.ptr, i);
                    const isUint = Z3.stats_is_uint(contextPtr, this.ptr, i);
                    const isDouble = Z3.stats_is_double(contextPtr, this.ptr, i);
                    const value = isUint ? Z3.stats_get_uint_value(contextPtr, this.ptr, i) : Z3.stats_get_double_value(contextPtr, this.ptr, i);
                    result.push({
                        __typename: 'StatisticsEntry',
                        key: key,
                        value: value,
                        isUint: isUint,
                        isDouble: isDouble
                    });
                }
                return result;
            }
            [Symbol.iterator]() {
                return this.entries()[Symbol.iterator]();
            }
            release() {
                Z3.stats_dec_ref(contextPtr, this.ptr);
                this._ptr = null;
                cleanup.unregister(this);
            }
        }
        class FuncEntryImpl {
            constructor(ptr){
                this.ptr = ptr;
                this.ctx = ctx;
                Z3.func_entry_inc_ref(contextPtr, ptr);
                cleanup.register(this, ()=>Z3.func_entry_dec_ref(contextPtr, ptr), this);
            }
            numArgs() {
                return check(Z3.func_entry_get_num_args(contextPtr, this.ptr));
            }
            argValue(i) {
                return _toExpr(check(Z3.func_entry_get_arg(contextPtr, this.ptr, i)));
            }
            value() {
                return _toExpr(check(Z3.func_entry_get_value(contextPtr, this.ptr)));
            }
        }
        class FuncInterpImpl {
            constructor(ptr){
                this.ptr = ptr;
                this.ctx = ctx;
                Z3.func_interp_inc_ref(contextPtr, ptr);
                cleanup.register(this, ()=>Z3.func_interp_dec_ref(contextPtr, ptr), this);
            }
            elseValue() {
                return _toExpr(check(Z3.func_interp_get_else(contextPtr, this.ptr)));
            }
            numEntries() {
                return check(Z3.func_interp_get_num_entries(contextPtr, this.ptr));
            }
            arity() {
                return check(Z3.func_interp_get_arity(contextPtr, this.ptr));
            }
            entry(i) {
                return new FuncEntryImpl(check(Z3.func_interp_get_entry(contextPtr, this.ptr, i)));
            }
            addEntry(args, value) {
                const argsVec = new AstVectorImpl();
                for (const arg of args)argsVec.push(arg);
                _assertContext(argsVec);
                _assertContext(value);
                (0, $kbizf.assert)(this.arity() === argsVec.length(), "Number of arguments in entry doesn't match function arity");
                check(Z3.func_interp_add_entry(contextPtr, this.ptr, argsVec.ptr, value.ptr));
            }
        }
        class SortImpl extends AstImpl {
            get ast() {
                return Z3.sort_to_ast(contextPtr, this.ptr);
            }
            kind() {
                return Z3.get_sort_kind(contextPtr, this.ptr);
            }
            subsort(other) {
                _assertContext(other);
                return false;
            }
            cast(expr) {
                _assertContext(expr);
                (0, $kbizf.assert)(expr.sort.eqIdentity(expr.sort), 'Sort mismatch');
                return expr;
            }
            name() {
                return _fromSymbol(Z3.get_sort_name(contextPtr, this.ptr));
            }
            eqIdentity(other) {
                _assertContext(other);
                return check(Z3.is_eq_sort(contextPtr, this.ptr, other.ptr));
            }
            neqIdentity(other) {
                return !this.eqIdentity(other);
            }
        }
        class FuncDeclImpl extends AstImpl {
            get ast() {
                return Z3.func_decl_to_ast(contextPtr, this.ptr);
            }
            name() {
                return _fromSymbol(Z3.get_decl_name(contextPtr, this.ptr));
            }
            arity() {
                return Z3.get_arity(contextPtr, this.ptr);
            }
            domain(i) {
                (0, $kbizf.assert)(i < this.arity(), 'Index out of bounds');
                return _toSort(Z3.get_domain(contextPtr, this.ptr, i));
            }
            range() {
                return _toSort(Z3.get_range(contextPtr, this.ptr));
            }
            kind() {
                return Z3.get_decl_kind(contextPtr, this.ptr);
            }
            params() {
                const n = Z3.get_decl_num_parameters(contextPtr, this.ptr);
                const result = [];
                for(let i = 0; i < n; i++){
                    const kind = check(Z3.get_decl_parameter_kind(contextPtr, this.ptr, i));
                    switch(kind){
                        case $7tXKo.Z3_parameter_kind.Z3_PARAMETER_INT:
                            result.push(check(Z3.get_decl_int_parameter(contextPtr, this.ptr, i)));
                            break;
                        case $7tXKo.Z3_parameter_kind.Z3_PARAMETER_DOUBLE:
                            result.push(check(Z3.get_decl_double_parameter(contextPtr, this.ptr, i)));
                            break;
                        case $7tXKo.Z3_parameter_kind.Z3_PARAMETER_RATIONAL:
                            result.push(check(Z3.get_decl_rational_parameter(contextPtr, this.ptr, i)));
                            break;
                        case $7tXKo.Z3_parameter_kind.Z3_PARAMETER_SYMBOL:
                            result.push(_fromSymbol(check(Z3.get_decl_symbol_parameter(contextPtr, this.ptr, i))));
                            break;
                        case $7tXKo.Z3_parameter_kind.Z3_PARAMETER_SORT:
                            result.push(new SortImpl(check(Z3.get_decl_sort_parameter(contextPtr, this.ptr, i))));
                            break;
                        case $7tXKo.Z3_parameter_kind.Z3_PARAMETER_AST:
                            result.push(new ExprImpl(check(Z3.get_decl_ast_parameter(contextPtr, this.ptr, i))));
                            break;
                        case $7tXKo.Z3_parameter_kind.Z3_PARAMETER_FUNC_DECL:
                            result.push(new FuncDeclImpl(check(Z3.get_decl_func_decl_parameter(contextPtr, this.ptr, i))));
                            break;
                        case $7tXKo.Z3_parameter_kind.Z3_PARAMETER_INTERNAL:
                            break;
                        case $7tXKo.Z3_parameter_kind.Z3_PARAMETER_ZSTRING:
                            break;
                        default:
                            (0, $kbizf.assertExhaustive)(kind);
                    }
                }
                return result;
            }
            call(...args) {
                (0, $kbizf.assert)(args.length === this.arity(), `Incorrect number of arguments to ${this}`);
                return _toExpr(check(Z3.mk_app(contextPtr, this.ptr, args.map((arg, i)=>{
                    return this.domain(i).cast(arg).ast;
                }))));
            }
        }
        class ExprImpl extends AstImpl {
            get sort() {
                return _toSort(Z3.get_sort(contextPtr, this.ast));
            }
            eq(other) {
                return new BoolImpl(check(Z3.mk_eq(contextPtr, this.ast, from(other).ast)));
            }
            neq(other) {
                return new BoolImpl(check(Z3.mk_distinct(contextPtr, [
                    this,
                    other
                ].map((expr)=>from(expr).ast))));
            }
            name() {
                return this.decl().name();
            }
            params() {
                return this.decl().params();
            }
            decl() {
                (0, $kbizf.assert)(isApp(this), 'Z3 application expected');
                return new FuncDeclImpl(check(Z3.get_app_decl(contextPtr, check(Z3.to_app(contextPtr, this.ast)))));
            }
            numArgs() {
                (0, $kbizf.assert)(isApp(this), 'Z3 applicaiton expected');
                return check(Z3.get_app_num_args(contextPtr, check(Z3.to_app(contextPtr, this.ast))));
            }
            arg(i) {
                (0, $kbizf.assert)(isApp(this), 'Z3 applicaiton expected');
                (0, $kbizf.assert)(i < this.numArgs(), `Invalid argument index - expected ${i} to be less than ${this.numArgs()}`);
                return _toExpr(check(Z3.get_app_arg(contextPtr, check(Z3.to_app(contextPtr, this.ast)), i)));
            }
            children() {
                const num_args = this.numArgs();
                if (isApp(this)) {
                    const result = [];
                    for(let i = 0; i < num_args; i++)result.push(this.arg(i));
                    return result;
                }
                return [];
            }
        }
        class PatternImpl {
            constructor(ptr){
                this.ptr = ptr;
                this.ctx = ctx;
            // TODO: implement rest of Pattern
            }
        }
        class BoolSortImpl extends SortImpl {
            cast(other) {
                if (typeof other === 'boolean') other = Bool.val(other);
                (0, $kbizf.assert)(isExpr(other), 'true, false or Z3 Boolean expression expected.');
                (0, $kbizf.assert)(this.eqIdentity(other.sort), 'Value cannot be converted into a Z3 Boolean value');
                return other;
            }
            subsort(other) {
                _assertContext(other.ctx);
                return other instanceof ArithSortImpl;
            }
        }
        class BoolImpl extends ExprImpl {
            not() {
                return Not(this);
            }
            and(other) {
                return And(this, other);
            }
            or(other) {
                return Or(this, other);
            }
            xor(other) {
                return Xor(this, other);
            }
            implies(other) {
                return Implies(this, other);
            }
            iff(other) {
                return Iff(this, other);
            }
        }
        class ProbeImpl {
            constructor(ptr){
                this.ptr = ptr;
                this.ctx = ctx;
            }
            apply(goal) {
                _assertContext(goal);
                return Z3.probe_apply(contextPtr, this.ptr, goal.ptr);
            }
        }
        class GoalImpl {
            constructor(models = true, unsat_cores = false, proofs = false){
                this.ctx = ctx;
                const myPtr = check(Z3.mk_goal(contextPtr, models, unsat_cores, proofs));
                this.ptr = myPtr;
                Z3.goal_inc_ref(contextPtr, myPtr);
                cleanup.register(this, ()=>Z3.goal_dec_ref(contextPtr, myPtr), this);
            }
            // Factory method for creating from existing Z3_goal pointer
            static fromPtr(goalPtr) {
                const goal = Object.create(GoalImpl.prototype);
                goal.ctx = ctx;
                goal.ptr = goalPtr;
                Z3.goal_inc_ref(contextPtr, goalPtr);
                cleanup.register(goal, ()=>Z3.goal_dec_ref(contextPtr, goalPtr), goal);
                return goal;
            }
            add(...constraints) {
                for (const constraint of constraints){
                    const boolConstraint = isBool(constraint) ? constraint : Bool.val(constraint);
                    _assertContext(boolConstraint);
                    Z3.goal_assert(contextPtr, this.ptr, boolConstraint.ast);
                }
            }
            size() {
                return Z3.goal_size(contextPtr, this.ptr);
            }
            get(i) {
                (0, $kbizf.assert)(i >= 0 && i < this.size(), 'Index out of bounds');
                const ast = check(Z3.goal_formula(contextPtr, this.ptr, i));
                return new BoolImpl(ast);
            }
            depth() {
                return Z3.goal_depth(contextPtr, this.ptr);
            }
            inconsistent() {
                return Z3.goal_inconsistent(contextPtr, this.ptr);
            }
            precision() {
                return Z3.goal_precision(contextPtr, this.ptr);
            }
            reset() {
                Z3.goal_reset(contextPtr, this.ptr);
            }
            numExprs() {
                return Z3.goal_num_exprs(contextPtr, this.ptr);
            }
            isDecidedSat() {
                return Z3.goal_is_decided_sat(contextPtr, this.ptr);
            }
            isDecidedUnsat() {
                return Z3.goal_is_decided_unsat(contextPtr, this.ptr);
            }
            convertModel(model) {
                _assertContext(model);
                const convertedModel = check(Z3.goal_convert_model(contextPtr, this.ptr, model.ptr));
                return new ModelImpl(convertedModel);
            }
            asExpr() {
                const sz = this.size();
                if (sz === 0) return Bool.val(true);
                else if (sz === 1) return this.get(0);
                else {
                    const constraints = [];
                    for(let i = 0; i < sz; i++)constraints.push(this.get(i));
                    return And(...constraints);
                }
            }
            toString() {
                return Z3.goal_to_string(contextPtr, this.ptr);
            }
            dimacs(includeNames = true) {
                return Z3.goal_to_dimacs_string(contextPtr, this.ptr, includeNames);
            }
        }
        class ApplyResultImpl {
            constructor(ptr){
                this.ctx = ctx;
                this.ptr = ptr;
                Z3.apply_result_inc_ref(contextPtr, ptr);
                cleanup.register(this, ()=>Z3.apply_result_dec_ref(contextPtr, ptr), this);
            }
            length() {
                return Z3.apply_result_get_num_subgoals(contextPtr, this.ptr);
            }
            getSubgoal(i) {
                (0, $kbizf.assert)(i >= 0 && i < this.length(), 'Index out of bounds');
                const goalPtr = check(Z3.apply_result_get_subgoal(contextPtr, this.ptr, i));
                return GoalImpl.fromPtr(goalPtr);
            }
            toString() {
                return Z3.apply_result_to_string(contextPtr, this.ptr);
            }
        }
        // Add indexer support to ApplyResultImpl
        const applyResultHandler = {
            get (target, prop) {
                if (typeof prop === 'string') {
                    const index = parseInt(prop, 10);
                    if (!isNaN(index) && index >= 0 && index < target.length()) return target.getSubgoal(index);
                }
                return target[prop];
            }
        };
        class TacticImpl {
            constructor(tactic){
                this.ctx = ctx;
                let myPtr;
                if (typeof tactic === 'string') myPtr = check(Z3.mk_tactic(contextPtr, tactic));
                else myPtr = tactic;
                this.ptr = myPtr;
                Z3.tactic_inc_ref(contextPtr, myPtr);
                cleanup.register(this, ()=>Z3.tactic_dec_ref(contextPtr, myPtr), this);
            }
            async apply(goal) {
                let goalToUse;
                if (isBool(goal)) {
                    // Convert Bool expression to Goal
                    goalToUse = new GoalImpl();
                    goalToUse.add(goal);
                } else goalToUse = goal;
                _assertContext(goalToUse);
                const result = await Z3.tactic_apply(contextPtr, this.ptr, goalToUse.ptr);
                const applyResult = new ApplyResultImpl(check(result));
                // Wrap with Proxy to enable indexer access
                return new Proxy(applyResult, applyResultHandler);
            }
            solver() {
                const solverPtr = check(Z3.mk_solver_from_tactic(contextPtr, this.ptr));
                return new SolverImpl(solverPtr);
            }
            help() {
                return Z3.tactic_get_help(contextPtr, this.ptr);
            }
            paramDescrs() {
                const descrs = check(Z3.tactic_get_param_descrs(contextPtr, this.ptr));
                return new ParamDescrsImpl(descrs);
            }
            usingParams(params) {
                _assertContext(params);
                const newTactic = check(Z3.tactic_using_params(contextPtr, this.ptr, params.ptr));
                return new TacticImpl(newTactic);
            }
        }
        class ParamsImpl {
            constructor(params){
                this.ctx = ctx;
                if (params) this.ptr = params;
                else this.ptr = Z3.mk_params(contextPtr);
                Z3.params_inc_ref(contextPtr, this.ptr);
                cleanup.register(this, ()=>Z3.params_dec_ref(contextPtr, this.ptr), this);
            }
            set(name, value) {
                const sym = _toSymbol(name);
                if (typeof value === 'boolean') Z3.params_set_bool(contextPtr, this.ptr, sym, value);
                else if (typeof value === 'number') {
                    if (Number.isInteger(value)) check(Z3.params_set_uint(contextPtr, this.ptr, sym, value));
                    else check(Z3.params_set_double(contextPtr, this.ptr, sym, value));
                } else if (typeof value === 'string') check(Z3.params_set_symbol(contextPtr, this.ptr, sym, _toSymbol(value)));
            }
            validate(descrs) {
                _assertContext(descrs);
                Z3.params_validate(contextPtr, this.ptr, descrs.ptr);
            }
            toString() {
                return Z3.params_to_string(contextPtr, this.ptr);
            }
        }
        class ParamDescrsImpl {
            constructor(paramDescrs){
                this.ctx = ctx;
                this.ptr = paramDescrs;
                Z3.param_descrs_inc_ref(contextPtr, this.ptr);
                cleanup.register(this, ()=>Z3.param_descrs_dec_ref(contextPtr, this.ptr), this);
            }
            size() {
                return Z3.param_descrs_size(contextPtr, this.ptr);
            }
            getName(i) {
                const sym = Z3.param_descrs_get_name(contextPtr, this.ptr, i);
                const name = _fromSymbol(sym);
                return typeof name === 'string' ? name : `${name}`;
            }
            getKind(name) {
                return Z3.param_descrs_get_kind(contextPtr, this.ptr, _toSymbol(name));
            }
            getDocumentation(name) {
                return Z3.param_descrs_get_documentation(contextPtr, this.ptr, _toSymbol(name));
            }
            toString() {
                return Z3.param_descrs_to_string(contextPtr, this.ptr);
            }
        }
        class SimplifierImpl {
            constructor(simplifier){
                this.ctx = ctx;
                let myPtr;
                if (typeof simplifier === 'string') myPtr = check(Z3.mk_simplifier(contextPtr, simplifier));
                else myPtr = simplifier;
                this.ptr = myPtr;
                Z3.simplifier_inc_ref(contextPtr, myPtr);
                cleanup.register(this, ()=>Z3.simplifier_dec_ref(contextPtr, myPtr), this);
            }
            help() {
                return Z3.simplifier_get_help(contextPtr, this.ptr);
            }
            paramDescrs() {
                const descrs = check(Z3.simplifier_get_param_descrs(contextPtr, this.ptr));
                return new ParamDescrsImpl(descrs);
            }
            usingParams(params) {
                _assertContext(params);
                const newSimplifier = check(Z3.simplifier_using_params(contextPtr, this.ptr, params.ptr));
                return new SimplifierImpl(newSimplifier);
            }
            andThen(other) {
                _assertContext(other);
                const newSimplifier = check(Z3.simplifier_and_then(contextPtr, this.ptr, other.ptr));
                return new SimplifierImpl(newSimplifier);
            }
        }
        class ArithSortImpl extends SortImpl {
            cast(other) {
                const sortTypeStr = isIntSort(this) ? 'IntSort' : 'RealSort';
                if (isExpr(other)) {
                    const otherS = other.sort;
                    if (isArith(other)) {
                        if (this.eqIdentity(otherS)) return other;
                        else if (isIntSort(otherS) && isRealSort(this)) return ToReal(other);
                        (0, $kbizf.assert)(false, "Can't cast Real to IntSort without loss");
                    } else if (isBool(other)) {
                        if (isIntSort(this)) return If(other, 1, 0);
                        else return ToReal(If(other, 1, 0));
                    }
                    (0, $kbizf.assert)(false, `Can't cast expression to ${sortTypeStr}`);
                } else {
                    if (typeof other !== 'boolean') {
                        if (isIntSort(this)) {
                            (0, $kbizf.assert)(!$e82bc407ca0fa51b$var$isCoercibleRational(other), "Can't cast fraction to IntSort");
                            return Int.val(other);
                        }
                        return Real.val(other);
                    }
                    (0, $kbizf.assert)(false, `Can't cast primitive to ${sortTypeStr}`);
                }
            }
        }
        function Sum(arg0, ...args) {
            if (arg0 instanceof BitVecImpl) {
                // Assert only 2
                if (args.length !== 1) throw new Error('BitVec add only supports 2 arguments');
                return new BitVecImpl(check(Z3.mk_bvadd(contextPtr, arg0.ast, arg0.sort.cast(args[0]).ast)));
            } else {
                (0, $kbizf.assert)(arg0 instanceof ArithImpl);
                return new ArithImpl(check(Z3.mk_add(contextPtr, [
                    arg0.ast
                ].concat(args.map((arg)=>arg0.sort.cast(arg).ast)))));
            }
        }
        function Sub(arg0, ...args) {
            if (arg0 instanceof BitVecImpl) {
                // Assert only 2
                if (args.length !== 1) throw new Error('BitVec sub only supports 2 arguments');
                return new BitVecImpl(check(Z3.mk_bvsub(contextPtr, arg0.ast, arg0.sort.cast(args[0]).ast)));
            } else {
                (0, $kbizf.assert)(arg0 instanceof ArithImpl);
                return new ArithImpl(check(Z3.mk_sub(contextPtr, [
                    arg0.ast
                ].concat(args.map((arg)=>arg0.sort.cast(arg).ast)))));
            }
        }
        function Product(arg0, ...args) {
            if (arg0 instanceof BitVecImpl) {
                // Assert only 2
                if (args.length !== 1) throw new Error('BitVec mul only supports 2 arguments');
                return new BitVecImpl(check(Z3.mk_bvmul(contextPtr, arg0.ast, arg0.sort.cast(args[0]).ast)));
            } else {
                (0, $kbizf.assert)(arg0 instanceof ArithImpl);
                return new ArithImpl(check(Z3.mk_mul(contextPtr, [
                    arg0.ast
                ].concat(args.map((arg)=>arg0.sort.cast(arg).ast)))));
            }
        }
        function Div(arg0, arg1) {
            if (arg0 instanceof BitVecImpl) return new BitVecImpl(check(Z3.mk_bvsdiv(contextPtr, arg0.ast, arg0.sort.cast(arg1).ast)));
            else {
                (0, $kbizf.assert)(arg0 instanceof ArithImpl);
                return new ArithImpl(check(Z3.mk_div(contextPtr, arg0.ast, arg0.sort.cast(arg1).ast)));
            }
        }
        function BUDiv(arg0, arg1) {
            return new BitVecImpl(check(Z3.mk_bvudiv(contextPtr, arg0.ast, arg0.sort.cast(arg1).ast)));
        }
        function Neg(a) {
            if (a instanceof BitVecImpl) return new BitVecImpl(check(Z3.mk_bvneg(contextPtr, a.ast)));
            else {
                (0, $kbizf.assert)(a instanceof ArithImpl);
                return new ArithImpl(check(Z3.mk_unary_minus(contextPtr, a.ast)));
            }
        }
        function Mod(a, b) {
            if (a instanceof BitVecImpl) return new BitVecImpl(check(Z3.mk_bvsrem(contextPtr, a.ast, a.sort.cast(b).ast)));
            else {
                (0, $kbizf.assert)(a instanceof ArithImpl);
                return new ArithImpl(check(Z3.mk_mod(contextPtr, a.ast, a.sort.cast(b).ast)));
            }
        }
        class ArithImpl extends ExprImpl {
            add(other) {
                return Sum(this, other);
            }
            mul(other) {
                return Product(this, other);
            }
            sub(other) {
                return Sub(this, other);
            }
            pow(exponent) {
                return new ArithImpl(check(Z3.mk_power(contextPtr, this.ast, this.sort.cast(exponent).ast)));
            }
            div(other) {
                return Div(this, other);
            }
            mod(other) {
                return Mod(this, other);
            }
            neg() {
                return Neg(this);
            }
            le(other) {
                return LE(this, other);
            }
            lt(other) {
                return LT(this, other);
            }
            gt(other) {
                return GT(this, other);
            }
            ge(other) {
                return GE(this, other);
            }
        }
        class IntNumImpl extends ArithImpl {
            value() {
                return BigInt(this.asString());
            }
            asString() {
                return Z3.get_numeral_string(contextPtr, this.ast);
            }
            asBinary() {
                return Z3.get_numeral_binary_string(contextPtr, this.ast);
            }
        }
        class RatNumImpl extends ArithImpl {
            value() {
                return {
                    numerator: this.numerator().value(),
                    denominator: this.denominator().value()
                };
            }
            numerator() {
                return new IntNumImpl(Z3.get_numerator(contextPtr, this.ast));
            }
            denominator() {
                return new IntNumImpl(Z3.get_denominator(contextPtr, this.ast));
            }
            asNumber() {
                const { numerator: numerator, denominator: denominator } = this.value();
                const div = numerator / denominator;
                return Number(div) + Number(numerator - div * denominator) / Number(denominator);
            }
            asDecimal(prec = Number.parseInt(getParam('precision') ?? $e82bc407ca0fa51b$var$FALLBACK_PRECISION.toString())) {
                return Z3.get_numeral_decimal_string(contextPtr, this.ast, prec);
            }
            asString() {
                return Z3.get_numeral_string(contextPtr, this.ast);
            }
        }
        class RCFNumImpl {
            constructor(valueOrPtr){
                this.ctx = ctx;
                let myPtr;
                if (typeof valueOrPtr === 'string') myPtr = check(Z3.rcf_mk_rational(contextPtr, valueOrPtr));
                else if (typeof valueOrPtr === 'number') myPtr = check(Z3.rcf_mk_small_int(contextPtr, valueOrPtr));
                else myPtr = valueOrPtr;
                this.ptr = myPtr;
                cleanup.register(this, ()=>Z3.rcf_del(contextPtr, myPtr), this);
            }
            add(other) {
                _assertContext(other);
                return new RCFNumImpl(check(Z3.rcf_add(contextPtr, this.ptr, other.ptr)));
            }
            sub(other) {
                _assertContext(other);
                return new RCFNumImpl(check(Z3.rcf_sub(contextPtr, this.ptr, other.ptr)));
            }
            mul(other) {
                _assertContext(other);
                return new RCFNumImpl(check(Z3.rcf_mul(contextPtr, this.ptr, other.ptr)));
            }
            div(other) {
                _assertContext(other);
                return new RCFNumImpl(check(Z3.rcf_div(contextPtr, this.ptr, other.ptr)));
            }
            neg() {
                return new RCFNumImpl(check(Z3.rcf_neg(contextPtr, this.ptr)));
            }
            inv() {
                return new RCFNumImpl(check(Z3.rcf_inv(contextPtr, this.ptr)));
            }
            power(k) {
                return new RCFNumImpl(check(Z3.rcf_power(contextPtr, this.ptr, k)));
            }
            lt(other) {
                _assertContext(other);
                return check(Z3.rcf_lt(contextPtr, this.ptr, other.ptr));
            }
            gt(other) {
                _assertContext(other);
                return check(Z3.rcf_gt(contextPtr, this.ptr, other.ptr));
            }
            le(other) {
                _assertContext(other);
                return check(Z3.rcf_le(contextPtr, this.ptr, other.ptr));
            }
            ge(other) {
                _assertContext(other);
                return check(Z3.rcf_ge(contextPtr, this.ptr, other.ptr));
            }
            eq(other) {
                _assertContext(other);
                return check(Z3.rcf_eq(contextPtr, this.ptr, other.ptr));
            }
            neq(other) {
                _assertContext(other);
                return check(Z3.rcf_neq(contextPtr, this.ptr, other.ptr));
            }
            isRational() {
                return check(Z3.rcf_is_rational(contextPtr, this.ptr));
            }
            isAlgebraic() {
                return check(Z3.rcf_is_algebraic(contextPtr, this.ptr));
            }
            isInfinitesimal() {
                return check(Z3.rcf_is_infinitesimal(contextPtr, this.ptr));
            }
            isTranscendental() {
                return check(Z3.rcf_is_transcendental(contextPtr, this.ptr));
            }
            toString(compact = false) {
                return check(Z3.rcf_num_to_string(contextPtr, this.ptr, compact, false));
            }
            toDecimal(precision) {
                return check(Z3.rcf_num_to_decimal_string(contextPtr, this.ptr, precision));
            }
        }
        class BitVecSortImpl extends SortImpl {
            size() {
                return Z3.get_bv_sort_size(contextPtr, this.ptr);
            }
            subsort(other) {
                return isBitVecSort(other) && this.size() < other.size();
            }
            cast(other) {
                if (isExpr(other)) {
                    _assertContext(other);
                    return other;
                }
                (0, $kbizf.assert)(!$e82bc407ca0fa51b$var$isCoercibleRational(other), "Can't convert rational to BitVec");
                return BitVec.val(other, this.size());
            }
        }
        class BitVecImpl extends ExprImpl {
            size() {
                return this.sort.size();
            }
            add(other) {
                return Sum(this, other);
            }
            mul(other) {
                return Product(this, other);
            }
            sub(other) {
                return Sub(this, other);
            }
            sdiv(other) {
                return Div(this, other);
            }
            udiv(other) {
                return BUDiv(this, other);
            }
            smod(other) {
                return Mod(this, other);
            }
            urem(other) {
                return new BitVecImpl(check(Z3.mk_bvurem(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            srem(other) {
                return new BitVecImpl(check(Z3.mk_bvsrem(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            neg() {
                return Neg(this);
            }
            or(other) {
                return new BitVecImpl(check(Z3.mk_bvor(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            and(other) {
                return new BitVecImpl(check(Z3.mk_bvand(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            nand(other) {
                return new BitVecImpl(check(Z3.mk_bvnand(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            xor(other) {
                return new BitVecImpl(check(Z3.mk_bvxor(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            xnor(other) {
                return new BitVecImpl(check(Z3.mk_bvxnor(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            shr(count) {
                return new BitVecImpl(check(Z3.mk_bvashr(contextPtr, this.ast, this.sort.cast(count).ast)));
            }
            lshr(count) {
                return new BitVecImpl(check(Z3.mk_bvlshr(contextPtr, this.ast, this.sort.cast(count).ast)));
            }
            shl(count) {
                return new BitVecImpl(check(Z3.mk_bvshl(contextPtr, this.ast, this.sort.cast(count).ast)));
            }
            rotateRight(count) {
                return new BitVecImpl(check(Z3.mk_ext_rotate_right(contextPtr, this.ast, this.sort.cast(count).ast)));
            }
            rotateLeft(count) {
                return new BitVecImpl(check(Z3.mk_ext_rotate_left(contextPtr, this.ast, this.sort.cast(count).ast)));
            }
            not() {
                return new BitVecImpl(check(Z3.mk_bvnot(contextPtr, this.ast)));
            }
            extract(high, low) {
                return Extract(high, low, this);
            }
            signExt(count) {
                return new BitVecImpl(check(Z3.mk_sign_ext(contextPtr, count, this.ast)));
            }
            zeroExt(count) {
                return new BitVecImpl(check(Z3.mk_zero_ext(contextPtr, count, this.ast)));
            }
            repeat(count) {
                return new BitVecImpl(check(Z3.mk_repeat(contextPtr, count, this.ast)));
            }
            sle(other) {
                return SLE(this, other);
            }
            ule(other) {
                return ULE(this, other);
            }
            slt(other) {
                return SLT(this, other);
            }
            ult(other) {
                return ULT(this, other);
            }
            sge(other) {
                return SGE(this, other);
            }
            uge(other) {
                return UGE(this, other);
            }
            sgt(other) {
                return SGT(this, other);
            }
            ugt(other) {
                return UGT(this, other);
            }
            redAnd() {
                return new BitVecImpl(check(Z3.mk_bvredand(contextPtr, this.ast)));
            }
            redOr() {
                return new BitVecImpl(check(Z3.mk_bvredor(contextPtr, this.ast)));
            }
            addNoOverflow(other, isSigned) {
                return new BoolImpl(check(Z3.mk_bvadd_no_overflow(contextPtr, this.ast, this.sort.cast(other).ast, isSigned)));
            }
            addNoUnderflow(other) {
                return new BoolImpl(check(Z3.mk_bvadd_no_underflow(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            subNoOverflow(other) {
                return new BoolImpl(check(Z3.mk_bvsub_no_overflow(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            subNoUnderflow(other, isSigned) {
                return new BoolImpl(check(Z3.mk_bvsub_no_underflow(contextPtr, this.ast, this.sort.cast(other).ast, isSigned)));
            }
            sdivNoOverflow(other) {
                return new BoolImpl(check(Z3.mk_bvsdiv_no_overflow(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            mulNoOverflow(other, isSigned) {
                return new BoolImpl(check(Z3.mk_bvmul_no_overflow(contextPtr, this.ast, this.sort.cast(other).ast, isSigned)));
            }
            mulNoUnderflow(other) {
                return new BoolImpl(check(Z3.mk_bvmul_no_underflow(contextPtr, this.ast, this.sort.cast(other).ast)));
            }
            negNoOverflow() {
                return new BoolImpl(check(Z3.mk_bvneg_no_overflow(contextPtr, this.ast)));
            }
        }
        class BitVecNumImpl extends BitVecImpl {
            value() {
                return BigInt(this.asString());
            }
            asSignedValue() {
                let val = this.value();
                const size = BigInt(this.size());
                if (val >= 2n ** (size - 1n)) val = val - 2n ** size;
                if (val < (-2n) ** (size - 1n)) val = val + 2n ** size;
                return val;
            }
            asString() {
                return Z3.get_numeral_string(contextPtr, this.ast);
            }
            asBinaryString() {
                return Z3.get_numeral_binary_string(contextPtr, this.ast);
            }
        }
        class FPRMSortImpl extends SortImpl {
            cast(other) {
                if (isFPRM(other)) {
                    _assertContext(other);
                    return other;
                }
                throw new Error("Can't cast to FPRMSort");
            }
        }
        class FPRMImpl extends ExprImpl {
        }
        class FPSortImpl extends SortImpl {
            ebits() {
                return Z3.fpa_get_ebits(contextPtr, this.ptr);
            }
            sbits() {
                return Z3.fpa_get_sbits(contextPtr, this.ptr);
            }
            cast(other) {
                if (isExpr(other)) {
                    _assertContext(other);
                    return other;
                }
                if (typeof other === 'number') return Float.val(other, this);
                throw new Error("Can't cast to FPSort");
            }
        }
        class FPImpl extends ExprImpl {
            add(rm, other) {
                const otherFP = isFP(other) ? other : Float.val(other, this.sort);
                return new FPImpl(check(Z3.mk_fpa_add(contextPtr, rm.ast, this.ast, otherFP.ast)));
            }
            sub(rm, other) {
                const otherFP = isFP(other) ? other : Float.val(other, this.sort);
                return new FPImpl(check(Z3.mk_fpa_sub(contextPtr, rm.ast, this.ast, otherFP.ast)));
            }
            mul(rm, other) {
                const otherFP = isFP(other) ? other : Float.val(other, this.sort);
                return new FPImpl(check(Z3.mk_fpa_mul(contextPtr, rm.ast, this.ast, otherFP.ast)));
            }
            div(rm, other) {
                const otherFP = isFP(other) ? other : Float.val(other, this.sort);
                return new FPImpl(check(Z3.mk_fpa_div(contextPtr, rm.ast, this.ast, otherFP.ast)));
            }
            neg() {
                return new FPImpl(check(Z3.mk_fpa_neg(contextPtr, this.ast)));
            }
            abs() {
                return new FPImpl(check(Z3.mk_fpa_abs(contextPtr, this.ast)));
            }
            sqrt(rm) {
                return new FPImpl(check(Z3.mk_fpa_sqrt(contextPtr, rm.ast, this.ast)));
            }
            rem(other) {
                const otherFP = isFP(other) ? other : Float.val(other, this.sort);
                return new FPImpl(check(Z3.mk_fpa_rem(contextPtr, this.ast, otherFP.ast)));
            }
            fma(rm, y, z) {
                const yFP = isFP(y) ? y : Float.val(y, this.sort);
                const zFP = isFP(z) ? z : Float.val(z, this.sort);
                return new FPImpl(check(Z3.mk_fpa_fma(contextPtr, rm.ast, this.ast, yFP.ast, zFP.ast)));
            }
            lt(other) {
                const otherFP = isFP(other) ? other : Float.val(other, this.sort);
                return new BoolImpl(check(Z3.mk_fpa_lt(contextPtr, this.ast, otherFP.ast)));
            }
            gt(other) {
                const otherFP = isFP(other) ? other : Float.val(other, this.sort);
                return new BoolImpl(check(Z3.mk_fpa_gt(contextPtr, this.ast, otherFP.ast)));
            }
            le(other) {
                const otherFP = isFP(other) ? other : Float.val(other, this.sort);
                return new BoolImpl(check(Z3.mk_fpa_leq(contextPtr, this.ast, otherFP.ast)));
            }
            ge(other) {
                const otherFP = isFP(other) ? other : Float.val(other, this.sort);
                return new BoolImpl(check(Z3.mk_fpa_geq(contextPtr, this.ast, otherFP.ast)));
            }
            isNaN() {
                return new BoolImpl(check(Z3.mk_fpa_is_nan(contextPtr, this.ast)));
            }
            isInf() {
                return new BoolImpl(check(Z3.mk_fpa_is_infinite(contextPtr, this.ast)));
            }
            isZero() {
                return new BoolImpl(check(Z3.mk_fpa_is_zero(contextPtr, this.ast)));
            }
            isNormal() {
                return new BoolImpl(check(Z3.mk_fpa_is_normal(contextPtr, this.ast)));
            }
            isSubnormal() {
                return new BoolImpl(check(Z3.mk_fpa_is_subnormal(contextPtr, this.ast)));
            }
            isNegative() {
                return new BoolImpl(check(Z3.mk_fpa_is_negative(contextPtr, this.ast)));
            }
            isPositive() {
                return new BoolImpl(check(Z3.mk_fpa_is_positive(contextPtr, this.ast)));
            }
            toIEEEBV() {
                return new BitVecImpl(check(Z3.mk_fpa_to_ieee_bv(contextPtr, this.ast)));
            }
            toReal() {
                return new ArithImpl(check(Z3.mk_fpa_to_real(contextPtr, this.ast)));
            }
        }
        class FPNumImpl extends FPImpl {
            value() {
                // Get the floating-point numeral as a JavaScript number
                // Note: This may lose precision for values outside JavaScript number range
                return Z3.get_numeral_double(contextPtr, this.ast);
            }
        }
        class SeqSortImpl extends SortImpl {
            isString() {
                return Z3.is_string_sort(contextPtr, this.ptr);
            }
            basis() {
                return _toSort(check(Z3.get_seq_sort_basis(contextPtr, this.ptr)));
            }
            cast(other) {
                if (isSeq(other)) {
                    _assertContext(other);
                    return other;
                }
                if (typeof other === 'string') return String.val(other);
                throw new Error("Can't cast to SeqSort");
            }
        }
        class SeqImpl extends ExprImpl {
            isString() {
                return Z3.is_string_sort(contextPtr, Z3.get_sort(contextPtr, this.ast));
            }
            asString() {
                if (!Z3.is_string(contextPtr, this.ast)) throw new Error('Not a string value');
                return Z3.get_string(contextPtr, this.ast);
            }
            concat(other) {
                const otherSeq = isSeq(other) ? other : String.val(other);
                return new SeqImpl(check(Z3.mk_seq_concat(contextPtr, [
                    this.ast,
                    otherSeq.ast
                ])));
            }
            length() {
                return new ArithImpl(check(Z3.mk_seq_length(contextPtr, this.ast)));
            }
            at(index) {
                const indexExpr = isArith(index) ? index : Int.val(index);
                return new SeqImpl(check(Z3.mk_seq_at(contextPtr, this.ast, indexExpr.ast)));
            }
            nth(index) {
                const indexExpr = isArith(index) ? index : Int.val(index);
                return _toExpr(check(Z3.mk_seq_nth(contextPtr, this.ast, indexExpr.ast)));
            }
            extract(offset, length) {
                const offsetExpr = isArith(offset) ? offset : Int.val(offset);
                const lengthExpr = isArith(length) ? length : Int.val(length);
                return new SeqImpl(check(Z3.mk_seq_extract(contextPtr, this.ast, offsetExpr.ast, lengthExpr.ast)));
            }
            indexOf(substr, offset) {
                const substrSeq = isSeq(substr) ? substr : String.val(substr);
                const offsetExpr = offset !== undefined ? isArith(offset) ? offset : Int.val(offset) : Int.val(0);
                return new ArithImpl(check(Z3.mk_seq_index(contextPtr, this.ast, substrSeq.ast, offsetExpr.ast)));
            }
            lastIndexOf(substr) {
                const substrSeq = isSeq(substr) ? substr : String.val(substr);
                return new ArithImpl(check(Z3.mk_seq_last_index(contextPtr, this.ast, substrSeq.ast)));
            }
            contains(substr) {
                const substrSeq = isSeq(substr) ? substr : String.val(substr);
                return new BoolImpl(check(Z3.mk_seq_contains(contextPtr, this.ast, substrSeq.ast)));
            }
            prefixOf(s) {
                const sSeq = isSeq(s) ? s : String.val(s);
                return new BoolImpl(check(Z3.mk_seq_prefix(contextPtr, this.ast, sSeq.ast)));
            }
            suffixOf(s) {
                const sSeq = isSeq(s) ? s : String.val(s);
                return new BoolImpl(check(Z3.mk_seq_suffix(contextPtr, this.ast, sSeq.ast)));
            }
            replace(src, dst) {
                const srcSeq = isSeq(src) ? src : String.val(src);
                const dstSeq = isSeq(dst) ? dst : String.val(dst);
                return new SeqImpl(check(Z3.mk_seq_replace(contextPtr, this.ast, srcSeq.ast, dstSeq.ast)));
            }
            replaceAll(src, dst) {
                const srcSeq = isSeq(src) ? src : String.val(src);
                const dstSeq = isSeq(dst) ? dst : String.val(dst);
                return new SeqImpl(check(Z3.mk_seq_replace_all(contextPtr, this.ast, srcSeq.ast, dstSeq.ast)));
            }
            replaceRe(re, dst) {
                const dstSeq = isSeq(dst) ? dst : String.val(dst);
                return new SeqImpl(check(Z3.mk_seq_replace_re(contextPtr, this.ast, re.ast, dstSeq.ast)));
            }
            replaceReAll(re, dst) {
                const dstSeq = isSeq(dst) ? dst : String.val(dst);
                return new SeqImpl(check(Z3.mk_seq_replace_re_all(contextPtr, this.ast, re.ast, dstSeq.ast)));
            }
            toInt() {
                return new ArithImpl(check(Z3.mk_str_to_int(contextPtr, this.ast)));
            }
            toCode() {
                return new ArithImpl(check(Z3.mk_string_to_code(contextPtr, this.ast)));
            }
            lt(other) {
                const otherSeq = isSeq(other) ? other : String.val(other);
                return new BoolImpl(check(Z3.mk_str_lt(contextPtr, this.ast, otherSeq.ast)));
            }
            le(other) {
                const otherSeq = isSeq(other) ? other : String.val(other);
                return new BoolImpl(check(Z3.mk_str_le(contextPtr, this.ast, otherSeq.ast)));
            }
            map(f) {
                return new SeqImpl(check(Z3.mk_seq_map(contextPtr, f.ast, this.ast)));
            }
            mapi(f, i) {
                const iExpr = isArith(i) ? i : Int.val(i);
                return new SeqImpl(check(Z3.mk_seq_mapi(contextPtr, f.ast, iExpr.ast, this.ast)));
            }
            foldl(f, a) {
                return _toExpr(check(Z3.mk_seq_foldl(contextPtr, f.ast, a.ast, this.ast)));
            }
            foldli(f, i, a) {
                const iExpr = isArith(i) ? i : Int.val(i);
                return _toExpr(check(Z3.mk_seq_foldli(contextPtr, f.ast, iExpr.ast, a.ast, this.ast)));
            }
        }
        class ReSortImpl extends SortImpl {
            basis() {
                return _toSort(check(Z3.get_re_sort_basis(contextPtr, this.ptr)));
            }
            cast(other) {
                if (isRe(other)) {
                    _assertContext(other);
                    return other;
                }
                throw new Error("Can't cast to ReSort");
            }
        }
        class ReImpl extends ExprImpl {
            plus() {
                return new ReImpl(check(Z3.mk_re_plus(contextPtr, this.ast)));
            }
            star() {
                return new ReImpl(check(Z3.mk_re_star(contextPtr, this.ast)));
            }
            option() {
                return new ReImpl(check(Z3.mk_re_option(contextPtr, this.ast)));
            }
            complement() {
                return new ReImpl(check(Z3.mk_re_complement(contextPtr, this.ast)));
            }
            union(other) {
                return new ReImpl(check(Z3.mk_re_union(contextPtr, [
                    this.ast,
                    other.ast
                ])));
            }
            intersect(other) {
                return new ReImpl(check(Z3.mk_re_intersect(contextPtr, [
                    this.ast,
                    other.ast
                ])));
            }
            diff(other) {
                return new ReImpl(check(Z3.mk_re_diff(contextPtr, this.ast, other.ast)));
            }
            concat(other) {
                return new ReImpl(check(Z3.mk_re_concat(contextPtr, [
                    this.ast,
                    other.ast
                ])));
            }
            /**
             * Create a bounded repetition of this regex
             * @param lo Minimum number of repetitions
             * @param hi Maximum number of repetitions (0 means unbounded, i.e., at least lo)
             */ loop(lo, hi = 0) {
                return new ReImpl(check(Z3.mk_re_loop(contextPtr, this.ast, lo, hi)));
            }
            power(n) {
                return new ReImpl(check(Z3.mk_re_power(contextPtr, this.ast, n)));
            }
        }
        class ArraySortImpl extends SortImpl {
            domain() {
                return _toSort(check(Z3.get_array_sort_domain(contextPtr, this.ptr)));
            }
            domain_n(i) {
                return _toSort(check(Z3.get_array_sort_domain_n(contextPtr, this.ptr, i)));
            }
            range() {
                return _toSort(check(Z3.get_array_sort_range(contextPtr, this.ptr)));
            }
        }
        class ArrayImpl extends ExprImpl {
            domain() {
                return this.sort.domain();
            }
            domain_n(i) {
                return this.sort.domain_n(i);
            }
            range() {
                return this.sort.range();
            }
            select(...indices) {
                return Select(this, ...indices);
            }
            store(...indicesAndValue) {
                return Store(this, ...indicesAndValue);
            }
            /**
             * Access the array default value.
             * Produces the default range value, for arrays that can be represented as
             * finite maps with a default range value.
             */ default() {
                return _toExpr(check(Z3.mk_array_default(contextPtr, this.ast)));
            }
        }
        class SetImpl extends ExprImpl {
            elemSort() {
                return this.sort.domain();
            }
            union(...args) {
                return SetUnion(this, ...args);
            }
            intersect(...args) {
                return SetIntersect(this, ...args);
            }
            diff(b) {
                return SetDifference(this, b);
            }
            add(elem) {
                return SetAdd(this, elem);
            }
            del(elem) {
                return SetDel(this, elem);
            }
            complement() {
                return SetComplement(this);
            }
            contains(elem) {
                return isMember(elem, this);
            }
            subsetOf(b) {
                return isSubset(this, b);
            }
        }
        ////////////////////////////
        // Finite Sets
        ////////////////////////////
        class FiniteSetSortImpl extends SortImpl {
            elemSort() {
                return _toSort(check(Z3.get_finite_set_sort_basis(contextPtr, this.ptr)));
            }
            cast(other) {
                _assertContext(other);
                return other;
            }
        }
        class FiniteSetImpl extends ExprImpl {
            union(other) {
                return new FiniteSetImpl(check(Z3.mk_finite_set_union(contextPtr, this.ast, other.ast)));
            }
            intersect(other) {
                return new FiniteSetImpl(check(Z3.mk_finite_set_intersect(contextPtr, this.ast, other.ast)));
            }
            diff(other) {
                return new FiniteSetImpl(check(Z3.mk_finite_set_difference(contextPtr, this.ast, other.ast)));
            }
            contains(elem) {
                return new BoolImpl(check(Z3.mk_finite_set_member(contextPtr, elem.ast, this.ast)));
            }
            size() {
                return new ExprImpl(check(Z3.mk_finite_set_size(contextPtr, this.ast)));
            }
            subsetOf(other) {
                return new BoolImpl(check(Z3.mk_finite_set_subset(contextPtr, this.ast, other.ast)));
            }
            map(f) {
                return new FiniteSetImpl(check(Z3.mk_finite_set_map(contextPtr, f.ast, this.ast)));
            }
            filter(f) {
                return new FiniteSetImpl(check(Z3.mk_finite_set_filter(contextPtr, f.ast, this.ast)));
            }
        }
        ////////////////////////////
        // Datatypes
        ////////////////////////////
        class DatatypeImpl {
            constructor(ctx, name){
                this.constructors = [];
                this.ctx = ctx;
                this.name = name;
            }
            declare(name, ...fields) {
                this.constructors.push([
                    name,
                    fields
                ]);
                return this;
            }
            create() {
                const datatypes = createDatatypes(this);
                return datatypes[0];
            }
            createPolymorphic(typeParams) {
                return createPolymorphicDatatype(typeParams, this);
            }
        }
        class DatatypeSortImpl extends SortImpl {
            numConstructors() {
                return Z3.get_datatype_sort_num_constructors(contextPtr, this.ptr);
            }
            constructorDecl(idx) {
                const ptr = Z3.get_datatype_sort_constructor(contextPtr, this.ptr, idx);
                return new FuncDeclImpl(ptr);
            }
            recognizer(idx) {
                const ptr = Z3.get_datatype_sort_recognizer(contextPtr, this.ptr, idx);
                return new FuncDeclImpl(ptr);
            }
            accessor(constructorIdx, accessorIdx) {
                const ptr = Z3.get_datatype_sort_constructor_accessor(contextPtr, this.ptr, constructorIdx, accessorIdx);
                return new FuncDeclImpl(ptr);
            }
            cast(other) {
                if (isExpr(other)) {
                    (0, $kbizf.assert)(this.eqIdentity(other.sort), 'Value cannot be converted to this datatype');
                    return other;
                }
                throw new Error('Cannot coerce value to datatype expression');
            }
            subsort(other) {
                _assertContext(other.ctx);
                return this.eqIdentity(other);
            }
        }
        class DatatypeExprImpl extends ExprImpl {
        }
        function createDatatypes(...datatypes) {
            if (datatypes.length === 0) throw new Error('At least one datatype must be provided');
            // All datatypes must be from the same context
            const dtCtx = datatypes[0].ctx;
            for (const dt of datatypes){
                if (dt.ctx !== dtCtx) throw new Error('All datatypes must be from the same context');
            }
            const sortNames = datatypes.map((dt)=>dt.name);
            const constructorLists = [];
            const scopedConstructors = [];
            try {
                // Create constructor lists for each datatype
                for (const dt of datatypes){
                    const constructors = [];
                    for (const [constructorName, fields] of dt.constructors){
                        const fieldNames = [];
                        const fieldSorts = [];
                        const fieldRefs = [];
                        for (const [fieldName, fieldSort] of fields){
                            fieldNames.push(fieldName);
                            if (fieldSort instanceof DatatypeImpl) {
                                // Reference to another datatype being defined
                                const refIndex = datatypes.indexOf(fieldSort);
                                if (refIndex === -1) throw new Error(`Referenced datatype "${fieldSort.name}" not found in datatypes being created`);
                                // For recursive references, we pass null and the ref index
                                fieldSorts.push(null); // null will be handled by the Z3 API
                                fieldRefs.push(refIndex);
                            } else {
                                // Regular sort
                                fieldSorts.push(fieldSort.ptr);
                                fieldRefs.push(0);
                            }
                        }
                        const constructor = Z3.mk_constructor(contextPtr, Z3.mk_string_symbol(contextPtr, constructorName), Z3.mk_string_symbol(contextPtr, `is_${constructorName}`), fieldNames.map((name)=>Z3.mk_string_symbol(contextPtr, name)), fieldSorts, fieldRefs);
                        constructors.push(constructor);
                        scopedConstructors.push(constructor);
                    }
                    const constructorList = Z3.mk_constructor_list(contextPtr, constructors);
                    constructorLists.push(constructorList);
                }
                // Create the datatypes
                const sortSymbols = sortNames.map((name)=>Z3.mk_string_symbol(contextPtr, name));
                const resultSorts = Z3.mk_datatypes(contextPtr, sortSymbols, constructorLists);
                // Create DatatypeSortImpl instances
                const results = [];
                for(let i = 0; i < resultSorts.length; i++){
                    const sortImpl = new DatatypeSortImpl(resultSorts[i]);
                    // Attach constructor, recognizer, and accessor functions dynamically
                    const numConstructors = sortImpl.numConstructors();
                    for(let j = 0; j < numConstructors; j++){
                        const constructor = sortImpl.constructorDecl(j);
                        const recognizer = sortImpl.recognizer(j);
                        const constructorName = constructor.name().toString();
                        // Attach constructor function
                        if (constructor.arity() === 0) // Nullary constructor (constant)
                        sortImpl[constructorName] = constructor.call();
                        else sortImpl[constructorName] = constructor;
                        // Attach recognizer function
                        sortImpl[`is_${constructorName}`] = recognizer;
                        // Attach accessor functions
                        for(let k = 0; k < constructor.arity(); k++){
                            const accessor = sortImpl.accessor(j, k);
                            const accessorName = accessor.name().toString();
                            sortImpl[accessorName] = accessor;
                        }
                    }
                    results.push(sortImpl);
                }
                return results;
            } finally{
                // Clean up resources
                for (const constructor of scopedConstructors)Z3.del_constructor(contextPtr, constructor);
                for (const constructorList of constructorLists)Z3.del_constructor_list(contextPtr, constructorList);
            }
        }
        function createPolymorphicDatatype(typeParams, datatype) {
            if (!(datatype instanceof DatatypeImpl)) throw new Error('Datatype instance expected');
            const constructors = [];
            try {
                for (const [constructorName, fields] of datatype.constructors){
                    const fieldNames = [];
                    const fieldSorts = [];
                    const fieldRefs = [];
                    for (const [fieldName, fieldSort] of fields){
                        fieldNames.push(fieldName);
                        if (fieldSort instanceof DatatypeImpl) {
                            // Self-recursive reference
                            if (fieldSort !== datatype) throw new Error(`Referenced datatype "${fieldSort.name}" is not the polymorphic datatype being created; mutual recursion is not supported in createPolymorphicDatatype`);
                            fieldSorts.push(null);
                            fieldRefs.push(0);
                        } else {
                            fieldSorts.push(fieldSort.ptr);
                            fieldRefs.push(0);
                        }
                    }
                    const constructor = Z3.mk_constructor(contextPtr, Z3.mk_string_symbol(contextPtr, constructorName), Z3.mk_string_symbol(contextPtr, `is_${constructorName}`), fieldNames.map((name)=>Z3.mk_string_symbol(contextPtr, name)), fieldSorts, fieldRefs);
                    constructors.push(constructor);
                }
                const nameSymbol = Z3.mk_string_symbol(contextPtr, datatype.name);
                const paramPtrs = typeParams.map((p)=>p.ptr);
                const resultSort = Z3.mk_polymorphic_datatype(contextPtr, nameSymbol, paramPtrs, constructors);
                const sortImpl = new DatatypeSortImpl(resultSort);
                // Attach constructor, recognizer, and accessor functions dynamically
                const numConstructors = sortImpl.numConstructors();
                for(let j = 0; j < numConstructors; j++){
                    const constructor = sortImpl.constructorDecl(j);
                    const recognizer = sortImpl.recognizer(j);
                    const constructorName = constructor.name().toString();
                    if (constructor.arity() === 0) sortImpl[constructorName] = constructor.call();
                    else sortImpl[constructorName] = constructor;
                    sortImpl[`is_${constructorName}`] = recognizer;
                    for(let k = 0; k < constructor.arity(); k++){
                        const accessor = sortImpl.accessor(j, k);
                        const accessorName = accessor.name().toString();
                        sortImpl[accessorName] = accessor;
                    }
                }
                return sortImpl;
            } finally{
                for (const constructor of constructors)Z3.del_constructor(contextPtr, constructor);
            }
        }
        class QuantifierImpl extends ExprImpl {
            is_forall() {
                return Z3.is_quantifier_forall(contextPtr, this.ast);
            }
            is_exists() {
                return Z3.is_quantifier_exists(contextPtr, this.ast);
            }
            is_lambda() {
                return Z3.is_lambda(contextPtr, this.ast);
            }
            weight() {
                return Z3.get_quantifier_weight(contextPtr, this.ast);
            }
            num_patterns() {
                return Z3.get_quantifier_num_patterns(contextPtr, this.ast);
            }
            pattern(i) {
                return new PatternImpl(check(Z3.get_quantifier_pattern_ast(contextPtr, this.ast, i)));
            }
            num_no_patterns() {
                return Z3.get_quantifier_num_no_patterns(contextPtr, this.ast);
            }
            no_pattern(i) {
                return _toExpr(check(Z3.get_quantifier_no_pattern_ast(contextPtr, this.ast, i)));
            }
            body() {
                return _toExpr(check(Z3.get_quantifier_body(contextPtr, this.ast)));
            }
            num_vars() {
                return Z3.get_quantifier_num_bound(contextPtr, this.ast);
            }
            var_name(i) {
                return _fromSymbol(Z3.get_quantifier_bound_name(contextPtr, this.ast, i));
            }
            var_sort(i) {
                return _toSort(check(Z3.get_quantifier_bound_sort(contextPtr, this.ast, i)));
            }
            children() {
                return [
                    this.body()
                ];
            }
        }
        class NonLambdaQuantifierImpl extends QuantifierImpl {
            not() {
                return Not(this);
            }
            and(other) {
                return And(this, other);
            }
            or(other) {
                return Or(this, other);
            }
            xor(other) {
                return Xor(this, other);
            }
            implies(other) {
                return Implies(this, other);
            }
            iff(other) {
                return Iff(this, other);
            }
        }
        // isBool will return false which is unlike the python API (but like the C API)
        class LambdaImpl extends QuantifierImpl {
            domain() {
                return this.sort.domain();
            }
            domain_n(i) {
                return this.sort.domain_n(i);
            }
            range() {
                return this.sort.range();
            }
            select(...indices) {
                return Select(this, ...indices);
            }
            store(...indicesAndValue) {
                return Store(this, ...indicesAndValue);
            }
            /**
             * Access the array default value.
             * Produces the default range value, for arrays that can be represented as
             * finite maps with a default range value.
             */ default() {
                return _toExpr(check(Z3.mk_array_default(contextPtr, this.ast)));
            }
        }
        class AstVectorImpl {
            constructor(ptr = Z3.mk_ast_vector(contextPtr)){
                this.ptr = ptr;
                this.ctx = ctx;
                Z3.ast_vector_inc_ref(contextPtr, ptr);
                cleanup.register(this, ()=>Z3.ast_vector_dec_ref(contextPtr, ptr), this);
            }
            length() {
                return Z3.ast_vector_size(contextPtr, this.ptr);
            }
            [Symbol.iterator]() {
                return this.values();
            }
            *entries() {
                const length = this.length();
                for(let i = 0; i < length; i++)yield [
                    i,
                    this.get(i)
                ];
            }
            *keys() {
                for (let [key] of this.entries())yield key;
            }
            *values() {
                for (let [, value] of this.entries())yield value;
            }
            get(from, to) {
                const length = this.length();
                if (from < 0) from += length;
                if (from >= length) throw new RangeError(`expected from index ${from} to be less than length ${length}`);
                if (to === undefined) return _toAst(check(Z3.ast_vector_get(contextPtr, this.ptr, from)));
                if (to < 0) to += length;
                if (to >= length) throw new RangeError(`expected to index ${to} to be less than length ${length}`);
                const result = [];
                for(let i = from; i < to; i++)result.push(_toAst(check(Z3.ast_vector_get(contextPtr, this.ptr, i))));
                return result;
            }
            set(i, v) {
                _assertContext(v);
                if (i >= this.length()) throw new RangeError(`expected index ${i} to be less than length ${this.length()}`);
                check(Z3.ast_vector_set(contextPtr, this.ptr, i, v.ast));
            }
            push(v) {
                _assertContext(v);
                check(Z3.ast_vector_push(contextPtr, this.ptr, v.ast));
            }
            resize(size) {
                check(Z3.ast_vector_resize(contextPtr, this.ptr, size));
            }
            has(v) {
                _assertContext(v);
                for (const item of this.values()){
                    if (item.eqIdentity(v)) return true;
                }
                return false;
            }
            sexpr() {
                return check(Z3.ast_vector_to_string(contextPtr, this.ptr));
            }
        }
        class AstMapImpl {
            constructor(ptr = Z3.mk_ast_map(contextPtr)){
                this.ptr = ptr;
                this.ctx = ctx;
                Z3.ast_map_inc_ref(contextPtr, ptr);
                cleanup.register(this, ()=>Z3.ast_map_dec_ref(contextPtr, ptr), this);
            }
            [Symbol.iterator]() {
                return this.entries();
            }
            get size() {
                return Z3.ast_map_size(contextPtr, this.ptr);
            }
            *entries() {
                for (const key of this.keys())yield [
                    key,
                    this.get(key)
                ];
            }
            keys() {
                return new AstVectorImpl(Z3.ast_map_keys(contextPtr, this.ptr));
            }
            *values() {
                for (const [_, value] of this.entries())yield value;
            }
            get(key) {
                return _toAst(check(Z3.ast_map_find(contextPtr, this.ptr, key.ast)));
            }
            set(key, value) {
                check(Z3.ast_map_insert(contextPtr, this.ptr, key.ast, value.ast));
            }
            delete(key) {
                check(Z3.ast_map_erase(contextPtr, this.ptr, key.ast));
            }
            clear() {
                check(Z3.ast_map_reset(contextPtr, this.ptr));
            }
            has(key) {
                return check(Z3.ast_map_contains(contextPtr, this.ptr, key.ast));
            }
            sexpr() {
                return check(Z3.ast_map_to_string(contextPtr, this.ptr));
            }
        }
        function substitute(t, ...substitutions) {
            _assertContext(t);
            const from = [];
            const to = [];
            for (const [f, t] of substitutions){
                _assertContext(f);
                _assertContext(t);
                from.push(f.ast);
                to.push(t.ast);
            }
            return _toExpr(check(Z3.substitute(contextPtr, t.ast, from, to)));
        }
        function substituteVars(t, ...to) {
            _assertContext(t);
            const toAsts = [];
            for (const expr of to){
                _assertContext(expr);
                toAsts.push(expr.ast);
            }
            return _toExpr(check(Z3.substitute_vars(contextPtr, t.ast, toAsts)));
        }
        function substituteFuns(t, ...substitutions) {
            _assertContext(t);
            const from = [];
            const to = [];
            for (const [f, body] of substitutions){
                _assertContext(f);
                _assertContext(body);
                from.push(f.ptr);
                to.push(body.ast);
            }
            return _toExpr(check(Z3.substitute_funs(contextPtr, t.ast, from, to)));
        }
        function updateField(t, fieldAccessor, newValue) {
            _assertContext(t);
            _assertContext(fieldAccessor);
            _assertContext(newValue);
            return _toExpr(check(Z3.datatype_update_field(contextPtr, fieldAccessor.ptr, t.ast, newValue.ast)));
        }
        function ast_from_string(s) {
            const sort_names = [];
            const sorts = [];
            const decl_names = [];
            const decls = [];
            const v = new AstVectorImpl(check(Z3.parse_smtlib2_string(contextPtr, s, sort_names, sorts, decl_names, decls)));
            if (v.length() !== 1) throw new Error('Expected exactly one AST. Instead got ' + v.length() + ': ' + v.sexpr());
            return v.get(0);
        }
        const ctx = {
            ptr: contextPtr,
            name: name,
            /////////////
            // Classes //
            /////////////
            Solver: SolverImpl,
            Optimize: OptimizeImpl,
            Fixedpoint: FixedpointImpl,
            Model: ModelImpl,
            Tactic: TacticImpl,
            Goal: GoalImpl,
            Params: ParamsImpl,
            Simplifier: SimplifierImpl,
            AstVector: AstVectorImpl,
            AstMap: AstMapImpl,
            interrupt: ///////////////
            // Functions //
            ///////////////
            interrupt,
            setPrintMode: setPrintMode,
            isModel: isModel,
            isAst: isAst,
            isSort: isSort,
            isFuncDecl: isFuncDecl,
            isFuncInterp: isFuncInterp,
            isApp: isApp,
            isConst: isConst,
            isExpr: isExpr,
            isVar: isVar,
            isAppOf: isAppOf,
            isBool: isBool,
            isTrue: isTrue,
            isFalse: isFalse,
            isAnd: isAnd,
            isOr: isOr,
            isImplies: isImplies,
            isNot: isNot,
            isEq: isEq,
            isDistinct: isDistinct,
            isQuantifier: isQuantifier,
            isArith: isArith,
            isArithSort: isArithSort,
            isInt: isInt,
            isIntVal: isIntVal,
            isIntSort: isIntSort,
            isReal: isReal,
            isRealVal: isRealVal,
            isRealSort: isRealSort,
            isRCFNum: isRCFNum,
            isBitVecSort: isBitVecSort,
            isBitVec: isBitVec,
            isBitVecVal: isBitVecVal,
            isFPRMSort: isFPRMSort,
            isFPRM: isFPRM,
            isFPSort: isFPSort,
            isFP: isFP,
            isFPVal: isFPVal,
            isSeqSort: isSeqSort,
            isSeq: isSeq,
            isStringSort: isStringSort,
            isString: isString,
            isFiniteSetSort: isFiniteSetSort,
            isFiniteSet: isFiniteSet,
            isArraySort: isArraySort,
            isArray: isArray,
            isConstArray: isConstArray,
            isProbe: isProbe,
            isTactic: isTactic,
            isGoal: isGoal,
            isAstVector: isAstVector,
            eqIdentity: eqIdentity,
            getVarIndex: getVarIndex,
            from: from,
            solve: solve,
            Sort: /////////////
            // Objects //
            /////////////
            Sort,
            Function: Function,
            RecFunc: RecFunc,
            Bool: Bool,
            Int: Int,
            Real: Real,
            RCFNum: RCFNum,
            BitVec: BitVec,
            Float: Float,
            FloatRM: FloatRM,
            String: String,
            Seq: Seq,
            Re: Re,
            Array: Array,
            Set: Set,
            FiniteSet: FiniteSet,
            Datatype: Datatype,
            TypeVariable: TypeVariable,
            If: ////////////////
            // Operations //
            ////////////////
            If,
            Distinct: Distinct,
            Const: Const,
            Consts: Consts,
            FreshConst: FreshConst,
            Var: Var,
            Implies: Implies,
            Iff: Iff,
            Eq: Eq,
            Xor: Xor,
            Not: Not,
            And: And,
            Or: Or,
            PbEq: PbEq,
            PbGe: PbGe,
            PbLe: PbLe,
            AtMost: AtMost,
            AtLeast: AtLeast,
            ForAll: ForAll,
            Exists: Exists,
            Lambda: Lambda,
            ToReal: ToReal,
            ToInt: ToInt,
            IsInt: IsInt,
            Sqrt: Sqrt,
            Cbrt: Cbrt,
            BV2Int: BV2Int,
            Int2BV: Int2BV,
            Concat: Concat,
            Cond: Cond,
            AndThen: AndThen,
            OrElse: OrElse,
            Repeat: Repeat,
            TryFor: TryFor,
            When: When,
            Skip: Skip,
            Fail: Fail,
            FailIf: FailIf,
            ParOr: ParOr,
            ParAndThen: ParAndThen,
            With: With,
            LT: LT,
            GT: GT,
            LE: LE,
            GE: GE,
            ULT: ULT,
            UGT: UGT,
            ULE: ULE,
            UGE: UGE,
            SLT: SLT,
            SGT: SGT,
            SLE: SLE,
            SGE: SGE,
            Sum: Sum,
            Sub: Sub,
            Product: Product,
            Div: Div,
            BUDiv: BUDiv,
            Neg: Neg,
            Mod: Mod,
            Select: Select,
            Store: Store,
            Ext: Ext,
            Extract: Extract,
            substitute: substitute,
            substituteVars: substituteVars,
            substituteFuns: substituteFuns,
            updateField: updateField,
            simplify: simplify,
            ast_from_string: /////////////
            // Loading //
            /////////////
            ast_from_string,
            SetUnion: SetUnion,
            SetIntersect: SetIntersect,
            SetDifference: SetDifference,
            SetAdd: SetAdd,
            SetDel: SetDel,
            SetComplement: SetComplement,
            EmptySet: EmptySet,
            FullSet: FullSet,
            isMember: isMember,
            isSubset: isSubset,
            InRe: InRe,
            Union: Union,
            Intersect: Intersect,
            ReConcat: ReConcat,
            Plus: Plus,
            Star: Star,
            Option: Option,
            Complement: Complement,
            Diff: Diff,
            Range: Range,
            Loop: Loop,
            Power: Power,
            AllChar: AllChar,
            Empty: Empty,
            Full: Full,
            mkPartialOrder: mkPartialOrder,
            mkLinearOrder: mkLinearOrder,
            mkPiecewiseLinearOrder: mkPiecewiseLinearOrder,
            mkTreeOrder: mkTreeOrder,
            mkTransitiveClosure: mkTransitiveClosure,
            mkChar: mkChar,
            mkCharLe: mkCharLe,
            mkCharToInt: mkCharToInt,
            mkCharToBV: mkCharToBV,
            mkCharFromBV: mkCharFromBV,
            mkCharIsDigit: mkCharIsDigit,
            polynomialSubresultants: polynomialSubresultants
        };
        cleanup.register(ctx, ()=>Z3.del_context(contextPtr));
        return ctx;
    }
    return {
        enableTrace: enableTrace,
        disableTrace: disableTrace,
        getVersion: getVersion,
        getVersionString: getVersionString,
        getFullVersion: getFullVersion,
        openLog: openLog,
        appendLog: appendLog,
        getParam: getParam,
        setParam: setParam,
        resetParams: resetParams,
        Context: createContext
    };
}

});
parcelRegister("5qEhx", function(module, exports) {

$parcel$export(module.exports, "Mutex", () => (parcelRequire("7smOd")).default);

var $7smOd = parcelRequire("7smOd");

var $kdbh9 = parcelRequire("kdbh9");

var $gwKUv = parcelRequire("gwKUv");

var $hTW9e = parcelRequire("hTW9e");
parcelRequire("Fgymq");

});
parcelRegister("7smOd", function(module, exports) {

$parcel$export(module.exports, "default", () => $56dcd752428c7c97$export$2e2bcd8739ae039);

var $gztBd = parcelRequire("gztBd");

var $kdbh9 = parcelRequire("kdbh9");
var $56dcd752428c7c97$var$Mutex = /** @class */ function() {
    function Mutex(cancelError) {
        this._semaphore = new (0, $kdbh9.default)(1, cancelError);
    }
    Mutex.prototype.acquire = function() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var _a, releaser;
            return (0, $gztBd.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._semaphore.acquire()
                        ];
                    case 1:
                        _a = _b.sent(), releaser = _a[1];
                        return [
                            2 /*return*/ ,
                            releaser
                        ];
                }
            });
        });
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this._semaphore.runExclusive(function() {
            return callback();
        });
    };
    Mutex.prototype.isLocked = function() {
        return this._semaphore.isLocked();
    };
    Mutex.prototype.waitForUnlock = function() {
        return this._semaphore.waitForUnlock();
    };
    /** @deprecated Deprecated in 0.3.0, will be removed in 0.4.0. Use runExclusive instead. */ Mutex.prototype.release = function() {
        this._semaphore.release();
    };
    Mutex.prototype.cancel = function() {
        return this._semaphore.cancel();
    };
    return Mutex;
}();
var $56dcd752428c7c97$export$2e2bcd8739ae039 = $56dcd752428c7c97$var$Mutex;

});
parcelRegister("gztBd", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $c106e002a49a00cb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $c106e002a49a00cb$export$67ebef60e6f28a6);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c106e002a49a00cb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c106e002a49a00cb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c106e002a49a00cb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c106e002a49a00cb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c106e002a49a00cb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c106e002a49a00cb$export$45d3717a4c69092e(o, m, p);
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c106e002a49a00cb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $c106e002a49a00cb$var$ownKeys = function(o) {
    $c106e002a49a00cb$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $c106e002a49a00cb$var$ownKeys(o);
};
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $c106e002a49a00cb$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $c106e002a49a00cb$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $c106e002a49a00cb$var$__setModuleDefault(result, mod);
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c106e002a49a00cb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c106e002a49a00cb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c106e002a49a00cb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c106e002a49a00cb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c106e002a49a00cb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $c106e002a49a00cb$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $c106e002a49a00cb$export$2e2bcd8739ae039 = {
    __extends: $c106e002a49a00cb$export$a8ba968b8961cb8a,
    __assign: $c106e002a49a00cb$export$18ce0697a983be9b,
    __rest: $c106e002a49a00cb$export$3c9a16f847548506,
    __decorate: $c106e002a49a00cb$export$29e00dfd3077644b,
    __param: $c106e002a49a00cb$export$d5ad3fd78186038f,
    __esDecorate: $c106e002a49a00cb$export$3a84e1ae4e97e9b0,
    __runInitializers: $c106e002a49a00cb$export$d831c04e792af3d,
    __propKey: $c106e002a49a00cb$export$6a2a36740a146cb8,
    __setFunctionName: $c106e002a49a00cb$export$d1a06452d3489bc7,
    __metadata: $c106e002a49a00cb$export$f1db080c865becb9,
    __awaiter: $c106e002a49a00cb$export$1050f835b63b671e,
    __generator: $c106e002a49a00cb$export$67ebef60e6f28a6,
    __createBinding: $c106e002a49a00cb$export$45d3717a4c69092e,
    __exportStar: $c106e002a49a00cb$export$f33643c0debef087,
    __values: $c106e002a49a00cb$export$19a8beecd37a4c45,
    __read: $c106e002a49a00cb$export$8d051b38c9118094,
    __spread: $c106e002a49a00cb$export$afc72e2116322959,
    __spreadArrays: $c106e002a49a00cb$export$6388937ca91ccae8,
    __spreadArray: $c106e002a49a00cb$export$1216008129fb82ed,
    __await: $c106e002a49a00cb$export$10c90e4f7922046c,
    __asyncGenerator: $c106e002a49a00cb$export$e427f37a30a4de9b,
    __asyncDelegator: $c106e002a49a00cb$export$bbd80228419bb833,
    __asyncValues: $c106e002a49a00cb$export$e3b29a3d6162315f,
    __makeTemplateObject: $c106e002a49a00cb$export$4fb47efe1390b86f,
    __importStar: $c106e002a49a00cb$export$c21735bcef00d192,
    __importDefault: $c106e002a49a00cb$export$da59b14a69baef04,
    __classPrivateFieldGet: $c106e002a49a00cb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c106e002a49a00cb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c106e002a49a00cb$export$81fdc39f203e4e04,
    __addDisposableResource: $c106e002a49a00cb$export$88ac25d8e944e405,
    __disposeResources: $c106e002a49a00cb$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $c106e002a49a00cb$export$889dfb5d17574b0b
};

});

parcelRegister("kdbh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6dc4a9ea964be2$export$2e2bcd8739ae039);

var $gztBd = parcelRequire("gztBd");

var $Fgymq = parcelRequire("Fgymq");
var $eb6dc4a9ea964be2$var$Semaphore = /** @class */ function() {
    function Semaphore(_maxConcurrency, _cancelError) {
        if (_cancelError === void 0) _cancelError = (0, $Fgymq.E_CANCELED);
        this._maxConcurrency = _maxConcurrency;
        this._cancelError = _cancelError;
        this._queue = [];
        this._waiters = [];
        if (_maxConcurrency <= 0) throw new Error('semaphore must be initialized to a positive value');
        this._value = _maxConcurrency;
    }
    Semaphore.prototype.acquire = function() {
        var _this = this;
        var locked = this.isLocked();
        var ticketPromise = new Promise(function(resolve, reject) {
            return _this._queue.push({
                resolve: resolve,
                reject: reject
            });
        });
        if (!locked) this._dispatch();
        return ticketPromise;
    };
    Semaphore.prototype.runExclusive = function(callback) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var _a, value, release;
            return (0, $gztBd.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.acquire()
                        ];
                    case 1:
                        _a = _b.sent(), value = _a[0], release = _a[1];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            ,
                            4,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            callback(value)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        release();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Semaphore.prototype.waitForUnlock = function() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var waitPromise;
            var _this = this;
            return (0, $gztBd.__generator)(this, function(_a) {
                if (!this.isLocked()) return [
                    2 /*return*/ ,
                    Promise.resolve()
                ];
                waitPromise = new Promise(function(resolve) {
                    return _this._waiters.push({
                        resolve: resolve
                    });
                });
                return [
                    2 /*return*/ ,
                    waitPromise
                ];
            });
        });
    };
    Semaphore.prototype.isLocked = function() {
        return this._value <= 0;
    };
    /** @deprecated Deprecated in 0.3.0, will be removed in 0.4.0. Use runExclusive instead. */ Semaphore.prototype.release = function() {
        if (this._maxConcurrency > 1) throw new Error('this method is unavailable on semaphores with concurrency > 1; use the scoped release returned by acquire instead');
        if (this._currentReleaser) {
            var releaser = this._currentReleaser;
            this._currentReleaser = undefined;
            releaser();
        }
    };
    Semaphore.prototype.cancel = function() {
        var _this = this;
        this._queue.forEach(function(ticket) {
            return ticket.reject(_this._cancelError);
        });
        this._queue = [];
    };
    Semaphore.prototype._dispatch = function() {
        var _this = this;
        var nextTicket = this._queue.shift();
        if (!nextTicket) return;
        var released = false;
        this._currentReleaser = function() {
            if (released) return;
            released = true;
            _this._value++;
            _this._resolveWaiters();
            _this._dispatch();
        };
        nextTicket.resolve([
            this._value--,
            this._currentReleaser
        ]);
    };
    Semaphore.prototype._resolveWaiters = function() {
        this._waiters.forEach(function(waiter) {
            return waiter.resolve();
        });
        this._waiters = [];
    };
    return Semaphore;
}();
var $eb6dc4a9ea964be2$export$2e2bcd8739ae039 = $eb6dc4a9ea964be2$var$Semaphore;

});
parcelRegister("Fgymq", function(module, exports) {

$parcel$export(module.exports, "E_TIMEOUT", () => $07c0ab92720027f6$export$7091319fa7a2605a);
$parcel$export(module.exports, "E_ALREADY_LOCKED", () => $07c0ab92720027f6$export$7af7a6c3bec038d7);
$parcel$export(module.exports, "E_CANCELED", () => $07c0ab92720027f6$export$59cb0096d5783133);
var $07c0ab92720027f6$export$7091319fa7a2605a = new Error('timeout while waiting for mutex to become available');
var $07c0ab92720027f6$export$7af7a6c3bec038d7 = new Error('mutex already locked');
var $07c0ab92720027f6$export$59cb0096d5783133 = new Error('request for lock canceled');

});



parcelRegister("gwKUv", function(module, exports) {

$parcel$export(module.exports, "withTimeout", () => $c08405f0d036a081$export$e86e19342bc4850e);

var $gztBd = parcelRequire("gztBd");

var $Fgymq = parcelRequire("Fgymq");
function $c08405f0d036a081$export$e86e19342bc4850e(sync, timeout, timeoutError) {
    var _this = this;
    if (timeoutError === void 0) timeoutError = (0, $Fgymq.E_TIMEOUT);
    return {
        acquire: function() {
            return new Promise(function(resolve, reject) {
                return (0, $gztBd.__awaiter)(_this, void 0, void 0, function() {
                    var isTimeout, handle, ticket, release, e_1;
                    return (0, $gztBd.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                isTimeout = false;
                                handle = setTimeout(function() {
                                    isTimeout = true;
                                    reject(timeoutError);
                                }, timeout);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    sync.acquire()
                                ];
                            case 2:
                                ticket = _a.sent();
                                if (isTimeout) {
                                    release = Array.isArray(ticket) ? ticket[1] : ticket;
                                    release();
                                } else {
                                    clearTimeout(handle);
                                    resolve(ticket);
                                }
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                e_1 = _a.sent();
                                if (!isTimeout) {
                                    clearTimeout(handle);
                                    reject(e_1);
                                }
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
        },
        runExclusive: function(callback) {
            return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
                var release, ticket;
                return (0, $gztBd.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            release = function() {
                                return undefined;
                            };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                ,
                                7,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.acquire()
                            ];
                        case 2:
                            ticket = _a.sent();
                            if (!Array.isArray(ticket)) return [
                                3 /*break*/ ,
                                4
                            ];
                            release = ticket[1];
                            return [
                                4 /*yield*/ ,
                                callback(ticket[0])
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 4:
                            release = ticket;
                            return [
                                4 /*yield*/ ,
                                callback()
                            ];
                        case 5:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            release();
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        /** @deprecated Deprecated in 0.3.0, will be removed in 0.4.0. Use runExclusive instead. */ release: function() {
            sync.release();
        },
        cancel: function() {
            return sync.cancel();
        },
        waitForUnlock: function() {
            return sync.waitForUnlock();
        },
        isLocked: function() {
            return sync.isLocked();
        }
    };
}

});

parcelRegister("hTW9e", function(module, exports) {

var $Fgymq = parcelRequire("Fgymq");

var $gwKUv = parcelRequire("gwKUv");
function $d084adaeb759aecd$export$b1b3e01dca9113dc(sync, alreadyAcquiredError) {
    if (alreadyAcquiredError === void 0) alreadyAcquiredError = (0, $Fgymq.E_ALREADY_LOCKED);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (0, $gwKUv.withTimeout)(sync, 0, alreadyAcquiredError);
}

});


parcelRegister("7tXKo", function(module, exports) {
"use strict";
var $5729966a08c45b01$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5729966a08c45b01$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5729966a08c45b01$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5729966a08c45b01$var$__exportStar((parcelRequire("idFre")), module.exports);

$5729966a08c45b01$var$__exportStar((parcelRequire("7ldQb")), module.exports);

});
parcelRegister("idFre", function(module, exports) {
"use strict";
// THIS FILE IS AUTOMATICALLY GENERATED BY make-ts-wrapper.ts
// DO NOT EDIT IT BY HAND
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Z3_goal_prec = module.exports.Z3_error_code = module.exports.Z3_ast_print_mode = module.exports.Z3_param_kind = module.exports.Z3_decl_kind = module.exports.Z3_ast_kind = module.exports.Z3_sort_kind = module.exports.Z3_parameter_kind = module.exports.Z3_symbol_kind = module.exports.Z3_lbool = void 0;
var $d43995a2c98fcc8e$var$Z3_lbool;
(function(Z3_lbool) {
    Z3_lbool[Z3_lbool["Z3_L_FALSE"] = -1] = "Z3_L_FALSE";
    Z3_lbool[Z3_lbool["Z3_L_UNDEF"] = 0] = "Z3_L_UNDEF";
    Z3_lbool[Z3_lbool["Z3_L_TRUE"] = 1] = "Z3_L_TRUE";
})($d43995a2c98fcc8e$var$Z3_lbool || (module.exports.Z3_lbool = $d43995a2c98fcc8e$var$Z3_lbool = {}));
var $d43995a2c98fcc8e$var$Z3_symbol_kind;
(function(Z3_symbol_kind) {
    Z3_symbol_kind[Z3_symbol_kind["Z3_INT_SYMBOL"] = 0] = "Z3_INT_SYMBOL";
    Z3_symbol_kind[Z3_symbol_kind["Z3_STRING_SYMBOL"] = 1] = "Z3_STRING_SYMBOL";
})($d43995a2c98fcc8e$var$Z3_symbol_kind || (module.exports.Z3_symbol_kind = $d43995a2c98fcc8e$var$Z3_symbol_kind = {}));
var $d43995a2c98fcc8e$var$Z3_parameter_kind;
(function(Z3_parameter_kind) {
    Z3_parameter_kind[Z3_parameter_kind["Z3_PARAMETER_INT"] = 0] = "Z3_PARAMETER_INT";
    Z3_parameter_kind[Z3_parameter_kind["Z3_PARAMETER_DOUBLE"] = 1] = "Z3_PARAMETER_DOUBLE";
    Z3_parameter_kind[Z3_parameter_kind["Z3_PARAMETER_RATIONAL"] = 2] = "Z3_PARAMETER_RATIONAL";
    Z3_parameter_kind[Z3_parameter_kind["Z3_PARAMETER_SYMBOL"] = 3] = "Z3_PARAMETER_SYMBOL";
    Z3_parameter_kind[Z3_parameter_kind["Z3_PARAMETER_SORT"] = 4] = "Z3_PARAMETER_SORT";
    Z3_parameter_kind[Z3_parameter_kind["Z3_PARAMETER_AST"] = 5] = "Z3_PARAMETER_AST";
    Z3_parameter_kind[Z3_parameter_kind["Z3_PARAMETER_FUNC_DECL"] = 6] = "Z3_PARAMETER_FUNC_DECL";
    Z3_parameter_kind[Z3_parameter_kind["Z3_PARAMETER_INTERNAL"] = 7] = "Z3_PARAMETER_INTERNAL";
    Z3_parameter_kind[Z3_parameter_kind["Z3_PARAMETER_ZSTRING"] = 8] = "Z3_PARAMETER_ZSTRING";
})($d43995a2c98fcc8e$var$Z3_parameter_kind || (module.exports.Z3_parameter_kind = $d43995a2c98fcc8e$var$Z3_parameter_kind = {}));
var $d43995a2c98fcc8e$var$Z3_sort_kind;
(function(Z3_sort_kind) {
    Z3_sort_kind[Z3_sort_kind["Z3_UNINTERPRETED_SORT"] = 0] = "Z3_UNINTERPRETED_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_BOOL_SORT"] = 1] = "Z3_BOOL_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_INT_SORT"] = 2] = "Z3_INT_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_REAL_SORT"] = 3] = "Z3_REAL_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_BV_SORT"] = 4] = "Z3_BV_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_ARRAY_SORT"] = 5] = "Z3_ARRAY_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_DATATYPE_SORT"] = 6] = "Z3_DATATYPE_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_RELATION_SORT"] = 7] = "Z3_RELATION_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_FINITE_DOMAIN_SORT"] = 8] = "Z3_FINITE_DOMAIN_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_FLOATING_POINT_SORT"] = 9] = "Z3_FLOATING_POINT_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_ROUNDING_MODE_SORT"] = 10] = "Z3_ROUNDING_MODE_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_SEQ_SORT"] = 11] = "Z3_SEQ_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_RE_SORT"] = 12] = "Z3_RE_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_CHAR_SORT"] = 13] = "Z3_CHAR_SORT";
    Z3_sort_kind[Z3_sort_kind["Z3_TYPE_VAR"] = 14] = "Z3_TYPE_VAR";
    Z3_sort_kind[Z3_sort_kind["Z3_UNKNOWN_SORT"] = 1000] = "Z3_UNKNOWN_SORT";
})($d43995a2c98fcc8e$var$Z3_sort_kind || (module.exports.Z3_sort_kind = $d43995a2c98fcc8e$var$Z3_sort_kind = {}));
var $d43995a2c98fcc8e$var$Z3_ast_kind;
(function(Z3_ast_kind) {
    Z3_ast_kind[Z3_ast_kind["Z3_NUMERAL_AST"] = 0] = "Z3_NUMERAL_AST";
    Z3_ast_kind[Z3_ast_kind["Z3_APP_AST"] = 1] = "Z3_APP_AST";
    Z3_ast_kind[Z3_ast_kind["Z3_VAR_AST"] = 2] = "Z3_VAR_AST";
    Z3_ast_kind[Z3_ast_kind["Z3_QUANTIFIER_AST"] = 3] = "Z3_QUANTIFIER_AST";
    Z3_ast_kind[Z3_ast_kind["Z3_SORT_AST"] = 4] = "Z3_SORT_AST";
    Z3_ast_kind[Z3_ast_kind["Z3_FUNC_DECL_AST"] = 5] = "Z3_FUNC_DECL_AST";
    Z3_ast_kind[Z3_ast_kind["Z3_UNKNOWN_AST"] = 1000] = "Z3_UNKNOWN_AST";
})($d43995a2c98fcc8e$var$Z3_ast_kind || (module.exports.Z3_ast_kind = $d43995a2c98fcc8e$var$Z3_ast_kind = {}));
var $d43995a2c98fcc8e$var$Z3_decl_kind;
(function(Z3_decl_kind) {
    Z3_decl_kind[Z3_decl_kind["Z3_OP_TRUE"] = 256] = "Z3_OP_TRUE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FALSE"] = 257] = "Z3_OP_FALSE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_EQ"] = 258] = "Z3_OP_EQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_DISTINCT"] = 259] = "Z3_OP_DISTINCT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ITE"] = 260] = "Z3_OP_ITE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_AND"] = 261] = "Z3_OP_AND";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_OR"] = 262] = "Z3_OP_OR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_IFF"] = 263] = "Z3_OP_IFF";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_XOR"] = 264] = "Z3_OP_XOR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_NOT"] = 265] = "Z3_OP_NOT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_IMPLIES"] = 266] = "Z3_OP_IMPLIES";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_OEQ"] = 267] = "Z3_OP_OEQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ANUM"] = 512] = "Z3_OP_ANUM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_AGNUM"] = 513] = "Z3_OP_AGNUM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_LE"] = 514] = "Z3_OP_LE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_GE"] = 515] = "Z3_OP_GE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_LT"] = 516] = "Z3_OP_LT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_GT"] = 517] = "Z3_OP_GT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ADD"] = 518] = "Z3_OP_ADD";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SUB"] = 519] = "Z3_OP_SUB";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_UMINUS"] = 520] = "Z3_OP_UMINUS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_MUL"] = 521] = "Z3_OP_MUL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_DIV"] = 522] = "Z3_OP_DIV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_IDIV"] = 523] = "Z3_OP_IDIV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_REM"] = 524] = "Z3_OP_REM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_MOD"] = 525] = "Z3_OP_MOD";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_TO_REAL"] = 526] = "Z3_OP_TO_REAL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_TO_INT"] = 527] = "Z3_OP_TO_INT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_IS_INT"] = 528] = "Z3_OP_IS_INT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_POWER"] = 529] = "Z3_OP_POWER";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ABS"] = 530] = "Z3_OP_ABS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_STORE"] = 768] = "Z3_OP_STORE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SELECT"] = 769] = "Z3_OP_SELECT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_CONST_ARRAY"] = 770] = "Z3_OP_CONST_ARRAY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ARRAY_MAP"] = 771] = "Z3_OP_ARRAY_MAP";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ARRAY_DEFAULT"] = 772] = "Z3_OP_ARRAY_DEFAULT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SET_UNION"] = 773] = "Z3_OP_SET_UNION";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SET_INTERSECT"] = 774] = "Z3_OP_SET_INTERSECT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SET_DIFFERENCE"] = 775] = "Z3_OP_SET_DIFFERENCE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SET_COMPLEMENT"] = 776] = "Z3_OP_SET_COMPLEMENT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SET_SUBSET"] = 777] = "Z3_OP_SET_SUBSET";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_AS_ARRAY"] = 778] = "Z3_OP_AS_ARRAY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ARRAY_EXT"] = 779] = "Z3_OP_ARRAY_EXT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BNUM"] = 1024] = "Z3_OP_BNUM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BIT1"] = 1025] = "Z3_OP_BIT1";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BIT0"] = 1026] = "Z3_OP_BIT0";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BNEG"] = 1027] = "Z3_OP_BNEG";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BADD"] = 1028] = "Z3_OP_BADD";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSUB"] = 1029] = "Z3_OP_BSUB";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BMUL"] = 1030] = "Z3_OP_BMUL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSDIV"] = 1031] = "Z3_OP_BSDIV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BUDIV"] = 1032] = "Z3_OP_BUDIV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSREM"] = 1033] = "Z3_OP_BSREM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BUREM"] = 1034] = "Z3_OP_BUREM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSMOD"] = 1035] = "Z3_OP_BSMOD";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSDIV0"] = 1036] = "Z3_OP_BSDIV0";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BUDIV0"] = 1037] = "Z3_OP_BUDIV0";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSREM0"] = 1038] = "Z3_OP_BSREM0";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BUREM0"] = 1039] = "Z3_OP_BUREM0";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSMOD0"] = 1040] = "Z3_OP_BSMOD0";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ULEQ"] = 1041] = "Z3_OP_ULEQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SLEQ"] = 1042] = "Z3_OP_SLEQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_UGEQ"] = 1043] = "Z3_OP_UGEQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SGEQ"] = 1044] = "Z3_OP_SGEQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ULT"] = 1045] = "Z3_OP_ULT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SLT"] = 1046] = "Z3_OP_SLT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_UGT"] = 1047] = "Z3_OP_UGT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SGT"] = 1048] = "Z3_OP_SGT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BAND"] = 1049] = "Z3_OP_BAND";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BOR"] = 1050] = "Z3_OP_BOR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BNOT"] = 1051] = "Z3_OP_BNOT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BXOR"] = 1052] = "Z3_OP_BXOR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BNAND"] = 1053] = "Z3_OP_BNAND";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BNOR"] = 1054] = "Z3_OP_BNOR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BXNOR"] = 1055] = "Z3_OP_BXNOR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_CONCAT"] = 1056] = "Z3_OP_CONCAT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SIGN_EXT"] = 1057] = "Z3_OP_SIGN_EXT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ZERO_EXT"] = 1058] = "Z3_OP_ZERO_EXT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_EXTRACT"] = 1059] = "Z3_OP_EXTRACT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_REPEAT"] = 1060] = "Z3_OP_REPEAT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BREDOR"] = 1061] = "Z3_OP_BREDOR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BREDAND"] = 1062] = "Z3_OP_BREDAND";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BCOMP"] = 1063] = "Z3_OP_BCOMP";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSHL"] = 1064] = "Z3_OP_BSHL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BLSHR"] = 1065] = "Z3_OP_BLSHR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BASHR"] = 1066] = "Z3_OP_BASHR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ROTATE_LEFT"] = 1067] = "Z3_OP_ROTATE_LEFT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_ROTATE_RIGHT"] = 1068] = "Z3_OP_ROTATE_RIGHT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_EXT_ROTATE_LEFT"] = 1069] = "Z3_OP_EXT_ROTATE_LEFT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_EXT_ROTATE_RIGHT"] = 1070] = "Z3_OP_EXT_ROTATE_RIGHT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BIT2BOOL"] = 1071] = "Z3_OP_BIT2BOOL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_INT2BV"] = 1072] = "Z3_OP_INT2BV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BV2INT"] = 1073] = "Z3_OP_BV2INT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SBV2INT"] = 1074] = "Z3_OP_SBV2INT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_CARRY"] = 1075] = "Z3_OP_CARRY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_XOR3"] = 1076] = "Z3_OP_XOR3";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSMUL_NO_OVFL"] = 1077] = "Z3_OP_BSMUL_NO_OVFL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BUMUL_NO_OVFL"] = 1078] = "Z3_OP_BUMUL_NO_OVFL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSMUL_NO_UDFL"] = 1079] = "Z3_OP_BSMUL_NO_UDFL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSDIV_I"] = 1080] = "Z3_OP_BSDIV_I";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BUDIV_I"] = 1081] = "Z3_OP_BUDIV_I";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSREM_I"] = 1082] = "Z3_OP_BSREM_I";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BUREM_I"] = 1083] = "Z3_OP_BUREM_I";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_BSMOD_I"] = 1084] = "Z3_OP_BSMOD_I";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_UNDEF"] = 1280] = "Z3_OP_PR_UNDEF";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_TRUE"] = 1281] = "Z3_OP_PR_TRUE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_ASSERTED"] = 1282] = "Z3_OP_PR_ASSERTED";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_GOAL"] = 1283] = "Z3_OP_PR_GOAL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_MODUS_PONENS"] = 1284] = "Z3_OP_PR_MODUS_PONENS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_REFLEXIVITY"] = 1285] = "Z3_OP_PR_REFLEXIVITY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_SYMMETRY"] = 1286] = "Z3_OP_PR_SYMMETRY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_TRANSITIVITY"] = 1287] = "Z3_OP_PR_TRANSITIVITY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_TRANSITIVITY_STAR"] = 1288] = "Z3_OP_PR_TRANSITIVITY_STAR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_MONOTONICITY"] = 1289] = "Z3_OP_PR_MONOTONICITY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_QUANT_INTRO"] = 1290] = "Z3_OP_PR_QUANT_INTRO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_BIND"] = 1291] = "Z3_OP_PR_BIND";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_DISTRIBUTIVITY"] = 1292] = "Z3_OP_PR_DISTRIBUTIVITY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_AND_ELIM"] = 1293] = "Z3_OP_PR_AND_ELIM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_NOT_OR_ELIM"] = 1294] = "Z3_OP_PR_NOT_OR_ELIM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_REWRITE"] = 1295] = "Z3_OP_PR_REWRITE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_REWRITE_STAR"] = 1296] = "Z3_OP_PR_REWRITE_STAR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_PULL_QUANT"] = 1297] = "Z3_OP_PR_PULL_QUANT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_PUSH_QUANT"] = 1298] = "Z3_OP_PR_PUSH_QUANT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_ELIM_UNUSED_VARS"] = 1299] = "Z3_OP_PR_ELIM_UNUSED_VARS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_DER"] = 1300] = "Z3_OP_PR_DER";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_QUANT_INST"] = 1301] = "Z3_OP_PR_QUANT_INST";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_HYPOTHESIS"] = 1302] = "Z3_OP_PR_HYPOTHESIS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_LEMMA"] = 1303] = "Z3_OP_PR_LEMMA";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_UNIT_RESOLUTION"] = 1304] = "Z3_OP_PR_UNIT_RESOLUTION";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_IFF_TRUE"] = 1305] = "Z3_OP_PR_IFF_TRUE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_IFF_FALSE"] = 1306] = "Z3_OP_PR_IFF_FALSE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_COMMUTATIVITY"] = 1307] = "Z3_OP_PR_COMMUTATIVITY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_DEF_AXIOM"] = 1308] = "Z3_OP_PR_DEF_AXIOM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_ASSUMPTION_ADD"] = 1309] = "Z3_OP_PR_ASSUMPTION_ADD";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_LEMMA_ADD"] = 1310] = "Z3_OP_PR_LEMMA_ADD";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_REDUNDANT_DEL"] = 1311] = "Z3_OP_PR_REDUNDANT_DEL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_CLAUSE_TRAIL"] = 1312] = "Z3_OP_PR_CLAUSE_TRAIL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_DEF_INTRO"] = 1313] = "Z3_OP_PR_DEF_INTRO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_APPLY_DEF"] = 1314] = "Z3_OP_PR_APPLY_DEF";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_IFF_OEQ"] = 1315] = "Z3_OP_PR_IFF_OEQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_NNF_POS"] = 1316] = "Z3_OP_PR_NNF_POS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_NNF_NEG"] = 1317] = "Z3_OP_PR_NNF_NEG";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_SKOLEMIZE"] = 1318] = "Z3_OP_PR_SKOLEMIZE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_MODUS_PONENS_OEQ"] = 1319] = "Z3_OP_PR_MODUS_PONENS_OEQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_TH_LEMMA"] = 1320] = "Z3_OP_PR_TH_LEMMA";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PR_HYPER_RESOLVE"] = 1321] = "Z3_OP_PR_HYPER_RESOLVE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_STORE"] = 1536] = "Z3_OP_RA_STORE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_EMPTY"] = 1537] = "Z3_OP_RA_EMPTY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_IS_EMPTY"] = 1538] = "Z3_OP_RA_IS_EMPTY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_JOIN"] = 1539] = "Z3_OP_RA_JOIN";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_UNION"] = 1540] = "Z3_OP_RA_UNION";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_WIDEN"] = 1541] = "Z3_OP_RA_WIDEN";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_PROJECT"] = 1542] = "Z3_OP_RA_PROJECT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_FILTER"] = 1543] = "Z3_OP_RA_FILTER";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_NEGATION_FILTER"] = 1544] = "Z3_OP_RA_NEGATION_FILTER";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_RENAME"] = 1545] = "Z3_OP_RA_RENAME";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_COMPLEMENT"] = 1546] = "Z3_OP_RA_COMPLEMENT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_SELECT"] = 1547] = "Z3_OP_RA_SELECT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RA_CLONE"] = 1548] = "Z3_OP_RA_CLONE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FD_CONSTANT"] = 1549] = "Z3_OP_FD_CONSTANT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FD_LT"] = 1550] = "Z3_OP_FD_LT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_UNIT"] = 1551] = "Z3_OP_SEQ_UNIT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_EMPTY"] = 1552] = "Z3_OP_SEQ_EMPTY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_CONCAT"] = 1553] = "Z3_OP_SEQ_CONCAT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_PREFIX"] = 1554] = "Z3_OP_SEQ_PREFIX";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_SUFFIX"] = 1555] = "Z3_OP_SEQ_SUFFIX";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_CONTAINS"] = 1556] = "Z3_OP_SEQ_CONTAINS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_EXTRACT"] = 1557] = "Z3_OP_SEQ_EXTRACT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_REPLACE"] = 1558] = "Z3_OP_SEQ_REPLACE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_REPLACE_RE"] = 1559] = "Z3_OP_SEQ_REPLACE_RE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_REPLACE_RE_ALL"] = 1560] = "Z3_OP_SEQ_REPLACE_RE_ALL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_REPLACE_ALL"] = 1561] = "Z3_OP_SEQ_REPLACE_ALL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_AT"] = 1562] = "Z3_OP_SEQ_AT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_NTH"] = 1563] = "Z3_OP_SEQ_NTH";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_LENGTH"] = 1564] = "Z3_OP_SEQ_LENGTH";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_INDEX"] = 1565] = "Z3_OP_SEQ_INDEX";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_LAST_INDEX"] = 1566] = "Z3_OP_SEQ_LAST_INDEX";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_TO_RE"] = 1567] = "Z3_OP_SEQ_TO_RE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_IN_RE"] = 1568] = "Z3_OP_SEQ_IN_RE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_MAP"] = 1569] = "Z3_OP_SEQ_MAP";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_MAPI"] = 1570] = "Z3_OP_SEQ_MAPI";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_FOLDL"] = 1571] = "Z3_OP_SEQ_FOLDL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SEQ_FOLDLI"] = 1572] = "Z3_OP_SEQ_FOLDLI";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_STR_TO_INT"] = 1573] = "Z3_OP_STR_TO_INT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_INT_TO_STR"] = 1574] = "Z3_OP_INT_TO_STR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_UBV_TO_STR"] = 1575] = "Z3_OP_UBV_TO_STR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SBV_TO_STR"] = 1576] = "Z3_OP_SBV_TO_STR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_STR_TO_CODE"] = 1577] = "Z3_OP_STR_TO_CODE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_STR_FROM_CODE"] = 1578] = "Z3_OP_STR_FROM_CODE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_STRING_LT"] = 1579] = "Z3_OP_STRING_LT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_STRING_LE"] = 1580] = "Z3_OP_STRING_LE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_PLUS"] = 1581] = "Z3_OP_RE_PLUS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_STAR"] = 1582] = "Z3_OP_RE_STAR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_OPTION"] = 1583] = "Z3_OP_RE_OPTION";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_CONCAT"] = 1584] = "Z3_OP_RE_CONCAT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_UNION"] = 1585] = "Z3_OP_RE_UNION";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_RANGE"] = 1586] = "Z3_OP_RE_RANGE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_DIFF"] = 1587] = "Z3_OP_RE_DIFF";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_INTERSECT"] = 1588] = "Z3_OP_RE_INTERSECT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_LOOP"] = 1589] = "Z3_OP_RE_LOOP";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_POWER"] = 1590] = "Z3_OP_RE_POWER";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_COMPLEMENT"] = 1591] = "Z3_OP_RE_COMPLEMENT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_EMPTY_SET"] = 1592] = "Z3_OP_RE_EMPTY_SET";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_FULL_SET"] = 1593] = "Z3_OP_RE_FULL_SET";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_FULL_CHAR_SET"] = 1594] = "Z3_OP_RE_FULL_CHAR_SET";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_OF_PRED"] = 1595] = "Z3_OP_RE_OF_PRED";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_REVERSE"] = 1596] = "Z3_OP_RE_REVERSE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RE_DERIVATIVE"] = 1597] = "Z3_OP_RE_DERIVATIVE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_CHAR_CONST"] = 1598] = "Z3_OP_CHAR_CONST";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_CHAR_LE"] = 1599] = "Z3_OP_CHAR_LE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_CHAR_TO_INT"] = 1600] = "Z3_OP_CHAR_TO_INT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_CHAR_TO_BV"] = 1601] = "Z3_OP_CHAR_TO_BV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_CHAR_FROM_BV"] = 1602] = "Z3_OP_CHAR_FROM_BV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_CHAR_IS_DIGIT"] = 1603] = "Z3_OP_CHAR_IS_DIGIT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_LABEL"] = 1792] = "Z3_OP_LABEL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_LABEL_LIT"] = 1793] = "Z3_OP_LABEL_LIT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_DT_CONSTRUCTOR"] = 2048] = "Z3_OP_DT_CONSTRUCTOR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_DT_RECOGNISER"] = 2049] = "Z3_OP_DT_RECOGNISER";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_DT_IS"] = 2050] = "Z3_OP_DT_IS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_DT_ACCESSOR"] = 2051] = "Z3_OP_DT_ACCESSOR";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_DT_UPDATE_FIELD"] = 2052] = "Z3_OP_DT_UPDATE_FIELD";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PB_AT_MOST"] = 2304] = "Z3_OP_PB_AT_MOST";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PB_AT_LEAST"] = 2305] = "Z3_OP_PB_AT_LEAST";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PB_LE"] = 2306] = "Z3_OP_PB_LE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PB_GE"] = 2307] = "Z3_OP_PB_GE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_PB_EQ"] = 2308] = "Z3_OP_PB_EQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SPECIAL_RELATION_LO"] = 40960] = "Z3_OP_SPECIAL_RELATION_LO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SPECIAL_RELATION_PO"] = 40961] = "Z3_OP_SPECIAL_RELATION_PO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SPECIAL_RELATION_PLO"] = 40962] = "Z3_OP_SPECIAL_RELATION_PLO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SPECIAL_RELATION_TO"] = 40963] = "Z3_OP_SPECIAL_RELATION_TO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SPECIAL_RELATION_TC"] = 40964] = "Z3_OP_SPECIAL_RELATION_TC";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_SPECIAL_RELATION_TRC"] = 40965] = "Z3_OP_SPECIAL_RELATION_TRC";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_RM_NEAREST_TIES_TO_EVEN"] = 45056] = "Z3_OP_FPA_RM_NEAREST_TIES_TO_EVEN";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_RM_NEAREST_TIES_TO_AWAY"] = 45057] = "Z3_OP_FPA_RM_NEAREST_TIES_TO_AWAY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_RM_TOWARD_POSITIVE"] = 45058] = "Z3_OP_FPA_RM_TOWARD_POSITIVE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_RM_TOWARD_NEGATIVE"] = 45059] = "Z3_OP_FPA_RM_TOWARD_NEGATIVE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_RM_TOWARD_ZERO"] = 45060] = "Z3_OP_FPA_RM_TOWARD_ZERO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_NUM"] = 45061] = "Z3_OP_FPA_NUM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_PLUS_INF"] = 45062] = "Z3_OP_FPA_PLUS_INF";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_MINUS_INF"] = 45063] = "Z3_OP_FPA_MINUS_INF";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_NAN"] = 45064] = "Z3_OP_FPA_NAN";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_PLUS_ZERO"] = 45065] = "Z3_OP_FPA_PLUS_ZERO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_MINUS_ZERO"] = 45066] = "Z3_OP_FPA_MINUS_ZERO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_ADD"] = 45067] = "Z3_OP_FPA_ADD";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_SUB"] = 45068] = "Z3_OP_FPA_SUB";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_NEG"] = 45069] = "Z3_OP_FPA_NEG";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_MUL"] = 45070] = "Z3_OP_FPA_MUL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_DIV"] = 45071] = "Z3_OP_FPA_DIV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_REM"] = 45072] = "Z3_OP_FPA_REM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_ABS"] = 45073] = "Z3_OP_FPA_ABS";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_MIN"] = 45074] = "Z3_OP_FPA_MIN";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_MAX"] = 45075] = "Z3_OP_FPA_MAX";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_FMA"] = 45076] = "Z3_OP_FPA_FMA";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_SQRT"] = 45077] = "Z3_OP_FPA_SQRT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_ROUND_TO_INTEGRAL"] = 45078] = "Z3_OP_FPA_ROUND_TO_INTEGRAL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_EQ"] = 45079] = "Z3_OP_FPA_EQ";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_LT"] = 45080] = "Z3_OP_FPA_LT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_GT"] = 45081] = "Z3_OP_FPA_GT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_LE"] = 45082] = "Z3_OP_FPA_LE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_GE"] = 45083] = "Z3_OP_FPA_GE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_IS_NAN"] = 45084] = "Z3_OP_FPA_IS_NAN";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_IS_INF"] = 45085] = "Z3_OP_FPA_IS_INF";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_IS_ZERO"] = 45086] = "Z3_OP_FPA_IS_ZERO";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_IS_NORMAL"] = 45087] = "Z3_OP_FPA_IS_NORMAL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_IS_SUBNORMAL"] = 45088] = "Z3_OP_FPA_IS_SUBNORMAL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_IS_NEGATIVE"] = 45089] = "Z3_OP_FPA_IS_NEGATIVE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_IS_POSITIVE"] = 45090] = "Z3_OP_FPA_IS_POSITIVE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_FP"] = 45091] = "Z3_OP_FPA_FP";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_TO_FP"] = 45092] = "Z3_OP_FPA_TO_FP";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_TO_FP_UNSIGNED"] = 45093] = "Z3_OP_FPA_TO_FP_UNSIGNED";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_TO_UBV"] = 45094] = "Z3_OP_FPA_TO_UBV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_TO_SBV"] = 45095] = "Z3_OP_FPA_TO_SBV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_TO_REAL"] = 45096] = "Z3_OP_FPA_TO_REAL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_TO_IEEE_BV"] = 45097] = "Z3_OP_FPA_TO_IEEE_BV";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_BVWRAP"] = 45098] = "Z3_OP_FPA_BVWRAP";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FPA_BV2RM"] = 45099] = "Z3_OP_FPA_BV2RM";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_EMPTY"] = 49152] = "Z3_OP_FINITE_SET_EMPTY";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_SINGLETON"] = 49153] = "Z3_OP_FINITE_SET_SINGLETON";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_UNION"] = 49154] = "Z3_OP_FINITE_SET_UNION";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_INTERSECT"] = 49155] = "Z3_OP_FINITE_SET_INTERSECT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_DIFFERENCE"] = 49156] = "Z3_OP_FINITE_SET_DIFFERENCE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_IN"] = 49157] = "Z3_OP_FINITE_SET_IN";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_SIZE"] = 49158] = "Z3_OP_FINITE_SET_SIZE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_SUBSET"] = 49159] = "Z3_OP_FINITE_SET_SUBSET";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_MAP"] = 49160] = "Z3_OP_FINITE_SET_MAP";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_FILTER"] = 49161] = "Z3_OP_FINITE_SET_FILTER";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_RANGE"] = 49162] = "Z3_OP_FINITE_SET_RANGE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_EXT"] = 49163] = "Z3_OP_FINITE_SET_EXT";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_FINITE_SET_MAP_INVERSE"] = 49164] = "Z3_OP_FINITE_SET_MAP_INVERSE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_INTERNAL"] = 49165] = "Z3_OP_INTERNAL";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_RECURSIVE"] = 49166] = "Z3_OP_RECURSIVE";
    Z3_decl_kind[Z3_decl_kind["Z3_OP_UNINTERPRETED"] = 49167] = "Z3_OP_UNINTERPRETED";
})($d43995a2c98fcc8e$var$Z3_decl_kind || (module.exports.Z3_decl_kind = $d43995a2c98fcc8e$var$Z3_decl_kind = {}));
var $d43995a2c98fcc8e$var$Z3_param_kind;
(function(Z3_param_kind) {
    Z3_param_kind[Z3_param_kind["Z3_PK_UINT"] = 0] = "Z3_PK_UINT";
    Z3_param_kind[Z3_param_kind["Z3_PK_BOOL"] = 1] = "Z3_PK_BOOL";
    Z3_param_kind[Z3_param_kind["Z3_PK_DOUBLE"] = 2] = "Z3_PK_DOUBLE";
    Z3_param_kind[Z3_param_kind["Z3_PK_SYMBOL"] = 3] = "Z3_PK_SYMBOL";
    Z3_param_kind[Z3_param_kind["Z3_PK_STRING"] = 4] = "Z3_PK_STRING";
    Z3_param_kind[Z3_param_kind["Z3_PK_OTHER"] = 5] = "Z3_PK_OTHER";
    Z3_param_kind[Z3_param_kind["Z3_PK_INVALID"] = 6] = "Z3_PK_INVALID";
})($d43995a2c98fcc8e$var$Z3_param_kind || (module.exports.Z3_param_kind = $d43995a2c98fcc8e$var$Z3_param_kind = {}));
var $d43995a2c98fcc8e$var$Z3_ast_print_mode;
(function(Z3_ast_print_mode) {
    Z3_ast_print_mode[Z3_ast_print_mode["Z3_PRINT_SMTLIB_FULL"] = 0] = "Z3_PRINT_SMTLIB_FULL";
    Z3_ast_print_mode[Z3_ast_print_mode["Z3_PRINT_LOW_LEVEL"] = 1] = "Z3_PRINT_LOW_LEVEL";
    Z3_ast_print_mode[Z3_ast_print_mode["Z3_PRINT_SMTLIB2_COMPLIANT"] = 2] = "Z3_PRINT_SMTLIB2_COMPLIANT";
})($d43995a2c98fcc8e$var$Z3_ast_print_mode || (module.exports.Z3_ast_print_mode = $d43995a2c98fcc8e$var$Z3_ast_print_mode = {}));
var $d43995a2c98fcc8e$var$Z3_error_code;
(function(Z3_error_code) {
    Z3_error_code[Z3_error_code["Z3_OK"] = 0] = "Z3_OK";
    Z3_error_code[Z3_error_code["Z3_SORT_ERROR"] = 1] = "Z3_SORT_ERROR";
    Z3_error_code[Z3_error_code["Z3_IOB"] = 2] = "Z3_IOB";
    Z3_error_code[Z3_error_code["Z3_INVALID_ARG"] = 3] = "Z3_INVALID_ARG";
    Z3_error_code[Z3_error_code["Z3_PARSER_ERROR"] = 4] = "Z3_PARSER_ERROR";
    Z3_error_code[Z3_error_code["Z3_NO_PARSER"] = 5] = "Z3_NO_PARSER";
    Z3_error_code[Z3_error_code["Z3_INVALID_PATTERN"] = 6] = "Z3_INVALID_PATTERN";
    Z3_error_code[Z3_error_code["Z3_MEMOUT_FAIL"] = 7] = "Z3_MEMOUT_FAIL";
    Z3_error_code[Z3_error_code["Z3_FILE_ACCESS_ERROR"] = 8] = "Z3_FILE_ACCESS_ERROR";
    Z3_error_code[Z3_error_code["Z3_INTERNAL_FATAL"] = 9] = "Z3_INTERNAL_FATAL";
    Z3_error_code[Z3_error_code["Z3_INVALID_USAGE"] = 10] = "Z3_INVALID_USAGE";
    Z3_error_code[Z3_error_code["Z3_DEC_REF_ERROR"] = 11] = "Z3_DEC_REF_ERROR";
    Z3_error_code[Z3_error_code["Z3_EXCEPTION"] = 12] = "Z3_EXCEPTION";
})($d43995a2c98fcc8e$var$Z3_error_code || (module.exports.Z3_error_code = $d43995a2c98fcc8e$var$Z3_error_code = {}));
var $d43995a2c98fcc8e$var$Z3_goal_prec;
(function(Z3_goal_prec) {
    Z3_goal_prec[Z3_goal_prec["Z3_GOAL_PRECISE"] = 0] = "Z3_GOAL_PRECISE";
    Z3_goal_prec[Z3_goal_prec["Z3_GOAL_UNDER"] = 1] = "Z3_GOAL_UNDER";
    Z3_goal_prec[Z3_goal_prec["Z3_GOAL_OVER"] = 2] = "Z3_GOAL_OVER";
    Z3_goal_prec[Z3_goal_prec["Z3_GOAL_UNDER_OVER"] = 3] = "Z3_GOAL_UNDER_OVER";
})($d43995a2c98fcc8e$var$Z3_goal_prec || (module.exports.Z3_goal_prec = $d43995a2c98fcc8e$var$Z3_goal_prec = {}));

});

parcelRegister("7ldQb", function(module, exports) {
"use strict";
// THIS FILE IS AUTOMATICALLY GENERATED BY make-ts-wrapper.ts
// DO NOT EDIT IT BY HAND
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = $55853b08c233b1a7$var$init;
async function $55853b08c233b1a7$var$init(initModule, moduleOverrides = {}) {
    let Mod = await initModule(moduleOverrides);
    // this works for both signed and unsigned, because JS will wrap for you when constructing the Uint32Array
    function intArrayToByteArr(ints) {
        return new Uint8Array(new Uint32Array(ints).buffer);
    }
    function boolArrayToByteArr(bools) {
        return bools.map((b)=>b ? 1 : 0);
    }
    function readUintArray(address, count) {
        return Array.from(new Uint32Array(Mod.HEAPU32.buffer, address, count));
    }
    let outAddress = Mod._malloc(24);
    let outUintArray = new Uint32Array(Mod.HEAPU32.buffer, outAddress, 6);
    let getOutUint = (i)=>outUintArray[i];
    let outIntArray = new Int32Array(Mod.HEAPU32.buffer, outAddress, 6);
    let getOutInt = (i)=>outIntArray[i];
    let outUint64Array = new BigUint64Array(Mod.HEAPU32.buffer, outAddress, 3);
    let getOutUint64 = (i)=>outUint64Array[i];
    let outInt64Array = new BigInt64Array(Mod.HEAPU32.buffer, outAddress, 3);
    let getOutInt64 = (i)=>outInt64Array[i];
    return {
        em: Mod,
        Z3: {
            mk_context: function(c) {
                let ctx = Mod._Z3_mk_context(c);
                Mod._set_noop_error_handler(ctx);
                return ctx;
            },
            mk_context_rc: function(c) {
                let ctx = Mod._Z3_mk_context_rc(c);
                Mod._set_noop_error_handler(ctx);
                return ctx;
            },
            global_param_set: function(param_id, param_value) {
                return Mod.ccall('Z3_global_param_set', 'void', [
                    'string',
                    'string'
                ], [
                    param_id,
                    param_value
                ]);
            },
            global_param_reset_all: Mod._Z3_global_param_reset_all,
            global_param_get: function(param_id) {
                let ret = Mod.ccall('Z3_global_param_get', 'boolean', [
                    'string',
                    'number'
                ], [
                    param_id,
                    outAddress
                ]);
                if (!ret) return null;
                return Mod.UTF8ToString(getOutUint(0));
            },
            mk_config: Mod._Z3_mk_config,
            del_config: Mod._Z3_del_config,
            set_param_value: function(c, param_id, param_value) {
                return Mod.ccall('Z3_set_param_value', 'void', [
                    'number',
                    'string',
                    'string'
                ], [
                    c,
                    param_id,
                    param_value
                ]);
            },
            del_context: Mod._Z3_del_context,
            inc_ref: Mod._Z3_inc_ref,
            dec_ref: Mod._Z3_dec_ref,
            update_param_value: function(c, param_id, param_value) {
                return Mod.ccall('Z3_update_param_value', 'void', [
                    'number',
                    'string',
                    'string'
                ], [
                    c,
                    param_id,
                    param_value
                ]);
            },
            get_global_param_descrs: Mod._Z3_get_global_param_descrs,
            interrupt: Mod._Z3_interrupt,
            enable_concurrent_dec_ref: Mod._Z3_enable_concurrent_dec_ref,
            mk_params: Mod._Z3_mk_params,
            params_inc_ref: Mod._Z3_params_inc_ref,
            params_dec_ref: Mod._Z3_params_dec_ref,
            params_set_bool: Mod._Z3_params_set_bool,
            params_set_uint: Mod._Z3_params_set_uint,
            params_set_double: Mod._Z3_params_set_double,
            params_set_symbol: Mod._Z3_params_set_symbol,
            params_to_string: function(c, p) {
                return Mod.ccall('Z3_params_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    p
                ]);
            },
            params_validate: Mod._Z3_params_validate,
            param_descrs_inc_ref: Mod._Z3_param_descrs_inc_ref,
            param_descrs_dec_ref: Mod._Z3_param_descrs_dec_ref,
            param_descrs_get_kind: Mod._Z3_param_descrs_get_kind,
            param_descrs_size: function(c, p) {
                let ret = Mod.ccall('Z3_param_descrs_size', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    p
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            param_descrs_get_name: Mod._Z3_param_descrs_get_name,
            param_descrs_get_documentation: function(c, p, s) {
                return Mod.ccall('Z3_param_descrs_get_documentation', 'string', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    p,
                    s
                ]);
            },
            param_descrs_to_string: function(c, p) {
                return Mod.ccall('Z3_param_descrs_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    p
                ]);
            },
            mk_int_symbol: Mod._Z3_mk_int_symbol,
            mk_string_symbol: function(c, s) {
                return Mod.ccall('Z3_mk_string_symbol', 'number', [
                    'number',
                    'string'
                ], [
                    c,
                    s
                ]);
            },
            mk_uninterpreted_sort: Mod._Z3_mk_uninterpreted_sort,
            mk_type_variable: Mod._Z3_mk_type_variable,
            mk_bool_sort: Mod._Z3_mk_bool_sort,
            mk_int_sort: Mod._Z3_mk_int_sort,
            mk_real_sort: Mod._Z3_mk_real_sort,
            mk_bv_sort: Mod._Z3_mk_bv_sort,
            mk_finite_domain_sort: Mod._Z3_mk_finite_domain_sort,
            mk_array_sort: Mod._Z3_mk_array_sort,
            mk_array_sort_n: function(c, domain, range) {
                return Mod.ccall('Z3_mk_array_sort_n', 'number', [
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    domain.length,
                    intArrayToByteArr(domain),
                    range
                ]);
            },
            mk_tuple_sort: function(c, mk_tuple_name, field_names, field_sorts) {
                if (field_names.length !== field_sorts.length) throw new TypeError(`field_names and field_sorts must be the same length (got ${field_names.length} and {field_sorts.length})`);
                let outArray_proj_decl = Mod._malloc(4 * field_names.length);
                try {
                    let ret = Mod.ccall('Z3_mk_tuple_sort', 'number', [
                        'number',
                        'number',
                        'number',
                        'array',
                        'array',
                        'number',
                        'number'
                    ], [
                        c,
                        mk_tuple_name,
                        field_names.length,
                        intArrayToByteArr(field_names),
                        intArrayToByteArr(field_sorts),
                        outAddress,
                        outArray_proj_decl
                    ]);
                    return {
                        rv: ret,
                        mk_tuple_decl: getOutUint(0),
                        proj_decl: readUintArray(outArray_proj_decl, field_names.length)
                    };
                } finally{
                    Mod._free(outArray_proj_decl);
                }
            },
            mk_enumeration_sort: function(c, name, enum_names) {
                let outArray_enum_consts = Mod._malloc(4 * enum_names.length);
                try {
                    let outArray_enum_testers = Mod._malloc(4 * enum_names.length);
                    try {
                        let ret = Mod.ccall('Z3_mk_enumeration_sort', 'number', [
                            'number',
                            'number',
                            'number',
                            'array',
                            'number',
                            'number'
                        ], [
                            c,
                            name,
                            enum_names.length,
                            intArrayToByteArr(enum_names),
                            outArray_enum_consts,
                            outArray_enum_testers
                        ]);
                        return {
                            rv: ret,
                            enum_consts: readUintArray(outArray_enum_consts, enum_names.length),
                            enum_testers: readUintArray(outArray_enum_testers, enum_names.length)
                        };
                    } finally{
                        Mod._free(outArray_enum_testers);
                    }
                } finally{
                    Mod._free(outArray_enum_consts);
                }
            },
            mk_list_sort: function(c, name, elem_sort) {
                let ret = Mod.ccall('Z3_mk_list_sort', 'number', [
                    'number',
                    'number',
                    'number',
                    'number',
                    'number',
                    'number',
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    name,
                    elem_sort,
                    outAddress,
                    outAddress + 4,
                    outAddress + 8,
                    outAddress + 12,
                    outAddress + 16,
                    outAddress + 20
                ]);
                return {
                    rv: ret,
                    nil_decl: getOutUint(0),
                    is_nil_decl: getOutUint(1),
                    cons_decl: getOutUint(2),
                    is_cons_decl: getOutUint(3),
                    head_decl: getOutUint(4),
                    tail_decl: getOutUint(5)
                };
            },
            mk_constructor: function(c, name, recognizer, field_names, sorts, sort_refs) {
                if (field_names.length !== sorts.length) throw new TypeError(`field_names and sorts must be the same length (got ${field_names.length} and {sorts.length})`);
                if (field_names.length !== sort_refs.length) throw new TypeError(`field_names and sort_refs must be the same length (got ${field_names.length} and {sort_refs.length})`);
                return Mod.ccall('Z3_mk_constructor', 'number', [
                    'number',
                    'number',
                    'number',
                    'number',
                    'array',
                    'array',
                    'array'
                ], [
                    c,
                    name,
                    recognizer,
                    field_names.length,
                    intArrayToByteArr(field_names),
                    intArrayToByteArr(sorts),
                    intArrayToByteArr(sort_refs)
                ]);
            },
            constructor_num_fields: function(c, constr) {
                let ret = Mod.ccall('Z3_constructor_num_fields', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    constr
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            del_constructor: Mod._Z3_del_constructor,
            mk_datatype: function(c, name, constructors) {
                return Mod.ccall('Z3_mk_datatype', 'number', [
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    name,
                    constructors.length,
                    intArrayToByteArr(constructors)
                ]);
            },
            mk_polymorphic_datatype: function(c, name, parameters, constructors) {
                return Mod.ccall('Z3_mk_polymorphic_datatype', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array'
                ], [
                    c,
                    name,
                    parameters.length,
                    intArrayToByteArr(parameters),
                    constructors.length,
                    intArrayToByteArr(constructors)
                ]);
            },
            mk_datatype_sort: function(c, name, params) {
                return Mod.ccall('Z3_mk_datatype_sort', 'number', [
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    name,
                    params.length,
                    intArrayToByteArr(params)
                ]);
            },
            mk_constructor_list: function(c, constructors) {
                return Mod.ccall('Z3_mk_constructor_list', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    constructors.length,
                    intArrayToByteArr(constructors)
                ]);
            },
            del_constructor_list: Mod._Z3_del_constructor_list,
            mk_datatypes: function(c, sort_names, constructor_lists) {
                if (sort_names.length !== constructor_lists.length) throw new TypeError(`sort_names and constructor_lists must be the same length (got ${sort_names.length} and {constructor_lists.length})`);
                let outArray_sorts = Mod._malloc(4 * sort_names.length);
                try {
                    let ret = Mod.ccall('Z3_mk_datatypes', 'void', [
                        'number',
                        'number',
                        'array',
                        'number',
                        'array'
                    ], [
                        c,
                        sort_names.length,
                        intArrayToByteArr(sort_names),
                        outArray_sorts,
                        intArrayToByteArr(constructor_lists)
                    ]);
                    return readUintArray(outArray_sorts, sort_names.length);
                } finally{
                    Mod._free(outArray_sorts);
                }
            },
            query_constructor: function(c, constr, num_fields) {
                let outArray_accessors = Mod._malloc(4 * num_fields);
                try {
                    let ret = Mod.ccall('Z3_query_constructor', 'void', [
                        'number',
                        'number',
                        'number',
                        'number',
                        'number',
                        'number'
                    ], [
                        c,
                        constr,
                        num_fields,
                        outAddress,
                        outAddress + 4,
                        outArray_accessors
                    ]);
                    return {
                        constructor: getOutUint(0),
                        tester: getOutUint(1),
                        accessors: readUintArray(outArray_accessors, num_fields)
                    };
                } finally{
                    Mod._free(outArray_accessors);
                }
            },
            mk_func_decl: function(c, s, domain, range) {
                return Mod.ccall('Z3_mk_func_decl', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    s,
                    domain.length,
                    intArrayToByteArr(domain),
                    range
                ]);
            },
            mk_app: function(c, d, args) {
                return Mod.ccall('Z3_mk_app', 'number', [
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    d,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_const: Mod._Z3_mk_const,
            mk_fresh_func_decl: function(c, prefix, domain, range) {
                return Mod.ccall('Z3_mk_fresh_func_decl', 'number', [
                    'number',
                    'string',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    prefix,
                    domain.length,
                    intArrayToByteArr(domain),
                    range
                ]);
            },
            mk_fresh_const: function(c, prefix, ty) {
                return Mod.ccall('Z3_mk_fresh_const', 'number', [
                    'number',
                    'string',
                    'number'
                ], [
                    c,
                    prefix,
                    ty
                ]);
            },
            mk_rec_func_decl: function(c, s, domain, range) {
                return Mod.ccall('Z3_mk_rec_func_decl', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    s,
                    domain.length,
                    intArrayToByteArr(domain),
                    range
                ]);
            },
            add_rec_def: function(c, f, args, body) {
                return Mod.ccall('Z3_add_rec_def', 'void', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    f,
                    args.length,
                    intArrayToByteArr(args),
                    body
                ]);
            },
            mk_true: Mod._Z3_mk_true,
            mk_false: Mod._Z3_mk_false,
            mk_eq: Mod._Z3_mk_eq,
            mk_distinct: function(c, args) {
                return Mod.ccall('Z3_mk_distinct', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_not: Mod._Z3_mk_not,
            mk_ite: Mod._Z3_mk_ite,
            mk_iff: Mod._Z3_mk_iff,
            mk_implies: Mod._Z3_mk_implies,
            mk_xor: Mod._Z3_mk_xor,
            mk_and: function(c, args) {
                return Mod.ccall('Z3_mk_and', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_or: function(c, args) {
                return Mod.ccall('Z3_mk_or', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_add: function(c, args) {
                return Mod.ccall('Z3_mk_add', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_mul: function(c, args) {
                return Mod.ccall('Z3_mk_mul', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_sub: function(c, args) {
                return Mod.ccall('Z3_mk_sub', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_unary_minus: Mod._Z3_mk_unary_minus,
            mk_div: Mod._Z3_mk_div,
            mk_mod: Mod._Z3_mk_mod,
            mk_rem: Mod._Z3_mk_rem,
            mk_power: Mod._Z3_mk_power,
            mk_abs: Mod._Z3_mk_abs,
            mk_lt: Mod._Z3_mk_lt,
            mk_le: Mod._Z3_mk_le,
            mk_gt: Mod._Z3_mk_gt,
            mk_ge: Mod._Z3_mk_ge,
            mk_divides: Mod._Z3_mk_divides,
            mk_int2real: Mod._Z3_mk_int2real,
            mk_real2int: Mod._Z3_mk_real2int,
            mk_is_int: Mod._Z3_mk_is_int,
            mk_bvnot: Mod._Z3_mk_bvnot,
            mk_bvredand: Mod._Z3_mk_bvredand,
            mk_bvredor: Mod._Z3_mk_bvredor,
            mk_bvand: Mod._Z3_mk_bvand,
            mk_bvor: Mod._Z3_mk_bvor,
            mk_bvxor: Mod._Z3_mk_bvxor,
            mk_bvnand: Mod._Z3_mk_bvnand,
            mk_bvnor: Mod._Z3_mk_bvnor,
            mk_bvxnor: Mod._Z3_mk_bvxnor,
            mk_bvneg: Mod._Z3_mk_bvneg,
            mk_bvadd: Mod._Z3_mk_bvadd,
            mk_bvsub: Mod._Z3_mk_bvsub,
            mk_bvmul: Mod._Z3_mk_bvmul,
            mk_bvudiv: Mod._Z3_mk_bvudiv,
            mk_bvsdiv: Mod._Z3_mk_bvsdiv,
            mk_bvurem: Mod._Z3_mk_bvurem,
            mk_bvsrem: Mod._Z3_mk_bvsrem,
            mk_bvsmod: Mod._Z3_mk_bvsmod,
            mk_bvult: Mod._Z3_mk_bvult,
            mk_bvslt: Mod._Z3_mk_bvslt,
            mk_bvule: Mod._Z3_mk_bvule,
            mk_bvsle: Mod._Z3_mk_bvsle,
            mk_bvuge: Mod._Z3_mk_bvuge,
            mk_bvsge: Mod._Z3_mk_bvsge,
            mk_bvugt: Mod._Z3_mk_bvugt,
            mk_bvsgt: Mod._Z3_mk_bvsgt,
            mk_concat: Mod._Z3_mk_concat,
            mk_extract: Mod._Z3_mk_extract,
            mk_sign_ext: Mod._Z3_mk_sign_ext,
            mk_zero_ext: Mod._Z3_mk_zero_ext,
            mk_repeat: Mod._Z3_mk_repeat,
            mk_bit2bool: Mod._Z3_mk_bit2bool,
            mk_bvshl: Mod._Z3_mk_bvshl,
            mk_bvlshr: Mod._Z3_mk_bvlshr,
            mk_bvashr: Mod._Z3_mk_bvashr,
            mk_rotate_left: Mod._Z3_mk_rotate_left,
            mk_rotate_right: Mod._Z3_mk_rotate_right,
            mk_ext_rotate_left: Mod._Z3_mk_ext_rotate_left,
            mk_ext_rotate_right: Mod._Z3_mk_ext_rotate_right,
            mk_int2bv: Mod._Z3_mk_int2bv,
            mk_bv2int: Mod._Z3_mk_bv2int,
            mk_bvadd_no_overflow: Mod._Z3_mk_bvadd_no_overflow,
            mk_bvadd_no_underflow: Mod._Z3_mk_bvadd_no_underflow,
            mk_bvsub_no_overflow: Mod._Z3_mk_bvsub_no_overflow,
            mk_bvsub_no_underflow: Mod._Z3_mk_bvsub_no_underflow,
            mk_bvsdiv_no_overflow: Mod._Z3_mk_bvsdiv_no_overflow,
            mk_bvneg_no_overflow: Mod._Z3_mk_bvneg_no_overflow,
            mk_bvmul_no_overflow: Mod._Z3_mk_bvmul_no_overflow,
            mk_bvmul_no_underflow: Mod._Z3_mk_bvmul_no_underflow,
            mk_select: Mod._Z3_mk_select,
            mk_select_n: function(c, a, idxs) {
                return Mod.ccall('Z3_mk_select_n', 'number', [
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    a,
                    idxs.length,
                    intArrayToByteArr(idxs)
                ]);
            },
            mk_store: Mod._Z3_mk_store,
            mk_store_n: function(c, a, idxs, v) {
                return Mod.ccall('Z3_mk_store_n', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    a,
                    idxs.length,
                    intArrayToByteArr(idxs),
                    v
                ]);
            },
            mk_const_array: Mod._Z3_mk_const_array,
            mk_map: function(c, f, args) {
                return Mod.ccall('Z3_mk_map', 'number', [
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    f,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_array_default: Mod._Z3_mk_array_default,
            mk_as_array: Mod._Z3_mk_as_array,
            mk_set_sort: Mod._Z3_mk_set_sort,
            mk_empty_set: Mod._Z3_mk_empty_set,
            mk_full_set: Mod._Z3_mk_full_set,
            mk_set_add: Mod._Z3_mk_set_add,
            mk_set_del: Mod._Z3_mk_set_del,
            mk_set_union: function(c, args) {
                return Mod.ccall('Z3_mk_set_union', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_set_intersect: function(c, args) {
                return Mod.ccall('Z3_mk_set_intersect', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_set_difference: Mod._Z3_mk_set_difference,
            mk_set_complement: Mod._Z3_mk_set_complement,
            mk_set_member: Mod._Z3_mk_set_member,
            mk_set_subset: Mod._Z3_mk_set_subset,
            mk_array_ext: Mod._Z3_mk_array_ext,
            mk_finite_set_sort: Mod._Z3_mk_finite_set_sort,
            is_finite_set_sort: function(c, s) {
                return Mod.ccall('Z3_is_finite_set_sort', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            get_finite_set_sort_basis: Mod._Z3_get_finite_set_sort_basis,
            mk_finite_set_empty: Mod._Z3_mk_finite_set_empty,
            mk_finite_set_singleton: Mod._Z3_mk_finite_set_singleton,
            mk_finite_set_union: Mod._Z3_mk_finite_set_union,
            mk_finite_set_intersect: Mod._Z3_mk_finite_set_intersect,
            mk_finite_set_difference: Mod._Z3_mk_finite_set_difference,
            mk_finite_set_member: Mod._Z3_mk_finite_set_member,
            mk_finite_set_size: Mod._Z3_mk_finite_set_size,
            mk_finite_set_subset: Mod._Z3_mk_finite_set_subset,
            mk_finite_set_map: Mod._Z3_mk_finite_set_map,
            mk_finite_set_filter: Mod._Z3_mk_finite_set_filter,
            mk_finite_set_range: Mod._Z3_mk_finite_set_range,
            mk_numeral: function(c, numeral, ty) {
                return Mod.ccall('Z3_mk_numeral', 'number', [
                    'number',
                    'string',
                    'number'
                ], [
                    c,
                    numeral,
                    ty
                ]);
            },
            mk_real: Mod._Z3_mk_real,
            mk_real_int64: Mod._Z3_mk_real_int64,
            mk_int: Mod._Z3_mk_int,
            mk_unsigned_int: Mod._Z3_mk_unsigned_int,
            mk_int64: Mod._Z3_mk_int64,
            mk_unsigned_int64: Mod._Z3_mk_unsigned_int64,
            mk_bv_numeral: function(c, bits) {
                return Mod.ccall('Z3_mk_bv_numeral', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    bits.length,
                    boolArrayToByteArr(bits)
                ]);
            },
            mk_seq_sort: Mod._Z3_mk_seq_sort,
            is_seq_sort: function(c, s) {
                return Mod.ccall('Z3_is_seq_sort', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            get_seq_sort_basis: Mod._Z3_get_seq_sort_basis,
            mk_re_sort: Mod._Z3_mk_re_sort,
            is_re_sort: function(c, s) {
                return Mod.ccall('Z3_is_re_sort', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            get_re_sort_basis: Mod._Z3_get_re_sort_basis,
            mk_string_sort: Mod._Z3_mk_string_sort,
            mk_char_sort: Mod._Z3_mk_char_sort,
            is_string_sort: function(c, s) {
                return Mod.ccall('Z3_is_string_sort', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            is_char_sort: function(c, s) {
                return Mod.ccall('Z3_is_char_sort', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            mk_string: function(c, s) {
                return Mod.ccall('Z3_mk_string', 'number', [
                    'number',
                    'string'
                ], [
                    c,
                    s
                ]);
            },
            mk_lstring: function(c, len, s) {
                return Mod.ccall('Z3_mk_lstring', 'number', [
                    'number',
                    'number',
                    'string'
                ], [
                    c,
                    len,
                    s
                ]);
            },
            mk_u32string: function(c, chars) {
                return Mod.ccall('Z3_mk_u32string', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    chars.length,
                    intArrayToByteArr(chars)
                ]);
            },
            is_string: function(c, s) {
                return Mod.ccall('Z3_is_string', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            get_string: function(c, s) {
                return Mod.ccall('Z3_get_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            get_string_length: function(c, s) {
                let ret = Mod.ccall('Z3_get_string_length', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_string_contents: function(c, s, length) {
                let outArray_contents = Mod._malloc(4 * length);
                try {
                    let ret = Mod.ccall('Z3_get_string_contents', 'void', [
                        'number',
                        'number',
                        'number',
                        'number'
                    ], [
                        c,
                        s,
                        length,
                        outArray_contents
                    ]);
                    return readUintArray(outArray_contents, length);
                } finally{
                    Mod._free(outArray_contents);
                }
            },
            mk_seq_empty: Mod._Z3_mk_seq_empty,
            mk_seq_unit: Mod._Z3_mk_seq_unit,
            mk_seq_concat: function(c, args) {
                return Mod.ccall('Z3_mk_seq_concat', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_seq_prefix: Mod._Z3_mk_seq_prefix,
            mk_seq_suffix: Mod._Z3_mk_seq_suffix,
            mk_seq_contains: Mod._Z3_mk_seq_contains,
            mk_str_lt: Mod._Z3_mk_str_lt,
            mk_str_le: Mod._Z3_mk_str_le,
            mk_seq_extract: Mod._Z3_mk_seq_extract,
            mk_seq_replace: Mod._Z3_mk_seq_replace,
            mk_seq_replace_all: Mod._Z3_mk_seq_replace_all,
            mk_seq_replace_re: Mod._Z3_mk_seq_replace_re,
            mk_seq_replace_re_all: Mod._Z3_mk_seq_replace_re_all,
            mk_seq_at: Mod._Z3_mk_seq_at,
            mk_seq_nth: Mod._Z3_mk_seq_nth,
            mk_seq_length: Mod._Z3_mk_seq_length,
            mk_seq_index: Mod._Z3_mk_seq_index,
            mk_seq_last_index: Mod._Z3_mk_seq_last_index,
            mk_seq_map: Mod._Z3_mk_seq_map,
            mk_seq_mapi: Mod._Z3_mk_seq_mapi,
            mk_seq_foldl: Mod._Z3_mk_seq_foldl,
            mk_seq_foldli: Mod._Z3_mk_seq_foldli,
            mk_str_to_int: Mod._Z3_mk_str_to_int,
            mk_int_to_str: Mod._Z3_mk_int_to_str,
            mk_string_to_code: Mod._Z3_mk_string_to_code,
            mk_string_from_code: Mod._Z3_mk_string_from_code,
            mk_ubv_to_str: Mod._Z3_mk_ubv_to_str,
            mk_sbv_to_str: Mod._Z3_mk_sbv_to_str,
            mk_seq_to_re: Mod._Z3_mk_seq_to_re,
            mk_seq_in_re: Mod._Z3_mk_seq_in_re,
            mk_re_plus: Mod._Z3_mk_re_plus,
            mk_re_star: Mod._Z3_mk_re_star,
            mk_re_option: Mod._Z3_mk_re_option,
            mk_re_union: function(c, args) {
                return Mod.ccall('Z3_mk_re_union', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_re_concat: function(c, args) {
                return Mod.ccall('Z3_mk_re_concat', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_re_range: Mod._Z3_mk_re_range,
            mk_re_allchar: Mod._Z3_mk_re_allchar,
            mk_re_loop: Mod._Z3_mk_re_loop,
            mk_re_power: Mod._Z3_mk_re_power,
            mk_re_intersect: function(c, args) {
                return Mod.ccall('Z3_mk_re_intersect', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            mk_re_complement: Mod._Z3_mk_re_complement,
            mk_re_diff: Mod._Z3_mk_re_diff,
            mk_re_empty: Mod._Z3_mk_re_empty,
            mk_re_full: Mod._Z3_mk_re_full,
            mk_char: Mod._Z3_mk_char,
            mk_char_le: Mod._Z3_mk_char_le,
            mk_char_to_int: Mod._Z3_mk_char_to_int,
            mk_char_to_bv: Mod._Z3_mk_char_to_bv,
            mk_char_from_bv: Mod._Z3_mk_char_from_bv,
            mk_char_is_digit: Mod._Z3_mk_char_is_digit,
            mk_linear_order: Mod._Z3_mk_linear_order,
            mk_partial_order: Mod._Z3_mk_partial_order,
            mk_piecewise_linear_order: Mod._Z3_mk_piecewise_linear_order,
            mk_tree_order: Mod._Z3_mk_tree_order,
            mk_transitive_closure: Mod._Z3_mk_transitive_closure,
            mk_pattern: function(c, terms) {
                return Mod.ccall('Z3_mk_pattern', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    terms.length,
                    intArrayToByteArr(terms)
                ]);
            },
            mk_bound: Mod._Z3_mk_bound,
            mk_forall: function(c, weight, patterns, sorts, decl_names, body) {
                if (sorts.length !== decl_names.length) throw new TypeError(`sorts and decl_names must be the same length (got ${sorts.length} and {decl_names.length})`);
                return Mod.ccall('Z3_mk_forall', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array',
                    'array',
                    'number'
                ], [
                    c,
                    weight,
                    patterns.length,
                    intArrayToByteArr(patterns),
                    sorts.length,
                    intArrayToByteArr(sorts),
                    intArrayToByteArr(decl_names),
                    body
                ]);
            },
            mk_exists: function(c, weight, patterns, sorts, decl_names, body) {
                if (sorts.length !== decl_names.length) throw new TypeError(`sorts and decl_names must be the same length (got ${sorts.length} and {decl_names.length})`);
                return Mod.ccall('Z3_mk_exists', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array',
                    'array',
                    'number'
                ], [
                    c,
                    weight,
                    patterns.length,
                    intArrayToByteArr(patterns),
                    sorts.length,
                    intArrayToByteArr(sorts),
                    intArrayToByteArr(decl_names),
                    body
                ]);
            },
            mk_quantifier: function(c, is_forall, weight, patterns, sorts, decl_names, body) {
                if (sorts.length !== decl_names.length) throw new TypeError(`sorts and decl_names must be the same length (got ${sorts.length} and {decl_names.length})`);
                return Mod.ccall('Z3_mk_quantifier', 'number', [
                    'number',
                    'boolean',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array',
                    'array',
                    'number'
                ], [
                    c,
                    is_forall,
                    weight,
                    patterns.length,
                    intArrayToByteArr(patterns),
                    sorts.length,
                    intArrayToByteArr(sorts),
                    intArrayToByteArr(decl_names),
                    body
                ]);
            },
            mk_quantifier_ex: function(c, is_forall, weight, quantifier_id, skolem_id, patterns, no_patterns, sorts, decl_names, body) {
                if (sorts.length !== decl_names.length) throw new TypeError(`sorts and decl_names must be the same length (got ${sorts.length} and {decl_names.length})`);
                return Mod.ccall('Z3_mk_quantifier_ex', 'number', [
                    'number',
                    'boolean',
                    'number',
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array',
                    'number',
                    'array',
                    'array',
                    'number'
                ], [
                    c,
                    is_forall,
                    weight,
                    quantifier_id,
                    skolem_id,
                    patterns.length,
                    intArrayToByteArr(patterns),
                    no_patterns.length,
                    intArrayToByteArr(no_patterns),
                    sorts.length,
                    intArrayToByteArr(sorts),
                    intArrayToByteArr(decl_names),
                    body
                ]);
            },
            mk_forall_const: function(c, weight, bound, patterns, body) {
                return Mod.ccall('Z3_mk_forall_const', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    weight,
                    bound.length,
                    intArrayToByteArr(bound),
                    patterns.length,
                    intArrayToByteArr(patterns),
                    body
                ]);
            },
            mk_exists_const: function(c, weight, bound, patterns, body) {
                return Mod.ccall('Z3_mk_exists_const', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    weight,
                    bound.length,
                    intArrayToByteArr(bound),
                    patterns.length,
                    intArrayToByteArr(patterns),
                    body
                ]);
            },
            mk_quantifier_const: function(c, is_forall, weight, bound, patterns, body) {
                return Mod.ccall('Z3_mk_quantifier_const', 'number', [
                    'number',
                    'boolean',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    is_forall,
                    weight,
                    bound.length,
                    intArrayToByteArr(bound),
                    patterns.length,
                    intArrayToByteArr(patterns),
                    body
                ]);
            },
            mk_quantifier_const_ex: function(c, is_forall, weight, quantifier_id, skolem_id, bound, patterns, no_patterns, body) {
                return Mod.ccall('Z3_mk_quantifier_const_ex', 'number', [
                    'number',
                    'boolean',
                    'number',
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    is_forall,
                    weight,
                    quantifier_id,
                    skolem_id,
                    bound.length,
                    intArrayToByteArr(bound),
                    patterns.length,
                    intArrayToByteArr(patterns),
                    no_patterns.length,
                    intArrayToByteArr(no_patterns),
                    body
                ]);
            },
            mk_lambda: function(c, sorts, decl_names, body) {
                if (sorts.length !== decl_names.length) throw new TypeError(`sorts and decl_names must be the same length (got ${sorts.length} and {decl_names.length})`);
                return Mod.ccall('Z3_mk_lambda', 'number', [
                    'number',
                    'number',
                    'array',
                    'array',
                    'number'
                ], [
                    c,
                    sorts.length,
                    intArrayToByteArr(sorts),
                    intArrayToByteArr(decl_names),
                    body
                ]);
            },
            mk_lambda_const: function(c, bound, body) {
                return Mod.ccall('Z3_mk_lambda_const', 'number', [
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    bound.length,
                    intArrayToByteArr(bound),
                    body
                ]);
            },
            get_symbol_kind: Mod._Z3_get_symbol_kind,
            get_symbol_int: Mod._Z3_get_symbol_int,
            get_symbol_string: function(c, s) {
                return Mod.ccall('Z3_get_symbol_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            get_sort_name: Mod._Z3_get_sort_name,
            get_sort_id: function(c, s) {
                let ret = Mod.ccall('Z3_get_sort_id', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            sort_to_ast: Mod._Z3_sort_to_ast,
            is_eq_sort: function(c, s1, s2) {
                return Mod.ccall('Z3_is_eq_sort', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    s1,
                    s2
                ]);
            },
            get_sort_kind: Mod._Z3_get_sort_kind,
            get_bv_sort_size: function(c, t) {
                let ret = Mod.ccall('Z3_get_bv_sort_size', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_finite_domain_sort_size: function(c, s) {
                let ret = Mod.ccall('Z3_get_finite_domain_sort_size', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    s,
                    outAddress
                ]);
                if (!ret) return null;
                return getOutUint64(0);
            },
            get_array_arity: function(c, s) {
                let ret = Mod.ccall('Z3_get_array_arity', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_array_sort_domain: Mod._Z3_get_array_sort_domain,
            get_array_sort_domain_n: Mod._Z3_get_array_sort_domain_n,
            get_array_sort_range: Mod._Z3_get_array_sort_range,
            get_tuple_sort_mk_decl: Mod._Z3_get_tuple_sort_mk_decl,
            get_tuple_sort_num_fields: function(c, t) {
                let ret = Mod.ccall('Z3_get_tuple_sort_num_fields', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_tuple_sort_field_decl: Mod._Z3_get_tuple_sort_field_decl,
            is_recursive_datatype_sort: function(c, s) {
                return Mod.ccall('Z3_is_recursive_datatype_sort', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            get_datatype_sort_num_constructors: function(c, t) {
                let ret = Mod.ccall('Z3_get_datatype_sort_num_constructors', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_datatype_sort_constructor: Mod._Z3_get_datatype_sort_constructor,
            get_datatype_sort_recognizer: Mod._Z3_get_datatype_sort_recognizer,
            get_datatype_sort_constructor_accessor: Mod._Z3_get_datatype_sort_constructor_accessor,
            datatype_update_field: Mod._Z3_datatype_update_field,
            get_relation_arity: function(c, s) {
                let ret = Mod.ccall('Z3_get_relation_arity', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_relation_column: Mod._Z3_get_relation_column,
            mk_atmost: function(c, args, k) {
                return Mod.ccall('Z3_mk_atmost', 'number', [
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args),
                    k
                ]);
            },
            mk_atleast: function(c, args, k) {
                return Mod.ccall('Z3_mk_atleast', 'number', [
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args),
                    k
                ]);
            },
            mk_pble: function(c, args, coeffs, k) {
                if (args.length !== coeffs.length) throw new TypeError(`args and coeffs must be the same length (got ${args.length} and {coeffs.length})`);
                return Mod.ccall('Z3_mk_pble', 'number', [
                    'number',
                    'number',
                    'array',
                    'array',
                    'number'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args),
                    intArrayToByteArr(coeffs),
                    k
                ]);
            },
            mk_pbge: function(c, args, coeffs, k) {
                if (args.length !== coeffs.length) throw new TypeError(`args and coeffs must be the same length (got ${args.length} and {coeffs.length})`);
                return Mod.ccall('Z3_mk_pbge', 'number', [
                    'number',
                    'number',
                    'array',
                    'array',
                    'number'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args),
                    intArrayToByteArr(coeffs),
                    k
                ]);
            },
            mk_pbeq: function(c, args, coeffs, k) {
                if (args.length !== coeffs.length) throw new TypeError(`args and coeffs must be the same length (got ${args.length} and {coeffs.length})`);
                return Mod.ccall('Z3_mk_pbeq', 'number', [
                    'number',
                    'number',
                    'array',
                    'array',
                    'number'
                ], [
                    c,
                    args.length,
                    intArrayToByteArr(args),
                    intArrayToByteArr(coeffs),
                    k
                ]);
            },
            func_decl_to_ast: Mod._Z3_func_decl_to_ast,
            is_eq_func_decl: function(c, f1, f2) {
                return Mod.ccall('Z3_is_eq_func_decl', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    f1,
                    f2
                ]);
            },
            get_func_decl_id: function(c, f) {
                let ret = Mod.ccall('Z3_get_func_decl_id', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    f
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_decl_name: Mod._Z3_get_decl_name,
            get_decl_kind: Mod._Z3_get_decl_kind,
            get_domain_size: function(c, d) {
                let ret = Mod.ccall('Z3_get_domain_size', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    d
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_arity: function(c, d) {
                let ret = Mod.ccall('Z3_get_arity', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    d
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_domain: Mod._Z3_get_domain,
            get_range: Mod._Z3_get_range,
            get_decl_num_parameters: function(c, d) {
                let ret = Mod.ccall('Z3_get_decl_num_parameters', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    d
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_decl_parameter_kind: Mod._Z3_get_decl_parameter_kind,
            get_decl_int_parameter: Mod._Z3_get_decl_int_parameter,
            get_decl_double_parameter: Mod._Z3_get_decl_double_parameter,
            get_decl_symbol_parameter: Mod._Z3_get_decl_symbol_parameter,
            get_decl_sort_parameter: Mod._Z3_get_decl_sort_parameter,
            get_decl_ast_parameter: Mod._Z3_get_decl_ast_parameter,
            get_decl_func_decl_parameter: Mod._Z3_get_decl_func_decl_parameter,
            get_decl_rational_parameter: function(c, d, idx) {
                return Mod.ccall('Z3_get_decl_rational_parameter', 'string', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    d,
                    idx
                ]);
            },
            app_to_ast: Mod._Z3_app_to_ast,
            get_app_decl: Mod._Z3_get_app_decl,
            get_app_num_args: function(c, a) {
                let ret = Mod.ccall('Z3_get_app_num_args', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_app_arg: Mod._Z3_get_app_arg,
            is_eq_ast: function(c, t1, t2) {
                return Mod.ccall('Z3_is_eq_ast', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    t1,
                    t2
                ]);
            },
            get_ast_id: function(c, t) {
                let ret = Mod.ccall('Z3_get_ast_id', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_ast_hash: function(c, a) {
                let ret = Mod.ccall('Z3_get_ast_hash', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_sort: Mod._Z3_get_sort,
            is_well_sorted: function(c, t) {
                return Mod.ccall('Z3_is_well_sorted', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            get_bool_value: Mod._Z3_get_bool_value,
            get_ast_kind: Mod._Z3_get_ast_kind,
            is_app: function(c, a) {
                return Mod.ccall('Z3_is_app', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            is_ground: function(c, a) {
                return Mod.ccall('Z3_is_ground', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            get_depth: function(c, a) {
                let ret = Mod.ccall('Z3_get_depth', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            is_numeral_ast: function(c, a) {
                return Mod.ccall('Z3_is_numeral_ast', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            is_algebraic_number: function(c, a) {
                return Mod.ccall('Z3_is_algebraic_number', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            to_app: Mod._Z3_to_app,
            to_func_decl: Mod._Z3_to_func_decl,
            get_numeral_string: function(c, a) {
                return Mod.ccall('Z3_get_numeral_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            get_numeral_binary_string: function(c, a) {
                return Mod.ccall('Z3_get_numeral_binary_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            get_numeral_decimal_string: function(c, a, precision) {
                return Mod.ccall('Z3_get_numeral_decimal_string', 'string', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    precision
                ]);
            },
            get_numeral_double: Mod._Z3_get_numeral_double,
            get_numerator: Mod._Z3_get_numerator,
            get_denominator: Mod._Z3_get_denominator,
            get_numeral_small: function(c, a) {
                let ret = Mod.ccall('Z3_get_numeral_small', 'boolean', [
                    'number',
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    outAddress,
                    outAddress + 8
                ]);
                if (!ret) return null;
                return {
                    num: getOutInt64(0),
                    den: getOutInt64(1)
                };
            },
            get_numeral_int: function(c, v) {
                let ret = Mod.ccall('Z3_get_numeral_int', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    v,
                    outAddress
                ]);
                if (!ret) return null;
                return getOutInt(0);
            },
            get_numeral_uint: function(c, v) {
                let ret = Mod.ccall('Z3_get_numeral_uint', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    v,
                    outAddress
                ]);
                if (!ret) return null;
                return getOutUint(0);
            },
            get_numeral_uint64: function(c, v) {
                let ret = Mod.ccall('Z3_get_numeral_uint64', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    v,
                    outAddress
                ]);
                if (!ret) return null;
                return getOutUint64(0);
            },
            get_numeral_int64: function(c, v) {
                let ret = Mod.ccall('Z3_get_numeral_int64', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    v,
                    outAddress
                ]);
                if (!ret) return null;
                return getOutInt64(0);
            },
            get_numeral_rational_int64: function(c, v) {
                let ret = Mod.ccall('Z3_get_numeral_rational_int64', 'boolean', [
                    'number',
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    v,
                    outAddress,
                    outAddress + 8
                ]);
                if (!ret) return null;
                return {
                    num: getOutInt64(0),
                    den: getOutInt64(1)
                };
            },
            get_algebraic_number_lower: Mod._Z3_get_algebraic_number_lower,
            get_algebraic_number_upper: Mod._Z3_get_algebraic_number_upper,
            pattern_to_ast: Mod._Z3_pattern_to_ast,
            get_pattern_num_terms: function(c, p) {
                let ret = Mod.ccall('Z3_get_pattern_num_terms', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    p
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_pattern: Mod._Z3_get_pattern,
            get_index_value: function(c, a) {
                let ret = Mod.ccall('Z3_get_index_value', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            is_quantifier_forall: function(c, a) {
                return Mod.ccall('Z3_is_quantifier_forall', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            is_quantifier_exists: function(c, a) {
                return Mod.ccall('Z3_is_quantifier_exists', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            is_lambda: function(c, a) {
                return Mod.ccall('Z3_is_lambda', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            get_quantifier_weight: function(c, a) {
                let ret = Mod.ccall('Z3_get_quantifier_weight', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_quantifier_skolem_id: Mod._Z3_get_quantifier_skolem_id,
            get_quantifier_id: Mod._Z3_get_quantifier_id,
            get_quantifier_num_patterns: function(c, a) {
                let ret = Mod.ccall('Z3_get_quantifier_num_patterns', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_quantifier_pattern_ast: Mod._Z3_get_quantifier_pattern_ast,
            get_quantifier_num_no_patterns: function(c, a) {
                let ret = Mod.ccall('Z3_get_quantifier_num_no_patterns', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_quantifier_no_pattern_ast: Mod._Z3_get_quantifier_no_pattern_ast,
            get_quantifier_num_bound: function(c, a) {
                let ret = Mod.ccall('Z3_get_quantifier_num_bound', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_quantifier_bound_name: Mod._Z3_get_quantifier_bound_name,
            get_quantifier_bound_sort: Mod._Z3_get_quantifier_bound_sort,
            get_quantifier_body: Mod._Z3_get_quantifier_body,
            simplify: function(c, a) {
                return Mod.async_call(Mod._async_Z3_simplify, c, a);
            },
            simplify_ex: function(c, a, p) {
                return Mod.async_call(Mod._async_Z3_simplify_ex, c, a, p);
            },
            simplify_get_help: function(c) {
                return Mod.ccall('Z3_simplify_get_help', 'string', [
                    'number'
                ], [
                    c
                ]);
            },
            simplify_get_param_descrs: Mod._Z3_simplify_get_param_descrs,
            update_term: function(c, a, args) {
                return Mod.ccall('Z3_update_term', 'number', [
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    a,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            substitute: function(c, a, from, to) {
                if (from.length !== to.length) throw new TypeError(`from and to must be the same length (got ${from.length} and {to.length})`);
                return Mod.ccall('Z3_substitute', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'array'
                ], [
                    c,
                    a,
                    from.length,
                    intArrayToByteArr(from),
                    intArrayToByteArr(to)
                ]);
            },
            substitute_vars: function(c, a, to) {
                return Mod.ccall('Z3_substitute_vars', 'number', [
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    a,
                    to.length,
                    intArrayToByteArr(to)
                ]);
            },
            substitute_funs: function(c, a, from, to) {
                if (from.length !== to.length) throw new TypeError(`from and to must be the same length (got ${from.length} and {to.length})`);
                return Mod.ccall('Z3_substitute_funs', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'array'
                ], [
                    c,
                    a,
                    from.length,
                    intArrayToByteArr(from),
                    intArrayToByteArr(to)
                ]);
            },
            translate: Mod._Z3_translate,
            mk_model: Mod._Z3_mk_model,
            model_inc_ref: Mod._Z3_model_inc_ref,
            model_dec_ref: Mod._Z3_model_dec_ref,
            model_eval: function(c, m, t, model_completion) {
                let ret = Mod.ccall('Z3_model_eval', 'boolean', [
                    'number',
                    'number',
                    'number',
                    'boolean',
                    'number'
                ], [
                    c,
                    m,
                    t,
                    model_completion,
                    outAddress
                ]);
                if (!ret) return null;
                return getOutUint(0);
            },
            model_get_const_interp: Mod._Z3_model_get_const_interp,
            model_has_interp: function(c, m, a) {
                return Mod.ccall('Z3_model_has_interp', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    m,
                    a
                ]);
            },
            model_get_func_interp: Mod._Z3_model_get_func_interp,
            model_get_num_consts: function(c, m) {
                let ret = Mod.ccall('Z3_model_get_num_consts', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    m
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            model_get_const_decl: Mod._Z3_model_get_const_decl,
            model_get_num_funcs: function(c, m) {
                let ret = Mod.ccall('Z3_model_get_num_funcs', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    m
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            model_get_func_decl: Mod._Z3_model_get_func_decl,
            model_get_num_sorts: function(c, m) {
                let ret = Mod.ccall('Z3_model_get_num_sorts', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    m
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            model_get_sort: Mod._Z3_model_get_sort,
            model_get_sort_universe: Mod._Z3_model_get_sort_universe,
            model_translate: Mod._Z3_model_translate,
            is_as_array: function(c, a) {
                return Mod.ccall('Z3_is_as_array', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            get_as_array_func_decl: Mod._Z3_get_as_array_func_decl,
            add_func_interp: Mod._Z3_add_func_interp,
            add_const_interp: Mod._Z3_add_const_interp,
            func_interp_inc_ref: Mod._Z3_func_interp_inc_ref,
            func_interp_dec_ref: Mod._Z3_func_interp_dec_ref,
            func_interp_get_num_entries: function(c, f) {
                let ret = Mod.ccall('Z3_func_interp_get_num_entries', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    f
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            func_interp_get_entry: Mod._Z3_func_interp_get_entry,
            func_interp_get_else: Mod._Z3_func_interp_get_else,
            func_interp_set_else: Mod._Z3_func_interp_set_else,
            func_interp_get_arity: function(c, f) {
                let ret = Mod.ccall('Z3_func_interp_get_arity', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    f
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            func_interp_add_entry: Mod._Z3_func_interp_add_entry,
            func_entry_inc_ref: Mod._Z3_func_entry_inc_ref,
            func_entry_dec_ref: Mod._Z3_func_entry_dec_ref,
            func_entry_get_value: Mod._Z3_func_entry_get_value,
            func_entry_get_num_args: function(c, e) {
                let ret = Mod.ccall('Z3_func_entry_get_num_args', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    e
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            func_entry_get_arg: Mod._Z3_func_entry_get_arg,
            open_log: function(filename) {
                return Mod.ccall('Z3_open_log', 'boolean', [
                    'string'
                ], [
                    filename
                ]);
            },
            append_log: function(string) {
                return Mod.ccall('Z3_append_log', 'void', [
                    'string'
                ], [
                    string
                ]);
            },
            close_log: Mod._Z3_close_log,
            toggle_warning_messages: Mod._Z3_toggle_warning_messages,
            set_ast_print_mode: Mod._Z3_set_ast_print_mode,
            ast_to_string: function(c, a) {
                return Mod.ccall('Z3_ast_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            pattern_to_string: function(c, p) {
                return Mod.ccall('Z3_pattern_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    p
                ]);
            },
            sort_to_string: function(c, s) {
                return Mod.ccall('Z3_sort_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            func_decl_to_string: function(c, d) {
                return Mod.ccall('Z3_func_decl_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    d
                ]);
            },
            model_to_string: function(c, m) {
                return Mod.ccall('Z3_model_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    m
                ]);
            },
            benchmark_to_smtlib_string: function(c, name, logic, status, attributes, assumptions, formula) {
                return Mod.ccall('Z3_benchmark_to_smtlib_string', 'string', [
                    'number',
                    'string',
                    'string',
                    'string',
                    'string',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    name,
                    logic,
                    status,
                    attributes,
                    assumptions.length,
                    intArrayToByteArr(assumptions),
                    formula
                ]);
            },
            parse_smtlib2_string: function(c, str, sort_names, sorts, decl_names, decls) {
                if (sort_names.length !== sorts.length) throw new TypeError(`sort_names and sorts must be the same length (got ${sort_names.length} and {sorts.length})`);
                if (decl_names.length !== decls.length) throw new TypeError(`decl_names and decls must be the same length (got ${decl_names.length} and {decls.length})`);
                return Mod.ccall('Z3_parse_smtlib2_string', 'number', [
                    'number',
                    'string',
                    'number',
                    'array',
                    'array',
                    'number',
                    'array',
                    'array'
                ], [
                    c,
                    str,
                    sort_names.length,
                    intArrayToByteArr(sort_names),
                    intArrayToByteArr(sorts),
                    decl_names.length,
                    intArrayToByteArr(decl_names),
                    intArrayToByteArr(decls)
                ]);
            },
            parse_smtlib2_file: function(c, file_name, sort_names, sorts, decl_names, decls) {
                if (sort_names.length !== sorts.length) throw new TypeError(`sort_names and sorts must be the same length (got ${sort_names.length} and {sorts.length})`);
                if (decl_names.length !== decls.length) throw new TypeError(`decl_names and decls must be the same length (got ${decl_names.length} and {decls.length})`);
                return Mod.ccall('Z3_parse_smtlib2_file', 'number', [
                    'number',
                    'string',
                    'number',
                    'array',
                    'array',
                    'number',
                    'array',
                    'array'
                ], [
                    c,
                    file_name,
                    sort_names.length,
                    intArrayToByteArr(sort_names),
                    intArrayToByteArr(sorts),
                    decl_names.length,
                    intArrayToByteArr(decl_names),
                    intArrayToByteArr(decls)
                ]);
            },
            eval_smtlib2_string: async function(c, str) {
                return await Mod.async_call(()=>Mod.ccall('async_Z3_eval_smtlib2_string', 'void', [
                        'number',
                        'string'
                    ], [
                        c,
                        str
                    ]));
            },
            mk_parser_context: Mod._Z3_mk_parser_context,
            parser_context_inc_ref: Mod._Z3_parser_context_inc_ref,
            parser_context_dec_ref: Mod._Z3_parser_context_dec_ref,
            parser_context_add_sort: Mod._Z3_parser_context_add_sort,
            parser_context_add_decl: Mod._Z3_parser_context_add_decl,
            parser_context_from_string: function(c, pc, s) {
                return Mod.ccall('Z3_parser_context_from_string', 'number', [
                    'number',
                    'number',
                    'string'
                ], [
                    c,
                    pc,
                    s
                ]);
            },
            get_error_code: Mod._Z3_get_error_code,
            set_error: Mod._Z3_set_error,
            get_error_msg: function(c, err) {
                return Mod.ccall('Z3_get_error_msg', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    err
                ]);
            },
            get_version: function() {
                let ret = Mod.ccall('Z3_get_version', 'void', [
                    'number',
                    'number',
                    'number',
                    'number'
                ], [
                    outAddress,
                    outAddress + 4,
                    outAddress + 8,
                    outAddress + 12
                ]);
                return {
                    major: getOutUint(0),
                    minor: getOutUint(1),
                    build_number: getOutUint(2),
                    revision_number: getOutUint(3)
                };
            },
            get_full_version: function() {
                return Mod.ccall('Z3_get_full_version', 'string', [], []);
            },
            enable_trace: function(tag) {
                return Mod.ccall('Z3_enable_trace', 'void', [
                    'string'
                ], [
                    tag
                ]);
            },
            disable_trace: function(tag) {
                return Mod.ccall('Z3_disable_trace', 'void', [
                    'string'
                ], [
                    tag
                ]);
            },
            reset_memory: Mod._Z3_reset_memory,
            finalize_memory: Mod._Z3_finalize_memory,
            mk_goal: Mod._Z3_mk_goal,
            goal_inc_ref: Mod._Z3_goal_inc_ref,
            goal_dec_ref: Mod._Z3_goal_dec_ref,
            goal_precision: Mod._Z3_goal_precision,
            goal_assert: Mod._Z3_goal_assert,
            goal_inconsistent: function(c, g) {
                return Mod.ccall('Z3_goal_inconsistent', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    g
                ]);
            },
            goal_depth: function(c, g) {
                let ret = Mod.ccall('Z3_goal_depth', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    g
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            goal_reset: Mod._Z3_goal_reset,
            goal_size: function(c, g) {
                let ret = Mod.ccall('Z3_goal_size', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    g
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            goal_formula: Mod._Z3_goal_formula,
            goal_num_exprs: function(c, g) {
                let ret = Mod.ccall('Z3_goal_num_exprs', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    g
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            goal_is_decided_sat: function(c, g) {
                return Mod.ccall('Z3_goal_is_decided_sat', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    g
                ]);
            },
            goal_is_decided_unsat: function(c, g) {
                return Mod.ccall('Z3_goal_is_decided_unsat', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    g
                ]);
            },
            goal_translate: Mod._Z3_goal_translate,
            goal_convert_model: Mod._Z3_goal_convert_model,
            goal_to_string: function(c, g) {
                return Mod.ccall('Z3_goal_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    g
                ]);
            },
            goal_to_dimacs_string: function(c, g, include_names) {
                return Mod.ccall('Z3_goal_to_dimacs_string', 'string', [
                    'number',
                    'number',
                    'boolean'
                ], [
                    c,
                    g,
                    include_names
                ]);
            },
            mk_tactic: function(c, name) {
                return Mod.ccall('Z3_mk_tactic', 'number', [
                    'number',
                    'string'
                ], [
                    c,
                    name
                ]);
            },
            tactic_inc_ref: Mod._Z3_tactic_inc_ref,
            tactic_dec_ref: Mod._Z3_tactic_dec_ref,
            mk_probe: function(c, name) {
                return Mod.ccall('Z3_mk_probe', 'number', [
                    'number',
                    'string'
                ], [
                    c,
                    name
                ]);
            },
            probe_inc_ref: Mod._Z3_probe_inc_ref,
            probe_dec_ref: Mod._Z3_probe_dec_ref,
            tactic_and_then: Mod._Z3_tactic_and_then,
            tactic_or_else: Mod._Z3_tactic_or_else,
            tactic_par_or: function(c, ts) {
                return Mod.ccall('Z3_tactic_par_or', 'number', [
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    ts.length,
                    intArrayToByteArr(ts)
                ]);
            },
            tactic_par_and_then: Mod._Z3_tactic_par_and_then,
            tactic_try_for: Mod._Z3_tactic_try_for,
            tactic_when: Mod._Z3_tactic_when,
            tactic_cond: Mod._Z3_tactic_cond,
            tactic_repeat: Mod._Z3_tactic_repeat,
            tactic_skip: Mod._Z3_tactic_skip,
            tactic_fail: Mod._Z3_tactic_fail,
            tactic_fail_if: Mod._Z3_tactic_fail_if,
            tactic_fail_if_not_decided: Mod._Z3_tactic_fail_if_not_decided,
            tactic_using_params: Mod._Z3_tactic_using_params,
            mk_simplifier: function(c, name) {
                return Mod.ccall('Z3_mk_simplifier', 'number', [
                    'number',
                    'string'
                ], [
                    c,
                    name
                ]);
            },
            simplifier_inc_ref: Mod._Z3_simplifier_inc_ref,
            simplifier_dec_ref: Mod._Z3_simplifier_dec_ref,
            solver_add_simplifier: Mod._Z3_solver_add_simplifier,
            simplifier_and_then: Mod._Z3_simplifier_and_then,
            simplifier_using_params: Mod._Z3_simplifier_using_params,
            get_num_simplifiers: function(c) {
                let ret = Mod.ccall('Z3_get_num_simplifiers', 'number', [
                    'number'
                ], [
                    c
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_simplifier_name: function(c, i) {
                return Mod.ccall('Z3_get_simplifier_name', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    i
                ]);
            },
            simplifier_get_help: function(c, t) {
                return Mod.ccall('Z3_simplifier_get_help', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            simplifier_get_param_descrs: Mod._Z3_simplifier_get_param_descrs,
            simplifier_get_descr: function(c, name) {
                return Mod.ccall('Z3_simplifier_get_descr', 'string', [
                    'number',
                    'string'
                ], [
                    c,
                    name
                ]);
            },
            probe_const: Mod._Z3_probe_const,
            probe_lt: Mod._Z3_probe_lt,
            probe_gt: Mod._Z3_probe_gt,
            probe_le: Mod._Z3_probe_le,
            probe_ge: Mod._Z3_probe_ge,
            probe_eq: Mod._Z3_probe_eq,
            probe_and: Mod._Z3_probe_and,
            probe_or: Mod._Z3_probe_or,
            probe_not: Mod._Z3_probe_not,
            get_num_tactics: function(c) {
                let ret = Mod.ccall('Z3_get_num_tactics', 'number', [
                    'number'
                ], [
                    c
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_tactic_name: function(c, i) {
                return Mod.ccall('Z3_get_tactic_name', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    i
                ]);
            },
            get_num_probes: function(c) {
                let ret = Mod.ccall('Z3_get_num_probes', 'number', [
                    'number'
                ], [
                    c
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            get_probe_name: function(c, i) {
                return Mod.ccall('Z3_get_probe_name', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    i
                ]);
            },
            tactic_get_help: function(c, t) {
                return Mod.ccall('Z3_tactic_get_help', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            tactic_get_param_descrs: Mod._Z3_tactic_get_param_descrs,
            tactic_get_descr: function(c, name) {
                return Mod.ccall('Z3_tactic_get_descr', 'string', [
                    'number',
                    'string'
                ], [
                    c,
                    name
                ]);
            },
            probe_get_descr: function(c, name) {
                return Mod.ccall('Z3_probe_get_descr', 'string', [
                    'number',
                    'string'
                ], [
                    c,
                    name
                ]);
            },
            probe_apply: Mod._Z3_probe_apply,
            tactic_apply: function(c, t, g) {
                return Mod.async_call(Mod._async_Z3_tactic_apply, c, t, g);
            },
            tactic_apply_ex: function(c, t, g, p) {
                return Mod.async_call(Mod._async_Z3_tactic_apply_ex, c, t, g, p);
            },
            apply_result_inc_ref: Mod._Z3_apply_result_inc_ref,
            apply_result_dec_ref: Mod._Z3_apply_result_dec_ref,
            apply_result_to_string: function(c, r) {
                return Mod.ccall('Z3_apply_result_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    r
                ]);
            },
            apply_result_get_num_subgoals: function(c, r) {
                let ret = Mod.ccall('Z3_apply_result_get_num_subgoals', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    r
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            apply_result_get_subgoal: Mod._Z3_apply_result_get_subgoal,
            mk_solver: Mod._Z3_mk_solver,
            mk_simple_solver: Mod._Z3_mk_simple_solver,
            mk_solver_for_logic: Mod._Z3_mk_solver_for_logic,
            mk_solver_from_tactic: Mod._Z3_mk_solver_from_tactic,
            solver_translate: Mod._Z3_solver_translate,
            solver_import_model_converter: Mod._Z3_solver_import_model_converter,
            solver_get_help: function(c, s) {
                return Mod.ccall('Z3_solver_get_help', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            solver_get_param_descrs: Mod._Z3_solver_get_param_descrs,
            solver_set_params: Mod._Z3_solver_set_params,
            solver_inc_ref: Mod._Z3_solver_inc_ref,
            solver_dec_ref: Mod._Z3_solver_dec_ref,
            solver_interrupt: Mod._Z3_solver_interrupt,
            solver_push: Mod._Z3_solver_push,
            solver_pop: Mod._Z3_solver_pop,
            solver_reset: Mod._Z3_solver_reset,
            solver_get_num_scopes: function(c, s) {
                let ret = Mod.ccall('Z3_solver_get_num_scopes', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            solver_assert: Mod._Z3_solver_assert,
            solver_assert_and_track: Mod._Z3_solver_assert_and_track,
            solver_from_file: function(c, s, file_name) {
                return Mod.ccall('Z3_solver_from_file', 'void', [
                    'number',
                    'number',
                    'string'
                ], [
                    c,
                    s,
                    file_name
                ]);
            },
            solver_from_string: function(c, s, str) {
                return Mod.ccall('Z3_solver_from_string', 'void', [
                    'number',
                    'number',
                    'string'
                ], [
                    c,
                    s,
                    str
                ]);
            },
            solver_get_assertions: Mod._Z3_solver_get_assertions,
            solver_get_units: Mod._Z3_solver_get_units,
            solver_get_trail: Mod._Z3_solver_get_trail,
            solver_get_non_units: Mod._Z3_solver_get_non_units,
            solver_get_levels: function(c, s, literals, sz) {
                let outArray_levels = Mod._malloc(4 * sz);
                try {
                    let ret = Mod.ccall('Z3_solver_get_levels', 'void', [
                        'number',
                        'number',
                        'number',
                        'number',
                        'number'
                    ], [
                        c,
                        s,
                        literals,
                        sz,
                        outArray_levels
                    ]);
                    return readUintArray(outArray_levels, sz);
                } finally{
                    Mod._free(outArray_levels);
                }
            },
            solver_congruence_root: Mod._Z3_solver_congruence_root,
            solver_congruence_next: Mod._Z3_solver_congruence_next,
            solver_congruence_explain: Mod._Z3_solver_congruence_explain,
            solver_solve_for: Mod._Z3_solver_solve_for,
            solver_next_split: function(c, cb, t, idx, phase) {
                return Mod.ccall('Z3_solver_next_split', 'boolean', [
                    'number',
                    'number',
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    cb,
                    t,
                    idx,
                    phase
                ]);
            },
            solver_propagate_declare: function(c, name, domain, range) {
                return Mod.ccall('Z3_solver_propagate_declare', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    name,
                    domain.length,
                    intArrayToByteArr(domain),
                    range
                ]);
            },
            solver_propagate_register: Mod._Z3_solver_propagate_register,
            solver_propagate_register_cb: Mod._Z3_solver_propagate_register_cb,
            solver_propagate_consequence: function(c, cb, fixed, eq_lhs, eq_rhs, conseq) {
                if (eq_lhs.length !== eq_rhs.length) throw new TypeError(`eq_lhs and eq_rhs must be the same length (got ${eq_lhs.length} and {eq_rhs.length})`);
                return Mod.ccall('Z3_solver_propagate_consequence', 'boolean', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'array',
                    'array',
                    'number'
                ], [
                    c,
                    cb,
                    fixed.length,
                    intArrayToByteArr(fixed),
                    eq_lhs.length,
                    intArrayToByteArr(eq_lhs),
                    intArrayToByteArr(eq_rhs),
                    conseq
                ]);
            },
            solver_set_initial_value: Mod._Z3_solver_set_initial_value,
            solver_check: function(c, s) {
                return Mod.async_call(Mod._async_Z3_solver_check, c, s);
            },
            solver_check_assumptions: async function(c, s, assumptions) {
                const assumptions_ptr = Mod._malloc(assumptions.length * 4);
                Mod.HEAPU32.set(assumptions, assumptions_ptr / 4);
                try {
                    let ret = await Mod.async_call(()=>Mod.ccall('async_Z3_solver_check_assumptions', 'void', [
                            'number',
                            'number',
                            'number',
                            'number'
                        ], [
                            c,
                            s,
                            assumptions.length,
                            assumptions_ptr
                        ]));
                    return ret;
                } finally{
                    Mod._free(assumptions_ptr);
                }
            },
            get_implied_equalities: function(c, s, terms) {
                let outArray_class_ids = Mod._malloc(4 * terms.length);
                try {
                    let ret = Mod.ccall('Z3_get_implied_equalities', 'number', [
                        'number',
                        'number',
                        'number',
                        'array',
                        'number'
                    ], [
                        c,
                        s,
                        terms.length,
                        intArrayToByteArr(terms),
                        outArray_class_ids
                    ]);
                    return {
                        rv: ret,
                        class_ids: readUintArray(outArray_class_ids, terms.length)
                    };
                } finally{
                    Mod._free(outArray_class_ids);
                }
            },
            solver_get_consequences: function(c, s, assumptions, variables, consequences) {
                return Mod.async_call(Mod._async_Z3_solver_get_consequences, c, s, assumptions, variables, consequences);
            },
            solver_cube: function(c, s, vars, backtrack_level) {
                return Mod.async_call(Mod._async_Z3_solver_cube, c, s, vars, backtrack_level);
            },
            solver_get_model: Mod._Z3_solver_get_model,
            solver_get_proof: Mod._Z3_solver_get_proof,
            solver_get_unsat_core: Mod._Z3_solver_get_unsat_core,
            solver_get_reason_unknown: function(c, s) {
                return Mod.ccall('Z3_solver_get_reason_unknown', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            solver_get_statistics: Mod._Z3_solver_get_statistics,
            solver_to_string: function(c, s) {
                return Mod.ccall('Z3_solver_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            solver_to_dimacs_string: function(c, s, include_names) {
                return Mod.ccall('Z3_solver_to_dimacs_string', 'string', [
                    'number',
                    'number',
                    'boolean'
                ], [
                    c,
                    s,
                    include_names
                ]);
            },
            stats_to_string: function(c, s) {
                return Mod.ccall('Z3_stats_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
            },
            stats_inc_ref: Mod._Z3_stats_inc_ref,
            stats_dec_ref: Mod._Z3_stats_dec_ref,
            stats_size: function(c, s) {
                let ret = Mod.ccall('Z3_stats_size', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            stats_get_key: function(c, s, idx) {
                return Mod.ccall('Z3_stats_get_key', 'string', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    s,
                    idx
                ]);
            },
            stats_is_uint: function(c, s, idx) {
                return Mod.ccall('Z3_stats_is_uint', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    s,
                    idx
                ]);
            },
            stats_is_double: function(c, s, idx) {
                return Mod.ccall('Z3_stats_is_double', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    s,
                    idx
                ]);
            },
            stats_get_uint_value: function(c, s, idx) {
                let ret = Mod.ccall('Z3_stats_get_uint_value', 'number', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    s,
                    idx
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            stats_get_double_value: Mod._Z3_stats_get_double_value,
            get_estimated_alloc_size: Mod._Z3_get_estimated_alloc_size,
            algebraic_is_value: function(c, a) {
                return Mod.ccall('Z3_algebraic_is_value', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            algebraic_is_pos: function(c, a) {
                return Mod.ccall('Z3_algebraic_is_pos', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            algebraic_is_neg: function(c, a) {
                return Mod.ccall('Z3_algebraic_is_neg', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            algebraic_is_zero: function(c, a) {
                return Mod.ccall('Z3_algebraic_is_zero', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            algebraic_sign: Mod._Z3_algebraic_sign,
            algebraic_add: Mod._Z3_algebraic_add,
            algebraic_sub: Mod._Z3_algebraic_sub,
            algebraic_mul: Mod._Z3_algebraic_mul,
            algebraic_div: Mod._Z3_algebraic_div,
            algebraic_root: Mod._Z3_algebraic_root,
            algebraic_power: Mod._Z3_algebraic_power,
            algebraic_lt: function(c, a, b) {
                return Mod.ccall('Z3_algebraic_lt', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            algebraic_gt: function(c, a, b) {
                return Mod.ccall('Z3_algebraic_gt', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            algebraic_le: function(c, a, b) {
                return Mod.ccall('Z3_algebraic_le', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            algebraic_ge: function(c, a, b) {
                return Mod.ccall('Z3_algebraic_ge', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            algebraic_eq: function(c, a, b) {
                return Mod.ccall('Z3_algebraic_eq', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            algebraic_neq: function(c, a, b) {
                return Mod.ccall('Z3_algebraic_neq', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            algebraic_roots: async function(c, p, a) {
                const a_ptr = Mod._malloc(a.length * 4);
                Mod.HEAPU32.set(a, a_ptr / 4);
                try {
                    let ret = await Mod.async_call(()=>Mod.ccall('async_Z3_algebraic_roots', 'void', [
                            'number',
                            'number',
                            'number',
                            'number'
                        ], [
                            c,
                            p,
                            a.length,
                            a_ptr
                        ]));
                    return ret;
                } finally{
                    Mod._free(a_ptr);
                }
            },
            algebraic_eval: async function(c, p, a) {
                const a_ptr = Mod._malloc(a.length * 4);
                Mod.HEAPU32.set(a, a_ptr / 4);
                try {
                    let ret = await Mod.async_call(()=>Mod.ccall('async_Z3_algebraic_eval', 'void', [
                            'number',
                            'number',
                            'number',
                            'number'
                        ], [
                            c,
                            p,
                            a.length,
                            a_ptr
                        ]));
                    return ret;
                } finally{
                    Mod._free(a_ptr);
                }
            },
            algebraic_get_poly: Mod._Z3_algebraic_get_poly,
            algebraic_get_i: function(c, a) {
                let ret = Mod.ccall('Z3_algebraic_get_i', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            mk_ast_vector: Mod._Z3_mk_ast_vector,
            ast_vector_inc_ref: Mod._Z3_ast_vector_inc_ref,
            ast_vector_dec_ref: Mod._Z3_ast_vector_dec_ref,
            ast_vector_size: function(c, v) {
                let ret = Mod.ccall('Z3_ast_vector_size', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    v
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            ast_vector_get: Mod._Z3_ast_vector_get,
            ast_vector_set: Mod._Z3_ast_vector_set,
            ast_vector_resize: Mod._Z3_ast_vector_resize,
            ast_vector_push: Mod._Z3_ast_vector_push,
            ast_vector_translate: Mod._Z3_ast_vector_translate,
            ast_vector_to_string: function(c, v) {
                return Mod.ccall('Z3_ast_vector_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    v
                ]);
            },
            mk_ast_map: Mod._Z3_mk_ast_map,
            ast_map_inc_ref: Mod._Z3_ast_map_inc_ref,
            ast_map_dec_ref: Mod._Z3_ast_map_dec_ref,
            ast_map_contains: function(c, m, k) {
                return Mod.ccall('Z3_ast_map_contains', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    m,
                    k
                ]);
            },
            ast_map_find: Mod._Z3_ast_map_find,
            ast_map_insert: Mod._Z3_ast_map_insert,
            ast_map_erase: Mod._Z3_ast_map_erase,
            ast_map_reset: Mod._Z3_ast_map_reset,
            ast_map_size: function(c, m) {
                let ret = Mod.ccall('Z3_ast_map_size', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    m
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            ast_map_keys: Mod._Z3_ast_map_keys,
            ast_map_to_string: function(c, m) {
                return Mod.ccall('Z3_ast_map_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    m
                ]);
            },
            mk_fixedpoint: Mod._Z3_mk_fixedpoint,
            fixedpoint_inc_ref: Mod._Z3_fixedpoint_inc_ref,
            fixedpoint_dec_ref: Mod._Z3_fixedpoint_dec_ref,
            fixedpoint_add_rule: Mod._Z3_fixedpoint_add_rule,
            fixedpoint_add_fact: function(c, d, r, args) {
                return Mod.ccall('Z3_fixedpoint_add_fact', 'void', [
                    'number',
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    d,
                    r,
                    args.length,
                    intArrayToByteArr(args)
                ]);
            },
            fixedpoint_assert: Mod._Z3_fixedpoint_assert,
            fixedpoint_query: function(c, d, query) {
                return Mod.async_call(Mod._async_Z3_fixedpoint_query, c, d, query);
            },
            fixedpoint_query_relations: async function(c, d, relations) {
                const relations_ptr = Mod._malloc(relations.length * 4);
                Mod.HEAPU32.set(relations, relations_ptr / 4);
                try {
                    let ret = await Mod.async_call(()=>Mod.ccall('async_Z3_fixedpoint_query_relations', 'void', [
                            'number',
                            'number',
                            'number',
                            'number'
                        ], [
                            c,
                            d,
                            relations.length,
                            relations_ptr
                        ]));
                    return ret;
                } finally{
                    Mod._free(relations_ptr);
                }
            },
            fixedpoint_get_answer: Mod._Z3_fixedpoint_get_answer,
            fixedpoint_get_reason_unknown: function(c, d) {
                return Mod.ccall('Z3_fixedpoint_get_reason_unknown', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    d
                ]);
            },
            fixedpoint_update_rule: Mod._Z3_fixedpoint_update_rule,
            fixedpoint_get_num_levels: function(c, d, pred) {
                let ret = Mod.ccall('Z3_fixedpoint_get_num_levels', 'number', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    d,
                    pred
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            fixedpoint_get_cover_delta: Mod._Z3_fixedpoint_get_cover_delta,
            fixedpoint_add_cover: Mod._Z3_fixedpoint_add_cover,
            fixedpoint_get_statistics: Mod._Z3_fixedpoint_get_statistics,
            fixedpoint_register_relation: Mod._Z3_fixedpoint_register_relation,
            fixedpoint_set_predicate_representation: function(c, d, f, relation_kinds) {
                return Mod.ccall('Z3_fixedpoint_set_predicate_representation', 'void', [
                    'number',
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    d,
                    f,
                    relation_kinds.length,
                    intArrayToByteArr(relation_kinds)
                ]);
            },
            fixedpoint_get_rules: Mod._Z3_fixedpoint_get_rules,
            fixedpoint_get_assertions: Mod._Z3_fixedpoint_get_assertions,
            fixedpoint_set_params: Mod._Z3_fixedpoint_set_params,
            fixedpoint_get_help: function(c, f) {
                return Mod.ccall('Z3_fixedpoint_get_help', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    f
                ]);
            },
            fixedpoint_get_param_descrs: Mod._Z3_fixedpoint_get_param_descrs,
            fixedpoint_to_string: function(c, f, queries) {
                return Mod.ccall('Z3_fixedpoint_to_string', 'string', [
                    'number',
                    'number',
                    'number',
                    'array'
                ], [
                    c,
                    f,
                    queries.length,
                    intArrayToByteArr(queries)
                ]);
            },
            fixedpoint_from_string: function(c, f, s) {
                return Mod.ccall('Z3_fixedpoint_from_string', 'number', [
                    'number',
                    'number',
                    'string'
                ], [
                    c,
                    f,
                    s
                ]);
            },
            fixedpoint_from_file: function(c, f, s) {
                return Mod.ccall('Z3_fixedpoint_from_file', 'number', [
                    'number',
                    'number',
                    'string'
                ], [
                    c,
                    f,
                    s
                ]);
            },
            mk_fpa_rounding_mode_sort: Mod._Z3_mk_fpa_rounding_mode_sort,
            mk_fpa_round_nearest_ties_to_even: Mod._Z3_mk_fpa_round_nearest_ties_to_even,
            mk_fpa_rne: Mod._Z3_mk_fpa_rne,
            mk_fpa_round_nearest_ties_to_away: Mod._Z3_mk_fpa_round_nearest_ties_to_away,
            mk_fpa_rna: Mod._Z3_mk_fpa_rna,
            mk_fpa_round_toward_positive: Mod._Z3_mk_fpa_round_toward_positive,
            mk_fpa_rtp: Mod._Z3_mk_fpa_rtp,
            mk_fpa_round_toward_negative: Mod._Z3_mk_fpa_round_toward_negative,
            mk_fpa_rtn: Mod._Z3_mk_fpa_rtn,
            mk_fpa_round_toward_zero: Mod._Z3_mk_fpa_round_toward_zero,
            mk_fpa_rtz: Mod._Z3_mk_fpa_rtz,
            mk_fpa_sort: Mod._Z3_mk_fpa_sort,
            mk_fpa_sort_half: Mod._Z3_mk_fpa_sort_half,
            mk_fpa_sort_16: Mod._Z3_mk_fpa_sort_16,
            mk_fpa_sort_single: Mod._Z3_mk_fpa_sort_single,
            mk_fpa_sort_32: Mod._Z3_mk_fpa_sort_32,
            mk_fpa_sort_double: Mod._Z3_mk_fpa_sort_double,
            mk_fpa_sort_64: Mod._Z3_mk_fpa_sort_64,
            mk_fpa_sort_quadruple: Mod._Z3_mk_fpa_sort_quadruple,
            mk_fpa_sort_128: Mod._Z3_mk_fpa_sort_128,
            mk_fpa_nan: Mod._Z3_mk_fpa_nan,
            mk_fpa_inf: Mod._Z3_mk_fpa_inf,
            mk_fpa_zero: Mod._Z3_mk_fpa_zero,
            mk_fpa_fp: Mod._Z3_mk_fpa_fp,
            mk_fpa_numeral_float: Mod._Z3_mk_fpa_numeral_float,
            mk_fpa_numeral_double: Mod._Z3_mk_fpa_numeral_double,
            mk_fpa_numeral_int: Mod._Z3_mk_fpa_numeral_int,
            mk_fpa_numeral_int_uint: Mod._Z3_mk_fpa_numeral_int_uint,
            mk_fpa_numeral_int64_uint64: Mod._Z3_mk_fpa_numeral_int64_uint64,
            mk_fpa_abs: Mod._Z3_mk_fpa_abs,
            mk_fpa_neg: Mod._Z3_mk_fpa_neg,
            mk_fpa_add: Mod._Z3_mk_fpa_add,
            mk_fpa_sub: Mod._Z3_mk_fpa_sub,
            mk_fpa_mul: Mod._Z3_mk_fpa_mul,
            mk_fpa_div: Mod._Z3_mk_fpa_div,
            mk_fpa_fma: Mod._Z3_mk_fpa_fma,
            mk_fpa_sqrt: Mod._Z3_mk_fpa_sqrt,
            mk_fpa_rem: Mod._Z3_mk_fpa_rem,
            mk_fpa_round_to_integral: Mod._Z3_mk_fpa_round_to_integral,
            mk_fpa_min: Mod._Z3_mk_fpa_min,
            mk_fpa_max: Mod._Z3_mk_fpa_max,
            mk_fpa_leq: Mod._Z3_mk_fpa_leq,
            mk_fpa_lt: Mod._Z3_mk_fpa_lt,
            mk_fpa_geq: Mod._Z3_mk_fpa_geq,
            mk_fpa_gt: Mod._Z3_mk_fpa_gt,
            mk_fpa_eq: Mod._Z3_mk_fpa_eq,
            mk_fpa_is_normal: Mod._Z3_mk_fpa_is_normal,
            mk_fpa_is_subnormal: Mod._Z3_mk_fpa_is_subnormal,
            mk_fpa_is_zero: Mod._Z3_mk_fpa_is_zero,
            mk_fpa_is_infinite: Mod._Z3_mk_fpa_is_infinite,
            mk_fpa_is_nan: Mod._Z3_mk_fpa_is_nan,
            mk_fpa_is_negative: Mod._Z3_mk_fpa_is_negative,
            mk_fpa_is_positive: Mod._Z3_mk_fpa_is_positive,
            mk_fpa_to_fp_bv: Mod._Z3_mk_fpa_to_fp_bv,
            mk_fpa_to_fp_float: Mod._Z3_mk_fpa_to_fp_float,
            mk_fpa_to_fp_real: Mod._Z3_mk_fpa_to_fp_real,
            mk_fpa_to_fp_signed: Mod._Z3_mk_fpa_to_fp_signed,
            mk_fpa_to_fp_unsigned: Mod._Z3_mk_fpa_to_fp_unsigned,
            mk_fpa_to_ubv: Mod._Z3_mk_fpa_to_ubv,
            mk_fpa_to_sbv: Mod._Z3_mk_fpa_to_sbv,
            mk_fpa_to_real: Mod._Z3_mk_fpa_to_real,
            fpa_get_ebits: function(c, s) {
                let ret = Mod.ccall('Z3_fpa_get_ebits', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            fpa_get_sbits: function(c, s) {
                let ret = Mod.ccall('Z3_fpa_get_sbits', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    s
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            fpa_is_numeral: function(c, t) {
                return Mod.ccall('Z3_fpa_is_numeral', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            fpa_is_numeral_nan: function(c, t) {
                return Mod.ccall('Z3_fpa_is_numeral_nan', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            fpa_is_numeral_inf: function(c, t) {
                return Mod.ccall('Z3_fpa_is_numeral_inf', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            fpa_is_numeral_zero: function(c, t) {
                return Mod.ccall('Z3_fpa_is_numeral_zero', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            fpa_is_numeral_normal: function(c, t) {
                return Mod.ccall('Z3_fpa_is_numeral_normal', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            fpa_is_numeral_subnormal: function(c, t) {
                return Mod.ccall('Z3_fpa_is_numeral_subnormal', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            fpa_is_numeral_positive: function(c, t) {
                return Mod.ccall('Z3_fpa_is_numeral_positive', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            fpa_is_numeral_negative: function(c, t) {
                return Mod.ccall('Z3_fpa_is_numeral_negative', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            fpa_get_numeral_sign_bv: Mod._Z3_fpa_get_numeral_sign_bv,
            fpa_get_numeral_significand_bv: Mod._Z3_fpa_get_numeral_significand_bv,
            fpa_get_numeral_significand_string: function(c, t) {
                return Mod.ccall('Z3_fpa_get_numeral_significand_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            fpa_get_numeral_significand_uint64: function(c, t) {
                let ret = Mod.ccall('Z3_fpa_get_numeral_significand_uint64', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    t,
                    outAddress
                ]);
                if (!ret) return null;
                return getOutUint64(0);
            },
            fpa_get_numeral_exponent_string: function(c, t, biased) {
                return Mod.ccall('Z3_fpa_get_numeral_exponent_string', 'string', [
                    'number',
                    'number',
                    'boolean'
                ], [
                    c,
                    t,
                    biased
                ]);
            },
            fpa_get_numeral_exponent_int64: function(c, t, biased) {
                let ret = Mod.ccall('Z3_fpa_get_numeral_exponent_int64', 'boolean', [
                    'number',
                    'number',
                    'number',
                    'boolean'
                ], [
                    c,
                    t,
                    outAddress,
                    biased
                ]);
                if (!ret) return null;
                return getOutInt64(0);
            },
            fpa_get_numeral_exponent_bv: Mod._Z3_fpa_get_numeral_exponent_bv,
            mk_fpa_to_ieee_bv: Mod._Z3_mk_fpa_to_ieee_bv,
            mk_fpa_to_fp_int_real: Mod._Z3_mk_fpa_to_fp_int_real,
            mk_optimize: Mod._Z3_mk_optimize,
            optimize_inc_ref: Mod._Z3_optimize_inc_ref,
            optimize_dec_ref: Mod._Z3_optimize_dec_ref,
            optimize_assert: Mod._Z3_optimize_assert,
            optimize_assert_and_track: Mod._Z3_optimize_assert_and_track,
            optimize_assert_soft: function(c, o, a, weight, id) {
                let ret = Mod.ccall('Z3_optimize_assert_soft', 'number', [
                    'number',
                    'number',
                    'number',
                    'string',
                    'number'
                ], [
                    c,
                    o,
                    a,
                    weight,
                    id
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            optimize_maximize: function(c, o, t) {
                let ret = Mod.ccall('Z3_optimize_maximize', 'number', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    o,
                    t
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            optimize_minimize: function(c, o, t) {
                let ret = Mod.ccall('Z3_optimize_minimize', 'number', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    o,
                    t
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            optimize_push: Mod._Z3_optimize_push,
            optimize_pop: Mod._Z3_optimize_pop,
            optimize_set_initial_value: Mod._Z3_optimize_set_initial_value,
            optimize_check: async function(c, o, assumptions) {
                const assumptions_ptr = Mod._malloc(assumptions.length * 4);
                Mod.HEAPU32.set(assumptions, assumptions_ptr / 4);
                try {
                    let ret = await Mod.async_call(()=>Mod.ccall('async_Z3_optimize_check', 'void', [
                            'number',
                            'number',
                            'number',
                            'number'
                        ], [
                            c,
                            o,
                            assumptions.length,
                            assumptions_ptr
                        ]));
                    return ret;
                } finally{
                    Mod._free(assumptions_ptr);
                }
            },
            optimize_get_reason_unknown: function(c, d) {
                return Mod.ccall('Z3_optimize_get_reason_unknown', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    d
                ]);
            },
            optimize_get_model: Mod._Z3_optimize_get_model,
            optimize_get_unsat_core: Mod._Z3_optimize_get_unsat_core,
            optimize_set_params: Mod._Z3_optimize_set_params,
            optimize_get_param_descrs: Mod._Z3_optimize_get_param_descrs,
            optimize_get_lower: Mod._Z3_optimize_get_lower,
            optimize_get_upper: Mod._Z3_optimize_get_upper,
            optimize_get_lower_as_vector: Mod._Z3_optimize_get_lower_as_vector,
            optimize_get_upper_as_vector: Mod._Z3_optimize_get_upper_as_vector,
            optimize_to_string: function(c, o) {
                return Mod.ccall('Z3_optimize_to_string', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    o
                ]);
            },
            optimize_from_string: function(c, o, s) {
                return Mod.ccall('Z3_optimize_from_string', 'void', [
                    'number',
                    'number',
                    'string'
                ], [
                    c,
                    o,
                    s
                ]);
            },
            optimize_from_file: function(c, o, s) {
                return Mod.ccall('Z3_optimize_from_file', 'void', [
                    'number',
                    'number',
                    'string'
                ], [
                    c,
                    o,
                    s
                ]);
            },
            optimize_get_help: function(c, t) {
                return Mod.ccall('Z3_optimize_get_help', 'string', [
                    'number',
                    'number'
                ], [
                    c,
                    t
                ]);
            },
            optimize_get_statistics: Mod._Z3_optimize_get_statistics,
            optimize_get_assertions: Mod._Z3_optimize_get_assertions,
            optimize_get_objectives: Mod._Z3_optimize_get_objectives,
            optimize_translate: Mod._Z3_optimize_translate,
            polynomial_subresultants: function(c, p, q, x) {
                return Mod.async_call(Mod._async_Z3_polynomial_subresultants, c, p, q, x);
            },
            rcf_del: Mod._Z3_rcf_del,
            rcf_mk_rational: function(c, val) {
                return Mod.ccall('Z3_rcf_mk_rational', 'number', [
                    'number',
                    'string'
                ], [
                    c,
                    val
                ]);
            },
            rcf_mk_small_int: Mod._Z3_rcf_mk_small_int,
            rcf_mk_pi: Mod._Z3_rcf_mk_pi,
            rcf_mk_e: Mod._Z3_rcf_mk_e,
            rcf_mk_infinitesimal: Mod._Z3_rcf_mk_infinitesimal,
            rcf_mk_roots: function(c, a) {
                let outArray_roots = Mod._malloc(4 * a.length);
                try {
                    let ret = Mod.ccall('Z3_rcf_mk_roots', 'number', [
                        'number',
                        'number',
                        'array',
                        'number'
                    ], [
                        c,
                        a.length,
                        intArrayToByteArr(a),
                        outArray_roots
                    ]);
                    ret = new Uint32Array([
                        ret
                    ])[0];
                    return {
                        rv: ret,
                        roots: readUintArray(outArray_roots, a.length)
                    };
                } finally{
                    Mod._free(outArray_roots);
                }
            },
            rcf_add: Mod._Z3_rcf_add,
            rcf_sub: Mod._Z3_rcf_sub,
            rcf_mul: Mod._Z3_rcf_mul,
            rcf_div: Mod._Z3_rcf_div,
            rcf_neg: Mod._Z3_rcf_neg,
            rcf_inv: Mod._Z3_rcf_inv,
            rcf_power: Mod._Z3_rcf_power,
            rcf_lt: function(c, a, b) {
                return Mod.ccall('Z3_rcf_lt', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            rcf_gt: function(c, a, b) {
                return Mod.ccall('Z3_rcf_gt', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            rcf_le: function(c, a, b) {
                return Mod.ccall('Z3_rcf_le', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            rcf_ge: function(c, a, b) {
                return Mod.ccall('Z3_rcf_ge', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            rcf_eq: function(c, a, b) {
                return Mod.ccall('Z3_rcf_eq', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            rcf_neq: function(c, a, b) {
                return Mod.ccall('Z3_rcf_neq', 'boolean', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    b
                ]);
            },
            rcf_num_to_string: function(c, a, compact, html) {
                return Mod.ccall('Z3_rcf_num_to_string', 'string', [
                    'number',
                    'number',
                    'boolean',
                    'boolean'
                ], [
                    c,
                    a,
                    compact,
                    html
                ]);
            },
            rcf_num_to_decimal_string: function(c, a, prec) {
                return Mod.ccall('Z3_rcf_num_to_decimal_string', 'string', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    prec
                ]);
            },
            rcf_get_numerator_denominator: function(c, a) {
                let ret = Mod.ccall('Z3_rcf_get_numerator_denominator', 'void', [
                    'number',
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    outAddress,
                    outAddress + 4
                ]);
                return {
                    n: getOutUint(0),
                    d: getOutUint(1)
                };
            },
            rcf_is_rational: function(c, a) {
                return Mod.ccall('Z3_rcf_is_rational', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            rcf_is_algebraic: function(c, a) {
                return Mod.ccall('Z3_rcf_is_algebraic', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            rcf_is_infinitesimal: function(c, a) {
                return Mod.ccall('Z3_rcf_is_infinitesimal', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            rcf_is_transcendental: function(c, a) {
                return Mod.ccall('Z3_rcf_is_transcendental', 'boolean', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
            },
            rcf_extension_index: function(c, a) {
                let ret = Mod.ccall('Z3_rcf_extension_index', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            rcf_transcendental_name: Mod._Z3_rcf_transcendental_name,
            rcf_infinitesimal_name: Mod._Z3_rcf_infinitesimal_name,
            rcf_num_coefficients: function(c, a) {
                let ret = Mod.ccall('Z3_rcf_num_coefficients', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            rcf_coefficient: Mod._Z3_rcf_coefficient,
            rcf_num_sign_conditions: function(c, a) {
                let ret = Mod.ccall('Z3_rcf_num_sign_conditions', 'number', [
                    'number',
                    'number'
                ], [
                    c,
                    a
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            rcf_sign_condition_sign: Mod._Z3_rcf_sign_condition_sign,
            rcf_num_sign_condition_coefficients: function(c, a, i) {
                let ret = Mod.ccall('Z3_rcf_num_sign_condition_coefficients', 'number', [
                    'number',
                    'number',
                    'number'
                ], [
                    c,
                    a,
                    i
                ]);
                ret = new Uint32Array([
                    ret
                ])[0];
                return ret;
            },
            rcf_sign_condition_coefficient: Mod._Z3_rcf_sign_condition_coefficient,
            fixedpoint_query_from_lvl: function(c, d, query, lvl) {
                return Mod.async_call(Mod._async_Z3_fixedpoint_query_from_lvl, c, d, query, lvl);
            },
            fixedpoint_get_ground_sat_answer: Mod._Z3_fixedpoint_get_ground_sat_answer,
            fixedpoint_get_rules_along_trace: Mod._Z3_fixedpoint_get_rules_along_trace,
            fixedpoint_get_rule_names_along_trace: Mod._Z3_fixedpoint_get_rule_names_along_trace,
            fixedpoint_add_invariant: Mod._Z3_fixedpoint_add_invariant,
            fixedpoint_get_reachable: Mod._Z3_fixedpoint_get_reachable,
            qe_model_project: function(c, m, bound, body) {
                return Mod.ccall('Z3_qe_model_project', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number'
                ], [
                    c,
                    m,
                    bound.length,
                    intArrayToByteArr(bound),
                    body
                ]);
            },
            qe_model_project_skolem: function(c, m, bound, body, map) {
                return Mod.ccall('Z3_qe_model_project_skolem', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'number'
                ], [
                    c,
                    m,
                    bound.length,
                    intArrayToByteArr(bound),
                    body,
                    map
                ]);
            },
            qe_model_project_with_witness: function(c, m, bound, body, map) {
                return Mod.ccall('Z3_qe_model_project_with_witness', 'number', [
                    'number',
                    'number',
                    'number',
                    'array',
                    'number',
                    'number'
                ], [
                    c,
                    m,
                    bound.length,
                    intArrayToByteArr(bound),
                    body,
                    map
                ]);
            },
            model_extrapolate: Mod._Z3_model_extrapolate,
            qe_lite: Mod._Z3_qe_lite
        }
    };
}

});


parcelRegister("jM2ZR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Z3AssertionError = module.exports.Z3Error = void 0;
/**
 * Used to create a Real constant
 *
 * ```typescript
 * const x = from({ numerator: 1, denominator: 3 })
 *
 * x
 * // 1/3
 * isReal(x)
 * // true
 * isRealVal(x)
 * // true
 * x.asNumber()
 * // 0.3333333333333333
 * ```
 * @see {@link Context.from}
 * @category Global
 */ class $e654d31fdea62468$var$Z3Error extends Error {
}
module.exports.Z3Error = $e654d31fdea62468$var$Z3Error;
class $e654d31fdea62468$var$Z3AssertionError extends $e654d31fdea62468$var$Z3Error {
}
module.exports.Z3AssertionError = $e654d31fdea62468$var$Z3AssertionError;

});

parcelRegister("kbizf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertExhaustive = $eb133cd7a8c249ec$var$assertExhaustive;
module.exports.assert = $eb133cd7a8c249ec$var$assert;
module.exports.allSatisfy = $eb133cd7a8c249ec$var$allSatisfy;

var $jM2ZR = parcelRequire("jM2ZR");
function $eb133cd7a8c249ec$var$getAllProperties(obj) {
    const properties = new Set();
    do for (const key of Reflect.ownKeys(obj))properties.add([
        obj,
        key
    ]);
    while ((obj = Reflect.getPrototypeOf(obj)) && obj !== Object.prototype);
    return properties;
}
/**
 * Use to ensure that switches are checked to be exhaustive at compile time
 *
 * @example Basic usage
 * ```typescript
 * enum Something {
 *  left,
 *  right,
 * };
 * const something = getSomething();
 * switch (something) {
 *  case Something.left:
 *    ...
 *  case Something.right:
 *    ...
 *  default:
 *    assertExhaustive(something);
 * }
 * ```
 *
 * @param x - The param on which the switch operates
 */ function $eb133cd7a8c249ec$var$assertExhaustive(x) {
    throw new Error('Unexpected code execution detected, should be caught at compile time');
}
function $eb133cd7a8c249ec$var$assert(condition, reason) {
    if (!condition) throw new $jM2ZR.Z3AssertionError(reason ?? 'Assertion failed');
}
/**
 * Check the all elements of a `collection` satisfy the `premise`.
 * If any of the items fail the `premise`, returns false;
 * @returns null if the `collection` is empty, boolean otherwise
 */ function $eb133cd7a8c249ec$var$allSatisfy(collection, premise) {
    let hasItems = false;
    for (const arg of collection){
        hasItems = true;
        if (!premise(arg)) return false;
    }
    return hasItems === true ? true : null;
}

});


var $7c1425af8460dd7a$exports = {};
$parcel$extendImportMap({
    "9UtJ4": "worker.a9dfe4ea.js"
});

// These are filled with ranges (rangeFrom[i] up to but not including
// rangeTo[i]) of code points that count as extending characters.
let $c24c0e3988234eca$var$rangeFrom = [], $c24c0e3988234eca$var$rangeTo = [];
(()=>{
    // Compressed representation of the Grapheme_Cluster_Break=Extend
    // information from
    // http://www.unicode.org/Public/16.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
    // Each pair of elements represents a range, as an offet from the
    // previous range and a length. Numbers are in base-36, with the empty
    // string being a shorthand for 1.
    let numbers = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
    for(let i = 0, n = 0; i < numbers.length; i++)(i % 2 ? $c24c0e3988234eca$var$rangeTo : $c24c0e3988234eca$var$rangeFrom).push(n = n + numbers[i]);
})();
function $c24c0e3988234eca$export$5ff7ae0b7231f50b(code) {
    if (code < 768) return false;
    for(let from = 0, to = $c24c0e3988234eca$var$rangeFrom.length;;){
        let mid = from + to >> 1;
        if (code < $c24c0e3988234eca$var$rangeFrom[mid]) to = mid;
        else if (code >= $c24c0e3988234eca$var$rangeTo[mid]) from = mid + 1;
        else return true;
        if (from == to) return false;
    }
}
function $c24c0e3988234eca$var$isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
function $c24c0e3988234eca$var$check(code) {
    for(let i = 0; i < $c24c0e3988234eca$var$rangeFrom.length; i++){
        if ($c24c0e3988234eca$var$rangeTo[i] > code) return $c24c0e3988234eca$var$rangeFrom[i] <= code;
    }
    return false;
}
const $c24c0e3988234eca$var$ZWJ = 0x200d;
function $c24c0e3988234eca$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (forward ? $c24c0e3988234eca$var$nextClusterBreak : $c24c0e3988234eca$var$prevClusterBreak)(str, pos, includeExtending);
}
function $c24c0e3988234eca$var$nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && $c24c0e3988234eca$var$surrogateLow(str.charCodeAt(pos)) && $c24c0e3988234eca$var$surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    let prev = $c24c0e3988234eca$var$codePointAt(str, pos);
    pos += $c24c0e3988234eca$var$codePointSize(prev);
    while(pos < str.length){
        let next = $c24c0e3988234eca$var$codePointAt(str, pos);
        if (prev == $c24c0e3988234eca$var$ZWJ || next == $c24c0e3988234eca$var$ZWJ || includeExtending && $c24c0e3988234eca$export$5ff7ae0b7231f50b(next)) {
            pos += $c24c0e3988234eca$var$codePointSize(next);
            prev = next;
        } else if ($c24c0e3988234eca$var$isRegionalIndicator(next)) {
            let countBefore = 0, i = pos - 2;
            while(i >= 0 && $c24c0e3988234eca$var$isRegionalIndicator($c24c0e3988234eca$var$codePointAt(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function $c24c0e3988234eca$var$prevClusterBreak(str, pos, includeExtending) {
    while(pos > 1){
        let found = $c24c0e3988234eca$var$nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function $c24c0e3988234eca$var$codePointAt(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$c24c0e3988234eca$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$c24c0e3988234eca$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
function $c24c0e3988234eca$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $c24c0e3988234eca$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
function $c24c0e3988234eca$var$codePointSize(code) {
    return code < 0x10000 ? 1 : 2;
}


/**
The data structure for documents. @nonabstract
*/ class $3ef527dddcdea745$export$5f1af8db9871e1d6 {
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        [from, to] = $3ef527dddcdea745$var$clip(this, from, to);
        let parts = [];
        this.decompose(0, from, parts, 2 /* Open.To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* Open.To */ );
        this.decompose(to, this.length, parts, 1 /* Open.From */ );
        return $3ef527dddcdea745$var$TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from, to = this.length) {
        [from, to] = $3ef527dddcdea745$var$clip(this, from, to);
        let parts = [];
        this.decompose(from, to, parts, 0);
        return $3ef527dddcdea745$var$TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        let a = new $3ef527dddcdea745$var$RawTextCursor(this), b = new $3ef527dddcdea745$var$RawTextCursor(other);
        for(let skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter(dir = 1) {
        return new $3ef527dddcdea745$var$RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from, to = this.length) {
        return new $3ef527dddcdea745$var$PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        let inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            let start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new $3ef527dddcdea745$var$LineCursor(inner);
    }
    /**
    Return the document as a string, using newline characters to
    separate lines.
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        let lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    @internal
    */ constructor(){}
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return $3ef527dddcdea745$export$5f1af8db9871e1d6.empty;
        return text.length <= 32 /* Tree.Branch */  ? new $3ef527dddcdea745$var$TextLeaf(text) : $3ef527dddcdea745$var$TextNode.from($3ef527dddcdea745$var$TextLeaf.split(text, []));
    }
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class $3ef527dddcdea745$var$TextLeaf extends $3ef527dddcdea745$export$5f1af8db9871e1d6 {
    constructor(text, length = $3ef527dddcdea745$var$textLength(text)){
        super();
        this.text = text;
        this.length = length;
    }
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new $3ef527dddcdea745$export$17d680238e50603e(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        let text = from <= 0 && to >= this.length ? this : new $3ef527dddcdea745$var$TextLeaf($3ef527dddcdea745$var$sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* Open.From */ ) {
            let prev = target.pop();
            let joined = $3ef527dddcdea745$var$appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Tree.Branch */ ) target.push(new $3ef527dddcdea745$var$TextLeaf(joined, prev.length + text.length));
            else {
                let mid = joined.length >> 1;
                target.push(new $3ef527dddcdea745$var$TextLeaf(joined.slice(0, mid)), new $3ef527dddcdea745$var$TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof $3ef527dddcdea745$var$TextLeaf)) return super.replace(from, to, text);
        [from, to] = $3ef527dddcdea745$var$clip(this, from, to);
        let lines = $3ef527dddcdea745$var$appendText(this.text, $3ef527dddcdea745$var$appendText(text.text, $3ef527dddcdea745$var$sliceText(this.text, 0, from)), to);
        let newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Tree.Branch */ ) return new $3ef527dddcdea745$var$TextLeaf(lines, newLen);
        return $3ef527dddcdea745$var$TextNode.from($3ef527dddcdea745$var$TextLeaf.split(lines, []), newLen);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $3ef527dddcdea745$var$clip(this, from, to);
        let result = "";
        for(let pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            let line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let line of this.text)target.push(line);
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        let part = [], len = -1;
        for (let line of text){
            part.push(line);
            len += line.length + 1;
            if (part.length == 32 /* Tree.Branch */ ) {
                target.push(new $3ef527dddcdea745$var$TextLeaf(part, len));
                part = [];
                len = -1;
            }
        }
        if (len > -1) target.push(new $3ef527dddcdea745$var$TextLeaf(part, len));
        return target;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class $3ef527dddcdea745$var$TextNode extends $3ef527dddcdea745$export$5f1af8db9871e1d6 {
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        for (let child of children)this.lines += child.lines;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(let i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                let childOpen = open & ((pos <= from ? 1 /* Open.From */  : 0) | (end >= to ? 2 /* Open.To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        [from, to] = $3ef527dddcdea745$var$clip(this, from, to);
        if (text.lines < this.lines) for(let i = 0, pos = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                let updated = child.replace(from - pos, to - pos, text);
                let totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    let copy = this.children.slice();
                    copy[i] = updated;
                    return new $3ef527dddcdea745$var$TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $3ef527dddcdea745$var$clip(this, from, to);
        let result = "";
        for(let i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let child of this.children)child.flatten(target);
    }
    scanIdentical(other, dir) {
        if (!(other instanceof $3ef527dddcdea745$var$TextNode)) return 0;
        let length = 0;
        let [iA, iB, eA, eB] = dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            let chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children, length = children.reduce((l, ch)=>l + ch.length + 1, -1)) {
        let lines = 0;
        for (let ch of children)lines += ch.lines;
        if (lines < 32 /* Tree.Branch */ ) {
            let flat = [];
            for (let ch of children)ch.flatten(flat);
            return new $3ef527dddcdea745$var$TextLeaf(flat, length);
        }
        let chunk = Math.max(32 /* Tree.Branch */ , lines >> 5 /* Tree.BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            let last;
            if (child.lines > maxChunk && child instanceof $3ef527dddcdea745$var$TextNode) for (let node of child.children)add(node);
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof $3ef527dddcdea745$var$TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof $3ef527dddcdea745$var$TextLeaf && child.lines + last.lines <= 32 /* Tree.Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new $3ef527dddcdea745$var$TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : $3ef527dddcdea745$var$TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        for (let child of children)add(child);
        flush();
        return chunked.length == 1 ? chunked[0] : new $3ef527dddcdea745$var$TextNode(chunked, length);
    }
}
$3ef527dddcdea745$export$5f1af8db9871e1d6.empty = /*@__PURE__*/ new $3ef527dddcdea745$var$TextLeaf([
    ""
], 0);
function $3ef527dddcdea745$var$textLength(text) {
    let length = -1;
    for (let line of text)length += line.length + 1;
    return length;
}
function $3ef527dddcdea745$var$appendText(text, target, from = 0, to = 1e9) {
    for(let pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        let line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function $3ef527dddcdea745$var$sliceText(text, from, to) {
    return $3ef527dddcdea745$var$appendText(text, [
        ""
    ], from, to);
}
class $3ef527dddcdea745$var$RawTextCursor {
    constructor(text, dir = 1){
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof $3ef527dddcdea745$var$TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            let last = this.nodes.length - 1;
            let top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            let size = top instanceof $3ef527dddcdea745$var$TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof $3ef527dddcdea745$var$TextLeaf) {
                // Move to the next string
                let next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                let next = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next.length) {
                    skip -= next.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next);
                    this.offsets.push(dir > 0 ? 1 : (next instanceof $3ef527dddcdea745$var$TextLeaf ? next.text.length : next.children.length) << 1);
                }
            }
        }
    }
    next(skip = 0) {
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
}
class $3ef527dddcdea745$var$PartialTextCursor {
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new $3ef527dddcdea745$var$RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        let { value: value } = this.cursor.next(skip);
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next(skip = 0) {
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
}
class $3ef527dddcdea745$var$LineCursor {
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
    next(skip = 0) {
        let { done: done, lineBreak: lineBreak, value: value } = this.inner.next(skip);
        if (done && this.afterBreak) {
            this.value = "";
            this.afterBreak = false;
        } else if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
}
if (typeof Symbol != "undefined") {
    $3ef527dddcdea745$export$5f1af8db9871e1d6.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    $3ef527dddcdea745$var$RawTextCursor.prototype[Symbol.iterator] = $3ef527dddcdea745$var$PartialTextCursor.prototype[Symbol.iterator] = $3ef527dddcdea745$var$LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class $3ef527dddcdea745$export$17d680238e50603e {
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
}
function $3ef527dddcdea745$var$clip(text, from, to) {
    from = Math.max(0, Math.min(text.length, from));
    return [
        from,
        Math.max(from, Math.min(text.length, to))
    ];
}
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function $3ef527dddcdea745$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (0, $c24c0e3988234eca$export$a0fa439fd515e1ed)(str, pos, forward, includeExtending);
}
function $3ef527dddcdea745$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $3ef527dddcdea745$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function $3ef527dddcdea745$export$42977f40461e1360(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$3ef527dddcdea745$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$3ef527dddcdea745$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function $3ef527dddcdea745$export$73bfc63873071f74(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The amount of positions a character takes up in a JavaScript string.
*/ function $3ef527dddcdea745$export$a870abf234f6353c(code) {
    return code < 0x10000 ? 1 : 2;
}
const $3ef527dddcdea745$var$DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var $3ef527dddcdea745$export$39cf3280165f92aa = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}($3ef527dddcdea745$export$39cf3280165f92aa || ($3ef527dddcdea745$export$39cf3280165f92aa = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class $3ef527dddcdea745$export$34b6a936f2bb06a2 {
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    /**
    @internal
    */ constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
    /**
    The length of the document before the change.
    */ get length() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2){
            let ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(let i = 0, posA = 0, posB = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f, individual = false) {
        $3ef527dddcdea745$var$iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        let sections = [];
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new $3ef527dddcdea745$export$34b6a936f2bb06a2(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : $3ef527dddcdea745$var$composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `this` happened before the ones in `other`.
    */ mapDesc(other, before = false) {
        return other.empty ? this : $3ef527dddcdea745$var$mapSet(this, other, before);
    }
    mapPos(pos, assoc = -1, mode = $3ef527dddcdea745$export$39cf3280165f92aa.Simple) {
        let posA = 0, posB = 0;
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != $3ef527dddcdea745$export$39cf3280165f92aa.Simple && endA >= pos && (mode == $3ef527dddcdea745$export$39cf3280165f92aa.TrackDel && posA < pos && endA > pos || mode == $3ef527dddcdea745$export$39cf3280165f92aa.TrackBefore && posA < pos || mode == $3ef527dddcdea745$export$39cf3280165f92aa.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from, to = from) {
        for(let i = 0, pos = 0; i < this.sections.length && pos <= to;){
            let len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        let result = "";
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new $3ef527dddcdea745$export$34b6a936f2bb06a2(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new $3ef527dddcdea745$export$34b6a936f2bb06a2(sections);
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class $3ef527dddcdea745$export$29d7fbdcb1f8b71c extends $3ef527dddcdea745$export$34b6a936f2bb06a2 {
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        $3ef527dddcdea745$var$iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other, before = false) {
        return $3ef527dddcdea745$var$mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        let sections = this.sections.slice(), inserted = [];
        for(let i = 0, pos = 0; i < sections.length; i += 2){
            let len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                let index = i >> 1;
                while(inserted.length < index)inserted.push($3ef527dddcdea745$export$5f1af8db9871e1d6.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : $3ef527dddcdea745$export$5f1af8db9871e1d6.empty);
            }
            pos += len;
        }
        return new $3ef527dddcdea745$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : $3ef527dddcdea745$var$composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other, before = false) {
        return other.empty ? this : $3ef527dddcdea745$var$mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f, individual = false) {
        $3ef527dddcdea745$var$iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return $3ef527dddcdea745$export$34b6a936f2bb06a2.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        let resultSections = [], resultInserted = [], filteredSections = [];
        let iter = new $3ef527dddcdea745$var$SectionIter(this);
        done: for(let i = 0, pos = 0;;){
            let next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                let len = Math.min(iter.len, next - pos);
                $3ef527dddcdea745$var$addSection(filteredSections, len, -1);
                let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                $3ef527dddcdea745$var$addSection(resultSections, len, ins);
                if (ins > 0) $3ef527dddcdea745$var$addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            let end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                let len = Math.min(iter.len, end - pos);
                $3ef527dddcdea745$var$addSection(resultSections, len, -1);
                $3ef527dddcdea745$var$addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len);
                pos += len;
            }
        }
        return {
            changes: new $3ef527dddcdea745$export$29d7fbdcb1f8b71c(resultSections, resultInserted),
            filtered: $3ef527dddcdea745$export$34b6a936f2bb06a2.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        let parts = [];
        for(let i = 0; i < this.sections.length; i += 2){
            let len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        let sections = [], inserted = [], pos = 0;
        let total = null;
        function flush(force = false) {
            if (!force && !sections.length) return;
            if (pos < length) $3ef527dddcdea745$var$addSection(sections, length - pos, -1);
            let set = new $3ef527dddcdea745$export$29d7fbdcb1f8b71c(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            if (Array.isArray(spec)) for (let sub of spec)process(sub);
            else if (spec instanceof $3ef527dddcdea745$export$29d7fbdcb1f8b71c) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                let { from: from, to: to = from, insert: insert } = spec;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                let insText = !insert ? $3ef527dddcdea745$export$5f1af8db9871e1d6.empty : typeof insert == "string" ? $3ef527dddcdea745$export$5f1af8db9871e1d6.of(insert.split(lineSep || $3ef527dddcdea745$var$DefaultSplit)) : insert;
                let insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) $3ef527dddcdea745$var$addSection(sections, from - pos, -1);
                $3ef527dddcdea745$var$addSection(sections, to - from, insLen);
                $3ef527dddcdea745$var$addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new $3ef527dddcdea745$export$29d7fbdcb1f8b71c(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        let sections = [], inserted = [];
        for(let i = 0; i < json.length; i++){
            let part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push($3ef527dddcdea745$export$5f1af8db9871e1d6.empty);
                inserted[i] = $3ef527dddcdea745$export$5f1af8db9871e1d6.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        }
        return new $3ef527dddcdea745$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new $3ef527dddcdea745$export$29d7fbdcb1f8b71c(sections, inserted);
    }
}
function $3ef527dddcdea745$var$addSection(sections, len, ins, forceJoin = false) {
    if (len == 0 && ins <= 0) return;
    let last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (last >= 0 && len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function $3ef527dddcdea745$var$addInsert(values, sections, value) {
    if (value.length == 0) return;
    let index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push($3ef527dddcdea745$export$5f1af8db9871e1d6.empty);
        values.push(value);
    }
}
function $3ef527dddcdea745$var$iterChanges(desc, f, individual) {
    let inserted = desc.inserted;
    for(let posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        let len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            let endA = posA, endB = posB, text = $3ef527dddcdea745$export$5f1af8db9871e1d6.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function $3ef527dddcdea745$var$mapSet(setA, setB, before, mkSet = false) {
    // Produce a copy of setA that applies to the document after setB
    // has been applied (assuming both start at the same document).
    let sections = [], insert = mkSet ? [] : null;
    let a = new $3ef527dddcdea745$var$SectionIter(setA), b = new $3ef527dddcdea745$var$SectionIter(setB);
    // Iterate over both sets in parallel. inserted tracks, for changes
    // in A that have to be processed piece-by-piece, whether their
    // content has been inserted already, and refers to the section
    // index.
    for(let inserted = -1;;){
        if (a.done && b.len || b.done && a.len) throw new Error("Mismatched change set lengths");
        else if (a.ins == -1 && b.ins == -1) {
            // Move across ranges skipped by both sets.
            let len = Math.min(a.len, b.len);
            $3ef527dddcdea745$var$addSection(sections, len, -1);
            a.forward(len);
            b.forward(len);
        } else if (b.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b.len < a.len || b.len == a.len && !before))) {
            // If there's a change in B that comes before the next change in
            // A (ordered by start pos, then len, then before flag), skip
            // that (and process any changes in A it covers).
            let len = b.len;
            $3ef527dddcdea745$var$addSection(sections, b.ins, -1);
            while(len){
                let piece = Math.min(a.len, len);
                if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
                    $3ef527dddcdea745$var$addSection(sections, 0, a.ins);
                    if (insert) $3ef527dddcdea745$var$addInsert(insert, sections, a.text);
                    inserted = a.i;
                }
                a.forward(piece);
                len -= piece;
            }
            b.next();
        } else if (a.ins >= 0) {
            // Process the part of a change in A up to the start of the next
            // non-deletion change in B (if overlapping).
            let len = 0, left = a.len;
            while(left){
                if (b.ins == -1) {
                    let piece = Math.min(left, b.len);
                    len += piece;
                    left -= piece;
                    b.forward(piece);
                } else if (b.ins == 0 && b.len < left) {
                    left -= b.len;
                    b.next();
                } else break;
            }
            $3ef527dddcdea745$var$addSection(sections, len, inserted < a.i ? a.ins : 0);
            if (insert && inserted < a.i) $3ef527dddcdea745$var$addInsert(insert, sections, a.text);
            inserted = a.i;
            a.forward(a.len - left);
        } else if (a.done && b.done) return insert ? $3ef527dddcdea745$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $3ef527dddcdea745$export$34b6a936f2bb06a2.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function $3ef527dddcdea745$var$composeSets(setA, setB, mkSet = false) {
    let sections = [];
    let insert = mkSet ? [] : null;
    let a = new $3ef527dddcdea745$var$SectionIter(setA), b = new $3ef527dddcdea745$var$SectionIter(setB);
    for(let open = false;;){
        if (a.done && b.done) return insert ? $3ef527dddcdea745$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $3ef527dddcdea745$export$34b6a936f2bb06a2.create(sections);
        else if (a.ins == 0) {
            $3ef527dddcdea745$var$addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            $3ef527dddcdea745$var$addSection(sections, 0, b.ins, open);
            if (insert) $3ef527dddcdea745$var$addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            let len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                let insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                $3ef527dddcdea745$var$addSection(sections, len, insB, open);
                if (insert && insB) $3ef527dddcdea745$var$addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                $3ef527dddcdea745$var$addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) $3ef527dddcdea745$var$addInsert(insert, sections, a.textBit(len));
            } else {
                $3ef527dddcdea745$var$addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) $3ef527dddcdea745$var$addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class $3ef527dddcdea745$var$SectionIter {
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
    next() {
        let { sections: sections } = this.set;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length ? $3ef527dddcdea745$export$5f1af8db9871e1d6.empty : inserted[index];
    }
    textBit(len) {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? $3ef527dddcdea745$export$5f1af8db9871e1d6.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class $3ef527dddcdea745$export$7bd1839c3c5d5bd4 {
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags, /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ goalColumn){
        this.from = from;
        this.to = to;
        this.flags = flags;
        this.goalColumn = goalColumn;
    }
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 8 /* RangeFlag.AssocBefore */  ? -1 : this.flags & 16 /* RangeFlag.AssocAfter */  ? 1 : 0;
    }
    /**
    A flag that, when set, makes some selection-extending commands
    treat the range's head and anchor as exchangeable, so that for
    example Shift-ArrowUp will make the lower side of the selection
    the anchor, even if that was the head before. Used to implement
    MacOS-style undirectional selections.
    */ get undirectional() {
        return (this.flags & 64 /* RangeFlag.Undirectional */ ) > 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        let level = this.flags & 7 /* RangeFlag.BidiLevelMask */ ;
        return level == 7 ? null : level;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change, assoc = -1) {
        let from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new $3ef527dddcdea745$export$7bd1839c3c5d5bd4(from, to, this.flags, this.goalColumn);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from, to = from, assoc = 0) {
        if (from <= this.anchor && to >= this.anchor) return $3ef527dddcdea745$export$3bb1bd44aee62999.range(from, to, undefined, undefined, assoc);
        let head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return $3ef527dddcdea745$export$3bb1bd44aee62999.range(this.anchor, head, undefined, undefined, assoc);
    }
    /**
    Compare this range to another range.
    */ eq(other, includeAssoc = false) {
        return this.anchor == other.anchor && this.head == other.head && this.goalColumn == other.goalColumn && (!includeAssoc || !this.empty || this.assoc == other.assoc);
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return $3ef527dddcdea745$export$3bb1bd44aee62999.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags, goalColumn) {
        return new $3ef527dddcdea745$export$7bd1839c3c5d5bd4(from, to, flags, goalColumn);
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class $3ef527dddcdea745$export$3bb1bd44aee62999 {
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change, assoc = -1) {
        if (change.empty) return this;
        return $3ef527dddcdea745$export$3bb1bd44aee62999.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection. By default, ranges
    are compared only by position. When `includeAssoc` is true,
    cursor ranges must also have the same
    [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
    */ eq(other, includeAssoc = false) {
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(let i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i], includeAssoc)) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new $3ef527dddcdea745$export$3bb1bd44aee62999([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range, main = true) {
        return $3ef527dddcdea745$export$3bb1bd44aee62999.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range, which = this.mainIndex) {
        let ranges = this.ranges.slice();
        ranges[which] = range;
        return $3ef527dddcdea745$export$3bb1bd44aee62999.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new $3ef527dddcdea745$export$3bb1bd44aee62999(json.ranges.map((r)=>$3ef527dddcdea745$export$7bd1839c3c5d5bd4.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor, head = anchor) {
        return new $3ef527dddcdea745$export$3bb1bd44aee62999([
            $3ef527dddcdea745$export$3bb1bd44aee62999.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges, mainIndex = 0) {
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(let pos = 0, i = 0; i < ranges.length; i++){
            let range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return $3ef527dddcdea745$export$3bb1bd44aee62999.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new $3ef527dddcdea745$export$3bb1bd44aee62999(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
        return $3ef527dddcdea745$export$7bd1839c3c5d5bd4.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 8 /* RangeFlag.AssocBefore */  : 16 /* RangeFlag.AssocAfter */ ) | (bidiLevel == null ? 7 : Math.min(6, bidiLevel)), goalColumn);
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn, bidiLevel, assoc) {
        let flags = bidiLevel == null ? 7 : Math.min(6, bidiLevel);
        if (!assoc && anchor != head) assoc = head < anchor ? 1 : -1;
        if (assoc) flags |= assoc < 0 ? 8 /* RangeFlag.AssocBefore */  : 16 /* RangeFlag.AssocAfter */ ;
        return head < anchor ? $3ef527dddcdea745$export$7bd1839c3c5d5bd4.create(head, anchor, flags | 32 /* RangeFlag.Inverted */ , goalColumn) : $3ef527dddcdea745$export$7bd1839c3c5d5bd4.create(anchor, head, flags, goalColumn);
    }
    /**
    Create an [undirectional](https://codemirror.net/6/docs/ref/#state.SelectionRange.undirectional)
    selection range.
    */ static undirectionalRange(from, to) {
        return $3ef527dddcdea745$export$7bd1839c3c5d5bd4.create(from, to, 64 /* RangeFlag.Undirectional */ , undefined);
    }
    /**
    @internal
    */ static normalized(ranges, mainIndex = 0) {
        let main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(let i = 1; i < ranges.length; i++){
            let range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                let from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? $3ef527dddcdea745$export$3bb1bd44aee62999.range(to, from) : $3ef527dddcdea745$export$3bb1bd44aee62999.range(from, to));
            }
        }
        return new $3ef527dddcdea745$export$3bb1bd44aee62999(ranges, mainIndex);
    }
}
function $3ef527dddcdea745$var$checkSelection(selection, docLength) {
    for (let range of selection.ranges)if (range.to > docLength) throw new RangeError("Selection points outside of document");
}
let $3ef527dddcdea745$var$nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).

Note that `Facet` instances can be used anywhere where
[`FacetReader`](https://codemirror.net/6/docs/ref/#state.FacetReader) is expected.
*/ class $3ef527dddcdea745$export$ef7d5e9b79fa1504 {
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, enables){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        /**
        @internal
        */ this.id = $3ef527dddcdea745$var$nextID++;
        this.default = combine([]);
        this.extensions = typeof enables == "function" ? enables(this) : enables;
    }
    /**
    Returns a facet reader for this facet, which can be used to
    [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
    */ get reader() {
        return this;
    }
    /**
    Define a new facet.
    */ static define(config = {}) {
        return new $3ef527dddcdea745$export$ef7d5e9b79fa1504(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? $3ef527dddcdea745$var$sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new $3ef527dddcdea745$var$FacetProvider([], this, 0 /* Provider.Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $3ef527dddcdea745$var$FacetProvider(deps, this, 1 /* Provider.Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $3ef527dddcdea745$var$FacetProvider(deps, this, 2 /* Provider.Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
}
function $3ef527dddcdea745$var$sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class $3ef527dddcdea745$var$FacetProvider {
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = $3ef527dddcdea745$var$nextID++;
    }
    dynamicSlot(addresses) {
        var _a;
        let getter = this.value;
        let compare = this.facet.compareInput;
        let id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Provider.Multi */ ;
        let depDoc = false, depSel = false, depAddrs = [];
        for (let dep of this.dependencies){
            if (dep == "doc") depDoc = true;
            else if (dep == "selection") depSel = true;
            else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || $3ef527dddcdea745$var$ensureAll(state, depAddrs)) {
                    let newVal = getter(state);
                    if (multi ? !$3ef527dddcdea745$var$compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* SlotStatus.Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                let newVal, oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    let oldVal = $3ef527dddcdea745$var$getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof $3ef527dddcdea745$export$ef7d5e9b79fa1504 ? oldState.facet(dep) === state.facet(dep) : dep instanceof $3ef527dddcdea745$export$34381b1ce2130245 ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? $3ef527dddcdea745$var$compareArray(newVal = getter(state), oldVal, compare) : compare(newVal = getter(state), oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                } else newVal = getter(state);
                state.values[idx] = newVal;
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    get extension() {
        return this;
    }
}
function $3ef527dddcdea745$var$compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function $3ef527dddcdea745$var$ensureAll(state, addrs) {
    let changed = false;
    for (let addr of addrs)if ($3ef527dddcdea745$var$ensureAddr(state, addr) & 1 /* SlotStatus.Changed */ ) changed = true;
    return changed;
}
function $3ef527dddcdea745$var$dynamicFacetSlot(addresses, facet, providers) {
    let providerAddrs = providers.map((p)=>addresses[p.id]);
    let providerTypes = providers.map((p)=>p.type);
    let dynamic = providerAddrs.filter((p)=>!(p & 1));
    let idx = addresses[facet.id] >> 1;
    function get(state) {
        let values = [];
        for(let i = 0; i < providerAddrs.length; i++){
            let value = $3ef527dddcdea745$var$getAddr(state, providerAddrs[i]);
            if (providerTypes[i] == 2 /* Provider.Multi */ ) for (let val of value)values.push(val);
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            for (let addr of providerAddrs)$3ef527dddcdea745$var$ensureAddr(state, addr);
            state.values[idx] = get(state);
            return 1 /* SlotStatus.Changed */ ;
        },
        update (state, tr) {
            if (!$3ef527dddcdea745$var$ensureAll(state, dynamic)) return 0;
            let value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        },
        reconfigure (state, oldState) {
            let depChanged = $3ef527dddcdea745$var$ensureAll(state, providerAddrs);
            let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && $3ef527dddcdea745$var$sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            let value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        }
    };
}
const $3ef527dddcdea745$var$initField = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class $3ef527dddcdea745$export$34381b1ce2130245 {
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
    /**
    Define a state field.
    */ static define(config) {
        let field = new $3ef527dddcdea745$export$34381b1ce2130245($3ef527dddcdea745$var$nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        let init = state.facet($3ef527dddcdea745$var$initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        let idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update: (state, tr)=>{
                let oldVal = state.values[idx];
                let value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* SlotStatus.Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                let init = state.facet($3ef527dddcdea745$var$initField), oldInit = oldState.facet($3ef527dddcdea745$var$initField), reInit;
                if ((reInit = init.find((i)=>i.field == this)) && reInit != oldInit.find((i)=>i.field == this)) {
                    state.values[idx] = reInit.create(state);
                    return 1 /* SlotStatus.Changed */ ;
                }
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            $3ef527dddcdea745$var$initField.of({
                field: this,
                create: create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
}
const $3ef527dddcdea745$var$Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function $3ef527dddcdea745$var$prec(value) {
    return (ext)=>new $3ef527dddcdea745$var$PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ const $3ef527dddcdea745$export$b92464a736444411 = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ $3ef527dddcdea745$var$prec($3ef527dddcdea745$var$Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ $3ef527dddcdea745$var$prec($3ef527dddcdea745$var$Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ $3ef527dddcdea745$var$prec($3ef527dddcdea745$var$Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ $3ef527dddcdea745$var$prec($3ef527dddcdea745$var$Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ $3ef527dddcdea745$var$prec($3ef527dddcdea745$var$Prec_.lowest)
};
class $3ef527dddcdea745$var$PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
    get extension() {
        return this;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class $3ef527dddcdea745$export$d51c0172eb2c2431 {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new $3ef527dddcdea745$var$CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return $3ef527dddcdea745$export$d51c0172eb2c2431.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class $3ef527dddcdea745$var$CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
    get extension() {
        return this;
    }
}
class $3ef527dddcdea745$var$Configuration {
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* SlotStatus.Unresolved */ );
    }
    staticFacet(facet) {
        let addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        let fields = [];
        let facets = Object.create(null);
        let newCompartments = new Map();
        for (let ext of $3ef527dddcdea745$var$flatten(base, compartments, newCompartments))if (ext instanceof $3ef527dddcdea745$export$34381b1ce2130245) fields.push(ext);
        else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
        let address = Object.create(null);
        let staticValues = [];
        let dynamicSlots = [];
        for (let field of fields){
            address[field.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a)=>field.slot(a));
        }
        let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(let id in facets){
            let providers = facets[id], facet = providers[0].facet;
            let oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Provider.Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if ($3ef527dddcdea745$var$sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    let value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                for (let p of providers)if (p.type == 0 /* Provider.Static */ ) {
                    address[p.id] = staticValues.length << 1 | 1;
                    staticValues.push(p.value);
                } else {
                    address[p.id] = dynamicSlots.length << 1;
                    dynamicSlots.push((a)=>p.dynamicSlot(a));
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>$3ef527dddcdea745$var$dynamicFacetSlot(a, facet, providers));
            }
        }
        let dynamic = dynamicSlots.map((f)=>f(address));
        return new $3ef527dddcdea745$var$Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
}
function $3ef527dddcdea745$var$flatten(extension, compartments, newCompartments) {
    let result = [
        [],
        [],
        [],
        [],
        []
    ];
    let seen = new Map();
    function inner(ext, prec) {
        let known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            let found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof $3ef527dddcdea745$var$CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        if (Array.isArray(ext)) for (let e of ext)inner(e, prec);
        else if (ext instanceof $3ef527dddcdea745$var$CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            let content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof $3ef527dddcdea745$var$PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof $3ef527dddcdea745$export$34381b1ce2130245) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof $3ef527dddcdea745$var$FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, $3ef527dddcdea745$var$Prec_.default);
        } else {
            let content = ext.extension;
            if (!content) throw new Error(`Unrecognized extension value in extension set (${ext}).`);
            if (content == ext) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content, prec);
        }
    }
    inner(extension, $3ef527dddcdea745$var$Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function $3ef527dddcdea745$var$ensureAddr(state, addr) {
    if (addr & 1) return 2 /* SlotStatus.Computed */ ;
    let idx = addr >> 1;
    let status = state.status[idx];
    if (status == 4 /* SlotStatus.Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* SlotStatus.Computed */ ) return status;
    state.status[idx] = 4 /* SlotStatus.Computing */ ;
    let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* SlotStatus.Computed */  | changed;
}
function $3ef527dddcdea745$var$getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const $3ef527dddcdea745$var$languageData = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define();
const $3ef527dddcdea745$var$allowMultipleSelections = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
const $3ef527dddcdea745$var$lineSeparator = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
const $3ef527dddcdea745$var$changeFilter = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define();
const $3ef527dddcdea745$var$transactionFilter = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define();
const $3ef527dddcdea745$var$transactionExtender = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define();
const $3ef527dddcdea745$var$readOnly = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class $3ef527dddcdea745$export$9279461326b8700a {
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Define a new type of annotation.
    */ static define() {
        return new $3ef527dddcdea745$export$f50c3066a53a6f2c();
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class $3ef527dddcdea745$export$f50c3066a53a6f2c {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new $3ef527dddcdea745$export$9279461326b8700a(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class $3ef527dddcdea745$export$e41ff6bd17cc4417 {
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new $3ef527dddcdea745$export$95000d4efaa4321f(this, value);
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class $3ef527dddcdea745$export$95000d4efaa4321f {
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        let mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new $3ef527dddcdea745$export$95000d4efaa4321f(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds. It should be a type that
    doesn't include `undefined`, since that is used in
    [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
    removed.
    */ static define(spec = {}) {
        return new $3ef527dddcdea745$export$e41ff6bd17cc4417(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        let result = [];
        for (let effect of effects){
            let mapped = effect.map(mapping);
            if (mapped) result.push(mapped);
        }
        return result;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ $3ef527dddcdea745$export$95000d4efaa4321f.reconfigure = /*@__PURE__*/ $3ef527dddcdea745$export$95000d4efaa4321f.define();
/**
Append extensions to the top-level configuration of the editor.
*/ $3ef527dddcdea745$export$95000d4efaa4321f.appendConfig = /*@__PURE__*/ $3ef527dddcdea745$export$95000d4efaa4321f.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class $3ef527dddcdea745$export$febc5573c75cefb0 {
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) $3ef527dddcdea745$var$checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == $3ef527dddcdea745$export$febc5573c75cefb0.time)) this.annotations = annotations.concat($3ef527dddcdea745$export$febc5573c75cefb0.time.of(Date.now()));
    }
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new $3ef527dddcdea745$export$febc5573c75cefb0(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        for (let ann of this.annotations)if (ann.type == type) return ann.value;
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        let e = this.annotation($3ef527dddcdea745$export$febc5573c75cefb0.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ $3ef527dddcdea745$export$febc5573c75cefb0.time = /*@__PURE__*/ $3ef527dddcdea745$export$9279461326b8700a.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ $3ef527dddcdea745$export$febc5573c75cefb0.userEvent = /*@__PURE__*/ $3ef527dddcdea745$export$9279461326b8700a.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ $3ef527dddcdea745$export$febc5573c75cefb0.addToHistory = /*@__PURE__*/ $3ef527dddcdea745$export$9279461326b8700a.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ $3ef527dddcdea745$export$febc5573c75cefb0.remote = /*@__PURE__*/ $3ef527dddcdea745$export$9279461326b8700a.define();
function $3ef527dddcdea745$var$joinRanges(a, b) {
    let result = [];
    for(let iA = 0, iB = 0;;){
        let from, to;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function $3ef527dddcdea745$var$mergeTransaction(a, b, sequential) {
    var _a;
    let mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = $3ef527dddcdea745$export$29d7fbdcb1f8b71c.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes: changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: $3ef527dddcdea745$export$95000d4efaa4321f.mapEffects(a.effects, mapForA).concat($3ef527dddcdea745$export$95000d4efaa4321f.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function $3ef527dddcdea745$var$resolveTransactionInner(state, spec, docSize) {
    let sel = spec.selection, annotations = $3ef527dddcdea745$var$asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat($3ef527dddcdea745$export$febc5573c75cefb0.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof $3ef527dddcdea745$export$29d7fbdcb1f8b71c ? spec.changes : $3ef527dddcdea745$export$29d7fbdcb1f8b71c.of(spec.changes || [], docSize, state.facet($3ef527dddcdea745$var$lineSeparator)),
        selection: sel && (sel instanceof $3ef527dddcdea745$export$3bb1bd44aee62999 ? sel : $3ef527dddcdea745$export$3bb1bd44aee62999.single(sel.anchor, sel.head)),
        effects: $3ef527dddcdea745$var$asArray(spec.effects),
        annotations: annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function $3ef527dddcdea745$var$resolveTransaction(state, specs, filter) {
    let s = $3ef527dddcdea745$var$resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(let i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        let seq = !!specs[i].sequential;
        s = $3ef527dddcdea745$var$mergeTransaction(s, $3ef527dddcdea745$var$resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    let tr = $3ef527dddcdea745$export$febc5573c75cefb0.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return $3ef527dddcdea745$var$extendTransaction(filter ? $3ef527dddcdea745$var$filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function $3ef527dddcdea745$var$filterTransaction(tr) {
    let state = tr.startState;
    // Change filters
    let result = true;
    for (let filter of state.facet($3ef527dddcdea745$var$changeFilter)){
        let value = filter(tr);
        if (value === false) {
            result = false;
            break;
        }
        if (Array.isArray(value)) result = result === true ? value : $3ef527dddcdea745$var$joinRanges(result, value);
    }
    if (result !== true) {
        let changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = $3ef527dddcdea745$export$29d7fbdcb1f8b71c.empty(state.doc.length);
        } else {
            let filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
        }
        tr = $3ef527dddcdea745$export$febc5573c75cefb0.create(state, changes, tr.selection && tr.selection.map(back), $3ef527dddcdea745$export$95000d4efaa4321f.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    let filters = state.facet($3ef527dddcdea745$var$transactionFilter);
    for(let i = filters.length - 1; i >= 0; i--){
        let filtered = filters[i](tr);
        if (filtered instanceof $3ef527dddcdea745$export$febc5573c75cefb0) tr = filtered;
        else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof $3ef527dddcdea745$export$febc5573c75cefb0) tr = filtered[0];
        else tr = $3ef527dddcdea745$var$resolveTransaction(state, $3ef527dddcdea745$var$asArray(filtered), false);
    }
    return tr;
}
function $3ef527dddcdea745$var$extendTransaction(tr) {
    let state = tr.startState, extenders = state.facet($3ef527dddcdea745$var$transactionExtender), spec = tr;
    for(let i = extenders.length - 1; i >= 0; i--){
        let extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = $3ef527dddcdea745$var$mergeTransaction(spec, $3ef527dddcdea745$var$resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : $3ef527dddcdea745$export$febc5573c75cefb0.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const $3ef527dddcdea745$var$none = [];
function $3ef527dddcdea745$var$asArray(value) {
    return value == null ? $3ef527dddcdea745$var$none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var $3ef527dddcdea745$export$239a3d59567c1401 = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}($3ef527dddcdea745$export$239a3d59567c1401 || ($3ef527dddcdea745$export$239a3d59567c1401 = {}));
const $3ef527dddcdea745$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let $3ef527dddcdea745$var$wordChar;
try {
    $3ef527dddcdea745$var$wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function $3ef527dddcdea745$var$hasWordChar(str) {
    if ($3ef527dddcdea745$var$wordChar) return $3ef527dddcdea745$var$wordChar.test(str);
    for(let i = 0; i < str.length; i++){
        let ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || $3ef527dddcdea745$var$nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function $3ef527dddcdea745$var$makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return $3ef527dddcdea745$export$239a3d59567c1401.Space;
        if ($3ef527dddcdea745$var$hasWordChar(char)) return $3ef527dddcdea745$export$239a3d59567c1401.Word;
        for(let i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return $3ef527dddcdea745$export$239a3d59567c1401.Word;
        return $3ef527dddcdea745$export$239a3d59567c1401.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class $3ef527dddcdea745$export$afa855cbfaff27f2 {
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(let i = 0; i < this.config.dynamicSlots.length; i++)$3ef527dddcdea745$var$ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
    field(field, require = true) {
        let addr = this.config.address[field.id];
        if (addr == null) {
            if (require) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        $3ef527dddcdea745$var$ensureAddr(this, addr);
        return $3ef527dddcdea745$var$getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update(...specs) {
        return $3ef527dddcdea745$var$resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        let conf = this.config, { base: base, compartments: compartments } = conf;
        for (let effect of tr.effects){
            if (effect.is($3ef527dddcdea745$export$d51c0172eb2c2431.reconfigure)) {
                if (conf) {
                    compartments = new Map;
                    conf.compartments.forEach((val, key)=>compartments.set(key, val));
                    conf = null;
                }
                compartments.set(effect.value.compartment, effect.value.extension);
            } else if (effect.is($3ef527dddcdea745$export$95000d4efaa4321f.reconfigure)) {
                conf = null;
                base = effect.value;
            } else if (effect.is($3ef527dddcdea745$export$95000d4efaa4321f.appendConfig)) {
                conf = null;
                base = $3ef527dddcdea745$var$asArray(base).concat(effect.value);
            }
        }
        let startValues;
        if (!conf) {
            conf = $3ef527dddcdea745$var$Configuration.resolve(base, compartments, this);
            let intermediateState = new $3ef527dddcdea745$export$afa855cbfaff27f2(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        let selection = tr.startState.facet($3ef527dddcdea745$var$allowMultipleSelections) ? tr.newSelection : tr.newSelection.asSingle();
        new $3ef527dddcdea745$export$afa855cbfaff27f2(conf, tr.newDoc, selection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: $3ef527dddcdea745$export$3bb1bd44aee62999.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        let sel = this.selection;
        let result1 = f(sel.ranges[0]);
        let changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        let effects = $3ef527dddcdea745$var$asArray(result1.effects);
        for(let i = 1; i < sel.ranges.length; i++){
            let result = f(sel.ranges[i]);
            let newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(let j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            let mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = $3ef527dddcdea745$export$95000d4efaa4321f.mapEffects(effects, newMapped).concat($3ef527dddcdea745$export$95000d4efaa4321f.mapEffects($3ef527dddcdea745$var$asArray(result.effects), mapBy));
        }
        return {
            changes: changes,
            selection: $3ef527dddcdea745$export$3bb1bd44aee62999.create(ranges, sel.mainIndex),
            effects: effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes(spec = []) {
        if (spec instanceof $3ef527dddcdea745$export$29d7fbdcb1f8b71c) return spec;
        return $3ef527dddcdea745$export$29d7fbdcb1f8b71c.of(spec, this.doc.length, this.facet($3ef527dddcdea745$export$afa855cbfaff27f2.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return $3ef527dddcdea745$export$5f1af8db9871e1d6.of(string.split(this.facet($3ef527dddcdea745$export$afa855cbfaff27f2.lineSeparator) || $3ef527dddcdea745$var$DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc(from = 0, to = this.doc.length) {
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        let addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        $3ef527dddcdea745$var$ensureAddr(this, addr);
        return $3ef527dddcdea745$var$getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        let result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(let prop in fields){
            let value = fields[prop];
            if (value instanceof $3ef527dddcdea745$export$34381b1ce2130245 && this.config.address[value.id] != null) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json, config = {}, fields) {
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        let fieldInit = [];
        if (fields) {
            for(let prop in fields)if (Object.prototype.hasOwnProperty.call(json, prop)) {
                let field = fields[prop], value = json[prop];
                fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
            }
        }
        return $3ef527dddcdea745$export$afa855cbfaff27f2.create({
            doc: json.doc,
            selection: $3ef527dddcdea745$export$3bb1bd44aee62999.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create(config = {}) {
        let configuration = $3ef527dddcdea745$var$Configuration.resolve(config.extensions || [], new Map);
        let doc = config.doc instanceof $3ef527dddcdea745$export$5f1af8db9871e1d6 ? config.doc : $3ef527dddcdea745$export$5f1af8db9871e1d6.of((config.doc || "").split(configuration.staticFacet($3ef527dddcdea745$export$afa855cbfaff27f2.lineSeparator) || $3ef527dddcdea745$var$DefaultSplit));
        let selection = !config.selection ? $3ef527dddcdea745$export$3bb1bd44aee62999.single(0) : config.selection instanceof $3ef527dddcdea745$export$3bb1bd44aee62999 ? config.selection : $3ef527dddcdea745$export$3bb1bd44aee62999.single(config.selection.anchor, config.selection.head);
        $3ef527dddcdea745$var$checkSelection(selection, doc.length);
        if (!configuration.staticFacet($3ef527dddcdea745$var$allowMultipleSelections)) selection = selection.asSingle();
        return new $3ef527dddcdea745$export$afa855cbfaff27f2(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet($3ef527dddcdea745$export$afa855cbfaff27f2.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet($3ef527dddcdea745$export$afa855cbfaff27f2.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet($3ef527dddcdea745$var$readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase, ...insert) {
        for (let map of this.facet($3ef527dddcdea745$export$afa855cbfaff27f2.phrases))if (Object.prototype.hasOwnProperty.call(map, phrase)) {
            phrase = map[phrase];
            break;
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            let n = +(i || 1);
            return !n || n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    
    Examples of language data fields are...
    
    - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
      comment syntax.
    - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
      for providing language-specific completion sources.
    - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
      characters that should be considered part of words in this
      language.
    - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
      bracket closing behavior.
    */ languageDataAt(name, pos, side = -1) {
        let values = [];
        for (let provider of this.facet($3ef527dddcdea745$var$languageData)){
            for (let result of provider(this, pos, side))if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        let chars = this.languageDataAt("wordChars", at);
        return $3ef527dddcdea745$var$makeCategorizer(chars.length ? chars[0] : "");
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        let { text: text, from: from, length: length } = this.doc.lineAt(pos);
        let cat = this.charCategorizer(pos);
        let start = pos - from, end = pos - from;
        while(start > 0){
            let prev = $3ef527dddcdea745$export$a0fa439fd515e1ed(text, start, false);
            if (cat(text.slice(prev, start)) != $3ef527dddcdea745$export$239a3d59567c1401.Word) break;
            start = prev;
        }
        while(end < length){
            let next = $3ef527dddcdea745$export$a0fa439fd515e1ed(text, end);
            if (cat(text.slice(end, next)) != $3ef527dddcdea745$export$239a3d59567c1401.Word) break;
            end = next;
        }
        return start == end ? null : $3ef527dddcdea745$export$3bb1bd44aee62999.range(start + from, end + from);
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ $3ef527dddcdea745$export$afa855cbfaff27f2.allowMultipleSelections = $3ef527dddcdea745$var$allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ $3ef527dddcdea745$export$afa855cbfaff27f2.tabSize = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ $3ef527dddcdea745$export$afa855cbfaff27f2.lineSeparator = $3ef527dddcdea745$var$lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ $3ef527dddcdea745$export$afa855cbfaff27f2.readOnly = $3ef527dddcdea745$var$readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ $3ef527dddcdea745$export$afa855cbfaff27f2.phrases = /*@__PURE__*/ $3ef527dddcdea745$export$ef7d5e9b79fa1504.define({
    compare (a, b) {
        let kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ $3ef527dddcdea745$export$afa855cbfaff27f2.languageData = $3ef527dddcdea745$var$languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ $3ef527dddcdea745$export$afa855cbfaff27f2.changeFilter = $3ef527dddcdea745$var$changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ $3ef527dddcdea745$export$afa855cbfaff27f2.transactionFilter = $3ef527dddcdea745$var$transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ $3ef527dddcdea745$export$afa855cbfaff27f2.transactionExtender = $3ef527dddcdea745$var$transactionExtender;
$3ef527dddcdea745$export$d51c0172eb2c2431.reconfigure = /*@__PURE__*/ $3ef527dddcdea745$export$95000d4efaa4321f.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function $3ef527dddcdea745$export$4e19c0b693794a7e(configs, defaults, combine = {}) {
    let result = {};
    for (let config of configs)for (let key of Object.keys(config)){
        let value = config[key], current = result[key];
        if (current === undefined) result[key] = value;
        else if (current === value || value === undefined) ; // No conflict
        else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
        else throw new Error("Config merge conflict for field " + key);
    }
    for(let key in defaults)if (result[key] === undefined) result[key] = defaults[key];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class $3ef527dddcdea745$export$d60f08ed93a48611 {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from, to = from) {
        return $3ef527dddcdea745$export$9a58ef0d7ad3278c.create(from, to, this);
    }
}
$3ef527dddcdea745$export$d60f08ed93a48611.prototype.startSide = $3ef527dddcdea745$export$d60f08ed93a48611.prototype.endSide = 0;
$3ef527dddcdea745$export$d60f08ed93a48611.prototype.point = false;
$3ef527dddcdea745$export$d60f08ed93a48611.prototype.mapMode = $3ef527dddcdea745$export$39cf3280165f92aa.TrackDel;
function $3ef527dddcdea745$var$cmpVal(a, b) {
    return a == b || a.constructor == b.constructor && a.eq(b);
}
/**
A range associates a value with a range of positions.
*/ class $3ef527dddcdea745$export$9a58ef0d7ad3278c {
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
    /**
    @internal
    */ static create(from, to, value) {
        return new $3ef527dddcdea745$export$9a58ef0d7ad3278c(from, to, value);
    }
}
function $3ef527dddcdea745$var$cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class $3ef527dddcdea745$var$Chunk {
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end, startAt = 0) {
        let arr = end ? this.to : this.from;
        for(let lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            let mid = lo + hi >> 1;
            let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(let i = this.findIndex(from, -1000000000 /* C.Far */ , true), e = this.findIndex(to, 1000000000 /* C.Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        let value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(let i = 0; i < this.value.length; i++){
            let val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom, newTo;
            if (curFrom == curTo) {
                let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new $3ef527dddcdea745$var$Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class $3ef527dddcdea745$export$34cb5241245008dd {
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new $3ef527dddcdea745$export$34cb5241245008dd(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        let last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        let size = this.nextLayer.size;
        for (let chunk of this.chunk)size += chunk.value.length;
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        let { add: add = [], sort: sort = false, filterFrom: filterFrom = 0, filterTo: filterTo = this.length } = updateSpec;
        let filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort($3ef527dddcdea745$var$cmpRange);
        if (this.isEmpty) return add.length ? $3ef527dddcdea745$export$34cb5241245008dd.of(add) : this;
        let cur = new $3ef527dddcdea745$var$LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        let builder = new $3ef527dddcdea745$export$89e09ce03c7e8594();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                let range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push($3ef527dddcdea745$export$9a58ef0d7ad3278c.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? $3ef527dddcdea745$export$34cb5241245008dd.empty : this.nextLayer.update({
            add: spill,
            filter: filter,
            filterFrom: filterFrom,
            filterTo: filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        let chunks = [], chunkPos = [], maxPoint = -1;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            let touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                let { mapped: mapped, pos: pos } = chunk.map(start, changes);
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        let next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new $3ef527dddcdea745$export$34cb5241245008dd(chunkPos, chunks, next || $3ef527dddcdea745$export$34cb5241245008dd.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter(from = 0) {
        return $3ef527dddcdea745$var$HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets, from = 0) {
        return $3ef527dddcdea745$var$HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration.
    */ textDiff, comparator, /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = -1) {
        let a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let sharedChunks = $3ef527dddcdea745$var$findSharedChunks(a, b, textDiff);
        let sideA = new $3ef527dddcdea745$var$SpanCursor(a, sharedChunks, minPointSize);
        let sideB = new $3ef527dddcdea745$var$SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>$3ef527dddcdea745$var$compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) $3ef527dddcdea745$var$compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets, from = 0, to) {
        if (to == null) to = 999999999;
        let a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        let b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        let sharedChunks = $3ef527dddcdea745$var$findSharedChunks(a, b);
        let sideA = new $3ef527dddcdea745$var$SpanCursor(a, sharedChunks, 0).goto(from), sideB = new $3ef527dddcdea745$var$SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !$3ef527dddcdea745$var$sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !$3ef527dddcdea745$var$cmpVal(sideA.point, sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator, /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = -1) {
        let cursor = new $3ef527dddcdea745$var$SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        let openRanges = cursor.openStart;
        for(;;){
            let curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                let active = cursor.activeForPoint(cursor.to);
                let openCount = cursor.pointFrom < from ? active.length + 1 : cursor.point.startSide < 0 ? active.length : Math.min(active.length, openRanges);
                iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
                openRanges = Math.min(cursor.openEnd(curTo), active.length);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, openRanges);
                openRanges = cursor.openEnd(curTo);
            }
            if (cursor.to > to) return openRanges + (cursor.point && cursor.to > to ? 1 : 0);
            pos = cursor.to;
            cursor.next();
        }
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges, sort = false) {
        let build = new $3ef527dddcdea745$export$89e09ce03c7e8594();
        for (let range of ranges instanceof $3ef527dddcdea745$export$9a58ef0d7ad3278c ? [
            ranges
        ] : sort ? $3ef527dddcdea745$var$lazySort(ranges) : ranges)build.add(range.from, range.to, range.value);
        return build.finish();
    }
    /**
    Join an array of range sets into a single set.
    */ static join(sets) {
        if (!sets.length) return $3ef527dddcdea745$export$34cb5241245008dd.empty;
        let result = sets[sets.length - 1];
        for(let i = sets.length - 2; i >= 0; i--)for(let layer = sets[i]; layer != $3ef527dddcdea745$export$34cb5241245008dd.empty; layer = layer.nextLayer)result = new $3ef527dddcdea745$export$34cb5241245008dd(layer.chunkPos, layer.chunk, result, Math.max(layer.maxPoint, result.maxPoint));
        return result;
    }
}
/**
The empty set of ranges.
*/ $3ef527dddcdea745$export$34cb5241245008dd.empty = /*@__PURE__*/ new $3ef527dddcdea745$export$34cb5241245008dd([], [], null, -1);
function $3ef527dddcdea745$var$lazySort(ranges) {
    if (ranges.length > 1) for(let prev = ranges[0], i = 1; i < ranges.length; i++){
        let cur = ranges[i];
        if ($3ef527dddcdea745$var$cmpRange(prev, cur) > 0) return ranges.slice().sort($3ef527dddcdea745$var$cmpRange);
        prev = cur;
    }
    return ranges;
}
$3ef527dddcdea745$export$34cb5241245008dd.empty.nextLayer = $3ef527dddcdea745$export$34cb5241245008dd.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class $3ef527dddcdea745$export$89e09ce03c7e8594 {
    finishChunk(newArrays) {
        this.chunks.push(new $3ef527dddcdea745$var$Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* C.Far */ ;
        this.lastTo = -1000000000 /* C.Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new $3ef527dddcdea745$export$89e09ce03c7e8594)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        let diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* C.ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        let last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner($3ef527dddcdea745$export$34cb5241245008dd.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        let result = $3ef527dddcdea745$export$34cb5241245008dd.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
}
function $3ef527dddcdea745$var$findSharedChunks(a, b, textDiff) {
    let inA = new Map();
    for (let set of a)for(let i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
    let shared = new Set();
    for (let set of b)for(let i = 0; i < set.chunk.length; i++){
        let known = inA.get(set.chunk[i]);
        if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set.chunkPos[i] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set.chunk[i].length))) shared.add(set.chunk[i]);
    }
    return shared;
}
class $3ef527dddcdea745$var$LayerCursor {
    constructor(layer, skip, minPoint, rank = 0){
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            let next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            break;
        } else {
            let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            let from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
}
class $3ef527dddcdea745$var$HeapCursor {
    constructor(heap){
        this.heap = heap;
    }
    static from(sets, skip = null, minPoint = -1) {
        let heap = [];
        for(let i = 0; i < sets.length; i++){
            for(let cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new $3ef527dddcdea745$var$LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new $3ef527dddcdea745$var$HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        for (let cur of this.heap)cur.goto(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$3ef527dddcdea745$var$heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        for (let cur of this.heap)cur.forward(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$3ef527dddcdea745$var$heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            let top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            $3ef527dddcdea745$var$heapBubble(this.heap, 0);
        }
    }
}
function $3ef527dddcdea745$var$heapBubble(heap, index) {
    for(let cur = heap[index];;){
        let childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        let child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class $3ef527dddcdea745$var$SpanCursor {
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* C.Far */ ;
        this.endSide = 0;
        // The amount of open active ranges at the start of the iterator.
        // Not including points.
        this.openStart = -1;
        this.cursor = $3ef527dddcdea745$var$HeapCursor.from(sets, skip, minPoint);
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        $3ef527dddcdea745$var$remove(this.active, index);
        $3ef527dddcdea745$var$remove(this.activeTo, index);
        $3ef527dddcdea745$var$remove(this.activeRank, index);
        this.minActive = $3ef527dddcdea745$var$findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        let i = 0, { value: value, to: to, rank: rank } = this.cursor;
        // Organize active marks by rank first, then by size
        while(i < this.activeRank.length && (rank - this.activeRank[i] || to - this.activeTo[i]) > 0)i++;
        $3ef527dddcdea745$var$insert(this.active, i, value);
        $3ef527dddcdea745$var$insert(this.activeTo, i, to);
        $3ef527dddcdea745$var$insert(this.activeRank, i, rank);
        if (trackOpen) $3ef527dddcdea745$var$insert(trackOpen, i, this.cursor.from);
        this.minActive = $3ef527dddcdea745$var$findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        let from = this.to, wasPoint = this.point;
        this.point = null;
        let trackOpen = this.openStart < 0 ? [] : null;
        for(;;){
            let a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) $3ef527dddcdea745$var$remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* C.Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                let nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            this.openStart = 0;
            for(let i = trackOpen.length - 1; i >= 0 && trackOpen[i] < from; i--)this.openStart++;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        let active = [];
        for(let i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        let open = 0;
        for(let i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
}
function $3ef527dddcdea745$var$compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    let endB = startB + length;
    let pos = startB, dPos = startB - startA;
    let bounds = !!comparator.boundChange;
    for(let boundChange = false;;){
        let dEnd = a.to + dPos - b.to, diff = dEnd || a.endSide - b.endSide;
        let end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        let point = a.point || b.point;
        if (point) {
            if (!(a.point && b.point && $3ef527dddcdea745$var$cmpVal(a.point, b.point) && $3ef527dddcdea745$var$sameValues(a.activeForPoint(a.to), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
            boundChange = false;
        } else {
            if (boundChange) comparator.boundChange(pos);
            if (clipEnd > pos && !$3ef527dddcdea745$var$sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
            if (bounds && clipEnd < endB && (dEnd || a.openEnd(end) != b.openEnd(end))) boundChange = true;
        }
        if (end > endB) break;
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function $3ef527dddcdea745$var$sameValues(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] != b[i] && !$3ef527dddcdea745$var$cmpVal(a[i], b[i])) return false;
    return true;
}
function $3ef527dddcdea745$var$remove(array, index) {
    for(let i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function $3ef527dddcdea745$var$insert(array, index, value) {
    for(let i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function $3ef527dddcdea745$var$findMinIndex(value, array) {
    let found = -1, foundPos = 1000000000 /* C.Far */ ;
    for(let i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function $3ef527dddcdea745$export$20b4ab289374d0ac(string, tabSize, to = string.length) {
    let n = 0;
    for(let i = 0; i < to && i < string.length;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = $3ef527dddcdea745$export$a0fa439fd515e1ed(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function $3ef527dddcdea745$export$718b3d71c384ca05(string, col, tabSize, strict) {
    for(let i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = $3ef527dddcdea745$export$a0fa439fd515e1ed(string, i);
    }
    return strict === true ? -1 : string.length;
}


const $246d4c208d441e56$var$C = "\u037c";
const $246d4c208d441e56$var$COUNT = typeof Symbol == "undefined" ? "__" + $246d4c208d441e56$var$C : Symbol.for($246d4c208d441e56$var$C);
const $246d4c208d441e56$var$SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const $246d4c208d441e56$var$top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class $246d4c208d441e56$export$b920c662d2efee20 {
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        let { finish: finish } = options || {};
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(let prop in spec){
                let value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(let prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        let id = $246d4c208d441e56$var$top[$246d4c208d441e56$var$COUNT] || 1;
        $246d4c208d441e56$var$top[$246d4c208d441e56$var$COUNT] = id + 1;
        return $246d4c208d441e56$var$C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    //
    // If a Content Security Policy nonce is provided, it is added to
    // the `<style>` tag generated by the library.
    static mount(root, modules, options) {
        let set = root[$246d4c208d441e56$var$SET], nonce = options && options.nonce;
        if (!set) set = new $246d4c208d441e56$var$StyleSet(root, nonce);
        else if (nonce) set.setNonce(nonce);
        set.mount(Array.isArray(modules) ? modules : [
            modules
        ], root);
    }
}
let $246d4c208d441e56$var$adoptedSet = new Map //<Document, StyleSet>
;
class $246d4c208d441e56$var$StyleSet {
    constructor(root, nonce){
        let doc = root.ownerDocument || root, win = doc.defaultView;
        if (!root.head && root.adoptedStyleSheets && win.CSSStyleSheet) {
            let adopted = $246d4c208d441e56$var$adoptedSet.get(doc);
            if (adopted) return root[$246d4c208d441e56$var$SET] = adopted;
            this.sheet = new win.CSSStyleSheet;
            $246d4c208d441e56$var$adoptedSet.set(doc, this);
        } else {
            this.styleTag = doc.createElement("style");
            if (nonce) this.styleTag.setAttribute("nonce", nonce);
        }
        this.modules = [];
        root[$246d4c208d441e56$var$SET] = this;
    }
    mount(modules, root) {
        let sheet = this.sheet;
        let pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(let i = 0; i < modules.length; i++){
            let mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(let k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (sheet) {
            if (root.adoptedStyleSheets.indexOf(this.sheet) < 0) root.adoptedStyleSheets = [
                this.sheet,
                ...root.adoptedStyleSheets
            ];
        } else {
            let text = "";
            for(let i = 0; i < this.modules.length; i++)text += this.modules[i].getRules() + "\n";
            this.styleTag.textContent = text;
            let target = root.head || root;
            if (this.styleTag.parentNode != target) target.insertBefore(this.styleTag, target.firstChild);
        }
    }
    setNonce(nonce) {
        if (this.styleTag && this.styleTag.getAttribute("nonce") != nonce) this.styleTag.setAttribute("nonce", nonce);
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.


var $0cf1073115e44648$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $0cf1073115e44648$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $0cf1073115e44648$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $0cf1073115e44648$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $0cf1073115e44648$var$i = 0; $0cf1073115e44648$var$i < 10; $0cf1073115e44648$var$i++)$0cf1073115e44648$export$e2253033e6e1df16[48 + $0cf1073115e44648$var$i] = $0cf1073115e44648$export$e2253033e6e1df16[96 + $0cf1073115e44648$var$i] = String($0cf1073115e44648$var$i);
// The function keys
for(var $0cf1073115e44648$var$i = 1; $0cf1073115e44648$var$i <= 24; $0cf1073115e44648$var$i++)$0cf1073115e44648$export$e2253033e6e1df16[$0cf1073115e44648$var$i + 111] = "F" + $0cf1073115e44648$var$i;
// And the alphabetic keys
for(var $0cf1073115e44648$var$i = 65; $0cf1073115e44648$var$i <= 90; $0cf1073115e44648$var$i++){
    $0cf1073115e44648$export$e2253033e6e1df16[$0cf1073115e44648$var$i] = String.fromCharCode($0cf1073115e44648$var$i + 32);
    $0cf1073115e44648$export$fba63a578e423eb[$0cf1073115e44648$var$i] = String.fromCharCode($0cf1073115e44648$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $0cf1073115e44648$var$code in $0cf1073115e44648$export$e2253033e6e1df16)if (!$0cf1073115e44648$export$fba63a578e423eb.hasOwnProperty($0cf1073115e44648$var$code)) $0cf1073115e44648$export$fba63a578e423eb[$0cf1073115e44648$var$code] = $0cf1073115e44648$export$e2253033e6e1df16[$0cf1073115e44648$var$code];
function $0cf1073115e44648$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $0cf1073115e44648$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $0cf1073115e44648$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $0cf1073115e44648$export$fba63a578e423eb : $0cf1073115e44648$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}


function $49ddc340444673b0$export$2e2bcd8739ae039() {
    var elt = arguments[0];
    if (typeof elt == "string") elt = document.createElement(elt);
    var i = 1, next = arguments[1];
    if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
        for(var name in next)if (Object.prototype.hasOwnProperty.call(next, name)) {
            var value = next[name];
            if (typeof value == "string") elt.setAttribute(name, value);
            else if (value != null) elt[name] = value;
        }
        i++;
    }
    for(; i < arguments.length; i++)$49ddc340444673b0$var$add(elt, arguments[i]);
    return elt;
}
function $49ddc340444673b0$var$add(elt, child) {
    if (typeof child == "string") elt.appendChild(document.createTextNode(child));
    else if (child == null) ;
    else if (child.nodeType != null) elt.appendChild(child);
    else if (Array.isArray(child)) for(var i = 0; i < child.length; i++)$49ddc340444673b0$var$add(elt, child[i]);
    else throw new RangeError("Unsupported child node: " + child);
}


let $b3e9d73db824614e$var$nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
let $b3e9d73db824614e$var$doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
const $b3e9d73db824614e$var$ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec($b3e9d73db824614e$var$nav.userAgent);
const $b3e9d73db824614e$var$ie_upto10 = /*@__PURE__*/ /MSIE \d/.test($b3e9d73db824614e$var$nav.userAgent);
const $b3e9d73db824614e$var$ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($b3e9d73db824614e$var$nav.userAgent);
const $b3e9d73db824614e$var$ie = !!($b3e9d73db824614e$var$ie_upto10 || $b3e9d73db824614e$var$ie_11up || $b3e9d73db824614e$var$ie_edge);
const $b3e9d73db824614e$var$gecko = !$b3e9d73db824614e$var$ie && /*@__PURE__*/ /gecko\/(\d+)/i.test($b3e9d73db824614e$var$nav.userAgent);
const $b3e9d73db824614e$var$chrome = !$b3e9d73db824614e$var$ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec($b3e9d73db824614e$var$nav.userAgent);
const $b3e9d73db824614e$var$webkit = "webkitFontSmoothing" in $b3e9d73db824614e$var$doc.documentElement.style;
const $b3e9d73db824614e$var$safari = !$b3e9d73db824614e$var$ie && /*@__PURE__*/ /Apple Computer/.test($b3e9d73db824614e$var$nav.vendor);
const $b3e9d73db824614e$var$ios = $b3e9d73db824614e$var$safari && /*@__PURE__*/ (/Mobile\/\w+/.test($b3e9d73db824614e$var$nav.userAgent) || $b3e9d73db824614e$var$nav.maxTouchPoints > 2);
var $b3e9d73db824614e$var$browser = {
    mac: $b3e9d73db824614e$var$ios || /*@__PURE__*/ /Mac/.test($b3e9d73db824614e$var$nav.platform),
    windows: /*@__PURE__*/ /Win/.test($b3e9d73db824614e$var$nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test($b3e9d73db824614e$var$nav.platform),
    ie: $b3e9d73db824614e$var$ie,
    ie_version: $b3e9d73db824614e$var$ie_upto10 ? $b3e9d73db824614e$var$doc.documentMode || 6 : $b3e9d73db824614e$var$ie_11up ? +$b3e9d73db824614e$var$ie_11up[1] : $b3e9d73db824614e$var$ie_edge ? +$b3e9d73db824614e$var$ie_edge[1] : 0,
    gecko: $b3e9d73db824614e$var$gecko,
    gecko_version: $b3e9d73db824614e$var$gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec($b3e9d73db824614e$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!$b3e9d73db824614e$var$chrome,
    chrome_version: $b3e9d73db824614e$var$chrome ? +$b3e9d73db824614e$var$chrome[1] : 0,
    ios: $b3e9d73db824614e$var$ios,
    android: /*@__PURE__*/ /Android\b/.test($b3e9d73db824614e$var$nav.userAgent),
    webkit: $b3e9d73db824614e$var$webkit,
    webkit_version: $b3e9d73db824614e$var$webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec($b3e9d73db824614e$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    safari: $b3e9d73db824614e$var$safari,
    safari_version: $b3e9d73db824614e$var$safari ? +/*@__PURE__*/ (/\bVersion\/(\d+(\.\d+)?)/.exec($b3e9d73db824614e$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: $b3e9d73db824614e$var$doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
function $b3e9d73db824614e$var$combineAttrs(source, target) {
    for(let name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
const $b3e9d73db824614e$var$noAttrs = /*@__PURE__*/ Object.create(null);
function $b3e9d73db824614e$var$attrsEq(a, b, ignore) {
    if (a == b) return true;
    if (!a) a = $b3e9d73db824614e$var$noAttrs;
    if (!b) b = $b3e9d73db824614e$var$noAttrs;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0)) return false;
    for (let key of keysA){
        if (key != ignore && (keysB.indexOf(key) == -1 || a[key] !== b[key])) return false;
    }
    return true;
}
function $b3e9d73db824614e$var$setAttrs(dom, attrs) {
    for(let i = dom.attributes.length - 1; i >= 0; i--){
        let name = dom.attributes[i].name;
        if (attrs[name] == null) dom.removeAttribute(name);
    }
    for(let name in attrs){
        let value = attrs[name];
        if (name == "style") dom.style.cssText = value;
        else if (dom.getAttribute(name) != value) dom.setAttribute(name, value);
    }
}
function $b3e9d73db824614e$var$updateAttrs(dom, prev, attrs) {
    let changed = false;
    if (prev) {
        for(let name in prev)if (!(attrs && name in attrs)) {
            changed = true;
            if (name == "style") dom.style.cssText = "";
            else dom.removeAttribute(name);
        }
    }
    if (attrs) {
        for(let name in attrs)if (!(prev && prev[name] == attrs[name])) {
            changed = true;
            if (name == "style") dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    return changed;
}
function $b3e9d73db824614e$var$getAttrs(dom) {
    let attrs = Object.create(null);
    for(let i = 0; i < dom.attributes.length; i++){
        let attr = dom.attributes[i];
        attrs[attr.name] = attr.value;
    }
    return attrs;
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class $b3e9d73db824614e$export$95cdd842edb044c5 {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom, view, from) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    For inline widgets that are displayed inline (as opposed to
    `inline-block`) and introduce line breaks (through `<br>` tags
    or textual newlines), this must indicate the amount of line
    breaks they introduce. Defaults to 0.
    */ get lineBreaks() {
        return 0;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    Override the way screen coordinates for positions at/in the
    widget are found. `pos` will be the offset into the widget, and
    `side` the side of the position that is being queried—less than
    zero for before, greater than zero for after, and zero for
    directly at that position.
    */ coordsAt(dom, pos, side) {
        return null;
    }
    /**
    @internal
    */ get isHidden() {
        return false;
    }
    /**
    @internal
    */ get editable() {
        return false;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var $b3e9d73db824614e$export$48808c686fe495c4 = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}($b3e9d73db824614e$export$48808c686fe495c4 || ($b3e9d73db824614e$export$48808c686fe495c4 = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class $b3e9d73db824614e$export$10e30b733df217ea extends (0, $3ef527dddcdea745$export$d60f08ed93a48611) {
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new $b3e9d73db824614e$var$MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        let side = Math.max(-10000, Math.min(10000, spec.side || 0)), block = !!spec.block;
        side += block && !spec.inlineOrder ? side > 0 ? 300000000 /* Side.BlockAfter */  : -400000000 /* Side.BlockBefore */  : side > 0 ? 100000000 /* Side.InlineAfter */  : -100000000 /* Side.InlineBefore */ ;
        return new $b3e9d73db824614e$var$PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        let block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* Side.GapStart */ ;
            endSide = 400000000 /* Side.GapEnd */ ;
        } else {
            let { start: start, end: end } = $b3e9d73db824614e$var$getInclusive(spec, block);
            startSide = (start ? block ? -300000000 /* Side.BlockIncStart */  : -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* Side.BlockIncEnd */  : 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ ) + 1;
        }
        return new $b3e9d73db824614e$var$PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new $b3e9d73db824614e$var$LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of, sort = false) {
        return (0, $3ef527dddcdea745$export$34cb5241245008dd).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
}
/**
The empty set of decorations.
*/ $b3e9d73db824614e$export$10e30b733df217ea.none = (0, $3ef527dddcdea745$export$34cb5241245008dd).empty;
class $b3e9d73db824614e$var$MarkDecoration extends $b3e9d73db824614e$export$10e30b733df217ea {
    constructor(spec){
        let { start: start, end: end } = $b3e9d73db824614e$var$getInclusive(spec);
        super(start ? -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ , end ? 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.attrs = spec.class && spec.attributes ? $b3e9d73db824614e$var$combineAttrs(spec.attributes, {
            class: spec.class
        }) : spec.class ? {
            class: spec.class
        } : spec.attributes || $b3e9d73db824614e$var$noAttrs;
    }
    eq(other) {
        return this == other || other instanceof $b3e9d73db824614e$var$MarkDecoration && this.tagName == other.tagName && $b3e9d73db824614e$var$attrsEq(this.attrs, other.attrs);
    }
    range(from, to = from) {
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
}
$b3e9d73db824614e$var$MarkDecoration.prototype.point = false;
class $b3e9d73db824614e$var$LineDecoration extends $b3e9d73db824614e$export$10e30b733df217ea {
    constructor(spec){
        super(-200000000 /* Side.Line */ , -200000000 /* Side.Line */ , null, spec);
    }
    eq(other) {
        return other instanceof $b3e9d73db824614e$var$LineDecoration && this.spec.class == other.spec.class && $b3e9d73db824614e$var$attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from, to = from) {
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
}
$b3e9d73db824614e$var$LineDecoration.prototype.mapMode = (0, $3ef527dddcdea745$export$39cf3280165f92aa).TrackBefore;
$b3e9d73db824614e$var$LineDecoration.prototype.point = true;
class $b3e9d73db824614e$var$PointDecoration extends $b3e9d73db824614e$export$10e30b733df217ea {
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, $3ef527dddcdea745$export$39cf3280165f92aa).TrackDel : startSide <= 0 ? (0, $3ef527dddcdea745$export$39cf3280165f92aa).TrackBefore : (0, $3ef527dddcdea745$export$39cf3280165f92aa).TrackAfter;
    }
    // Only relevant when this.block == true
    get type() {
        return this.startSide != this.endSide ? $b3e9d73db824614e$export$48808c686fe495c4.WidgetRange : this.startSide <= 0 ? $b3e9d73db824614e$export$48808c686fe495c4.WidgetBefore : $b3e9d73db824614e$export$48808c686fe495c4.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
    }
    eq(other) {
        return other instanceof $b3e9d73db824614e$var$PointDecoration && $b3e9d73db824614e$var$widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from, to = from) {
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
}
$b3e9d73db824614e$var$PointDecoration.prototype.point = true;
function $b3e9d73db824614e$var$getInclusive(spec, block = false) {
    let { inclusiveStart: start, inclusiveEnd: end } = spec;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function $b3e9d73db824614e$var$widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function $b3e9d73db824614e$var$addRange(from, to, ranges, margin = 0) {
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
/**
A block wrapper defines a DOM node that wraps lines or other block
wrappers at the top of the document. It affects any line or block
widget that starts inside its range, including blocks starting
directly at `from` but not including `to`.
*/ class $b3e9d73db824614e$export$b9b108b497733374 extends (0, $3ef527dddcdea745$export$d60f08ed93a48611) {
    constructor(/**
    @internal
    */ tagName, /**
    @internal
    */ attributes, /**
    @internal
    */ rank){
        super();
        this.tagName = tagName;
        this.attributes = attributes;
        this.rank = rank;
    }
    eq(other) {
        return other == this || other instanceof $b3e9d73db824614e$export$b9b108b497733374 && this.tagName == other.tagName && $b3e9d73db824614e$var$attrsEq(this.attributes, other.attributes);
    }
    /**
    Create a block wrapper object with the given tag name and
    attributes.
    */ static create(spec) {
        return new $b3e9d73db824614e$export$b9b108b497733374(spec.tagName, spec.attributes || $b3e9d73db824614e$var$noAttrs, spec.rank == null ? 50 : Math.max(0, Math.min(spec.rank, 100)));
    }
    /**
    Create a range set from the given block wrapper ranges.
    */ static set(of, sort = false) {
        return (0, $3ef527dddcdea745$export$34cb5241245008dd).of(of, sort);
    }
}
$b3e9d73db824614e$export$b9b108b497733374.prototype.startSide = $b3e9d73db824614e$export$b9b108b497733374.prototype.endSide = -1;
function $b3e9d73db824614e$var$getSelection(root) {
    let target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function $b3e9d73db824614e$var$contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function $b3e9d73db824614e$var$hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return $b3e9d73db824614e$var$contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function $b3e9d73db824614e$var$clientRectsFor(dom) {
    if (dom.nodeType == 3) return $b3e9d73db824614e$var$textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function $b3e9d73db824614e$var$isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? $b3e9d73db824614e$var$scanFor(node, off, targetNode, targetOff, -1) || $b3e9d73db824614e$var$scanFor(node, off, targetNode, targetOff, 1) : false;
}
function $b3e9d73db824614e$var$domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function $b3e9d73db824614e$var$isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
function $b3e9d73db824614e$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $b3e9d73db824614e$var$maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = $b3e9d73db824614e$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? $b3e9d73db824614e$var$maxOffset(node) : 0;
        } else return false;
    }
}
function $b3e9d73db824614e$var$maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b3e9d73db824614e$var$flattenRect(rect, toLeft) {
    let { left: left, right: right } = rect;
    if (left == right) return rect;
    let x = toLeft ? left : right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function $b3e9d73db824614e$var$windowRect(win) {
    let vp = win.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function $b3e9d73db824614e$var$getScale(elt, rect) {
    let scaleX = rect.width / elt.offsetWidth;
    let scaleY = rect.height / elt.offsetHeight;
    if (scaleX > 0.995 && scaleX < 1.005 || !isFinite(scaleX) || Math.abs(rect.width - elt.offsetWidth) < 1) scaleX = 1;
    if (scaleY > 0.995 && scaleY < 1.005 || !isFinite(scaleY) || Math.abs(rect.height - elt.offsetHeight) < 1) scaleY = 1;
    return {
        scaleX: scaleX,
        scaleY: scaleY
    };
}
function $b3e9d73db824614e$var$scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    for(let cur = dom, stop = false; cur && !stop;){
        if (cur.nodeType == 1) {
            let bounding, top = cur == doc.body;
            let scaleX = 1, scaleY = 1;
            if (top) bounding = $b3e9d73db824614e$var$windowRect(win);
            else {
                if (/^(fixed|sticky)$/.test(getComputedStyle(cur).position)) stop = true;
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.assignedSlot || cur.parentNode;
                    continue;
                }
                let rect = cur.getBoundingClientRect();
                ({ scaleX: scaleX, scaleY: scaleY } = $b3e9d73db824614e$var$getScale(cur, rect));
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: rect.left,
                    right: rect.left + cur.clientWidth * scaleX,
                    top: rect.top,
                    bottom: rect.top + cur.clientHeight * scaleY
                };
            }
            let moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top + yMargin) {
                    moveY = rect.top - (bounding.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + yMargin;
                } else if (rect.bottom > bounding.bottom - yMargin) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = rect.top - (bounding.top + yMargin);
                }
            } else {
                let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left + xMargin) {
                    moveX = rect.left - (bounding.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + xMargin;
                } else if (rect.right > bounding.right - xMargin) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = rect.left - (bounding.left + xMargin);
                }
            } else {
                let targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    let movedX = 0, movedY = 0;
                    if (moveY) {
                        let start = cur.scrollTop;
                        cur.scrollTop += moveY / scaleY;
                        movedY = (cur.scrollTop - start) * scaleY;
                    }
                    if (moveX) {
                        let start = cur.scrollLeft;
                        cur.scrollLeft += moveX / scaleX;
                        movedX = (cur.scrollLeft - start) * scaleX;
                    }
                    rect = {
                        left: rect.left - movedX,
                        top: rect.top - movedY,
                        right: rect.right - movedX,
                        bottom: rect.bottom - movedY
                    };
                    if (movedX && Math.abs(movedX - moveX) < 1) x = "nearest";
                    if (movedY && Math.abs(movedY - moveY) < 1) y = "nearest";
                }
            }
            if (top) break;
            if (rect.top < bounding.top || rect.bottom > bounding.bottom || rect.left < bounding.left || rect.right > bounding.right) rect = {
                left: Math.max(rect.left, bounding.left),
                right: Math.min(rect.right, bounding.right),
                top: Math.max(rect.top, bounding.top),
                bottom: Math.min(rect.bottom, bounding.bottom)
            };
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
function $b3e9d73db824614e$var$scrollableParents(dom, getX = true) {
    let doc = dom.ownerDocument, x = null, y = null;
    for(let cur = dom.parentNode; cur;){
        if (cur == doc.body || (!getX || x) && y) break;
        else if (cur.nodeType == 1) {
            if (!y && cur.scrollHeight > cur.clientHeight) y = cur;
            if (getX && !x && cur.scrollWidth > cur.clientWidth) x = cur;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
    return {
        x: x,
        y: y
    };
}
class $b3e9d73db824614e$var$DOMSelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        let { anchorNode: anchorNode, focusNode: focusNode } = range;
        // Clip offsets to node size to avoid crashes when Safari reports bogus offsets (#1152)
        this.set(anchorNode, Math.min(range.anchorOffset, anchorNode ? $b3e9d73db824614e$var$maxOffset(anchorNode) : 0), focusNode, Math.min(range.focusOffset, focusNode ? $b3e9d73db824614e$var$maxOffset(focusNode) : 0));
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
}
function $b3e9d73db824614e$var$getScrollStack(target) {
    let stack = [];
    for(let cur = target; cur; cur = cur.nodeType == 11 ? cur.host : cur.parentNode)if (cur.nodeType == 1) stack.push({
        node: cur,
        left: cur.scrollLeft,
        top: cur.scrollTop
    });
    return stack;
}
function $b3e9d73db824614e$var$restoreScrollStack(stack, vert = true) {
    for (let { node: node, left: left, top: top } of stack){
        if (vert && node.scrollTop != top) node.scrollTop = top;
        if (node.scrollLeft != left) node.scrollLeft = left;
    }
}
let $b3e9d73db824614e$var$preventScrollSupported = null;
// Safari 26 breaks preventScroll support
if ($b3e9d73db824614e$var$browser.safari && $b3e9d73db824614e$var$browser.safari_version >= 26) $b3e9d73db824614e$var$preventScrollSupported = false;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $b3e9d73db824614e$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($b3e9d73db824614e$var$preventScrollSupported) return dom.focus($b3e9d73db824614e$var$preventScrollSupported);
    let stack = $b3e9d73db824614e$var$getScrollStack(dom);
    dom.focus($b3e9d73db824614e$var$preventScrollSupported == null ? {
        get preventScroll () {
            $b3e9d73db824614e$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$b3e9d73db824614e$var$preventScrollSupported) {
        $b3e9d73db824614e$var$preventScrollSupported = false;
        $b3e9d73db824614e$var$restoreScrollStack(stack);
    }
}
let $b3e9d73db824614e$var$scratchRange;
function $b3e9d73db824614e$var$textRange(node, from, to = from) {
    let range = $b3e9d73db824614e$var$scratchRange || ($b3e9d73db824614e$var$scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function $b3e9d73db824614e$var$dispatchKey(elt, name, code, mods) {
    let options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    if (mods) ({ altKey: options.altKey, ctrlKey: options.ctrlKey, shiftKey: options.shiftKey, metaKey: options.metaKey } = mods);
    let down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    let up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function $b3e9d73db824614e$var$getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function $b3e9d73db824614e$var$atElementStart(doc, selection) {
    let node = selection.focusNode, offset = selection.focusOffset;
    if (!node || selection.anchorNode != node || selection.anchorOffset != offset) return false;
    // Safari can report bogus offsets (#1152)
    offset = Math.min(offset, $b3e9d73db824614e$var$maxOffset(node));
    for(;;){
        if (offset) {
            if (node.nodeType != 1) return false;
            let prev = node.childNodes[offset - 1];
            if (prev.contentEditable == "false") offset--;
            else {
                node = prev;
                offset = $b3e9d73db824614e$var$maxOffset(node);
            }
        } else if (node == doc) return true;
        else {
            offset = $b3e9d73db824614e$var$domIndex(node);
            node = node.parentNode;
        }
    }
}
function $b3e9d73db824614e$var$isScrolledToBottom(elt) {
    if (elt instanceof Window) return elt.pageYOffset > Math.max(0, elt.document.documentElement.scrollHeight - elt.innerHeight - 4);
    return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
function $b3e9d73db824614e$var$textNodeBefore(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset > 0) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $b3e9d73db824614e$var$maxOffset(node);
        } else if (node.parentNode && !$b3e9d73db824614e$var$isBlockElement(node)) {
            offset = $b3e9d73db824614e$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $b3e9d73db824614e$var$textNodeAfter(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$b3e9d73db824614e$var$isBlockElement(node)) {
            offset = $b3e9d73db824614e$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
class $b3e9d73db824614e$var$DOMPos {
    constructor(node, offset, precise = true){
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
    static before(dom, precise) {
        return new $b3e9d73db824614e$var$DOMPos(dom.parentNode, $b3e9d73db824614e$var$domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new $b3e9d73db824614e$var$DOMPos(dom.parentNode, $b3e9d73db824614e$var$domIndex(dom) + 1, precise);
    }
}
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var $b3e9d73db824614e$export$cacd6541cfeeb6c1 = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}($b3e9d73db824614e$export$cacd6541cfeeb6c1 || ($b3e9d73db824614e$export$cacd6541cfeeb6c1 = {}));
const $b3e9d73db824614e$var$LTR = $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR, $b3e9d73db824614e$var$RTL = $b3e9d73db824614e$export$cacd6541cfeeb6c1.RTL;
// Decode a string with each type encoded as log2(type)
function $b3e9d73db824614e$var$dec(str) {
    let result = [];
    for(let i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
const $b3e9d73db824614e$var$LowTypes = /*@__PURE__*/ $b3e9d73db824614e$var$dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
const $b3e9d73db824614e$var$ArabicTypes = /*@__PURE__*/ $b3e9d73db824614e$var$dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const $b3e9d73db824614e$var$Brackets = /*@__PURE__*/ Object.create(null), $b3e9d73db824614e$var$BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for (let p of [
    "()",
    "[]",
    "{}"
]){
    let l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    $b3e9d73db824614e$var$Brackets[l] = r;
    $b3e9d73db824614e$var$Brackets[r] = -l;
}
function $b3e9d73db824614e$var$charType(ch) {
    return ch <= 0xf7 ? $b3e9d73db824614e$var$LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* T.R */  : 0x600 <= ch && ch <= 0x6f9 ? $b3e9d73db824614e$var$ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* T.AL */  : 0x2000 <= ch && ch <= 0x200c ? 256 /* T.NI */  : 0xfb50 <= ch && ch <= 0xfdff ? 4 /* T.AL */  : 1 /* T.L */ ;
}
const $b3e9d73db824614e$var$BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class $b3e9d73db824614e$export$e1ed96b746bb516a {
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? $b3e9d73db824614e$var$RTL : $b3e9d73db824614e$var$LTR;
    }
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ forward(forward, dir) {
        return forward == (this.dir == dir);
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        let maybe = -1;
        for(let i = 0; i < order.length; i++){
            let span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
}
function $b3e9d73db824614e$var$isolatesEq(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++){
        let iA = a[i], iB = b[i];
        if (iA.from != iB.from || iA.to != iB.to || iA.direction != iB.direction || !$b3e9d73db824614e$var$isolatesEq(iA.inner, iB.inner)) return false;
    }
    return true;
}
// Reused array of character types
const $b3e9d73db824614e$var$types = [];
// Fill in the character types (in `types`) from `from` to `to` and
// apply W normalization rules.
function $b3e9d73db824614e$var$computeCharTypes(line, rFrom, rTo, isolates, outerType) {
    for(let iI = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        let prevType = iI ? 256 /* T.NI */  : outerType;
        // W1. Examine each non-spacing mark (NSM) in the level run, and
        // change the type of the NSM to the type of the previous
        // character. If the NSM is at the start of the level run, it will
        // get the type of sor.
        // W2. Search backwards from each instance of a European number
        // until the first strong type (R, L, AL, or sor) is found. If an
        // AL is found, change the type of the European number to Arabic
        // number.
        // W3. Change all ALs to R.
        // (Left after this: L, R, EN, AN, ET, CS, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $b3e9d73db824614e$var$charType(line.charCodeAt(i));
            if (type == 512 /* T.NSM */ ) type = prev;
            else if (type == 8 /* T.EN */  && prevStrong == 4 /* T.AL */ ) type = 16 /* T.AN */ ;
            $b3e9d73db824614e$var$types[i] = type == 4 /* T.AL */  ? 2 /* T.R */  : type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
            prev = type;
        }
        // W5. A sequence of European terminators adjacent to European
        // numbers changes to all European numbers.
        // W6. Otherwise, separators and terminators change to Other
        // Neutral.
        // W7. Search backwards from each instance of a European number
        // until the first strong type (R, L, or sor) is found. If an L is
        // found, then change the type of the European number to L.
        // (Left after this: L, R, EN+AN, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $b3e9d73db824614e$var$types[i];
            if (type == 128 /* T.CS */ ) {
                if (i < to - 1 && prev == $b3e9d73db824614e$var$types[i + 1] && prev & 24 /* T.Num */ ) type = $b3e9d73db824614e$var$types[i] = prev;
                else $b3e9d73db824614e$var$types[i] = 256 /* T.NI */ ;
            } else if (type == 64 /* T.ET */ ) {
                let end = i + 1;
                while(end < to && $b3e9d73db824614e$var$types[end] == 64 /* T.ET */ )end++;
                let replace = i && prev == 8 /* T.EN */  || end < rTo && $b3e9d73db824614e$var$types[end] == 8 /* T.EN */  ? prevStrong == 1 /* T.L */  ? 1 /* T.L */  : 8 /* T.EN */  : 256 /* T.NI */ ;
                for(let j = i; j < end; j++)$b3e9d73db824614e$var$types[j] = replace;
                i = end - 1;
            } else if (type == 8 /* T.EN */  && prevStrong == 1 /* T.L */ ) $b3e9d73db824614e$var$types[i] = 1 /* T.L */ ;
            prev = type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
        }
    }
}
// Process brackets throughout a run sequence.
function $b3e9d73db824614e$var$processBracketPairs(line, rFrom, rTo, isolates, outerType) {
    let oppositeType = outerType == 1 /* T.L */  ? 2 /* T.R */  : 1 /* T.L */ ;
    for(let iI = 0, sI = 0, context = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N0. Process bracket pairs in an isolating run sequence
        // sequentially in the logical order of the text positions of the
        // opening paired brackets using the logic given below. Within this
        // scope, bidirectional types EN and AN are treated as R.
        for(let i = from, ch, br, type; i < to; i++){
            // Keeps [startIndex, type, strongSeen] triples for each open
            // bracket on BracketStack.
            if (br = $b3e9d73db824614e$var$Brackets[ch = line.charCodeAt(i)]) {
                if (br < 0) {
                    for(let sJ = sI - 3; sJ >= 0; sJ -= 3)if ($b3e9d73db824614e$var$BracketStack[sJ + 1] == -br) {
                        let flags = $b3e9d73db824614e$var$BracketStack[sJ + 2];
                        let type = flags & 2 /* Bracketed.EmbedInside */  ? outerType : !(flags & 4 /* Bracketed.OppositeInside */ ) ? 0 : flags & 1 /* Bracketed.OppositeBefore */  ? oppositeType : outerType;
                        if (type) $b3e9d73db824614e$var$types[i] = $b3e9d73db824614e$var$types[$b3e9d73db824614e$var$BracketStack[sJ]] = type;
                        sI = sJ;
                        break;
                    }
                } else if ($b3e9d73db824614e$var$BracketStack.length == 189 /* Bracketed.MaxDepth */ ) break;
                else {
                    $b3e9d73db824614e$var$BracketStack[sI++] = i;
                    $b3e9d73db824614e$var$BracketStack[sI++] = ch;
                    $b3e9d73db824614e$var$BracketStack[sI++] = context;
                }
            } else if ((type = $b3e9d73db824614e$var$types[i]) == 2 /* T.R */  || type == 1 /* T.L */ ) {
                let embed = type == outerType;
                context = embed ? 0 : 1 /* Bracketed.OppositeBefore */ ;
                for(let sJ = sI - 3; sJ >= 0; sJ -= 3){
                    let cur = $b3e9d73db824614e$var$BracketStack[sJ + 2];
                    if (cur & 2 /* Bracketed.EmbedInside */ ) break;
                    if (embed) $b3e9d73db824614e$var$BracketStack[sJ + 2] |= 2 /* Bracketed.EmbedInside */ ;
                    else {
                        if (cur & 4 /* Bracketed.OppositeInside */ ) break;
                        $b3e9d73db824614e$var$BracketStack[sJ + 2] |= 4 /* Bracketed.OppositeInside */ ;
                    }
                }
            }
        }
    }
}
function $b3e9d73db824614e$var$processNeutrals(rFrom, rTo, isolates, outerType) {
    for(let iI = 0, prev = outerType; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N1. A sequence of neutrals takes the direction of the
        // surrounding strong text if the text on both sides has the same
        // direction. European and Arabic numbers act as if they were R in
        // terms of their influence on neutrals. Start-of-level-run (sor)
        // and end-of-level-run (eor) are used at level run boundaries.
        // N2. Any remaining neutrals take the embedding direction.
        // (Left after this: L, R, EN+AN)
        for(let i = from; i < to;){
            let type = $b3e9d73db824614e$var$types[i];
            if (type == 256 /* T.NI */ ) {
                let end = i + 1;
                for(;;){
                    if (end == to) {
                        if (iI == isolates.length) break;
                        end = isolates[iI++].to;
                        to = iI < isolates.length ? isolates[iI].from : rTo;
                    } else if ($b3e9d73db824614e$var$types[end] == 256 /* T.NI */ ) end++;
                    else break;
                }
                let beforeL = prev == 1 /* T.L */ ;
                let afterL = (end < rTo ? $b3e9d73db824614e$var$types[end] : outerType) == 1 /* T.L */ ;
                let replace = beforeL == afterL ? beforeL ? 1 /* T.L */  : 2 /* T.R */  : outerType;
                for(let j = end, jI = iI, fromJ = jI ? isolates[jI - 1].to : rFrom; j > i;){
                    if (j == fromJ) {
                        j = isolates[--jI].from;
                        fromJ = jI ? isolates[jI - 1].to : rFrom;
                    }
                    $b3e9d73db824614e$var$types[--j] = replace;
                }
                i = end;
            } else {
                prev = type;
                i++;
            }
        }
    }
}
// Find the contiguous ranges of character types in a given range, and
// emit spans for them. Flip the order of the spans as appropriate
// based on the level, and call through to compute the spans for
// isolates at the proper point.
function $b3e9d73db824614e$var$emitSpans(line, from, to, level, baseLevel, isolates, order) {
    let ourType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    if (level % 2 == baseLevel % 2) for(let iCh = from, iI = 0; iCh < to;){
        // Scan a section of characters in direction ourType, unless
        // there's another type of char right after iCh, in which case
        // we scan a section of other characters (which, if ourType ==
        // T.L, may contain both T.R and T.AN chars).
        let sameDir = true, isNum = false;
        if (iI == isolates.length || iCh < isolates[iI].from) {
            let next = $b3e9d73db824614e$var$types[iCh];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        // Holds an array of isolates to pass to a recursive call if we
        // must recurse (to distinguish T.AN inside an RTL section in
        // LTR text), null if we can emit directly
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI < isolates.length && iScan == isolates[iI].from) {
                if (isNum) break run;
                let iso = isolates[iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.to, jI = iI + 1;;){
                    if (upto == to) break run;
                    if (jI < isolates.length && isolates[jI].from == upto) upto = isolates[jI++].to;
                    else if ($b3e9d73db824614e$var$types[upto] == ourType) break run;
                    else break;
                }
                iI++;
                if (recurse) recurse.push(iso);
                else {
                    if (iso.from > iCh) order.push(new $b3e9d73db824614e$export$e1ed96b746bb516a(iCh, iso.from, localLevel));
                    let dirSwap = iso.direction == $b3e9d73db824614e$var$LTR != !(localLevel % 2);
                    $b3e9d73db824614e$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.to;
                }
                iScan = iso.to;
            } else if (iScan == to || (sameDir ? $b3e9d73db824614e$var$types[iScan] != ourType : $b3e9d73db824614e$var$types[iScan] == ourType)) break;
            else iScan++;
        }
        if (recurse) $b3e9d73db824614e$var$emitSpans(line, iCh, iScan, level + 1, baseLevel, recurse, order);
        else if (iCh < iScan) order.push(new $b3e9d73db824614e$export$e1ed96b746bb516a(iCh, iScan, localLevel));
        iCh = iScan;
    }
    else // Iterate in reverse to flip the span order. Same code again, but
    // going from the back of the section to the front
    for(let iCh = to, iI = isolates.length; iCh > from;){
        let sameDir = true, isNum = false;
        if (!iI || iCh > isolates[iI - 1].to) {
            let next = $b3e9d73db824614e$var$types[iCh - 1];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI && iScan == isolates[iI - 1].to) {
                if (isNum) break run;
                let iso = isolates[--iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.from, jI = iI;;){
                    if (upto == from) break run;
                    if (jI && isolates[jI - 1].to == upto) upto = isolates[--jI].from;
                    else if ($b3e9d73db824614e$var$types[upto - 1] == ourType) break run;
                    else break;
                }
                if (recurse) recurse.push(iso);
                else {
                    if (iso.to < iCh) order.push(new $b3e9d73db824614e$export$e1ed96b746bb516a(iso.to, iCh, localLevel));
                    let dirSwap = iso.direction == $b3e9d73db824614e$var$LTR != !(localLevel % 2);
                    $b3e9d73db824614e$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.from;
                }
                iScan = iso.from;
            } else if (iScan == from || (sameDir ? $b3e9d73db824614e$var$types[iScan - 1] != ourType : $b3e9d73db824614e$var$types[iScan - 1] == ourType)) break;
            else iScan--;
        }
        if (recurse) $b3e9d73db824614e$var$emitSpans(line, iScan, iCh, level + 1, baseLevel, recurse, order);
        else if (iScan < iCh) order.push(new $b3e9d73db824614e$export$e1ed96b746bb516a(iScan, iCh, localLevel));
        iCh = iScan;
    }
}
function $b3e9d73db824614e$var$computeSectionOrder(line, level, baseLevel, isolates, from, to, order) {
    let outerType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    $b3e9d73db824614e$var$computeCharTypes(line, from, to, isolates, outerType);
    $b3e9d73db824614e$var$processBracketPairs(line, from, to, isolates, outerType);
    $b3e9d73db824614e$var$processNeutrals(from, to, isolates, outerType);
    $b3e9d73db824614e$var$emitSpans(line, from, to, level, baseLevel, isolates, order);
}
function $b3e9d73db824614e$var$computeOrder(line, direction, isolates) {
    if (!line) return [
        new $b3e9d73db824614e$export$e1ed96b746bb516a(0, 0, direction == $b3e9d73db824614e$var$RTL ? 1 : 0)
    ];
    if (direction == $b3e9d73db824614e$var$LTR && !isolates.length && !$b3e9d73db824614e$var$BidiRE.test(line)) return $b3e9d73db824614e$var$trivialOrder(line.length);
    if (isolates.length) while(line.length > $b3e9d73db824614e$var$types.length)$b3e9d73db824614e$var$types[$b3e9d73db824614e$var$types.length] = 256 /* T.NI */ ; // Make sure types array has no gaps
    let order = [], level = direction == $b3e9d73db824614e$var$LTR ? 0 : 1;
    $b3e9d73db824614e$var$computeSectionOrder(line, level, level, isolates, 0, line.length, order);
    return order;
}
function $b3e9d73db824614e$var$trivialOrder(length) {
    return [
        new $b3e9d73db824614e$export$e1ed96b746bb516a(0, length, 0)
    ];
}
let $b3e9d73db824614e$var$movedOver = "";
// This implementation moves strictly visually, without concern for a
// traversal visiting every logical position in the string. It will
// still do so for simple input, but situations like multiple isolates
// with the same level next to each other, or text going against the
// main dir at the end of the line, will make some positions
// unreachable with this motion. Each visible cursor position will
// correspond to the lower-level bidi span that touches it.
//
// The alternative would be to solve an order globally for a given
// line, making sure that it includes every position, but that would
// require associating non-canonical (higher bidi span level)
// positions with a given visual position, which is likely to confuse
// people. (And would generally be a lot more complicated.)
function $b3e9d73db824614e$var$moveVisually(line, order, dir, start, forward) {
    var _a;
    let startIndex = start.head - line.from;
    let spanI = $b3e9d73db824614e$export$e1ed96b746bb516a.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    let span = order[spanI], spanEnd = span.side(forward, dir);
    // End of span
    if (startIndex == spanEnd) {
        let nextI = spanI += forward ? 1 : -1;
        if (nextI < 0 || nextI >= order.length) return null;
        span = order[spanI = nextI];
        startIndex = span.side(!forward, dir);
        spanEnd = span.side(forward, dir);
    }
    let nextIndex = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, startIndex, span.forward(forward, dir));
    if (nextIndex < span.from || nextIndex > span.to) nextIndex = spanEnd;
    $b3e9d73db824614e$var$movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (nextSpan && nextIndex == spanEnd && nextSpan.level + (forward ? 0 : 1) < span.level) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(nextSpan.side(!forward, dir) + line.from, nextSpan.forward(forward, dir) ? 1 : -1, nextSpan.level);
    return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(nextIndex + line.from, span.forward(forward, dir) ? -1 : 1, span.level);
}
function $b3e9d73db824614e$var$autoDirection(text, from, to) {
    for(let i = from; i < to; i++){
        let type = $b3e9d73db824614e$var$charType(text.charCodeAt(i));
        if (type == 1 /* T.L */ ) return $b3e9d73db824614e$var$LTR;
        if (type == 2 /* T.R */  || type == 4 /* T.AL */ ) return $b3e9d73db824614e$var$RTL;
    }
    return $b3e9d73db824614e$var$LTR;
}
const $b3e9d73db824614e$var$clickAddsSelectionRange = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$dragMovesSelection$1 = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$mouseSelectionStyle = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$exceptionSink = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$updateListener = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$inputHandler = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$focusChangeEffect = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$clipboardInputFilter = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$clipboardOutputFilter = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$perLineTextDirection = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $b3e9d73db824614e$var$nativeSelectionHidden = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $b3e9d73db824614e$var$scrollHandler = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
class $b3e9d73db824614e$var$ScrollTarget {
    constructor(range, y, x, yMargin, xMargin, // This data structure is abused to also store precise scroll
    // snapshots, instead of a `scrollIntoView` request. When this
    // flag is `true`, `range` points at a position in the reference
    // line, `yMargin` holds the difference between the top of that
    // line and the top of the editor, and `xMargin` holds the
    // editor's `scrollLeft`.
    isSnapshot = false){
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
        this.isSnapshot = isSnapshot;
    }
    map(changes) {
        return changes.empty ? this : new $b3e9d73db824614e$var$ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
    clip(state) {
        return this.range.to <= state.doc.length ? this : new $b3e9d73db824614e$var$ScrollTarget((0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(state.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
}
const $b3e9d73db824614e$var$scrollIntoView = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define({
    map: (t, ch)=>t.map(ch)
});
const $b3e9d73db824614e$var$setEditContextFormatting = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function $b3e9d73db824614e$export$f86b2a1a2ce291b3(state, exception, context) {
    let handler = state.facet($b3e9d73db824614e$var$exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror && window.onerror(String(exception), context, undefined, undefined, exception)) ;
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
const $b3e9d73db824614e$var$editable = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : true
});
let $b3e9d73db824614e$var$nextPluginID = 0;
const $b3e9d73db824614e$var$viewPlugin = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (plugins) {
        return plugins.filter((p, i)=>{
            for(let j = 0; j < i; j++)if (plugins[j].plugin == p.plugin) return false;
            return true;
        });
    }
});
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view. They optionally take an argument, in
which case you need to call [`of`](https://codemirror.net/6/docs/ref/#view.ViewPlugin.of) to create
an extension for the plugin. When the argument type is undefined,
you can use the plugin instance as an extension directly.
*/ class $b3e9d73db824614e$export$44d5eccfd62adda7 {
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, /**
    @internal
    */ domEventObservers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.domEventObservers = domEventObservers;
        this.baseExtensions = buildExtensions(this);
        this.extension = this.baseExtensions.concat($b3e9d73db824614e$var$viewPlugin.of({
            plugin: this,
            arg: undefined
        }));
    }
    /**
    Create an extension for this plugin with the given argument.
    */ of(arg) {
        return this.baseExtensions.concat($b3e9d73db824614e$var$viewPlugin.of({
            plugin: this,
            arg: arg
        }));
    }
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        const { eventHandlers: eventHandlers, eventObservers: eventObservers, provide: provide, decorations: deco } = spec || {};
        return new $b3e9d73db824614e$export$44d5eccfd62adda7($b3e9d73db824614e$var$nextPluginID++, create, eventHandlers, eventObservers, (plugin)=>{
            let ext = [];
            if (deco) ext.push($b3e9d73db824614e$var$decorations.of((view)=>{
                let pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : $b3e9d73db824614e$export$10e30b733df217ea.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return $b3e9d73db824614e$export$44d5eccfd62adda7.define((view, arg)=>new cls(view, arg), spec);
    }
}
class $b3e9d73db824614e$var$PluginInstance {
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `null`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
    get plugin() {
        return this.spec && this.spec.plugin;
    }
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.plugin.create(view, this.spec.arg);
            } catch (e) {
                $b3e9d73db824614e$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            let update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                $b3e9d73db824614e$export$f86b2a1a2ce291b3(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            $b3e9d73db824614e$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
}
const $b3e9d73db824614e$var$editorAttributes = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$contentAttributes = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
// Provide decorations
const $b3e9d73db824614e$var$decorations = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$blockWrappers = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$outerDecorations = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$atomicRanges = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$bidiIsolatedRanges = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
function $b3e9d73db824614e$var$getIsolatedRanges(view, line) {
    let isolates = view.state.facet($b3e9d73db824614e$var$bidiIsolatedRanges);
    if (!isolates.length) return isolates;
    let sets = isolates.map((i)=>i instanceof Function ? i(view) : i);
    let result = [];
    (0, $3ef527dddcdea745$export$34cb5241245008dd).spans(sets, line.from, line.to, {
        point () {},
        span (fromDoc, toDoc, active, open) {
            let from = fromDoc - line.from, to = toDoc - line.from;
            let level = result;
            for(let i = active.length - 1; i >= 0; i--, open--){
                let direction = active[i].spec.bidiIsolate, update;
                if (direction == null) direction = $b3e9d73db824614e$var$autoDirection(line.text, from, to);
                if (open > 0 && level.length && (update = level[level.length - 1]).to == from && update.direction == direction) {
                    update.to = to;
                    level = update.inner;
                } else {
                    let add = {
                        from: from,
                        to: to,
                        direction: direction,
                        inner: []
                    };
                    level.push(add);
                    level = add.inner;
                }
            }
        }
    });
    return result;
}
const $b3e9d73db824614e$var$scrollMargins = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
function $b3e9d73db824614e$var$getScrollMargins(view) {
    let left = 0, right = 0, top = 0, bottom = 0;
    for (let source of view.state.facet($b3e9d73db824614e$var$scrollMargins)){
        let m = source(view);
        if (m) {
            if (m.left != null) left = Math.max(left, m.left);
            if (m.right != null) right = Math.max(right, m.right);
            if (m.top != null) top = Math.max(top, m.top);
            if (m.bottom != null) bottom = Math.max(bottom, m.bottom);
        }
    }
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
    };
}
const $b3e9d73db824614e$var$styleModule = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
class $b3e9d73db824614e$var$ChangedRange {
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
    join(other) {
        return new $b3e9d73db824614e$var$ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        let i = set.length, me = this;
        for(; i > 0; i--){
            let range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    // Extend a set to cover all the content in `ranges`, which is a
    // flat array with each pair of numbers representing fromB/toB
    // positions. These pairs are generated in unchanged ranges, so the
    // offset between doc A and doc B is the same for their start and
    // end points.
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        let result = [];
        for(let dI = 0, rI = 0, off = 0;;){
            let nextD = dI < diff.length ? diff[dI].fromB : 1e9;
            let nextR = rI < ranges.length ? ranges[rI] : 1e9;
            let fromB = Math.min(nextD, nextR);
            if (fromB == 1e9) break;
            let fromA = fromB + off, toB = fromB, toA = fromA;
            for(;;){
                if (rI < ranges.length && ranges[rI] <= toB) {
                    let end = ranges[rI + 1];
                    rI += 2;
                    toB = Math.max(toB, end);
                    for(let i = dI; i < diff.length && diff[i].fromB <= toB; i++)off = diff[i].toA - diff[i].toB;
                    toA = Math.max(toA, end + off);
                } else if (dI < diff.length && diff[dI].fromB <= toB) {
                    let next = diff[dI++];
                    toB = Math.max(toB, next.toB);
                    toA = Math.max(toA, next.toA);
                    off = next.toA - next.toB;
                } else break;
            }
            result.push(new $b3e9d73db824614e$var$ChangedRange(fromA, toA, fromB, toB));
        }
        return result;
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class $b3e9d73db824614e$export$b5b084f95c87edf7 {
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, $3ef527dddcdea745$export$29d7fbdcb1f8b71c).empty(this.startState.doc.length);
        for (let tr of transactions)this.changes = this.changes.compose(tr.changes);
        let changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new $b3e9d73db824614e$var$ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
    }
    /**
    @internal
    */ static create(view, state, transactions) {
        return new $b3e9d73db824614e$export$b5b084f95c87edf7(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* UpdateFlag.Viewport */ ) > 0;
    }
    /**
    Returns true when
    [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
    and the viewport change is not just the result of mapping it in
    response to document changes.
    */ get viewportMoved() {
        return (this.flags & 8 /* UpdateFlag.ViewportMoved */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 18 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* UpdateFlag.Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
}
const $b3e9d73db824614e$var$noChildren = [];
class $b3e9d73db824614e$var$Tile {
    constructor(dom, length, flags = 0){
        this.dom = dom;
        this.length = length;
        this.flags = flags;
        this.parent = null;
        dom.cmTile = this;
    }
    get breakAfter() {
        return this.flags & 1 /* TileFlag.BreakAfter */ ;
    }
    get children() {
        return $b3e9d73db824614e$var$noChildren;
    }
    isWidget() {
        return false;
    }
    get isHidden() {
        return false;
    }
    isComposite() {
        return false;
    }
    isLine() {
        return false;
    }
    isText() {
        return false;
    }
    isBlock() {
        return false;
    }
    get domAttrs() {
        return null;
    }
    sync(track) {
        this.flags |= 2 /* TileFlag.Synced */ ;
        if (this.flags & 4 /* TileFlag.AttrsDirty */ ) {
            this.flags &= -5 /* TileFlag.AttrsDirty */ ;
            let attrs = this.domAttrs;
            if (attrs) $b3e9d73db824614e$var$setAttrs(this.dom, attrs);
        }
    }
    toString() {
        return this.constructor.name + (this.children.length ? `(${this.children})` : "") + (this.breakAfter ? "#" : "");
    }
    destroy() {
        this.parent = null;
    }
    setDOM(dom) {
        this.dom = dom;
        dom.cmTile = this;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(tile, start = this.posAtStart) {
        let pos = start;
        for (let child of this.children){
            if (child == tile) return pos;
            pos += child.length + child.breakAfter;
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(tile) {
        return this.posBefore(tile) + tile.length;
    }
    covers(side) {
        return true;
    }
    coordsIn(pos, side, rtl) {
        return null;
    }
    domPosFor(off, side) {
        let index = $b3e9d73db824614e$var$domIndex(this.dom);
        let after = this.length ? off > 0 : side > 0;
        return new $b3e9d73db824614e$var$DOMPos(this.parent.dom, index + (after ? 1 : 0), off == 0 || off == this.length);
    }
    markDirty(attrs) {
        this.flags &= -3 /* TileFlag.Synced */ ;
        if (attrs) this.flags |= 4 /* TileFlag.AttrsDirty */ ;
        if (this.parent && this.parent.flags & 2 /* TileFlag.Synced */ ) this.parent.markDirty(false);
    }
    get overrideDOMText() {
        return null;
    }
    get root() {
        for(let t = this; t; t = t.parent)if (t instanceof $b3e9d73db824614e$var$DocTile) return t;
        return null;
    }
    static get(dom) {
        return dom.cmTile;
    }
}
class $b3e9d73db824614e$var$CompositeTile extends $b3e9d73db824614e$var$Tile {
    constructor(dom){
        super(dom, 0);
        this._children = [];
    }
    isComposite() {
        return true;
    }
    get children() {
        return this._children;
    }
    get lastChild() {
        return this.children.length ? this.children[this.children.length - 1] : null;
    }
    append(child) {
        this.children.push(child);
        child.parent = this;
    }
    sync(track) {
        if (this.flags & 2 /* TileFlag.Synced */ ) return;
        super.sync(track);
        let parent = this.dom, prev = null, next;
        let tracking = (track === null || track === void 0 ? void 0 : track.node) == parent ? track : null;
        let length = 0;
        for (let child of this.children){
            child.sync(track);
            length += child.length + child.breakAfter;
            next = prev ? prev.nextSibling : parent.firstChild;
            if (tracking && next != child.dom) tracking.written = true;
            if (child.dom.parentNode == parent) while(next && next != child.dom)next = $b3e9d73db824614e$var$rm$1(next);
            else parent.insertBefore(child.dom, next);
            prev = child.dom;
        }
        next = prev ? prev.nextSibling : parent.firstChild;
        if (tracking && next) tracking.written = true;
        while(next)next = $b3e9d73db824614e$var$rm$1(next);
        this.length = length;
    }
}
// Remove a DOM node and return its next sibling.
function $b3e9d73db824614e$var$rm$1(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// The top-level tile. Its dom property equals view.contentDOM.
class $b3e9d73db824614e$var$DocTile extends $b3e9d73db824614e$var$CompositeTile {
    constructor(view, dom){
        super(dom);
        this.view = view;
    }
    owns(tile) {
        for(; tile; tile = tile.parent)if (tile == this) return true;
        return false;
    }
    isBlock() {
        return true;
    }
    nearest(dom) {
        for(;;){
            if (!dom) return null;
            let tile = $b3e9d73db824614e$var$Tile.get(dom);
            if (tile && this.owns(tile)) return tile;
            dom = dom.parentNode;
        }
    }
    blockTiles(f) {
        for(let stack = [], cur = this, i = 0, pos = 0;;)if (i == cur.children.length) {
            if (!stack.length) return;
            cur = cur.parent;
            if (cur.breakAfter) pos++;
            i = stack.pop();
        } else {
            let next = cur.children[i++];
            if (next instanceof $b3e9d73db824614e$var$BlockWrapperTile) {
                stack.push(i);
                cur = next;
                i = 0;
            } else {
                let end = pos + next.length;
                let result = f(next, pos);
                if (result !== undefined) return result;
                pos = end + next.breakAfter;
            }
        }
    }
    // Find the block at the given position. If side < -1, make sure to
    // stay before block widgets at that position, if side > 1, after
    // such widgets (used for selection drawing, which needs to be able
    // to get coordinates for positions that aren't valid cursor positions).
    resolveBlock(pos, side) {
        let before, beforeOff = -1, after, afterOff = -1;
        this.blockTiles((tile, off)=>{
            let end = off + tile.length;
            if (pos >= off && pos <= end) {
                if (tile.isWidget() && side >= -1 && side <= 1) {
                    if (tile.flags & 32 /* TileFlag.After */ ) return true;
                    if (tile.flags & 16 /* TileFlag.Before */ ) before = undefined;
                }
                if ((off < pos || pos == end && (side < -1 ? tile.length : tile.covers(1))) && (!before || !tile.isWidget() && before.isWidget())) {
                    before = tile;
                    beforeOff = pos - off;
                }
                if ((end > pos || pos == off && (side > 1 ? tile.length : tile.covers(-1))) && (!after || !tile.isWidget() && after.isWidget())) {
                    after = tile;
                    afterOff = pos - off;
                }
            }
        });
        if (!before && !after) throw new Error("No tile at position " + pos);
        return before && side < 0 || !after ? {
            tile: before,
            offset: beforeOff
        } : {
            tile: after,
            offset: afterOff
        };
    }
}
class $b3e9d73db824614e$var$BlockWrapperTile extends $b3e9d73db824614e$var$CompositeTile {
    constructor(dom, wrapper){
        super(dom);
        this.wrapper = wrapper;
    }
    isBlock() {
        return true;
    }
    covers(side) {
        if (!this.children.length) return false;
        return side < 0 ? this.children[0].covers(-1) : this.lastChild.covers(1);
    }
    get domAttrs() {
        return this.wrapper.attributes;
    }
    static of(wrapper, dom) {
        let tile = new $b3e9d73db824614e$var$BlockWrapperTile(dom || document.createElement(wrapper.tagName), wrapper);
        if (!dom) tile.flags |= 4 /* TileFlag.AttrsDirty */ ;
        return tile;
    }
}
class $b3e9d73db824614e$var$LineTile extends $b3e9d73db824614e$var$CompositeTile {
    constructor(dom, attrs){
        super(dom);
        this.attrs = attrs;
    }
    isLine() {
        return true;
    }
    static start(attrs, dom, keepAttrs) {
        let line = new $b3e9d73db824614e$var$LineTile(dom || document.createElement("div"), attrs);
        if (!dom || !keepAttrs) line.flags |= 4 /* TileFlag.AttrsDirty */ ;
        return line;
    }
    get domAttrs() {
        return this.attrs;
    }
    // Find the tile associated with a given position in this line.
    // Side -2/2 is handled specially, in that it allows the position
    // returned to be before (-2) or after (2) widgets that would always
    // be after/before a cursor position.
    resolveInline(pos, side, forCoords) {
        let before = null, beforeOff = -1, after = null, afterOff = -1;
        function scan(tile, pos) {
            for(let i = 0, off = 0; i < tile.children.length && off <= pos; i++){
                let child = tile.children[i], end = off + child.length;
                if (end >= pos) {
                    if (child.isComposite()) scan(child, pos - off);
                    else if ((!after || after.isHidden && (side > 0 && !(after.flags & 32 /* TileFlag.After */ ) || forCoords && $b3e9d73db824614e$var$onSameLine(after, child))) && (end > pos || child.flags & 32 /* TileFlag.After */  && side <= 1)) {
                        after = child;
                        afterOff = pos - off;
                    } else if (off < pos || child.flags & 16 /* TileFlag.Before */  && !child.isHidden && side >= -1) {
                        before = child;
                        beforeOff = pos - off;
                    }
                }
                off = end;
            }
        }
        scan(this, pos);
        let target = (side < 0 ? before : after) || before || after;
        return target ? {
            tile: target,
            offset: target == before ? beforeOff : afterOff
        } : null;
    }
    coordsIn(pos, side, rtl) {
        let found = this.resolveInline(pos, side, true);
        if (!found) return $b3e9d73db824614e$var$fallbackRect(this);
        return found.tile.coordsIn(Math.max(0, found.offset), side, rtl);
    }
    domIn(pos, side) {
        let found = this.resolveInline(pos, side);
        if (found) {
            let { tile: tile, offset: offset } = found;
            if (this.dom.contains(tile.dom)) {
                if (tile.isText()) return new $b3e9d73db824614e$var$DOMPos(tile.dom, Math.min(tile.dom.nodeValue.length, offset));
                return tile.domPosFor(offset, tile.flags & 16 /* TileFlag.Before */  ? 1 : tile.flags & 32 /* TileFlag.After */  ? -1 : side);
            }
            let parent = found.tile.parent, saw = false;
            for (let ch of parent.children){
                if (saw) return new $b3e9d73db824614e$var$DOMPos(ch.dom, 0);
                if (ch == found.tile) saw = true;
            }
        }
        return new $b3e9d73db824614e$var$DOMPos(this.dom, 0);
    }
}
function $b3e9d73db824614e$var$fallbackRect(tile) {
    let last = tile.dom.lastChild;
    if (!last) return tile.dom.getBoundingClientRect();
    let rects = $b3e9d73db824614e$var$clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function $b3e9d73db824614e$var$onSameLine(a, b) {
    let posA = a.coordsIn(0, 1), posB = b.coordsIn(0, 1);
    return posA && posB && posB.top < posA.bottom;
}
class $b3e9d73db824614e$var$MarkTile extends $b3e9d73db824614e$var$CompositeTile {
    constructor(dom, mark){
        super(dom);
        this.mark = mark;
    }
    get domAttrs() {
        return this.mark.attrs;
    }
    static of(mark, dom) {
        let tile = new $b3e9d73db824614e$var$MarkTile(dom || document.createElement(mark.tagName), mark);
        if (!dom) tile.flags |= 4 /* TileFlag.AttrsDirty */ ;
        return tile;
    }
}
class $b3e9d73db824614e$var$TextTile extends $b3e9d73db824614e$var$Tile {
    constructor(dom, text){
        super(dom, text.length);
        this.text = text;
    }
    sync(track) {
        if (this.flags & 2 /* TileFlag.Synced */ ) return;
        super.sync(track);
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    isText() {
        return true;
    }
    toString() {
        return JSON.stringify(this.text);
    }
    coordsIn(pos, side, rtl) {
        let length = this.dom.nodeValue.length;
        if (pos > length) pos = length;
        let from = pos, to = pos, flatten = 0;
        if (pos == 0 && side < 0 || pos == length && side >= 0) {
            if (!($b3e9d73db824614e$var$browser.chrome || $b3e9d73db824614e$var$browser.gecko)) {
                if (pos) {
                    from--;
                    flatten = 1;
                } else if (to < length) {
                    to++;
                    flatten = -1;
                }
            }
        } else {
            if (side < 0) from--;
            else if (to < length) to++;
        }
        let rects = $b3e9d73db824614e$var$textRange(this.dom, from, to).getClientRects();
        if (!rects.length) return null;
        let rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
        if ($b3e9d73db824614e$var$browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
        return rtl == null ? rect : $b3e9d73db824614e$var$flattenRect(rect, (flatten ? flatten > 0 : side < 0) == rtl);
    }
    static of(text, dom) {
        let tile = new $b3e9d73db824614e$var$TextTile(dom || document.createTextNode(text), text);
        if (!dom) tile.flags |= 2 /* TileFlag.Synced */ ;
        return tile;
    }
}
class $b3e9d73db824614e$var$WidgetTile extends $b3e9d73db824614e$var$Tile {
    constructor(dom, length, widget, flags){
        super(dom, length, flags);
        this.widget = widget;
    }
    isWidget() {
        return true;
    }
    get isHidden() {
        return this.widget.isHidden;
    }
    covers(side) {
        if (this.flags & 48 /* TileFlag.PointWidget */ ) return false;
        return (this.flags & (side < 0 ? 64 /* TileFlag.IncStart */  : 128 /* TileFlag.IncEnd */ )) > 0;
    }
    coordsIn(pos, side) {
        return this.coordsInWidget(pos, side, false);
    }
    coordsInWidget(pos, side, block) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        if (block) return $b3e9d73db824614e$var$flattenRect(this.dom.getBoundingClientRect(), this.length ? pos == 0 : side <= 0);
        else {
            let rects = this.dom.getClientRects(), rect = null;
            if (!rects.length) return null;
            let fromBack = this.flags & 16 /* TileFlag.Before */  ? true : this.flags & 32 /* TileFlag.After */  ? false : pos > 0;
            for(let i = fromBack ? rects.length - 1 : 0;; i += fromBack ? -1 : 1){
                rect = rects[i];
                if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
            }
            return $b3e9d73db824614e$var$flattenRect(rect, !fromBack);
        }
    }
    get overrideDOMText() {
        if (!this.length) return (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).empty;
        let { root: root } = this;
        if (!root) return (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).empty;
        let start = this.posAtStart;
        return root.view.state.doc.slice(start, start + this.length);
    }
    destroy() {
        super.destroy();
        this.widget.destroy(this.dom);
    }
    static of(widget, view, length, flags, dom) {
        if (!dom) {
            dom = widget.toDOM(view);
            if (!widget.editable) dom.contentEditable = "false";
        }
        return new $b3e9d73db824614e$var$WidgetTile(dom, length, widget, flags);
    }
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class $b3e9d73db824614e$var$WidgetBufferTile extends $b3e9d73db824614e$var$Tile {
    constructor(flags){
        let img = document.createElement("img");
        img.className = "cm-widgetBuffer";
        img.setAttribute("aria-hidden", "true");
        super(img, 0, flags);
    }
    get isHidden() {
        return true;
    }
    get overrideDOMText() {
        return (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).empty;
    }
    coordsIn(pos, side, rtl) {
        let rect = this.dom.getBoundingClientRect();
        return rtl == null ? rect : $b3e9d73db824614e$var$flattenRect(rect, side > 0 == rtl);
    }
}
// Represents a position in the tile tree.
class $b3e9d73db824614e$var$TilePointer {
    constructor(top){
        this.index = 0;
        this.beforeBreak = false;
        this.parents = [];
        this.tile = top;
    }
    // Advance by the given distance. If side is -1, stop leaving or
    // entering tiles, or skipping zero-length tiles, once the distance
    // has been traversed. When side is 1, leave, enter, or skip
    // everything at the end position.
    advance(dist, side, walker) {
        let { tile: tile, index: index, beforeBreak: beforeBreak, parents: parents } = this;
        while(dist || side > 0){
            if (!tile.isComposite()) {
                let len = tile.length;
                if (index < len && dist) {
                    let take = Math.min(dist, len - index);
                    if (walker) walker.skip(tile, index, index + take);
                    dist -= take;
                    index += take;
                }
                if (index == len) {
                    beforeBreak = !!tile.breakAfter;
                    ({ tile: tile, index: index } = parents.pop());
                    index++;
                } else if (!dist) break;
            } else if (beforeBreak) {
                if (!dist) break;
                if (walker) walker.break();
                dist--;
                beforeBreak = false;
            } else if (index == tile.children.length) {
                if (!dist && !parents.length) break;
                if (walker) walker.leave(tile);
                beforeBreak = !!tile.breakAfter;
                ({ tile: tile, index: index } = parents.pop());
                index++;
            } else {
                let next = tile.children[index], brk = next.breakAfter;
                if ((side > 0 ? next.length <= dist : next.length < dist) && (!walker || walker.skip(next, 0, next.length) !== false || !next.isComposite)) {
                    beforeBreak = !!brk;
                    index++;
                    dist -= next.length;
                } else {
                    parents.push({
                        tile: tile,
                        index: index
                    });
                    tile = next;
                    index = 0;
                    if (walker && next.isComposite()) walker.enter(next);
                }
            }
        }
        this.tile = tile;
        this.index = index;
        this.beforeBreak = beforeBreak;
        return this;
    }
    get root() {
        return this.parents.length ? this.parents[0].tile : this.tile;
    }
}
// Used to track open block wrappers
class $b3e9d73db824614e$var$OpenWrapper {
    constructor(from, to, wrapper, rank){
        this.from = from;
        this.to = to;
        this.wrapper = wrapper;
        this.rank = rank;
    }
}
// This class builds up a new document tile using input from either
// iteration over the old tree or iteration over the document +
// decorations. The add* methods emit elements into the tile
// structure. To avoid awkward synchronization issues, marks and block
// wrappers are treated as belonging to to their content, rather than
// opened/closed independently.
//
// All composite tiles that are touched by changes are rebuilt,
// reusing as much of the old tree (either whole nodes or just DOM
// elements) as possible. The new tree is built without the Synced
// flag, and then synced (during which DOM parent/child relations are
// fixed up, text nodes filled in, and attributes added) in a second
// phase.
class $b3e9d73db824614e$var$TileBuilder {
    constructor(cache, root, blockWrappers){
        this.cache = cache;
        this.root = root;
        this.blockWrappers = blockWrappers;
        this.curLine = null;
        this.lastBlock = null;
        this.afterWidget = null;
        this.pos = 0;
        this.wrappers = [];
        this.wrapperPos = 0;
    }
    addText(text, marks, openStart, tile) {
        var _a;
        this.flushBuffer();
        let parent = this.ensureMarks(marks, openStart);
        let prev = parent.lastChild;
        if (prev && prev.isText() && !(prev.flags & 8 /* TileFlag.Composition */ ) && prev.length + text.length < 512 /* C.Chunk */ ) {
            this.cache.reused.set(prev, 2 /* Reused.DOM */ );
            let tile = parent.children[parent.children.length - 1] = new $b3e9d73db824614e$var$TextTile(prev.dom, prev.text + text);
            tile.parent = parent;
        } else parent.append(tile || $b3e9d73db824614e$var$TextTile.of(text, (_a = this.cache.find($b3e9d73db824614e$var$TextTile)) === null || _a === void 0 ? void 0 : _a.dom));
        this.pos += text.length;
        this.afterWidget = null;
    }
    addComposition(composition, context) {
        let line = this.curLine;
        if (line.dom != context.line.dom) {
            line.setDOM(this.cache.reused.has(context.line) ? $b3e9d73db824614e$var$freeNode(context.line.dom) : context.line.dom);
            this.cache.reused.set(context.line, 2 /* Reused.DOM */ );
        }
        let head = line;
        for(let i = context.marks.length - 1; i >= 0; i--){
            let mark = context.marks[i];
            let last = head.lastChild;
            if (last instanceof $b3e9d73db824614e$var$MarkTile && last.mark.eq(mark.mark)) {
                if (last.dom != mark.dom) last.setDOM($b3e9d73db824614e$var$freeNode(mark.dom));
                head = last;
            } else {
                if (this.cache.reused.get(mark)) {
                    let tile = $b3e9d73db824614e$var$Tile.get(mark.dom);
                    if (tile) tile.setDOM($b3e9d73db824614e$var$freeNode(mark.dom));
                }
                let nw = $b3e9d73db824614e$var$MarkTile.of(mark.mark, mark.dom);
                head.append(nw);
                head = nw;
            }
            this.cache.reused.set(mark, 2 /* Reused.DOM */ );
        }
        let oldTile = $b3e9d73db824614e$var$Tile.get(composition.text);
        if (oldTile) this.cache.reused.set(oldTile, 2 /* Reused.DOM */ );
        let text = new $b3e9d73db824614e$var$TextTile(composition.text, composition.text.nodeValue);
        text.flags |= 8 /* TileFlag.Composition */ ;
        this.pos = composition.range.toB;
        head.append(text);
    }
    addInlineWidget(widget, marks, openStart) {
        // Adjacent same-side-facing non-replacing widgets don't need buffers between them
        let noSpace = this.afterWidget && widget.flags & 48 /* TileFlag.PointWidget */  && (this.afterWidget.flags & 48 /* TileFlag.PointWidget */ ) == (widget.flags & 48 /* TileFlag.PointWidget */ );
        if (!noSpace) this.flushBuffer();
        let parent = this.ensureMarks(marks, openStart);
        if (!noSpace && !(widget.flags & 16 /* TileFlag.Before */ )) parent.append(this.getBuffer(1));
        parent.append(widget);
        this.pos += widget.length;
        this.afterWidget = widget;
    }
    addMark(tile, marks, openStart) {
        this.flushBuffer();
        let parent = this.ensureMarks(marks, openStart);
        parent.append(tile);
        this.pos += tile.length;
        this.afterWidget = null;
    }
    addBlockWidget(widget) {
        this.getBlockPos().append(widget);
        this.pos += widget.length;
        this.lastBlock = widget;
        this.endLine();
    }
    continueWidget(length) {
        let widget = this.afterWidget || this.lastBlock;
        widget.length += length;
        this.pos += length;
    }
    addLineStart(attrs, dom) {
        var _a;
        if (!attrs) attrs = $b3e9d73db824614e$var$lineBaseAttrs;
        let tile = $b3e9d73db824614e$var$LineTile.start(attrs, dom || ((_a = this.cache.find($b3e9d73db824614e$var$LineTile)) === null || _a === void 0 ? void 0 : _a.dom), !!dom);
        this.getBlockPos().append(this.lastBlock = this.curLine = tile);
    }
    addLine(tile) {
        this.getBlockPos().append(tile);
        this.pos += tile.length;
        this.lastBlock = tile;
        this.endLine();
    }
    addBreak() {
        this.lastBlock.flags |= 1 /* TileFlag.BreakAfter */ ;
        this.endLine();
        this.pos++;
    }
    addLineStartIfNotCovered(attrs) {
        if (!this.blockPosCovered()) this.addLineStart(attrs);
    }
    ensureLine(attrs) {
        if (!this.curLine) this.addLineStart(attrs);
    }
    ensureMarks(marks, openStart) {
        var _a;
        let parent = this.curLine;
        for(let i = marks.length - 1; i >= 0; i--){
            let mark = marks[i], last;
            if (openStart > 0 && (last = parent.lastChild) && last instanceof $b3e9d73db824614e$var$MarkTile && last.mark.eq(mark)) {
                parent = last;
                openStart--;
            } else {
                let tile = $b3e9d73db824614e$var$MarkTile.of(mark, (_a = this.cache.find($b3e9d73db824614e$var$MarkTile, (m)=>m.mark.eq(mark))) === null || _a === void 0 ? void 0 : _a.dom);
                parent.append(tile);
                parent = tile;
                openStart = 0;
            }
        }
        return parent;
    }
    endLine() {
        if (this.curLine) {
            this.flushBuffer();
            let last = this.curLine.lastChild;
            if (!last || !$b3e9d73db824614e$var$hasContent(this.curLine, false) || last.dom.nodeName != "BR" && last.isWidget() && !($b3e9d73db824614e$var$browser.ios && $b3e9d73db824614e$var$hasContent(this.curLine, true))) this.curLine.append(this.cache.findWidget($b3e9d73db824614e$var$BreakWidget, 0, 32 /* TileFlag.After */ ) || new $b3e9d73db824614e$var$WidgetTile($b3e9d73db824614e$var$BreakWidget.toDOM(), 0, $b3e9d73db824614e$var$BreakWidget, 32 /* TileFlag.After */ ));
            this.curLine = this.afterWidget = null;
        }
    }
    updateBlockWrappers() {
        if (this.wrapperPos > this.pos + 10000 /* C.WrapperReset */ ) {
            this.blockWrappers.goto(this.pos);
            this.wrappers.length = 0;
        }
        for(let i = this.wrappers.length - 1; i >= 0; i--)if (this.wrappers[i].to < this.pos) this.wrappers.splice(i, 1);
        for(let cur = this.blockWrappers; cur.value && cur.from <= this.pos; cur.next())if (cur.to >= this.pos) {
            let rank = cur.rank * 102 + cur.value.rank;
            let wrap = new $b3e9d73db824614e$var$OpenWrapper(cur.from, cur.to, cur.value, rank), i = this.wrappers.length;
            while(i > 0 && (this.wrappers[i - 1].rank - wrap.rank || this.wrappers[i - 1].to - wrap.to) < 0)i--;
            this.wrappers.splice(i, 0, wrap);
        }
        this.wrapperPos = this.pos;
    }
    getBlockPos() {
        var _a;
        this.updateBlockWrappers();
        let parent = this.root;
        for (let wrap of this.wrappers){
            let last = parent.lastChild;
            if (wrap.from < this.pos && last instanceof $b3e9d73db824614e$var$BlockWrapperTile && last.wrapper.eq(wrap.wrapper)) parent = last;
            else {
                let tile = $b3e9d73db824614e$var$BlockWrapperTile.of(wrap.wrapper, (_a = this.cache.find($b3e9d73db824614e$var$BlockWrapperTile, (t)=>t.wrapper.eq(wrap.wrapper))) === null || _a === void 0 ? void 0 : _a.dom);
                parent.append(tile);
                parent = tile;
            }
        }
        return parent;
    }
    blockPosCovered() {
        let last = this.lastBlock;
        return last != null && !last.breakAfter && (!last.isWidget() || (last.flags & 160 /* TileFlag.IncEnd */ ) > 0);
    }
    getBuffer(side) {
        let flags = 2 /* TileFlag.Synced */  | (side < 0 ? 16 /* TileFlag.Before */  : 32 /* TileFlag.After */ );
        let found = this.cache.find($b3e9d73db824614e$var$WidgetBufferTile, undefined, 1 /* Reused.Full */ );
        if (found) found.flags = flags;
        return found || new $b3e9d73db824614e$var$WidgetBufferTile(flags);
    }
    flushBuffer() {
        if (this.afterWidget && !(this.afterWidget.flags & 32 /* TileFlag.After */ )) {
            this.afterWidget.parent.append(this.getBuffer(-1));
            this.afterWidget = null;
        }
    }
}
// Helps getting efficient access to the document text.
class $b3e9d73db824614e$var$TextStream {
    constructor(doc){
        this.skipCount = 0;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
    }
    skip(len) {
        // Advance the iterator past the replaced content
        if (this.textOff + len <= this.text.length) this.textOff += len;
        else {
            this.skipCount += len - (this.text.length - this.textOff);
            this.text = "";
            this.textOff = 0;
        }
    }
    next(maxLen) {
        if (this.textOff == this.text.length) {
            let { value: value, lineBreak: lineBreak, done: done } = this.cursor.next(this.skipCount);
            this.skipCount = 0;
            if (done) throw new Error("Ran out of text content when drawing inline views");
            this.text = value;
            let len = this.textOff = Math.min(maxLen, value.length);
            return lineBreak ? null : value.slice(0, len);
        }
        let end = Math.min(this.text.length, this.textOff + maxLen);
        let chars = this.text.slice(this.textOff, end);
        this.textOff = end;
        return chars;
    }
}
// Assign the tile classes bucket numbers for caching.
const $b3e9d73db824614e$var$buckets = [
    $b3e9d73db824614e$var$WidgetTile,
    $b3e9d73db824614e$var$LineTile,
    $b3e9d73db824614e$var$TextTile,
    $b3e9d73db824614e$var$MarkTile,
    $b3e9d73db824614e$var$WidgetBufferTile,
    $b3e9d73db824614e$var$BlockWrapperTile,
    $b3e9d73db824614e$var$DocTile
];
for(let i = 0; i < $b3e9d73db824614e$var$buckets.length; i++)$b3e9d73db824614e$var$buckets[i].bucket = i;
// Leaf tiles and line tiles may be reused in their entirety. All
// others will get new tiles allocated, using the old DOM when
// possible.
class $b3e9d73db824614e$var$TileCache {
    constructor(view){
        this.view = view;
        // Buckets are circular buffers, using `index` as the current
        // position.
        this.buckets = $b3e9d73db824614e$var$buckets.map(()=>[]);
        this.index = $b3e9d73db824614e$var$buckets.map(()=>0);
        this.reused = new Map;
    }
    // Put a tile in the cache.
    add(tile) {
        let i = tile.constructor.bucket, bucket = this.buckets[i];
        if (bucket.length < 6 /* C.Bucket */ ) bucket.push(tile);
        else bucket[this.index[i] = (this.index[i] + 1) % 6 /* C.Bucket */ ] = tile;
    }
    find(cls, test, type = 2 /* Reused.DOM */ ) {
        let i = cls.bucket;
        let bucket = this.buckets[i], off = this.index[i];
        for(let j = 0; j < bucket.length; j++){
            // Look at the most oldest items first (first-in, first-out)
            let index = (j + off) % bucket.length, tile = bucket[index];
            if ((!test || test(tile)) && !this.reused.has(tile)) {
                bucket.splice(index, 1);
                if (index < off) this.index[i]--;
                this.reused.set(tile, type);
                return tile;
            }
        }
        return null;
    }
    findWidget(widget, length, flags) {
        let widgets = this.buckets[0];
        if (widgets.length) for(let i = 0, pass = 0;; i++){
            if (i == widgets.length) {
                if (pass) return null;
                pass = 1;
                i = 0;
            }
            let tile = widgets[i];
            if (!this.reused.has(tile) && (pass == 0 ? tile.widget.compare(widget) : tile.widget.constructor == widget.constructor && widget.updateDOM(tile.dom, this.view, tile.widget))) {
                widgets.splice(i, 1);
                if (i < this.index[0]) this.index[0]--;
                if (tile.widget == widget && tile.length == length && (tile.flags & 497 /* TileFlag.BreakAfter */ ) == flags) {
                    this.reused.set(tile, 1 /* Reused.Full */ );
                    return tile;
                } else {
                    this.reused.set(tile, 2 /* Reused.DOM */ );
                    return new $b3e9d73db824614e$var$WidgetTile(tile.dom, length, widget, tile.flags & -498 | flags);
                }
            }
        }
    }
    reuse(tile) {
        this.reused.set(tile, 1 /* Reused.Full */ );
        return tile;
    }
    maybeReuse(tile, type = 2 /* Reused.DOM */ ) {
        if (this.reused.has(tile)) return undefined;
        this.reused.set(tile, type);
        return tile.dom;
    }
    clear() {
        for(let i = 0; i < this.buckets.length; i++)this.buckets[i].length = this.index[i] = 0;
    }
}
// This class organizes a pass over the document, guided by the array
// of replaced ranges. For ranges that haven't changed, it iterates
// the old tree and copies its content into the new document. For
// changed ranges, it runs a decoration iterator to guide generation
// of content.
class $b3e9d73db824614e$var$TileUpdate {
    constructor(view, old, blockWrappers, decorations, disallowBlockEffectsFor){
        this.view = view;
        this.decorations = decorations;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.openWidget = false;
        this.openMarks = 0;
        this.cache = new $b3e9d73db824614e$var$TileCache(view);
        this.text = new $b3e9d73db824614e$var$TextStream(view.state.doc);
        this.builder = new $b3e9d73db824614e$var$TileBuilder(this.cache, new $b3e9d73db824614e$var$DocTile(view, view.contentDOM), (0, $3ef527dddcdea745$export$34cb5241245008dd).iter(blockWrappers));
        this.cache.reused.set(old, 2 /* Reused.DOM */ );
        this.old = new $b3e9d73db824614e$var$TilePointer(old);
        this.reuseWalker = {
            skip: (tile, from, to)=>{
                this.cache.add(tile);
                if (tile.isComposite()) return false;
            },
            enter: (tile)=>this.cache.add(tile),
            leave: ()=>{},
            break: ()=>{}
        };
    }
    run(changes, composition) {
        let compositionContext = composition && this.getCompositionContext(composition.text);
        for(let posA = 0, posB = 0, i = 0;;){
            let next = i < changes.length ? changes[i++] : null;
            let skipA = next ? next.fromA : this.old.root.length;
            if (skipA > posA) {
                let len = skipA - posA;
                this.preserve(len, !i, !next);
                posA = skipA;
                posB += len;
            }
            if (!next) break;
            // Compositions need to be handled specially, forcing the
            // focused text node and its parent nodes to remain stable at
            // that point in the document.
            if (composition && next.fromA <= composition.range.fromA && next.toA >= composition.range.toA) {
                this.forward(next.fromA, composition.range.fromA, composition.range.fromA < composition.range.toA ? 1 : -1);
                this.emit(posB, composition.range.fromB);
                this.builder.flushBuffer();
                this.cache.clear(); // Must not reuse DOM across composition
                this.builder.addComposition(composition, compositionContext);
                this.text.skip(composition.range.toB - composition.range.fromB);
                this.forward(composition.range.fromA, next.toA);
                this.emit(composition.range.toB, next.toB);
            } else {
                this.forward(next.fromA, next.toA);
                this.emit(posB, next.toB);
            }
            posB = next.toB;
            posA = next.toA;
        }
        if (this.builder.curLine) this.builder.endLine();
        return this.builder.root;
    }
    preserve(length, incStart, incEnd) {
        let activeMarks = $b3e9d73db824614e$var$getMarks(this.old), openMarks = this.openMarks;
        this.old.advance(length, incEnd ? 1 : -1, {
            skip: (tile, from, to)=>{
                if (tile.isWidget()) {
                    if (this.openWidget) this.builder.continueWidget(to - from);
                    else {
                        let widget = to > 0 || from < tile.length ? $b3e9d73db824614e$var$WidgetTile.of(tile.widget, this.view, to - from, tile.flags & 496 /* TileFlag.Widget */ , this.cache.maybeReuse(tile)) : this.cache.reuse(tile);
                        if (widget.flags & 256 /* TileFlag.Block */ ) {
                            widget.flags &= -2 /* TileFlag.BreakAfter */ ;
                            this.builder.addBlockWidget(widget);
                        } else {
                            this.builder.ensureLine(null);
                            this.builder.addInlineWidget(widget, activeMarks, openMarks);
                            openMarks = activeMarks.length;
                        }
                    }
                } else if (tile.isText()) {
                    this.builder.ensureLine(null);
                    if (!from && to == tile.length && !this.cache.reused.has(tile)) this.builder.addText(tile.text, activeMarks, openMarks, this.cache.reuse(tile));
                    else {
                        this.cache.add(tile);
                        this.builder.addText(tile.text.slice(from, to), activeMarks, openMarks);
                    }
                    openMarks = activeMarks.length;
                } else if (tile.isLine()) {
                    tile.flags &= -2 /* TileFlag.BreakAfter */ ;
                    this.cache.reused.set(tile, 1 /* Reused.Full */ );
                    this.builder.addLine(tile);
                } else if (tile instanceof $b3e9d73db824614e$var$WidgetBufferTile) this.cache.add(tile);
                else if (tile instanceof $b3e9d73db824614e$var$MarkTile) {
                    this.builder.ensureLine(null);
                    this.builder.addMark(tile, activeMarks, openMarks);
                    this.cache.reused.set(tile, 1 /* Reused.Full */ );
                    openMarks = activeMarks.length;
                } else return false;
                this.openWidget = false;
            },
            enter: (tile)=>{
                if (tile.isLine()) this.builder.addLineStart(tile.attrs, this.cache.maybeReuse(tile));
                else {
                    this.cache.add(tile);
                    if (tile instanceof $b3e9d73db824614e$var$MarkTile) activeMarks.unshift(tile.mark);
                }
                this.openWidget = false;
            },
            leave: (tile)=>{
                if (tile.isLine()) {
                    if (activeMarks.length) activeMarks.length = openMarks = 0;
                } else if (tile instanceof $b3e9d73db824614e$var$MarkTile) {
                    activeMarks.shift();
                    openMarks = Math.min(openMarks, activeMarks.length);
                }
            },
            break: ()=>{
                this.builder.addBreak();
                this.openWidget = false;
            }
        });
        this.text.skip(length);
    }
    emit(from, to) {
        let pendingLineAttrs = null;
        let b = this.builder, markCount = -1;
        let openEnd = (0, $3ef527dddcdea745$export$34cb5241245008dd).spans(this.decorations, from, to, {
            point: (from, to, deco, active, openStart, index)=>{
                if (deco instanceof $b3e9d73db824614e$var$PointDecoration) {
                    if (this.disallowBlockEffectsFor[index]) {
                        if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
                        if (to > this.view.state.doc.lineAt(from).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
                    }
                    markCount = active.length;
                    if (openStart > active.length) b.continueWidget(to - from);
                    else {
                        let widget = deco.widget || (deco.block ? $b3e9d73db824614e$var$NullWidget.block : $b3e9d73db824614e$var$NullWidget.inline);
                        let flags = $b3e9d73db824614e$var$widgetFlags(deco);
                        let tile = this.cache.findWidget(widget, to - from, flags) || $b3e9d73db824614e$var$WidgetTile.of(widget, this.view, to - from, flags);
                        if (deco.block) {
                            if (deco.startSide > 0) b.addLineStartIfNotCovered(pendingLineAttrs);
                            b.addBlockWidget(tile);
                        } else {
                            b.ensureLine(pendingLineAttrs);
                            b.addInlineWidget(tile, active, openStart);
                        }
                    }
                    pendingLineAttrs = null;
                } else pendingLineAttrs = $b3e9d73db824614e$var$addLineDeco(pendingLineAttrs, deco);
                if (to > from) this.text.skip(to - from);
            },
            span: (from, to, active, openStart)=>{
                for(let pos = from; pos < to;){
                    let chars = this.text.next(Math.min(512 /* C.Chunk */ , to - pos));
                    if (chars == null) {
                        b.addLineStartIfNotCovered(pendingLineAttrs);
                        b.addBreak();
                        pos++;
                    } else {
                        b.ensureLine(pendingLineAttrs);
                        b.addText(chars, active, pos == from ? openStart : active.length);
                        pos += chars.length;
                    }
                    pendingLineAttrs = null;
                }
                markCount = active.length;
            }
        });
        if (markCount > -1) this.openWidget = openEnd > markCount;
        if (!this.openWidget) b.addLineStartIfNotCovered(pendingLineAttrs);
        this.openMarks = openEnd;
    }
    forward(from, to, side = 1) {
        if (to - from <= 10) this.old.advance(to - from, side, this.reuseWalker);
        else {
            this.old.advance(5, -1, this.reuseWalker);
            this.old.advance(to - from - 10, -1);
            this.old.advance(5, side, this.reuseWalker);
        }
    }
    getCompositionContext(text) {
        let marks = [], line = null;
        for(let parent = text.parentNode;; parent = parent.parentNode){
            let tile = $b3e9d73db824614e$var$Tile.get(parent);
            if (parent == this.view.contentDOM) break;
            if (tile instanceof $b3e9d73db824614e$var$MarkTile) marks.push(tile);
            else if (tile === null || tile === void 0 ? void 0 : tile.isLine()) line = tile;
            else if (tile instanceof $b3e9d73db824614e$var$BlockWrapperTile) ; // Ignore
            else if (parent.nodeName == "DIV" && !line && parent != this.view.contentDOM) line = new $b3e9d73db824614e$var$LineTile(parent, $b3e9d73db824614e$var$lineBaseAttrs);
            else if (!line) marks.push($b3e9d73db824614e$var$MarkTile.of(new $b3e9d73db824614e$var$MarkDecoration({
                tagName: parent.nodeName.toLowerCase(),
                attributes: $b3e9d73db824614e$var$getAttrs(parent)
            }), parent));
        }
        return {
            line: line,
            marks: marks
        };
    }
}
function $b3e9d73db824614e$var$hasContent(tile, requireText) {
    let scan = (tile)=>{
        for (let ch of tile.children)if ((requireText ? ch.isText() : ch.length) || scan(ch)) return true;
        return false;
    };
    return scan(tile);
}
function $b3e9d73db824614e$var$widgetFlags(deco) {
    let flags = deco.isReplace ? (deco.startSide < 0 ? 64 /* TileFlag.IncStart */  : 0) | (deco.endSide > 0 ? 128 /* TileFlag.IncEnd */  : 0) : deco.startSide > 0 ? 32 /* TileFlag.After */  : 16 /* TileFlag.Before */ ;
    if (deco.block) flags |= 256 /* TileFlag.Block */ ;
    return flags;
}
const $b3e9d73db824614e$var$lineBaseAttrs = {
    class: "cm-line"
};
function $b3e9d73db824614e$var$addLineDeco(value, deco) {
    let attrs = deco.spec.attributes, cls = deco.spec.class;
    if (!attrs && !cls) return value;
    if (!value) value = {
        class: "cm-line"
    };
    if (attrs) $b3e9d73db824614e$var$combineAttrs(attrs, value);
    if (cls) value.class += " " + cls;
    return value;
}
function $b3e9d73db824614e$var$getMarks(ptr) {
    let found = [];
    for(let i = ptr.parents.length; i > 1; i--){
        let tile = i == ptr.parents.length ? ptr.tile : ptr.parents[i].tile;
        if (tile instanceof $b3e9d73db824614e$var$MarkTile) found.push(tile.mark);
    }
    return found;
}
function $b3e9d73db824614e$var$freeNode(node) {
    let tile = $b3e9d73db824614e$var$Tile.get(node);
    if (tile) tile.setDOM(node.cloneNode());
    return node;
}
class $b3e9d73db824614e$var$NullWidget extends $b3e9d73db824614e$export$95cdd842edb044c5 {
    constructor(tag){
        super();
        this.tag = tag;
    }
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
        return true;
    }
}
$b3e9d73db824614e$var$NullWidget.inline = /*@__PURE__*/ new $b3e9d73db824614e$var$NullWidget("span");
$b3e9d73db824614e$var$NullWidget.block = /*@__PURE__*/ new $b3e9d73db824614e$var$NullWidget("div");
const $b3e9d73db824614e$var$BreakWidget = /*@__PURE__*/ new class extends $b3e9d73db824614e$export$95cdd842edb044c5 {
    toDOM() {
        return document.createElement("br");
    }
    get isHidden() {
        return true;
    }
    get editable() {
        return true;
    }
};
class $b3e9d73db824614e$var$DocView {
    constructor(view){
        this.view = view;
        this.decorations = [];
        this.blockWrappers = [];
        this.dynamicDecorationMap = [
            false
        ];
        this.domChanged = null;
        this.hasComposition = null;
        this.editContextFormatting = $b3e9d73db824614e$export$10e30b733df217ea.none;
        this.lastCompositionAfterCursor = false;
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.updateDeco();
        this.tile = new $b3e9d73db824614e$var$DocTile(view, view.contentDOM);
        this.updateInner([
            new $b3e9d73db824614e$var$ChangedRange(0, 0, 0, view.state.doc.length)
        ], null);
    }
    // Update the document view to a given state.
    update(update) {
        var _a;
        let changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every(({ fromA: fromA, toA: toA })=>toA < this.minWidthFrom || fromA > this.minWidthTo)) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        this.updateEditContextFormatting(update);
        let readCompositionAt = -1;
        if (this.view.inputState.composing >= 0 && !this.view.observer.editContext) {
            if ((_a = this.domChanged) === null || _a === void 0 ? void 0 : _a.newSel) readCompositionAt = this.domChanged.newSel.head;
            else if (!$b3e9d73db824614e$var$touchesComposition(update.changes, this.hasComposition) && !update.selectionSet) readCompositionAt = update.state.selection.main.head;
        }
        let composition = readCompositionAt > -1 ? $b3e9d73db824614e$var$findCompositionRange(this.view, update.changes, readCompositionAt) : null;
        this.domChanged = null;
        if (this.hasComposition) {
            let { from: from, to: to } = this.hasComposition;
            changedRanges = new $b3e9d73db824614e$var$ChangedRange(from, to, update.changes.mapPos(from, -1), update.changes.mapPos(to, 1)).addToSet(changedRanges.slice());
        }
        this.hasComposition = composition ? {
            from: composition.range.fromB,
            to: composition.range.toB
        } : null;
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if (($b3e9d73db824614e$var$browser.ie || $b3e9d73db824614e$var$browser.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        let prevDeco = this.decorations, prevWrappers = this.blockWrappers;
        this.updateDeco();
        let decoDiff = $b3e9d73db824614e$var$findChangedDeco(prevDeco, this.decorations, update.changes);
        if (decoDiff.length) changedRanges = $b3e9d73db824614e$var$ChangedRange.extendWithRanges(changedRanges, decoDiff);
        let blockDiff = $b3e9d73db824614e$var$findChangedWrappers(prevWrappers, this.blockWrappers, update.changes);
        if (blockDiff.length) changedRanges = $b3e9d73db824614e$var$ChangedRange.extendWithRanges(changedRanges, blockDiff);
        if (composition && !changedRanges.some((r)=>r.fromA <= composition.range.fromA && r.toA >= composition.range.toA)) changedRanges = composition.range.addToSet(changedRanges.slice());
        if (this.tile.flags & 2 /* TileFlag.Synced */  && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, composition);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, composition) {
        this.view.viewState.mustMeasureContent = true;
        let { observer: observer } = this.view;
        observer.ignore(()=>{
            if (composition || changes.length) {
                let oldTile = this.tile;
                let builder = new $b3e9d73db824614e$var$TileUpdate(this.view, oldTile, this.blockWrappers, this.decorations, this.dynamicDecorationMap);
                if (composition && $b3e9d73db824614e$var$Tile.get(composition.text)) builder.cache.reused.set($b3e9d73db824614e$var$Tile.get(composition.text), 2 /* Reused.DOM */ );
                this.tile = builder.run(changes, composition);
                $b3e9d73db824614e$var$destroyDropped(oldTile, builder.cache.reused);
            }
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.tile.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px";
            this.tile.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            let track = $b3e9d73db824614e$var$browser.chrome || $b3e9d73db824614e$var$browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.tile.sync(track);
            if (track && (track.written || observer.selectionRange.focusNode != track.node || !this.tile.dom.contains(track.node))) this.forceSelection = true;
            this.tile.dom.style.height = "";
        });
        let gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            for (let child of this.tile.children)if (child.isWidget() && child.widget instanceof $b3e9d73db824614e$var$BlockGapWidget) gaps.push(child.dom);
        }
        observer.updateGaps(gaps);
    }
    updateEditContextFormatting(update) {
        this.editContextFormatting = this.editContextFormatting.map(update.changes);
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($b3e9d73db824614e$var$setEditContextFormatting)) this.editContextFormatting = effect.value;
    }
    // Sync the DOM selection to this.state.selection
    updateSelection(mustRead = false, fromPointer = false) {
        if (mustRead || !this.view.observer.selectionRange.focusNode) this.view.observer.readSelectionRange();
        let { dom: dom } = this.tile;
        let activeElt = this.view.root.activeElement, focused = activeElt == dom;
        let selectionNotFocus = !focused && !(this.view.state.facet($b3e9d73db824614e$var$editable) || dom.tabIndex > -1) && $b3e9d73db824614e$var$hasSelection(dom, this.view.observer.selectionRange) && !(activeElt && dom.contains(activeElt));
        if (!(focused || fromPointer || selectionNotFocus)) return;
        let force = this.forceSelection;
        this.forceSelection = false;
        let main = this.view.state.selection.main, anchor, head;
        if (main.empty) head = anchor = this.inlineDOMNearPos(main.anchor, main.assoc || 1);
        else {
            head = this.inlineDOMNearPos(main.head, main.head == main.from ? 1 : -1);
            anchor = this.inlineDOMNearPos(main.anchor, main.anchor == main.from ? 1 : -1);
        }
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if ($b3e9d73db824614e$var$browser.gecko && main.empty && !this.hasComposition && $b3e9d73db824614e$var$betweenUneditable(anchor)) {
            let dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new $b3e9d73db824614e$var$DOMPos(dummy, 0);
            force = true;
        }
        let domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || (!$b3e9d73db824614e$var$isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !$b3e9d73db824614e$var$isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) && !this.suppressWidgetCursorChange(domSel, main)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if ($b3e9d73db824614e$var$browser.android && $b3e9d73db824614e$var$browser.chrome && dom.contains(domSel.focusNode) && $b3e9d73db824614e$var$inUneditable(domSel.focusNode, dom)) {
                    dom.blur();
                    dom.focus({
                        preventScroll: true
                    });
                }
                let rawSel = $b3e9d73db824614e$var$getSelection(this.view.root);
                if (!rawSel) ;
                else if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if ($b3e9d73db824614e$var$browser.gecko) {
                        let nextTo = $b3e9d73db824614e$var$nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* NextTo.After */ ) {
                            let text = (nextTo == 1 /* NextTo.Before */  ? $b3e9d73db824614e$var$textNodeBefore : $b3e9d73db824614e$var$textNodeAfter)(anchor.node, anchor.offset);
                            if (text) anchor = new $b3e9d73db824614e$var$DOMPos(text.node, text.offset);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && rawSel.caretBidiLevel !== undefined) rawSel.caretBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    // Safari will ignore the call above when the editor is
                    // hidden, and then raise an error on the call to extend
                    // (#940).
                    try {
                        rawSel.extend(head.node, head.offset);
                    } catch (_) {}
                } else {
                    // Primitive (IE) way
                    let range = document.createRange();
                    if (main.anchor > main.head) [anchor, head] = [
                        head,
                        anchor
                    ];
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
                if (selectionNotFocus && this.view.root.activeElement == dom) {
                    dom.blur();
                    if (activeElt) activeElt.focus();
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new $b3e9d73db824614e$var$DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new $b3e9d73db824614e$var$DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    // If a zero-length widget is inserted next to the cursor during
    // composition, avoid moving it across it and disrupting the
    // composition.
    suppressWidgetCursorChange(sel, cursor) {
        return this.hasComposition && cursor.empty && $b3e9d73db824614e$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset) && this.posFromDOM(sel.focusNode, sel.focusOffset) == cursor.head;
    }
    enforceCursorAssoc() {
        if (this.hasComposition) return;
        let { view: view } = this, cursor = view.state.selection.main;
        let sel = $b3e9d73db824614e$var$getSelection(view.root);
        let { anchorNode: anchorNode, anchorOffset: anchorOffset } = view.observer.selectionRange;
        if (!sel || !cursor.empty || !cursor.assoc || !sel.modify) return;
        let line = this.lineAt(cursor.head, cursor.assoc);
        if (!line) return;
        let lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        let dom = this.domAtPos(cursor.head + cursor.assoc, cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
        // This can go wrong in corner cases like single-character lines,
        // so check and reset if necessary.
        view.observer.readSelectionRange();
        let newRange = view.observer.selectionRange;
        if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from) sel.collapse(anchorNode, anchorOffset);
    }
    posFromDOM(node, offset) {
        let tile = this.tile.nearest(node);
        if (!tile) return this.tile.dom.compareDocumentPosition(node) & 2 /* PRECEDING */  ? 0 : this.view.state.doc.length;
        let start = tile.posAtStart;
        if (tile.isComposite()) {
            let after;
            if (node == tile.dom) after = tile.dom.childNodes[offset];
            else {
                let bias = $b3e9d73db824614e$var$maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
                for(;;){
                    let parent = node.parentNode;
                    if (parent == tile.dom) break;
                    if (bias == 0 && parent.firstChild != parent.lastChild) {
                        if (node == parent.firstChild) bias = -1;
                        else bias = 1;
                    }
                    node = parent;
                }
                if (bias < 0) after = node;
                else after = node.nextSibling;
            }
            if (after == tile.dom.firstChild) return start;
            while(after && !$b3e9d73db824614e$var$Tile.get(after))after = after.nextSibling;
            if (!after) return start + tile.length;
            for(let i = 0, pos = start;; i++){
                let child = tile.children[i];
                if (child.dom == after) return pos;
                pos += child.length + child.breakAfter;
            }
        } else if (tile.isText()) return node == tile.dom ? start + offset : start + (offset ? tile.length : 0);
        else return start;
    }
    domAtPos(pos, side) {
        let { tile: tile, offset: offset } = this.tile.resolveBlock(pos, side);
        if (tile.isWidget()) return tile.domPosFor(offset, side);
        return tile.domIn(offset, side);
    }
    inlineDOMNearPos(pos, side) {
        let before, beforeOff = -1, beforeBad = false;
        let after, afterOff = -1, afterBad = false;
        this.tile.blockTiles((tile, off)=>{
            if (tile.isWidget()) {
                if (tile.flags & 32 /* TileFlag.After */  && off >= pos) return true;
                if (tile.flags & 16 /* TileFlag.Before */ ) beforeBad = true;
            } else {
                let end = off + tile.length;
                if (off <= pos) {
                    before = tile;
                    beforeOff = pos - off;
                    beforeBad = end < pos;
                }
                if (end >= pos && !after) {
                    after = tile;
                    afterOff = pos - off;
                    afterBad = off > pos;
                }
                if (off > pos && after) return true;
            }
        });
        if (!before && !after) return this.domAtPos(pos, side);
        if (beforeBad && after) before = null;
        else if (afterBad && before) after = null;
        return before && side < 0 || !after ? before.domIn(beforeOff, side) : after.domIn(afterOff, side);
    }
    // Get the coord of the element at the given side of the given
    // position. If rtl is given, flatten it using that text direction.
    coordsAt(pos, side, rtl) {
        let { tile: tile, offset: offset } = this.tile.resolveBlock(pos, side);
        if (tile.isWidget()) {
            if (tile.widget instanceof $b3e9d73db824614e$var$BlockGapWidget) return null;
            return tile.coordsInWidget(offset, side, true);
        }
        return tile.coordsIn(offset, side, rtl);
    }
    lineAt(pos, side) {
        let { tile: tile } = this.tile.resolveBlock(pos, side);
        return tile.isLine() ? tile : null;
    }
    coordsForChar(pos) {
        let { tile: tile, offset: offset } = this.tile.resolveBlock(pos, 1);
        if (!tile.isLine()) return null;
        function scan(tile, offset) {
            if (tile.isComposite()) for (let ch of tile.children){
                if (ch.length >= offset) {
                    let found = scan(ch, offset);
                    if (found) return found;
                }
                offset -= ch.length;
                if (offset < 0) break;
            }
            else if (tile.isText() && offset < tile.length) {
                let end = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(tile.text, offset);
                if (end == offset) return null;
                let rects = $b3e9d73db824614e$var$textRange(tile.dom, offset, end).getClientRects();
                for(let i = 0; i < rects.length; i++){
                    let rect = rects[i];
                    if (i == rects.length - 1 || rect.top < rect.bottom && rect.left < rect.right) return rect;
                }
            }
            return null;
        }
        return scan(tile, offset);
    }
    measureVisibleLineHeights(viewport) {
        let result = [], { from: from, to: to } = viewport;
        let contentWidth = this.view.contentDOM.clientWidth;
        let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        let widest = -1, ltr = this.view.textDirection == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR;
        let spaceAbove = 0;
        let scan = (tile, pos, measureBounds)=>{
            for(let i = 0; i < tile.children.length; i++){
                if (pos > to) break;
                let child = tile.children[i], end = pos + child.length;
                let childRect = child.dom.getBoundingClientRect(), { height: height } = childRect;
                if (measureBounds && !i) spaceAbove += childRect.top - measureBounds.top;
                if (child instanceof $b3e9d73db824614e$var$BlockWrapperTile) {
                    if (end > from) scan(child, pos, childRect);
                } else if (pos >= from) {
                    if (spaceAbove > 0) result.push(-spaceAbove);
                    result.push(height + spaceAbove);
                    spaceAbove = 0;
                    if (isWider) {
                        let last = child.dom.lastChild;
                        let rects = last ? $b3e9d73db824614e$var$clientRectsFor(last) : [];
                        if (rects.length) {
                            let rect = rects[rects.length - 1];
                            let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                            if (width > widest) {
                                widest = width;
                                this.minWidth = contentWidth;
                                this.minWidthFrom = pos;
                                this.minWidthTo = end;
                            }
                        }
                    }
                }
                if (measureBounds && i == tile.children.length - 1) spaceAbove += measureBounds.bottom - childRect.bottom;
                pos = end + child.breakAfter;
            }
        };
        scan(this.tile, 0, null);
        return result;
    }
    textDirectionAt(pos) {
        let { tile: tile } = this.tile.resolveBlock(pos, 1);
        return getComputedStyle(tile.dom).direction == "rtl" ? $b3e9d73db824614e$export$cacd6541cfeeb6c1.RTL : $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR;
    }
    measureTextSize() {
        let lineMeasure = this.tile.blockTiles((tile)=>{
            if (tile.isLine() && tile.children.length && tile.length <= 20) {
                let totalWidth = 0, textHeight;
                for (let child of tile.children){
                    if (!child.isText() || /[^ -~]/.test(child.text)) return undefined;
                    let rects = $b3e9d73db824614e$var$clientRectsFor(child.dom);
                    if (rects.length != 1) return undefined;
                    totalWidth += rects[0].width;
                    textHeight = rects[0].height;
                }
                if (totalWidth) return {
                    lineHeight: tile.dom.getBoundingClientRect().height,
                    charWidth: totalWidth / tile.length,
                    textHeight: textHeight
                };
            }
        });
        if (lineMeasure) return lineMeasure;
        // If no workable line exists, force a layout of a measurable element
        let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
        dummy.className = "cm-line";
        dummy.style.width = "99999px";
        dummy.style.position = "absolute";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.tile.dom.appendChild(dummy);
            let rect = $b3e9d73db824614e$var$clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect && rect.width ? rect.width / 27 : 7;
            textHeight = rect && rect.height ? rect.height : lineHeight;
            dummy.remove();
        });
        return {
            lineHeight: lineHeight,
            charWidth: charWidth,
            textHeight: textHeight
        };
    }
    computeBlockGapDeco() {
        let deco = [], vs = this.view.viewState;
        for(let pos = 0, i = 0;; i++){
            let next = i == vs.viewports.length ? null : vs.viewports[i];
            let end = next ? next.from - 1 : this.view.state.doc.length;
            if (end > pos) {
                let height = (vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top) / this.view.scaleY;
                deco.push($b3e9d73db824614e$export$10e30b733df217ea.replace({
                    widget: new $b3e9d73db824614e$var$BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return $b3e9d73db824614e$export$10e30b733df217ea.set(deco);
    }
    updateDeco() {
        let i = 1;
        let allDeco = this.view.state.facet($b3e9d73db824614e$var$decorations).map((d)=>{
            let dynamic = this.dynamicDecorationMap[i++] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        let dynamicOuter = false, outerDeco = this.view.state.facet($b3e9d73db824614e$var$outerDecorations).map((d, i)=>{
            let dynamic = typeof d == "function";
            if (dynamic) dynamicOuter = true;
            return dynamic ? d(this.view) : d;
        });
        if (outerDeco.length) {
            this.dynamicDecorationMap[i++] = dynamicOuter;
            allDeco.push((0, $3ef527dddcdea745$export$34cb5241245008dd).join(outerDeco));
        }
        this.decorations = [
            this.editContextFormatting,
            ...allDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
        while(i < this.decorations.length)this.dynamicDecorationMap[i++] = false;
        this.blockWrappers = this.view.state.facet($b3e9d73db824614e$var$blockWrappers).map((v)=>typeof v == "function" ? v(this.view) : v);
    }
    scrollIntoView(target) {
        if (target.isSnapshot) {
            let ref = this.view.viewState.lineBlockAt(target.range.head);
            this.view.scrollDOM.scrollTop = ref.top - target.yMargin;
            this.view.scrollDOM.scrollLeft = target.xMargin;
            return;
        }
        for (let handler of this.view.state.facet($b3e9d73db824614e$var$scrollHandler))try {
            if (handler(this.view, target.range, target)) return true;
        } catch (e) {
            $b3e9d73db824614e$export$f86b2a1a2ce291b3(this.view.state, e, "scroll handler");
        }
        let { range: range } = target;
        let rect = this.coordsAt(range.head, range.assoc || (range.head > range.anchor ? -1 : 1)), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        let margins = $b3e9d73db824614e$var$getScrollMargins(this.view);
        let targetRect = {
            left: rect.left - margins.left,
            top: rect.top - margins.top,
            right: rect.right + margins.right,
            bottom: rect.bottom + margins.bottom
        };
        let { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = this.view.scrollDOM;
        $b3e9d73db824614e$var$scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, Math.max(Math.min(target.xMargin, offsetWidth), -offsetWidth), Math.max(Math.min(target.yMargin, offsetHeight), -offsetHeight), this.view.textDirection == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR);
        // On mobile browsers, the visual viewport may be smaller than the
        // actual reported viewport, causing scrollRectIntoView to fail to
        // scroll properly. Unfortunately, this visual viewport cannot be
        // updated directly, and scrollIntoView is the only way a script
        // can affect it. So this tries to kludge around the problem by
        // calling scrollIntoView on the scroll target's line.
        if (window.visualViewport && window.innerHeight - window.visualViewport.height > 1 && (rect.top > window.visualViewport.offsetTop + window.visualViewport.height || rect.bottom < window.visualViewport.offsetTop)) {
            let line = this.view.docView.lineAt(range.head, 1);
            if (line) {
                let stack = $b3e9d73db824614e$var$getScrollStack(line.dom);
                line.dom.scrollIntoView({
                    block: "nearest"
                });
                $b3e9d73db824614e$var$restoreScrollStack(stack, false);
            }
        }
    }
    lineHasWidget(pos) {
        let scan = (child)=>child.isWidget() || child.children.some(scan);
        return scan(this.tile.resolveBlock(pos, 1).tile);
    }
    destroy() {
        $b3e9d73db824614e$var$destroyDropped(this.tile);
    }
}
function $b3e9d73db824614e$var$destroyDropped(tile, reused) {
    let r = reused === null || reused === void 0 ? void 0 : reused.get(tile);
    if (r != 1 /* Reused.Full */ ) {
        if (r == null) tile.destroy();
        for (let ch of tile.children)$b3e9d73db824614e$var$destroyDropped(ch, reused);
    }
}
function $b3e9d73db824614e$var$betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
function $b3e9d73db824614e$var$findCompositionNode(view, headPos) {
    let sel = view.observer.selectionRange;
    if (!sel.focusNode) return null;
    let textBefore = $b3e9d73db824614e$var$textNodeBefore(sel.focusNode, sel.focusOffset);
    let textAfter = $b3e9d73db824614e$var$textNodeAfter(sel.focusNode, sel.focusOffset);
    let textNode = textBefore || textAfter;
    if (textAfter && textBefore && textAfter.node != textBefore.node) {
        let tileAfter = $b3e9d73db824614e$var$Tile.get(textAfter.node);
        if (!tileAfter || tileAfter.isText() && tileAfter.text != textAfter.node.nodeValue) textNode = textAfter;
        else if (view.docView.lastCompositionAfterCursor) {
            let tileBefore = $b3e9d73db824614e$var$Tile.get(textBefore.node);
            if (!(!tileBefore || tileBefore.isText() && tileBefore.text != textBefore.node.nodeValue)) textNode = textAfter;
        }
    }
    view.docView.lastCompositionAfterCursor = textNode != textBefore;
    if (!textNode) return null;
    let from = headPos - textNode.offset;
    return {
        from: from,
        to: from + textNode.node.nodeValue.length,
        node: textNode.node
    };
}
function $b3e9d73db824614e$var$findCompositionRange(view, changes, headPos) {
    let found = $b3e9d73db824614e$var$findCompositionNode(view, headPos);
    if (!found) return null;
    let { node: textNode, from: from, to: to } = found, text = textNode.nodeValue;
    // Don't try to preserve multi-line compositions
    if (/[\n\r]/.test(text)) return null;
    if (view.state.doc.sliceString(found.from, found.to) != text) return null;
    let inv = changes.invertedDesc;
    return {
        range: new $b3e9d73db824614e$var$ChangedRange(inv.mapPos(from), inv.mapPos(to), from, to),
        text: textNode
    };
}
function $b3e9d73db824614e$var$nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* NextTo.Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* NextTo.After */  : 0);
}
let $b3e9d73db824614e$var$DecorationComparator$1 = class DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $b3e9d73db824614e$var$addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        $b3e9d73db824614e$var$addRange(from, to, this.changes);
    }
    boundChange(pos) {
        $b3e9d73db824614e$var$addRange(pos, pos, this.changes);
    }
};
function $b3e9d73db824614e$var$findChangedDeco(a, b, diff) {
    let comp = new $b3e9d73db824614e$var$DecorationComparator$1;
    (0, $3ef527dddcdea745$export$34cb5241245008dd).compare(a, b, diff, comp);
    return comp.changes;
}
class $b3e9d73db824614e$var$WrapperComparator {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $b3e9d73db824614e$var$addRange(from, to, this.changes);
    }
    comparePoint() {}
    boundChange(pos) {
        $b3e9d73db824614e$var$addRange(pos, pos, this.changes);
    }
}
function $b3e9d73db824614e$var$findChangedWrappers(a, b, diff) {
    let comp = new $b3e9d73db824614e$var$WrapperComparator;
    (0, $3ef527dddcdea745$export$34cb5241245008dd).compare(a, b, diff, comp);
    return comp.changes;
}
function $b3e9d73db824614e$var$inUneditable(node, inside) {
    for(let cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == 'false') return true;
    }
    return false;
}
function $b3e9d73db824614e$var$touchesComposition(changes, composition) {
    let touched = false;
    if (composition) changes.iterChangedRanges((from, to)=>{
        if (from < composition.to && to > composition.from) touched = true;
    });
    return touched;
}
class $b3e9d73db824614e$var$BlockGapWidget extends $b3e9d73db824614e$export$95cdd842edb044c5 {
    constructor(height){
        super();
        this.height = height;
    }
    toDOM() {
        let elt = document.createElement("div");
        elt.className = "cm-gap";
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get editable() {
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
    ignoreEvent() {
        return false;
    }
}
function $b3e9d73db824614e$var$groupAt(state, pos, bias = 1) {
    let categorize = state.charCategorizer(pos);
    let line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    let from = linePos, to = linePos;
    if (bias < 0) from = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, linePos, false);
    else to = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, linePos);
    let cat = categorize(line.text.slice(from, to));
    while(from > 0){
        let prev = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        let next = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).undirectionalRange(from + line.from, to + line.from);
}
function $b3e9d73db824614e$var$posAtCoordsImprecise(view, contentRect, block, x, y) {
    let into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        let textHeight = view.viewState.heightOracle.textHeight;
        let line = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    let content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, $3ef527dddcdea745$export$718b3d71c384ca05)(content, into, view.state.tabSize);
}
function $b3e9d73db824614e$var$blockAt(view, pos, side) {
    let line = view.lineBlockAt(pos);
    if (Array.isArray(line.type)) {
        let best;
        for (let l of line.type){
            if (l.from > pos) break;
            if (l.to < pos) continue;
            if (l.from < pos && l.to > pos) return l;
            if (!best || l.type == $b3e9d73db824614e$export$48808c686fe495c4.Text && (best.type != l.type || (side < 0 ? l.from < pos : l.to > pos))) best = l;
        }
        return best || line;
    }
    return line;
}
function $b3e9d73db824614e$var$moveToLineBoundary(view, start, forward, includeWrap) {
    let line = $b3e9d73db824614e$var$blockAt(view, start.head, start.assoc || -1);
    let coords = !includeWrap || line.type != $b3e9d73db824614e$export$48808c686fe495c4.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        let editorRect = view.dom.getBoundingClientRect();
        let direction = view.textDirectionAt(line.from);
        let pos = view.posAtCoords({
            x: forward == (direction == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
    }
    return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function $b3e9d73db824614e$var$moveByChar(view, start, forward, by) {
    let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    let direction = view.textDirectionAt(line.from);
    for(let cur = start, check = null;;){
        let next = $b3e9d73db824614e$var$moveVisually(line, spans, direction, cur, forward), char = $b3e9d73db824614e$var$movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = view.visualLineSide(line, !forward);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function $b3e9d73db824614e$var$byGroup(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start);
    return (next)=>{
        let nextCat = categorize(next);
        if (cat == (0, $3ef527dddcdea745$export$239a3d59567c1401).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function $b3e9d73db824614e$var$moveVertically(view, start, forward, distance) {
    let startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(startPos, start.assoc);
    let goal = start.goalColumn, startY;
    let rect = view.contentDOM.getBoundingClientRect();
    let startCoords = view.coordsAtPos(startPos, start.assoc || ((start.empty ? forward : start.head == start.from) ? 1 : -1));
    let docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        let line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    let resolvedGoal = rect.left + goal;
    let halfText = view.viewState.heightOracle.textHeight >> 1, dist = distance !== null && distance !== void 0 ? distance : halfText;
    for(let scan = 0;; scan += halfText){
        let y = startY + (dist + scan) * dir;
        let pos = $b3e9d73db824614e$var$posAtCoords(view, {
            x: resolvedGoal,
            y: y
        }, false, dir);
        if (forward ? y > rect.bottom : y < rect.top) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(pos.pos, pos.assoc);
        let posCoords = view.coordsAtPos(pos.pos, pos.assoc), mid = posCoords ? (posCoords.top + posCoords.bottom) / 2 : 0;
        if (!posCoords || (forward ? mid > startY : mid < startY)) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(pos.pos, pos.assoc, undefined, goal);
    }
}
function $b3e9d73db824614e$var$skipAtomicRanges(atoms, pos, bias) {
    for(;;){
        let moved = 0;
        for (let set of atoms)set.between(pos - 1, pos + 1, (from, to, value)=>{
            if (pos > from && pos < to) {
                let side = moved || bias || (pos - from < to - pos ? -1 : 1);
                pos = side < 0 ? from : to;
                moved = side;
            }
        });
        if (!moved) return pos;
    }
}
function $b3e9d73db824614e$var$skipAtomsForSelection(atoms, sel) {
    let ranges = null;
    for(let i = 0; i < sel.ranges.length; i++){
        let range = sel.ranges[i], updated = null;
        if (range.empty) {
            let pos = $b3e9d73db824614e$var$skipAtomicRanges(atoms, range.from, 0);
            if (pos != range.from) updated = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(pos, -1);
        } else {
            let from = $b3e9d73db824614e$var$skipAtomicRanges(atoms, range.from, -1);
            let to = $b3e9d73db824614e$var$skipAtomicRanges(atoms, range.to, 1);
            if (from != range.from || to != range.to) {
                if (range.undirectional) updated = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).undirectionalRange(range.from, range.to);
                else updated = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(range.from == range.anchor ? from : to, range.from == range.head ? from : to);
            }
        }
        if (updated) {
            if (!ranges) ranges = sel.ranges.slice();
            ranges[i] = updated;
        }
    }
    return ranges ? (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create(ranges, sel.mainIndex) : sel;
}
function $b3e9d73db824614e$var$skipAtoms(view, oldPos, pos) {
    let newPos = $b3e9d73db824614e$var$skipAtomicRanges(view.state.facet($b3e9d73db824614e$var$atomicRanges).map((f)=>f(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
    return newPos == pos.from ? pos : (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(newPos, newPos < pos.from ? 1 : -1);
}
class $b3e9d73db824614e$var$PosAssoc {
    constructor(pos, assoc){
        this.pos = pos;
        this.assoc = assoc;
    }
}
function $b3e9d73db824614e$var$posAtCoords(view, coords, precise, scanY) {
    let content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    let { x: x, y: y } = coords, yOffset = y - docTop, block;
    // First find the block at the given Y position, if any. If scanY is
    // given (used for vertical cursor motion), try to skip widgets and
    // line padding.
    for(;;){
        if (yOffset < 0) return new $b3e9d73db824614e$var$PosAssoc(0, 1);
        if (yOffset > view.viewState.docHeight) return new $b3e9d73db824614e$var$PosAssoc(view.state.doc.length, -1);
        block = view.elementAtHeight(yOffset);
        if (scanY == null) break;
        if (block.type == $b3e9d73db824614e$export$48808c686fe495c4.Text) {
            if (scanY < 0 ? block.to < view.viewport.from : block.from > view.viewport.to) break;
            // Check whether we aren't landing on the top/bottom padding of the line
            let rect = view.docView.coordsAt(scanY < 0 ? block.from : block.to, scanY > 0 ? -1 : 1);
            if (rect && (scanY < 0 ? rect.top <= yOffset + docTop : rect.bottom >= yOffset + docTop)) break;
        }
        let halfLine = view.viewState.heightOracle.textHeight / 2;
        yOffset = scanY > 0 ? block.bottom + halfLine : block.top - halfLine;
    }
    // If outside the viewport, return null if precise==true, an
    // estimate otherwise.
    if (view.viewport.from >= block.to || view.viewport.to <= block.from) {
        if (precise) return null;
        if (block.type == $b3e9d73db824614e$export$48808c686fe495c4.Text) {
            let pos = $b3e9d73db824614e$var$posAtCoordsImprecise(view, content, block, x, y);
            return new $b3e9d73db824614e$var$PosAssoc(pos, pos == block.from ? 1 : -1);
        }
    }
    if (block.type != $b3e9d73db824614e$export$48808c686fe495c4.Text) return yOffset < (block.top + block.bottom) / 2 ? new $b3e9d73db824614e$var$PosAssoc(block.from, 1) : new $b3e9d73db824614e$var$PosAssoc(block.to, -1);
    // Here we know we're in a line, so run the logic for inline layout
    let line = view.docView.lineAt(block.from, 2);
    if (!line || line.length != block.length) line = view.docView.lineAt(block.from, -2);
    return new $b3e9d73db824614e$var$InlineCoordsScan(view, x, y, view.textDirectionAt(block.from)).scanTile(line, block.from);
}
class $b3e9d73db824614e$var$InlineCoordsScan {
    constructor(view, x, y, baseDir){
        this.view = view;
        this.x = x;
        this.y = y;
        this.baseDir = baseDir;
        // Cached bidi info
        this.line = null;
        this.spans = null;
    }
    bidiSpansAt(pos) {
        if (!this.line || this.line.from > pos || this.line.to < pos) {
            this.line = this.view.state.doc.lineAt(pos);
            this.spans = this.view.bidiSpans(this.line);
        }
        return this;
    }
    baseDirAt(pos, side) {
        let { line: line, spans: spans } = this.bidiSpansAt(pos);
        let level = spans[$b3e9d73db824614e$export$e1ed96b746bb516a.find(spans, pos - line.from, -1, side)].level;
        return level == this.baseDir;
    }
    dirAt(pos, side) {
        let { line: line, spans: spans } = this.bidiSpansAt(pos);
        return spans[$b3e9d73db824614e$export$e1ed96b746bb516a.find(spans, pos - line.from, -1, side)].dir;
    }
    // Used to short-circuit bidi tests for content with a uniform direction
    bidiIn(from, to) {
        let { spans: spans, line: line } = this.bidiSpansAt(from);
        return spans.length > 1 || spans.length && (spans[0].level != this.baseDir || spans[0].to + line.from < to);
    }
    // Scan through the rectangles for the content of a tile with inline
    // content, looking for one that overlaps the queried position
    // vertically and is closest horizontally. The caller is responsible
    // for dividing its content into N pieces, and pass an array with
    // N+1 positions (including the position after the last piece). For
    // a text tile, these will be character clusters, for a composite
    // tile, these will be child tiles.
    scan(positions, getRects, recursed = false) {
        let lo = 0, hi = positions.length - 1, seen = new Set();
        let bidi = this.bidiIn(positions[0], positions[hi]);
        let above, below;
        let closestI = -1, closestDx = 1e9, closestRect;
        // Because, when the content is bidirectional, a regular binary
        // search is hard to perform (the content order does not
        // correspond to visual order), this loop does something between a
        // regular binary search and a full scan, depending on what it can
        // get away with. The outer hi/lo bounds are only adjusted for
        // elements that are part of the base order.
        //
        // To make sure all elements inside those bounds are visited,
        // eventually, we keep a set of seen indices, and if the midpoint
        // has already been handled, we start in a random index within the
        // current bounds and scan forward until we find an index that
        // hasn't been seen yet.
        search: while(lo < hi){
            let dist = hi - lo, mid = lo + hi >> 1;
            adjust: if (seen.has(mid)) {
                for(let i = 1; i < dist; i++){
                    let scan = mid + i;
                    if (scan >= hi) scan -= dist;
                    if (!seen.has(scan)) {
                        mid = scan;
                        break adjust;
                    }
                }
                break search; // No index found, we're done
            }
            seen.add(mid);
            let rects = getRects(mid), side = 0;
            if (rects) for(let i = 0; i < rects.length; i++){
                let rect = rects[i];
                // Ignore empty rectangles when there are other rectangles
                if (rect.width == 0 && rects.length > 1) continue;
                if (rect.bottom < this.y) {
                    if (!above || above.bottom < rect.bottom) above = rect;
                    side = 1;
                } else if (rect.top > this.y) {
                    if (!below || below.top > rect.top) below = rect;
                    side = -1;
                } else {
                    let off = rect.left > this.x ? this.x - rect.left : rect.right < this.x ? this.x - rect.right : 0;
                    let dx = Math.abs(off);
                    if (dx < closestDx) {
                        closestI = mid;
                        closestDx = dx;
                        closestRect = rect;
                    }
                    if (off) side = off < 0 == (this.baseDir == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR) ? -1 : 1;
                }
            }
            // Narrow binary search when it is safe to do so
            if (side == -1 && (!bidi || this.baseDirAt(positions[mid], 1))) hi = mid;
            else if (side == 1 && (!bidi || this.baseDirAt(positions[mid + 1], -1))) lo = mid + 1;
        }
        // If no element with y overlap is found, find the nearest element
        // on the y axis, move this.y into it, and retry the scan.
        if (!closestRect) {
            if (!below && !above) return {
                i: positions[0],
                after: false
            };
            let side = above && (!below || this.y - above.bottom < below.top - this.y) ? above : below;
            this.y = (side.top + side.bottom) / 2;
            return this.scan(positions, getRects, true);
        }
        // Handle the case where closest matched a higher element on the
        // same line as an element below/above the coords
        if (closestDx && !recursed) {
            let { top: top, bottom: bottom } = closestRect;
            if (above && above.bottom > (top + top + bottom) / 3) {
                this.y = above.bottom - 1;
                return this.scan(positions, getRects, true);
            }
            if (below && below.top < (top + bottom + bottom) / 3) {
                this.y = below.top + 1;
                return this.scan(positions, getRects, true);
            }
        }
        let ltr = (bidi ? this.dirAt(positions[closestI], 1) : this.baseDir) == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR;
        return {
            i: closestI,
            // Test whether x is closes to the start or end of this element
            after: this.x > (closestRect.left + closestRect.right) / 2 == ltr
        };
    }
    scanText(tile, offset) {
        let positions = [];
        for(let i = 0; i < tile.length; i = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(tile.text, i))positions.push(offset + i);
        positions.push(offset + tile.length);
        let scan = this.scan(positions, (i)=>{
            let off = positions[i] - offset, end = positions[i + 1] - offset;
            return $b3e9d73db824614e$var$textRange(tile.dom, off, end).getClientRects();
        });
        return scan.after ? new $b3e9d73db824614e$var$PosAssoc(positions[scan.i + 1], -1) : new $b3e9d73db824614e$var$PosAssoc(positions[scan.i], 1);
    }
    scanTile(tile, offset) {
        if (!tile.length) return new $b3e9d73db824614e$var$PosAssoc(offset, 1);
        if (tile.children.length == 1) {
            let child = tile.children[0];
            if (child.isText()) return this.scanText(child, offset);
            else if (child.isComposite()) return this.scanTile(child, offset);
        }
        let positions = [
            offset
        ];
        for(let i = 0, pos = offset; i < tile.children.length; i++)positions.push(pos += tile.children[i].length);
        let scan = this.scan(positions, (i)=>{
            let child = tile.children[i];
            if (child.flags & 48 /* TileFlag.PointWidget */ ) return null;
            return (child.dom.nodeType == 1 ? child.dom : $b3e9d73db824614e$var$textRange(child.dom, 0, child.length)).getClientRects();
        });
        let child = tile.children[scan.i], pos = positions[scan.i];
        if (child.isText()) return this.scanText(child, pos);
        if (child.isComposite()) return this.scanTile(child, pos);
        return scan.after ? new $b3e9d73db824614e$var$PosAssoc(positions[scan.i + 1], -1) : new $b3e9d73db824614e$var$PosAssoc(pos, 1);
    }
}
const $b3e9d73db824614e$var$LineBreakPlaceholder = "\uffff";
class $b3e9d73db824614e$var$DOMReader {
    constructor(points, view){
        this.points = points;
        this.view = view;
        this.text = "";
        this.lineSeparator = view.state.facet((0, $3ef527dddcdea745$export$afa855cbfaff27f2).lineSeparator);
    }
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += $b3e9d73db824614e$var$LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        let parent = start.parentNode;
        for(let cur = start;;){
            this.findPointBefore(parent, cur);
            let oldLen = this.text.length;
            this.readNode(cur);
            let tile = $b3e9d73db824614e$var$Tile.get(cur), next = cur.nextSibling;
            if (next == end) {
                if ((tile === null || tile === void 0 ? void 0 : tile.breakAfter) && !next && parent != this.view.contentDOM) this.lineBreak();
                break;
            }
            let nextTile = $b3e9d73db824614e$var$Tile.get(next);
            if ((tile && nextTile ? tile.breakAfter : (tile ? tile.breakAfter : $b3e9d73db824614e$var$isBlockElement(cur)) || $b3e9d73db824614e$var$isBlockElement(next) && (cur.nodeName != "BR" || (tile === null || tile === void 0 ? void 0 : tile.isWidget())) && this.text.length > oldLen) && !$b3e9d73db824614e$var$isEmptyToEnd(next, end)) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        let text = node.nodeValue;
        for (let point of this.points)if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
        for(let off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            let nextBreak = -1, breakSize = 1, m;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                for (let point of this.points)if (point.node == node && point.pos > this.text.length) point.pos -= breakSize - 1;
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        let tile = $b3e9d73db824614e$var$Tile.get(node);
        let fromView = tile && tile.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(let i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        for (let point of this.points)if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
    }
    findPointInside(node, length) {
        for (let point of this.points)if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + ($b3e9d73db824614e$var$isAtEnd(node, point.node, point.offset) ? length : 0);
    }
}
function $b3e9d73db824614e$var$isAtEnd(parent, node, offset) {
    for(;;){
        if (!node || offset < $b3e9d73db824614e$var$maxOffset(node)) return false;
        if (node == parent) return true;
        offset = $b3e9d73db824614e$var$domIndex(node) + 1;
        node = node.parentNode;
    }
}
function $b3e9d73db824614e$var$isEmptyToEnd(node, end) {
    let widgets;
    for(;; node = node.nextSibling){
        if (node == end || !node) break;
        let view = $b3e9d73db824614e$var$Tile.get(node);
        if (!(view === null || view === void 0 ? void 0 : view.isWidget())) return false;
        if (view) (widgets || (widgets = [])).push(view);
    }
    if (widgets) for (let w of widgets){
        let override = w.overrideDOMText;
        if (override === null || override === void 0 ? void 0 : override.length) return false;
    }
    return true;
}
class $b3e9d73db824614e$var$DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
class $b3e9d73db824614e$var$DOMChange {
    constructor(view, start, end, typeOver){
        this.typeOver = typeOver;
        this.bounds = null;
        this.text = "";
        this.domChanged = start > -1;
        let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView, curSel = view.state.selection;
        if (view.state.readOnly && start > -1) // Ignore changes when the editor is read-only
        this.newSel = null;
        else if (start > -1 && (this.bounds = $b3e9d73db824614e$var$domBoundsAround(view.docView.tile, start, end, 0))) {
            let selPoints = iHead || iAnchor ? [] : $b3e9d73db824614e$var$selectionPoints(view);
            let reader = new $b3e9d73db824614e$var$DOMReader(selPoints, view);
            reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
            this.text = reader.text;
            this.newSel = $b3e9d73db824614e$var$selectionFromPoints(selPoints, this.bounds.from);
        } else {
            let domSel = view.observer.selectionRange;
            let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !$b3e9d73db824614e$var$contains(view.contentDOM, domSel.focusNode) ? curSel.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
            let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !$b3e9d73db824614e$var$contains(view.contentDOM, domSel.anchorNode) ? curSel.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
            // iOS will refuse to select the block gaps when doing
            // select-all.
            // Chrome will put the selection *inside* them, confusing
            // posFromDOM
            let vp = view.viewport;
            if (($b3e9d73db824614e$var$browser.ios || $b3e9d73db824614e$var$browser.chrome) && head != anchor && Math.min(head, anchor) <= curSel.main.from && Math.max(head, anchor) >= curSel.main.to && (vp.from > 0 || vp.to < view.state.doc.length)) {
                let from = Math.min(head, anchor), to = Math.max(head, anchor);
                let offFrom = vp.from - from, offTo = vp.to - to;
                if ((offFrom == 0 || offFrom == 1 || from == 0) && (offTo == 0 || offTo == -1 || to == view.state.doc.length)) {
                    head = 0;
                    anchor = view.state.doc.length;
                }
            }
            if (view.inputState.composing > -1 && curSel.ranges.length > 1) this.newSel = curSel.replaceRange((0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(anchor, head));
            else if (view.lineWrapping && anchor == head && !(curSel.main.empty && curSel.main.head == head) && view.inputState.lastTouchTime > Date.now() - 100) {
                // If this is a cursor selection change in a line-wrapping
                // editor that may have been a touch, use the last touch
                // position to assign a side to the cursor.
                let before = view.coordsAtPos(head, -1), assoc = 0;
                if (before) assoc = view.inputState.lastTouchY <= before.bottom ? -1 : 1;
                this.newSel = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create([
                    (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(head, assoc)
                ]);
            } else this.newSel = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).single(anchor, head);
        }
    }
}
function $b3e9d73db824614e$var$domBoundsAround(tile, from, to, offset) {
    if (tile.isComposite()) {
        let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(let i = 0, pos = offset, prevEnd = offset; i < tile.children.length; i++){
            let child = tile.children[i], end = pos + child.length;
            if (pos < from && end > to) return $b3e9d73db824614e$var$domBoundsAround(child, from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == tile.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + tile.length : toEnd,
            startDOM: (fromI ? tile.children[fromI - 1].dom.nextSibling : null) || tile.dom.firstChild,
            endDOM: toI < tile.children.length && toI >= 0 ? tile.children[toI].dom : null
        };
    } else if (tile.isText()) return {
        from: offset,
        to: offset + tile.length,
        startDOM: tile.dom,
        endDOM: tile.dom.nextSibling
    };
    else return null;
}
function $b3e9d73db824614e$var$applyDOMChange(view, domChange) {
    let change;
    let { newSel: newSel } = domChange, { state: state } = view, sel = state.selection.main;
    let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
    if (domChange.bounds) {
        let { from: from, to: to } = domChange.bounds;
        let preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (lastKey === 8 || $b3e9d73db824614e$var$browser.android && domChange.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        let cmp = state.doc.sliceString(from, to, $b3e9d73db824614e$var$LineBreakPlaceholder), selEnd, diff;
        if (!sel.empty && sel.from >= from && sel.to <= to && (domChange.typeOver || cmp != domChange.text) && cmp.slice(0, sel.from - from) == domChange.text.slice(0, sel.from - from) && cmp.slice(sel.to - from) == domChange.text.slice(selEnd = domChange.text.length - (cmp.length - (sel.to - from)))) // This looks like a selection replacement
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).of(domChange.text.slice(sel.from - from, selEnd).split($b3e9d73db824614e$var$LineBreakPlaceholder))
        };
        else if (diff = $b3e9d73db824614e$var$findDiff(cmp, domChange.text, preferredPos - from, preferredSide)) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. DomChange drops one of those.
            if ($b3e9d73db824614e$var$browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == $b3e9d73db824614e$var$LineBreakPlaceholder + $b3e9d73db824614e$var$LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).of(domChange.text.slice(diff.from, diff.toB).split($b3e9d73db824614e$var$LineBreakPlaceholder))
            };
        }
    } else if (newSel && (!view.hasFocus && state.facet($b3e9d73db824614e$var$editable) || $b3e9d73db824614e$var$sameSelPos(newSel, sel))) newSel = null;
    if (!change && !newSel) return false;
    if (($b3e9d73db824614e$var$browser.mac || $b3e9d73db824614e$var$browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
        // Detect insert-period-on-double-space Mac and Android behavior,
        // and transform it into a regular space insert.
        if (newSel && change.insert.length == 2) newSel = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: change.from,
            to: change.to,
            insert: (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).of([
                change.insert.toString().replace(".", " ")
            ])
        };
    } else if (state.doc.lineAt(sel.from).to < sel.to && view.docView.lineHasWidget(sel.to) && view.inputState.insertingTextAt > Date.now() - 50) // For a cross-line insertion, Chrome and Safari will crudely take
    // the text of the line after the selection, flattening any
    // widgets, and move it into the joined line. This tries to detect
    // such a situation, and replaces the change with a selection
    // replace of the text provided by the beforeinput event.
    change = {
        from: sel.from,
        to: sel.to,
        insert: state.toText(view.inputState.insertingText)
    };
    else if ($b3e9d73db824614e$var$browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
        // In Chrome, if you insert a space at the start of a wrapped
        // line, it will actually insert a newline and a space, causing a
        // bogus new line to be created in CodeMirror (#968)
        if (newSel) newSel = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).of([
                " "
            ])
        };
    }
    if (change) return $b3e9d73db824614e$var$applyDOMChangeInner(view, change, newSel, lastKey);
    else if (newSel && !$b3e9d73db824614e$var$sameSelPos(newSel, sel)) {
        let scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
            if (userEvent == "select.pointer") newSel = $b3e9d73db824614e$var$skipAtomsForSelection(state.facet($b3e9d73db824614e$var$atomicRanges).map((f)=>f(view)), newSel);
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView: scrollIntoView,
            userEvent: userEvent
        });
        return true;
    } else return false;
}
function $b3e9d73db824614e$var$applyDOMChangeInner(view, change, newSel, lastKey = -1) {
    if ($b3e9d73db824614e$var$browser.ios && view.inputState.flushIOSKey(change)) return true;
    let sel = view.state.selection.main;
    // Android browsers don't fire reasonable key events for enter,
    // backspace, or delete. So this detects changes that look like
    // they're caused by those keys, and reinterprets them as key
    // events. (Some of these keys are also handled by beforeinput
    // events and the pendingAndroidKey mechanism, but that's not
    // reliable in all situations.)
    if ($b3e9d73db824614e$var$browser.android && (change.to == sel.to && // GBoard will sometimes remove a space it just inserted
    // after a completion when you press enter
    (change.from == sel.from || change.from == sel.from - 1 && view.state.sliceDoc(change.from, sel.from) == " ") && change.insert.length == 1 && change.insert.lines == 2 && $b3e9d73db824614e$var$dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from && change.to > sel.head) && $b3e9d73db824614e$var$dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && $b3e9d73db824614e$var$dispatchKey(view.contentDOM, "Delete", 46))) return true;
    let text = change.insert.toString();
    if (view.inputState.composing >= 0) view.inputState.composing++;
    let defaultTr;
    let defaultInsert = ()=>defaultTr || (defaultTr = $b3e9d73db824614e$var$applyDefaultInsert(view, change, newSel));
    if (!view.state.facet($b3e9d73db824614e$var$inputHandler).some((h)=>h(view, change.from, change.to, text, defaultInsert))) view.dispatch(defaultInsert());
    return true;
}
function $b3e9d73db824614e$var$applyDefaultInsert(view, change, newSel) {
    let tr, startState = view.state, sel = startState.selection.main, inAtomic = -1;
    if (change.from == change.to && change.from < sel.from || change.from > sel.to) {
        let side = change.from < sel.from ? -1 : 1, pos = side < 0 ? sel.from : sel.to;
        let moved = $b3e9d73db824614e$var$skipAtomicRanges(startState.facet($b3e9d73db824614e$var$atomicRanges).map((f)=>f(view)), pos, side);
        if (change.from == moved) inAtomic = moved;
    }
    if (inAtomic > -1) tr = {
        changes: change,
        selection: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(change.from + change.insert.length, -1)
    };
    else if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
        let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
        let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
        tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
    } else {
        let changes = startState.changes(change);
        let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : undefined;
        // Try to apply a composition change to all cursors
        if (startState.selection.ranges.length > 1 && (view.inputState.composing >= 0 || view.inputState.compositionPendingChange) && change.to <= sel.to + 10 && change.to >= sel.to - 10) {
            let replaced = view.state.sliceDoc(change.from, change.to);
            let compositionRange, composition = newSel && $b3e9d73db824614e$var$findCompositionNode(view, newSel.main.head);
            if (composition) {
                let dLen = change.insert.length - (change.to - change.from);
                compositionRange = {
                    from: composition.from,
                    to: composition.to - dLen
                };
            } else compositionRange = view.state.doc.lineAt(sel.head);
            let offset = sel.to - change.to;
            tr = startState.changeByRange((range)=>{
                if (range.from == sel.from && range.to == sel.to) return {
                    changes: changes,
                    range: mainSel || range.map(changes)
                };
                let to = range.to - offset, from = to - replaced.length;
                if (view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                // changes in the same node work without aborting
                // composition, so cursors in the composition range are
                // ignored.
                to >= compositionRange.from && from <= compositionRange.to) return {
                    range: range
                };
                let rangeChanges = startState.changes({
                    from: from,
                    to: to,
                    insert: change.insert
                }), selOff = range.to - sel.to;
                return {
                    changes: rangeChanges,
                    range: !mainSel ? range.map(rangeChanges) : (0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                };
            });
        } else tr = {
            changes: changes,
            selection: mainSel && startState.selection.replaceRange(mainSel)
        };
    }
    let userEvent = "input.type";
    if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
        view.inputState.compositionPendingChange = false;
        userEvent += ".compose";
        if (view.inputState.compositionFirstChange) {
            userEvent += ".start";
            view.inputState.compositionFirstChange = false;
        }
    }
    return startState.update(tr, {
        userEvent: userEvent,
        scrollIntoView: true
    });
}
function $b3e9d73db824614e$var$findDiff(a, b, preferredPos, preferredSide) {
    let minLen = Math.min(a.length, b.length);
    let from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    let toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        let adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from: from,
        toA: toA,
        toB: toB
    };
}
function $b3e9d73db824614e$var$selectionPoints(view) {
    let result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    let { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = view.observer.selectionRange;
    if (anchorNode) {
        result.push(new $b3e9d73db824614e$var$DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new $b3e9d73db824614e$var$DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function $b3e9d73db824614e$var$selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, $3ef527dddcdea745$export$3bb1bd44aee62999).single(anchor + base, head + base) : null;
}
function $b3e9d73db824614e$var$sameSelPos(selection, range) {
    return range.head == selection.main.head && range.anchor == selection.main.anchor;
}
class $b3e9d73db824614e$var$InputState {
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    constructor(view){
        this.view = view;
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.touchActive = false;
        this.lastTouchTime = 0;
        this.lastTouchX = 0;
        this.lastTouchY = 0;
        this.lastFocusTime = 0;
        this.lastScrollTop = 0;
        this.lastScrollLeft = 0;
        this.lastWheelEvent = 0;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        // Set to a time stap by scroll events when touch isn't active on
        // iOS, to work around an issue where Safari will abort the scroll
        // momentum if we set scrollTop
        this.lastIOSMomentumScroll = 0;
        // When enabled (>-1), tab presses are not given to key handlers,
        // leaving the browser's default behavior. If >0, the mode expires
        // at that timestamp, and any other keypress clears it.
        // Esc enables temporary tab focus mode for two seconds when not
        // otherwise handled.
        this.tabFocusMode = -1;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.handlers = Object.create(null);
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        // End time of the previous composition
        this.compositionEndedAt = 0;
        // Used in a kludge to detect when an Enter keypress should be
        // considered part of the composition on Safari, which fires events
        // in the wrong order
        this.compositionPendingKey = false;
        // Used to categorize changes as part of a composition, even when
        // the mutation events fire shortly after the compositionend event
        this.compositionPendingChange = false;
        // Set by beforeinput, used in DOM change reader
        this.insertingText = "";
        this.insertingTextAt = 0;
        this.mouseSelection = null;
        // When a drag from the editor is active, this points at the range
        // being dragged.
        this.draggedContent = null;
        this.handleEvent = this.handleEvent.bind(this);
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if ($b3e9d73db824614e$var$browser.safari) view.contentDOM.addEventListener("input", ()=>null);
        if ($b3e9d73db824614e$var$browser.gecko) $b3e9d73db824614e$var$firefoxCopyCutHack(view.contentDOM.ownerDocument);
    }
    handleEvent(event) {
        if (!$b3e9d73db824614e$var$eventBelongsToEditor(this.view, event) || this.ignoreDuringComposition(event)) return;
        if (event.type == "keydown" && this.keydown(event)) return;
        if (this.view.updateState != 0 /* UpdateState.Idle */ ) Promise.resolve().then(()=>this.runHandlers(event.type, event));
        else this.runHandlers(event.type, event);
    }
    runHandlers(type, event) {
        let handlers = this.handlers[type];
        if (handlers) {
            for (let observer of handlers.observers)observer(this.view, event);
            for (let handler of handlers.handlers){
                if (event.defaultPrevented) break;
                if (handler(this.view, event)) {
                    event.preventDefault();
                    break;
                }
            }
        }
    }
    ensureHandlers(plugins) {
        let handlers = $b3e9d73db824614e$var$computeHandlers(plugins), prev = this.handlers, dom = this.view.contentDOM;
        for(let type in handlers)if (type != "scroll") {
            let passive = !handlers[type].handlers.length;
            let exists = prev[type];
            if (exists && passive != !exists.handlers.length) {
                dom.removeEventListener(type, this.handleEvent);
                exists = null;
            }
            if (!exists) dom.addEventListener(type, this.handleEvent, {
                passive: passive
            });
        }
        for(let type in prev)if (type != "scroll" && !handlers[type]) dom.removeEventListener(type, this.handleEvent);
        this.handlers = handlers;
    }
    keydown(event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode)) return true;
        if (this.tabFocusMode > 0 && event.keyCode != 27 && $b3e9d73db824614e$var$modifierCodes.indexOf(event.keyCode) < 0) this.tabFocusMode = -1;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if ($b3e9d73db824614e$var$browser.android && $b3e9d73db824614e$var$browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            this.view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Preventing the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        if ($b3e9d73db824614e$var$browser.ios && !event.synthetic && !event.altKey && !event.metaKey && ($b3e9d73db824614e$var$PendingKeys.some((key)=>key.keyCode == event.keyCode) && !event.ctrlKey || $b3e9d73db824614e$var$EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey)) {
            let mods = {
                ctrlKey: event.ctrlKey,
                altKey: event.altKey,
                metaKey: event.metaKey,
                shiftKey: event.shiftKey
            };
            // On iOS with autocapitalize, drop the shift modifier for these
            // keys, since it will be set at the start of every sentence.
            if (mods.shiftKey && $b3e9d73db824614e$var$browser.ios && !/^(off|none)$/.test(this.view.contentDOM.autocapitalize) && $b3e9d73db824614e$var$iosVirtualKeyboardOpen(this.view.win)) mods.shiftKey = false;
            this.pendingIOSKey = {
                key: event.key,
                keyCode: event.keyCode,
                mods: mods
            };
            setTimeout(()=>this.flushIOSKey(), 250);
            return true;
        }
        if (event.keyCode != 229) this.view.observer.forceFlush();
        return false;
    }
    flushIOSKey(change) {
        let key = this.pendingIOSKey;
        if (!key) return false;
        // This looks like an autocorrection before Enter
        if (key.key == "Enter" && change && change.from < change.to && /^\S+$/.test(change.insert.toString())) return false;
        this.pendingIOSKey = undefined;
        return $b3e9d73db824614e$var$dispatchKey(this.view.contentDOM, key.key, key.keyCode, key.mods);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type) || event.synthetic) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if ($b3e9d73db824614e$var$browser.safari && !$b3e9d73db824614e$var$browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
            this.compositionPendingKey = false;
            return true;
        }
        return false;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        this.view.observer.update(update);
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (this.draggedContent && update.docChanged) this.draggedContent = this.draggedContent.map(update.changes);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
}
function $b3e9d73db824614e$var$iosVirtualKeyboardOpen(win) {
    if (!win.visualViewport) return false;
    return win.visualViewport.height * win.visualViewport.scale / win.document.documentElement.clientHeight < 0.85;
}
function $b3e9d73db824614e$var$bindHandler(plugin, handler) {
    return (view, event)=>{
        try {
            return handler.call(plugin, event, view);
        } catch (e) {
            $b3e9d73db824614e$export$f86b2a1a2ce291b3(view.state, e);
        }
    };
}
function $b3e9d73db824614e$var$computeHandlers(plugins) {
    let result = Object.create(null);
    function record(type) {
        return result[type] || (result[type] = {
            observers: [],
            handlers: []
        });
    }
    for (let plugin of plugins){
        let spec = plugin.spec, handlers = spec && spec.plugin.domEventHandlers, observers = spec && spec.plugin.domEventObservers;
        if (handlers) for(let type in handlers){
            let f = handlers[type];
            if (f) record(type).handlers.push($b3e9d73db824614e$var$bindHandler(plugin.value, f));
        }
        if (observers) for(let type in observers){
            let f = observers[type];
            if (f) record(type).observers.push($b3e9d73db824614e$var$bindHandler(plugin.value, f));
        }
    }
    for(let type in $b3e9d73db824614e$var$handlers)record(type).handlers.push($b3e9d73db824614e$var$handlers[type]);
    for(let type in $b3e9d73db824614e$var$observers)record(type).observers.push($b3e9d73db824614e$var$observers[type]);
    return result;
}
const $b3e9d73db824614e$var$PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertLineBreak"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
const $b3e9d73db824614e$var$EmacsyPendingKeys = "dthko";
// Key codes for modifier keys
const $b3e9d73db824614e$var$modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
const $b3e9d73db824614e$var$dragScrollMargin = 6;
function $b3e9d73db824614e$var$dragScrollSpeed(dist) {
    return Math.max(0, dist) * 0.7 + 8;
}
function $b3e9d73db824614e$var$dist(a, b) {
    return Math.max(Math.abs(a.clientX - b.clientX), Math.abs(a.clientY - b.clientY));
}
class $b3e9d73db824614e$var$MouseSelection {
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.startEvent = startEvent;
        this.style = style;
        this.mustSelect = mustSelect;
        this.scrollSpeed = {
            x: 0,
            y: 0
        };
        this.scrolling = -1;
        this.lastEvent = startEvent;
        this.scrollParents = $b3e9d73db824614e$var$scrollableParents(view.contentDOM);
        this.atoms = view.state.facet($b3e9d73db824614e$var$atomicRanges).map((f)=>f(view));
        let doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, $3ef527dddcdea745$export$afa855cbfaff27f2).allowMultipleSelections) && $b3e9d73db824614e$var$addsSelectionRange(view, startEvent);
        this.dragging = $b3e9d73db824614e$var$isInPrimarySelection(view, startEvent) && $b3e9d73db824614e$var$getClickType(startEvent) == 1 ? null : false;
    }
    start(event) {
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) this.select(event);
    }
    move(event) {
        if (event.buttons == 0) return this.destroy();
        if (this.dragging || this.dragging == null && $b3e9d73db824614e$var$dist(this.startEvent, event) < 10) return;
        this.select(this.lastEvent = event);
        let sx = 0, sy = 0;
        let left = 0, top = 0, right = this.view.win.innerWidth, bottom = this.view.win.innerHeight;
        if (this.scrollParents.x) ({ left: left, right: right } = this.scrollParents.x.getBoundingClientRect());
        if (this.scrollParents.y) ({ top: top, bottom: bottom } = this.scrollParents.y.getBoundingClientRect());
        let margins = $b3e9d73db824614e$var$getScrollMargins(this.view);
        if (event.clientX - margins.left <= left + $b3e9d73db824614e$var$dragScrollMargin) sx = -$b3e9d73db824614e$var$dragScrollSpeed(left - event.clientX);
        else if (event.clientX + margins.right >= right - $b3e9d73db824614e$var$dragScrollMargin) sx = $b3e9d73db824614e$var$dragScrollSpeed(event.clientX - right);
        if (event.clientY - margins.top <= top + $b3e9d73db824614e$var$dragScrollMargin) sy = -$b3e9d73db824614e$var$dragScrollSpeed(top - event.clientY);
        else if (event.clientY + margins.bottom >= bottom - $b3e9d73db824614e$var$dragScrollMargin) sy = $b3e9d73db824614e$var$dragScrollSpeed(event.clientY - bottom);
        this.setScrollSpeed(sx, sy);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        this.setScrollSpeed(0, 0);
        let doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
    }
    setScrollSpeed(sx, sy) {
        this.scrollSpeed = {
            x: sx,
            y: sy
        };
        if (sx || sy) {
            if (this.scrolling < 0) this.scrolling = setInterval(()=>this.scroll(), 50);
        } else if (this.scrolling > -1) {
            clearInterval(this.scrolling);
            this.scrolling = -1;
        }
    }
    scroll() {
        let { x: x, y: y } = this.scrollSpeed;
        if (x && this.scrollParents.x) {
            this.scrollParents.x.scrollLeft += x;
            x = 0;
        }
        if (y && this.scrollParents.y) {
            this.scrollParents.y.scrollTop += y;
            y = 0;
        }
        if (x || y) this.view.win.scrollBy(x, y);
        if (this.dragging === false) this.select(this.lastEvent);
    }
    select(event) {
        let { view: view } = this, selection = $b3e9d73db824614e$var$skipAtomsForSelection(this.atoms, this.style.get(event, this.extend, this.multiple));
        if (this.mustSelect || !selection.eq(view.state.selection, this.dragging === false)) this.view.dispatch({
            selection: selection,
            userEvent: "select.pointer"
        });
        this.mustSelect = false;
    }
    update(update) {
        if (update.transactions.some((tr)=>tr.isUserEvent("input.type"))) this.destroy();
        else if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
}
function $b3e9d73db824614e$var$addsSelectionRange(view, event) {
    let facet = view.state.facet($b3e9d73db824614e$var$clickAddsSelectionRange);
    return facet.length ? facet[0](event) : $b3e9d73db824614e$var$browser.mac ? event.metaKey : event.ctrlKey;
}
function $b3e9d73db824614e$var$dragMovesSelection(view, event) {
    let facet = view.state.facet($b3e9d73db824614e$var$dragMovesSelection$1);
    return facet.length ? facet[0](event) : $b3e9d73db824614e$var$browser.mac ? !event.altKey : !event.ctrlKey;
}
function $b3e9d73db824614e$var$isInPrimarySelection(view, event) {
    let { main: main } = view.state.selection;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    let sel = $b3e9d73db824614e$var$getSelection(view.root);
    if (!sel || sel.rangeCount == 0) return true;
    let rects = sel.getRangeAt(0).getClientRects();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function $b3e9d73db824614e$var$eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target, tile; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (tile = $b3e9d73db824614e$var$Tile.get(node)) && tile.isWidget() && !tile.isHidden && tile.widget.ignoreEvent(event)) return false;
    return true;
}
const $b3e9d73db824614e$var$handlers = /*@__PURE__*/ Object.create(null);
const $b3e9d73db824614e$var$observers = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $b3e9d73db824614e$var$brokenClipboardAPI = $b3e9d73db824614e$var$browser.ie && $b3e9d73db824614e$var$browser.ie_version < 15 || $b3e9d73db824614e$var$browser.ios && $b3e9d73db824614e$var$browser.webkit_version < 604;
function $b3e9d73db824614e$var$capturePaste(view) {
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        $b3e9d73db824614e$var$doPaste(view, target.value);
    }, 50);
}
function $b3e9d73db824614e$var$textFilter(state, facet, text) {
    for (let filter of state.facet(facet))text = filter(text, state);
    return text;
}
function $b3e9d73db824614e$var$doPaste(view, input) {
    input = $b3e9d73db824614e$var$textFilter(view.state, $b3e9d73db824614e$var$clipboardInputFilter, input);
    let { state: state } = view, changes, i = 1, text = state.toText(input);
    let byLine = text.lines == state.selection.ranges.length;
    let linewise = $b3e9d73db824614e$var$lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && $b3e9d73db824614e$var$lastLinewiseCopy == text.toString();
    if (linewise) {
        let lastLine = -1;
        changes = state.changeByRange((range)=>{
            let line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range: range
            };
            lastLine = line.from;
            let insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert: insert
                },
                range: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        let line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
$b3e9d73db824614e$var$observers.scroll = (view)=>{
    let iState = view.inputState;
    iState.lastScrollTop = view.scrollDOM.scrollTop;
    iState.lastScrollLeft = view.scrollDOM.scrollLeft;
    if ($b3e9d73db824614e$var$browser.ios && !iState.touchActive) iState.lastIOSMomentumScroll = Date.now();
};
$b3e9d73db824614e$var$observers.wheel = $b3e9d73db824614e$var$observers.mousewheel = (view)=>{
    view.inputState.lastWheelEvent = Date.now();
};
$b3e9d73db824614e$var$handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27 && view.inputState.tabFocusMode != 0) view.inputState.tabFocusMode = Date.now() + 2000;
    return false;
};
$b3e9d73db824614e$var$observers.touchstart = (view, e)=>{
    let iState = view.inputState, touch = e.targetTouches[0];
    iState.touchActive = true;
    iState.lastTouchTime = Date.now();
    if (touch) {
        iState.lastTouchX = touch.clientX;
        iState.lastTouchY = touch.clientY;
    }
    iState.setSelectionOrigin("select.pointer");
};
$b3e9d73db824614e$var$observers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
$b3e9d73db824614e$var$observers.touchend = (view, e)=>{
    view.inputState.touchActive = false;
};
$b3e9d73db824614e$var$handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if (view.inputState.lastTouchTime > Date.now() - 2000) return false; // Ignore touch interaction
    let style = null;
    for (let makeStyle of view.state.facet($b3e9d73db824614e$var$mouseSelectionStyle)){
        style = makeStyle(view, event);
        if (style) break;
    }
    if (!style && event.button == 0) style = $b3e9d73db824614e$var$basicMouseSelection(view, event);
    if (style) {
        let mustFocus = !view.hasFocus;
        view.inputState.startMouseSelection(new $b3e9d73db824614e$var$MouseSelection(view, event, style, mustFocus));
        if (mustFocus) view.observer.ignore(()=>{
            $b3e9d73db824614e$var$focusPreventScroll(view.contentDOM);
            let active = view.root.activeElement;
            if (active && !active.contains(view.contentDOM)) active.blur();
        });
        let mouseSel = view.inputState.mouseSelection;
        if (mouseSel) {
            mouseSel.start(event);
            return mouseSel.dragging === false;
        }
    } else view.inputState.setSelectionOrigin("select.pointer");
    return false;
};
function $b3e9d73db824614e$var$rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(pos, bias);
    else if (type == 2) return $b3e9d73db824614e$var$groupAt(view.state, pos, bias);
    else {
        let visual = view.docView.lineAt(pos, bias), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        let from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).undirectionalRange(from, to);
    }
}
const $b3e9d73db824614e$var$BadMouseDetail = $b3e9d73db824614e$var$browser.ie && $b3e9d73db824614e$var$browser.ie_version <= 11;
let $b3e9d73db824614e$var$lastMouseDown = null, $b3e9d73db824614e$var$lastMouseDownCount = 0, $b3e9d73db824614e$var$lastMouseDownTime = 0;
function $b3e9d73db824614e$var$getClickType(event) {
    if (!$b3e9d73db824614e$var$BadMouseDetail) return event.detail;
    let last = $b3e9d73db824614e$var$lastMouseDown, lastTime = $b3e9d73db824614e$var$lastMouseDownTime;
    $b3e9d73db824614e$var$lastMouseDown = event;
    $b3e9d73db824614e$var$lastMouseDownTime = Date.now();
    return $b3e9d73db824614e$var$lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? ($b3e9d73db824614e$var$lastMouseDownCount + 1) % 3 : 1;
}
function $b3e9d73db824614e$var$basicMouseSelection(view, event) {
    let start = view.posAndSideAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false), type = $b3e9d73db824614e$var$getClickType(event);
    let startSel = view.state.selection;
    return {
        update (update) {
            if (update.docChanged) {
                start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
            }
        },
        get (event, extend, multiple) {
            let cur = view.posAndSideAtCoords({
                x: event.clientX,
                y: event.clientY
            }, false), removed;
            let range = $b3e9d73db824614e$var$rangeForClick(view, cur.pos, cur.assoc, type);
            if (start.pos != cur.pos && !extend) {
                let startRange = $b3e9d73db824614e$var$rangeForClick(view, start.pos, start.assoc, type);
                let from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(from, to, range.assoc) : (0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(to, from, range.assoc);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to, range.assoc));
            else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = $b3e9d73db824614e$var$removeRangeAround(startSel, cur.pos))) return removed;
            else if (multiple) return startSel.addRange(range);
            else return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create([
                range
            ]);
        }
    };
}
function $b3e9d73db824614e$var$removeRangeAround(sel, pos) {
    for(let i = 0; i < sel.ranges.length; i++){
        let { from: from, to: to } = sel.ranges[i];
        if (from <= pos && to >= pos) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create(sel.ranges.slice(0, i).concat(sel.ranges.slice(i + 1)), sel.mainIndex == i ? 0 : sel.mainIndex - (sel.mainIndex > i ? 1 : 0));
    }
    return null;
}
$b3e9d73db824614e$var$handlers.dragstart = (view, event)=>{
    let { selection: { main: range } } = view.state;
    if (event.target.draggable) {
        let tile = view.docView.tile.nearest(event.target);
        if (tile && tile.isWidget()) {
            let from = tile.posAtStart, to = from + tile.length;
            if (from >= range.to || to <= range.from) range = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).undirectionalRange(from, to);
        }
    }
    let { inputState: inputState } = view;
    if (inputState.mouseSelection) inputState.mouseSelection.dragging = true;
    inputState.draggedContent = range;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", $b3e9d73db824614e$var$textFilter(view.state, $b3e9d73db824614e$var$clipboardOutputFilter, view.state.sliceDoc(range.from, range.to)));
        event.dataTransfer.effectAllowed = "copyMove";
    }
    return false;
};
$b3e9d73db824614e$var$handlers.dragend = (view)=>{
    view.inputState.draggedContent = null;
    return false;
};
function $b3e9d73db824614e$var$dropText(view, event, text, direct) {
    text = $b3e9d73db824614e$var$textFilter(view.state, $b3e9d73db824614e$var$clipboardInputFilter, text);
    if (!text) return;
    let dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let { draggedContent: draggedContent } = view.inputState;
    let del = direct && draggedContent && $b3e9d73db824614e$var$dragMovesSelection(view, event) ? {
        from: draggedContent.from,
        to: draggedContent.to
    } : null;
    let ins = {
        from: dropPos,
        insert: text
    };
    let changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes: changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
    view.inputState.draggedContent = null;
}
$b3e9d73db824614e$var$handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return false;
    if (view.state.readOnly) return true;
    let files = event.dataTransfer.files;
    if (files && files.length) {
        let text = Array(files.length), read = 0;
        let finishFile = ()=>{
            if (++read == files.length) $b3e9d73db824614e$var$dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(let i = 0; i < files.length; i++){
            let reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        }
        return true;
    } else {
        let text = event.dataTransfer.getData("Text");
        if (text) {
            $b3e9d73db824614e$var$dropText(view, event, text, true);
            return true;
        }
    }
    return false;
};
$b3e9d73db824614e$var$handlers.paste = (view, event)=>{
    if (view.state.readOnly) return true;
    view.observer.flush();
    let data = $b3e9d73db824614e$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        $b3e9d73db824614e$var$doPaste(view, data.getData("text/plain") || data.getData("text/uri-list"));
        return true;
    } else {
        $b3e9d73db824614e$var$capturePaste(view);
        return false;
    }
};
function $b3e9d73db824614e$var$captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function $b3e9d73db824614e$var$copiedRange(state) {
    let content = [], ranges = [], linewise = false;
    for (let range of state.selection.ranges)if (!range.empty) {
        content.push(state.sliceDoc(range.from, range.to));
        ranges.push(range);
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        let upto = -1;
        for (let { from: from } of state.selection.ranges){
            let line = state.doc.lineAt(from);
            if (line.number > upto) {
                content.push(line.text);
                ranges.push({
                    from: line.from,
                    to: Math.min(state.doc.length, line.to + 1)
                });
            }
            upto = line.number;
        }
        linewise = true;
    }
    return {
        text: $b3e9d73db824614e$var$textFilter(state, $b3e9d73db824614e$var$clipboardOutputFilter, content.join(state.lineBreak)),
        ranges: ranges,
        linewise: linewise
    };
}
let $b3e9d73db824614e$var$lastLinewiseCopy = null;
$b3e9d73db824614e$var$handlers.copy = $b3e9d73db824614e$var$handlers.cut = (view, event)=>{
    // If the DOM selection is outside this editor, don't intercept.
    // This happens when a parent editor (like ProseMirror) selects content that
    // spans multiple elements including this CodeMirror. The copy event may
    // bubble through CodeMirror (e.g. when CodeMirror is the first or the last
    // element in the selection), but we should let the parent handle it.
    if (!$b3e9d73db824614e$var$hasSelection(view.contentDOM, view.observer.selectionRange)) return false;
    let { text: text, ranges: ranges, linewise: linewise } = $b3e9d73db824614e$var$copiedRange(view.state);
    if (!text && !linewise) return false;
    $b3e9d73db824614e$var$lastLinewiseCopy = linewise ? text : null;
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
    let data = $b3e9d73db824614e$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        data.clearData();
        data.setData("text/plain", text);
        return true;
    } else {
        $b3e9d73db824614e$var$captureCopy(view, text);
        return false;
    }
};
const $b3e9d73db824614e$var$isFocusChange = /*@__PURE__*/ (0, $3ef527dddcdea745$export$9279461326b8700a).define();
function $b3e9d73db824614e$var$focusChangeTransaction(state, focus) {
    let effects = [];
    for (let getEffect of state.facet($b3e9d73db824614e$var$focusChangeEffect)){
        let effect = getEffect(state, focus);
        if (effect) effects.push(effect);
    }
    return effects.length ? state.update({
        effects: effects,
        annotations: $b3e9d73db824614e$var$isFocusChange.of(true)
    }) : null;
}
function $b3e9d73db824614e$var$updateForFocusChange(view) {
    setTimeout(()=>{
        let focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            let tr = $b3e9d73db824614e$var$focusChangeTransaction(view.state, focus);
            if (tr) view.dispatch(tr);
            else view.update([]);
        }
    }, 10);
}
$b3e9d73db824614e$var$observers.focus = (view)=>{
    view.inputState.lastFocusTime = Date.now();
    // When focusing reset the scroll position, move it back to where it was
    if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
        view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
        view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
    }
    $b3e9d73db824614e$var$updateForFocusChange(view);
};
$b3e9d73db824614e$var$observers.blur = (view)=>{
    view.observer.clearSelectionRange();
    $b3e9d73db824614e$var$updateForFocusChange(view);
};
$b3e9d73db824614e$var$observers.compositionstart = $b3e9d73db824614e$var$observers.compositionupdate = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) // FIXME possibly set a timeout to clear it again on Android
    view.inputState.composing = 0;
};
$b3e9d73db824614e$var$observers.compositionend = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionPendingKey = true;
    view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
    view.inputState.compositionFirstChange = null;
    if ($b3e9d73db824614e$var$browser.chrome && $b3e9d73db824614e$var$browser.android) // Delay flushing for a bit on Android because it'll often fire a
    // bunch of contradictory changes in a row at end of composition
    view.observer.flushSoon();
    else if (view.inputState.compositionPendingChange) // If we found pending records, schedule a flush.
    Promise.resolve().then(()=>view.observer.flush());
    else // Otherwise, make sure that, if no changes come in soon, the
    // composition view is cleared.
    setTimeout(()=>{
        if (view.inputState.composing < 0 && view.docView.hasComposition) view.update([]);
    }, 50);
};
$b3e9d73db824614e$var$observers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
$b3e9d73db824614e$var$handlers.beforeinput = (view, event)=>{
    var _a, _b;
    if (event.inputType == "insertText" || event.inputType == "insertCompositionText") {
        view.inputState.insertingText = event.data;
        view.inputState.insertingTextAt = Date.now();
    }
    // In EditContext mode, we must handle insertReplacementText events
    // directly, to make spell checking corrections work
    if (event.inputType == "insertReplacementText" && view.observer.editContext) {
        let text = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("text/plain"), ranges = event.getTargetRanges();
        if (text && ranges.length) {
            let r = ranges[0];
            let from = view.posAtDOM(r.startContainer, r.startOffset), to = view.posAtDOM(r.endContainer, r.endOffset);
            $b3e9d73db824614e$var$applyDOMChangeInner(view, {
                from: from,
                to: to,
                insert: view.state.toText(text)
            }, null);
            return true;
        }
    }
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    let pending;
    if ($b3e9d73db824614e$var$browser.chrome && $b3e9d73db824614e$var$browser.android && (pending = $b3e9d73db824614e$var$PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            let startViewHeight = ((_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
    if ($b3e9d73db824614e$var$browser.ios && event.inputType == "deleteContentForward") // For some reason, DOM changes (and beforeinput) happen _before_
    // the key event for ctrl-d on iOS when using an external
    // keyboard.
    view.observer.flushSoon();
    // Safari will occasionally forget to fire compositionend at the end of a dead-key composition
    if ($b3e9d73db824614e$var$browser.safari && event.inputType == "insertText" && view.inputState.composing >= 0) setTimeout(()=>$b3e9d73db824614e$var$observers.compositionend(view, event), 20);
    return false;
};
const $b3e9d73db824614e$var$appliedFirefoxHack = /*@__PURE__*/ new Set;
// In Firefox, when cut/copy handlers are added to the document, that
// somehow avoids a bug where those events aren't fired when the
// selection is empty. See issue #1082 and
// https://bugzilla.mozilla.org/show_bug.cgi?id=995961
function $b3e9d73db824614e$var$firefoxCopyCutHack(doc) {
    if (!$b3e9d73db824614e$var$appliedFirefoxHack.has(doc)) {
        $b3e9d73db824614e$var$appliedFirefoxHack.add(doc);
        doc.addEventListener("copy", ()=>{});
        doc.addEventListener("cut", ()=>{});
    }
}
const $b3e9d73db824614e$var$wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
// Used to track, during updateHeight, if any actual heights changed
let $b3e9d73db824614e$var$heightChangeFlag = false;
function $b3e9d73db824614e$var$clearHeightChangeFlag() {
    $b3e9d73db824614e$var$heightChangeFlag = false;
}
class $b3e9d73db824614e$var$HeightOracle {
    constructor(lineWrapping){
        this.lineWrapping = lineWrapping;
        this.doc = (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).empty;
        this.heightSamples = {};
        this.lineHeight = 14; // The height of an entire line (line-height)
        this.charWidth = 7;
        this.textHeight = 14; // The height of the actual font (font-size)
        this.lineLength = 30;
    }
    heightForGap(from, to) {
        let lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.max(0, Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength));
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / Math.max(1, this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return $b3e9d73db824614e$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        let newHeight = false;
        for(let i = 0; i < lineHeights.length; i++){
            let h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
        let lineWrapping = $b3e9d73db824614e$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        let changed = Math.abs(lineHeight - this.lineHeight) > 0.3 || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.textHeight = textHeight;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(let i = 0; i < knownHeights.length; i++){
                let h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nodes. The `heights` array is a sequence of
// block heights, starting from position `from`.
class $b3e9d73db824614e$var$MeasuredHeights {
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
    get more() {
        return this.index < this.heights.length;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class $b3e9d73db824614e$export$ddfdc4ccfe9512bd {
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    @internal Weird packed field that holds an array of children
    for composite blocks, a decoration for block widgets, and a
    number indicating the amount of widget-created line breaks for
    text blocks.
    */ _content){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this._content = _content;
    }
    /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ get type() {
        return typeof this._content == "number" ? $b3e9d73db824614e$export$48808c686fe495c4.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    If this is a widget block, this will return the widget
    associated with it.
    */ get widget() {
        return this._content instanceof $b3e9d73db824614e$var$PointDecoration ? this._content.widget : null;
    }
    /**
    If this is a textblock, this holds the number of line breaks
    that appear in widgets inside the block.
    */ get widgetLineBreaks() {
        return typeof this._content == "number" ? this._content : 0;
    }
    /**
    @internal
    */ join(other) {
        let content = (Array.isArray(this._content) ? this._content : [
            this
        ]).concat(Array.isArray(other._content) ? other._content : [
            other
        ]);
        return new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(this.from, this.length + other.length, this.top, this.height + other.height, content);
    }
}
var $b3e9d73db824614e$var$QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}($b3e9d73db824614e$var$QueryType || ($b3e9d73db824614e$var$QueryType = {}));
const $b3e9d73db824614e$var$Epsilon = 1e-3;
class $b3e9d73db824614e$var$HeightMap {
    constructor(length, height, flags = 2 /* Flag.Outdated */ ){
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
    get outdated() {
        return (this.flags & 2 /* Flag.Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Flag.Outdated */  : 0) | this.flags & -3 /* Flag.Outdated */ ;
    }
    setHeight(height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > $b3e9d73db824614e$var$Epsilon) $b3e9d73db824614e$var$heightChangeFlag = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return $b3e9d73db824614e$var$HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        let me = this, doc = oracle.doc;
        for(let i = changes.length - 1; i >= 0; i--){
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = changes[i];
            let start = me.lineAt(fromA, $b3e9d73db824614e$var$QueryType.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
            let end = start.to >= toA ? start : me.lineAt(toA, $b3e9d73db824614e$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, $b3e9d73db824614e$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            let nodes = $b3e9d73db824614e$var$NodeBuilder.build(oracle.setDoc(doc), decorations, fromB, toB);
            me = $b3e9d73db824614e$var$replace(me, me.replace(fromA, toA, nodes));
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new $b3e9d73db824614e$var$HeightMapText(0, 0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        let i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    let split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    let split = nodes[j];
                    if (split.break) nodes.splice(j, 1, split.left, null, split.right);
                    else nodes.splice(j, 1, split.left, split.right);
                    j += 2 + split.break;
                    after -= split.size;
                } else break;
            } else if (before < after) {
                let next = nodes[i++];
                if (next) before += next.size;
            } else {
                let next = nodes[--j];
                if (next) after += next.size;
            }
        }
        let brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new $b3e9d73db824614e$var$HeightMapBranch($b3e9d73db824614e$var$HeightMap.of(nodes.slice(0, i)), brk, $b3e9d73db824614e$var$HeightMap.of(nodes.slice(j)));
    }
}
function $b3e9d73db824614e$var$replace(old, val) {
    if (old == val) return old;
    if (old.constructor != val.constructor) $b3e9d73db824614e$var$heightChangeFlag = true;
    return val;
}
$b3e9d73db824614e$var$HeightMap.prototype.size = 1;
const $b3e9d73db824614e$var$SpaceDeco = /*@__PURE__*/ $b3e9d73db824614e$export$10e30b733df217ea.replace({});
class $b3e9d73db824614e$var$HeightMapBlock extends $b3e9d73db824614e$var$HeightMap {
    constructor(length, height, deco){
        super(length, height);
        this.deco = deco;
        this.spaceAbove = 0;
    }
    mainBlock(top, offset) {
        return new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(offset, this.length, top + this.spaceAbove, this.height - this.spaceAbove, this.deco || 0);
    }
    blockAt(height, _oracle, top, offset) {
        return this.spaceAbove && height < top + this.spaceAbove ? new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(offset, 0, top, this.spaceAbove, $b3e9d73db824614e$var$SpaceDeco) : this.mainBlock(top, offset);
    }
    lineAt(_value, _type, oracle, top, offset) {
        let main = this.mainBlock(top, offset);
        return this.spaceAbove ? this.blockAt(0, oracle, top, offset).join(main) : main;
    }
    forEachLine(from, to, oracle, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.lineAt(0, $b3e9d73db824614e$var$QueryType.ByPos, oracle, top, offset));
    }
    setMeasuredHeight(measured) {
        let next = measured.heights[measured.index++];
        if (next < 0) {
            this.spaceAbove = -next;
            next = measured.heights[measured.index++];
        } else this.spaceAbove = 0;
        this.setHeight(next);
    }
    updateHeight(oracle, offset = 0, _force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setMeasuredHeight(measured);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
}
class $b3e9d73db824614e$var$HeightMapText extends $b3e9d73db824614e$var$HeightMapBlock {
    constructor(length, height, above){
        super(length, height, null);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
        this.breaks = 0; // Number of widget-introduced line breaks on the line
        this.spaceAbove = above;
    }
    mainBlock(top, offset) {
        return new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(offset, this.length, top + this.spaceAbove, this.height - this.spaceAbove, this.breaks);
    }
    replace(_from, _to, nodes) {
        let node = nodes[0];
        if (nodes.length == 1 && (node instanceof $b3e9d73db824614e$var$HeightMapText || node instanceof $b3e9d73db824614e$var$HeightMapGap && node.flags & 4 /* Flag.SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof $b3e9d73db824614e$var$HeightMapGap) node = new $b3e9d73db824614e$var$HeightMapText(node.length, this.height, this.spaceAbove);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return $b3e9d73db824614e$var$HeightMap.of(nodes);
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setMeasuredHeight(measured);
        else if (force || this.outdated) {
            this.spaceAbove = 0;
            this.setHeight(Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
        }
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
}
class $b3e9d73db824614e$var$HeightMapGap extends $b3e9d73db824614e$var$HeightMap {
    constructor(length){
        super(length, 0);
    }
    heightMetrics(oracle, offset) {
        let firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
        let lines = lastLine - firstLine + 1;
        let perLine, perChar = 0;
        if (oracle.lineWrapping) {
            let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
            perLine = totalPerLine / lines;
            if (this.length > lines + 1) perChar = (this.height - totalPerLine) / (this.length - lines - 1);
        } else perLine = this.height / lines;
        return {
            firstLine: firstLine,
            lastLine: lastLine,
            perLine: perLine,
            perChar: perChar
        };
    }
    blockAt(height, oracle, top, offset) {
        let { firstLine: firstLine, lastLine: lastLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        if (oracle.lineWrapping) {
            let guess = offset + (height < oracle.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (height - top) / this.height)) * this.length));
            let line = oracle.doc.lineAt(guess), lineHeight = perLine + line.length * perChar;
            let lineTop = Math.max(top, height - lineHeight / 2);
            return new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0);
        } else {
            let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / perLine)));
            let { from: from, length: length } = oracle.doc.line(firstLine + line);
            return new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(from, length, top + perLine * line, perLine, 0);
        }
    }
    lineAt(value, type, oracle, top, offset) {
        if (type == $b3e9d73db824614e$var$QueryType.ByHeight) return this.blockAt(value, oracle, top, offset);
        if (type == $b3e9d73db824614e$var$QueryType.ByPosNoHeight) {
            let { from: from, to: to } = oracle.doc.lineAt(value);
            return new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(from, to - from, 0, 0, 0);
        }
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        let line = oracle.doc.lineAt(value), lineHeight = perLine + line.length * perChar;
        let linesAbove = line.number - firstLine;
        let lineTop = top + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
        return new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(line.from, line.length, Math.max(top, Math.min(lineTop, top + this.height - lineHeight)), lineHeight, 0);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        from = Math.max(from, offset);
        to = Math.min(to, offset + this.length);
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        for(let pos = from, lineTop = top; pos <= to;){
            let line = oracle.doc.lineAt(pos);
            if (pos == from) {
                let linesAbove = line.number - firstLine;
                lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
            }
            let lineHeight = perLine + perChar * line.length;
            f(new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0));
            lineTop += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        let after = this.length - to;
        if (after > 0) {
            let last = nodes[nodes.length - 1];
            if (last instanceof $b3e9d73db824614e$var$HeightMapGap) nodes[nodes.length - 1] = new $b3e9d73db824614e$var$HeightMapGap(last.length + after);
            else nodes.push(null, new $b3e9d73db824614e$var$HeightMapGap(after - 1));
        }
        if (from > 0) {
            let first = nodes[0];
            if (first instanceof $b3e9d73db824614e$var$HeightMapGap) nodes[0] = new $b3e9d73db824614e$var$HeightMapGap(from + first.length);
            else nodes.unshift(new $b3e9d73db824614e$var$HeightMapGap(from - 1), null);
        }
        return $b3e9d73db824614e$var$HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new $b3e9d73db824614e$var$HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new $b3e9d73db824614e$var$HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            if (measured.from > offset) nodes.push(new $b3e9d73db824614e$var$HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                let len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                let height = measured.heights[measured.index++], above = 0;
                if (height < 0) {
                    above = -height;
                    height = measured.heights[measured.index++];
                }
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= $b3e9d73db824614e$var$Epsilon) singleHeight = -2;
                let line = new $b3e9d73db824614e$var$HeightMapText(len, height, above);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new $b3e9d73db824614e$var$HeightMapGap(end - pos).updateHeight(oracle, pos));
            let result = $b3e9d73db824614e$var$HeightMap.of(nodes);
            if (singleHeight < 0 || Math.abs(result.height - this.height) >= $b3e9d73db824614e$var$Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= $b3e9d73db824614e$var$Epsilon) $b3e9d73db824614e$var$heightChangeFlag = true;
            return $b3e9d73db824614e$var$replace(this, result);
        } else if (force || this.outdated) {
            this.setHeight(oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
}
class $b3e9d73db824614e$var$HeightMapBranch extends $b3e9d73db824614e$var$HeightMap {
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Flag.Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
    get break() {
        return this.flags & 1 /* Flag.Break */ ;
    }
    blockAt(height, oracle, top, offset) {
        let mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, oracle, top, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, oracle, top, offset) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        let left = type == $b3e9d73db824614e$var$QueryType.ByHeight ? value < rightTop : value < rightOffset;
        let base = left ? this.left.lineAt(value, type, oracle, top, offset) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        let subQuery = type == $b3e9d73db824614e$var$QueryType.ByPosNoHeight ? $b3e9d73db824614e$var$QueryType.ByPosNoHeight : $b3e9d73db824614e$var$QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, oracle, top, offset).join(base);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, oracle, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, oracle, rightTop, rightOffset, f);
        } else {
            let mid = this.lineAt(rightOffset, $b3e9d73db824614e$var$QueryType.ByPos, oracle, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, oracle, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, oracle, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        let rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        let result = [];
        if (from > 0) this.decomposeLeft(from, result);
        let left = result.length;
        for (let node of nodes)result.push(node);
        if (from > 0) $b3e9d73db824614e$var$mergeGaps(result, left - 1);
        if (to < this.length) {
            let right = result.length;
            this.decomposeRight(to, result);
            $b3e9d73db824614e$var$mergeGaps(result, right);
        }
        return $b3e9d73db824614e$var$HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        let left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        let left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return $b3e9d73db824614e$var$HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = $b3e9d73db824614e$var$replace(this.left, left);
        this.right = $b3e9d73db824614e$var$replace(this.right, right);
        this.setHeight(left.height + right.height);
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let { left: left, right: right } = this, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
}
function $b3e9d73db824614e$var$mergeGaps(nodes, around) {
    let before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof $b3e9d73db824614e$var$HeightMapGap && (after = nodes[around + 1]) instanceof $b3e9d73db824614e$var$HeightMapGap) nodes.splice(around - 1, 3, new $b3e9d73db824614e$var$HeightMapGap(before.length + 1 + after.length));
}
const $b3e9d73db824614e$var$relevantWidgetHeight = 5;
class $b3e9d73db824614e$var$NodeBuilder {
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            let end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof $b3e9d73db824614e$var$HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new $b3e9d73db824614e$var$HeightMapText(end - this.pos, -1, 0));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            let height = deco.widget ? deco.widget.estimatedHeight : 0;
            let breaks = deco.widget ? deco.widget.lineBreaks : 0;
            if (height < 0) height = this.oracle.lineHeight;
            let len = to - from;
            if (deco.block) this.addBlock(new $b3e9d73db824614e$var$HeightMapBlock(len, height, deco));
            else if (len || breaks || height >= $b3e9d73db824614e$var$relevantWidgetHeight) this.addLineDeco(height, breaks, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        let { from: from, to: to } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new $b3e9d73db824614e$var$HeightMapText(this.pos - from, -1, 0));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        let gap = new $b3e9d73db824614e$var$HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* Flag.SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof $b3e9d73db824614e$var$HeightMapText) return last;
        let line = new $b3e9d73db824614e$var$HeightMapText(0, -1, 0);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        this.enterLine();
        let deco = block.deco;
        if (deco && deco.startSide > 0 && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (deco && deco.endSide > 0) this.covering = block;
    }
    addLineDeco(height, breaks, length) {
        let line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        line.breaks += breaks;
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof $b3e9d73db824614e$var$HeightMapText) && !this.isCovered) this.nodes.push(new $b3e9d73db824614e$var$HeightMapText(0, -1, 0));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        let pos = from;
        for (let node of this.nodes){
            if (node instanceof $b3e9d73db824614e$var$HeightMapText) node.updateHeight(this.oracle, pos);
            pos += node ? node.length : 1;
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        let builder = new $b3e9d73db824614e$var$NodeBuilder(from, oracle);
        (0, $3ef527dddcdea745$export$34cb5241245008dd).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
}
function $b3e9d73db824614e$var$heightRelevantDecoChanges(a, b, diff) {
    let comp = new $b3e9d73db824614e$var$DecorationComparator;
    (0, $3ef527dddcdea745$export$34cb5241245008dd).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class $b3e9d73db824614e$var$DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) $b3e9d73db824614e$var$addRange(from, to, this.changes, 5);
    }
}
function $b3e9d73db824614e$var$visiblePixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
    let top = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
    for(let parent = dom.parentNode; parent && parent != doc.body;){
        if (parent.nodeType == 1) {
            let elt = parent;
            let style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                let parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = Math.min(parent == dom.parentNode ? win.innerHeight : bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function $b3e9d73db824614e$var$inWindow(elt) {
    let rect = elt.getBoundingClientRect(), win = elt.ownerDocument.defaultView || window;
    return rect.left < win.innerWidth && rect.right > 0 && rect.top < win.innerHeight && rect.bottom > 0;
}
function $b3e9d73db824614e$var$fullPixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class $b3e9d73db824614e$var$LineGap {
    constructor(from, to, size, displaySize){
        this.from = from;
        this.to = to;
        this.size = size;
        this.displaySize = displaySize;
    }
    static same(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++){
            let gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(viewState, wrapping) {
        return $b3e9d73db824614e$export$10e30b733df217ea.replace({
            widget: new $b3e9d73db824614e$var$LineGapWidget(this.displaySize * (wrapping ? viewState.scaleY : viewState.scaleX), wrapping)
        }).range(this.from, this.to);
    }
}
class $b3e9d73db824614e$var$LineGapWidget extends $b3e9d73db824614e$export$95cdd842edb044c5 {
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        let elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
}
class $b3e9d73db824614e$var$ViewState {
    constructor(view, state){
        this.view = view;
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0; // Padding above the document, scaled
        this.paddingBottom = 0; // Padding below the document, scaled
        this.contentDOMWidth = 0; // contentDOM.getBoundingClientRect().width
        this.contentDOMHeight = 0; // contentDOM.getBoundingClientRect().height
        this.editorHeight = 0; // scrollDOM.clientHeight, unscaled
        this.editorWidth = 0; // scrollDOM.clientWidth, unscaled
        // The CSS-transformation scale of the editor (transformed size /
        // concrete size)
        this.scaleX = 1;
        this.scaleY = 1;
        // Last seen vertical offset of the element at the top of the scroll
        // container, or top of the window if there's no wrapping scroller
        this.scrollOffset = 0;
        this.scrolledToBottom = false;
        // The vertical position (document-relative) to which to anchor the
        // scroll position. -1 means anchor to the end of the document.
        this.scrollAnchorPos = 0;
        // The height at the anchor position. Set by the DOM update phase.
        // -1 means no height available.
        this.scrollAnchorHeight = -1;
        // See VP.MaxDOMHeight
        this.scaler = $b3e9d73db824614e$var$IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        let guessWrapping = state.facet($b3e9d73db824614e$var$contentAttributes).some((v)=>typeof v != "function" && v.class == "cm-lineWrapping");
        this.heightOracle = new $b3e9d73db824614e$var$HeightOracle(guessWrapping);
        this.stateDeco = $b3e9d73db824614e$var$staticDeco(state);
        this.heightMap = $b3e9d73db824614e$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).empty, this.heightOracle.setDoc(state.doc), [
            new $b3e9d73db824614e$var$ChangedRange(0, 0, 0, state.doc.length)
        ]);
        for(let i = 0; i < 2; i++){
            this.viewport = this.getViewport(0, null);
            if (!this.updateForViewport()) break;
        }
        this.updateViewportLines();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = $b3e9d73db824614e$export$10e30b733df217ea.set(this.lineGaps.map((gap)=>gap.draw(this, false)));
        this.scrollParent = view.scrollDOM;
        this.computeVisibleRanges();
    }
    updateForViewport() {
        let viewports = [
            this.viewport
        ], { main: main } = this.state.selection;
        for(let i = 0; i <= 1; i++){
            let pos = i ? main.head : main.anchor;
            if (!viewports.some(({ from: from, to: to })=>pos >= from && pos <= to)) {
                let { from: from, to: to } = this.lineBlockAt(pos);
                viewports.push(new $b3e9d73db824614e$var$Viewport(from, to));
            }
        }
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        return this.updateScaler();
    }
    updateScaler() {
        let scaler = this.scaler;
        this.scaler = this.heightMap.height <= 7000000 /* VP.MaxDOMHeight */  ? $b3e9d73db824614e$var$IdScaler : new $b3e9d73db824614e$var$BigScaler(this.heightOracle, this.heightMap, this.viewports);
        return scaler.eq(this.scaler) ? 0 : 2 /* UpdateFlag.Height */ ;
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block)=>{
            this.viewportLines.push($b3e9d73db824614e$var$scaleBlock(block, this.scaler));
        });
    }
    update(update, scrollTarget = null) {
        this.state = update.state;
        let prevDeco = this.stateDeco;
        this.stateDeco = $b3e9d73db824614e$var$staticDeco(this.state);
        let contentChanges = update.changedRanges;
        let heightChanges = $b3e9d73db824614e$var$ChangedRange.extendWithRanges(contentChanges, $b3e9d73db824614e$var$heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, $3ef527dddcdea745$export$29d7fbdcb1f8b71c).empty(this.state.doc.length)));
        let prevHeight = this.heightMap.height;
        let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollOffset);
        $b3e9d73db824614e$var$clearHeightChangeFlag();
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight || $b3e9d73db824614e$var$heightChangeFlag) update.flags |= 2 /* UpdateFlag.Height */ ;
        if (scrollAnchor) {
            this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
            this.scrollAnchorHeight = scrollAnchor.top;
        } else {
            this.scrollAnchorPos = -1;
            this.scrollAnchorHeight = prevHeight;
        }
        let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        let viewportChange = viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        update.flags |= this.updateForViewport();
        if (viewportChange || !update.changes.empty || update.flags & 2 /* UpdateFlag.Height */ ) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges(update.changes);
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && (update.selectionSet || update.focusChanged) && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet($b3e9d73db824614e$var$nativeSelectionHidden)) this.mustEnforceCursorAssoc = true;
    }
    measure() {
        let { view: view } = this, dom = view.contentDOM, style = window.getComputedStyle(dom);
        let oracle = this.heightOracle;
        let whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? $b3e9d73db824614e$export$cacd6541cfeeb6c1.RTL : $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR;
        let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace) || this.mustMeasureContent === "refresh";
        let domRect = dom.getBoundingClientRect();
        let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
        this.contentDOMHeight = domRect.height;
        this.mustMeasureContent = false;
        let result = 0, bias = 0;
        if (domRect.width && domRect.height) {
            let { scaleX: scaleX, scaleY: scaleY } = $b3e9d73db824614e$var$getScale(dom, domRect);
            if (scaleX > .005 && Math.abs(this.scaleX - scaleX) > .005 || scaleY > .005 && Math.abs(this.scaleY - scaleY) > .005) {
                this.scaleX = scaleX;
                this.scaleY = scaleY;
                result |= 16 /* UpdateFlag.Geometry */ ;
                refresh = measureContent = true;
            }
        }
        // Vertical padding
        let paddingTop = (parseInt(style.paddingTop) || 0) * this.scaleY;
        let paddingBottom = (parseInt(style.paddingBottom) || 0) * this.scaleY;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 18 /* UpdateFlag.Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        let scrollParent = $b3e9d73db824614e$var$scrollableParents(this.view.contentDOM, false).y;
        if (scrollParent != this.scrollParent) {
            this.scrollParent = scrollParent;
            this.scrollAnchorHeight = -1;
            this.scrollOffset = 0;
        }
        let scrollOffset = this.getScrollOffset();
        if (this.scrollOffset != scrollOffset) {
            this.scrollAnchorHeight = -1;
            this.scrollOffset = scrollOffset;
        }
        this.scrolledToBottom = $b3e9d73db824614e$var$isScrolledToBottom(this.scrollParent || view.win);
        // Pixel viewport
        let pixelViewport = (this.printing ? $b3e9d73db824614e$var$fullPixelRange : $b3e9d73db824614e$var$visiblePixelRange)(dom, this.paddingTop);
        let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView && !this.scrollTarget && !$b3e9d73db824614e$var$inWindow(view.dom)) return 0;
        let contentWidth = domRect.width;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = domRect.width;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        if (measureContent) {
            let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                let { lineHeight: lineHeight, charWidth: charWidth, textHeight: textHeight } = view.docView.measureTextSize();
                refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, Math.max(5, contentWidth / charWidth), lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 16 /* UpdateFlag.Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            $b3e9d73db824614e$var$clearHeightChangeFlag();
            for (let vp of this.viewports){
                let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                this.heightMap = (refresh ? $b3e9d73db824614e$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).empty, this.heightOracle, [
                    new $b3e9d73db824614e$var$ChangedRange(0, 0, 0, view.state.doc.length)
                ]) : this.heightMap).updateHeight(oracle, 0, refresh, new $b3e9d73db824614e$var$MeasuredHeights(vp.from, heights));
            }
            if ($b3e9d73db824614e$var$heightChangeFlag) result |= 2 /* UpdateFlag.Height */ ;
        }
        let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) {
            if (result & 2 /* UpdateFlag.Height */ ) result |= this.updateScaler();
            this.viewport = this.getViewport(bias, this.scrollTarget);
            result |= this.updateForViewport();
        }
        if (result & 2 /* UpdateFlag.Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* VP.Margin */  / 2));
        let map = this.heightMap, oracle = this.heightOracle;
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        let viewport = new $b3e9d73db824614e$var$Viewport(map.lineAt(visibleTop - marginTop * 1000 /* VP.Margin */ , $b3e9d73db824614e$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* VP.Margin */ , $b3e9d73db824614e$var$QueryType.ByHeight, oracle, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            let { head: head } = scrollTarget.range;
            if (head < viewport.from || head > viewport.to) {
                let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                let block = map.lineAt(head, $b3e9d73db824614e$var$QueryType.ByPos, oracle, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new $b3e9d73db824614e$var$Viewport(map.lineAt(topPos - 500, $b3e9d73db824614e$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(topPos + viewHeight + 500, $b3e9d73db824614e$var$QueryType.ByHeight, oracle, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        let from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new $b3e9d73db824614e$var$Viewport(this.heightMap.lineAt(from, $b3e9d73db824614e$var$QueryType.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to, $b3e9d73db824614e$var$QueryType.ByPos, this.heightOracle, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate({ from: from, to: to }, bias = 0) {
        if (!this.inView) return true;
        let { top: top } = this.heightMap.lineAt(from, $b3e9d73db824614e$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { bottom: bottom } = this.heightMap.lineAt(to, $b3e9d73db824614e$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        return (from == 0 || top <= visibleTop - Math.max(10 /* VP.MinCoverMargin */ , Math.min(-bias, 250 /* VP.MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* VP.MinCoverMargin */ , Math.min(bias, 250 /* VP.MaxCoverMargin */ ))) && top > visibleTop - 2000 /* VP.Margin */  && bottom < visibleBottom + 2000 /* VP.Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        let mapped = [];
        for (let gap of gaps)if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new $b3e9d73db824614e$var$LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size, gap.displaySize));
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current, mayMeasure) {
        let wrapping = this.heightOracle.lineWrapping;
        let margin = wrapping ? 10000 /* LG.MarginWrap */  : 2000 /* LG.Margin */ , halfMargin = margin >> 1, doubleMargin = margin << 1;
        // The non-wrapping logic won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR && !wrapping) return [];
        let gaps = [];
        let addGap = (from, to, line, structure)=>{
            if (to - from < halfMargin) return;
            let sel = this.state.selection.main, avoid = [
                sel.from
            ];
            if (!sel.empty) avoid.push(sel.to);
            for (let pos of avoid)if (pos > from && pos < to) {
                addGap(from, pos - 10 /* LG.SelectionMargin */ , line, structure);
                addGap(pos + 10 /* LG.SelectionMargin */ , to, line, structure);
                return;
            }
            let gap = $b3e9d73db824614e$var$find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < halfMargin && Math.abs(gap.to - to) < halfMargin && !avoid.some((pos)=>gap.from < pos && gap.to > pos));
            if (!gap) {
                // When scrolling down, snap gap ends to line starts to avoid shifts in wrapping
                if (to < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r)=>r.from <= to && r.to >= to)) {
                    let lineStart = mayMeasure.moveToLineBoundary((0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(to), false, true).head;
                    if (lineStart > from) to = lineStart;
                }
                let size = this.gapSize(line, from, to, structure);
                let displaySize = wrapping || size < 2000000 /* VP.MaxHorizGap */  ? size : 2000000 /* VP.MaxHorizGap */ ;
                gap = new $b3e9d73db824614e$var$LineGap(from, to, size, displaySize);
            }
            gaps.push(gap);
        };
        let checkLine = (line)=>{
            if (line.length < doubleMargin || line.type != $b3e9d73db824614e$export$48808c686fe495c4.Text) return;
            let structure = $b3e9d73db824614e$var$lineStructure(line.from, line.to, this.stateDeco);
            if (structure.total < doubleMargin) return;
            let target = this.scrollTarget ? this.scrollTarget.range.head : null;
            let viewFrom, viewTo;
            if (wrapping) {
                let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                let top, bot;
                if (target != null) {
                    let targetFrac = $b3e9d73db824614e$var$findFraction(structure, target);
                    let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
                    top = targetFrac - spaceFrac;
                    bot = targetFrac + spaceFrac;
                } else {
                    top = (this.visibleTop - line.top - marginHeight) / line.height;
                    bot = (this.visibleBottom - line.top + marginHeight) / line.height;
                }
                viewFrom = $b3e9d73db824614e$var$findPosition(structure, top);
                viewTo = $b3e9d73db824614e$var$findPosition(structure, bot);
            } else {
                let totalWidth = structure.total * this.heightOracle.charWidth;
                let marginWidth = margin * this.heightOracle.charWidth;
                let horizOffset = 0;
                if (totalWidth > 2000000 /* VP.MaxHorizGap */ ) {
                    for (let old of current)if (old.from >= line.from && old.from < line.to && old.size != old.displaySize && old.from * this.heightOracle.charWidth + horizOffset < this.pixelViewport.left) horizOffset = old.size - old.displaySize;
                }
                let pxLeft = this.pixelViewport.left + horizOffset, pxRight = this.pixelViewport.right + horizOffset;
                let left, right;
                if (target != null) {
                    let targetFrac = $b3e9d73db824614e$var$findFraction(structure, target);
                    let spaceFrac = ((pxRight - pxLeft) / 2 + marginWidth) / totalWidth;
                    left = targetFrac - spaceFrac;
                    right = targetFrac + spaceFrac;
                } else {
                    left = (pxLeft - marginWidth) / totalWidth;
                    right = (pxRight + marginWidth) / totalWidth;
                }
                viewFrom = $b3e9d73db824614e$var$findPosition(structure, left);
                viewTo = $b3e9d73db824614e$var$findPosition(structure, right);
            }
            if (viewFrom > line.from) addGap(line.from, viewFrom, line, structure);
            if (viewTo < line.to) addGap(viewTo, line.to, line, structure);
        };
        for (let line of this.viewportLines)if (Array.isArray(line.type)) line.type.forEach(checkLine);
        else checkLine(line);
        return gaps;
    }
    gapSize(line, from, to, structure) {
        let fraction = $b3e9d73db824614e$var$findFraction(structure, to) - $b3e9d73db824614e$var$findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!$b3e9d73db824614e$var$LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = $b3e9d73db824614e$export$10e30b733df217ea.set(gaps.map((gap)=>gap.draw(this, this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges(changes) {
        let deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        let ranges = [];
        (0, $3ef527dddcdea745$export$34cb5241245008dd).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from: from,
                    to: to
                });
            },
            point () {}
        }, 20);
        let changed = 0;
        if (ranges.length != this.visibleRanges.length) changed = 12 /* UpdateFlag.Viewport */ ;
        else for(let i = 0; i < ranges.length && !(changed & 8 /* UpdateFlag.ViewportMoved */ ); i++){
            let old = this.visibleRanges[i], nw = ranges[i];
            if (old.from != nw.from || old.to != nw.to) {
                changed |= 4 /* UpdateFlag.Viewport */ ;
                if (!(changes && changes.mapPos(old.from, -1) == nw.from && changes.mapPos(old.to, 1) == nw.to)) changed |= 8 /* UpdateFlag.ViewportMoved */ ;
            }
        }
        this.visibleRanges = ranges;
        return changed;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || $b3e9d73db824614e$var$scaleBlock(this.heightMap.lineAt(pos, $b3e9d73db824614e$var$QueryType.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return height >= this.viewportLines[0].top && height <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((l)=>l.top <= height && l.bottom >= height) || $b3e9d73db824614e$var$scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), $b3e9d73db824614e$var$QueryType.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    getScrollOffset() {
        let base = this.scrollParent == this.view.scrollDOM ? this.scrollParent.scrollTop : (this.scrollParent ? this.scrollParent.getBoundingClientRect().top : 0) - this.view.contentDOM.getBoundingClientRect().top;
        return base * this.scaleY;
    }
    scrollAnchorAt(scrollOffset) {
        let block = this.lineBlockAtHeight(scrollOffset + 8);
        return block.from >= this.viewport.from || this.viewportLines[0].top - scrollOffset > 200 ? block : this.viewportLines[0];
    }
    elementAtHeight(height) {
        return $b3e9d73db824614e$var$scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
}
class $b3e9d73db824614e$var$Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function $b3e9d73db824614e$var$lineStructure(from, to, stateDeco) {
    let ranges = [], pos = from, total = 0;
    (0, $3ef527dddcdea745$export$34cb5241245008dd).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to: to
        });
        total += to - pos;
    }
    return {
        total: total,
        ranges: ranges
    };
}
function $b3e9d73db824614e$var$findPosition({ total: total, ranges: ranges }, ratio) {
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    let dist = Math.floor(total * ratio);
    for(let i = 0;; i++){
        let { from: from, to: to } = ranges[i], size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function $b3e9d73db824614e$var$findFraction(structure, pos) {
    let counted = 0;
    for (let { from: from, to: to } of structure.ranges){
        if (pos <= to) {
            counted += pos - from;
            break;
        }
        counted += to - from;
    }
    return counted / structure.total;
}
function $b3e9d73db824614e$var$find(array, f) {
    for (let val of array)if (f(val)) return val;
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
const $b3e9d73db824614e$var$IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1,
    eq (other) {
        return other == this;
    }
};
function $b3e9d73db824614e$var$staticDeco(state) {
    let deco = state.facet($b3e9d73db824614e$var$decorations).filter((d)=>typeof d != "function");
    let outer = state.facet($b3e9d73db824614e$var$outerDecorations).filter((d)=>typeof d != "function");
    if (outer.length) deco.push((0, $3ef527dddcdea745$export$34cb5241245008dd).join(outer));
    return deco;
}
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class $b3e9d73db824614e$var$BigScaler {
    constructor(oracle, heightMap, viewports){
        let vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map(({ from: from, to: to })=>{
            let top = heightMap.lineAt(from, $b3e9d73db824614e$var$QueryType.ByPos, oracle, 0, 0).top;
            let bottom = heightMap.lineAt(to, $b3e9d73db824614e$var$QueryType.ByPos, oracle, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from: from,
                to: to,
                top: top,
                bottom: bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* VP.MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        for (let obj of this.viewports){
            obj.domTop = domBase + (obj.top - base) * this.scale;
            domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
            base = obj.bottom;
        }
    }
    toDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    eq(other) {
        if (!(other instanceof $b3e9d73db824614e$var$BigScaler)) return false;
        return this.scale == other.scale && this.viewports.length == other.viewports.length && this.viewports.every((vp, i)=>vp.from == other.viewports[i].from && vp.to == other.viewports[i].to);
    }
}
function $b3e9d73db824614e$var$scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new $b3e9d73db824614e$export$ddfdc4ccfe9512bd(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b)=>$b3e9d73db824614e$var$scaleBlock(b, scaler)) : block._content);
}
const $b3e9d73db824614e$var$theme = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (strs)=>strs.join(" ")
});
const $b3e9d73db824614e$var$darkTheme = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.indexOf(true) > -1
});
const $b3e9d73db824614e$var$baseThemeID = /*@__PURE__*/ (0, $246d4c208d441e56$export$b920c662d2efee20).newName(), $b3e9d73db824614e$var$baseLightID = /*@__PURE__*/ (0, $246d4c208d441e56$export$b920c662d2efee20).newName(), $b3e9d73db824614e$var$baseDarkID = /*@__PURE__*/ (0, $246d4c208d441e56$export$b920c662d2efee20).newName();
const $b3e9d73db824614e$var$lightDarkIDs = {
    "&light": "." + $b3e9d73db824614e$var$baseLightID,
    "&dark": "." + $b3e9d73db824614e$var$baseDarkID
};
function $b3e9d73db824614e$var$buildTheme(main, spec, scopes) {
    return new (0, $246d4c208d441e56$export$b920c662d2efee20)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
const $b3e9d73db824614e$var$baseTheme$1 = /*@__PURE__*/ $b3e9d73db824614e$var$buildTheme("." + $b3e9d73db824614e$var$baseThemeID, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0,
        overflowAnchor: "none"
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        minHeight: "100%",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        userSelect: "none",
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#ddd"
    },
    ".cm-selectionHandle": {
        backgroundColor: "currentColor",
        width: "1.5px"
    },
    ".cm-selectionHandle-start::before, .cm-selectionHandle-end::before": {
        content: '""',
        backgroundColor: "inherit",
        borderRadius: "50%",
        width: "8px",
        height: "8px",
        position: "absolute",
        left: "-3.25px"
    },
    ".cm-selectionHandle-start::before": {
        top: "-8px"
    },
    ".cm-selectionHandle-end::before": {
        bottom: "-8px"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    ".cm-iso": {
        unicodeBidi: "isolate"
    },
    ".cm-announced": {
        position: "fixed",
        top: "-10000px"
    },
    "@media print": {
        ".cm-announced": {
            display: "none"
        }
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        zIndex: 200
    },
    ".cm-gutters-before": {
        insetInlineStart: 0
    },
    ".cm-gutters-after": {
        insetInlineEnd: 0
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        border: "0px solid #ddd",
        "&.cm-gutters-before": {
            borderRightWidth: "1px"
        },
        "&.cm-gutters-after": {
            borderLeftWidth: "1px"
        }
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0,
        zIndex: 300
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    ".cm-panels-top": {
        top: "0"
    },
    ".cm-panels-bottom": {
        bottom: "0"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-dialog": {
        padding: "2px 19px 4px 6px",
        position: "relative",
        "& label": {
            fontSize: "80%"
        }
    },
    ".cm-dialog-close": {
        position: "absolute",
        top: "3px",
        right: "4px",
        backgroundColor: "inherit",
        border: "none",
        font: "inherit",
        fontSize: "14px",
        padding: "0"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top",
        userSelect: "none"
    },
    ".cm-highlightSpace": {
        backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
        backgroundPosition: "center"
    },
    ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, $b3e9d73db824614e$var$lightDarkIDs);
const $b3e9d73db824614e$var$observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
const $b3e9d73db824614e$var$useCharData = $b3e9d73db824614e$var$browser.ie && $b3e9d73db824614e$var$browser.ie_version <= 11;
class $b3e9d73db824614e$var$DOMObserver {
    constructor(view){
        this.view = view;
        this.active = false;
        this.editContext = null;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new $b3e9d73db824614e$var$DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
        this.lastChange = 0;
        this.scrollTargets = [];
        this.intersection = null;
        this.resizeScroll = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        this.printQuery = null;
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            for (let mut of mutations)this.queue.push(mut);
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if (($b3e9d73db824614e$var$browser.ie && $b3e9d73db824614e$var$browser.ie_version <= 11 || $b3e9d73db824614e$var$browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if (window.EditContext && $b3e9d73db824614e$var$browser.android && view.constructor.EDIT_CONTEXT !== false && // Chrome <126 doesn't support inverted selections in edit context (#1392)
        !($b3e9d73db824614e$var$browser.chrome && $b3e9d73db824614e$var$browser.chrome_version < 126)) {
            this.editContext = new $b3e9d73db824614e$var$EditContextManager(view);
            if (view.state.facet($b3e9d73db824614e$var$editable)) view.contentDOM.editContext = this.editContext.editContext;
        }
        if ($b3e9d73db824614e$var$useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onScroll = this.onScroll.bind(this);
        if (window.matchMedia) this.printQuery = window.matchMedia("print");
        if (typeof ResizeObserver == "function") {
            this.resizeScroll = new ResizeObserver(()=>{
                var _a;
                if (((_a = this.view.docView) === null || _a === void 0 ? void 0 : _a.lastUpdate) < Date.now() - 75) this.onResize();
            });
            this.resizeScroll.observe(view.scrollDOM);
        }
        this.addWindowListeners(this.win = view.win);
        this.start();
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {
                threshold: [
                    0,
                    .001
                ]
            });
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
    }
    onScrollChanged(e) {
        this.view.inputState.runHandlers("scroll", e);
        if (this.intersecting) this.view.measure();
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        if (this.editContext) this.view.requestMeasure(this.editContext.measureReq);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint(event) {
        if ((event.type == "change" || !event.type) && !event.matches) return;
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            for (let gap of gaps)this.gapIntersection.observe(gap);
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        let wasChanged = this.selectionChanged;
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        let { view: view } = this, sel = this.selectionRange;
        if (view.state.facet($b3e9d73db824614e$var$editable) ? view.root.activeElement != this.dom : !$b3e9d73db824614e$var$hasSelection(this.dom, sel)) return;
        let context = sel.anchorNode && view.docView.tile.nearest(sel.anchorNode);
        if (context && context.isWidget() && context.widget.ignoreEvent(event)) {
            if (!wasChanged) this.selectionChanged = false;
            return;
        }
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if (($b3e9d73db824614e$var$browser.ie && $b3e9d73db824614e$var$browser.ie_version <= 11 || $b3e9d73db824614e$var$browser.android && $b3e9d73db824614e$var$browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && $b3e9d73db824614e$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        let { view: view } = this;
        // The Selection object is broken in shadow roots in Safari. See
        // issue #414
        let selection = $b3e9d73db824614e$var$getSelection(view.root);
        if (!selection) return false;
        let range = $b3e9d73db824614e$var$browser.safari && view.root.nodeType == 11 && view.root.activeElement == this.dom && $b3e9d73db824614e$var$safariSelectionRangeHack(this.view, selection) || selection;
        if (!range || this.selectionRange.eq(range)) return false;
        let local = $b3e9d73db824614e$var$hasSelection(this.dom, range);
        // Detect the situation where the browser has, on focus, moved the
        // selection to the start of the content element. Reset it to the
        // position from the editor state.
        if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && $b3e9d73db824614e$var$atElementStart(this.dom, range)) {
            this.view.inputState.lastFocusTime = 0;
            view.docView.updateSelection();
            return false;
        }
        this.selectionRange.setRange(range);
        if (local) this.selectionChanged = true;
        return true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        let i = 0, changed = null;
        for(let dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
            for (let dom of this.scrollTargets = changed)dom.addEventListener("scroll", this.onScroll);
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, $b3e9d73db824614e$var$observeOptions);
        if ($b3e9d73db824614e$var$useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if ($b3e9d73db824614e$var$useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        var _a;
        if (!this.delayedAndroidKey) {
            let flush = ()=>{
                let key = this.delayedAndroidKey;
                if (key) {
                    this.clearDelayedAndroidKey();
                    this.view.inputState.lastKeyCode = key.keyCode;
                    this.view.inputState.lastKeyTime = Date.now();
                    let flushed = this.flush();
                    if (!flushed && key.force) $b3e9d73db824614e$var$dispatchKey(this.dom, key.key, key.keyCode);
                }
            };
            this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
        }
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key: key,
            keyCode: keyCode,
            // Only run the key handler when no changes are detected if
            // this isn't coming right after another change, in which case
            // it is probably part of a weird chain of updates, and should
            // be ignored if it returns the DOM to its previous state.
            force: this.lastChange < Date.now() - 50 || !!((_a = this.delayedAndroidKey) === null || _a === void 0 ? void 0 : _a.force)
        };
    }
    clearDelayedAndroidKey() {
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = this.view.win.requestAnimationFrame(()=>{
            this.delayedFlush = -1;
            this.flush();
        });
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            this.view.win.cancelAnimationFrame(this.delayedFlush);
            this.delayedFlush = -1;
        }
        this.flush();
    }
    pendingRecords() {
        for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    processRecords() {
        let records = this.pendingRecords();
        if (records.length) this.queue = [];
        let from = -1, to = -1, typeOver = false;
        for (let record of records){
            let range = this.readMutation(record);
            if (!range) continue;
            if (range.typeOver) typeOver = true;
            if (from == -1) ({ from: from, to: to } = range);
            else {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        }
        return {
            from: from,
            to: to,
            typeOver: typeOver
        };
    }
    readChange() {
        let { from: from, to: to, typeOver: typeOver } = this.processRecords();
        let newSel = this.selectionChanged && $b3e9d73db824614e$var$hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return null;
        if (from > -1) this.lastChange = Date.now();
        this.view.inputState.lastFocusTime = 0;
        this.selectionChanged = false;
        let change = new $b3e9d73db824614e$var$DOMChange(this.view, from, to, typeOver);
        this.view.docView.domChanged = {
            newSel: change.newSel ? change.newSel.main : null
        };
        return change;
    }
    // Apply pending changes, if any
    flush(readSelection = true) {
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return false;
        if (readSelection) this.readSelectionRange();
        let domChange = this.readChange();
        if (!domChange) {
            this.view.requestMeasure();
            return false;
        }
        let startState = this.view.state;
        let handled = $b3e9d73db824614e$var$applyDOMChange(this.view, domChange);
        // The view wasn't updated but DOM/selection changes were seen. Reset the view.
        if (this.view.state == startState && (domChange.domChanged || domChange.newSel && !$b3e9d73db824614e$var$sameSelPos(this.view.state.selection, domChange.newSel.main))) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        let tile = this.view.docView.tile.nearest(rec.target);
        if (!tile || tile.isWidget()) return null;
        tile.markDirty(rec.type == "attributes");
        if (rec.type == "childList") {
            let childBefore = $b3e9d73db824614e$var$findChild(tile, rec.previousSibling || rec.target.previousSibling, -1);
            let childAfter = $b3e9d73db824614e$var$findChild(tile, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? tile.posAfter(childBefore) : tile.posAtStart,
                to: childAfter ? tile.posBefore(childAfter) : tile.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: tile.posAtStart,
            to: tile.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    setWindow(win) {
        if (win != this.win) {
            this.removeWindowListeners(this.win);
            this.win = win;
            this.addWindowListeners(this.win);
        }
    }
    addWindowListeners(win) {
        win.addEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.addEventListener) this.printQuery.addEventListener("change", this.onPrint);
            else this.printQuery.addListener(this.onPrint);
        } else win.addEventListener("beforeprint", this.onPrint);
        win.addEventListener("scroll", this.onScroll);
        win.document.addEventListener("selectionchange", this.onSelectionChange);
    }
    removeWindowListeners(win) {
        win.removeEventListener("scroll", this.onScroll);
        win.removeEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.removeEventListener) this.printQuery.removeEventListener("change", this.onPrint);
            else this.printQuery.removeListener(this.onPrint);
        } else win.removeEventListener("beforeprint", this.onPrint);
        win.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    update(update) {
        if (this.editContext) {
            this.editContext.update(update);
            if (update.startState.facet($b3e9d73db824614e$var$editable) != update.state.facet($b3e9d73db824614e$var$editable)) update.view.contentDOM.editContext = update.state.facet($b3e9d73db824614e$var$editable) ? this.editContext.editContext : null;
        }
    }
    destroy() {
        var _a, _b, _c;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resizeScroll) === null || _c === void 0 || _c.disconnect();
        for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
        this.removeWindowListeners(this.win);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
        this.win.cancelAnimationFrame(this.delayedFlush);
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        if (this.editContext) {
            this.view.contentDOM.editContext = null;
            this.editContext.destroy();
        }
    }
}
function $b3e9d73db824614e$var$findChild(tile, dom, dir) {
    while(dom){
        let curTile = $b3e9d73db824614e$var$Tile.get(dom);
        if (curTile && curTile.parent == tile) return curTile;
        let parent = dom.parentNode;
        dom = parent != tile.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
function $b3e9d73db824614e$var$buildSelectionRangeFromRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor, 1);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($b3e9d73db824614e$var$isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function $b3e9d73db824614e$var$safariSelectionRangeHack(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $b3e9d73db824614e$var$buildSelectionRangeFromRange(view, range);
    }
    let found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    view.dom.ownerDocument.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    return found ? $b3e9d73db824614e$var$buildSelectionRangeFromRange(view, found) : null;
}
class $b3e9d73db824614e$var$EditContextManager {
    constructor(view){
        // The document window for which the text in the context is
        // maintained. For large documents, this may be smaller than the
        // editor document. This window always includes the selection head.
        this.from = 0;
        this.to = 0;
        // When applying a transaction, this is used to compare the change
        // made to the context content to the change in the transaction in
        // order to make the minimal changes to the context (since touching
        // that sometimes breaks series of multiple edits made for a single
        // user action on some Android keyboards)
        this.pendingContextChange = null;
        this.handlers = Object.create(null);
        // Kludge to work around the fact that EditContext does not respond
        // well to having its content updated during a composition (see #1472)
        this.composing = null;
        this.resetRange(view.state);
        let context = this.editContext = new window.EditContext({
            text: view.state.doc.sliceString(this.from, this.to),
            selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, view.state.selection.main.anchor))),
            selectionEnd: this.toContextPos(view.state.selection.main.head)
        });
        this.handlers.textupdate = (e)=>{
            let main = view.state.selection.main, { anchor: anchor, head: head } = main;
            let from = this.toEditorPos(e.updateRangeStart), to = this.toEditorPos(e.updateRangeEnd);
            if (view.inputState.composing >= 0 && !this.composing) this.composing = {
                contextBase: e.updateRangeStart,
                editorBase: from,
                drifted: false
            };
            let deletes = to - from > e.text.length;
            // If the window doesn't include the anchor, assume changes
            // adjacent to a side go up to the anchor.
            if (from == this.from && anchor < this.from) from = anchor;
            else if (to == this.to && anchor > this.to) to = anchor;
            let diff = $b3e9d73db824614e$var$findDiff(view.state.sliceDoc(from, to), e.text, (deletes ? main.from : main.to) - from, deletes ? "end" : null);
            // Edit contexts sometimes fire empty changes
            if (!diff) {
                let newSel = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart), this.toEditorPos(e.selectionEnd));
                if (!$b3e9d73db824614e$var$sameSelPos(newSel, main)) view.dispatch({
                    selection: newSel,
                    userEvent: "select"
                });
                return;
            }
            let change = {
                from: diff.from + from,
                to: diff.toA + from,
                insert: (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).of(e.text.slice(diff.from, diff.toB).split("\n"))
            };
            if (($b3e9d73db824614e$var$browser.mac || $b3e9d73db824614e$var$browser.android) && change.from == head - 1 && /^\. ?$/.test(e.text) && view.contentDOM.getAttribute("autocorrect") == "off") change = {
                from: from,
                to: to,
                insert: (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).of([
                    e.text.replace(".", " ")
                ])
            };
            this.pendingContextChange = change;
            if (!view.state.readOnly) {
                let newLen = this.to - this.from + (change.to - change.from + change.insert.length);
                $b3e9d73db824614e$var$applyDOMChangeInner(view, change, (0, $3ef527dddcdea745$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart, newLen), this.toEditorPos(e.selectionEnd, newLen)));
            }
            // If the transaction didn't flush our change, revert it so
            // that the context is in sync with the editor state again.
            if (this.pendingContextChange) {
                this.revertPending(view.state);
                this.setSelection(view.state);
            }
            // Work around missed compositionend events. See https://discuss.codemirror.net/t/a/9514
            if (change.from < change.to && !change.insert.length && view.inputState.composing >= 0 && !/[\\p{Alphabetic}\\p{Number}_]/.test(context.text.slice(Math.max(0, e.updateRangeStart - 1), Math.min(context.text.length, e.updateRangeStart + 1)))) this.handlers.compositionend(e);
        };
        this.handlers.characterboundsupdate = (e)=>{
            let rects = [], prev = null;
            for(let i = this.toEditorPos(e.rangeStart), end = this.toEditorPos(e.rangeEnd); i < end; i++){
                let rect = view.coordsForChar(i);
                prev = rect && new DOMRect(rect.left, rect.top, rect.right - rect.left, rect.bottom - rect.top) || prev || new DOMRect;
                rects.push(prev);
            }
            context.updateCharacterBounds(e.rangeStart, rects);
        };
        this.handlers.textformatupdate = (e)=>{
            let deco = [];
            for (let format of e.getTextFormats()){
                let lineStyle = format.underlineStyle, thickness = format.underlineThickness;
                if (!/none/i.test(lineStyle) && !/none/i.test(thickness)) {
                    let from = this.toEditorPos(format.rangeStart), to = this.toEditorPos(format.rangeEnd);
                    if (from < to) {
                        // These values changed from capitalized custom strings to lower-case CSS keywords in 2025
                        let style = `text-decoration: underline ${/^[a-z]/.test(lineStyle) ? lineStyle + " " : lineStyle == "Dashed" ? "dashed " : lineStyle == "Squiggle" ? "wavy " : ""}${/thin/i.test(thickness) ? 1 : 2}px`;
                        deco.push($b3e9d73db824614e$export$10e30b733df217ea.mark({
                            attributes: {
                                style: style
                            }
                        }).range(from, to));
                    }
                }
            }
            view.dispatch({
                effects: $b3e9d73db824614e$var$setEditContextFormatting.of($b3e9d73db824614e$export$10e30b733df217ea.set(deco))
            });
        };
        this.handlers.compositionstart = ()=>{
            if (view.inputState.composing < 0) {
                view.inputState.composing = 0;
                view.inputState.compositionFirstChange = true;
            }
        };
        this.handlers.compositionend = ()=>{
            view.inputState.composing = -1;
            view.inputState.compositionFirstChange = null;
            if (this.composing) {
                let { drifted: drifted } = this.composing;
                this.composing = null;
                if (drifted) this.reset(view.state);
            }
        };
        for(let event in this.handlers)context.addEventListener(event, this.handlers[event]);
        this.measureReq = {
            read: (view)=>{
                let sel = $b3e9d73db824614e$var$getSelection(view.root);
                if (sel && sel.rangeCount) this.editContext.updateSelectionBounds(sel.getRangeAt(0).getBoundingClientRect());
            }
        };
    }
    applyEdits(update) {
        let off = 0, abort = false, pending = this.pendingContextChange;
        update.changes.iterChanges((fromA, toA, _fromB, _toB, insert)=>{
            if (abort) return;
            let dLen = insert.length - (toA - fromA);
            if (pending && toA >= pending.to) {
                if (pending.from == fromA && pending.to == toA && pending.insert.eq(insert)) {
                    pending = this.pendingContextChange = null; // Match
                    off += dLen;
                    this.to += dLen;
                    return;
                } else {
                    pending = null;
                    this.revertPending(update.state);
                }
            }
            fromA += off;
            toA += off;
            if (toA <= this.from) {
                this.from += dLen;
                this.to += dLen;
            } else if (fromA < this.to) {
                if (fromA < this.from || toA > this.to || this.to - this.from + insert.length > 30000 /* CxVp.MaxSize */ ) {
                    abort = true;
                    return;
                }
                this.editContext.updateText(this.toContextPos(fromA), this.toContextPos(toA), insert.toString());
                this.to += dLen;
            }
            off += dLen;
        });
        if (pending && !abort) this.revertPending(update.state);
        return !abort;
    }
    update(update) {
        let reverted = this.pendingContextChange, startSel = update.startState.selection.main;
        if (this.composing && (this.composing.drifted || !update.changes.touchesRange(startSel.from, startSel.to) && update.transactions.some((tr)=>!tr.isUserEvent("input.type") && tr.changes.touchesRange(this.from, this.to)))) {
            this.composing.drifted = true;
            this.composing.editorBase = update.changes.mapPos(this.composing.editorBase);
        } else if (!this.applyEdits(update) || !this.rangeIsValid(update.state)) {
            this.pendingContextChange = null;
            this.reset(update.state);
        } else if (update.docChanged || update.selectionSet || reverted) this.setSelection(update.state);
        if (update.geometryChanged || update.docChanged || update.selectionSet) update.view.requestMeasure(this.measureReq);
    }
    resetRange(state) {
        let { head: head } = state.selection.main;
        this.from = Math.max(0, head - 10000 /* CxVp.Margin */ );
        this.to = Math.min(state.doc.length, head + 10000 /* CxVp.Margin */ );
    }
    reset(state) {
        this.resetRange(state);
        this.editContext.updateText(0, this.editContext.text.length, state.doc.sliceString(this.from, this.to));
        this.setSelection(state);
    }
    revertPending(state) {
        let pending = this.pendingContextChange;
        this.pendingContextChange = null;
        this.editContext.updateText(this.toContextPos(pending.from), this.toContextPos(pending.from + pending.insert.length), state.doc.sliceString(pending.from, pending.to));
    }
    setSelection(state) {
        let { main: main } = state.selection;
        let start = this.toContextPos(Math.max(this.from, Math.min(this.to, main.anchor)));
        let end = this.toContextPos(main.head);
        if (this.editContext.selectionStart != start || this.editContext.selectionEnd != end) this.editContext.updateSelection(start, end);
    }
    rangeIsValid(state) {
        let { head: head } = state.selection.main;
        return !(this.from > 0 && head - this.from < 500 /* CxVp.MinMargin */  || this.to < state.doc.length && this.to - head < 500 /* CxVp.MinMargin */  || this.to - this.from > 30000);
    }
    toEditorPos(contextPos, clipLen = this.to - this.from) {
        contextPos = Math.min(contextPos, clipLen);
        let c = this.composing;
        return c && c.drifted ? c.editorBase + (contextPos - c.contextBase) : contextPos + this.from;
    }
    toContextPos(editorPos) {
        let c = this.composing;
        return c && c.drifted ? c.contextBase + (editorPos - c.editorBase) : editorPos - this.from;
    }
    destroy() {
        for(let event in this.handlers)this.editContext.removeEventListener(event, this.handlers[event]);
    }
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class $b3e9d73db824614e$export$eece2fccabbb77c5 {
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return !!this.inputState && this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return !!this.inputState && this.inputState.composing >= 0;
    }
    /**
    The document or shadow root that the view lives in.
    */ get root() {
        return this._root;
    }
    /**
    @internal
    */ get win() {
        return this.dom.ownerDocument.defaultView || window;
    }
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(config = {}){
        var _a;
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* UpdateState.Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.className = "cm-announced";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        if (config.parent) config.parent.appendChild(this.dom);
        let { dispatch: dispatch } = config;
        this.dispatchTransactions = config.dispatchTransactions || dispatch && ((trs)=>trs.forEach((tr)=>dispatch(tr, this))) || ((trs)=>this.update(trs));
        this.dispatch = this.dispatch.bind(this);
        this._root = config.root || $b3e9d73db824614e$var$getRoot(config.parent) || document;
        this.viewState = new $b3e9d73db824614e$var$ViewState(this, config.state || (0, $3ef527dddcdea745$export$afa855cbfaff27f2).create(config));
        if (config.scrollTo && config.scrollTo.is($b3e9d73db824614e$var$scrollIntoView)) this.viewState.scrollTarget = config.scrollTo.value.clip(this.viewState.state);
        this.plugins = this.state.facet($b3e9d73db824614e$var$viewPlugin).map((spec)=>new $b3e9d73db824614e$var$PluginInstance(spec));
        for (let plugin of this.plugins)plugin.update(this);
        this.observer = new $b3e9d73db824614e$var$DOMObserver(this);
        this.inputState = new $b3e9d73db824614e$var$InputState(this);
        this.inputState.ensureHandlers(this.plugins);
        this.docView = new $b3e9d73db824614e$var$DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* UpdateState.Idle */ ;
        this.requestMeasure();
        if ((_a = document.fonts) === null || _a === void 0 ? void 0 : _a.ready) document.fonts.ready.then(()=>{
            this.viewState.mustMeasureContent = "refresh";
            this.requestMeasure();
        });
    }
    dispatch(...input) {
        let trs = input.length == 1 && input[0] instanceof (0, $3ef527dddcdea745$export$febc5573c75cefb0) ? input : input.length == 1 && Array.isArray(input[0]) ? input[0] : [
            this.state.update(...input)
        ];
        this.dispatchTransactions(trs, this);
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        let redrawn = false, attrsChanged = false, update;
        let state = this.state;
        for (let tr of transactions){
            if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
            state = tr.state;
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
        if (transactions.some((tr)=>tr.annotation($b3e9d73db824614e$var$isFocusChange))) {
            this.inputState.notifiedFocused = focus;
            // If a focus-change transaction is being dispatched, set this update flag.
            focusFlag = 1 /* UpdateFlag.Focus */ ;
        } else if (focus != this.inputState.notifiedFocused) {
            this.inputState.notifiedFocused = focus;
            // Schedule a separate focus transaction if necessary, otherwise
            // add a flag to this update
            dispatchFocus = $b3e9d73db824614e$var$focusChangeTransaction(state, focus);
            if (!dispatchFocus) focusFlag = 1 /* UpdateFlag.Focus */ ;
        }
        // If there was a pending DOM change, eagerly read it and try to
        // apply it after the given transactions.
        let pendingKey = this.observer.delayedAndroidKey, domChange = null;
        if (pendingKey) {
            this.observer.clearDelayedAndroidKey();
            domChange = this.observer.readChange();
            // Only try to apply DOM changes if the transactions didn't
            // change the doc or selection.
            if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection)) domChange = null;
        } else this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, $3ef527dddcdea745$export$afa855cbfaff27f2).phrases) != this.state.facet((0, $3ef527dddcdea745$export$afa855cbfaff27f2).phrases)) return this.setState(state);
        update = $b3e9d73db824614e$export$b5b084f95c87edf7.create(this, state, transactions);
        update.flags |= focusFlag;
        let scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* UpdateState.Updating */ ;
            for (let tr of transactions){
                if (scrollTarget) scrollTarget = scrollTarget.map(tr.changes);
                if (tr.scrollIntoView) {
                    let { main: main } = tr.state.selection;
                    let { x: x, y: y } = this.state.facet($b3e9d73db824614e$export$eece2fccabbb77c5.cursorScrollMargin);
                    scrollTarget = new $b3e9d73db824614e$var$ScrollTarget(main.empty ? main : (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(main.head, main.head > main.anchor ? -1 : 1), "nearest", "nearest", y, x);
                }
                for (let e of tr.effects)if (e.is($b3e9d73db824614e$var$scrollIntoView)) scrollTarget = e.value.clip(this.state);
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = $b3e9d73db824614e$var$CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet($b3e9d73db824614e$var$styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (update.startState.facet($b3e9d73db824614e$var$theme) != update.state.facet($b3e9d73db824614e$var$theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (redrawn) this.docViewUpdate();
        if (!update.empty) for (let listener of this.state.facet($b3e9d73db824614e$var$updateListener))try {
            listener(update);
        } catch (e) {
            $b3e9d73db824614e$export$f86b2a1a2ce291b3(this.state, e, "update listener");
        }
        if (dispatchFocus || domChange) Promise.resolve().then(()=>{
            if (dispatchFocus && this.state == dispatchFocus.startState) this.dispatch(dispatchFocus);
            if (domChange) {
                if (!$b3e9d73db824614e$var$applyDOMChange(this, domChange) && pendingKey.force) $b3e9d73db824614e$var$dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
            }
        });
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* UpdateState.Updating */ ;
        let hadFocus = this.hasFocus;
        try {
            for (let plugin of this.plugins)plugin.destroy(this);
            this.viewState = new $b3e9d73db824614e$var$ViewState(this, newState);
            this.plugins = newState.facet($b3e9d73db824614e$var$viewPlugin).map((spec)=>new $b3e9d73db824614e$var$PluginInstance(spec));
            this.pluginMap.clear();
            for (let plugin of this.plugins)plugin.update(this);
            this.docView.destroy();
            this.docView = new $b3e9d73db824614e$var$DocView(this);
            this.inputState.ensureHandlers(this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        let prevSpecs = update.startState.facet($b3e9d73db824614e$var$viewPlugin), specs = update.state.facet($b3e9d73db824614e$var$viewPlugin);
        if (prevSpecs != specs) {
            let newPlugins = [];
            for (let spec of specs){
                let found = prevSpecs.indexOf(spec);
                if (found < 0) newPlugins.push(new $b3e9d73db824614e$var$PluginInstance(spec));
                else {
                    let plugin = this.plugins[found];
                    plugin.mustUpdate = update;
                    newPlugins.push(plugin);
                }
            }
            for (let plugin of this.plugins)if (plugin.mustUpdate != update) plugin.destroy(this);
            this.plugins = newPlugins;
            this.pluginMap.clear();
        } else for (let p of this.plugins)p.mustUpdate = update;
        for(let i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
        if (prevSpecs != specs) this.inputState.ensureHandlers(this.plugins);
    }
    docViewUpdate() {
        for (let plugin of this.plugins){
            let val = plugin.value;
            if (val && val.docViewUpdate) try {
                val.docViewUpdate(this);
            } catch (e) {
                $b3e9d73db824614e$export$f86b2a1a2ce291b3(this.state, e, "doc view update listener");
            }
        }
    }
    /**
    @internal
    */ measure(flush = true) {
        if (this.destroyed) return;
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        if (this.observer.delayedAndroidKey) {
            this.measureScheduled = -1;
            this.requestMeasure();
            return;
        }
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.forceFlush();
        let updated = null;
        let scroll = this.viewState.scrollParent, scrollOffset = this.viewState.getScrollOffset();
        let { scrollAnchorPos: scrollAnchorPos, scrollAnchorHeight: scrollAnchorHeight } = this.viewState;
        if (Math.abs(scrollOffset - this.viewState.scrollOffset) > 1) scrollAnchorHeight = -1;
        this.viewState.scrollAnchorHeight = -1;
        try {
            for(let i = 0;; i++){
                if (scrollAnchorHeight < 0) {
                    if ($b3e9d73db824614e$var$isScrolledToBottom(scroll || this.win)) {
                        scrollAnchorPos = -1;
                        scrollAnchorHeight = this.viewState.heightMap.height;
                    } else {
                        let block = this.viewState.scrollAnchorAt(scrollOffset);
                        scrollAnchorPos = block.from;
                        scrollAnchorHeight = block.top;
                    }
                }
                this.updateState = 1 /* UpdateState.Measuring */ ;
                let changed = this.viewState.measure();
                if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
                if (i > 5) {
                    console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    break;
                }
                let measuring = [];
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* UpdateFlag.Viewport */ )) [this.measureRequests, measuring] = [
                    measuring,
                    this.measureRequests
                ];
                let measured = measuring.map((m)=>{
                    try {
                        return m.read(this);
                    } catch (e) {
                        $b3e9d73db824614e$export$f86b2a1a2ce291b3(this.state, e);
                        return $b3e9d73db824614e$var$BadMeasure;
                    }
                });
                let update = $b3e9d73db824614e$export$b5b084f95c87edf7.create(this, this.state, []), redrawn = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                this.updateState = 2 /* UpdateState.Updating */ ;
                if (!update.empty) {
                    this.updatePlugins(update);
                    this.inputState.update(update);
                    this.updateAttrs();
                    redrawn = this.docView.update(update);
                    if (redrawn) this.docViewUpdate();
                }
                for(let i = 0; i < measuring.length; i++)if (measured[i] != $b3e9d73db824614e$var$BadMeasure) try {
                    let m = measuring[i];
                    if (m.write) m.write(measured[i], this);
                } catch (e) {
                    $b3e9d73db824614e$export$f86b2a1a2ce291b3(this.state, e);
                }
                if (redrawn) this.docView.updateSelection(true);
                if (!update.viewportChanged && this.measureRequests.length == 0) {
                    if (this.viewState.editorHeight) {
                        if (this.viewState.scrollTarget) {
                            this.docView.scrollIntoView(this.viewState.scrollTarget);
                            this.viewState.scrollTarget = null;
                            scrollAnchorHeight = -1;
                            continue;
                        } else {
                            let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
                            let diff = (newAnchorHeight - scrollAnchorHeight) / this.scaleY;
                            if ((diff > 1 || diff < -1) && !($b3e9d73db824614e$var$browser.ios && this.inputState.lastIOSMomentumScroll > Date.now() - 100) && (scroll == this.scrollDOM || this.hasFocus || Math.max(this.inputState.lastWheelEvent, this.inputState.lastTouchTime) > Date.now() - 100)) {
                                scrollOffset = scrollOffset + diff;
                                if (scroll) scroll.scrollTop += diff;
                                else this.win.scrollBy(0, diff);
                                scrollAnchorHeight = -1;
                                continue;
                            }
                        }
                    }
                    break;
                }
            }
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
            this.measureScheduled = -1;
        }
        if (updated && !updated.empty) for (let listener of this.state.facet($b3e9d73db824614e$var$updateListener))listener(updated);
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return $b3e9d73db824614e$var$baseThemeID + " " + (this.state.facet($b3e9d73db824614e$var$darkTheme) ? $b3e9d73db824614e$var$baseDarkID : $b3e9d73db824614e$var$baseLightID) + " " + this.state.facet($b3e9d73db824614e$var$theme);
    }
    updateAttrs() {
        let editorAttrs = $b3e9d73db824614e$var$attrsFromFacet(this, $b3e9d73db824614e$var$editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        let contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            writingsuggestions: "false",
            translate: "no",
            contenteditable: !this.state.facet($b3e9d73db824614e$var$editable) ? "false" : "true",
            class: "cm-content",
            style: `${$b3e9d73db824614e$var$browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        $b3e9d73db824614e$var$attrsFromFacet(this, $b3e9d73db824614e$var$contentAttributes, contentAttrs);
        let changed = this.observer.ignore(()=>{
            let changedContent = $b3e9d73db824614e$var$updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            let changedEditor = $b3e9d73db824614e$var$updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        let first = true;
        for (let tr of trs)for (let effect of tr.effects)if (effect.is($b3e9d73db824614e$export$eece2fccabbb77c5.announce)) {
            if (first) this.announceDOM.textContent = "";
            first = false;
            let div = this.announceDOM.appendChild(document.createElement("div"));
            div.textContent = effect.value;
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet($b3e9d73db824614e$var$styleModule);
        let nonce = this.state.facet($b3e9d73db824614e$export$eece2fccabbb77c5.cspNonce);
        (0, $246d4c208d441e56$export$b920c662d2efee20).mount(this.root, this.styleModules.concat($b3e9d73db824614e$var$baseTheme$1).reverse(), nonce ? {
            nonce: nonce
        } : undefined);
    }
    readMeasured() {
        if (this.updateState == 2 /* UpdateState.Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* UpdateState.Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = this.win.requestAnimationFrame(()=>this.measure());
        if (request) {
            if (this.measureRequests.indexOf(request) > -1) return;
            if (request.key != null) {
                for(let i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        let known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.plugin != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.plugin == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    If the editor is transformed with CSS, this provides the scale
    along the X axis. Otherwise, it will just be 1. Note that
    transforms other than translation and scaling are not supported.
    */ get scaleX() {
        return this.viewState.scaleX;
    }
    /**
    Provide the CSS transformed scale along the Y axis.
    */ get scaleY() {
        return this.viewState.scaleY;
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt)) at the given
    height, again interpreted relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return $b3e9d73db824614e$var$skipAtoms(this, start, $b3e9d73db824614e$var$moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return $b3e9d73db824614e$var$skipAtoms(this, start, $b3e9d73db824614e$var$moveByChar(this, start, forward, (initial)=>$b3e9d73db824614e$var$byGroup(this, start.head, initial)));
    }
    /**
    Get the cursor position visually at the start or end of a line.
    Note that this may differ from the _logical_ position at its
    start or end (which is simply at `line.from`/`line.to`) if text
    at the start or end goes against the line's base text direction.
    */ visualLineSide(line, end) {
        let order = this.bidiSpans(line), dir = this.textDirectionAt(line.from);
        let span = order[end ? order.length - 1 : 0];
        return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(span.side(end, dir) + line.from, span.forward(!end, dir) ? 1 : -1);
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward, includeWrap = true) {
        return $b3e9d73db824614e$var$moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return $b3e9d73db824614e$var$skipAtoms(this, start, $b3e9d73db824614e$var$moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos, side = 1) {
        return this.docView.domAtPos(pos, side);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node, offset = 0) {
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords, precise = true) {
        this.readMeasured();
        let found = $b3e9d73db824614e$var$posAtCoords(this, coords, precise);
        return found && found.pos;
    }
    posAndSideAtCoords(coords, precise = true) {
        this.readMeasured();
        return $b3e9d73db824614e$var$posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos, side = 1) {
        this.readMeasured();
        let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        let span = order[$b3e9d73db824614e$export$e1ed96b746bb516a.find(order, pos - line.from, -1, side)];
        return this.docView.coordsAt(pos, side, span.dir == $b3e9d73db824614e$export$cacd6541cfeeb6c1.RTL);
    }
    /**
    Return the rectangle around a given character. If `pos` does not
    point in front of a character that is in the viewport and
    rendered (i.e. not replaced, not a line break), this will return
    null. For space characters that are a line wrap point, this will
    return the position before the line break.
    */ coordsForChar(pos) {
        this.readMeasured();
        return this.docView.coordsForChar(pos);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        let perLine = this.state.facet($b3e9d73db824614e$var$perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > $b3e9d73db824614e$var$MaxBidiLine) return $b3e9d73db824614e$var$trivialOrder(line.length);
        let dir = this.textDirectionAt(line.from), isolates;
        for (let entry of this.bidiCache){
            if (entry.from == line.from && entry.dir == dir && (entry.fresh || $b3e9d73db824614e$var$isolatesEq(entry.isolates, isolates = $b3e9d73db824614e$var$getIsolatedRanges(this, line)))) return entry.order;
        }
        if (!isolates) isolates = $b3e9d73db824614e$var$getIsolatedRanges(this, line);
        let order = $b3e9d73db824614e$var$computeOrder(line.text, dir, isolates);
        this.bidiCache.push(new $b3e9d73db824614e$var$CachedOrder(line.from, line.to, dir, isolates, true, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (this.dom.ownerDocument.hasFocus() || $b3e9d73db824614e$var$browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            $b3e9d73db824614e$var$focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
    necessary when moving the editor's existing DOM to a new window or shadow root.
    */ setRoot(root) {
        if (this._root != root) {
            this._root = root;
            this.observer.setWindow((root.nodeType == 9 ? root : root.ownerDocument).defaultView || window);
            this.mountStyles();
        }
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        if (this.root.activeElement == this.contentDOM) this.contentDOM.blur();
        for (let plugin of this.plugins)plugin.destroy(this);
        this.plugins = [];
        this.inputState.destroy();
        this.docView.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos, options = {}) {
        var _a, _b, _c, _d;
        return $b3e9d73db824614e$var$scrollIntoView.of(new $b3e9d73db824614e$var$ScrollTarget(typeof pos == "number" ? (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(pos) : pos, (_a = options.y) !== null && _a !== void 0 ? _a : "nearest", (_b = options.x) !== null && _b !== void 0 ? _b : "nearest", (_c = options.yMargin) !== null && _c !== void 0 ? _c : 5, (_d = options.xMargin) !== null && _d !== void 0 ? _d : 5));
    }
    /**
    Return an effect that resets the editor to its current (at the
    time this method was called) scroll position. Note that this
    only affects the editor's own scrollable element, not parents.
    See also
    [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
    
    The effect should be used with a document identical to the one
    it was created for. Failing to do so is not an error, but may
    not scroll to the expected position. You can
    [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
    */ scrollSnapshot() {
        let { scrollTop: scrollTop, scrollLeft: scrollLeft } = this.scrollDOM;
        let ref = this.viewState.scrollAnchorAt(scrollTop);
        return $b3e9d73db824614e$var$scrollIntoView.of(new $b3e9d73db824614e$var$ScrollTarget((0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(ref.from), "start", "start", ref.top - scrollTop, scrollLeft, true));
    }
    /**
    Enable or disable tab-focus mode, which disables key bindings
    for Tab and Shift-Tab, letting the browser's default
    focus-changing behavior go through instead. This is useful to
    prevent trapping keyboard users in your editor.
    
    Without argument, this toggles the mode. With a boolean, it
    enables (true) or disables it (false). Given a number, it
    temporarily enables the mode until that number of milliseconds
    have passed or another non-Tab key is pressed.
    */ setTabFocusMode(to) {
        if (to == null) this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1;
        else if (typeof to == "boolean") this.inputState.tabFocusMode = to ? 0 : -1;
        else if (this.inputState.tabFocusMode != 0) this.inputState.tabFocusMode = Date.now() + to;
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return $b3e9d73db824614e$export$44d5eccfd62adda7.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create an extension that registers DOM event observers. Contrary
    to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
    observers can't be prevented from running by a higher-precedence
    handler returning true. They also don't prevent other handlers
    and observers from running when they return true, and should not
    call `preventDefault`.
    */ static domEventObservers(observers) {
        return $b3e9d73db824614e$export$44d5eccfd62adda7.define(()=>({}), {
            eventObservers: observers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://code.haverbeke.berlin/marijn/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        let prefix = (0, $246d4c208d441e56$export$b920c662d2efee20).newName();
        let result = [
            $b3e9d73db824614e$var$theme.of(prefix),
            $b3e9d73db824614e$var$styleModule.of($b3e9d73db824614e$var$buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push($b3e9d73db824614e$var$darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, $3ef527dddcdea745$export$b92464a736444411).lowest($b3e9d73db824614e$var$styleModule.of($b3e9d73db824614e$var$buildTheme("." + $b3e9d73db824614e$var$baseThemeID, spec, $b3e9d73db824614e$var$lightDarkIDs)));
    }
    /**
    Retrieve an editor view instance from the view's DOM
    representation.
    */ static findFromDOM(dom) {
        var _a;
        let content = dom.querySelector(".cm-content");
        let tile = content && $b3e9d73db824614e$var$Tile.get(content) || $b3e9d73db824614e$var$Tile.get(dom);
        return ((_a = tile === null || tile === void 0 ? void 0 : tile.root) === null || _a === void 0 ? void 0 : _a.view) || null;
    }
}
/**
Facet to add a [style
module](https://code.haverbeke.berlin/marijn/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.styleModule = $b3e9d73db824614e$var$styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.

The `insert` argument can be used to get the default transaction
that would be applied for this input. This can be useful when
dispatching the custom behavior as a separate transaction.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.inputHandler = $b3e9d73db824614e$var$inputHandler;
/**
Functions provided in this facet will be used to transform text
pasted or dropped into the editor.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.clipboardInputFilter = $b3e9d73db824614e$var$clipboardInputFilter;
/**
Transform text copied or dragged from the editor.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.clipboardOutputFilter = $b3e9d73db824614e$var$clipboardOutputFilter;
/**
Scroll handlers can override how things are scrolled into view.
If they return `true`, no further handling happens for the
scrolling. If they return false, the default scroll behavior is
applied. Scroll handlers should never initiate editor updates.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.scrollHandler = $b3e9d73db824614e$var$scrollHandler;
/**
This facet can be used to provide functions that create effects
to be dispatched when the editor's focus state changes.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.focusChangeEffect = $b3e9d73db824614e$var$focusChangeEffect;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.perLineTextDirection = $b3e9d73db824614e$var$perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.exceptionSink = $b3e9d73db824614e$var$exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.updateListener = $b3e9d73db824614e$var$updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.editable = $b3e9d73db824614e$var$editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.mouseSelectionStyle = $b3e9d73db824614e$var$mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.dragMovesSelection = $b3e9d73db824614e$var$dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.clickAddsSelectionRange = $b3e9d73db824614e$var$clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.

If you want decorated ranges to behave like atomic units for
cursor motion and deletion purposes, also provide the range set
containing the decorations to
[`EditorView.atomicRanges`](https://codemirror.net/6/docs/ref/#view.EditorView^atomicRanges).
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.decorations = $b3e9d73db824614e$var$decorations;
/**
[Block wrappers](https://codemirror.net/6/docs/ref/#view.BlockWrapper) provide a way to add DOM
structure around editor lines and block widgets. Sets of
wrappers are provided in a similar way to decorations, and are
nested in a similar way when they overlap. A wrapper affects all
lines and block widgets that start inside its range.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.blockWrappers = $b3e9d73db824614e$var$blockWrappers;
/**
Facet that works much like
[`decorations`](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), but puts its
inputs at the very bottom of the precedence stack, meaning mark
decorations provided here will only be split by other, partially
overlapping `outerDecorations` ranges, and wrap around all
regular decorations. Use this for mark elements that should, as
much as possible, remain in one piece.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.outerDecorations = $b3e9d73db824614e$var$outerDecorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.atomicRanges = $b3e9d73db824614e$var$atomicRanges;
/**
When range decorations add a `unicode-bidi: isolate` style, they
should also include a
[`bidiIsolate`](https://codemirror.net/6/docs/ref/#view.MarkDecorationSpec.bidiIsolate) property
in their decoration spec, and be exposed through this facet, so
that the editor can compute the proper text order. (Other values
for `unicode-bidi`, except of course `normal`, are not
supported.)
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.bidiIsolatedRanges = $b3e9d73db824614e$var$bidiIsolatedRanges;
/**
Can be used to specify the distance that scrolling cursor into
view keeps it away from the sides of the editor, either as a
single pixel number or two different values for the different
axes. Defaults to 5 pixels on both axes.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.cursorScrollMargin = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (inputs)=>{
        let x = 5, y = 5;
        for (let i of inputs)if (typeof i == "number") x = y = i;
        else ({ x: x, y: y } = i);
        return {
            x: x,
            y: y
        };
    }
});
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter). Not to be confused with
[`cursorScrollMargin`](https://codemirror.net/6/docs/ref/#view.EditorView^cursorScrollMargin).
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.scrollMargins = $b3e9d73db824614e$var$scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.darkTheme = $b3e9d73db824614e$var$darkTheme;
/**
Provides a Content Security Policy nonce to use when creating
the style sheets for the editor. Holds the empty string when no
nonce has been provided.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.cspNonce = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : ""
});
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.contentAttributes = $b3e9d73db824614e$var$contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.editorAttributes = $b3e9d73db824614e$var$editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.lineWrapping = /*@__PURE__*/ $b3e9d73db824614e$export$eece2fccabbb77c5.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ $b3e9d73db824614e$export$eece2fccabbb77c5.announce = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
// Maximum line length for which we compute accurate bidi info
const $b3e9d73db824614e$var$MaxBidiLine = 4096;
const $b3e9d73db824614e$var$BadMeasure = {};
class $b3e9d73db824614e$var$CachedOrder {
    constructor(from, to, dir, isolates, fresh, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.isolates = isolates;
        this.fresh = fresh;
        this.order = order;
    }
    static update(cache, changes) {
        if (changes.empty && !cache.some((c)=>c.fresh)) return cache;
        let result = [], lastDir = cache.length ? cache[cache.length - 1].dir : $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR;
        for(let i = Math.max(0, cache.length - 10); i < cache.length; i++){
            let entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new $b3e9d73db824614e$var$CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.isolates, false, entry.order));
        }
        return result;
    }
}
function $b3e9d73db824614e$var$attrsFromFacet(view, facet, base) {
    for(let sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        let source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) $b3e9d73db824614e$var$combineAttrs(value, base);
    }
    return base;
}
const $b3e9d73db824614e$var$currentPlatform = $b3e9d73db824614e$var$browser.mac ? "mac" : $b3e9d73db824614e$var$browser.windows ? "win" : $b3e9d73db824614e$var$browser.linux ? "linux" : "key";
function $b3e9d73db824614e$var$normalizeKeyName(name, platform) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; ++i){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $b3e9d73db824614e$var$modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
const $b3e9d73db824614e$var$handleKeyEvents = /*@__PURE__*/ (0, $3ef527dddcdea745$export$b92464a736444411).default(/*@__PURE__*/ $b3e9d73db824614e$export$eece2fccabbb77c5.domEventHandlers({
    keydown (event, view) {
        return $b3e9d73db824614e$var$runHandlers($b3e9d73db824614e$var$getKeymap(view.state), event, view, "editor");
    }
}));
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ const $b3e9d73db824614e$export$5043418e2ef368d5 = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    enables: $b3e9d73db824614e$var$handleKeyEvents
});
const $b3e9d73db824614e$var$Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function $b3e9d73db824614e$var$getKeymap(state) {
    let bindings = state.facet($b3e9d73db824614e$export$5043418e2ef368d5);
    let map = $b3e9d73db824614e$var$Keymaps.get(bindings);
    if (!map) $b3e9d73db824614e$var$Keymaps.set(bindings, map = $b3e9d73db824614e$var$buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function $b3e9d73db824614e$export$bce154f45536286e(view, event, scope) {
    return $b3e9d73db824614e$var$runHandlers($b3e9d73db824614e$var$getKeymap(view.state), event, view, scope);
}
let $b3e9d73db824614e$var$storedPrefix = null;
const $b3e9d73db824614e$var$PrefixTimeout = 4000;
function $b3e9d73db824614e$var$buildKeymap(bindings, platform = $b3e9d73db824614e$var$currentPlatform) {
    let bound = Object.create(null);
    let isPrefix = Object.create(null);
    let checkPrefix = (name, is)=>{
        let current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    let add = (scope, key, command, preventDefault, stopPropagation)=>{
        var _a, _b;
        let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        let parts = key.split(/ (?!$)/).map((k)=>$b3e9d73db824614e$var$normalizeKeyName(k, platform));
        for(let i = 1; i < parts.length; i++){
            let prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                stopPropagation: false,
                run: [
                    (view)=>{
                        let ourObj = $b3e9d73db824614e$var$storedPrefix = {
                            view: view,
                            prefix: prefix,
                            scope: scope
                        };
                        setTimeout(()=>{
                            if ($b3e9d73db824614e$var$storedPrefix == ourObj) $b3e9d73db824614e$var$storedPrefix = null;
                        }, $b3e9d73db824614e$var$PrefixTimeout);
                        return true;
                    }
                ]
            };
        }
        let full = parts.join(" ");
        checkPrefix(full, false);
        let binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            stopPropagation: false,
            run: ((_b = (_a = scopeObj._any) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
        });
        if (command) binding.run.push(command);
        if (preventDefault) binding.preventDefault = true;
        if (stopPropagation) binding.stopPropagation = true;
    };
    for (let b of bindings){
        let scopes = b.scope ? b.scope.split(" ") : [
            "editor"
        ];
        if (b.any) for (let scope of scopes){
            let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
            if (!scopeObj._any) scopeObj._any = {
                preventDefault: false,
                stopPropagation: false,
                run: []
            };
            let { any: any } = b;
            for(let key in scopeObj)scopeObj[key].run.push((view)=>any(view, $b3e9d73db824614e$var$currentKeyEvent));
        }
        let name = b[platform] || b.key;
        if (!name) continue;
        for (let scope of scopes){
            add(scope, name, b.run, b.preventDefault, b.stopPropagation);
            if (b.shift) add(scope, "Shift-" + name, b.shift, b.preventDefault, b.stopPropagation);
        }
    }
    return bound;
}
let $b3e9d73db824614e$var$currentKeyEvent = null;
function $b3e9d73db824614e$var$runHandlers(map, event, view, scope) {
    $b3e9d73db824614e$var$currentKeyEvent = event;
    let name = (0, $0cf1073115e44648$export$fb33aafd75404f4c)(event);
    let charCode = (0, $3ef527dddcdea745$export$42977f40461e1360)(name, 0), isChar = (0, $3ef527dddcdea745$export$a870abf234f6353c)(charCode) == name.length && name != " ";
    let prefix = "", handled = false, prevented = false, stopPropagation = false;
    if ($b3e9d73db824614e$var$storedPrefix && $b3e9d73db824614e$var$storedPrefix.view == view && $b3e9d73db824614e$var$storedPrefix.scope == scope) {
        prefix = $b3e9d73db824614e$var$storedPrefix.prefix + " ";
        if ($b3e9d73db824614e$var$modifierCodes.indexOf(event.keyCode) < 0) {
            prevented = true;
            $b3e9d73db824614e$var$storedPrefix = null;
        }
    }
    let ran = new Set;
    let runFor = (binding)=>{
        if (binding) {
            for (let cmd of binding.run)if (!ran.has(cmd)) {
                ran.add(cmd);
                if (cmd(view)) {
                    if (binding.stopPropagation) stopPropagation = true;
                    return true;
                }
            }
            if (binding.preventDefault) {
                if (binding.stopPropagation) stopPropagation = true;
                prevented = true;
            }
        }
        return false;
    };
    let scopeObj = map[scope], baseName, shiftName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + $b3e9d73db824614e$var$modifiers(name, event, !isChar)])) handled = true;
        else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
        !($b3e9d73db824614e$var$browser.windows && event.ctrlKey && event.altKey) && // Alt-combinations on macOS tend to be typed characters
        !($b3e9d73db824614e$var$browser.mac && event.altKey && !(event.ctrlKey || event.metaKey)) && (baseName = (0, $0cf1073115e44648$export$e2253033e6e1df16)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + $b3e9d73db824614e$var$modifiers(baseName, event, true)])) handled = true;
            else if (event.shiftKey && (shiftName = (0, $0cf1073115e44648$export$fba63a578e423eb)[event.keyCode]) != name && shiftName != baseName && runFor(scopeObj[prefix + $b3e9d73db824614e$var$modifiers(shiftName, event, false)])) handled = true;
        } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + $b3e9d73db824614e$var$modifiers(name, event, true)])) handled = true;
        if (!handled && runFor(scopeObj._any)) handled = true;
    }
    if (prevented) handled = true;
    if (handled && stopPropagation) event.stopPropagation();
    $b3e9d73db824614e$var$currentKeyEvent = null;
    return handled;
}
/**
Implementation of [`LayerMarker`](https://codemirror.net/6/docs/ref/#view.LayerMarker) that creates
a rectangle at a given set of coordinates.
*/ class $b3e9d73db824614e$export$9ddce7bd14f42a78 {
    /**
    Create a marker with the given class and dimensions. If `width`
    is null, the DOM element will get no width style.
    */ constructor(className, /**
    The left position of the marker (in pixels, document-relative).
    */ left, /**
    The top position of the marker.
    */ top, /**
    The width of the marker, or null if it shouldn't get a width assigned.
    */ width, /**
    The height of the marker.
    */ height){
        this.className = className;
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    draw() {
        let elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    update(elt, prev) {
        if (prev.className != this.className) return false;
        this.adjust(elt);
        return true;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width != null) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
    /**
    Create a set of rectangles for the given selection range,
    assigning them theclass`className`. Will create a single
    rectangle for empty ranges, and a set of selection-style
    rectangles covering the range's content (in a bidi-aware
    way) for non-empty ones.
    */ static forRange(view, className, range) {
        if (range.empty) {
            let pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (!pos) return [];
            let base = $b3e9d73db824614e$var$getBase(view);
            return [
                new $b3e9d73db824614e$export$9ddce7bd14f42a78(className, pos.left - base.left, pos.top - base.top, null, pos.bottom - pos.top)
            ];
        } else return $b3e9d73db824614e$var$rectanglesForRange(view, className, range);
    }
}
function $b3e9d73db824614e$var$getBase(view) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let left = view.textDirection == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth * view.scaleX;
    return {
        left: left - view.scrollDOM.scrollLeft * view.scaleX,
        top: rect.top - view.scrollDOM.scrollTop * view.scaleY
    };
}
function $b3e9d73db824614e$var$wrappedLine(view, pos, side, inside) {
    let coords = view.coordsAtPos(pos, side * 2);
    if (!coords) return inside;
    let editorRect = view.dom.getBoundingClientRect();
    let y = (coords.top + coords.bottom) / 2;
    let left = view.posAtCoords({
        x: editorRect.left + 1,
        y: y
    });
    let right = view.posAtCoords({
        x: editorRect.right - 1,
        y: y
    });
    if (left == null || right == null) return inside;
    return {
        from: Math.max(inside.from, Math.min(left, right)),
        to: Math.min(inside.to, Math.max(left, right))
    };
}
function $b3e9d73db824614e$var$rectanglesForRange(view, className, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    let from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    let ltr = view.textDirection == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR;
    let content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = $b3e9d73db824614e$var$getBase(view);
    let lineElt = content.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
    let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
    let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
    let startBlock = $b3e9d73db824614e$var$blockAt(view, from, 1), endBlock = $b3e9d73db824614e$var$blockAt(view, to, -1);
    let visualStart = startBlock.type == $b3e9d73db824614e$export$48808c686fe495c4.Text ? startBlock : null;
    let visualEnd = endBlock.type == $b3e9d73db824614e$export$48808c686fe495c4.Text ? endBlock : null;
    if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks)) visualStart = $b3e9d73db824614e$var$wrappedLine(view, from, 1, visualStart);
    if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks)) visualEnd = $b3e9d73db824614e$var$wrappedLine(view, to, -1, visualEnd);
    if (visualStart && visualEnd && visualStart.from == visualEnd.from && visualStart.to == visualEnd.to) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        let top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        let bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        let between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top.bottom + view.defaultLineHeight / 2 < bottom.top) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == $b3e9d73db824614e$export$48808c686fe495c4.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new $b3e9d73db824614e$export$9ddce7bd14f42a78(className, left - base.left, top - base.top, Math.max(0, right - left), bottom - top);
    }
    function pieces({ top: top, bottom: bottom, horizontal: horizontal }) {
        let pieces = [];
        for(let i = 0; i < horizontal.length; i += 2)pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        let top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            let fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            let toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            if (!fromCoords || !toCoords) return;
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        let start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        // Split the range by visible range and document line
        for (let r of view.visibleRanges)if (r.to > start && r.from < end) for(let pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
            let docLine = view.state.doc.lineAt(pos);
            for (let span of view.bidiSpans(docLine)){
                let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                if (spanFrom >= endPos) break;
                if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
            }
            pos = docLine.to + 1;
            if (pos >= endPos) break;
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top: top,
            bottom: bottom,
            horizontal: horizontal
        };
    }
    function drawForWidget(block, top) {
        let y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function $b3e9d73db824614e$var$sameMarker(a, b) {
    return a.constructor == b.constructor && a.eq(b);
}
class $b3e9d73db824614e$var$LayerView {
    constructor(view, layer){
        this.view = view;
        this.layer = layer;
        this.drawn = [];
        this.scaleX = 1;
        this.scaleY = 1;
        this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        };
        this.dom = view.scrollDOM.appendChild(document.createElement("div"));
        this.dom.classList.add("cm-layer");
        if (layer.above) this.dom.classList.add("cm-layer-above");
        if (layer.class) this.dom.classList.add(layer.class);
        this.scale();
        this.dom.setAttribute("aria-hidden", "true");
        this.setOrder(view.state);
        view.requestMeasure(this.measureReq);
        if (layer.mount) layer.mount(this.dom, view);
    }
    update(update) {
        if (update.startState.facet($b3e9d73db824614e$var$layerOrder) != update.state.facet($b3e9d73db824614e$var$layerOrder)) this.setOrder(update.state);
        if (this.layer.update(update, this.dom) || update.geometryChanged) {
            this.scale();
            update.view.requestMeasure(this.measureReq);
        }
    }
    docViewUpdate(view) {
        if (this.layer.updateOnDocViewUpdate !== false) view.requestMeasure(this.measureReq);
    }
    setOrder(state) {
        let pos = 0, order = state.facet($b3e9d73db824614e$var$layerOrder);
        while(pos < order.length && order[pos] != this.layer)pos++;
        this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
    }
    measure() {
        return this.layer.markers(this.view);
    }
    scale() {
        let { scaleX: scaleX, scaleY: scaleY } = this.view;
        if (scaleX != this.scaleX || scaleY != this.scaleY) {
            this.scaleX = scaleX;
            this.scaleY = scaleY;
            this.dom.style.transform = `scale(${1 / scaleX}, ${1 / scaleY})`;
        }
    }
    draw(markers) {
        if (markers.length != this.drawn.length || markers.some((p, i)=>!$b3e9d73db824614e$var$sameMarker(p, this.drawn[i]))) {
            let old = this.dom.firstChild, oldI = 0;
            for (let marker of markers)if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
                old = old.nextSibling;
                oldI++;
            } else this.dom.insertBefore(marker.draw(), old);
            while(old){
                let next = old.nextSibling;
                old.remove();
                old = next;
            }
            this.drawn = markers;
            if ($b3e9d73db824614e$var$browser.webkit) this.dom.style.display = this.dom.firstChild ? "" : "none";
        }
    }
    destroy() {
        if (this.layer.destroy) this.layer.destroy(this.dom, this.view);
        this.dom.remove();
    }
}
const $b3e9d73db824614e$var$layerOrder = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
/**
Define a layer.
*/ function $b3e9d73db824614e$export$50a222d9023da98b(config) {
    return [
        $b3e9d73db824614e$export$44d5eccfd62adda7.define((v)=>new $b3e9d73db824614e$var$LayerView(v, config)),
        $b3e9d73db824614e$var$layerOrder.of(config)
    ];
}
const $b3e9d73db824614e$var$selectionConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $3ef527dddcdea745$export$4e19c0b693794a7e)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true,
            iosSelectionHandles: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function $b3e9d73db824614e$export$17a3d0ab3687347d(config = {}) {
    return [
        $b3e9d73db824614e$var$selectionConfig.of(config),
        $b3e9d73db824614e$var$cursorLayer,
        $b3e9d73db824614e$var$selectionLayer,
        $b3e9d73db824614e$var$hideNativeSelection,
        $b3e9d73db824614e$var$nativeSelectionHidden.of(true)
    ];
}
/**
Retrieve the [`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) configuration
for this state. (Note that this will return a set of defaults even
if `drawSelection` isn't enabled.)
*/ function $b3e9d73db824614e$export$74e411a7b5f41f23(state) {
    return state.facet($b3e9d73db824614e$var$selectionConfig);
}
function $b3e9d73db824614e$var$configChanged(update) {
    return update.startState.facet($b3e9d73db824614e$var$selectionConfig) != update.state.facet($b3e9d73db824614e$var$selectionConfig);
}
const $b3e9d73db824614e$var$cursorLayer = /*@__PURE__*/ $b3e9d73db824614e$export$50a222d9023da98b({
    above: true,
    markers (view) {
        let { state: state } = view, conf = state.facet($b3e9d73db824614e$var$selectionConfig);
        let cursors = [];
        for (let r of state.selection.ranges){
            let prim = r == state.selection.main;
            if (r.empty || conf.drawRangeCursor && !(prim && $b3e9d73db824614e$var$browser.ios && conf.iosSelectionHandles)) {
                let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
                let cursor = r.empty ? r : (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(r.head, r.assoc);
                for (let piece of $b3e9d73db824614e$export$9ddce7bd14f42a78.forRange(view, className, cursor))cursors.push(piece);
            }
        }
        return cursors;
    },
    update (update, dom) {
        if (update.transactions.some((tr)=>tr.selection)) dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        let confChange = $b3e9d73db824614e$var$configChanged(update);
        if (confChange) $b3e9d73db824614e$var$setBlinkRate(update.state, dom);
        return update.docChanged || update.selectionSet || confChange;
    },
    mount (dom, view) {
        $b3e9d73db824614e$var$setBlinkRate(view.state, dom);
    },
    class: "cm-cursorLayer"
});
function $b3e9d73db824614e$var$setBlinkRate(state, dom) {
    dom.style.animationDuration = state.facet($b3e9d73db824614e$var$selectionConfig).cursorBlinkRate + "ms";
}
const $b3e9d73db824614e$var$selectionLayer = /*@__PURE__*/ $b3e9d73db824614e$export$50a222d9023da98b({
    above: false,
    markers (view) {
        let markers = [], { main: main, ranges: ranges } = view.state.selection;
        for (let r of ranges)if (!r.empty) for (let marker of $b3e9d73db824614e$export$9ddce7bd14f42a78.forRange(view, "cm-selectionBackground", r))markers.push(marker);
        if ($b3e9d73db824614e$var$browser.ios && !main.empty && view.state.facet($b3e9d73db824614e$var$selectionConfig).iosSelectionHandles) {
            for (let piece of $b3e9d73db824614e$export$9ddce7bd14f42a78.forRange(view, "cm-selectionHandle cm-selectionHandle-start", (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(main.from, 1)))markers.push(piece);
            for (let piece of $b3e9d73db824614e$export$9ddce7bd14f42a78.forRange(view, "cm-selectionHandle cm-selectionHandle-end", (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(main.to, 1)))markers.push(piece);
        }
        return markers;
    },
    update (update, dom) {
        return update.docChanged || update.selectionSet || update.viewportChanged || $b3e9d73db824614e$var$configChanged(update);
    },
    class: "cm-selectionLayer"
});
// https://discuss.codemirror.net/t/firefox-153-ignores-transparent-selection-styling/9838
const $b3e9d73db824614e$var$selectionBg = $b3e9d73db824614e$var$browser.gecko && $b3e9d73db824614e$var$browser.gecko_version == 153 ? "#ffffff01" : "transparent";
const $b3e9d73db824614e$var$hideNativeSelection = /*@__PURE__*/ (0, $3ef527dddcdea745$export$b92464a736444411).highest(/*@__PURE__*/ $b3e9d73db824614e$export$eece2fccabbb77c5.theme({
    ".cm-line": {
        "& ::selection, &::selection": {
            backgroundColor: `${$b3e9d73db824614e$var$selectionBg} !important`
        },
        caretColor: "transparent !important"
    },
    ".cm-content": {
        caretColor: "transparent !important",
        "& :focus": {
            caretColor: "initial !important",
            "&::selection, & ::selection": {
                backgroundColor: "Highlight !important"
            }
        }
    }
}));
const $b3e9d73db824614e$var$setDropCursorPos = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
const $b3e9d73db824614e$var$dropCursorPos = /*@__PURE__*/ (0, $3ef527dddcdea745$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is($b3e9d73db824614e$var$setDropCursorPos) ? e.value : pos, pos);
    }
});
const $b3e9d73db824614e$var$drawDropCursor = /*@__PURE__*/ $b3e9d73db824614e$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    update(update) {
        var _a;
        let cursorPos = update.state.field($b3e9d73db824614e$var$dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field($b3e9d73db824614e$var$dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        let { view: view } = this;
        let pos = view.state.field($b3e9d73db824614e$var$dropCursorPos);
        let rect = pos != null && view.coordsAtPos(pos);
        if (!rect) return null;
        let outer = view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + view.scrollDOM.scrollLeft * view.scaleX,
            top: rect.top - outer.top + view.scrollDOM.scrollTop * view.scaleY,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            let { scaleX: scaleX, scaleY: scaleY } = this.view;
            if (pos) {
                this.cursor.style.left = pos.left / scaleX + "px";
                this.cursor.style.top = pos.top / scaleY + "px";
                this.cursor.style.height = pos.height / scaleY + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field($b3e9d73db824614e$var$dropCursorPos) != pos) this.view.dispatch({
            effects: $b3e9d73db824614e$var$setDropCursorPos.of(pos)
        });
    }
}, {
    eventObservers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function $b3e9d73db824614e$export$b8e3092a3bfa2062() {
    return [
        $b3e9d73db824614e$var$dropCursorPos,
        $b3e9d73db824614e$var$drawDropCursor
    ];
}
function $b3e9d73db824614e$var$iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(let cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, m);
    }
}
function $b3e9d73db824614e$var$matchRanges(view, maxLength) {
    let visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    let result = [];
    for (let { from: from, to: to } of visible){
        from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
        to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
        if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
        else result.push({
            from: from,
            to: to
        });
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class $b3e9d73db824614e$export$9b928b0ca20b25cb {
    /**
    Create a decorator.
    */ constructor(config){
        const { regexp: regexp, decoration: decoration, decorate: decorate, boundary: boundary, maxLength: maxLength = 1000 } = config;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        if (decorate) this.addMatch = (match, view, from, add)=>decorate(add, from, from + match[0].length, match, view);
        else if (typeof decoration == "function") this.addMatch = (match, view, from, add)=>{
            let deco = decoration(match, view, from);
            if (deco) add(from, from + match[0].length, deco);
        };
        else if (decoration) this.addMatch = (match, _view, from, add)=>add(from, from + match[0].length, decoration);
        else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        let build = new (0, $3ef527dddcdea745$export$89e09ce03c7e8594)(), add = build.add.bind(build);
        for (let { from: from, to: to } of $b3e9d73db824614e$var$matchRanges(view, this.maxLength))$b3e9d73db824614e$var$iterMatches(view.state.doc, this.regexp, from, to, (from, m)=>this.addMatch(m, view, from, add));
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        let changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to >= update.view.viewport.from && from <= update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportMoved || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        for (let r of view.visibleRanges){
            let from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
            if (to >= from) {
                let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                if (this.boundary) {
                    for(; from > fromLine.from; from--)if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                        start = from;
                        break;
                    }
                    for(; to < toLine.to; to++)if (this.boundary.test(toLine.text[to - toLine.from])) {
                        end = to;
                        break;
                    }
                }
                let ranges = [], m;
                let add = (from, to, deco)=>ranges.push(deco.range(from, to));
                if (fromLine == toLine) {
                    this.regexp.lastIndex = start - fromLine.from;
                    while((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)this.addMatch(m, view, m.index + fromLine.from, add);
                } else $b3e9d73db824614e$var$iterMatches(view.state.doc, this.regexp, start, end, (from, m)=>this.addMatch(m, view, from, add));
                deco = deco.update({
                    filterFrom: start,
                    filterTo: end,
                    filter: (from, to)=>from < start || to > end,
                    add: ranges
                });
            }
        }
        return deco;
    }
}
const $b3e9d73db824614e$var$UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const $b3e9d73db824614e$var$Specials = /*@__PURE__*/ new RegExp("[\u0000-\u0008\u000a-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]", $b3e9d73db824614e$var$UnicodeRegexpSupport);
const $b3e9d73db824614e$var$Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
let $b3e9d73db824614e$var$_supportsTabSize = null;
function $b3e9d73db824614e$var$supportsTabSize() {
    var _a;
    if ($b3e9d73db824614e$var$_supportsTabSize == null && typeof document != "undefined" && document.body) {
        let styles = document.body.style;
        $b3e9d73db824614e$var$_supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return $b3e9d73db824614e$var$_supportsTabSize || false;
}
const $b3e9d73db824614e$var$specialCharConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let config = (0, $3ef527dddcdea745$export$4e19c0b693794a7e)(configs, {
            render: null,
            specialChars: $b3e9d73db824614e$var$Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !$b3e9d73db824614e$var$supportsTabSize()) config.specialChars = new RegExp("\t|" + config.specialChars.source, $b3e9d73db824614e$var$UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, $b3e9d73db824614e$var$UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function $b3e9d73db824614e$export$76dc0899547f659c(/**
Configuration options.
*/ config = {}) {
    return [
        $b3e9d73db824614e$var$specialCharConfig.of(config),
        $b3e9d73db824614e$var$specialCharPlugin()
    ];
}
let $b3e9d73db824614e$var$_plugin = null;
function $b3e9d73db824614e$var$specialCharPlugin() {
    return $b3e9d73db824614e$var$_plugin || ($b3e9d73db824614e$var$_plugin = $b3e9d73db824614e$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.decorations = $b3e9d73db824614e$export$10e30b733df217ea.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet($b3e9d73db824614e$var$specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
        makeDecorator(conf) {
            return new $b3e9d73db824614e$export$9b928b0ca20b25cb({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    let { doc: doc } = view.state;
                    let code = (0, $3ef527dddcdea745$export$42977f40461e1360)(m[0], 0);
                    if (code == 9) {
                        let line = doc.lineAt(pos);
                        let size = view.state.tabSize, col = (0, $3ef527dddcdea745$export$20b4ab289374d0ac)(line.text, size, pos - line.from);
                        return $b3e9d73db824614e$export$10e30b733df217ea.replace({
                            widget: new $b3e9d73db824614e$var$TabWidget((size - col % size) * this.view.defaultCharacterWidth / this.view.scaleX)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = $b3e9d73db824614e$export$10e30b733df217ea.replace({
                        widget: new $b3e9d73db824614e$var$SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            let conf = update.state.facet($b3e9d73db824614e$var$specialCharConfig);
            if (update.startState.facet($b3e9d73db824614e$var$specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
const $b3e9d73db824614e$var$DefaultPlaceholder = "\u2022";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function $b3e9d73db824614e$var$placeholder$1(code) {
    if (code >= 32) return $b3e9d73db824614e$var$DefaultPlaceholder;
    if (code == 10) return "\u2424";
    return String.fromCharCode(9216 + code);
}
class $b3e9d73db824614e$var$SpecialCharWidget extends $b3e9d73db824614e$export$95cdd842edb044c5 {
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        let ph = $b3e9d73db824614e$var$placeholder$1(this.code);
        let desc = view.state.phrase("Control character") + " " + ($b3e9d73db824614e$var$Names[this.code] || "0x" + this.code.toString(16));
        let custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        let span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
class $b3e9d73db824614e$var$TabWidget extends $b3e9d73db824614e$export$95cdd842edb044c5 {
    constructor(width){
        super();
        this.width = width;
    }
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        let span = document.createElement("span");
        span.textContent = "\t";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
const $b3e9d73db824614e$var$plugin = /*@__PURE__*/ $b3e9d73db824614e$export$44d5eccfd62adda7.fromClass(class {
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
    update(update) {
        let { view: view } = update;
        let height = view.viewState.editorHeight - view.defaultLineHeight - view.documentPadding.top - 0.5;
        if (height >= 0 && height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function $b3e9d73db824614e$export$1f905ef5d6deb4f() {
    return [
        $b3e9d73db824614e$var$plugin,
        $b3e9d73db824614e$var$contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin($b3e9d73db824614e$var$plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function $b3e9d73db824614e$export$1a7e096bee9035c() {
    return $b3e9d73db824614e$var$activeLineHighlighter;
}
const $b3e9d73db824614e$var$lineDeco = /*@__PURE__*/ $b3e9d73db824614e$export$10e30b733df217ea.line({
    class: "cm-activeLine"
});
const $b3e9d73db824614e$var$activeLineHighlighter = /*@__PURE__*/ $b3e9d73db824614e$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let lastLineStart = -1, deco = [];
        for (let r of view.state.selection.ranges){
            let line = view.lineBlockAt(r.head);
            if (line.from > lastLineStart) {
                deco.push($b3e9d73db824614e$var$lineDeco.range(line.from));
                lastLineStart = line.from;
            }
        }
        return $b3e9d73db824614e$export$10e30b733df217ea.set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
class $b3e9d73db824614e$var$Placeholder extends $b3e9d73db824614e$export$95cdd842edb044c5 {
    constructor(content){
        super();
        this.content = content;
    }
    toDOM(view) {
        let wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(view) : this.content.cloneNode(true));
        wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    coordsAt(dom) {
        let rects = dom.firstChild ? $b3e9d73db824614e$var$clientRectsFor(dom.firstChild) : [];
        if (!rects.length) return null;
        let style = window.getComputedStyle(dom.parentNode);
        let rect = $b3e9d73db824614e$var$flattenRect(rects[0], style.direction != "rtl");
        let lineHeight = parseInt(style.lineHeight);
        if (rect.bottom - rect.top > lineHeight * 1.5) return {
            left: rect.left,
            right: rect.right,
            top: rect.top,
            bottom: rect.top + lineHeight
        };
        return rect;
    }
    ignoreEvent() {
        return false;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function $b3e9d73db824614e$export$c7187bbd1a7a9244(content) {
    let plugin = $b3e9d73db824614e$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.placeholder = content ? $b3e9d73db824614e$export$10e30b733df217ea.set([
                $b3e9d73db824614e$export$10e30b733df217ea.widget({
                    widget: new $b3e9d73db824614e$var$Placeholder(content),
                    side: 1
                }).range(0)
            ]) : $b3e9d73db824614e$export$10e30b733df217ea.none;
        }
        get decorations() {
            return this.view.state.doc.length ? $b3e9d73db824614e$export$10e30b733df217ea.none : this.placeholder;
        }
    }, {
        decorations: (v)=>v.decorations
    });
    return typeof content == "string" ? [
        plugin,
        $b3e9d73db824614e$export$eece2fccabbb77c5.contentAttributes.of({
            "aria-placeholder": content
        })
    ] : plugin;
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
const $b3e9d73db824614e$var$MaxOff = 2000;
function $b3e9d73db824614e$var$rectangleFor(state, a, b) {
    let startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    let ranges = [];
    if (a.off > $b3e9d73db824614e$var$MaxOff || b.off > $b3e9d73db824614e$var$MaxOff || a.col < 0 || b.col < 0) {
        let startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(line.from + startOff, line.to + endOff));
        }
    } else {
        let startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            let start = (0, $3ef527dddcdea745$export$718b3d71c384ca05)(line.text, startCol, state.tabSize, true);
            if (start < 0) ranges.push((0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(line.to));
            else {
                let end = (0, $3ef527dddcdea745$export$718b3d71c384ca05)(line.text, endCol, state.tabSize);
                ranges.push((0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(line.from + start, line.from + end));
            }
        }
    }
    return ranges;
}
function $b3e9d73db824614e$var$absoluteColumn(view, x) {
    let ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function $b3e9d73db824614e$var$getPos(view, event) {
    let offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let line = view.state.doc.lineAt(offset), off = offset - line.from;
    let col = off > $b3e9d73db824614e$var$MaxOff ? -1 : off == line.length ? $b3e9d73db824614e$var$absoluteColumn(view, event.clientX) : (0, $3ef527dddcdea745$export$20b4ab289374d0ac)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col: col,
        off: off
    };
}
function $b3e9d73db824614e$var$rectangleSelectionStyle(view, event) {
    let start = $b3e9d73db824614e$var$getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                let newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            let cur = $b3e9d73db824614e$var$getPos(view, event);
            if (!cur) return startSel;
            let ranges = $b3e9d73db824614e$var$rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create(ranges.concat(startSel.ranges));
            else return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function $b3e9d73db824614e$export$dd482925db1aabd3(options) {
    let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return $b3e9d73db824614e$export$eece2fccabbb77c5.mouseSelectionStyle.of((view, event)=>filter(event) ? $b3e9d73db824614e$var$rectangleSelectionStyle(view, event) : null);
}
const $b3e9d73db824614e$var$keys = {
    Alt: [
        18,
        (e)=>!!e.altKey
    ],
    Control: [
        17,
        (e)=>!!e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>!!e.shiftKey
    ],
    Meta: [
        91,
        (e)=>!!e.metaKey
    ]
};
const $b3e9d73db824614e$var$showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function $b3e9d73db824614e$export$9b6525222ac3b7fb(options = {}) {
    let [code, getter] = $b3e9d73db824614e$var$keys[options.key || "Alt"];
    let plugin = $b3e9d73db824614e$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
    }, {
        eventObservers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            },
            mousemove (e) {
                this.set(getter(e));
            }
        }
    });
    return [
        plugin,
        $b3e9d73db824614e$export$eece2fccabbb77c5.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? $b3e9d73db824614e$var$showCrosshair : null;
        })
    ];
}
const $b3e9d73db824614e$var$Outside = "-10000px";
class $b3e9d73db824614e$var$TooltipViewManager {
    constructor(view, facet, createTooltipView, removeTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.removeTooltipView = removeTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        let prev = null;
        this.tooltipViews = this.tooltips.map((t)=>prev = createTooltipView(t, prev));
    }
    update(update, above) {
        var _a;
        let input = update.state.facet(this.facet);
        let tooltips = input.filter((x)=>x);
        if (input === this.input) {
            for (let t of this.tooltipViews)if (t.update) t.update(update);
            return false;
        }
        let tooltipViews = [], newAbove = above ? [] : null;
        for(let i = 0; i < tooltips.length; i++){
            let tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(let i = 0; i < this.tooltips.length; i++){
                let other = this.tooltips[i];
                if (other && other.create == tip.create) known = i;
            }
            if (known < 0) {
                tooltipViews[i] = this.createTooltipView(tip, i ? tooltipViews[i - 1] : null);
                if (newAbove) newAbove[i] = !!tip.above;
            } else {
                let tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (newAbove) newAbove[i] = above[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        for (let t of this.tooltipViews)if (tooltipViews.indexOf(t) < 0) {
            this.removeTooltipView(t);
            (_a = t.destroy) === null || _a === void 0 || _a.call(t);
        }
        if (above) {
            newAbove.forEach((val, i)=>above[i] = val);
            above.length = newAbove.length;
        }
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function $b3e9d73db824614e$export$1fc29293196e3bc(config = {}) {
    return $b3e9d73db824614e$var$tooltipConfig.of(config);
}
function $b3e9d73db824614e$var$windowSpace(view) {
    let docElt = view.dom.ownerDocument.documentElement;
    return {
        top: 0,
        left: 0,
        bottom: docElt.clientHeight,
        right: docElt.clientWidth
    };
}
const $b3e9d73db824614e$var$tooltipConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: $b3e9d73db824614e$var$browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || $b3e9d73db824614e$var$windowSpace
        };
    }
});
const $b3e9d73db824614e$var$knownHeight = /*@__PURE__*/ new WeakMap();
const $b3e9d73db824614e$var$tooltipPlugin = /*@__PURE__*/ $b3e9d73db824614e$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.above = [];
        this.inView = true;
        this.madeAbsolute = false;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        let config = view.state.facet($b3e9d73db824614e$var$tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(()=>this.measureSoon()) : null;
        this.manager = new $b3e9d73db824614e$var$TooltipViewManager(view, $b3e9d73db824614e$export$dba11b50e1aa3c12, (t, p)=>this.createTooltip(t, p), (t)=>{
            if (this.resizeObserver) this.resizeObserver.unobserve(t.dom);
            t.dom.remove();
        });
        this.above = this.manager.tooltips.map((t)=>!!t.above);
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            for (let tooltip of this.manager.tooltipViews)this.intersectionObserver.observe(tooltip.dom);
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        let updated = this.manager.update(update, this.above);
        if (updated) this.observeIntersection();
        let shouldMeasure = updated || update.geometryChanged;
        let newConfig = update.state.facet($b3e9d73db824614e$var$tooltipConfig);
        if (newConfig.position != this.position && !this.madeAbsolute) {
            this.position = newConfig.position;
            for (let t of this.manager.tooltipViews)t.dom.style.position = this.position;
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            for (let t of this.manager.tooltipViews)this.container.appendChild(t.dom);
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip, prev) {
        let tooltipView = tooltip.create(this.view);
        let before = prev ? prev.dom : null;
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            let arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.appendChild(arrow);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = $b3e9d73db824614e$var$Outside;
        tooltipView.dom.style.left = "0px";
        this.container.insertBefore(tooltipView.dom, before);
        if (tooltipView.mount) tooltipView.mount(this.view);
        if (this.resizeObserver) this.resizeObserver.observe(tooltipView.dom);
        return tooltipView;
    }
    destroy() {
        var _a, _b, _c;
        this.view.win.removeEventListener("resize", this.measureSoon);
        for (let tooltipView of this.manager.tooltipViews){
            tooltipView.dom.remove();
            (_a = tooltipView.destroy) === null || _a === void 0 || _a.call(tooltipView);
        }
        if (this.parent) this.container.remove();
        (_b = this.resizeObserver) === null || _b === void 0 || _b.disconnect();
        (_c = this.intersectionObserver) === null || _c === void 0 || _c.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        let scaleX = 1, scaleY = 1, makeAbsolute = false;
        if (this.position == "fixed" && this.manager.tooltipViews.length) {
            let { dom: dom } = this.manager.tooltipViews[0];
            if ($b3e9d73db824614e$var$browser.safari) {
                // Safari always sets offsetParent to null, even if a fixed
                // element is positioned relative to a transformed parent. So
                // we use this kludge to try and detect this.
                let rect = dom.getBoundingClientRect();
                makeAbsolute = Math.abs(rect.top + 10000) > 1 || Math.abs(rect.left) > 1;
            } else // More conforming browsers will set offsetParent to the
            // transformed element.
            makeAbsolute = !!dom.offsetParent && dom.offsetParent != this.container.ownerDocument.body;
        }
        if (makeAbsolute || this.position == "absolute") {
            if (this.parent) {
                let rect = this.parent.getBoundingClientRect();
                if (rect.width && rect.height) {
                    scaleX = rect.width / this.parent.offsetWidth;
                    scaleY = rect.height / this.parent.offsetHeight;
                }
            } else ({ scaleX: scaleX, scaleY: scaleY } = this.view.viewState);
        }
        let visible = this.view.scrollDOM.getBoundingClientRect(), margins = $b3e9d73db824614e$var$getScrollMargins(this.view);
        return {
            visible: {
                left: visible.left + margins.left,
                top: visible.top + margins.top,
                right: visible.right - margins.right,
                bottom: visible.bottom - margins.bottom
            },
            parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
            pos: this.manager.tooltips.map((t, i)=>{
                let tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map(({ dom: dom })=>dom.getBoundingClientRect()),
            space: this.view.state.facet($b3e9d73db824614e$var$tooltipConfig).tooltipSpace(this.view),
            scaleX: scaleX,
            scaleY: scaleY,
            makeAbsolute: makeAbsolute
        };
    }
    writeMeasure(measured) {
        var _a;
        if (measured.makeAbsolute) {
            this.madeAbsolute = true;
            this.position = "absolute";
            for (let t of this.manager.tooltipViews)t.dom.style.position = "absolute";
        }
        let { visible: visible, space: space, scaleX: scaleX, scaleY: scaleY } = measured;
        let others = [];
        for(let i = 0; i < this.manager.tooltips.length; i++){
            let tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], { dom: dom } = tView;
            let pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || tooltip.clip !== false && (pos.bottom <= Math.max(visible.top, space.top) || pos.top >= Math.min(visible.bottom, space.bottom) || pos.right < Math.max(visible.left, space.left) - .1 || pos.left > Math.min(visible.right, space.right) + .1)) {
                dom.style.top = $b3e9d73db824614e$var$Outside;
                continue;
            }
            let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            let arrowHeight = arrow ? 7 /* Arrow.Size */  : 0;
            let width = size.right - size.left, height = (_a = $b3e9d73db824614e$var$knownHeight.get(tView)) !== null && _a !== void 0 ? _a : size.bottom - size.top;
            let offset = tView.offset || $b3e9d73db824614e$var$noOffset, ltr = this.view.textDirection == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR;
            let left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.max(space.left, Math.min(pos.left - (arrow ? 14 /* Arrow.Offset */  : 0) + offset.x, space.right - width)) : Math.min(Math.max(space.left, pos.left - width + (arrow ? 14 /* Arrow.Offset */  : 0) - offset.x), space.right - width);
            let above = this.above[i];
            if (!tooltip.strictSide && (above ? pos.top - height - arrowHeight - offset.y < space.top : pos.bottom + height + arrowHeight + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = this.above[i] = !above;
            let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
            if (spaceVert < height && tView.resize !== false) {
                if (spaceVert < this.view.defaultLineHeight) {
                    dom.style.top = $b3e9d73db824614e$var$Outside;
                    continue;
                }
                $b3e9d73db824614e$var$knownHeight.set(tView, height);
                dom.style.height = (height = spaceVert) / scaleY + "px";
            } else if (dom.style.height) dom.style.height = "";
            let top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            let right = left + width;
            if (tView.overlap !== true) {
                for (let r of others)if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
            }
            if (this.position == "absolute") {
                dom.style.top = (top - measured.parent.top) / scaleY + "px";
                $b3e9d73db824614e$var$setLeftStyle(dom, (left - measured.parent.left) / scaleX);
            } else {
                dom.style.top = top / scaleY + "px";
                $b3e9d73db824614e$var$setLeftStyle(dom, left / scaleX);
            }
            if (arrow) {
                let arrowLeft = pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Arrow.Offset */  - 7 /* Arrow.Size */ );
                arrow.style.left = arrowLeft / scaleX + "px";
            }
            if (tView.overlap !== true) others.push({
                left: left,
                top: top,
                right: right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned(measured.space);
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                if (!this.inView) for (let tv of this.manager.tooltipViews)tv.dom.style.top = $b3e9d73db824614e$var$Outside;
            }
        }
    }
}, {
    eventObservers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
function $b3e9d73db824614e$var$setLeftStyle(elt, value) {
    let current = parseInt(elt.style.left, 10);
    if (isNaN(current) || Math.abs(value - current) > 1) elt.style.left = value + "px";
}
const $b3e9d73db824614e$var$baseTheme = /*@__PURE__*/ $b3e9d73db824614e$export$eece2fccabbb77c5.baseTheme({
    ".cm-tooltip": {
        zIndex: 500,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Arrow.Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Arrow.Size */ }px solid transparent`,
            borderRight: `${7 /* Arrow.Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
const $b3e9d73db824614e$var$noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ const $b3e9d73db824614e$export$dba11b50e1aa3c12 = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    enables: [
        $b3e9d73db824614e$var$tooltipPlugin,
        $b3e9d73db824614e$var$baseTheme
    ]
});
const $b3e9d73db824614e$var$showHoverTooltip = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (inputs)=>inputs.reduce((a, i)=>a.concat(i), [])
});
class $b3e9d73db824614e$var$HoverTooltipHost {
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new $b3e9d73db824614e$var$HoverTooltipHost(view);
    }
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new $b3e9d73db824614e$var$TooltipViewManager(view, $b3e9d73db824614e$var$showHoverTooltip, (t, p)=>this.createHostedView(t, p), (t)=>t.dom.remove());
    }
    createHostedView(tooltip, prev) {
        let hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.insertBefore(hostedView.dom, prev ? prev.dom.nextSibling : this.dom.firstChild);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.mount) hostedView.mount(view);
        this.mounted = true;
    }
    positioned(space) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.positioned) hostedView.positioned(space);
    }
    update(update) {
        this.manager.update(update);
    }
    destroy() {
        var _a;
        for (let t of this.manager.tooltipViews)(_a = t.destroy) === null || _a === void 0 || _a.call(t);
    }
    passProp(name) {
        let value = undefined;
        for (let view of this.manager.tooltipViews){
            let given = view[name];
            if (given !== undefined) {
                if (value === undefined) value = given;
                else if (value !== given) return undefined;
            }
        }
        return value;
    }
    get offset() {
        return this.passProp("offset");
    }
    get getCoords() {
        return this.passProp("getCoords");
    }
    get overlap() {
        return this.passProp("overlap");
    }
    get resize() {
        return this.passProp("resize");
    }
}
const $b3e9d73db824614e$var$showHoverTooltipHost = /*@__PURE__*/ $b3e9d73db824614e$export$dba11b50e1aa3c12.compute([
    $b3e9d73db824614e$var$showHoverTooltip
], (state)=>{
    let tooltips = state.facet($b3e9d73db824614e$var$showHoverTooltip);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.map((t)=>{
            var _a;
            return (_a = t.end) !== null && _a !== void 0 ? _a : t.pos;
        })),
        create: $b3e9d73db824614e$var$HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
const $b3e9d73db824614e$var$hoverPlugin = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
class $b3e9d73db824614e$var$HoverPlugin {
    constructor(view, source, field, locked, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.locked = locked;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update(update) {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active.length) return;
        let hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        let { view: view, lastMove: lastMove } = this;
        let tile = view.docView.tile.nearest(lastMove.target);
        if (!tile) return;
        let pos, side = 1;
        if (tile.isWidget()) pos = tile.posAtStart;
        else {
            pos = view.posAtCoords(lastMove);
            if (pos == null) return;
            let posCoords = view.coordsAtPos(pos);
            if (!posCoords || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - view.defaultCharacterWidth || lastMove.x > posCoords.right + view.defaultCharacterWidth) return;
            let bidi = view.bidiSpans(view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
            let rtl = bidi && bidi.dir == $b3e9d73db824614e$export$cacd6541cfeeb6c1.RTL ? -1 : 1;
            side = lastMove.x < posCoords.left ? -rtl : rtl;
        }
        this.activateHover(view, pos, side);
    }
    activateHover(view, pos, side, locked) {
        let open = this.source(view, pos, side);
        let done = (value)=>{
            if (value && !(Array.isArray(value) && !value.length)) {
                let tooltips = Array.isArray(value) ? value : [
                    value
                ];
                if (locked) this.locked.set(tooltips, locked);
                view.dispatch({
                    effects: this.setHover.of(tooltips)
                });
            }
        };
        if (open && "then" in open) {
            let pending = this.pending = {
                pos: pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    done(result);
                }
            }, (e)=>$b3e9d73db824614e$export$f86b2a1a2ce291b3(view.state, e, "hover tooltip"));
        } else done(open);
    }
    get tooltip() {
        let plugin = this.view.plugin($b3e9d73db824614e$var$tooltipPlugin);
        let index = plugin ? plugin.manager.tooltips.findIndex((t)=>t.create == $b3e9d73db824614e$var$HoverTooltipHost.create) : -1;
        return index > -1 ? plugin.manager.tooltipViews[index] : null;
    }
    mousemove(event) {
        var _a, _b;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        let { active: active, tooltip: tooltip } = this;
        if (active.length && !this.locked.has(active) && tooltip && !$b3e9d73db824614e$var$isInTooltip(tooltip.dom, event) || this.pending) {
            let { pos: pos } = active[0] || this.pending, end = (_b = (_a = active[0]) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !$b3e9d73db824614e$var$isOverRange(this.view, pos, end, event.clientX, event.clientY)) {
                this.view.dispatch({
                    effects: this.setHover.of([])
                });
                this.pending = null;
            }
        }
    }
    mouseleave(event) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        let { active: active } = this;
        if (active.length && !this.locked.has(active)) {
            let { tooltip: tooltip } = this;
            let inTooltip = tooltip && tooltip.dom.contains(event.relatedTarget);
            if (!inTooltip) this.view.dispatch({
                effects: this.setHover.of([])
            });
            else this.watchTooltipLeave(tooltip.dom);
        }
    }
    watchTooltipLeave(tooltip) {
        let watch = (event)=>{
            tooltip.removeEventListener("mouseleave", watch);
            let { active: active } = this;
            if (active.length && !this.locked.has(active) && !this.view.dom.contains(event.relatedTarget)) this.view.dispatch({
                effects: this.setHover.of([])
            });
        };
        tooltip.addEventListener("mouseleave", watch);
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        clearTimeout(this.restartTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
}
const $b3e9d73db824614e$var$tooltipMargin = 4;
function $b3e9d73db824614e$var$isInTooltip(tooltip, event) {
    let { left: left, right: right, top: top, bottom: bottom } = tooltip.getBoundingClientRect(), arrow;
    if (arrow = tooltip.querySelector(".cm-tooltip-arrow")) {
        let arrowRect = arrow.getBoundingClientRect();
        top = Math.min(arrowRect.top, top);
        bottom = Math.max(arrowRect.bottom, bottom);
    }
    return event.clientX >= left - $b3e9d73db824614e$var$tooltipMargin && event.clientX <= right + $b3e9d73db824614e$var$tooltipMargin && event.clientY >= top - $b3e9d73db824614e$var$tooltipMargin && event.clientY <= bottom + $b3e9d73db824614e$var$tooltipMargin;
}
function $b3e9d73db824614e$var$isOverRange(view, from, to, x, y, margin) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let docBottom = view.documentTop + view.documentPadding.top + view.contentHeight;
    if (rect.left > x || rect.right < x || rect.top > y || Math.min(rect.bottom, docBottom) < y) return false;
    let pos = view.posAtCoords({
        x: x,
        y: y
    }, false);
    return pos >= from && pos <= to;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.

The return value is a valid [editor extension](https://codemirror.net/6/docs/ref/#state.Extension)
but also provides an `active` property holding a state field that
can be used to read the currently active tooltips produced by this
extension.
*/ function $b3e9d73db824614e$export$69f8d9e63c4aa884(source, options = {}) {
    let setHover = (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
    // This would be better stored in the state field, but we've set
    // down the type of the field in our interface, so it's indirectly
    // stored by array identity.
    let locked = new WeakMap();
    let hoverState = (0, $3ef527dddcdea745$export$34381b1ce2130245).define({
        create () {
            return [];
        },
        update (value, tr) {
            let lock = locked.get(value);
            if (value.length) {
                if (options.hideOnChange && (tr.docChanged || tr.selection)) value = [];
                else if (lock && lock(tr)) value = [];
                else if (options.hideOn) value = value.filter((v)=>!options.hideOn(tr, v));
            }
            if (tr.docChanged && value.length) {
                let mapped = [];
                for (let tooltip of value){
                    let newPos = tr.changes.mapPos(tooltip.pos, -1, (0, $3ef527dddcdea745$export$39cf3280165f92aa).TrackDel);
                    if (newPos != null) {
                        let copy = Object.assign(Object.create(null), tooltip);
                        copy.pos = newPos;
                        if (copy.end != null) copy.end = tr.changes.mapPos(copy.end);
                        mapped.push(copy);
                    }
                }
                value = mapped;
            }
            for (let effect of tr.effects){
                if (effect.is(setHover)) {
                    value = effect.value;
                    lock = undefined;
                }
                if (effect.is($b3e9d73db824614e$var$closeHoverTooltipEffect) && !effect.value || effect.value == hoverState) value = [];
            }
            if (value.length && lock) locked.set(value, lock);
            return value;
        },
        provide: (f)=>$b3e9d73db824614e$var$showHoverTooltip.from(f)
    });
    const plugin = $b3e9d73db824614e$export$44d5eccfd62adda7.define((view)=>new $b3e9d73db824614e$var$HoverPlugin(view, source, hoverState, locked, setHover, options.hoverTime || 300 /* Hover.Time */ ));
    return {
        active: hoverState,
        extension: [
            hoverState,
            plugin,
            $b3e9d73db824614e$var$hoverPlugin.of(plugin),
            $b3e9d73db824614e$var$showHoverTooltipHost
        ]
    };
}
/**
Activate hover tooltips for the given position and side. If you
provide a specific hover tooltip (the value returned from
[`hoverTooltip`](https://codemirror.net/6/docs/ref/#view.hoverTooltip)), only that one will be
activated. If not given, all hover tooltips at the given position
are triggered.

Note that tooltips opened this way don't close automatically, and
you'll want to pass an `until` callback or use
[`closeHoverTooltip`](https://codemirror.net/6/docs/ref/#view.closeHoverTooltip)/[`closeHoverTooltips`](https://codemirror.net/6/docs/ref/#view.closeHoverTooltips)
to deactivate them.
*/ function $b3e9d73db824614e$export$a34e0ba9d4697396(view, pos, side, options = {}) {
    var _a;
    let plugins = view.state.facet($b3e9d73db824614e$var$hoverPlugin).map((p)=>view.plugin(p)).filter((p)=>!!p);
    if (options.tooltip && options.tooltip.active) {
        let found = plugins.find((p)=>p.field == options.tooltip.active);
        if (found) plugins = [
            found
        ];
    }
    for (let plugin of plugins)plugin.activateHover(view, pos, side, (_a = options.until) !== null && _a !== void 0 ? _a : ()=>false);
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function $b3e9d73db824614e$export$46455b4476d4b8e1(view, tooltip) {
    let plugin = view.plugin($b3e9d73db824614e$var$tooltipPlugin);
    if (!plugin) return null;
    let found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function $b3e9d73db824614e$export$7864d875805bc1b0(state) {
    return state.facet($b3e9d73db824614e$var$showHoverTooltip).some((x)=>x);
}
const $b3e9d73db824614e$var$closeHoverTooltipEffect = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
/**
Transaction effect that closes all hover tooltips.
*/ const $b3e9d73db824614e$export$f6974094db6525a = /*@__PURE__*/ $b3e9d73db824614e$var$closeHoverTooltipEffect.of(null);
/**
Transaction effect that closes a specific hover tooltip.
*/ function $b3e9d73db824614e$export$8ad7caa9981c5ca8(tooltip) {
    return $b3e9d73db824614e$var$closeHoverTooltipEffect.of(tooltip.active);
}
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function $b3e9d73db824614e$export$912859096d593b90(view) {
    let plugin = view.plugin($b3e9d73db824614e$var$tooltipPlugin);
    if (plugin) plugin.maybeMeasure();
}
const $b3e9d73db824614e$var$panelConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let topContainer, bottomContainer;
        for (let c of configs){
            topContainer = topContainer || c.topContainer;
            bottomContainer = bottomContainer || c.bottomContainer;
        }
        return {
            topContainer: topContainer,
            bottomContainer: bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function $b3e9d73db824614e$export$8128819a2322681a(config) {
    return config ? [
        $b3e9d73db824614e$var$panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function $b3e9d73db824614e$export$7361ed18ff57179e(view, panel) {
    let plugin = view.plugin($b3e9d73db824614e$var$panelPlugin);
    let index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
const $b3e9d73db824614e$var$panelPlugin = /*@__PURE__*/ $b3e9d73db824614e$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.input = view.state.facet($b3e9d73db824614e$export$e89c3c9af31c1e3b);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        let conf = view.state.facet($b3e9d73db824614e$var$panelConfig);
        this.top = new $b3e9d73db824614e$var$PanelGroup(view, true, conf.topContainer);
        this.bottom = new $b3e9d73db824614e$var$PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        for (let p of this.panels){
            p.dom.classList.add("cm-panel");
            if (p.mount) p.mount();
        }
    }
    update(update) {
        let conf = update.state.facet($b3e9d73db824614e$var$panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new $b3e9d73db824614e$var$PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new $b3e9d73db824614e$var$PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        let input = update.state.facet($b3e9d73db824614e$export$e89c3c9af31c1e3b);
        if (input != this.input) {
            let specs = input.filter((x)=>x);
            let panels = [], top = [], bottom = [], mount = [];
            for (let spec of specs){
                let known = this.specs.indexOf(spec), panel;
                if (known < 0) {
                    panel = spec(update.view);
                    mount.push(panel);
                } else {
                    panel = this.panels[known];
                    if (panel.update) panel.update(update);
                }
                panels.push(panel);
                (panel.top ? top : bottom).push(panel);
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            for (let p of mount){
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } else {
            for (let p of this.panels)if (p.update) p.update(update);
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
}, {
    provide: (plugin)=>$b3e9d73db824614e$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class $b3e9d73db824614e$var$PanelGroup {
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
    sync(panels) {
        for (let p of this.panels)if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            let parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        let curDOM = this.dom.firstChild;
        for (let panel of this.panels)if (panel.dom.parentNode == this.dom) {
            while(curDOM != panel.dom)curDOM = $b3e9d73db824614e$var$rm(curDOM);
            curDOM = curDOM.nextSibling;
        } else this.dom.insertBefore(panel.dom, curDOM);
        while(curDOM)curDOM = $b3e9d73db824614e$var$rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        for (let cls of this.classes.split(" "))if (cls) this.container.classList.remove(cls);
        for (let cls of (this.classes = this.view.themeClasses).split(" "))if (cls) this.container.classList.add(cls);
    }
}
function $b3e9d73db824614e$var$rm(node) {
    let next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ const $b3e9d73db824614e$export$e89c3c9af31c1e3b = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    enables: $b3e9d73db824614e$var$panelPlugin
});
/**
Show a panel above or below the editor to show the user a message
or prompt them for input. Returns an effect that can be dispatched
to close the dialog, and a promise that resolves when the dialog
is closed or a form inside of it is submitted.

You are encouraged, if your handling of the result of the promise
dispatches a transaction, to include the `close` effect in it. If
you don't, this function will automatically dispatch a separate
transaction right after.
*/ function $b3e9d73db824614e$export$61e0a65f251cfdb3(view, config) {
    let resolve;
    let promise = new Promise((r)=>resolve = r);
    let panelCtor = (view)=>$b3e9d73db824614e$var$createDialog(view, config, resolve);
    if (view.state.field($b3e9d73db824614e$var$dialogField, false)) view.dispatch({
        effects: $b3e9d73db824614e$var$openDialogEffect.of(panelCtor)
    });
    else view.dispatch({
        effects: (0, $3ef527dddcdea745$export$95000d4efaa4321f).appendConfig.of($b3e9d73db824614e$var$dialogField.init(()=>[
                panelCtor
            ]))
    });
    let close = $b3e9d73db824614e$var$closeDialogEffect.of(panelCtor);
    return {
        close: close,
        result: promise.then((form)=>{
            let queue = view.win.queueMicrotask || ((f)=>view.win.setTimeout(f, 10));
            queue(()=>{
                if (view.state.field($b3e9d73db824614e$var$dialogField).indexOf(panelCtor) > -1) view.dispatch({
                    effects: close
                });
            });
            return form;
        })
    };
}
/**
Find the [`Panel`](https://codemirror.net/6/docs/ref/#view.Panel) for an open dialog, using a class
name as identifier.
*/ function $b3e9d73db824614e$export$add6d5f54f9ab5a8(view, className) {
    let dialogs = view.state.field($b3e9d73db824614e$var$dialogField, false) || [];
    for (let open of dialogs){
        let panel = $b3e9d73db824614e$export$7361ed18ff57179e(view, open);
        if (panel && panel.dom.classList.contains(className)) return panel;
    }
    return null;
}
const $b3e9d73db824614e$var$dialogField = /*@__PURE__*/ (0, $3ef527dddcdea745$export$34381b1ce2130245).define({
    create () {
        return [];
    },
    update (dialogs, tr) {
        for (let e of tr.effects){
            if (e.is($b3e9d73db824614e$var$openDialogEffect)) dialogs = [
                e.value
            ].concat(dialogs);
            else if (e.is($b3e9d73db824614e$var$closeDialogEffect)) dialogs = dialogs.filter((d)=>d != e.value);
        }
        return dialogs;
    },
    provide: (f)=>$b3e9d73db824614e$export$e89c3c9af31c1e3b.computeN([
            f
        ], (state)=>state.field(f))
});
const $b3e9d73db824614e$var$openDialogEffect = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
const $b3e9d73db824614e$var$closeDialogEffect = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
function $b3e9d73db824614e$var$createDialog(view, config, result) {
    let content = config.content ? config.content(view, ()=>done(null)) : null;
    if (!content) {
        content = (0, $49ddc340444673b0$export$2e2bcd8739ae039)("form");
        if (config.input) {
            let input = (0, $49ddc340444673b0$export$2e2bcd8739ae039)("input", config.input);
            if (/^(text|password|number|email|tel|url)$/.test(input.type)) input.classList.add("cm-textfield");
            if (!input.name) input.name = "input";
            content.appendChild((0, $49ddc340444673b0$export$2e2bcd8739ae039)("label", (config.label || "") + ": ", input));
        } else content.appendChild(document.createTextNode(config.label || ""));
        content.appendChild(document.createTextNode(" "));
        content.appendChild((0, $49ddc340444673b0$export$2e2bcd8739ae039)("button", {
            class: "cm-button",
            type: "submit"
        }, config.submitLabel || "OK"));
    }
    let forms = content.nodeName == "FORM" ? [
        content
    ] : content.querySelectorAll("form");
    for(let i = 0; i < forms.length; i++){
        let form = forms[i];
        form.addEventListener("keydown", (event)=>{
            if (event.keyCode == 27) {
                event.preventDefault();
                done(null);
            } else if (event.keyCode == 13) {
                event.preventDefault();
                done(form);
            }
        });
        form.addEventListener("submit", (event)=>{
            event.preventDefault();
            done(form);
        });
    }
    let panel = (0, $49ddc340444673b0$export$2e2bcd8739ae039)("div", content, (0, $49ddc340444673b0$export$2e2bcd8739ae039)("button", {
        onclick: ()=>done(null),
        "aria-label": view.state.phrase("close"),
        class: "cm-dialog-close",
        type: "button"
    }, [
        "\xd7"
    ]));
    if (config.class) panel.className = config.class;
    panel.classList.add("cm-dialog");
    function done(form) {
        if (panel.contains(panel.ownerDocument.activeElement)) view.focus();
        result(form);
    }
    return {
        dom: panel,
        top: config.top,
        mount: ()=>{
            if (config.focus) {
                let focus;
                if (typeof config.focus == "string") focus = content.querySelector(config.focus);
                else focus = content.querySelector("input") || content.querySelector("button");
                if (focus && "select" in focus) focus.select();
                else if (focus && "focus" in focus) focus.focus();
            }
        }
    };
}
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class $b3e9d73db824614e$export$591ab4c909549043 extends (0, $3ef527dddcdea745$export$d60f08ed93a48611) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
$b3e9d73db824614e$export$591ab4c909549043.prototype.elementClass = "";
$b3e9d73db824614e$export$591ab4c909549043.prototype.toDOM = undefined;
$b3e9d73db824614e$export$591ab4c909549043.prototype.mapMode = (0, $3ef527dddcdea745$export$39cf3280165f92aa).TrackBefore;
$b3e9d73db824614e$export$591ab4c909549043.prototype.startSide = $b3e9d73db824614e$export$591ab4c909549043.prototype.endSide = -1;
$b3e9d73db824614e$export$591ab4c909549043.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ const $b3e9d73db824614e$export$113bd64f27ac1172 = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
/**
Facet used to add a class to all gutter elements next to a widget.
Should not provide widgets with a `toDOM` method.
*/ const $b3e9d73db824614e$export$6dd229d2c0925f7a = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, $3ef527dddcdea745$export$34cb5241245008dd).empty,
    lineMarker: ()=>null,
    widgetMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {},
    side: "before"
};
const $b3e9d73db824614e$var$activeGutters = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function $b3e9d73db824614e$export$f2b922cb4a245974(config) {
    return [
        $b3e9d73db824614e$export$ec15ef01b8fbae61(),
        $b3e9d73db824614e$var$activeGutters.of({
            ...$b3e9d73db824614e$var$defaults,
            ...config
        })
    ];
}
const $b3e9d73db824614e$var$unfixGutters = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function $b3e9d73db824614e$export$ec15ef01b8fbae61(config) {
    let result = [
        $b3e9d73db824614e$var$gutterView
    ];
    if (config && config.fixed === false) result.push($b3e9d73db824614e$var$unfixGutters.of(true));
    return result;
}
const $b3e9d73db824614e$var$gutterView = /*@__PURE__*/ $b3e9d73db824614e$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.domAfter = null;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters cm-gutters-before";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        this.gutters = view.state.facet($b3e9d73db824614e$var$activeGutters).map((conf)=>new $b3e9d73db824614e$var$SingleGutterView(view, conf));
        this.fixed = !view.state.facet($b3e9d73db824614e$var$unfixGutters);
        for (let gutter of this.gutters)if (gutter.config.side == "after") this.getDOMAfter().appendChild(gutter.dom);
        else this.dom.appendChild(gutter.dom);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
    getDOMAfter() {
        if (!this.domAfter) {
            this.domAfter = document.createElement("div");
            this.domAfter.className = "cm-gutters cm-gutters-after";
            this.domAfter.setAttribute("aria-hidden", "true");
            this.domAfter.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
            this.domAfter.style.position = this.fixed ? "sticky" : "";
            this.view.scrollDOM.appendChild(this.domAfter);
        }
        return this.domAfter;
    }
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            let vpA = this.prevViewport, vpB = update.view.viewport;
            let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) {
            let min = this.view.contentHeight / this.view.scaleY + "px";
            this.dom.style.minHeight = min;
            if (this.domAfter) this.domAfter.style.minHeight = min;
        }
        if (this.view.state.facet($b3e9d73db824614e$var$unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
            if (this.domAfter) this.domAfter.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        let after = this.dom.nextSibling;
        if (detach) {
            this.dom.remove();
            if (this.domAfter) this.domAfter.remove();
        }
        let lineClasses = (0, $3ef527dddcdea745$export$34cb5241245008dd).iter(this.view.state.facet($b3e9d73db824614e$export$113bd64f27ac1172), this.view.viewport.from);
        let classSet = [];
        let contexts = this.gutters.map((gutter)=>new $b3e9d73db824614e$var$UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        for (let line of this.view.viewportLineBlocks){
            if (classSet.length) classSet = [];
            if (Array.isArray(line.type)) {
                let first = true;
                for (let b of line.type){
                    if (b.type == $b3e9d73db824614e$export$48808c686fe495c4.Text && first) {
                        $b3e9d73db824614e$var$advanceCursor(lineClasses, classSet, b.from);
                        for (let cx of contexts)cx.line(this.view, b, classSet);
                        first = false;
                    } else if (b.widget) for (let cx of contexts)cx.widget(this.view, b);
                }
            } else if (line.type == $b3e9d73db824614e$export$48808c686fe495c4.Text) {
                $b3e9d73db824614e$var$advanceCursor(lineClasses, classSet, line.from);
                for (let cx of contexts)cx.line(this.view, line, classSet);
            } else if (line.widget) for (let cx of contexts)cx.widget(this.view, line);
        }
        for (let cx of contexts)cx.finish();
        if (detach) {
            this.view.scrollDOM.insertBefore(this.dom, after);
            if (this.domAfter) this.view.scrollDOM.appendChild(this.domAfter);
        }
    }
    updateGutters(update) {
        let prev = update.startState.facet($b3e9d73db824614e$var$activeGutters), cur = update.state.facet($b3e9d73db824614e$var$activeGutters);
        let change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, $3ef527dddcdea745$export$34cb5241245008dd).eq(update.startState.facet($b3e9d73db824614e$export$113bd64f27ac1172), update.state.facet($b3e9d73db824614e$export$113bd64f27ac1172), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            for (let gutter of this.gutters)if (gutter.update(update)) change = true;
        } else {
            change = true;
            let gutters = [];
            for (let conf of cur){
                let known = prev.indexOf(conf);
                if (known < 0) gutters.push(new $b3e9d73db824614e$var$SingleGutterView(this.view, conf));
                else {
                    this.gutters[known].update(update);
                    gutters.push(this.gutters[known]);
                }
            }
            for (let g of this.gutters){
                g.dom.remove();
                if (gutters.indexOf(g) < 0) g.destroy();
            }
            for (let g of gutters)if (g.config.side == "after") this.getDOMAfter().appendChild(g.dom);
            else this.dom.appendChild(g.dom);
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        for (let view of this.gutters)view.destroy();
        this.dom.remove();
        if (this.domAfter) this.domAfter.remove();
    }
}, {
    provide: (plugin)=>$b3e9d73db824614e$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            let before = value.dom.offsetWidth * view.scaleX, after = value.domAfter ? value.domAfter.offsetWidth * view.scaleX : 0;
            return view.textDirection == $b3e9d73db824614e$export$cacd6541cfeeb6c1.LTR ? {
                left: before,
                right: after
            } : {
                right: before,
                left: after
            };
        })
});
function $b3e9d73db824614e$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $b3e9d73db824614e$var$advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class $b3e9d73db824614e$var$UpdateContext {
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.i = 0;
        this.cursor = (0, $3ef527dddcdea745$export$34cb5241245008dd).iter(gutter.markers, viewport.from);
    }
    addElement(view, block, markers) {
        let { gutter: gutter } = this, above = (block.top - this.height) / view.scaleY, height = block.height / view.scaleY;
        if (this.i == gutter.elements.length) {
            let newElt = new $b3e9d73db824614e$var$GutterElement(view, height, above, markers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, height, above, markers);
        this.height = block.bottom;
        this.i++;
    }
    line(view, line, extraMarkers) {
        let localMarkers = [];
        $b3e9d73db824614e$var$advanceCursor(this.cursor, localMarkers, line.from);
        if (extraMarkers.length) localMarkers = localMarkers.concat(extraMarkers);
        let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        let gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        this.addElement(view, line, localMarkers);
    }
    widget(view, block) {
        let marker = this.gutter.config.widgetMarker(view, block.widget, block), markers = marker ? [
            marker
        ] : null;
        for (let cls of view.state.facet($b3e9d73db824614e$export$6dd229d2c0925f7a)){
            let marker = cls(view, block.widget, block);
            if (marker) (markers || (markers = [])).push(marker);
        }
        if (markers) this.addElement(view, block, markers);
    }
    finish() {
        let gutter = this.gutter;
        while(gutter.elements.length > this.i){
            let last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
}
class $b3e9d73db824614e$var$SingleGutterView {
    constructor(view, config){
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(let prop in config.domEventHandlers)this.dom.addEventListener(prop, (event)=>{
            let target = event.target, y;
            if (target != this.dom && this.dom.contains(target)) {
                while(target.parentNode != this.dom)target = target.parentNode;
                let rect = target.getBoundingClientRect();
                y = (rect.top + rect.bottom) / 2;
            } else y = event.clientY;
            let line = view.lineBlockAtHeight(y - view.documentTop);
            if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
        });
        this.markers = $b3e9d73db824614e$var$asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new $b3e9d73db824614e$var$GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
    update(update) {
        let prevMarkers = this.markers;
        this.markers = $b3e9d73db824614e$var$asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            let updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        let vp = update.view.viewport;
        return !(0, $3ef527dddcdea745$export$34cb5241245008dd).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        for (let elt of this.elements)elt.destroy();
    }
}
class $b3e9d73db824614e$var$GutterElement {
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
    update(view, height, above, markers) {
        if (this.height != height) {
            this.height = height;
            this.dom.style.height = height + "px";
        }
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!$b3e9d73db824614e$var$sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        let cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(let iNew = 0, iOld = 0;;){
            let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                let c = marker.elementClass;
                if (c) cls += " " + c;
                for(let i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                let next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    let after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
}
function $b3e9d73db824614e$var$sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ const $b3e9d73db824614e$export$dd0c91e0a7121f5f = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
/**
Facet used to create markers in the line number gutter next to widgets.
*/ const $b3e9d73db824614e$export$510194e22d36ff6c = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $b3e9d73db824614e$var$lineNumberConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $3ef527dddcdea745$export$4e19c0b693794a7e)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                let result = Object.assign({}, a);
                for(let event in b){
                    let exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                }
                return result;
            }
        });
    }
});
class $b3e9d73db824614e$var$NumberMarker extends $b3e9d73db824614e$export$591ab4c909549043 {
    constructor(number){
        super();
        this.number = number;
    }
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
}
function $b3e9d73db824614e$var$formatNumber(view, number) {
    return view.state.facet($b3e9d73db824614e$var$lineNumberConfig).formatNumber(number, view.state);
}
const $b3e9d73db824614e$var$lineNumberGutter = /*@__PURE__*/ $b3e9d73db824614e$var$activeGutters.compute([
    $b3e9d73db824614e$var$lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet($b3e9d73db824614e$export$dd0c91e0a7121f5f);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new $b3e9d73db824614e$var$NumberMarker($b3e9d73db824614e$var$formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        widgetMarker: (view, widget, block)=>{
            for (let m of view.state.facet($b3e9d73db824614e$export$510194e22d36ff6c)){
                let result = m(view, widget, block);
                if (result) return result;
            }
            return null;
        },
        lineMarkerChange: (update)=>update.startState.facet($b3e9d73db824614e$var$lineNumberConfig) != update.state.facet($b3e9d73db824614e$var$lineNumberConfig),
        initialSpacer (view) {
            return new $b3e9d73db824614e$var$NumberMarker($b3e9d73db824614e$var$formatNumber(view, $b3e9d73db824614e$var$maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            let max = $b3e9d73db824614e$var$formatNumber(update.view, $b3e9d73db824614e$var$maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new $b3e9d73db824614e$var$NumberMarker(max);
        },
        domEventHandlers: state.facet($b3e9d73db824614e$var$lineNumberConfig).domEventHandlers,
        side: "before"
    }));
/**
Create a line number gutter extension.
*/ function $b3e9d73db824614e$export$1a8cf111682eaa7d(config = {}) {
    return [
        $b3e9d73db824614e$var$lineNumberConfig.of(config),
        $b3e9d73db824614e$export$ec15ef01b8fbae61(),
        $b3e9d73db824614e$var$lineNumberGutter
    ];
}
function $b3e9d73db824614e$var$maxLineNumber(lines) {
    let last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
const $b3e9d73db824614e$var$activeLineGutterMarker = /*@__PURE__*/ new class extends $b3e9d73db824614e$export$591ab4c909549043 {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
const $b3e9d73db824614e$var$activeLineGutterHighlighter = /*@__PURE__*/ $b3e9d73db824614e$export$113bd64f27ac1172.compute([
    "selection"
], (state)=>{
    let marks = [], last = -1;
    for (let range of state.selection.ranges){
        let linePos = state.doc.lineAt(range.head).from;
        if (linePos > last) {
            last = linePos;
            marks.push($b3e9d73db824614e$var$activeLineGutterMarker.range(linePos));
        }
    }
    return (0, $3ef527dddcdea745$export$34cb5241245008dd).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function $b3e9d73db824614e$export$93b52f08bb2c759c() {
    return $b3e9d73db824614e$var$activeLineGutterHighlighter;
}
function $b3e9d73db824614e$var$matcher(decorator) {
    return $b3e9d73db824614e$export$44d5eccfd62adda7.define((view)=>({
            decorations: decorator.createDeco(view),
            update (u) {
                this.decorations = decorator.updateDeco(u, this.decorations);
            }
        }), {
        decorations: (v)=>v.decorations
    });
}
const $b3e9d73db824614e$var$tabDeco = /*@__PURE__*/ $b3e9d73db824614e$export$10e30b733df217ea.mark({
    class: "cm-highlightTab"
});
const $b3e9d73db824614e$var$spaceDeco = /*@__PURE__*/ $b3e9d73db824614e$export$10e30b733df217ea.mark({
    class: "cm-highlightSpace"
});
const $b3e9d73db824614e$var$whitespaceHighlighter = /*@__PURE__*/ $b3e9d73db824614e$var$matcher(/*@__PURE__*/ new $b3e9d73db824614e$export$9b928b0ca20b25cb({
    regexp: /\t| /g,
    decoration: (match)=>match[0] == "\t" ? $b3e9d73db824614e$var$tabDeco : $b3e9d73db824614e$var$spaceDeco,
    boundary: /\S/
}));
/**
Returns an extension that highlights whitespace, adding a
`cm-highlightSpace` class to stretches of spaces, and a
`cm-highlightTab` class to individual tab characters. By default,
the former are shown as faint dots, and the latter as arrows.
*/ function $b3e9d73db824614e$export$beeff585f23bdb79() {
    return $b3e9d73db824614e$var$whitespaceHighlighter;
}
const $b3e9d73db824614e$var$trailingHighlighter = /*@__PURE__*/ $b3e9d73db824614e$var$matcher(/*@__PURE__*/ new $b3e9d73db824614e$export$9b928b0ca20b25cb({
    regexp: /\s+$/g,
    decoration: /*@__PURE__*/ $b3e9d73db824614e$export$10e30b733df217ea.mark({
        class: "cm-trailingSpace"
    })
}));
/**
Returns an extension that adds a `cm-trailingSpace` class to all
trailing whitespace.
*/ function $b3e9d73db824614e$export$6e66b0e142f44c26() {
    return $b3e9d73db824614e$var$trailingHighlighter;
}
/**
@internal
*/ const $b3e9d73db824614e$export$91afc2cf83e15b44 = {
    HeightMap: $b3e9d73db824614e$var$HeightMap,
    HeightOracle: $b3e9d73db824614e$var$HeightOracle,
    MeasuredHeights: $b3e9d73db824614e$var$MeasuredHeights,
    QueryType: $b3e9d73db824614e$var$QueryType,
    ChangedRange: $b3e9d73db824614e$var$ChangedRange,
    computeOrder: $b3e9d73db824614e$var$computeOrder,
    moveVisually: $b3e9d73db824614e$var$moveVisually,
    clearHeightChangeFlag: $b3e9d73db824614e$var$clearHeightChangeFlag,
    getHeightChangeFlag: ()=>$b3e9d73db824614e$var$heightChangeFlag
};




/**
The default maximum length of a `TreeBuffer` node.
*/ const $7c348856541b1efa$export$de305a849879ffa = 1024;
let $7c348856541b1efa$var$nextPropID = 0;
class $7c348856541b1efa$var$Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/**
Each [node type](#common.NodeType) or [individual tree](#common.Tree)
can have metadata associated with it in props. Instances of this
class represent prop names.
*/ class $7c348856541b1efa$export$b8034b9bc18acd90 {
    /**
    Create a new node prop type.
    */ constructor(config = {}){
        this.id = $7c348856541b1efa$var$nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
        this.combine = config.combine || null;
    }
    /**
    This is meant to be used with
    [`NodeSet.extend`](#common.NodeSet.extend) or
    [`LRParser.configure`](#lr.ParserConfig.props) to compute
    prop values for each node type in the set. Takes a [match
    object](#common.NodeType^match) or function that returns undefined
    if the node type doesn't get this prop, and the prop's value if
    it does.
    */ add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = $7c348856541b1efa$export$f06e977173f1857c.match(match);
        return (type)=>{
            let result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
}
/**
Prop that is used to describe matching delimiters. For opening
delimiters, this holds an array of node names (written as a
space-separated string when declaring this prop in a grammar)
for the node types of closing delimiters that match it.
*/ $7c348856541b1efa$export$b8034b9bc18acd90.closedBy = new $7c348856541b1efa$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
attached to closing delimiters, holding an array of node names
of types of matching opening delimiters.
*/ $7c348856541b1efa$export$b8034b9bc18acd90.openedBy = new $7c348856541b1efa$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Used to assign node types to groups (for example, all node
types that represent an expression could be tagged with an
`"Expression"` group).
*/ $7c348856541b1efa$export$b8034b9bc18acd90.group = new $7c348856541b1efa$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Attached to nodes to indicate these should be
[displayed](https://codemirror.net/docs/ref/#language.syntaxTree)
in a bidirectional text isolate, so that direction-neutral
characters on their sides don't incorrectly get associated with
surrounding text. You'll generally want to set this for nodes
that contain arbitrary text, like strings and comments, and for
nodes that appear _inside_ arbitrary text, like HTML tags. When
not given a value, in a grammar declaration, defaults to
`"auto"`.
*/ $7c348856541b1efa$export$b8034b9bc18acd90.isolate = new $7c348856541b1efa$export$b8034b9bc18acd90({
    deserialize: (value)=>{
        if (value && value != "rtl" && value != "ltr" && value != "auto") throw new RangeError("Invalid value for isolate: " + value);
        return value || "auto";
    }
});
/**
The hash of the [context](#lr.ContextTracker.constructor)
that the node was parsed in, if any. Used to limit reuse of
contextual nodes.
*/ $7c348856541b1efa$export$b8034b9bc18acd90.contextHash = new $7c348856541b1efa$export$b8034b9bc18acd90({
    perNode: true
});
/**
The distance beyond the end of the node that the tokenizer
looked ahead for any of the tokens inside the node. (The LR
parser only stores this when it is larger than 25, for
efficiency reasons.)
*/ $7c348856541b1efa$export$b8034b9bc18acd90.lookAhead = new $7c348856541b1efa$export$b8034b9bc18acd90({
    perNode: true
});
/**
This per-node prop is used to replace a given node, or part of a
node, with another tree. This is useful to include trees from
different languages in mixed-language parsers.
*/ $7c348856541b1efa$export$b8034b9bc18acd90.mounted = new $7c348856541b1efa$export$b8034b9bc18acd90({
    perNode: true
});
/**
A mounted tree, which can be [stored](#common.NodeProp^mounted) on
a tree node to indicate that parts of its content are
represented by another tree.
*/ class $7c348856541b1efa$export$358cdd8bd77577cc {
    constructor(/**
    The inner tree.
    */ tree, /**
    If this is null, this tree replaces the entire node (it will
    be included in the regular iteration instead of its host
    node). If not, only the given ranges are considered to be
    covered by this tree. This is used for trees that are mixed in
    a way that isn't strictly hierarchical. Such mounted trees are
    only entered by [`resolveInner`](#common.Tree.resolveInner)
    and [`enter`](#common.SyntaxNode.enter).
    */ overlay, /**
    The parser used to create this subtree.
    */ parser, /**
    [Indicates](#common.IterMode.EnterBracketed) that the nested
    content is delineated with some kind
    of bracket token.
    */ bracketed = false){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
        this.bracketed = bracketed;
    }
    /**
    @internal
    */ static get(tree) {
        return tree && tree.props && tree.props[$7c348856541b1efa$export$b8034b9bc18acd90.mounted.id];
    }
}
const $7c348856541b1efa$var$noProps = Object.create(null);
/**
Each node in a syntax tree has a node type associated with it.
*/ class $7c348856541b1efa$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name of the node type. Not necessarily unique, but if the
    grammar was written properly, different node types with the
    same name within a node set should play the same semantic
    role.
    */ name, /**
    @internal
    */ props, /**
    The id of this node in its set. Corresponds to the term ids
    used in the parser.
    */ id, /**
    @internal
    */ flags = 0){
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
    /**
    Define a node type.
    */ static define(spec) {
        let props = spec.props && spec.props.length ? Object.create(null) : $7c348856541b1efa$var$noProps;
        let flags = (spec.top ? 1 /* NodeFlag.Top */  : 0) | (spec.skipped ? 2 /* NodeFlag.Skipped */  : 0) | (spec.error ? 4 /* NodeFlag.Error */  : 0) | (spec.name == null ? 8 /* NodeFlag.Anonymous */  : 0);
        let type = new $7c348856541b1efa$export$f06e977173f1857c(spec.name || "", props, spec.id, flags);
        if (spec.props) for (let src of spec.props){
            if (!Array.isArray(src)) src = src(type);
            if (src) {
                if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                props[src[0].id] = src[1];
            }
        }
        return type;
    }
    /**
    Retrieves a node prop for this type. Will return `undefined` if
    the prop isn't present on this node.
    */ prop(prop) {
        return this.props[prop.id];
    }
    /**
    True when this is the top node of a grammar.
    */ get isTop() {
        return (this.flags & 1 /* NodeFlag.Top */ ) > 0;
    }
    /**
    True when this node is produced by a skip rule.
    */ get isSkipped() {
        return (this.flags & 2 /* NodeFlag.Skipped */ ) > 0;
    }
    /**
    Indicates whether this is an error node.
    */ get isError() {
        return (this.flags & 4 /* NodeFlag.Error */ ) > 0;
    }
    /**
    When true, this node type doesn't correspond to a user-declared
    named node, for example because it is used to cache repetition.
    */ get isAnonymous() {
        return (this.flags & 8 /* NodeFlag.Anonymous */ ) > 0;
    }
    /**
    Returns true when this node's name or one of its
    [groups](#common.NodeProp^group) matches the given string.
    */ is(name) {
        if (typeof name == 'string') {
            if (this.name == name) return true;
            let group = this.prop($7c348856541b1efa$export$b8034b9bc18acd90.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /**
    Create a function from node types to arbitrary values by
    specifying an object whose property names are node or
    [group](#common.NodeProp^group) names. Often useful with
    [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    names, separated by spaces, in a single property name to map
    multiple node names to a single value.
    */ static match(map) {
        let direct = Object.create(null);
        for(let prop in map)for (let name of prop.split(" "))direct[name] = map[prop];
        return (node)=>{
            for(let groups = node.prop($7c348856541b1efa$export$b8034b9bc18acd90.group), i = -1; i < (groups ? groups.length : 0); i++){
                let found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
}
/**
An empty dummy node type to use when no actual type is available.
*/ $7c348856541b1efa$export$f06e977173f1857c.none = new $7c348856541b1efa$export$f06e977173f1857c("", Object.create(null), 0, 8 /* NodeFlag.Anonymous */ );
/**
A node set holds a collection of node types. It is used to
compactly represent trees by storing their type ids, rather than a
full pointer to the type object, in a numeric array. Each parser
[has](#lr.LRParser.nodeSet) a node set, and [tree
buffers](#common.TreeBuffer) can only store collections of nodes
from the same set. A set can have a maximum of 2**16 (65536) node
types in it, so that the ids fit into 16-bit typed array slots.
*/ class $7c348856541b1efa$export$7fad5fb00d8de02c {
    /**
    Create a set with the given types. The `id` property of each
    type should correspond to its position within the array.
    */ constructor(/**
    The node types in this set, by id.
    */ types){
        this.types = types;
        for(let i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    /**
    Create a copy of this set with some node properties added. The
    arguments to this method can be created with
    [`NodeProp.add`](#common.NodeProp.add).
    */ extend(...props) {
        let newTypes = [];
        for (let type of this.types){
            let newProps = null;
            for (let source of props){
                let add = source(type);
                if (add) {
                    if (!newProps) newProps = Object.assign({}, type.props);
                    let value = add[1], prop = add[0];
                    if (prop.combine && prop.id in newProps) value = prop.combine(newProps[prop.id], value);
                    newProps[prop.id] = value;
                }
            }
            newTypes.push(newProps ? new $7c348856541b1efa$export$f06e977173f1857c(type.name, newProps, type.id, type.flags) : type);
        }
        return new $7c348856541b1efa$export$7fad5fb00d8de02c(newTypes);
    }
}
const $7c348856541b1efa$var$CachedNode = new WeakMap(), $7c348856541b1efa$var$CachedInnerNode = new WeakMap();
/**
Options that control iteration. Can be combined with the `|`
operator to enable multiple ones.
*/ var $7c348856541b1efa$export$b0e28367f55837aa;
(function(IterMode) {
    /**
    When enabled, iteration will only visit [`Tree`](#common.Tree)
    objects, not nodes packed into
    [`TreeBuffer`](#common.TreeBuffer)s.
    */ IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /**
    Enable this to make iteration include anonymous nodes (such as
    the nodes that wrap repeated grammar constructs into a balanced
    tree).
    */ IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /**
    By default, regular [mounted](#common.NodeProp^mounted) nodes
    replace their base node in iteration. Enable this to ignore them
    instead.
    */ IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /**
    This option only applies in
    [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    library to not enter mounted overlays if one covers the given
    position.
    */ IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
    /**
    When set, positions on the boundary of a mounted overlay tree
    that has its [`bracketed`](#common.NestedParse.bracketed) flag
    set will enter that tree regardless of side. Only supported in
    [`enter`](#common.SyntaxNode.enter), not in cursors.
    */ IterMode[IterMode["EnterBracketed"] = 16] = "EnterBracketed";
})($7c348856541b1efa$export$b0e28367f55837aa || ($7c348856541b1efa$export$b0e28367f55837aa = {}));
/**
A piece of syntax tree. There are two ways to approach these
trees: the way they are actually stored in memory, and the
convenient way.

Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
objects. By packing detail information into `TreeBuffer` leaf
nodes, the representation is made a lot more memory-efficient.

However, when you want to actually work with tree nodes, this
representation is very awkward, so most client code will want to
use the [`TreeCursor`](#common.TreeCursor) or
[`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
a view on some part of this data structure, and can be used to
move around to adjacent nodes.
*/ class $7c348856541b1efa$export$7fbedc92909ed28e {
    /**
    Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    */ constructor(/**
    The type of the top node.
    */ type, /**
    This node's child nodes.
    */ children, /**
    The positions (offsets relative to the start of this tree) of
    the children.
    */ positions, /**
    The total length of this tree
    */ length, /**
    Per-node [node props](#common.NodeProp) to associate with this node.
    */ props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /**
        @internal
        */ this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            for (let [prop, value] of props)this.props[typeof prop == "number" ? prop : prop.id] = value;
        }
    }
    /**
    @internal
    */ toString() {
        let mounted = $7c348856541b1efa$export$358cdd8bd77577cc.get(this);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        let children = "";
        for (let ch of this.children){
            let str = ch.toString();
            if (str) {
                if (children) children += ",";
                children += str;
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /**
    Get a [tree cursor](#common.TreeCursor) positioned at the top of
    the tree. Mode can be used to [control](#common.IterMode) which
    nodes the cursor visits.
    */ cursor(mode = 0) {
        return new $7c348856541b1efa$export$3ae4554f36e54a34(this.topNode, mode);
    }
    /**
    Get a [tree cursor](#common.TreeCursor) pointing into this tree
    at the given position and side (see
    [`moveTo`](#common.TreeCursor.moveTo).
    */ cursorAt(pos, side = 0, mode = 0) {
        let scope = $7c348856541b1efa$var$CachedNode.get(this) || this.topNode;
        let cursor = new $7c348856541b1efa$export$3ae4554f36e54a34(scope);
        cursor.moveTo(pos, side);
        $7c348856541b1efa$var$CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) object for the top of the
    tree.
    */ get topNode() {
        return new $7c348856541b1efa$var$TreeNode(this, 0, 0, null);
    }
    /**
    Get the [syntax node](#common.SyntaxNode) at the given position.
    If `side` is -1, this will move into nodes that end at the
    position. If 1, it'll move into nodes that start at the
    position. With 0, it'll only enter nodes that cover the position
    from both sides.
    
    Note that this will not enter
    [overlays](#common.MountedTree.overlay), and you often want
    [`resolveInner`](#common.Tree.resolveInner) instead.
    */ resolve(pos, side = 0) {
        let node = $7c348856541b1efa$var$resolveNode($7c348856541b1efa$var$CachedNode.get(this) || this.topNode, pos, side, false);
        $7c348856541b1efa$var$CachedNode.set(this, node);
        return node;
    }
    /**
    Like [`resolve`](#common.Tree.resolve), but will enter
    [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    pointing into the innermost overlaid tree at the given position
    (with parent links going through all parent structure, including
    the host trees).
    */ resolveInner(pos, side = 0) {
        let node = $7c348856541b1efa$var$resolveNode($7c348856541b1efa$var$CachedInnerNode.get(this) || this.topNode, pos, side, true);
        $7c348856541b1efa$var$CachedInnerNode.set(this, node);
        return node;
    }
    /**
    In some situations, it can be useful to iterate through all
    nodes around a position, including those in overlays that don't
    directly cover the position. This method gives you an iterator
    that will produce all nodes, from small to big, around the given
    position.
    */ resolveStack(pos, side = 0) {
        return $7c348856541b1efa$var$stackIterator(this, pos, side);
    }
    /**
    Iterate over the tree and its children, calling `enter` for any
    node that touches the `from`/`to` region (if given) before
    running over such a node's children, and `leave` (if given) when
    leaving the node. When `enter` returns `false`, that node will
    not have its children iterated over (or `leave` called).
    */ iterate(spec) {
        let { enter: enter, leave: leave, from: from = 0, to: to = this.length } = spec;
        let mode = spec.mode || 0, anon = (mode & $7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous) > 0;
        for(let c = this.cursor(mode | $7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous);;){
            let entered = false;
            if (c.from <= to && c.to >= from && (!anon && c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && (anon || !c.type.isAnonymous)) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /**
    Get the value of the given [node prop](#common.NodeProp) for this
    node. Works with both per-node and per-type props.
    */ prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /**
    Returns the node's [per-node props](#common.NodeProp.perNode) in a
    format that can be passed to the [`Tree`](#common.Tree)
    constructor.
    */ get propValues() {
        let result = [];
        if (this.props) for(let id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /**
    Balance the direct children of this tree, producing a copy of
    which may have children grouped into subtrees with type
    [`NodeType.none`](#common.NodeType^none).
    */ balance(config = {}) {
        return this.children.length <= 8 /* Balance.BranchFactor */  ? this : $7c348856541b1efa$var$balanceRange($7c348856541b1efa$export$f06e977173f1857c.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new $7c348856541b1efa$export$7fbedc92909ed28e(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new $7c348856541b1efa$export$7fbedc92909ed28e($7c348856541b1efa$export$f06e977173f1857c.none, children, positions, length)));
    }
    /**
    Build a tree from a postfix-ordered buffer of node information,
    or a cursor over such a buffer.
    */ static build(data) {
        return $7c348856541b1efa$var$buildTree(data);
    }
}
/**
The empty tree
*/ $7c348856541b1efa$export$7fbedc92909ed28e.empty = new $7c348856541b1efa$export$7fbedc92909ed28e($7c348856541b1efa$export$f06e977173f1857c.none, [], [], 0);
class $7c348856541b1efa$var$FlatBufferCursor {
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new $7c348856541b1efa$var$FlatBufferCursor(this.buffer, this.index);
    }
}
/**
Tree buffers contain (type, start, end, endIndex) quads for each
node. In such a buffer, nodes are stored in prefix order (parents
before children, with the endIndex of the parent indicating which
children belong to it).
*/ class $7c348856541b1efa$export$33300581b70be371 {
    /**
    Create a tree buffer.
    */ constructor(/**
    The buffer's content.
    */ buffer, /**
    The total length of the group of nodes in the buffer.
    */ length, /**
    The node set used in this buffer.
    */ set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
    /**
    @internal
    */ get type() {
        return $7c348856541b1efa$export$f06e977173f1857c.none;
    }
    /**
    @internal
    */ toString() {
        let result = [];
        for(let index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /**
    @internal
    */ childString(index) {
        let id = this.buffer[index], endIndex = this.buffer[index + 3];
        let type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        let children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /**
    @internal
    */ findChild(startIndex, endIndex, dir, pos, side) {
        let { buffer: buffer } = this, pick = -1;
        for(let i = startIndex; i != endIndex; i = buffer[i + 3])if ($7c348856541b1efa$var$checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /**
    @internal
    */ slice(startI, endI, from) {
        let b = this.buffer;
        let copy = new Uint16Array(endI - startI), len = 0;
        for(let i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            let to = copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
            len = Math.max(len, to);
        }
        return new $7c348856541b1efa$export$33300581b70be371(copy, len, this.set);
    }
}
function $7c348856541b1efa$var$checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Side.Before */ :
            return from < pos;
        case -1 /* Side.AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Side.Around */ :
            return from < pos && to > pos;
        case 1 /* Side.AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* Side.After */ :
            return to > pos;
        case 4 /* Side.DontCare */ :
            return true;
    }
}
function $7c348856541b1efa$var$resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        let parent = !overlays && node instanceof $7c348856541b1efa$var$TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    let mode = overlays ? 0 : $7c348856541b1efa$export$b0e28367f55837aa.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent)if (scan instanceof $7c348856541b1efa$var$TreeNode && scan.index < 0 && ((_a = parent.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent;
    }
    for(;;){
        let inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class $7c348856541b1efa$var$BaseNode {
    cursor(mode = 0) {
        return new $7c348856541b1efa$export$3ae4554f36e54a34(this, mode);
    }
    getChild(type, before = null, after = null) {
        let r = $7c348856541b1efa$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $7c348856541b1efa$var$getChildren(this, type, before, after);
    }
    resolve(pos, side = 0) {
        return $7c348856541b1efa$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $7c348856541b1efa$var$resolveNode(this, pos, side, true);
    }
    matchContext(context) {
        return $7c348856541b1efa$var$matchNodeContext(this.parent, context);
    }
    enterUnfinishedNodesBefore(pos) {
        let scan = this.childBefore(pos), node = this;
        while(scan){
            let last = scan.lastChild;
            if (!last || last.to != scan.to) break;
            if (last.type.isError && last.from == last.to) {
                node = scan;
                scan = last.prevSibling;
            } else scan = last;
        }
        return node;
    }
    get node() {
        return this;
    }
    get next() {
        return this.parent;
    }
}
class $7c348856541b1efa$var$TreeNode extends $7c348856541b1efa$var$BaseNode {
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        super();
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side, mode = 0) {
        for(let parent = this;;){
            for(let { children: children, positions: positions } = parent._tree, e = dir > 0 ? children.length : -1; i != e; i += dir){
                let next = children[i], start = positions[i] + parent.from, mounted;
                if (!(mode & $7c348856541b1efa$export$b0e28367f55837aa.EnterBracketed && next instanceof $7c348856541b1efa$export$7fbedc92909ed28e && (mounted = $7c348856541b1efa$export$358cdd8bd77577cc.get(next)) && !mounted.overlay && mounted.bracketed && pos >= start && pos <= start + next.length) && !$7c348856541b1efa$var$checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof $7c348856541b1efa$export$33300581b70be371) {
                    if (mode & $7c348856541b1efa$export$b0e28367f55837aa.ExcludeBuffers) continue;
                    let index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new $7c348856541b1efa$var$BufferNode(new $7c348856541b1efa$var$BufferContext(parent, next, i, start), null, index);
                } else if (mode & $7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous || !next.type.isAnonymous || $7c348856541b1efa$var$hasChild(next)) {
                    let mounted;
                    if (!(mode & $7c348856541b1efa$export$b0e28367f55837aa.IgnoreMounts) && (mounted = $7c348856541b1efa$export$358cdd8bd77577cc.get(next)) && !mounted.overlay) return new $7c348856541b1efa$var$TreeNode(mounted.tree, start, i, parent);
                    let inner = new $7c348856541b1efa$var$TreeNode(next, start, i, parent);
                    return mode & $7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side, mode);
                }
            }
            if (mode & $7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Side.Before */ );
    }
    prop(prop) {
        return this._tree.prop(prop);
    }
    enter(pos, side, mode = 0) {
        let mounted;
        if (!(mode & $7c348856541b1efa$export$b0e28367f55837aa.IgnoreOverlays) && (mounted = $7c348856541b1efa$export$358cdd8bd77577cc.get(this._tree)) && mounted.overlay) {
            let rPos = pos - this.from, enterBracketed = mode & $7c348856541b1efa$export$b0e28367f55837aa.EnterBracketed && mounted.bracketed;
            for (let { from: from, to: to } of mounted.overlay){
                if ((side > 0 || enterBracketed ? from <= rPos : from < rPos) && (side < 0 || enterBracketed ? to >= rPos : to > rPos)) return new $7c348856541b1efa$var$TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        let val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    /**
    @internal
    */ toString() {
        return this._tree.toString();
    }
}
function $7c348856541b1efa$var$getChildren(node, type, before, after) {
    let cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) for(let found = false; !found;){
        found = cur.type.is(before);
        if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function $7c348856541b1efa$var$matchNodeContext(node, context, i = context.length - 1) {
    for(let p = node; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class $7c348856541b1efa$var$BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class $7c348856541b1efa$var$BufferNode extends $7c348856541b1efa$var$BaseNode {
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(context, _parent, index){
        super();
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
    child(dir, pos, side) {
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new $7c348856541b1efa$var$BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Side.Before */ );
    }
    prop(prop) {
        return this.type.prop(prop);
    }
    enter(pos, side, mode = 0) {
        if (mode & $7c348856541b1efa$export$b0e28367f55837aa.ExcludeBuffers) return null;
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new $7c348856541b1efa$var$BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* Side.DontCare */ );
    }
    get nextSibling() {
        let { buffer: buffer } = this.context;
        let after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new $7c348856541b1efa$var$BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        let { buffer: buffer } = this.context;
        let parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new $7c348856541b1efa$var$BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
    }
    get tree() {
        return null;
    }
    toTree() {
        let children = [], positions = [];
        let { buffer: buffer } = this.context;
        let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            let from = buffer.buffer[this.index + 1];
            children.push(buffer.slice(startI, endI, from));
            positions.push(0);
        }
        return new $7c348856541b1efa$export$7fbedc92909ed28e(this.type, children, positions, this.to - this.from);
    }
    /**
    @internal
    */ toString() {
        return this.context.buffer.childString(this.index);
    }
}
function $7c348856541b1efa$var$iterStack(heads) {
    if (!heads.length) return null;
    let pick = 0, picked = heads[0];
    for(let i = 1; i < heads.length; i++){
        let node = heads[i];
        if (node.from > picked.from || node.to < picked.to) {
            picked = node;
            pick = i;
        }
    }
    let next = picked instanceof $7c348856541b1efa$var$TreeNode && picked.index < 0 ? null : picked.parent;
    let newHeads = heads.slice();
    if (next) newHeads[pick] = next;
    else newHeads.splice(pick, 1);
    return new $7c348856541b1efa$var$StackIterator(newHeads, picked);
}
class $7c348856541b1efa$var$StackIterator {
    constructor(heads, node){
        this.heads = heads;
        this.node = node;
    }
    get next() {
        return $7c348856541b1efa$var$iterStack(this.heads);
    }
}
function $7c348856541b1efa$var$stackIterator(tree, pos, side) {
    let inner = tree.resolveInner(pos, side), layers = null;
    for(let scan = inner instanceof $7c348856541b1efa$var$TreeNode ? inner : inner.context.parent; scan; scan = scan.parent)if (scan.index < 0) {
        let parent = scan.parent;
        (layers || (layers = [
            inner
        ])).push(parent.resolve(pos, side));
        scan = parent;
    } else {
        let mount = $7c348856541b1efa$export$358cdd8bd77577cc.get(scan.tree);
        // Relevant overlay branching off
        if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
            let root = new $7c348856541b1efa$var$TreeNode(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
            (layers || (layers = [
                inner
            ])).push($7c348856541b1efa$var$resolveNode(root, pos, side, false));
        }
    }
    return layers ? $7c348856541b1efa$var$iterStack(layers) : inner;
}
/**
A tree cursor object focuses on a given node in a syntax tree, and
allows you to move to adjacent nodes.
*/ class $7c348856541b1efa$export$3ae4554f36e54a34 {
    /**
    Shorthand for `.type.name`.
    */ get name() {
        return this.type.name;
    }
    /**
    @internal
    */ constructor(node, mode = 0){
        /**
        @internal
        */ this.buffer = null;
        this.stack = [];
        /**
        @internal
        */ this.index = 0;
        this.bufferNode = null;
        this.mode = mode & ~$7c348856541b1efa$export$b0e28367f55837aa.EnterBracketed;
        if (node instanceof $7c348856541b1efa$var$TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(let n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        let { start: start, buffer: buffer } = this.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    /**
    @internal
    */ yield(node) {
        if (!node) return false;
        if (node instanceof $7c348856541b1efa$var$TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /**
    @internal
    */ toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /**
    @internal
    */ enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        let { buffer: buffer } = this.buffer;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /**
    Move the cursor to this node's first child. When this returns
    false, the node has no child, and the cursor has not been moved.
    */ firstChild() {
        return this.enterChild(1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to this node's last child.
    */ lastChild() {
        return this.enterChild(-1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to the first child that ends after `pos`.
    */ childAfter(pos) {
        return this.enterChild(1, pos, 2 /* Side.After */ );
    }
    /**
    Move to the last child that starts before `pos`.
    */ childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Side.Before */ );
    }
    /**
    Move the cursor to the child around `pos`. If side is -1 the
    child may end at that position, when 1 it may start there. This
    will also enter [overlaid](#common.MountedTree.overlay)
    [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    set to false.
    */ enter(pos, side, mode = this.mode) {
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & $7c348856541b1efa$export$b0e28367f55837aa.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /**
    Move to the node's parent node, if this isn't the top node.
    */ parent() {
        if (!this.buffer) return this.yieldNode(this.mode & $7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        let parent = this.mode & $7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /**
    @internal
    */ sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode));
        let { buffer: buffer } = this.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            let parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
        } else {
            let after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode)) : false;
    }
    /**
    Move to this node's next sibling, if any.
    */ nextSibling() {
        return this.sibling(1);
    }
    /**
    Move to this node's previous sibling, if any.
    */ prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        let index, parent, { buffer: buffer } = this;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(let i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            ({ index: index, parent: parent } = buffer);
        } else ({ index: index, _parent: parent } = this._tree);
        for(; parent; { index: index, _parent: parent } = parent){
            if (index > -1) for(let i = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i != e; i += dir){
                let child = parent._tree.children[i];
                if (this.mode & $7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous || child instanceof $7c348856541b1efa$export$33300581b70be371 || !child.type.isAnonymous || $7c348856541b1efa$var$hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* Side.DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /**
    Move to the next node in a
    [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
    traversal, going from a node to its first child or, if the
    current node is empty or `enter` is false, its next sibling or
    the next sibling of the first parent node that has one.
    */ next(enter = true) {
        return this.move(1, enter);
    }
    /**
    Move to the next node in a last-to-first pre-order traversal. A
    node is followed by its last child or, if it has none, its
    previous sibling or the previous sibling of the first parent
    node that has one.
    */ prev(enter = true) {
        return this.move(-1, enter);
    }
    /**
    Move the cursor to the innermost node that covers `pos`. If
    `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    it will enter nodes that start at `pos`.
    */ moveTo(pos, side = 0) {
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) at the cursor's current
    position.
    */ get node() {
        if (!this.buffer) return this._tree;
        let cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(let index = this.index, d = this.stack.length; d >= 0;){
            for(let c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(let i = depth; i < this.stack.length; i++)result = new $7c348856541b1efa$var$BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new $7c348856541b1efa$var$BufferNode(this.buffer, result, this.index);
    }
    /**
    Get the [tree](#common.Tree) that represents the current node, if
    any. Will return null when the node is in a [tree
    buffer](#common.TreeBuffer).
    */ get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /**
    Iterate over the current node and all its descendants, calling
    `enter` when entering a node and `leave`, if given, when leaving
    one. When `enter` returns `false`, any children of that node are
    skipped, and `leave` isn't called for it.
    */ iterate(enter, leave) {
        for(let depth = 0;;){
            let mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (!depth) return;
                if (this.nextSibling()) break;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /**
    Test whether the current node matches a given context—a sequence
    of direct parent node names. Empty strings in the context array
    are treated as wildcards.
    */ matchContext(context) {
        if (!this.buffer) return $7c348856541b1efa$var$matchNodeContext(this.node.parent, context);
        let { buffer: buffer } = this.buffer, { types: types } = buffer.set;
        for(let i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return $7c348856541b1efa$var$matchNodeContext(this._tree, context, i);
            let type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
}
function $7c348856541b1efa$var$hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof $7c348856541b1efa$export$33300581b70be371 || !ch.type.isAnonymous || $7c348856541b1efa$var$hasChild(ch));
}
function $7c348856541b1efa$var$buildTree(data) {
    var _a;
    let { buffer: buffer, nodeSet: nodeSet, maxBufferLength: maxBufferLength = $7c348856541b1efa$export$de305a849879ffa, reused: reused = [], minRepeatType: minRepeatType = nodeSet.types.length } = data;
    let cursor = Array.isArray(buffer) ? new $7c348856541b1efa$var$FlatBufferCursor(buffer, buffer.length) : buffer;
    let types = nodeSet.types;
    let contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat, depth) {
        let { id: id, start: start, end: end, size: size } = cursor;
        let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
        if (size < 0) {
            cursor.next();
            if (size == -1 /* SpecialRecord.Reuse */ ) {
                let node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* SpecialRecord.ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* SpecialRecord.LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        let type = types[id], node, buffer;
        let startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            let data = new Uint16Array(buffer.size - buffer.skip);
            let endPos = cursor.pos - buffer.size, index = data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, data, index);
            node = new $7c348856541b1efa$export$33300581b70be371(data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            let endPos = cursor.pos - size;
            cursor.next();
            let localChildren = [], localPositions = [];
            let localInRepeat = id >= minRepeatType ? id : -1;
            let lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos){
                if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                    if (cursor.end <= lastEnd - maxBufferLength) {
                        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
                        lastGroup = localChildren.length;
                        lastEnd = cursor.end;
                    }
                    cursor.next();
                } else if (depth > 2500 /* CutOff.Depth */ ) takeFlatNode(start, endPos, localChildren, localPositions);
                else takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
            }
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                let make = makeBalanced(type, contextAtStart);
                node = $7c348856541b1efa$var$balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
        }
        children.push(node);
        positions.push(startPos);
    }
    function takeFlatNode(parentStart, minPos, children, positions) {
        let nodes = []; // Temporary, inverted array of leaf nodes found, with absolute positions
        let nodeCount = 0, stopAt = -1;
        while(cursor.pos > minPos){
            let { id: id, start: start, end: end, size: size } = cursor;
            if (size > 4) cursor.next();
            else if (stopAt > -1 && start < stopAt) break;
            else {
                if (stopAt < 0) stopAt = end - maxBufferLength;
                nodes.push(id, start, end);
                nodeCount++;
                cursor.next();
            }
        }
        if (nodeCount) {
            let buffer = new Uint16Array(nodeCount * 4);
            let start = nodes[nodes.length - 2];
            for(let i = nodes.length - 3, j = 0; i >= 0; i -= 3){
                buffer[j++] = nodes[i];
                buffer[j++] = nodes[i + 1] - start;
                buffer[j++] = nodes[i + 2] - start;
                buffer[j++] = j;
            }
            children.push(new $7c348856541b1efa$export$33300581b70be371(buffer, nodes[2] - start, nodeSet));
            positions.push(start - parentStart);
        }
    }
    function makeBalanced(type, contextHash) {
        return (children, positions, length)=>{
            let lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof $7c348856541b1efa$export$7fbedc92909ed28e) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop($7c348856541b1efa$export$b8034b9bc18acd90.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead, contextHash);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead, contextHash) {
        let localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to, contextHash));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length, lookAhead, contextHash, props) {
        if (contextHash) {
            let pair = [
                $7c348856541b1efa$export$b8034b9bc18acd90.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            let pair = [
                $7c348856541b1efa$export$b8034b9bc18acd90.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        return new $7c348856541b1efa$export$7fbedc92909ed28e(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        let fork = cursor.fork();
        let size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        let result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(let minPos = fork.pos - maxSize; fork.pos > minPos;){
            let nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            let startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            let localSkipped = fork.id >= minRepeatType ? 4 : 0;
            let nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* SpecialRecord.ContextChange */  || fork.size == -4 /* SpecialRecord.LookAhead */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        let { id: id, start: start, end: end, size: size } = cursor;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            let startIndex = index;
            if (size > 4) {
                let endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* SpecialRecord.ContextChange */ ) contextHash = id;
        else if (size == -4 /* SpecialRecord.LookAhead */ ) lookAhead = id;
        return index;
    }
    let children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
    let length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new $7c348856541b1efa$export$7fbedc92909ed28e(types[data.topID], children.reverse(), positions.reverse(), length);
}
const $7c348856541b1efa$var$nodeSizeCache = new WeakMap;
function $7c348856541b1efa$var$nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof $7c348856541b1efa$export$33300581b70be371 || node.type != balanceType) return 1;
    let size = $7c348856541b1efa$var$nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        for (let child of node.children){
            if (child.type != balanceType || !(child instanceof $7c348856541b1efa$export$7fbedc92909ed28e)) {
                size = 1;
                break;
            }
            size += $7c348856541b1efa$var$nodeSize(balanceType, child);
        }
        $7c348856541b1efa$var$nodeSizeCache.set(node, size);
    }
    return size;
}
function $7c348856541b1efa$var$balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    let total = 0;
    for(let i = from; i < to; i++)total += $7c348856541b1efa$var$nodeSize(balanceType, children[i]);
    let maxChild = Math.ceil(total * 1.5 / 8 /* Balance.BranchFactor */ );
    let localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(let i = from; i < to;){
            let groupFrom = i, groupStart = positions[i], groupSize = $7c348856541b1efa$var$nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                let nextSize = $7c348856541b1efa$var$nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    let only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                let length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push($7c348856541b1efa$var$balanceRange(balanceType, children, positions, groupFrom, i, groupStart, length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/**
Provides a way to associate values with pieces of trees. As long
as that part of the tree is reused, the associated values can be
retrieved from an updated tree.
*/ class $7c348856541b1efa$export$7f13b5dc44c541ae {
    constructor(){
        this.map = new WeakMap();
    }
    setBuffer(buffer, index, value) {
        let inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        let inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /**
    Set the value for this syntax node.
    */ set(node, value) {
        if (node instanceof $7c348856541b1efa$var$BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof $7c348856541b1efa$var$TreeNode) this.map.set(node.tree, value);
    }
    /**
    Retrieve value for this syntax node, if it exists in the map.
    */ get(node) {
        return node instanceof $7c348856541b1efa$var$BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof $7c348856541b1efa$var$TreeNode ? this.map.get(node.tree) : undefined;
    }
    /**
    Set the value for the node that a cursor currently points to.
    */ cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /**
    Retrieve the value for the node that a cursor currently points
    to.
    */ cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
}
/**
Tree fragments are used during [incremental
parsing](#common.Parser.startParse) to track parts of old trees
that can be reused in a new parse. An array of fragments is used
to track regions of an old tree whose nodes might be reused in new
parses. Use the static
[`applyChanges`](#common.TreeFragment^applyChanges) method to
update fragments for document changes.
*/ class $7c348856541b1efa$export$3ae2ede6dca97077 {
    /**
    Construct a tree fragment. You'll usually want to use
    [`addTree`](#common.TreeFragment^addTree) and
    [`applyChanges`](#common.TreeFragment^applyChanges) instead of
    calling this directly.
    */ constructor(/**
    The start of the unchanged range pointed to by this fragment.
    This refers to an offset in the _updated_ document (as opposed
    to the original tree).
    */ from, /**
    The end of the unchanged range.
    */ to, /**
    The tree that this fragment is based on.
    */ tree, /**
    The offset between the fragment's tree and the document that
    this fragment can be used against. Add this when going from
    document to tree positions, subtract it to go from tree to
    document positions.
    */ offset, openStart = false, openEnd = false){
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Open.Start */  : 0) | (openEnd ? 2 /* Open.End */  : 0);
    }
    /**
    Whether the start of the fragment represents the start of a
    parse, or the end of a change. (In the second case, it may not
    be safe to reuse some nodes at the start, depending on the
    parsing algorithm.)
    */ get openStart() {
        return (this.open & 1 /* Open.Start */ ) > 0;
    }
    /**
    Whether the end of the fragment represents the end of a
    full-document parse, or the start of a change.
    */ get openEnd() {
        return (this.open & 2 /* Open.End */ ) > 0;
    }
    /**
    Create a set of fragments from a freshly parsed tree, or update
    an existing set of fragments by replacing the ones that overlap
    with a tree with content from the new tree. When `partial` is
    true, the parse is treated as incomplete, and the resulting
    fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    true.
    */ static addTree(tree, fragments = [], partial = false) {
        let result = [
            new $7c348856541b1efa$export$3ae2ede6dca97077(0, tree.length, tree, 0, false, partial)
        ];
        for (let f of fragments)if (f.to > tree.length) result.push(f);
        return result;
    }
    /**
    Apply a set of edits to an array of fragments, removing or
    splitting fragments as necessary to remove edited ranges, and
    adjusting offsets for fragments that moved.
    */ static applyChanges(fragments, changes, minGap = 128) {
        if (!changes.length) return fragments;
        let result = [];
        let fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(let cI = 0, pos = 0, off = 0;; cI++){
            let nextC = cI < changes.length ? changes[cI] : null;
            let nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                let cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new $7c348856541b1efa$export$3ae2ede6dca97077(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
}
/**
A superclass that parsers should extend.
*/ class $7c348856541b1efa$export$7acfa6ed01010e37 {
    /**
    Start a parse, returning a [partial parse](#common.PartialParse)
    object. [`fragments`](#common.TreeFragment) can be passed in to
    make the parse incremental.
    
    By default, the entire input is parsed. You can pass `ranges`,
    which should be a sorted array of non-empty, non-overlapping
    ranges, to parse only those ranges. The tree returned in that
    case will start at `ranges[0].from`.
    */ startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new $7c348856541b1efa$var$StringInput(input);
        ranges = !ranges ? [
            new $7c348856541b1efa$var$Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new $7c348856541b1efa$var$Range(r.from, r.to)) : [
            new $7c348856541b1efa$var$Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /**
    Run a full parse, returning the resulting tree.
    */ parse(input, fragments, ranges) {
        let parse = this.startParse(input, fragments, ranges);
        for(;;){
            let done = parse.advance();
            if (done) return done;
        }
    }
}
class $7c348856541b1efa$var$StringInput {
    constructor(string){
        this.string = string;
    }
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
}
/**
Create a parse wrapper that, after the inner parse completes,
scans its tree for mixed language regions with the `nest`
function, runs the resulting [inner parses](#common.NestedParse),
and then [mounts](#common.NodeProp^mounted) their results onto the
tree.
*/ function $7c348856541b1efa$export$5dcc455959c76221(nest) {
    return (parse, input, fragments, ranges)=>new $7c348856541b1efa$var$MixedParse(parse, nest, input, fragments, ranges);
}
class $7c348856541b1efa$var$InnerParse {
    constructor(parser, parse, overlay, bracketed, target, from){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.bracketed = bracketed;
        this.target = target;
        this.from = from;
    }
}
function $7c348856541b1efa$var$checkRanges(ranges) {
    if (!ranges.length || ranges.some((r)=>r.from >= r.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
}
class $7c348856541b1efa$var$ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, bracketed, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.bracketed = bracketed;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
const $7c348856541b1efa$var$stoppedInner = new $7c348856541b1efa$export$b8034b9bc18acd90({
    perNode: true
});
class $7c348856541b1efa$var$MixedParse {
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
    advance() {
        if (this.baseParse) {
            let done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            if (this.stoppedAt != null) for (let inner of this.inner)inner.parse.stopAt(this.stoppedAt);
        }
        if (this.innerDone == this.inner.length) {
            let result = this.baseTree;
            if (this.stoppedAt != null) result = new $7c348856541b1efa$export$7fbedc92909ed28e(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    $7c348856541b1efa$var$stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        let inner = this.inner[this.innerDone], done = inner.parse.advance();
        if (done) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            let props = Object.assign(Object.create(null), inner.target.props);
            props[$7c348856541b1efa$export$b8034b9bc18acd90.mounted.id] = new $7c348856541b1efa$export$358cdd8bd77577cc(done, inner.overlay, inner.parser, inner.bracketed);
            inner.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        let pos = this.input.length;
        for(let i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(let i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        let fragmentCursor = new $7c348856541b1efa$var$FragmentCursor(this.fragments);
        let overlay = null;
        let covered = null;
        let cursor = new $7c348856541b1efa$export$3ae4554f36e54a34(new $7c348856541b1efa$var$TreeNode(this.baseTree, this.ranges[0].from, 0, null), $7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous | $7c348856541b1efa$export$b0e28367f55837aa.IgnoreMounts);
        scan: for(let nest, isCovered;;){
            let enter = true, range;
            if (this.stoppedAt != null && cursor.from >= this.stoppedAt) enter = false;
            else if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    let match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    if (match) for (let r of match.mount.overlay){
                        let from = r.from + match.pos, to = r.to + match.pos;
                        if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                            from: from,
                            to: to
                        });
                    }
                }
                enter = false;
            } else if (covered && (isCovered = $7c348856541b1efa$var$checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered != 2 /* Cover.Full */ ;
            else if (!cursor.type.isAnonymous && (nest = this.nest(cursor, this.input)) && (cursor.from < cursor.to || !nest.overlay)) {
                if (!cursor.tree) {
                    $7c348856541b1efa$var$materialize(cursor);
                    // materialize create one more level of nesting
                    // we need to add depth to active overlay for going backwards
                    if (overlay) overlay.depth++;
                    if (covered) covered.depth++;
                }
                let oldMounts = fragmentCursor.findMounts(cursor.from, nest.parser);
                if (typeof nest.overlay == "function") overlay = new $7c348856541b1efa$var$ActiveOverlay(nest.parser, nest.overlay, oldMounts, this.inner.length, cursor.from, !!nest.bracketed, cursor.tree, overlay);
                else {
                    let ranges = $7c348856541b1efa$var$punchRanges(this.ranges, nest.overlay || (cursor.from < cursor.to ? [
                        new $7c348856541b1efa$var$Range(cursor.from, cursor.to)
                    ] : []));
                    if (ranges.length) $7c348856541b1efa$var$checkRanges(ranges);
                    if (ranges.length || !nest.overlay) this.inner.push(new $7c348856541b1efa$var$InnerParse(nest.parser, ranges.length ? nest.parser.startParse(this.input, $7c348856541b1efa$var$enterFragments(oldMounts, ranges), ranges) : nest.parser.startParse(""), nest.overlay ? nest.overlay.map((r)=>new $7c348856541b1efa$var$Range(r.from - cursor.from, r.to - cursor.from)) : null, !!nest.bracketed, cursor.tree, ranges.length ? ranges[0].from : cursor.from));
                    if (!nest.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges: ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new $7c348856541b1efa$var$Range(cursor.from, cursor.to);
                if (range.from < range.to) {
                    let last = overlay.ranges.length - 1;
                    if (last >= 0 && overlay.ranges[last].to == range.from) overlay.ranges[last] = {
                        from: overlay.ranges[last].from,
                        to: range.to
                    };
                    else overlay.ranges.push(range);
                }
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) break scan;
                if (overlay && !--overlay.depth) {
                    let ranges = $7c348856541b1efa$var$punchRanges(this.ranges, overlay.ranges);
                    if (ranges.length) {
                        $7c348856541b1efa$var$checkRanges(ranges);
                        this.inner.splice(overlay.index, 0, new $7c348856541b1efa$var$InnerParse(overlay.parser, overlay.parser.startParse(this.input, $7c348856541b1efa$var$enterFragments(overlay.mounts, ranges), ranges), overlay.ranges.map((r)=>new $7c348856541b1efa$var$Range(r.from - overlay.start, r.to - overlay.start)), overlay.bracketed, overlay.target, ranges[0].from));
                    }
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
        }
    }
}
function $7c348856541b1efa$var$checkCover(covered, from, to) {
    for (let range of covered){
        if (range.from >= to) break;
        if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Cover.Full */  : 1 /* Cover.Partial */ ;
    }
    return 0 /* Cover.None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function $7c348856541b1efa$var$sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        let from = buf.buffer[startI + 1];
        nodes.push(buf.slice(startI, endI, from));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function $7c348856541b1efa$var$materialize(cursor) {
    let { node: node } = cursor, stack = [];
    let buffer = node.context.buffer;
    // Scan up to the nearest tree
    do {
        stack.push(cursor.index);
        cursor.parent();
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    let base = cursor.tree, i = base.children.indexOf(buffer);
    let buf = base.children[i], b = buf.buffer, newStack = [
        i
    ];
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length, stackPos) {
        let targetI = stack[stackPos];
        let children = [], positions = [];
        $7c348856541b1efa$var$sliceBuf(buf, startI, targetI, children, positions, innerOffset);
        let from = b[targetI + 1], to = b[targetI + 2];
        newStack.push(children.length);
        let child = stackPos ? split(targetI + 4, b[targetI + 3], buf.set.types[b[targetI]], from, to - from, stackPos - 1) : node.toTree();
        children.push(child);
        positions.push(from - innerOffset);
        $7c348856541b1efa$var$sliceBuf(buf, b[targetI + 3], endI, children, positions, innerOffset);
        return new $7c348856541b1efa$export$7fbedc92909ed28e(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, $7c348856541b1efa$export$f06e977173f1857c.none, 0, buf.length, stack.length - 1);
    // Move the cursor back to the target node
    for (let index of newStack){
        let tree = cursor.tree.children[index], pos = cursor.tree.positions[index];
        cursor.yield(new $7c348856541b1efa$var$TreeNode(tree, pos + cursor.from, index, cursor._tree));
    }
}
class $7c348856541b1efa$var$StructureCursor {
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor($7c348856541b1efa$export$b0e28367f55837aa.IncludeAnonymous | $7c348856541b1efa$export$b0e28367f55837aa.IgnoreMounts);
    }
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        let { cursor: cursor } = this, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, $7c348856541b1efa$export$b0e28367f55837aa.IgnoreOverlays | $7c348856541b1efa$export$b0e28367f55837aa.ExcludeBuffers)) ;
            else if (cursor.to <= pos) {
                if (!cursor.next(false)) this.done = true;
            } else break;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(let tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof $7c348856541b1efa$export$7fbedc92909ed28e) tree = tree.children[0];
            else break;
        }
        return false;
    }
}
class $7c348856541b1efa$var$FragmentCursor {
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            let first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop($7c348856541b1efa$var$stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new $7c348856541b1efa$var$StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            let frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop($7c348856541b1efa$var$stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new $7c348856541b1efa$var$StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        let result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(let pos = this.inner.cursor.node; pos; pos = pos.parent){
                let mount = (_a = pos.tree) === null || _a === void 0 ? void 0 : _a.prop($7c348856541b1efa$export$b8034b9bc18acd90.mounted);
                if (mount && mount.parser == parser) for(let i = this.fragI; i < this.fragments.length; i++){
                    let frag = this.fragments[i];
                    if (frag.from >= pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag: frag,
                        pos: pos.from - frag.offset,
                        mount: mount
                    });
                }
            }
        }
        return result;
    }
}
function $7c348856541b1efa$var$punchRanges(outer, ranges) {
    let copy = null, current = ranges;
    for(let i = 1, j = 0; i < outer.length; i++){
        let gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            let r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new $7c348856541b1efa$var$Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new $7c348856541b1efa$var$Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new $7c348856541b1efa$var$Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function $7c348856541b1efa$var$findCoverChanges(a, b, from, to) {
    let iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    let result = [];
    for(;;){
        let nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        let nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            let start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new $7c348856541b1efa$var$Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function $7c348856541b1efa$var$enterFragments(mounts, ranges) {
    let result = [];
    for (let { pos: pos, mount: mount, frag: frag } of mounts){
        let startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
        let from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
        if (mount.overlay) {
            let overlay = mount.overlay.map((r)=>new $7c348856541b1efa$var$Range(r.from + pos, r.to + pos));
            let changes = $7c348856541b1efa$var$findCoverChanges(ranges, overlay, from, to);
            for(let i = 0, pos = from;; i++){
                let last = i == changes.length, end = last ? to : changes[i].from;
                if (end > pos) result.push(new $7c348856541b1efa$export$3ae2ede6dca97077(pos, end, mount.tree, -startPos, frag.from >= pos || frag.openStart, frag.to <= end || frag.openEnd));
                if (last) break;
                pos = changes[i].to;
            }
        } else result.push(new $7c348856541b1efa$export$3ae2ede6dca97077(from, to, mount.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
    }
    return result;
}





let $f0075d67137b7b29$var$nextTagID = 0;
/**
Highlighting tags are markers that denote a highlighting category.
They are [associated](#highlight.styleTags) with parts of a syntax
tree by a language mode, and then mapped to an actual CSS style by
a [highlighter](#highlight.Highlighter).

Because syntax tree node types and highlight styles have to be
able to talk the same language, CodeMirror uses a mostly _closed_
[vocabulary](#highlight.tags) of syntax tags (as opposed to
traditional open string-based systems, which make it hard for
highlighting themes to cover all the tokens produced by the
various languages).

It _is_ possible to [define](#highlight.Tag^define) your own
highlighting tags for system-internal use (where you control both
the language package and the highlighter), but such tags will not
be picked up by regular highlighters (though you can derive them
from standard tags to allow highlighters to fall back to those).
*/ class $f0075d67137b7b29$export$3288d34c523a1192 {
    /**
    @internal
    */ constructor(/**
    The optional name of the base tag @internal
    */ name, /**
    The set of this tag and all its parent tags, starting with
    this one itself and sorted in order of decreasing specificity.
    */ set, /**
    The base unmodified tag that this one is based on, if it's
    modified @internal
    */ base, /**
    The modifiers applied to this.base @internal
    */ modified){
        this.name = name;
        this.set = set;
        this.base = base;
        this.modified = modified;
        /**
        @internal
        */ this.id = $f0075d67137b7b29$var$nextTagID++;
    }
    toString() {
        let { name: name } = this;
        for (let mod of this.modified)if (mod.name) name = `${mod.name}(${name})`;
        return name;
    }
    static define(nameOrParent, parent) {
        let name = typeof nameOrParent == "string" ? nameOrParent : "?";
        if (nameOrParent instanceof $f0075d67137b7b29$export$3288d34c523a1192) parent = nameOrParent;
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        let tag = new $f0075d67137b7b29$export$3288d34c523a1192(name, [], null, []);
        tag.set.push(tag);
        if (parent) for (let t of parent.set)tag.set.push(t);
        return tag;
    }
    /**
    Define a tag _modifier_, which is a function that, given a tag,
    will return a tag that is a subtag of the original. Applying the
    same modifier to a twice tag will return the same value (`m1(t1)
    == m1(t1)`) and applying multiple modifiers will, regardless or
    order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    
    When multiple modifiers are applied to a given base tag, each
    smaller set of modifiers is registered as a parent, so that for
    example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    `m1(m3(t1)`, and so on.
    */ static defineModifier(name) {
        let mod = new $f0075d67137b7b29$var$Modifier(name);
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return $f0075d67137b7b29$var$Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
}
let $f0075d67137b7b29$var$nextModifierID = 0;
class $f0075d67137b7b29$var$Modifier {
    constructor(name){
        this.name = name;
        this.instances = [];
        this.id = $f0075d67137b7b29$var$nextModifierID++;
    }
    static get(base, mods) {
        if (!mods.length) return base;
        let exists = mods[0].instances.find((t)=>t.base == base && $f0075d67137b7b29$var$sameArray(mods, t.modified));
        if (exists) return exists;
        let set = [], tag = new $f0075d67137b7b29$export$3288d34c523a1192(base.name, set, base, mods);
        for (let m of mods)m.instances.push(tag);
        let configs = $f0075d67137b7b29$var$powerSet(mods);
        for (let parent of base.set)if (!parent.modified.length) for (let config of configs)set.push($f0075d67137b7b29$var$Modifier.get(parent, config));
        return tag;
    }
}
function $f0075d67137b7b29$var$sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function $f0075d67137b7b29$var$powerSet(array) {
    let sets = [
        []
    ];
    for(let i = 0; i < array.length; i++)for(let j = 0, e = sets.length; j < e; j++)sets.push(sets[j].concat(array[i]));
    return sets.sort((a, b)=>b.length - a.length);
}
/**
This function is used to add a set of tags to a language syntax
via [`NodeSet.extend`](#common.NodeSet.extend) or
[`LRParser.configure`](#lr.LRParser.configure).

The argument object maps node selectors to [highlighting
tags](#highlight.Tag) or arrays of tags.

Node selectors may hold one or more (space-separated) node paths.
Such a path can be a [node name](#common.NodeType.name), or
multiple node names (or `*` wildcards) separated by slash
characters, as in `"Block/Declaration/VariableName"`. Such a path
matches the final node but only if its direct parent nodes are the
other nodes mentioned. A `*` in such a path matches any parent,
but only a single level—wildcards that match multiple parents
aren't supported, both for efficiency reasons and because Lezer
trees make it rather hard to reason about what they would match.)

A path can be ended with `/...` to indicate that the tag assigned
to the node should also apply to all child nodes, even if they
match their own style (by default, only the innermost style is
used).

When a path ends in `!`, as in `Attribute!`, no further matching
happens for the node's child nodes, and the entire node gets the
given style.

In this notation, node names that contain `/`, `!`, `*`, or `...`
must be quoted as JSON strings.

For example:

```javascript
parser.configure({props: [
  styleTags({
    // Style Number and BigNumber nodes
    "Number BigNumber": tags.number,
    // Style Escape nodes whose parent is String
    "String/Escape": tags.escape,
    // Style anything inside Attributes nodes
    "Attributes!": tags.meta,
    // Add a style to all content inside Italic nodes
    "Italic/...": tags.emphasis,
    // Style InvalidString nodes as both `string` and `invalid`
    "InvalidString": [tags.string, tags.invalid],
    // Style the node named "/" as punctuation
    '"/"': tags.punctuation
  })
]})
```
*/ function $f0075d67137b7b29$export$c537e79bb7b94295(spec) {
    let byName = Object.create(null);
    for(let prop in spec){
        let tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        for (let part of prop.split(" "))if (part) {
            let pieces = [], mode = 2 /* Mode.Normal */ , rest = part;
            for(let pos = 0;;){
                if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                    mode = 1 /* Mode.Inherit */ ;
                    break;
                }
                let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                if (!m) throw new RangeError("Invalid path: " + part);
                pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                pos += m[0].length;
                if (pos == part.length) break;
                let next = part[pos++];
                if (pos == part.length && next == "!") {
                    mode = 0 /* Mode.Opaque */ ;
                    break;
                }
                if (next != "/") throw new RangeError("Invalid path: " + part);
                rest = part.slice(pos);
            }
            let last = pieces.length - 1, inner = pieces[last];
            if (!inner) throw new RangeError("Invalid path: " + part);
            let rule = new $f0075d67137b7b29$var$Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
            byName[inner] = rule.sort(byName[inner]);
        }
    }
    return $f0075d67137b7b29$var$ruleNodeProp.add(byName);
}
const $f0075d67137b7b29$var$ruleNodeProp = new (0, $7c348856541b1efa$export$b8034b9bc18acd90)({
    combine (a, b) {
        let cur, root, take;
        while(a || b){
            if (!a || b && a.depth >= b.depth) {
                take = b;
                b = b.next;
            } else {
                take = a;
                a = a.next;
            }
            if (cur && cur.mode == take.mode && !take.context && !cur.context) continue;
            let copy = new $f0075d67137b7b29$var$Rule(take.tags, take.mode, take.context);
            if (cur) cur.next = copy;
            else root = copy;
            cur = copy;
        }
        return root;
    }
});
class $f0075d67137b7b29$var$Rule {
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
    get opaque() {
        return this.mode == 0 /* Mode.Opaque */ ;
    }
    get inherit() {
        return this.mode == 1 /* Mode.Inherit */ ;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
}
$f0075d67137b7b29$var$Rule.empty = new $f0075d67137b7b29$var$Rule([], 2 /* Mode.Normal */ , null);
/**
Define a [highlighter](#highlight.Highlighter) from an array of
tag/class pairs. Classes associated with more specific tags will
take precedence.
*/ function $f0075d67137b7b29$export$b7f6332ce20f80fb(tags, options) {
    let map = Object.create(null);
    for (let style of tags){
        if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
        else for (let tag of style.tag)map[tag.id] = style.class;
    }
    let { scope: scope, all: all = null } = options || {};
    return {
        style: (tags)=>{
            let cls = all;
            for (let tag of tags)for (let sub of tag.set){
                let tagClass = map[sub.id];
                if (tagClass) {
                    cls = cls ? cls + " " + tagClass : tagClass;
                    break;
                }
            }
            return cls;
        },
        scope: scope
    };
}
function $f0075d67137b7b29$var$highlightTags(highlighters, tags) {
    let result = null;
    for (let highlighter of highlighters){
        let value = highlighter.style(tags);
        if (value) result = result ? result + " " + value : value;
    }
    return result;
}
/**
Highlight the given [tree](#common.Tree) with the given
[highlighter](#highlight.Highlighter). Often, the higher-level
[`highlightCode`](#highlight.highlightCode) function is easier to
use.
*/ function $f0075d67137b7b29$export$af82b3d076119fad(tree, highlighter, /**
Assign styling to a region of the text. Will be called, in order
of position, for any ranges where more than zero classes apply.
`classes` is a space separated string of CSS classes.
*/ putStyle, /**
The start of the range to highlight.
*/ from = 0, /**
The end of the range.
*/ to = tree.length) {
    let builder = new $f0075d67137b7b29$var$HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
/**
Highlight the given tree with the given highlighter, calling
`putText` for every piece of text, either with a set of classes or
with the empty string when unstyled, and `putBreak` for every line
break.
*/ function $f0075d67137b7b29$export$e443a046766e80e8(code, tree, highlighter, putText, putBreak, from = 0, to = code.length) {
    let pos = from;
    function writeTo(p, classes) {
        if (p <= pos) return;
        for(let text = code.slice(pos, p), i = 0;;){
            let nextBreak = text.indexOf("\n", i);
            let upto = nextBreak < 0 ? text.length : nextBreak;
            if (upto > i) putText(text.slice(i, upto), classes);
            if (nextBreak < 0) break;
            putBreak();
            i = nextBreak + 1;
        }
        pos = p;
    }
    $f0075d67137b7b29$export$af82b3d076119fad(tree, highlighter, (from, to, classes)=>{
        writeTo(from, "");
        writeTo(to, classes);
    }, from, to);
    writeTo(to, "");
}
class $f0075d67137b7b29$var$HighlightBuilder {
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        let { type: type, from: start, to: end } = cursor;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        let cls = inheritedClass;
        let rule = $f0075d67137b7b29$export$1519d79cc79711ec(cursor) || $f0075d67137b7b29$var$Rule.empty;
        let tagCls = $f0075d67137b7b29$var$highlightTags(highlighters, rule.tags);
        if (tagCls) {
            if (cls) cls += " ";
            cls += tagCls;
            if (rule.mode == 1 /* Mode.Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
        }
        this.startSpan(Math.max(from, start), cls);
        if (rule.opaque) return;
        let mounted = cursor.tree && cursor.tree.prop((0, $7c348856541b1efa$export$b8034b9bc18acd90).mounted);
        if (mounted && mounted.overlay) {
            let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            let innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            let hasChild = cursor.firstChild();
            for(let i = 0, pos = start;; i++){
                let next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                let nextPos = next ? next.from + start : end;
                let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(rangeTo, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), "", innerHighlighters);
                    this.startSpan(Math.min(to, pos), cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            if (mounted) inheritedClass = "";
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
}
/**
Match a syntax node's [highlight rules](#highlight.styleTags). If
there's a match, return its set of tags, and whether it is
opaque (uses a `!`) or applies to all child nodes (`/...`).
*/ function $f0075d67137b7b29$export$1519d79cc79711ec(node) {
    let rule = node.type.prop($f0075d67137b7b29$var$ruleNodeProp);
    while(rule && rule.context && !node.matchContext(rule.context))rule = rule.next;
    return rule || null;
}
const $f0075d67137b7b29$var$t = $f0075d67137b7b29$export$3288d34c523a1192.define;
const $f0075d67137b7b29$var$comment = $f0075d67137b7b29$var$t(), $f0075d67137b7b29$var$name = $f0075d67137b7b29$var$t(), $f0075d67137b7b29$var$typeName = $f0075d67137b7b29$var$t($f0075d67137b7b29$var$name), $f0075d67137b7b29$var$propertyName = $f0075d67137b7b29$var$t($f0075d67137b7b29$var$name), $f0075d67137b7b29$var$literal = $f0075d67137b7b29$var$t(), $f0075d67137b7b29$var$string = $f0075d67137b7b29$var$t($f0075d67137b7b29$var$literal), $f0075d67137b7b29$var$number = $f0075d67137b7b29$var$t($f0075d67137b7b29$var$literal), $f0075d67137b7b29$var$content = $f0075d67137b7b29$var$t(), $f0075d67137b7b29$var$heading = $f0075d67137b7b29$var$t($f0075d67137b7b29$var$content), $f0075d67137b7b29$var$keyword = $f0075d67137b7b29$var$t(), $f0075d67137b7b29$var$operator = $f0075d67137b7b29$var$t(), $f0075d67137b7b29$var$punctuation = $f0075d67137b7b29$var$t(), $f0075d67137b7b29$var$bracket = $f0075d67137b7b29$var$t($f0075d67137b7b29$var$punctuation), $f0075d67137b7b29$var$meta = $f0075d67137b7b29$var$t();
/**
The default set of highlighting [tags](#highlight.Tag).

This collection is heavily biased towards programming languages,
and necessarily incomplete. A full ontology of syntactic
constructs would fill a stack of books, and be impractical to
write themes for. So try to make do with this set. If all else
fails, [open an
issue](https://github.com/codemirror/codemirror.next) to propose a
new tag, or [define](#highlight.Tag^define) a local custom tag for
your use case.

Note that it is not obligatory to always attach the most specific
tag possible to an element—if your grammar can't easily
distinguish a certain type of element (such as a local variable),
it is okay to style it as its more general variant (a variable).

For tags that extend some parent tag, the documentation links to
the parent.
*/ const $f0075d67137b7b29$export$8b7a896ae75accbf = {
    comment: /**
    A comment.
    */ $f0075d67137b7b29$var$comment,
    /**
    A line [comment](#highlight.tags.comment).
    */ lineComment: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$comment),
    /**
    A block [comment](#highlight.tags.comment).
    */ blockComment: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$comment),
    /**
    A documentation [comment](#highlight.tags.comment).
    */ docComment: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$comment),
    name: /**
    Any kind of identifier.
    */ $f0075d67137b7b29$var$name,
    /**
    The [name](#highlight.tags.name) of a variable.
    */ variableName: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$name),
    /**
    A type [name](#highlight.tags.name).
    */ typeName: $f0075d67137b7b29$var$typeName,
    /**
    A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    */ tagName: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$typeName),
    /**
    A property or field [name](#highlight.tags.name).
    */ propertyName: $f0075d67137b7b29$var$propertyName,
    /**
    An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    */ attributeName: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$propertyName),
    /**
    The [name](#highlight.tags.name) of a class.
    */ className: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$name),
    /**
    A label [name](#highlight.tags.name).
    */ labelName: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$name),
    /**
    A namespace [name](#highlight.tags.name).
    */ namespace: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$name),
    /**
    The [name](#highlight.tags.name) of a macro.
    */ macroName: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$name),
    literal: /**
    A literal value.
    */ $f0075d67137b7b29$var$literal,
    string: /**
    A string [literal](#highlight.tags.literal).
    */ $f0075d67137b7b29$var$string,
    /**
    A documentation [string](#highlight.tags.string).
    */ docString: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$string),
    /**
    A character literal (subtag of [string](#highlight.tags.string)).
    */ character: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$string),
    /**
    An attribute value (subtag of [string](#highlight.tags.string)).
    */ attributeValue: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$string),
    number: /**
    A number [literal](#highlight.tags.literal).
    */ $f0075d67137b7b29$var$number,
    /**
    An integer [number](#highlight.tags.number) literal.
    */ integer: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$number),
    /**
    A floating-point [number](#highlight.tags.number) literal.
    */ float: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$number),
    /**
    A boolean [literal](#highlight.tags.literal).
    */ bool: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$literal),
    /**
    Regular expression [literal](#highlight.tags.literal).
    */ regexp: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$literal),
    /**
    An escape [literal](#highlight.tags.literal), for example a
    backslash escape in a string.
    */ escape: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$literal),
    /**
    A color [literal](#highlight.tags.literal).
    */ color: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$literal),
    /**
    A URL [literal](#highlight.tags.literal).
    */ url: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$literal),
    keyword: /**
    A language keyword.
    */ $f0075d67137b7b29$var$keyword,
    /**
    The [keyword](#highlight.tags.keyword) for the self or this
    object.
    */ self: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$keyword),
    /**
    The [keyword](#highlight.tags.keyword) for null.
    */ null: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) denoting some atomic value.
    */ atom: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that represents a unit.
    */ unit: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$keyword),
    /**
    A modifier [keyword](#highlight.tags.keyword).
    */ modifier: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that acts as an operator.
    */ operatorKeyword: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$keyword),
    /**
    A control-flow related [keyword](#highlight.tags.keyword).
    */ controlKeyword: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that defines something.
    */ definitionKeyword: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) related to defining or
    interfacing with modules.
    */ moduleKeyword: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$keyword),
    operator: /**
    An operator.
    */ $f0075d67137b7b29$var$operator,
    /**
    An [operator](#highlight.tags.operator) that dereferences something.
    */ derefOperator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$operator),
    /**
    Arithmetic-related [operator](#highlight.tags.operator).
    */ arithmeticOperator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$operator),
    /**
    Logical [operator](#highlight.tags.operator).
    */ logicOperator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$operator),
    /**
    Bit [operator](#highlight.tags.operator).
    */ bitwiseOperator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$operator),
    /**
    Comparison [operator](#highlight.tags.operator).
    */ compareOperator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$operator),
    /**
    [Operator](#highlight.tags.operator) that updates its operand.
    */ updateOperator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$operator),
    /**
    [Operator](#highlight.tags.operator) that defines something.
    */ definitionOperator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$operator),
    /**
    Type-related [operator](#highlight.tags.operator).
    */ typeOperator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$operator),
    /**
    Control-flow [operator](#highlight.tags.operator).
    */ controlOperator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$operator),
    punctuation: /**
    Program or markup punctuation.
    */ $f0075d67137b7b29$var$punctuation,
    /**
    [Punctuation](#highlight.tags.punctuation) that separates
    things.
    */ separator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$punctuation),
    bracket: /**
    Bracket-style [punctuation](#highlight.tags.punctuation).
    */ $f0075d67137b7b29$var$bracket,
    /**
    Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    tokens).
    */ angleBracket: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$bracket),
    /**
    Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    tokens).
    */ squareBracket: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$bracket),
    /**
    Parentheses (usually `(` and `)` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ paren: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$bracket),
    /**
    Braces (usually `{` and `}` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ brace: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$bracket),
    content: /**
    Content, for example plain text in XML or markup documents.
    */ $f0075d67137b7b29$var$content,
    heading: /**
    [Content](#highlight.tags.content) that represents a heading.
    */ $f0075d67137b7b29$var$heading,
    /**
    A level 1 [heading](#highlight.tags.heading).
    */ heading1: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$heading),
    /**
    A level 2 [heading](#highlight.tags.heading).
    */ heading2: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$heading),
    /**
    A level 3 [heading](#highlight.tags.heading).
    */ heading3: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$heading),
    /**
    A level 4 [heading](#highlight.tags.heading).
    */ heading4: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$heading),
    /**
    A level 5 [heading](#highlight.tags.heading).
    */ heading5: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$heading),
    /**
    A level 6 [heading](#highlight.tags.heading).
    */ heading6: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$heading),
    /**
    A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
    */ contentSeparator: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$content),
    /**
    [Content](#highlight.tags.content) that represents a list.
    */ list: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$content),
    /**
    [Content](#highlight.tags.content) that represents a quote.
    */ quote: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$content),
    /**
    [Content](#highlight.tags.content) that is emphasized.
    */ emphasis: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$content),
    /**
    [Content](#highlight.tags.content) that is styled strong.
    */ strong: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$content),
    /**
    [Content](#highlight.tags.content) that is part of a link.
    */ link: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$content),
    /**
    [Content](#highlight.tags.content) that is styled as code or
    monospace.
    */ monospace: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$content),
    /**
    [Content](#highlight.tags.content) that has a strike-through
    style.
    */ strikethrough: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$content),
    /**
    Inserted text in a change-tracking format.
    */ inserted: $f0075d67137b7b29$var$t(),
    /**
    Deleted text.
    */ deleted: $f0075d67137b7b29$var$t(),
    /**
    Changed text.
    */ changed: $f0075d67137b7b29$var$t(),
    /**
    An invalid or unsyntactic element.
    */ invalid: $f0075d67137b7b29$var$t(),
    meta: /**
    Metadata or meta-instruction.
    */ $f0075d67137b7b29$var$meta,
    /**
    [Metadata](#highlight.tags.meta) that applies to the entire
    document.
    */ documentMeta: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$meta),
    /**
    [Metadata](#highlight.tags.meta) that annotates or adds
    attributes to a given syntactic element.
    */ annotation: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$meta),
    /**
    Processing instruction or preprocessor directive. Subtag of
    [meta](#highlight.tags.meta).
    */ processingInstruction: $f0075d67137b7b29$var$t($f0075d67137b7b29$var$meta),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that a
    given element is being defined. Expected to be used with the
    various [name](#highlight.tags.name) tags.
    */ definition: $f0075d67137b7b29$export$3288d34c523a1192.defineModifier("definition"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that
    something is constant. Mostly expected to be used with
    [variable names](#highlight.tags.variableName).
    */ constant: $f0075d67137b7b29$export$3288d34c523a1192.defineModifier("constant"),
    /**
    [Modifier](#highlight.Tag^defineModifier) used to indicate that
    a [variable](#highlight.tags.variableName) or [property
    name](#highlight.tags.propertyName) is being called or defined
    as a function.
    */ function: $f0075d67137b7b29$export$3288d34c523a1192.defineModifier("function"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that can be applied to
    [names](#highlight.tags.name) to indicate that they belong to
    the language's standard environment.
    */ standard: $f0075d67137b7b29$export$3288d34c523a1192.defineModifier("standard"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates a given
    [names](#highlight.tags.name) is local to some scope.
    */ local: $f0075d67137b7b29$export$3288d34c523a1192.defineModifier("local"),
    /**
    A generic variant [modifier](#highlight.Tag^defineModifier) that
    can be used to tag language-specific alternative variants of
    some common tag. It is recommended for themes to define special
    forms of at least the [string](#highlight.tags.string) and
    [variable name](#highlight.tags.variableName) tags, since those
    come up a lot.
    */ special: $f0075d67137b7b29$export$3288d34c523a1192.defineModifier("special")
};
for(let name in $f0075d67137b7b29$export$8b7a896ae75accbf){
    let val = $f0075d67137b7b29$export$8b7a896ae75accbf[name];
    if (val instanceof $f0075d67137b7b29$export$3288d34c523a1192) val.name = name;
}
/**
This is a highlighter that adds stable, predictable classes to
tokens, for styling with external CSS.

The following tags are mapped to their name prefixed with `"tok-"`
(for example `"tok-comment"`):

* [`link`](#highlight.tags.link)
* [`heading`](#highlight.tags.heading)
* [`emphasis`](#highlight.tags.emphasis)
* [`strong`](#highlight.tags.strong)
* [`keyword`](#highlight.tags.keyword)
* [`atom`](#highlight.tags.atom)
* [`bool`](#highlight.tags.bool)
* [`url`](#highlight.tags.url)
* [`labelName`](#highlight.tags.labelName)
* [`inserted`](#highlight.tags.inserted)
* [`deleted`](#highlight.tags.deleted)
* [`literal`](#highlight.tags.literal)
* [`string`](#highlight.tags.string)
* [`number`](#highlight.tags.number)
* [`variableName`](#highlight.tags.variableName)
* [`typeName`](#highlight.tags.typeName)
* [`namespace`](#highlight.tags.namespace)
* [`className`](#highlight.tags.className)
* [`macroName`](#highlight.tags.macroName)
* [`propertyName`](#highlight.tags.propertyName)
* [`operator`](#highlight.tags.operator)
* [`comment`](#highlight.tags.comment)
* [`meta`](#highlight.tags.meta)
* [`punctuation`](#highlight.tags.punctuation)
* [`invalid`](#highlight.tags.invalid)

In addition, these mappings are provided:

* [`regexp`](#highlight.tags.regexp),
  [`escape`](#highlight.tags.escape), and
  [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
  are mapped to `"tok-string2"`
* [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName2"`
* [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-local"`
* [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-definition"`
* [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
  to `"tok-propertyName tok-definition"`
*/ const $f0075d67137b7b29$export$bf3ffb24fb17216c = $f0075d67137b7b29$export$b7f6332ce20f80fb([
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.link,
        class: "tok-link"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.heading,
        class: "tok-heading"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.strong,
        class: "tok-strong"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.keyword,
        class: "tok-keyword"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.atom,
        class: "tok-atom"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.bool,
        class: "tok-bool"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.url,
        class: "tok-url"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.labelName,
        class: "tok-labelName"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.inserted,
        class: "tok-inserted"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.deleted,
        class: "tok-deleted"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.literal,
        class: "tok-literal"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.string,
        class: "tok-string"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.number,
        class: "tok-number"
    },
    {
        tag: [
            $f0075d67137b7b29$export$8b7a896ae75accbf.regexp,
            $f0075d67137b7b29$export$8b7a896ae75accbf.escape,
            $f0075d67137b7b29$export$8b7a896ae75accbf.special($f0075d67137b7b29$export$8b7a896ae75accbf.string)
        ],
        class: "tok-string2"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.variableName,
        class: "tok-variableName"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.local($f0075d67137b7b29$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.definition($f0075d67137b7b29$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.special($f0075d67137b7b29$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName2"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.definition($f0075d67137b7b29$export$8b7a896ae75accbf.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.typeName,
        class: "tok-typeName"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.namespace,
        class: "tok-namespace"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.className,
        class: "tok-className"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.macroName,
        class: "tok-macroName"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.operator,
        class: "tok-operator"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.comment,
        class: "tok-comment"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.meta,
        class: "tok-meta"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.invalid,
        class: "tok-invalid"
    },
    {
        tag: $f0075d67137b7b29$export$8b7a896ae75accbf.punctuation,
        class: "tok-punctuation"
    }
]);



var $d245ca63c4fe5041$var$_a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ const $d245ca63c4fe5041$export$27a2e78097f753f7 = /*@__PURE__*/ new (0, $7c348856541b1efa$export$b8034b9bc18acd90)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function $d245ca63c4fe5041$export$b57f683f43553b99(baseData) {
    return (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
Syntax node prop used to register sublanguages. Should be added to
the top level node type for the language.
*/ const $d245ca63c4fe5041$export$4afc6f37514bbb67 = /*@__PURE__*/ new (0, $7c348856541b1efa$export$b8034b9bc18acd90)();
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class $d245ca63c4fe5041$export$ce4fe1c9e6520c1a {
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, extraExtensions = [], /**
    A language name.
    */ name = ""){
        this.data = data;
        this.name = name;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, $3ef527dddcdea745$export$afa855cbfaff27f2).prototype.hasOwnProperty("tree")) Object.defineProperty((0, $3ef527dddcdea745$export$afa855cbfaff27f2).prototype, "tree", {
            get () {
                return $d245ca63c4fe5041$export$7fc98e56a4ca6be1(this);
            }
        });
        this.parser = parser;
        this.extension = [
            $d245ca63c4fe5041$export$789c912f57fe164c.of(this),
            (0, $3ef527dddcdea745$export$afa855cbfaff27f2).languageData.of((state, pos, side)=>{
                let top = $d245ca63c4fe5041$var$topNodeAt(state, pos, side), data = top.type.prop($d245ca63c4fe5041$export$27a2e78097f753f7);
                if (!data) return [];
                let base = state.facet(data), sub = top.type.prop($d245ca63c4fe5041$export$4afc6f37514bbb67);
                if (sub) {
                    let innerNode = top.resolve(pos - top.from, side);
                    for (let sublang of sub)if (sublang.test(innerNode, state)) {
                        let data = state.facet(sublang.facet);
                        return sublang.type == "replace" ? data : data.concat(base);
                    }
                }
                return base;
            })
        ].concat(extraExtensions);
    }
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos, side = -1) {
        return $d245ca63c4fe5041$var$topNodeAt(state, pos, side).type.prop($d245ca63c4fe5041$export$27a2e78097f753f7) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        let lang = state.facet($d245ca63c4fe5041$export$789c912f57fe164c);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        let result = [];
        let explore = (tree, from)=>{
            if (tree.prop($d245ca63c4fe5041$export$27a2e78097f753f7) == this.data) {
                result.push({
                    from: from,
                    to: from + tree.length
                });
                return;
            }
            let mount = tree.prop((0, $7c348856541b1efa$export$b8034b9bc18acd90).mounted);
            if (mount) {
                if (mount.tree.prop($d245ca63c4fe5041$export$27a2e78097f753f7) == this.data) {
                    if (mount.overlay) for (let r of mount.overlay)result.push({
                        from: r.from + from,
                        to: r.to + from
                    });
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    let size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(let i = 0; i < tree.children.length; i++){
                let ch = tree.children[i];
                if (ch instanceof (0, $7c348856541b1efa$export$7fbedc92909ed28e)) explore(ch, tree.positions[i] + from);
            }
        };
        explore($d245ca63c4fe5041$export$7fc98e56a4ca6be1(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
}
/**
@internal
*/ $d245ca63c4fe5041$export$ce4fe1c9e6520c1a.setState = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
function $d245ca63c4fe5041$var$topNodeAt(state, pos, side) {
    let topLang = state.facet($d245ca63c4fe5041$export$789c912f57fe164c), tree = $d245ca63c4fe5041$export$7fc98e56a4ca6be1(state).topNode;
    if (!topLang || topLang.allowsNesting) {
        for(let node = tree; node; node = node.enter(pos, side, (0, $7c348856541b1efa$export$b0e28367f55837aa).ExcludeBuffers | (0, $7c348856541b1efa$export$b0e28367f55837aa).EnterBracketed))if (node.type.isTop) tree = node;
    }
    return tree;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser).
*/ class $d245ca63c4fe5041$export$b243968d9fb6db03 extends $d245ca63c4fe5041$export$ce4fe1c9e6520c1a {
    constructor(data, parser, name){
        super(data, parser, [], name);
        this.parser = parser;
    }
    /**
    Define a language from a parser.
    */ static define(spec) {
        let data = $d245ca63c4fe5041$export$b57f683f43553b99(spec.languageData);
        return new $d245ca63c4fe5041$export$b243968d9fb6db03(data, spec.parser.configure({
            props: [
                $d245ca63c4fe5041$export$27a2e78097f753f7.add((type)=>type.isTop ? data : undefined)
            ]
        }), spec.name);
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser and optionally a new name.
    */ configure(options, name) {
        return new $d245ca63c4fe5041$export$b243968d9fb6db03(this.data, this.parser.configure(options), name || this.name);
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function $d245ca63c4fe5041$export$7fc98e56a4ca6be1(state) {
    let field = state.field($d245ca63c4fe5041$export$ce4fe1c9e6520c1a.state, false);
    return field ? field.tree : (0, $7c348856541b1efa$export$7fbedc92909ed28e).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function $d245ca63c4fe5041$export$8694796f3a52e973(state, upto, timeout = 50) {
    var _a;
    let parse = (_a = state.field($d245ca63c4fe5041$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    if (!parse) return null;
    let oldVieport = parse.viewport;
    parse.updateViewport({
        from: 0,
        to: upto
    });
    let result = parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
    parse.updateViewport(oldVieport);
    return result;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function $d245ca63c4fe5041$export$2c95b013b0941e86(state, upto = state.doc.length) {
    var _a;
    return ((_a = state.field($d245ca63c4fe5041$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function $d245ca63c4fe5041$export$b3bcb61c35026d72(view, upto = view.viewport.to, timeout = 100) {
    let success = $d245ca63c4fe5041$export$8694796f3a52e973(view.state, upto, timeout);
    if (success != $d245ca63c4fe5041$export$7fc98e56a4ca6be1(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function $d245ca63c4fe5041$export$23c0ee92d6189d3f(view) {
    var _a;
    return ((_a = view.plugin($d245ca63c4fe5041$var$parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
/**
Lezer-style
[`Input`](https://lezer.codemirror.net/docs/ref#common.Input)
object for a [`Text`](https://codemirror.net/6/docs/ref/#state.Text) object.
*/ class $d245ca63c4fe5041$export$78c262ab5af874ad {
    /**
    Create an input object for the given document.
    */ constructor(doc){
        this.doc = doc;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
    get length() {
        return this.doc.length;
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        let stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
}
let $d245ca63c4fe5041$var$currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class $d245ca63c4fe5041$export$3fcb7c01ff2a41fa {
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ fragments = [], /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new $d245ca63c4fe5041$export$3fcb7c01ff2a41fa(parser, state, [], (0, $7c348856541b1efa$export$7fbedc92909ed28e).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new $d245ca63c4fe5041$export$78c262ab5af874ad(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, $7c348856541b1efa$export$7fbedc92909ed28e).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                let endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                let done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, $7c348856541b1efa$export$3ae2ede6dca97077).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        let pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, $7c348856541b1efa$export$3ae2ede6dca97077).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        let prev = $d245ca63c4fe5041$var$currentContext;
        $d245ca63c4fe5041$var$currentContext = this;
        try {
            return f();
        } finally{
            $d245ca63c4fe5041$var$currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(let r; r = this.tempSkipped.pop();)fragments = $d245ca63c4fe5041$var$cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        let { fragments: fragments, tree: tree, treeLen: treeLen, viewport: viewport, skipped: skipped } = this;
        this.takeTree();
        if (!changes.empty) {
            let ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                }));
            fragments = (0, $7c348856541b1efa$export$3ae2ede6dca97077).applyChanges(fragments, ranges);
            tree = (0, $7c348856541b1efa$export$7fbedc92909ed28e).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                for (let r of this.skipped){
                    let from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                    if (from < to) skipped.push({
                        from: from,
                        to: to
                    });
                }
            }
        }
        return new $d245ca63c4fe5041$export$3fcb7c01ff2a41fa(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        let startLen = this.skipped.length;
        for(let i = 0; i < this.skipped.length; i++){
            let { from: from, to: to } = this.skipped[i];
            if (from < viewport.to && to > viewport.from) {
                this.fragments = $d245ca63c4fe5041$var$cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from: from,
            to: to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, $7c348856541b1efa$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                let from = ranges[0].from, to = ranges[ranges.length - 1].to;
                let parser = {
                    parsedPos: from,
                    advance () {
                        let cx = $d245ca63c4fe5041$var$currentContext;
                        if (cx) {
                            for (let r of ranges)cx.tempSkipped.push(r);
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, $7c348856541b1efa$export$7fbedc92909ed28e)((0, $7c348856541b1efa$export$f06e977173f1857c).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        let frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return $d245ca63c4fe5041$var$currentContext;
    }
}
function $d245ca63c4fe5041$var$cutFragments(fragments, from, to) {
    return (0, $7c348856541b1efa$export$3ae2ede6dca97077).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class $d245ca63c4fe5041$var$LanguageState {
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        let newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        let upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Work.Apply */ , upto)) newCx.takeTree();
        return new $d245ca63c4fe5041$var$LanguageState(newCx);
    }
    static init(state) {
        let vpTo = Math.min(3000 /* Work.InitViewport */ , state.doc.length);
        let parseState = $d245ca63c4fe5041$export$3fcb7c01ff2a41fa.create(state.facet($d245ca63c4fe5041$export$789c912f57fe164c).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Work.Apply */ , vpTo)) parseState.takeTree();
        return new $d245ca63c4fe5041$var$LanguageState(parseState);
    }
}
$d245ca63c4fe5041$export$ce4fe1c9e6520c1a.state = /*@__PURE__*/ (0, $3ef527dddcdea745$export$34381b1ce2130245).define({
    create: $d245ca63c4fe5041$var$LanguageState.init,
    update (value, tr) {
        for (let e of tr.effects)if (e.is($d245ca63c4fe5041$export$ce4fe1c9e6520c1a.setState)) return e.value;
        if (tr.startState.facet($d245ca63c4fe5041$export$789c912f57fe164c) != tr.state.facet($d245ca63c4fe5041$export$789c912f57fe164c)) return $d245ca63c4fe5041$var$LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
let $d245ca63c4fe5041$var$requestIdle = (callback)=>{
    let timeout = setTimeout(()=>callback(), 500 /* Work.MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") $d245ca63c4fe5041$var$requestIdle = (callback)=>{
    let idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* Work.MinPause */ 
        });
    }, 100 /* Work.MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
const $d245ca63c4fe5041$var$isInputPending = typeof navigator != "undefined" && (($d245ca63c4fe5041$var$_a = navigator.scheduling) === null || $d245ca63c4fe5041$var$_a === void 0 ? void 0 : $d245ca63c4fe5041$var$_a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
const $d245ca63c4fe5041$var$parseWorker = /*@__PURE__*/ (0, $b3e9d73db824614e$export$44d5eccfd62adda7).fromClass(class ParseWorker {
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
    update(update) {
        let cx = this.view.state.field($d245ca63c4fe5041$export$ce4fe1c9e6520c1a.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged || update.selectionSet) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* Work.ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        let { state: state } = this.view, field = state.field($d245ca63c4fe5041$export$ce4fe1c9e6520c1a.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = $d245ca63c4fe5041$var$requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        let now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* Work.ChunkTime */ ;
            this.chunkBudget = 3000 /* Work.ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        let { state: state, viewport: { to: vpTo } } = this.view, field = state.field($d245ca63c4fe5041$export$ce4fe1c9e6520c1a.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* Work.MaxParseAhead */ )) return;
        let endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Work.Slice */ , deadline && !$d245ca63c4fe5041$var$isInputPending ? Math.max(25 /* Work.MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        let done = field.context.work(()=>{
            return $d245ca63c4fe5041$var$isInputPending && $d245ca63c4fe5041$var$isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* Work.MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: $d245ca63c4fe5041$export$ce4fe1c9e6520c1a.setState.of(new $d245ca63c4fe5041$var$LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, $b3e9d73db824614e$export$f86b2a1a2ce291b3)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state. Used
by `Language` object's `extension` property (so you don't need to
manually wrap your languages in this). Can be used to access the
current language on a state.
*/ const $d245ca63c4fe5041$export$789c912f57fe164c = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: (language)=>[
            $d245ca63c4fe5041$export$ce4fe1c9e6520c1a.state,
            $d245ca63c4fe5041$var$parseWorker,
            (0, $b3e9d73db824614e$export$eece2fccabbb77c5).contentAttributes.compute([
                language
            ], (state)=>{
                let lang = state.facet(language);
                return lang && lang.name ? {
                    "data-language": lang.name
                } : {};
            })
        ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class $d245ca63c4fe5041$export$cbdefefa8a51dd3b {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ support = []){
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class $d245ca63c4fe5041$export$50ab82debf88f71 {
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        let { load: load, support: support } = spec;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new $d245ca63c4fe5041$export$50ab82debf88f71(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        for (let d of descs)if (d.filename && d.filename.test(filename)) return d;
        let ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            for (let d of descs)if (d.extensions.indexOf(ext[1]) > -1) return d;
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name, fuzzy = true) {
        name = name.toLowerCase();
        for (let d of descs)if (d.alias.some((a)=>a == name)) return d;
        if (fuzzy) for (let d of descs)for (let a of d.alias){
            let found = name.indexOf(a);
            if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d;
        }
        return null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth, as a column number (see
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)), at the start of a given
line. A return value of `null` indicates no indentation can be
determined, and the line should inherit the indentation of the one
above it. A return value of `undefined` defers to the next indent
service.
*/ const $d245ca63c4fe5041$export$5952625dce50d1f3 = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
/**
Facet for overriding the unit by which indentation happens. Should
be a string consisting entirely of the same whitespace character.
When not set, this defaults to 2 spaces.
*/ const $d245ca63c4fe5041$export$9e0d0c2ce4d3ceb5 = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        let unit = values[0];
        if (!unit || /\S/.test(unit) || Array.from(unit).some((e)=>e != unit[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return unit;
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function $d245ca63c4fe5041$export$ad3205d09311a797(state) {
    let unit = state.facet($d245ca63c4fe5041$export$9e0d0c2ce4d3ceb5);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function $d245ca63c4fe5041$export$db5a40e207b40576(state, cols) {
    let result = "", ts = state.tabSize, ch = state.facet($d245ca63c4fe5041$export$9e0d0c2ce4d3ceb5)[0];
    if (ch == "\t") {
        while(cols >= ts){
            result += "\t";
            cols -= ts;
        }
        ch = " ";
    }
    for(let i = 0; i < cols; i++)result += ch;
    return result;
}
/**
Get the indentation, as a column number, at the given position.
Will first consult any [indent services](https://codemirror.net/6/docs/ref/#language.indentService)
that are registered, and if none of those return an indentation,
this will check the syntax tree for the [indent node
prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp) and use that if found. Returns a
number when an indentation could be determined, and null
otherwise.
*/ function $d245ca63c4fe5041$export$a2d3c9dbce6d2211(context, pos) {
    if (context instanceof (0, $3ef527dddcdea745$export$afa855cbfaff27f2)) context = new $d245ca63c4fe5041$export$eeab79349cc2f7c8(context);
    for (let service of context.state.facet($d245ca63c4fe5041$export$5952625dce50d1f3)){
        let result = service(context, pos);
        if (result !== undefined) return result;
    }
    let tree = $d245ca63c4fe5041$export$7fc98e56a4ca6be1(context.state);
    return tree.length >= pos ? $d245ca63c4fe5041$var$syntaxIndentation(context, tree, pos) : null;
}
/**
Create a change set that auto-indents all lines touched by the
given document range.
*/ function $d245ca63c4fe5041$export$2fc72a4ad8b85e40(state, from, to) {
    let updated = Object.create(null);
    let context = new $d245ca63c4fe5041$export$eeab79349cc2f7c8(state, {
        overrideIndentation: (start)=>{
            var _a;
            return (_a = updated[start]) !== null && _a !== void 0 ? _a : -1;
        }
    });
    let changes = [];
    for(let pos = from; pos <= to;){
        let line = state.doc.lineAt(pos);
        pos = line.to + 1;
        let indent = $d245ca63c4fe5041$export$a2d3c9dbce6d2211(context, line.from);
        if (indent == null) continue;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = $d245ca63c4fe5041$export$db5a40e207b40576(state, indent);
        if (cur != norm) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    }
    return state.changes(changes);
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class $d245ca63c4fe5041$export$eeab79349cc2f7c8 {
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ options = {}){
        this.state = state;
        this.options = options;
        this.unit = $d245ca63c4fe5041$export$ad3205d09311a797(state);
    }
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos, bias = 1) {
        let line = this.state.doc.lineAt(pos);
        let { simulateBreak: simulateBreak, simulateDoubleBreak: simulateDoubleBreak } = this.options;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos, bias = 1) {
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        let { text: text, from: from } = this.lineAt(pos, bias);
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let result = this.countColumn(text, pos - from);
        let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line, pos = line.length) {
        return (0, $3ef527dddcdea745$export$20b4ab289374d0ac)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let override = this.options.overrideIndentation;
        if (override) {
            let overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number (see also
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)) or null, where null
indicates that no definitive indentation can be determined.
*/ const $d245ca63c4fe5041$export$72c7d4c52b3c6460 = /*@__PURE__*/ new (0, $7c348856541b1efa$export$b8034b9bc18acd90)();
// Compute the indentation for a given position from the syntax tree.
function $d245ca63c4fe5041$var$syntaxIndentation(cx, ast, pos) {
    let stack = ast.resolveStack(pos);
    let inner = ast.resolveInner(pos, -1).resolve(pos, 0).enterUnfinishedNodesBefore(pos);
    if (inner != stack.node) {
        let add = [];
        for(let cur = inner; cur && !(cur.from < stack.node.from || cur.to > stack.node.to || cur.from == stack.node.from && cur.type == stack.node.type); cur = cur.parent)add.push(cur);
        for(let i = add.length - 1; i >= 0; i--)stack = {
            node: add[i],
            next: stack
        };
    }
    return $d245ca63c4fe5041$var$indentFor(stack, cx, pos);
}
function $d245ca63c4fe5041$var$indentFor(stack, cx, pos) {
    for(let cur = stack; cur; cur = cur.next){
        let strategy = $d245ca63c4fe5041$var$indentStrategy(cur.node);
        if (strategy) return strategy($d245ca63c4fe5041$export$8aaeb0848a33f7c3.create(cx, pos, cur));
    }
    return 0;
}
function $d245ca63c4fe5041$var$ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function $d245ca63c4fe5041$var$indentStrategy(tree) {
    let strategy = tree.type.prop($d245ca63c4fe5041$export$72c7d4c52b3c6460);
    if (strategy) return strategy;
    let first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, $7c348856541b1efa$export$b8034b9bc18acd90).closedBy))) {
        let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>$d245ca63c4fe5041$var$delimitedStrategy(cx, true, 1, undefined, closed && !$d245ca63c4fe5041$var$ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? $d245ca63c4fe5041$var$topIndent : null;
}
function $d245ca63c4fe5041$var$topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class $d245ca63c4fe5041$export$8aaeb0848a33f7c3 extends $d245ca63c4fe5041$export$eeab79349cc2f7c8 {
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    @internal
    */ context){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.context = context;
    }
    /**
    The syntax tree node to which the indentation strategy
    applies.
    */ get node() {
        return this.context.node;
    }
    /**
    @internal
    */ static create(base, pos, context) {
        return new $d245ca63c4fe5041$export$8aaeb0848a33f7c3(base, pos, context);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        return this.baseIndentFor(this.node);
    }
    /**
    Get the indentation for the reference line of the given node
    (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
    */ baseIndentFor(node) {
        let line = this.state.doc.lineAt(node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            let atBreak = node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if ($d245ca63c4fe5041$var$isParent(atBreak, node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        return $d245ca63c4fe5041$var$indentFor(this.context.next, this.base, this.pos);
    }
}
function $d245ca63c4fe5041$var$isParent(parent, of) {
    for(let cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function $d245ca63c4fe5041$var$bracketedAligned(context) {
    let tree = context.node;
    let openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    let sim = context.options.simulateBreak;
    let openLine = context.state.doc.lineAt(openToken.from);
    let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(let pos = openToken.to;;){
        let next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) {
            if (next.from >= lineEnd) return null;
            let space = /^ */.exec(openLine.text.slice(openToken.to - openLine.from))[0].length;
            return {
                from: openToken.from,
                to: openToken.to + space
            };
        }
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function $d245ca63c4fe5041$export$60e82ea306899488({ closing: closing, align: align = true, units: units = 1 }) {
    return (context)=>$d245ca63c4fe5041$var$delimitedStrategy(context, align, units, closing);
}
function $d245ca63c4fe5041$var$delimitedStrategy(context, align, units, closing, closedAt) {
    let after = context.textAfter, space = after.match(/^\s*/)[0].length;
    let closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    let aligned = align ? $d245ca63c4fe5041$var$bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ const $d245ca63c4fe5041$export$4764c629086182f2 = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function $d245ca63c4fe5041$export$688ff433e7e7cc5c({ except: except, units: units = 1 } = {}) {
    return (context)=>{
        let matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
const $d245ca63c4fe5041$var$DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function $d245ca63c4fe5041$export$9bcaf6e2125ee117() {
    return (0, $3ef527dddcdea745$export$afa855cbfaff27f2).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        let rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        let doc = tr.newDoc, { head: head } = tr.newSelection.main, line = doc.lineAt(head);
        if (head > line.from + $d245ca63c4fe5041$var$DontIndentBeyond) return tr;
        let lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        let { state: state } = tr, last = -1, changes = [];
        for (let { head: head } of state.selection.ranges){
            let line = state.doc.lineAt(head);
            if (line.from == last) continue;
            last = line.from;
            let indent = $d245ca63c4fe5041$export$a2d3c9dbce6d2211(state, line.from);
            if (indent == null) continue;
            let cur = /^\s*/.exec(line.text)[0];
            let norm = $d245ca63c4fe5041$export$db5a40e207b40576(state, indent);
            if (cur != norm) changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
        return changes.length ? [
            tr,
            {
                changes: changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ const $d245ca63c4fe5041$export$40014037e3ef64a = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ const $d245ca63c4fe5041$export$9b075a85eb4377d8 = /*@__PURE__*/ new (0, $7c348856541b1efa$export$b8034b9bc18acd90)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function $d245ca63c4fe5041$export$48672beae16a681b(node) {
    let first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function $d245ca63c4fe5041$var$syntaxFolding(state, start, end) {
    let tree = $d245ca63c4fe5041$export$7fc98e56a4ca6be1(state);
    if (tree.length < end) return null;
    let stack = tree.resolveStack(end, 1);
    let found = null;
    for(let iter = stack; iter; iter = iter.next){
        let cur = iter.node;
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        let prop = cur.type.prop($d245ca63c4fe5041$export$9b075a85eb4377d8);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !$d245ca63c4fe5041$var$isUnfinished(cur))) {
            let value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function $d245ca63c4fe5041$var$isUnfinished(node) {
    let ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function $d245ca63c4fe5041$export$cbe8a3d55245b07d(state, lineStart, lineEnd) {
    for (let service of state.facet($d245ca63c4fe5041$export$40014037e3ef64a)){
        let result = service(state, lineStart, lineEnd);
        if (result) return result;
    }
    return $d245ca63c4fe5041$var$syntaxFolding(state, lineStart, lineEnd);
}
function $d245ca63c4fe5041$var$mapRange(range, mapping) {
    let from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from: from,
        to: to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ const $d245ca63c4fe5041$export$a123efe007ad265 = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define({
    map: $d245ca63c4fe5041$var$mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ const $d245ca63c4fe5041$export$bf2507dc398fc1ab = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define({
    map: $d245ca63c4fe5041$var$mapRange
});
function $d245ca63c4fe5041$var$selectedLines(view) {
    let lines = [];
    for (let { head: head } of view.state.selection.ranges){
        if (lines.some((l)=>l.from <= head && l.to >= head)) continue;
        lines.push(view.lineBlockAt(head));
    }
    return lines;
}
/**
The state field that stores the folded ranges (as a [decoration
set](https://codemirror.net/6/docs/ref/#view.DecorationSet)). Can be passed to
[`EditorState.toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) and
[`fromJSON`](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) to serialize the fold
state.
*/ const $d245ca63c4fe5041$export$6955fe1f7c578abb = /*@__PURE__*/ (0, $3ef527dddcdea745$export$34381b1ce2130245).define({
    create () {
        return (0, $b3e9d73db824614e$export$10e30b733df217ea).none;
    },
    update (folded, tr) {
        if (tr.isUserEvent("delete")) tr.changes.iterChangedRanges((fromA, toA)=>folded = $d245ca63c4fe5041$var$clearTouchedFolds(folded, fromA, toA));
        folded = folded.map(tr.changes);
        let rangesToFold = [];
        for (let e of tr.effects){
            if (e.is($d245ca63c4fe5041$export$a123efe007ad265) && !$d245ca63c4fe5041$var$foldExists(folded, e.value.from, e.value.to)) rangesToFold.push(e.value);
            else if (e.is($d245ca63c4fe5041$export$bf2507dc398fc1ab)) folded = folded.update({
                filter: (from, to)=>e.value.from != from || e.value.to != to,
                filterFrom: e.value.from,
                filterTo: e.value.to
            });
        }
        if (rangesToFold.length) {
            let { preparePlaceholder: preparePlaceholder } = tr.state.facet($d245ca63c4fe5041$var$foldConfig);
            let decorations = rangesToFold.map((value)=>{
                let widget = !preparePlaceholder ? $d245ca63c4fe5041$var$foldWidget : (0, $b3e9d73db824614e$export$10e30b733df217ea).replace({
                    widget: new $d245ca63c4fe5041$var$PreparedFoldWidget(preparePlaceholder(tr.state, value))
                });
                return widget.range(value.from, value.to);
            });
            folded = folded.update({
                add: decorations
            });
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) folded = $d245ca63c4fe5041$var$clearTouchedFolds(folded, tr.selection.main.head);
        return folded;
    },
    provide: (f)=>(0, $b3e9d73db824614e$export$eece2fccabbb77c5).decorations.from(f),
    toJSON (folded, state) {
        let ranges = [];
        folded.between(0, state.doc.length, (from, to)=>{
            ranges.push(from, to);
        });
        return ranges;
    },
    fromJSON (value) {
        if (!Array.isArray(value) || value.length % 2) throw new RangeError("Invalid JSON for fold state");
        let ranges = [];
        for(let i = 0; i < value.length;){
            let from = value[i++], to = value[i++];
            if (typeof from != "number" || typeof to != "number") throw new RangeError("Invalid JSON for fold state");
            ranges.push($d245ca63c4fe5041$var$foldWidget.range(from, to));
        }
        return (0, $b3e9d73db824614e$export$10e30b733df217ea).set(ranges, true);
    }
});
function $d245ca63c4fe5041$var$clearTouchedFolds(folded, from, to = from) {
    let touched = false;
    folded.between(from, to, (a, b)=>{
        if (a < to && b > from) touched = true;
    });
    return !touched ? folded : folded.update({
        filterFrom: from,
        filterTo: to,
        filter: (a, b)=>a >= to || b <= from
    });
}
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function $d245ca63c4fe5041$export$2b3c199812391e05(state) {
    return state.field($d245ca63c4fe5041$export$6955fe1f7c578abb, false) || (0, $3ef527dddcdea745$export$34cb5241245008dd).empty;
}
function $d245ca63c4fe5041$var$findFold(state, from, to) {
    var _a;
    let found = null;
    (_a = state.field($d245ca63c4fe5041$export$6955fe1f7c578abb, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from: from,
            to: to
        };
    });
    return found;
}
function $d245ca63c4fe5041$var$foldExists(folded, from, to) {
    let found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function $d245ca63c4fe5041$var$maybeEnable(state, other) {
    return state.field($d245ca63c4fe5041$export$6955fe1f7c578abb, false) ? other : other.concat((0, $3ef527dddcdea745$export$95000d4efaa4321f).appendConfig.of($d245ca63c4fe5041$export$2c875b83a85d0f31()));
}
/**
Fold the lines that are selected, if possible.
*/ const $d245ca63c4fe5041$export$52e96be2adbea02a = (view)=>{
    for (let line of $d245ca63c4fe5041$var$selectedLines(view)){
        let range = $d245ca63c4fe5041$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (range) {
            view.dispatch({
                effects: $d245ca63c4fe5041$var$maybeEnable(view.state, [
                    $d245ca63c4fe5041$export$a123efe007ad265.of(range),
                    $d245ca63c4fe5041$var$announceFold(view, range)
                ])
            });
            return true;
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ const $d245ca63c4fe5041$export$f4cd5e9f2c073861 = (view)=>{
    if (!view.state.field($d245ca63c4fe5041$export$6955fe1f7c578abb, false)) return false;
    let effects = [];
    for (let line of $d245ca63c4fe5041$var$selectedLines(view)){
        let folded = $d245ca63c4fe5041$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($d245ca63c4fe5041$export$bf2507dc398fc1ab.of(folded), $d245ca63c4fe5041$var$announceFold(view, folded, false));
    }
    if (effects.length) view.dispatch({
        effects: effects
    });
    return effects.length > 0;
};
function $d245ca63c4fe5041$var$announceFold(view, range, fold = true) {
    let lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, $b3e9d73db824614e$export$eece2fccabbb77c5).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ const $d245ca63c4fe5041$export$5396d9eaf1c0ba76 = (view)=>{
    let { state: state } = view, effects = [];
    for(let pos = 0; pos < state.doc.length;){
        let line = view.lineBlockAt(pos), range = $d245ca63c4fe5041$export$cbe8a3d55245b07d(state, line.from, line.to);
        if (range) effects.push($d245ca63c4fe5041$export$a123efe007ad265.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: $d245ca63c4fe5041$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ const $d245ca63c4fe5041$export$5671b24df569b27d = (view)=>{
    let field = view.state.field($d245ca63c4fe5041$export$6955fe1f7c578abb, false);
    if (!field || !field.size) return false;
    let effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push($d245ca63c4fe5041$export$bf2507dc398fc1ab.of({
            from: from,
            to: to
        }));
    });
    view.dispatch({
        effects: effects
    });
    return true;
};
// Find the foldable region containing the given line, if one exists
function $d245ca63c4fe5041$var$foldableContainer(view, lineBlock) {
    // Look backwards through line blocks until we find a foldable region that
    // intersects with the line
    for(let line = lineBlock;;){
        let foldableRegion = $d245ca63c4fe5041$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (foldableRegion && foldableRegion.to > lineBlock.from) return foldableRegion;
        if (!line.from) return null;
        line = view.lineBlockAt(line.from - 1);
    }
}
/**
Toggle folding at cursors. Unfolds if there is an existing fold
starting in that line, tries to find a foldable range around it
otherwise.
*/ const $d245ca63c4fe5041$export$b23e83f59d68c8f1 = (view)=>{
    let effects = [];
    for (let line of $d245ca63c4fe5041$var$selectedLines(view)){
        let folded = $d245ca63c4fe5041$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($d245ca63c4fe5041$export$bf2507dc398fc1ab.of(folded), $d245ca63c4fe5041$var$announceFold(view, folded, false));
        else {
            let foldRange = $d245ca63c4fe5041$var$foldableContainer(view, line);
            if (foldRange) effects.push($d245ca63c4fe5041$export$a123efe007ad265.of(foldRange), $d245ca63c4fe5041$var$announceFold(view, foldRange));
        }
    }
    if (effects.length > 0) view.dispatch({
        effects: $d245ca63c4fe5041$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ const $d245ca63c4fe5041$export$39c52376a8936d67 = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: $d245ca63c4fe5041$export$52e96be2adbea02a
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: $d245ca63c4fe5041$export$f4cd5e9f2c073861
    },
    {
        key: "Ctrl-Alt-[",
        run: $d245ca63c4fe5041$export$5396d9eaf1c0ba76
    },
    {
        key: "Ctrl-Alt-]",
        run: $d245ca63c4fe5041$export$5671b24df569b27d
    }
];
const $d245ca63c4fe5041$var$defaultConfig = {
    placeholderDOM: null,
    preparePlaceholder: null,
    placeholderText: "\u2026"
};
const $d245ca63c4fe5041$var$foldConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $3ef527dddcdea745$export$4e19c0b693794a7e)(values, $d245ca63c4fe5041$var$defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function $d245ca63c4fe5041$export$2c875b83a85d0f31(config) {
    let result = [
        $d245ca63c4fe5041$export$6955fe1f7c578abb,
        $d245ca63c4fe5041$var$baseTheme$1
    ];
    if (config) result.push($d245ca63c4fe5041$var$foldConfig.of(config));
    return result;
}
function $d245ca63c4fe5041$var$widgetToDOM(view, prepared) {
    let { state: state } = view, conf = state.facet($d245ca63c4fe5041$var$foldConfig);
    let onclick = (event)=>{
        let line = view.lineBlockAt(view.posAtDOM(event.target));
        let folded = $d245ca63c4fe5041$var$findFold(view.state, line.from, line.to);
        if (folded) view.dispatch({
            effects: $d245ca63c4fe5041$export$bf2507dc398fc1ab.of(folded)
        });
        event.preventDefault();
    };
    if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick, prepared);
    let element = document.createElement("span");
    element.textContent = conf.placeholderText;
    element.setAttribute("aria-label", state.phrase("folded code"));
    element.title = state.phrase("unfold");
    element.className = "cm-foldPlaceholder";
    element.onclick = onclick;
    return element;
}
const $d245ca63c4fe5041$var$foldWidget = /*@__PURE__*/ (0, $b3e9d73db824614e$export$10e30b733df217ea).replace({
    widget: /*@__PURE__*/ new class extends (0, $b3e9d73db824614e$export$95cdd842edb044c5) {
        toDOM(view) {
            return $d245ca63c4fe5041$var$widgetToDOM(view, null);
        }
    }
});
class $d245ca63c4fe5041$var$PreparedFoldWidget extends (0, $b3e9d73db824614e$export$95cdd842edb044c5) {
    constructor(value){
        super();
        this.value = value;
    }
    eq(other) {
        return this.value == other.value;
    }
    toDOM(view) {
        return $d245ca63c4fe5041$var$widgetToDOM(view, this.value);
    }
}
const $d245ca63c4fe5041$var$foldGutterDefaults = {
    openText: "\u2304",
    closedText: "\u203A",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: ()=>false
};
class $d245ca63c4fe5041$var$FoldMarker extends (0, $b3e9d73db824614e$export$591ab4c909549043) {
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        let span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function $d245ca63c4fe5041$export$c4dcf64f741b6228(config = {}) {
    let fullConfig = {
        ...$d245ca63c4fe5041$var$foldGutterDefaults,
        ...config
    };
    let canFold = new $d245ca63c4fe5041$var$FoldMarker(fullConfig, true), canUnfold = new $d245ca63c4fe5041$var$FoldMarker(fullConfig, false);
    let markers = (0, $b3e9d73db824614e$export$44d5eccfd62adda7).fromClass(class {
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet($d245ca63c4fe5041$export$789c912f57fe164c) != update.state.facet($d245ca63c4fe5041$export$789c912f57fe164c) || update.startState.field($d245ca63c4fe5041$export$6955fe1f7c578abb, false) != update.state.field($d245ca63c4fe5041$export$6955fe1f7c578abb, false) || $d245ca63c4fe5041$export$7fc98e56a4ca6be1(update.startState) != $d245ca63c4fe5041$export$7fc98e56a4ca6be1(update.state) || fullConfig.foldingChanged(update)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            let builder = new (0, $3ef527dddcdea745$export$89e09ce03c7e8594)();
            for (let line of view.viewportLineBlocks){
                let mark = $d245ca63c4fe5041$var$findFold(view.state, line.from, line.to) ? canUnfold : $d245ca63c4fe5041$export$cbe8a3d55245b07d(view.state, line.from, line.to) ? canFold : null;
                if (mark) builder.add(line.from, line.from, mark);
            }
            return builder.finish();
        }
    });
    let { domEventHandlers: domEventHandlers } = fullConfig;
    return [
        markers,
        (0, $b3e9d73db824614e$export$f2b922cb4a245974)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, $3ef527dddcdea745$export$34cb5241245008dd).empty;
            },
            initialSpacer () {
                return new $d245ca63c4fe5041$var$FoldMarker(fullConfig, false);
            },
            domEventHandlers: {
                ...domEventHandlers,
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    let folded = $d245ca63c4fe5041$var$findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: $d245ca63c4fe5041$export$bf2507dc398fc1ab.of(folded)
                        });
                        return true;
                    }
                    let range = $d245ca63c4fe5041$export$cbe8a3d55245b07d(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: $d245ca63c4fe5041$export$a123efe007ad265.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            }
        }),
        $d245ca63c4fe5041$export$2c875b83a85d0f31()
    ];
}
const $d245ca63c4fe5041$var$baseTheme$1 = /*@__PURE__*/ (0, $b3e9d73db824614e$export$eece2fccabbb77c5).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with highlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class $d245ca63c4fe5041$export$4819f093bdd5b4a {
    constructor(/**
    The tag styles used to create this highlight style.
    */ specs, options){
        this.specs = specs;
        let modSpec;
        function def(spec) {
            let cls = (0, $246d4c208d441e56$export$b920c662d2efee20).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        const scopeOpt = options.scope;
        this.scope = scopeOpt instanceof $d245ca63c4fe5041$export$ce4fe1c9e6520c1a ? (type)=>type.prop($d245ca63c4fe5041$export$27a2e78097f753f7) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, $f0075d67137b7b29$export$b7f6332ce20f80fb)(specs.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all: all
        }).style;
        this.module = modSpec ? new (0, $246d4c208d441e56$export$b920c662d2efee20)(modSpec) : null;
        this.themeType = options.themeType;
    }
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://code.haverbeke.berlin/marijn/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new $d245ca63c4fe5041$export$4819f093bdd5b4a(specs, options || {});
    }
}
const $d245ca63c4fe5041$var$highlighterFacet = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $d245ca63c4fe5041$var$fallbackHighlighter = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function $d245ca63c4fe5041$var$getHighlighters(state) {
    let main = state.facet($d245ca63c4fe5041$var$highlighterFacet);
    return main.length ? main : state.facet($d245ca63c4fe5041$var$fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function $d245ca63c4fe5041$export$ec1b956ff3a16361(highlighter, options) {
    let ext = [
        $d245ca63c4fe5041$var$treeHighlighter
    ], themeType;
    if (highlighter instanceof $d245ca63c4fe5041$export$4819f093bdd5b4a) {
        if (highlighter.module) ext.push((0, $b3e9d73db824614e$export$eece2fccabbb77c5).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push($d245ca63c4fe5041$var$fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push($d245ca63c4fe5041$var$highlighterFacet.computeN([
        (0, $b3e9d73db824614e$export$eece2fccabbb77c5).darkTheme
    ], (state)=>{
        return state.facet((0, $b3e9d73db824614e$export$eece2fccabbb77c5).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push($d245ca63c4fe5041$var$highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function $d245ca63c4fe5041$export$8ca2b052028e8782(state, tags, scope) {
    let highlighters = $d245ca63c4fe5041$var$getHighlighters(state);
    let result = null;
    if (highlighters) {
        for (let highlighter of highlighters)if (!highlighter.scope || scope && highlighter.scope(scope)) {
            let cls = highlighter.style(tags);
            if (cls) result = result ? result + " " + cls : cls;
        }
    }
    return result;
}
class $d245ca63c4fe5041$var$TreeHighlighter {
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = $d245ca63c4fe5041$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.buildDeco(view, $d245ca63c4fe5041$var$getHighlighters(view.state));
        this.decoratedTo = view.viewport.to;
    }
    update(update) {
        let tree = $d245ca63c4fe5041$export$7fc98e56a4ca6be1(update.state), highlighters = $d245ca63c4fe5041$var$getHighlighters(update.state);
        let styleChange = highlighters != $d245ca63c4fe5041$var$getHighlighters(update.startState);
        let { viewport: viewport } = update.view, decoratedToMapped = update.changes.mapPos(this.decoratedTo, 1);
        if (tree.length < viewport.to && !styleChange && tree.type == this.tree.type && decoratedToMapped >= viewport.to) {
            this.decorations = this.decorations.map(update.changes);
            this.decoratedTo = decoratedToMapped;
        } else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
            this.decoratedTo = viewport.to;
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, $b3e9d73db824614e$export$10e30b733df217ea).none;
        let builder = new (0, $3ef527dddcdea745$export$89e09ce03c7e8594)();
        for (let { from: from, to: to } of view.visibleRanges)(0, $f0075d67137b7b29$export$af82b3d076119fad)(this.tree, highlighters, (from, to, style)=>{
            builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, $b3e9d73db824614e$export$10e30b733df217ea).mark({
                class: style
            })));
        }, from, to);
        return builder.finish();
    }
}
const $d245ca63c4fe5041$var$treeHighlighter = /*@__PURE__*/ (0, $3ef527dddcdea745$export$b92464a736444411).high(/*@__PURE__*/ (0, $b3e9d73db824614e$export$44d5eccfd62adda7).fromClass($d245ca63c4fe5041$var$TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ const $d245ca63c4fe5041$export$bb02a6818dd48320 = /*@__PURE__*/ $d245ca63c4fe5041$export$4819f093bdd5b4a.define([
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).meta,
        color: "#404740"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).link,
        textDecoration: "underline"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).atom,
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).bool,
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).url,
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).contentSeparator,
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).literal,
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).string,
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).regexp,
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).escape,
            /*@__PURE__*/ (0, $f0075d67137b7b29$export$8b7a896ae75accbf).special((0, $f0075d67137b7b29$export$8b7a896ae75accbf).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, $f0075d67137b7b29$export$8b7a896ae75accbf).definition((0, $f0075d67137b7b29$export$8b7a896ae75accbf).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, $f0075d67137b7b29$export$8b7a896ae75accbf).local((0, $f0075d67137b7b29$export$8b7a896ae75accbf).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).typeName,
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, $f0075d67137b7b29$export$8b7a896ae75accbf).special((0, $f0075d67137b7b29$export$8b7a896ae75accbf).variableName),
            (0, $f0075d67137b7b29$export$8b7a896ae75accbf).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, $f0075d67137b7b29$export$8b7a896ae75accbf).definition((0, $f0075d67137b7b29$export$8b7a896ae75accbf).propertyName),
        color: "#00c"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).comment,
        color: "#940"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).invalid,
        color: "#f00"
    }
]);
const $d245ca63c4fe5041$var$baseTheme = /*@__PURE__*/ (0, $b3e9d73db824614e$export$eece2fccabbb77c5).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
const $d245ca63c4fe5041$var$DefaultScanDist = 10000, $d245ca63c4fe5041$var$DefaultBrackets = "()[]{}";
const $d245ca63c4fe5041$var$bracketMatchingConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $3ef527dddcdea745$export$4e19c0b693794a7e)(configs, {
            afterCursor: true,
            brackets: $d245ca63c4fe5041$var$DefaultBrackets,
            maxScanDistance: $d245ca63c4fe5041$var$DefaultScanDist,
            renderMatch: $d245ca63c4fe5041$var$defaultRenderMatch
        });
    }
});
const $d245ca63c4fe5041$var$matchingMark = /*@__PURE__*/ (0, $b3e9d73db824614e$export$10e30b733df217ea).mark({
    class: "cm-matchingBracket"
}), $d245ca63c4fe5041$var$nonmatchingMark = /*@__PURE__*/ (0, $b3e9d73db824614e$export$10e30b733df217ea).mark({
    class: "cm-nonmatchingBracket"
});
function $d245ca63c4fe5041$var$defaultRenderMatch(match) {
    let decorations = [];
    let mark = match.matched ? $d245ca63c4fe5041$var$matchingMark : $d245ca63c4fe5041$var$nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
function $d245ca63c4fe5041$var$bracketDeco(state) {
    let decorations = [];
    let config = state.facet($d245ca63c4fe5041$var$bracketMatchingConfig);
    for (let range of state.selection.ranges){
        if (!range.empty) continue;
        let match = $d245ca63c4fe5041$export$3391942603e90cda(state, range.head, -1, config) || range.head > 0 && $d245ca63c4fe5041$export$3391942603e90cda(state, range.head - 1, 1, config) || config.afterCursor && ($d245ca63c4fe5041$export$3391942603e90cda(state, range.head, 1, config) || range.head < state.doc.length && $d245ca63c4fe5041$export$3391942603e90cda(state, range.head + 1, -1, config));
        if (match) decorations = decorations.concat(config.renderMatch(match, state));
    }
    return (0, $b3e9d73db824614e$export$10e30b733df217ea).set(decorations, true);
}
const $d245ca63c4fe5041$var$bracketMatcher = /*@__PURE__*/ (0, $b3e9d73db824614e$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.paused = false;
        this.decorations = $d245ca63c4fe5041$var$bracketDeco(view.state);
    }
    update(update) {
        if (update.docChanged || update.selectionSet || this.paused) {
            if (update.view.composing) {
                this.decorations = this.decorations.map(update.changes);
                this.paused = true;
            } else {
                this.decorations = $d245ca63c4fe5041$var$bracketDeco(update.state);
                this.paused = false;
            }
        }
    }
}, {
    decorations: (v)=>v.decorations
});
const $d245ca63c4fe5041$var$bracketMatchingUnique = [
    $d245ca63c4fe5041$var$bracketMatcher,
    $d245ca63c4fe5041$var$baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function $d245ca63c4fe5041$export$cef7edfd214be605(config = {}) {
    return [
        $d245ca63c4fe5041$var$bracketMatchingConfig.of(config),
        $d245ca63c4fe5041$var$bracketMatchingUnique
    ];
}
/**
When larger syntax nodes, such as HTML tags, are marked as
opening/closing, it can be a bit messy to treat the whole node as
a matchable bracket. This node prop allows you to define, for such
a node, a ‘handle’—the part of the node that is highlighted, and
that the cursor must be on to activate highlighting in the first
place.
*/ const $d245ca63c4fe5041$export$ca7d74cd5b9f1011 = /*@__PURE__*/ new (0, $7c348856541b1efa$export$b8034b9bc18acd90)();
function $d245ca63c4fe5041$var$matchingNodes(node, dir, brackets) {
    let byProp = node.prop(dir < 0 ? (0, $7c348856541b1efa$export$b8034b9bc18acd90).openedBy : (0, $7c348856541b1efa$export$b8034b9bc18acd90).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        let index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
function $d245ca63c4fe5041$var$findHandle(node) {
    let hasHandle = node.type.prop($d245ca63c4fe5041$export$ca7d74cd5b9f1011);
    return hasHandle ? hasHandle(node.node) : node;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function $d245ca63c4fe5041$export$3391942603e90cda(state, pos, dir, config = {}) {
    let maxScanDistance = config.maxScanDistance || $d245ca63c4fe5041$var$DefaultScanDist, brackets = config.brackets || $d245ca63c4fe5041$var$DefaultBrackets;
    let tree = $d245ca63c4fe5041$export$7fc98e56a4ca6be1(state), node = tree.resolveInner(pos, dir);
    for(let cur = node; cur; cur = cur.parent){
        let matches = $d245ca63c4fe5041$var$matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) {
            let handle = $d245ca63c4fe5041$var$findHandle(cur);
            if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to)) return $d245ca63c4fe5041$var$matchMarkedBrackets(state, pos, dir, cur, handle, matches, brackets);
        }
    }
    return $d245ca63c4fe5041$var$matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function $d245ca63c4fe5041$var$matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
    let parent = token.parent, firstToken = {
        from: handle.from,
        to: handle.to
    };
    let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
            let endHandle = $d245ca63c4fe5041$var$findHandle(cursor);
            return {
                start: firstToken,
                end: endHandle ? {
                    from: endHandle.from,
                    to: endHandle.to
                } : undefined,
                matched: true
            };
        } else if ($d245ca63c4fe5041$var$matchingNodes(cursor.type, dir, brackets)) depth++;
        else if ($d245ca63c4fe5041$var$matchingNodes(cursor.type, -dir, brackets)) {
            if (depth == 0) {
                let endHandle = $d245ca63c4fe5041$var$findHandle(cursor);
                return {
                    start: firstToken,
                    end: endHandle && endHandle.from < endHandle.to ? {
                        from: endHandle.from,
                        to: endHandle.to
                    } : undefined,
                    matched: false
                };
            }
            depth--;
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function $d245ca63c4fe5041$var$matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    if (dir < 0 ? !pos : pos == state.doc.length) return null;
    let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    let bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    let startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(let distance = 0; !iter.next().done && distance <= maxScanDistance;){
        let text = iter.value;
        if (dir < 0) distance += text.length;
        let basePos = pos + distance * dir;
        for(let pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos != end; pos += dir){
            let found = brackets.indexOf(text[pos]);
            if (found < 0 || tree.resolveInner(basePos + pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + pos,
                    to: basePos + pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function $d245ca63c4fe5041$var$countCol(string, end, tabSize, startIndex = 0, startValue = 0) {
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    let n = startValue;
    for(let i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class $d245ca63c4fe5041$export$72a09304cc8c1940 {
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit, overrideIndent){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        this.overrideIndent = overrideIndent;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        let ch = this.string.charAt(this.pos);
        let ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        let start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        let start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        let found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = $d245ca63c4fe5041$var$countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        var _a;
        return (_a = this.overrideIndent) !== null && _a !== void 0 ? _a : $d245ca63c4fe5041$var$countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            let cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            let substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            let match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
}
function $d245ca63c4fe5041$var$fullParser(spec) {
    return {
        name: spec.name || "",
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || $d245ca63c4fe5041$var$defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || $d245ca63c4fe5041$var$noTokens,
        mergeTokens: spec.mergeTokens !== false
    };
}
function $d245ca63c4fe5041$var$defaultCopyState(state) {
    if (typeof state != "object") return state;
    let newState = {};
    for(let prop in state){
        let val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
const $d245ca63c4fe5041$var$IndentedFrom = /*@__PURE__*/ new WeakMap();
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class $d245ca63c4fe5041$export$5ee3cc23916207d8 extends $d245ca63c4fe5041$export$ce4fe1c9e6520c1a {
    constructor(parser){
        let data = $d245ca63c4fe5041$export$b57f683f43553b99(parser.languageData);
        let p = $d245ca63c4fe5041$var$fullParser(parser), self;
        let impl = new class extends (0, $7c348856541b1efa$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                return new $d245ca63c4fe5041$var$Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [], parser.name);
        this.topNode = $d245ca63c4fe5041$var$docID(data, this);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, $7c348856541b1efa$export$b8034b9bc18acd90)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new $d245ca63c4fe5041$var$TokenTable(p.tokenTable) : $d245ca63c4fe5041$var$defaultTokenTable;
    }
    /**
    Define a stream language.
    */ static define(spec) {
        return new $d245ca63c4fe5041$export$5ee3cc23916207d8(spec);
    }
    /**
    @internal
    */ getIndent(cx) {
        let from = undefined;
        let { overrideIndentation: overrideIndentation } = cx.options;
        if (overrideIndentation) {
            from = $d245ca63c4fe5041$var$IndentedFrom.get(cx.state);
            if (from != null && from < cx.pos - 1e4) from = undefined;
        }
        let start = $d245ca63c4fe5041$var$findState(this, cx.node.tree, cx.node.from, cx.node.from, from !== null && from !== void 0 ? from : cx.pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = cx.node.from;
        }
        if (cx.pos - statePos > 10000 /* C.MaxIndentScanDist */ ) return null;
        while(statePos < cx.pos){
            let line = cx.state.doc.lineAt(statePos), end = Math.min(cx.pos, line.to);
            if (line.length) {
                let indentation = overrideIndentation ? overrideIndentation(line.from) : -1;
                let stream = new $d245ca63c4fe5041$export$72a09304cc8c1940(line.text, cx.state.tabSize, cx.unit, indentation < 0 ? undefined : indentation);
                while(stream.pos < end - line.from)$d245ca63c4fe5041$var$readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == cx.pos) break;
            statePos = line.to + 1;
        }
        let line = cx.lineAt(cx.pos);
        if (overrideIndentation && from == null) $d245ca63c4fe5041$var$IndentedFrom.set(cx.state, line.from);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(line.text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
}
function $d245ca63c4fe5041$var$findState(lang, tree, off, startPos, before) {
    let state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(let i = tree.children.length - 1; i >= 0; i--){
        let child = tree.children[i], pos = off + tree.positions[i];
        let found = child instanceof (0, $7c348856541b1efa$export$7fbedc92909ed28e) && pos < before && $d245ca63c4fe5041$var$findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function $d245ca63c4fe5041$var$cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && from == 0 && tree.type == lang.topNode) inside = true;
    for(let i = tree.children.length - 1; i >= 0; i--){
        let pos = tree.positions[i], child = tree.children[i], inner;
        if (pos < to && child instanceof (0, $7c348856541b1efa$export$7fbedc92909ed28e)) {
            if (!(inner = $d245ca63c4fe5041$var$cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, $7c348856541b1efa$export$7fbedc92909ed28e)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function $d245ca63c4fe5041$var$findStartInFragments(lang, fragments, startPos, endPos, editorState) {
    for (let f of fragments){
        let from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
        let found = from <= startPos && to > startPos && $d245ca63c4fe5041$var$findState(lang, f.tree, 0 - f.offset, startPos, to), tree;
        if (found && found.pos <= endPos && (tree = $d245ca63c4fe5041$var$cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
            state: found.state,
            tree: tree
        };
    }
    return {
        state: lang.streamParser.startState(editorState ? $d245ca63c4fe5041$export$ad3205d09311a797(editorState) : 4),
        tree: (0, $7c348856541b1efa$export$7fbedc92909ed28e).empty
    };
}
class $d245ca63c4fe5041$var$Parse {
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        let context = $d245ca63c4fe5041$export$3fcb7c01ff2a41fa.get(), from = ranges[0].from;
        let { state: state, tree: tree } = $d245ca63c4fe5041$var$findStartInFragments(lang, fragments, from, this.to, context === null || context === void 0 ? void 0 : context.state);
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(let i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* C.MaxDistanceBeforeViewport */  && ranges.some((r)=>r.from <= context.viewport.from && r.to >= context.viewport.from)) {
            this.state = this.lang.streamParser.startState($d245ca63c4fe5041$export$ad3205d09311a797(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
    advance() {
        let context = $d245ca63c4fe5041$export$3fcb7c01ff2a41fa.get();
        let parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        let end = Math.min(parseEnd, this.chunkStart + 512 /* C.ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        let chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            let eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        let from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(let index = this.rangeIndex;;){
            let rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            let rangeStart = this.ranges[index].from;
            let after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line: line,
            end: end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            let end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            let start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, offset) {
        let size = 4;
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            let len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        let last = this.chunk.length - 4;
        if (this.lang.streamParser.mergeTokens && size == 4 && last >= 0 && this.chunk[last] == id && this.chunk[last + 2] == from) this.chunk[last + 2] = to;
        else this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        let { line: line, end: end } = this.nextLine(), offset = 0, { streamParser: streamParser } = this.lang;
        let stream = new $d245ca63c4fe5041$export$72a09304cc8c1940(line, context ? context.state.tabSize : 4, context ? $d245ca63c4fe5041$export$ad3205d09311a797(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            let token = $d245ca63c4fe5041$var$readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, offset);
            if (stream.start > 10000 /* C.MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        let tree = (0, $7c348856541b1efa$export$7fbedc92909ed28e).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet: $d245ca63c4fe5041$var$nodeSet,
            topID: 0,
            maxBufferLength: 512 /* C.ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, $7c348856541b1efa$export$7fbedc92909ed28e)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, $7c348856541b1efa$export$7fbedc92909ed28e)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
}
function $d245ca63c4fe5041$var$readToken(token, stream, state) {
    stream.start = stream.pos;
    for(let i = 0; i < 10; i++){
        let result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
const $d245ca63c4fe5041$var$noTokens = /*@__PURE__*/ Object.create(null);
const $d245ca63c4fe5041$var$typeArray = [
    (0, $7c348856541b1efa$export$f06e977173f1857c).none
];
const $d245ca63c4fe5041$var$nodeSet = /*@__PURE__*/ new (0, $7c348856541b1efa$export$7fad5fb00d8de02c)($d245ca63c4fe5041$var$typeArray);
const $d245ca63c4fe5041$var$warned = [];
// Cache of node types by name and tags
const $d245ca63c4fe5041$var$byTag = /*@__PURE__*/ Object.create(null);
const $d245ca63c4fe5041$var$defaultTable = /*@__PURE__*/ Object.create(null);
for (let [legacyName, name] of [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
])$d245ca63c4fe5041$var$defaultTable[legacyName] = /*@__PURE__*/ $d245ca63c4fe5041$var$createTokenType($d245ca63c4fe5041$var$noTokens, name);
class $d245ca63c4fe5041$var$TokenTable {
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), $d245ca63c4fe5041$var$defaultTable);
    }
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = $d245ca63c4fe5041$var$createTokenType(this.extra, tag));
    }
}
const $d245ca63c4fe5041$var$defaultTokenTable = /*@__PURE__*/ new $d245ca63c4fe5041$var$TokenTable($d245ca63c4fe5041$var$noTokens);
function $d245ca63c4fe5041$var$warnForPart(part, msg) {
    if ($d245ca63c4fe5041$var$warned.indexOf(part) > -1) return;
    $d245ca63c4fe5041$var$warned.push(part);
    console.warn(msg);
}
function $d245ca63c4fe5041$var$createTokenType(extra, tagStr) {
    let tags$1 = [];
    for (let name of tagStr.split(" ")){
        let found = [];
        for (let part of name.split(".")){
            let value = extra[part] || (0, $f0075d67137b7b29$export$8b7a896ae75accbf)[part];
            if (!value) $d245ca63c4fe5041$var$warnForPart(part, `Unknown highlighting tag ${part}`);
            else if (typeof value == "function") {
                if (!found.length) $d245ca63c4fe5041$var$warnForPart(part, `Modifier ${part} used at start of tag`);
                else found = found.map(value);
            } else if (found.length) $d245ca63c4fe5041$var$warnForPart(part, `Tag ${part} used as modifier`);
            else found = Array.isArray(value) ? value : [
                value
            ];
        }
        for (let tag of found)tags$1.push(tag);
    }
    if (!tags$1.length) return 0;
    let name = tagStr.replace(/ /g, "_"), key = name + " " + tags$1.map((t)=>t.id);
    let known = $d245ca63c4fe5041$var$byTag[key];
    if (known) return known.id;
    let type = $d245ca63c4fe5041$var$byTag[key] = (0, $7c348856541b1efa$export$f06e977173f1857c).define({
        id: $d245ca63c4fe5041$var$typeArray.length,
        name: name,
        props: [
            (0, $f0075d67137b7b29$export$c537e79bb7b94295)({
                [name]: tags$1
            })
        ]
    });
    $d245ca63c4fe5041$var$typeArray.push(type);
    return type.id;
}
function $d245ca63c4fe5041$var$docID(data, lang) {
    let type = (0, $7c348856541b1efa$export$f06e977173f1857c).define({
        id: $d245ca63c4fe5041$var$typeArray.length,
        name: "Document",
        props: [
            $d245ca63c4fe5041$export$27a2e78097f753f7.add(()=>data),
            $d245ca63c4fe5041$export$72c7d4c52b3c6460.add(()=>(cx)=>lang.getIndent(cx))
        ],
        top: true
    });
    $d245ca63c4fe5041$var$typeArray.push(type);
    return type;
}
function $d245ca63c4fe5041$var$buildForLine(line) {
    return line.length <= 4096 && /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/.test(line);
}
function $d245ca63c4fe5041$var$textHasRTL(text) {
    for(let i = text.iter(); !i.next().done;)if ($d245ca63c4fe5041$var$buildForLine(i.value)) return true;
    return false;
}
function $d245ca63c4fe5041$var$changeAddsRTL(change) {
    let added = false;
    change.iterChanges((fA, tA, fB, tB, ins)=>{
        if (!added && $d245ca63c4fe5041$var$textHasRTL(ins)) added = true;
    });
    return added;
}
const $d245ca63c4fe5041$var$alwaysIsolate = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
Make sure nodes
[marked](https://lezer.codemirror.net/docs/ref/#common.NodeProp^isolate)
as isolating for bidirectional text are rendered in a way that
isolates them from the surrounding text.
*/ function $d245ca63c4fe5041$export$9c455d2bd760f210(options = {}) {
    let extensions = [
        $d245ca63c4fe5041$var$isolateMarks
    ];
    if (options.alwaysIsolate) extensions.push($d245ca63c4fe5041$var$alwaysIsolate.of(true));
    return extensions;
}
const $d245ca63c4fe5041$var$isolateMarks = /*@__PURE__*/ (0, $b3e9d73db824614e$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.always = view.state.facet($d245ca63c4fe5041$var$alwaysIsolate) || view.textDirection != (0, $b3e9d73db824614e$export$cacd6541cfeeb6c1).LTR || view.state.facet((0, $b3e9d73db824614e$export$eece2fccabbb77c5).perLineTextDirection);
        this.hasRTL = !this.always && $d245ca63c4fe5041$var$textHasRTL(view.state.doc);
        this.tree = $d245ca63c4fe5041$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.always || this.hasRTL ? $d245ca63c4fe5041$var$buildDeco(view, this.tree, this.always) : (0, $b3e9d73db824614e$export$10e30b733df217ea).none;
    }
    update(update) {
        let always = update.state.facet($d245ca63c4fe5041$var$alwaysIsolate) || update.view.textDirection != (0, $b3e9d73db824614e$export$cacd6541cfeeb6c1).LTR || update.state.facet((0, $b3e9d73db824614e$export$eece2fccabbb77c5).perLineTextDirection);
        if (!always && !this.hasRTL && $d245ca63c4fe5041$var$changeAddsRTL(update.changes)) this.hasRTL = true;
        if (!always && !this.hasRTL) return;
        let tree = $d245ca63c4fe5041$export$7fc98e56a4ca6be1(update.state);
        if (always != this.always || tree != this.tree || update.docChanged || update.viewportChanged) {
            this.tree = tree;
            this.always = always;
            this.decorations = $d245ca63c4fe5041$var$buildDeco(update.view, tree, always);
        }
    }
}, {
    provide: (plugin)=>{
        function access(view) {
            var _a, _b;
            return (_b = (_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.decorations) !== null && _b !== void 0 ? _b : (0, $b3e9d73db824614e$export$10e30b733df217ea).none;
        }
        return [
            (0, $b3e9d73db824614e$export$eece2fccabbb77c5).outerDecorations.of(access),
            (0, $3ef527dddcdea745$export$b92464a736444411).lowest((0, $b3e9d73db824614e$export$eece2fccabbb77c5).bidiIsolatedRanges.of(access))
        ];
    }
});
function $d245ca63c4fe5041$var$buildDeco(view, tree, always) {
    let deco = new (0, $3ef527dddcdea745$export$89e09ce03c7e8594)();
    let ranges = view.visibleRanges;
    if (!always) ranges = $d245ca63c4fe5041$var$clipRTLLines(ranges, view.state.doc);
    for (let { from: from, to: to } of ranges)tree.iterate({
        enter: (node)=>{
            let iso = node.type.prop((0, $7c348856541b1efa$export$b8034b9bc18acd90).isolate);
            if (iso) deco.add(node.from, node.to, $d245ca63c4fe5041$var$marks[iso]);
        },
        from: from,
        to: to
    });
    return deco.finish();
}
function $d245ca63c4fe5041$var$clipRTLLines(ranges, doc) {
    let cur = doc.iter(), pos = 0, result = [], last = null;
    for (let { from: from, to: to } of ranges){
        if (last && last.to > from) {
            from = last.to;
            if (from >= to) continue;
        }
        if (pos + cur.value.length < from) {
            cur.next(from - (pos + cur.value.length));
            pos = from;
        }
        for(;;){
            let start = pos, end = pos + cur.value.length;
            if (!cur.lineBreak && $d245ca63c4fe5041$var$buildForLine(cur.value)) {
                if (last && last.to > start - 10) last.to = Math.min(to, end);
                else result.push(last = {
                    from: start,
                    to: Math.min(to, end)
                });
            }
            if (end >= to) break;
            pos = end;
            cur.next();
        }
    }
    return result;
}
const $d245ca63c4fe5041$var$marks = {
    rtl: /*@__PURE__*/ (0, $b3e9d73db824614e$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "rtl"
        },
        bidiIsolate: (0, $b3e9d73db824614e$export$cacd6541cfeeb6c1).RTL
    }),
    ltr: /*@__PURE__*/ (0, $b3e9d73db824614e$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "ltr"
        },
        bidiIsolate: (0, $b3e9d73db824614e$export$cacd6541cfeeb6c1).LTR
    }),
    auto: /*@__PURE__*/ (0, $b3e9d73db824614e$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "auto"
        },
        bidiIsolate: null
    })
};



/**
Comment or uncomment the current selection. Will use line comments
if available, otherwise falling back to block comments.
*/ const $d6ef25f90fa77b71$export$afbcdd0bff36c567 = (target)=>{
    let { state: state } = target, line = state.doc.lineAt(state.selection.main.from), config = $d6ef25f90fa77b71$var$getConfig(target.state, line.from);
    return config.line ? $d6ef25f90fa77b71$export$63a9abf96aaa3c5d(target) : config.block ? $d6ef25f90fa77b71$export$e88d9eff7cafcc34(target) : false;
};
function $d6ef25f90fa77b71$var$command(f, option) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let tr = f(option, state);
        if (!tr) return false;
        dispatch(state.update(tr));
        return true;
    };
}
/**
Comment or uncomment the current selection using line comments.
The line comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $d6ef25f90fa77b71$export$63a9abf96aaa3c5d = /*@__PURE__*/ $d6ef25f90fa77b71$var$command($d6ef25f90fa77b71$var$changeLineComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using line comments.
*/ const $d6ef25f90fa77b71$export$5d080f5a78d4f5b3 = /*@__PURE__*/ $d6ef25f90fa77b71$var$command($d6ef25f90fa77b71$var$changeLineComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using line comments.
*/ const $d6ef25f90fa77b71$export$5a43b8c36509b6fd = /*@__PURE__*/ $d6ef25f90fa77b71$var$command($d6ef25f90fa77b71$var$changeLineComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the current selection using block comments.
The block comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $d6ef25f90fa77b71$export$19d6fa84ce3a55ab = /*@__PURE__*/ $d6ef25f90fa77b71$var$command($d6ef25f90fa77b71$var$changeBlockComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using block comments.
*/ const $d6ef25f90fa77b71$export$f2ae215066c4835a = /*@__PURE__*/ $d6ef25f90fa77b71$var$command($d6ef25f90fa77b71$var$changeBlockComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using block comments.
*/ const $d6ef25f90fa77b71$export$fddcfb23c3a05835 = /*@__PURE__*/ $d6ef25f90fa77b71$var$command($d6ef25f90fa77b71$var$changeBlockComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the lines around the current selection using
block comments.
*/ const $d6ef25f90fa77b71$export$e88d9eff7cafcc34 = /*@__PURE__*/ $d6ef25f90fa77b71$var$command((o, s)=>$d6ef25f90fa77b71$var$changeBlockComment(o, s, $d6ef25f90fa77b71$var$selectedLineRanges(s)), 0 /* CommentOption.Toggle */ );
function $d6ef25f90fa77b71$var$getConfig(state, pos) {
    let data = state.languageDataAt("commentTokens", pos, 1);
    return data.length ? data[0] : {};
}
const $d6ef25f90fa77b71$var$SearchMargin = 50;
/**
Determines if the given range is block-commented in the given
state.
*/ function $d6ef25f90fa77b71$var$findBlockComment(state, { open: open, close: close }, from, to) {
    let textBefore = state.sliceDoc(from - $d6ef25f90fa77b71$var$SearchMargin, from);
    let textAfter = state.sliceDoc(to, to + $d6ef25f90fa77b71$var$SearchMargin);
    let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
    let beforeOff = textBefore.length - spaceBefore;
    if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) return {
        open: {
            pos: from - spaceBefore,
            margin: spaceBefore && 1
        },
        close: {
            pos: to + spaceAfter,
            margin: spaceAfter && 1
        }
    };
    let startText, endText;
    if (to - from <= 2 * $d6ef25f90fa77b71$var$SearchMargin) startText = endText = state.sliceDoc(from, to);
    else {
        startText = state.sliceDoc(from, from + $d6ef25f90fa77b71$var$SearchMargin);
        endText = state.sliceDoc(to - $d6ef25f90fa77b71$var$SearchMargin, to);
    }
    let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
    let endOff = endText.length - endSpace - close.length;
    if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) return {
        open: {
            pos: from + startSpace + open.length,
            margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
        },
        close: {
            pos: to - endSpace - close.length,
            margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
        }
    };
    return null;
}
function $d6ef25f90fa77b71$var$selectedLineRanges(state) {
    let ranges = [];
    for (let r of state.selection.ranges){
        let fromLine = state.doc.lineAt(r.from);
        let toLine = r.to <= fromLine.to ? fromLine : state.doc.lineAt(r.to);
        if (toLine.from > fromLine.from && toLine.from == r.to) toLine = r.to == fromLine.to + 1 ? fromLine : state.doc.lineAt(r.to - 1);
        let last = ranges.length - 1;
        if (last >= 0 && ranges[last].to > fromLine.from) ranges[last].to = toLine.to;
        else ranges.push({
            from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length,
            to: toLine.to
        });
    }
    return ranges;
}
// Performs toggle, comment and uncomment of block comments in
// languages that support them.
function $d6ef25f90fa77b71$var$changeBlockComment(option, state, ranges = state.selection.ranges) {
    let tokens = ranges.map((r)=>$d6ef25f90fa77b71$var$getConfig(state, r.from).block);
    if (!tokens.every((c)=>c)) return null;
    let comments = ranges.map((r, i)=>$d6ef25f90fa77b71$var$findBlockComment(state, tokens[i], r.from, r.to));
    if (option != 2 /* CommentOption.Uncomment */  && !comments.every((c)=>c)) return {
        changes: state.changes(ranges.map((range, i)=>{
            if (comments[i]) return [];
            return [
                {
                    from: range.from,
                    insert: tokens[i].open + " "
                },
                {
                    from: range.to,
                    insert: " " + tokens[i].close
                }
            ];
        }))
    };
    else if (option != 1 /* CommentOption.Comment */  && comments.some((c)=>c)) {
        let changes = [];
        for(let i = 0, comment; i < comments.length; i++)if (comment = comments[i]) {
            let token = tokens[i], { open: open, close: close } = comment;
            changes.push({
                from: open.pos - token.open.length,
                to: open.pos + open.margin
            }, {
                from: close.pos - close.margin,
                to: close.pos + token.close.length
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
// Performs toggle, comment and uncomment of line comments.
function $d6ef25f90fa77b71$var$changeLineComment(option, state, ranges = state.selection.ranges) {
    let lines = [];
    let prevLine = -1;
    ranges: for (let { from: from, to: to } of ranges){
        let startI = lines.length, minIndent = 1e9, token;
        for(let pos = from; pos <= to;){
            let line = state.doc.lineAt(pos);
            if (token == undefined) {
                token = $d6ef25f90fa77b71$var$getConfig(state, line.from).line;
                if (!token) continue ranges;
            }
            if (line.from > prevLine && (from == to || to > line.from)) {
                prevLine = line.from;
                let indent = /^\s*/.exec(line.text)[0].length;
                let empty = indent == line.length;
                let comment = line.text.slice(indent, indent + token.length) == token ? indent : -1;
                if (indent < line.text.length && indent < minIndent) minIndent = indent;
                lines.push({
                    line: line,
                    comment: comment,
                    token: token,
                    indent: indent,
                    empty: empty,
                    single: false
                });
            }
            pos = line.to + 1;
        }
        if (minIndent < 1e9) {
            for(let i = startI; i < lines.length; i++)if (lines[i].indent < lines[i].line.text.length) lines[i].indent = minIndent;
        }
        if (lines.length == startI + 1) lines[startI].single = true;
    }
    if (option != 2 /* CommentOption.Uncomment */  && lines.some((l)=>l.comment < 0 && (!l.empty || l.single))) {
        let changes = [];
        for (let { line: line, token: token, indent: indent, empty: empty, single: single } of lines)if (single || !empty) changes.push({
            from: line.from + indent,
            insert: token + " "
        });
        let changeSet = state.changes(changes);
        return {
            changes: changeSet,
            selection: state.selection.map(changeSet, 1)
        };
    } else if (option != 1 /* CommentOption.Comment */  && lines.some((l)=>l.comment >= 0)) {
        let changes = [];
        for (let { line: line, comment: comment, token: token } of lines)if (comment >= 0) {
            let from = line.from + comment, to = from + token.length;
            if (line.text[to - line.from] == " ") to++;
            changes.push({
                from: from,
                to: to
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
const $d6ef25f90fa77b71$var$fromHistory = /*@__PURE__*/ (0, $3ef527dddcdea745$export$9279461326b8700a).define();
/**
Transaction annotation that will prevent that transaction from
being combined with other transactions in the undo history. Given
`"before"`, it'll prevent merging with previous transactions. With
`"after"`, subsequent transactions won't be combined with this
one. With `"full"`, the transaction is isolated on both sides.
*/ const $d6ef25f90fa77b71$export$33e0bb25992f9954 = /*@__PURE__*/ (0, $3ef527dddcdea745$export$9279461326b8700a).define();
/**
This facet provides a way to register functions that, given a
transaction, provide a set of effects that the history should
store when inverting the transaction. This can be used to
integrate some kinds of effects in the history, so that they can
be undone (and redone again).
*/ const $d6ef25f90fa77b71$export$edb12867fb9b2023 = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define();
const $d6ef25f90fa77b71$var$historyConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $3ef527dddcdea745$export$4e19c0b693794a7e)(configs, {
            minDepth: 100,
            newGroupDelay: 500,
            joinToEvent: (_t, isAdjacent)=>isAdjacent
        }, {
            minDepth: Math.max,
            newGroupDelay: Math.min,
            joinToEvent: (a, b)=>(tr, adj)=>a(tr, adj) || b(tr, adj)
        });
    }
});
const $d6ef25f90fa77b71$var$historyField_ = /*@__PURE__*/ (0, $3ef527dddcdea745$export$34381b1ce2130245).define({
    create () {
        return $d6ef25f90fa77b71$var$HistoryState.empty;
    },
    update (state, tr) {
        let config = tr.state.facet($d6ef25f90fa77b71$var$historyConfig);
        let fromHist = tr.annotation($d6ef25f90fa77b71$var$fromHistory);
        if (fromHist) {
            let item = $d6ef25f90fa77b71$var$HistEvent.fromTransaction(tr, fromHist.selection), from = fromHist.side;
            let other = from == 0 /* BranchName.Done */  ? state.undone : state.done;
            if (item) other = $d6ef25f90fa77b71$var$updateBranch(other, other.length, config.minDepth, item);
            else other = $d6ef25f90fa77b71$var$addSelection(other, tr.startState.selection);
            return new $d6ef25f90fa77b71$var$HistoryState(from == 0 /* BranchName.Done */  ? fromHist.rest : other, from == 0 /* BranchName.Done */  ? other : fromHist.rest);
        }
        let isolate = tr.annotation($d6ef25f90fa77b71$export$33e0bb25992f9954);
        if (isolate == "full" || isolate == "before") state = state.isolate();
        if (tr.annotation((0, $3ef527dddcdea745$export$febc5573c75cefb0).addToHistory) === false) return !tr.changes.empty ? state.addMapping(tr.changes.desc) : state;
        let event = $d6ef25f90fa77b71$var$HistEvent.fromTransaction(tr);
        let time = tr.annotation((0, $3ef527dddcdea745$export$febc5573c75cefb0).time), userEvent = tr.annotation((0, $3ef527dddcdea745$export$febc5573c75cefb0).userEvent);
        if (event) state = state.addChanges(event, time, userEvent, config, tr);
        else if (tr.selection) state = state.addSelection(tr.startState.selection, time, userEvent, config.newGroupDelay);
        if (isolate == "full" || isolate == "after") state = state.isolate();
        return state;
    },
    toJSON (value) {
        return {
            done: value.done.map((e)=>e.toJSON()),
            undone: value.undone.map((e)=>e.toJSON())
        };
    },
    fromJSON (json) {
        return new $d6ef25f90fa77b71$var$HistoryState(json.done.map($d6ef25f90fa77b71$var$HistEvent.fromJSON), json.undone.map($d6ef25f90fa77b71$var$HistEvent.fromJSON));
    }
});
/**
Create a history extension with the given configuration.
*/ function $d6ef25f90fa77b71$export$55abd4691b317664(config = {}) {
    return [
        $d6ef25f90fa77b71$var$historyField_,
        $d6ef25f90fa77b71$var$historyConfig.of(config),
        (0, $b3e9d73db824614e$export$eece2fccabbb77c5).domEventHandlers({
            beforeinput (e, view) {
                let command = e.inputType == "historyUndo" ? $d6ef25f90fa77b71$export$21f930c44940fd98 : e.inputType == "historyRedo" ? $d6ef25f90fa77b71$export$1688e416fee0a49e : null;
                if (!command) return false;
                e.preventDefault();
                return command(view);
            }
        })
    ];
}
/**
The state field used to store the history data. Should probably
only be used when you want to
[serialize](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) or
[deserialize](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) state objects in a way
that preserves history.
*/ const $d6ef25f90fa77b71$export$c00598b6ceeb3e9 = $d6ef25f90fa77b71$var$historyField_;
function $d6ef25f90fa77b71$var$cmd(side, selection) {
    return function({ state: state, dispatch: dispatch }) {
        if (!selection && state.readOnly) return false;
        let historyState = state.field($d6ef25f90fa77b71$var$historyField_, false);
        if (!historyState) return false;
        let tr = historyState.pop(side, state, selection);
        if (!tr) return false;
        dispatch(tr);
        return true;
    };
}
/**
Undo a single group of history events. Returns false if no group
was available.
*/ const $d6ef25f90fa77b71$export$21f930c44940fd98 = /*@__PURE__*/ $d6ef25f90fa77b71$var$cmd(0 /* BranchName.Done */ , false);
/**
Redo a group of history events. Returns false if no group was
available.
*/ const $d6ef25f90fa77b71$export$1688e416fee0a49e = /*@__PURE__*/ $d6ef25f90fa77b71$var$cmd(1 /* BranchName.Undone */ , false);
/**
Undo a change or selection change.
*/ const $d6ef25f90fa77b71$export$43103d47530fe49f = /*@__PURE__*/ $d6ef25f90fa77b71$var$cmd(0 /* BranchName.Done */ , true);
/**
Redo a change or selection change.
*/ const $d6ef25f90fa77b71$export$2d87af80f1777f20 = /*@__PURE__*/ $d6ef25f90fa77b71$var$cmd(1 /* BranchName.Undone */ , true);
function $d6ef25f90fa77b71$var$depth(side) {
    return function(state) {
        let histState = state.field($d6ef25f90fa77b71$var$historyField_, false);
        if (!histState) return 0;
        let branch = side == 0 /* BranchName.Done */  ? histState.done : histState.undone;
        return branch.length - (branch.length && !branch[0].changes ? 1 : 0);
    };
}
/**
The amount of undoable change events available in a given state.
*/ const $d6ef25f90fa77b71$export$f8a176c2b9a10bdb = /*@__PURE__*/ $d6ef25f90fa77b71$var$depth(0 /* BranchName.Done */ );
/**
The amount of redoable change events available in a given state.
*/ const $d6ef25f90fa77b71$export$3ffe6b288e7d941b = /*@__PURE__*/ $d6ef25f90fa77b71$var$depth(1 /* BranchName.Undone */ );
// History events store groups of changes or effects that need to be
// undone/redone together.
class $d6ef25f90fa77b71$var$HistEvent {
    constructor(// The changes in this event. Normal events hold at least one
    // change or effect. But it may be necessary to store selection
    // events before the first change, in which case a special type of
    // instance is created which doesn't hold any changes, with
    // changes == startSelection == undefined
    changes, // The effects associated with this event
    effects, // Accumulated mapping (from addToHistory==false) that should be
    // applied to events below this one.
    mapped, // The selection before this event
    startSelection, // Stores selection changes after this event, to be used for
    // selection undo/redo.
    selectionsAfter){
        this.changes = changes;
        this.effects = effects;
        this.mapped = mapped;
        this.startSelection = startSelection;
        this.selectionsAfter = selectionsAfter;
    }
    setSelAfter(after) {
        return new $d6ef25f90fa77b71$var$HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after);
    }
    toJSON() {
        var _a, _b, _c;
        return {
            changes: (_a = this.changes) === null || _a === void 0 ? void 0 : _a.toJSON(),
            mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
            startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
            selectionsAfter: this.selectionsAfter.map((s)=>s.toJSON())
        };
    }
    static fromJSON(json) {
        return new $d6ef25f90fa77b71$var$HistEvent(json.changes && (0, $3ef527dddcdea745$export$29d7fbdcb1f8b71c).fromJSON(json.changes), [], json.mapped && (0, $3ef527dddcdea745$export$34b6a936f2bb06a2).fromJSON(json.mapped), json.startSelection && (0, $3ef527dddcdea745$export$3bb1bd44aee62999).fromJSON(json.startSelection), json.selectionsAfter.map((0, $3ef527dddcdea745$export$3bb1bd44aee62999).fromJSON));
    }
    // This does not check `addToHistory` and such, it assumes the
    // transaction needs to be converted to an item. Returns null when
    // there are no changes or effects in the transaction.
    static fromTransaction(tr, selection) {
        let effects = $d6ef25f90fa77b71$var$none;
        for (let invert of tr.startState.facet($d6ef25f90fa77b71$export$edb12867fb9b2023)){
            let result = invert(tr);
            if (result.length) effects = effects.concat(result);
        }
        if (!effects.length && tr.changes.empty) return null;
        return new $d6ef25f90fa77b71$var$HistEvent(tr.changes.invert(tr.startState.doc), effects, undefined, selection || tr.startState.selection, $d6ef25f90fa77b71$var$none);
    }
    static selection(selections) {
        return new $d6ef25f90fa77b71$var$HistEvent(undefined, $d6ef25f90fa77b71$var$none, undefined, undefined, selections);
    }
}
function $d6ef25f90fa77b71$var$updateBranch(branch, to, maxLen, newEvent) {
    let start = to + 1 > maxLen + 20 ? to - maxLen - 1 : 0;
    let newBranch = branch.slice(start, to);
    newBranch.push(newEvent);
    return newBranch;
}
function $d6ef25f90fa77b71$var$isAdjacent(a, b) {
    let ranges = [], isAdjacent = false;
    a.iterChangedRanges((f, t)=>ranges.push(f, t));
    b.iterChangedRanges((_f, _t, f, t)=>{
        for(let i = 0; i < ranges.length;){
            let from = ranges[i++], to = ranges[i++];
            if (t >= from && f <= to) isAdjacent = true;
        }
    });
    return isAdjacent;
}
function $d6ef25f90fa77b71$var$eqSelectionShape(a, b) {
    return a.ranges.length == b.ranges.length && a.ranges.filter((r, i)=>r.empty != b.ranges[i].empty).length === 0;
}
function $d6ef25f90fa77b71$var$conc(a, b) {
    return !a.length ? b : !b.length ? a : a.concat(b);
}
const $d6ef25f90fa77b71$var$none = [];
const $d6ef25f90fa77b71$var$MaxSelectionsPerEvent = 200;
function $d6ef25f90fa77b71$var$addSelection(branch, selection) {
    if (!branch.length) return [
        $d6ef25f90fa77b71$var$HistEvent.selection([
            selection
        ])
    ];
    else {
        let lastEvent = branch[branch.length - 1];
        let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - $d6ef25f90fa77b71$var$MaxSelectionsPerEvent));
        if (sels.length && sels[sels.length - 1].eq(selection)) return branch;
        sels.push(selection);
        return $d6ef25f90fa77b71$var$updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
    }
}
// Assumes the top item has one or more selectionAfter values
function $d6ef25f90fa77b71$var$popSelection(branch) {
    let last = branch[branch.length - 1];
    let newBranch = branch.slice();
    newBranch[branch.length - 1] = last.setSelAfter(last.selectionsAfter.slice(0, last.selectionsAfter.length - 1));
    return newBranch;
}
// Add a mapping to the top event in the given branch. If this maps
// away all the changes and effects in that item, drop it and
// propagate the mapping to the next item.
function $d6ef25f90fa77b71$var$addMappingToBranch(branch, mapping) {
    if (!branch.length) return branch;
    let length = branch.length, selections = $d6ef25f90fa77b71$var$none;
    while(length){
        let event = $d6ef25f90fa77b71$var$mapEvent(branch[length - 1], mapping, selections);
        if (event.changes && !event.changes.empty || event.effects.length) {
            let result = branch.slice(0, length);
            result[length - 1] = event;
            return result;
        } else {
            mapping = event.mapped;
            length--;
            selections = event.selectionsAfter;
        }
    }
    return selections.length ? [
        $d6ef25f90fa77b71$var$HistEvent.selection(selections)
    ] : $d6ef25f90fa77b71$var$none;
}
function $d6ef25f90fa77b71$var$mapEvent(event, mapping, extraSelections) {
    let selections = $d6ef25f90fa77b71$var$conc(event.selectionsAfter.length ? event.selectionsAfter.map((s)=>s.map(mapping)) : $d6ef25f90fa77b71$var$none, extraSelections);
    // Change-less events don't store mappings (they are always the last event in a branch)
    if (!event.changes) return $d6ef25f90fa77b71$var$HistEvent.selection(selections);
    let mappedChanges = event.changes.map(mapping), before = mapping.mapDesc(event.changes, true);
    let fullMapping = event.mapped ? event.mapped.composeDesc(before) : before;
    return new $d6ef25f90fa77b71$var$HistEvent(mappedChanges, (0, $3ef527dddcdea745$export$95000d4efaa4321f).mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before), selections);
}
const $d6ef25f90fa77b71$var$joinableUserEvent = /^(input\.type|delete)($|\.)/;
class $d6ef25f90fa77b71$var$HistoryState {
    constructor(done, undone, prevTime = 0, prevUserEvent){
        this.done = done;
        this.undone = undone;
        this.prevTime = prevTime;
        this.prevUserEvent = prevUserEvent;
    }
    isolate() {
        return this.prevTime ? new $d6ef25f90fa77b71$var$HistoryState(this.done, this.undone) : this;
    }
    addChanges(event, time, userEvent, config, tr) {
        let done = this.done, lastEvent = done[done.length - 1];
        if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || $d6ef25f90fa77b71$var$joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < config.newGroupDelay && config.joinToEvent(tr, $d6ef25f90fa77b71$var$isAdjacent(lastEvent.changes, event.changes)) || // For compose (but not compose.start) events, always join with previous event
        userEvent == "input.type.compose")) done = $d6ef25f90fa77b71$var$updateBranch(done, done.length - 1, config.minDepth, new $d6ef25f90fa77b71$var$HistEvent(event.changes.compose(lastEvent.changes), $d6ef25f90fa77b71$var$conc((0, $3ef527dddcdea745$export$95000d4efaa4321f).mapEffects(event.effects, lastEvent.changes), lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, $d6ef25f90fa77b71$var$none));
        else done = $d6ef25f90fa77b71$var$updateBranch(done, done.length, config.minDepth, event);
        return new $d6ef25f90fa77b71$var$HistoryState(done, $d6ef25f90fa77b71$var$none, time, userEvent);
    }
    addSelection(selection, time, userEvent, newGroupDelay) {
        let last = this.done.length ? this.done[this.done.length - 1].selectionsAfter : $d6ef25f90fa77b71$var$none;
        if (last.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && $d6ef25f90fa77b71$var$eqSelectionShape(last[last.length - 1], selection)) return this;
        return new $d6ef25f90fa77b71$var$HistoryState($d6ef25f90fa77b71$var$addSelection(this.done, selection), this.undone, time, userEvent);
    }
    addMapping(mapping) {
        return new $d6ef25f90fa77b71$var$HistoryState($d6ef25f90fa77b71$var$addMappingToBranch(this.done, mapping), $d6ef25f90fa77b71$var$addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
    }
    pop(side, state, onlySelection) {
        let branch = side == 0 /* BranchName.Done */  ? this.done : this.undone;
        if (branch.length == 0) return null;
        let event = branch[branch.length - 1], selection = event.selectionsAfter[0] || (event.startSelection ? event.startSelection.map(event.changes.invertedDesc, 1) : state.selection);
        if (onlySelection && event.selectionsAfter.length) return state.update({
            selection: event.selectionsAfter[event.selectionsAfter.length - 1],
            annotations: $d6ef25f90fa77b71$var$fromHistory.of({
                side: side,
                rest: $d6ef25f90fa77b71$var$popSelection(branch),
                selection: selection
            }),
            userEvent: side == 0 /* BranchName.Done */  ? "select.undo" : "select.redo",
            scrollIntoView: true
        });
        else if (!event.changes) return null;
        else {
            let rest = branch.length == 1 ? $d6ef25f90fa77b71$var$none : branch.slice(0, branch.length - 1);
            if (event.mapped) rest = $d6ef25f90fa77b71$var$addMappingToBranch(rest, event.mapped);
            return state.update({
                changes: event.changes,
                selection: event.startSelection,
                effects: event.effects,
                annotations: $d6ef25f90fa77b71$var$fromHistory.of({
                    side: side,
                    rest: rest,
                    selection: selection
                }),
                filter: false,
                userEvent: side == 0 /* BranchName.Done */  ? "undo" : "redo",
                scrollIntoView: true
            });
        }
    }
}
$d6ef25f90fa77b71$var$HistoryState.empty = /*@__PURE__*/ new $d6ef25f90fa77b71$var$HistoryState($d6ef25f90fa77b71$var$none, $d6ef25f90fa77b71$var$none);
/**
Default key bindings for the undo history.

- Mod-z: [`undo`](https://codemirror.net/6/docs/ref/#commands.undo).
- Mod-y (Mod-Shift-z on macOS) + Ctrl-Shift-z on Linux: [`redo`](https://codemirror.net/6/docs/ref/#commands.redo).
- Mod-u: [`undoSelection`](https://codemirror.net/6/docs/ref/#commands.undoSelection).
- Alt-u (Mod-Shift-u on macOS): [`redoSelection`](https://codemirror.net/6/docs/ref/#commands.redoSelection).
*/ const $d6ef25f90fa77b71$export$ab4a28cb63e8a670 = [
    {
        key: "Mod-z",
        run: $d6ef25f90fa77b71$export$21f930c44940fd98,
        preventDefault: true
    },
    {
        key: "Mod-y",
        mac: "Mod-Shift-z",
        run: $d6ef25f90fa77b71$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        linux: "Ctrl-Shift-z",
        run: $d6ef25f90fa77b71$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        key: "Mod-u",
        run: $d6ef25f90fa77b71$export$43103d47530fe49f,
        preventDefault: true
    },
    {
        key: "Alt-u",
        mac: "Mod-Shift-u",
        run: $d6ef25f90fa77b71$export$2d87af80f1777f20,
        preventDefault: true
    }
];
function $d6ef25f90fa77b71$var$updateSel(sel, by) {
    return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create(sel.ranges.map(by), sel.mainIndex);
}
function $d6ef25f90fa77b71$var$setSel(state, selection) {
    return state.update({
        selection: selection,
        scrollIntoView: true,
        userEvent: "select"
    });
}
function $d6ef25f90fa77b71$var$moveSel({ state: state, dispatch: dispatch }, how) {
    let selection = $d6ef25f90fa77b71$var$updateSel(state.selection, how);
    if (selection.eq(state.selection, true)) return false;
    dispatch($d6ef25f90fa77b71$var$setSel(state, selection));
    return true;
}
function $d6ef25f90fa77b71$var$rangeEnd(range, forward) {
    return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(forward ? range.to : range.from);
}
function $d6ef25f90fa77b71$var$cursorByChar(view, forward) {
    return $d6ef25f90fa77b71$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, forward) : $d6ef25f90fa77b71$var$rangeEnd(range, forward));
}
function $d6ef25f90fa77b71$var$ltrAtCursor(view) {
    return view.textDirectionAt(view.state.selection.main.head) == (0, $b3e9d73db824614e$export$cacd6541cfeeb6c1).LTR;
}
/**
Move the selection one character to the left (which is backward in
left-to-right text, forward in right-to-left text).
*/ const $d6ef25f90fa77b71$export$3447f2b737925430 = (view)=>$d6ef25f90fa77b71$var$cursorByChar(view, !$d6ef25f90fa77b71$var$ltrAtCursor(view));
/**
Move the selection one character to the right.
*/ const $d6ef25f90fa77b71$export$e45941411d098b = (view)=>$d6ef25f90fa77b71$var$cursorByChar(view, $d6ef25f90fa77b71$var$ltrAtCursor(view));
/**
Move the selection one character forward.
*/ const $d6ef25f90fa77b71$export$25b7809021291927 = (view)=>$d6ef25f90fa77b71$var$cursorByChar(view, true);
/**
Move the selection one character backward.
*/ const $d6ef25f90fa77b71$export$6ddc33d0aa7a1b65 = (view)=>$d6ef25f90fa77b71$var$cursorByChar(view, false);
function $d6ef25f90fa77b71$var$byCharLogical(state, range, forward) {
    let pos = range.head, line = state.doc.lineAt(pos);
    if (pos == (forward ? line.to : line.from)) pos = forward ? Math.min(state.doc.length, line.to + 1) : Math.max(0, line.from - 1);
    else pos = line.from + (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward);
    return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
}
function $d6ef25f90fa77b71$var$moveByCharLogical(target, forward) {
    return $d6ef25f90fa77b71$var$moveSel(target, (range)=>range.empty ? $d6ef25f90fa77b71$var$byCharLogical(target.state, range, forward) : $d6ef25f90fa77b71$var$rangeEnd(range, forward));
}
/**
Move the selection one character forward, in logical
(non-text-direction-aware) string index order.
*/ const $d6ef25f90fa77b71$export$7ce32ef700b0ef27 = (target)=>$d6ef25f90fa77b71$var$moveByCharLogical(target, true);
/**
Move the selection one character backward, in logical string index
order.
*/ const $d6ef25f90fa77b71$export$a4c56edc7f7903df = (target)=>$d6ef25f90fa77b71$var$moveByCharLogical(target, false);
function $d6ef25f90fa77b71$var$cursorByGroup(view, forward) {
    return $d6ef25f90fa77b71$var$moveSel(view, (range)=>range.empty ? view.moveByGroup(range, forward) : $d6ef25f90fa77b71$var$rangeEnd(range, forward));
}
/**
Move the selection to the left across one group of word or
non-word (but also non-space) characters.
*/ const $d6ef25f90fa77b71$export$137fb1611fb38377 = (view)=>$d6ef25f90fa77b71$var$cursorByGroup(view, !$d6ef25f90fa77b71$var$ltrAtCursor(view));
/**
Move the selection one group to the right.
*/ const $d6ef25f90fa77b71$export$8fb2c619d55341b4 = (view)=>$d6ef25f90fa77b71$var$cursorByGroup(view, $d6ef25f90fa77b71$var$ltrAtCursor(view));
/**
Move the selection one group forward.
*/ const $d6ef25f90fa77b71$export$ce8d94762dbdebb8 = (view)=>$d6ef25f90fa77b71$var$cursorByGroup(view, true);
/**
Move the selection one group backward.
*/ const $d6ef25f90fa77b71$export$dd83d1d646f184d8 = (view)=>$d6ef25f90fa77b71$var$cursorByGroup(view, false);
function $d6ef25f90fa77b71$var$toGroupStart(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start), initial = cat != (0, $3ef527dddcdea745$export$239a3d59567c1401).Space;
    return (next)=>{
        let nextCat = categorize(next);
        if (nextCat != (0, $3ef527dddcdea745$export$239a3d59567c1401).Space) return initial && nextCat == cat;
        initial = false;
        return true;
    };
}
/**
Move the cursor one group forward in the default Windows style,
where it moves to the start of the next group.
*/ const $d6ef25f90fa77b71$export$c0e6054be0198e65 = (view)=>{
    return $d6ef25f90fa77b71$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, true, (start)=>$d6ef25f90fa77b71$var$toGroupStart(view, range.head, start)) : $d6ef25f90fa77b71$var$rangeEnd(range, true));
};
const $d6ef25f90fa77b71$var$segmenter = typeof Intl != "undefined" && Intl.Segmenter ? /*@__PURE__*/ new Intl.Segmenter(undefined, {
    granularity: "word"
}) : null;
function $d6ef25f90fa77b71$var$moveBySubword(view, range, forward) {
    let categorize = view.state.charCategorizer(range.from);
    let cat = (0, $3ef527dddcdea745$export$239a3d59567c1401).Space, pos = range.from, steps = 0;
    let done = false, sawUpper = false, sawLower = false;
    let step = (next)=>{
        if (done) return false;
        pos += forward ? next.length : -next.length;
        let nextCat = categorize(next), ahead;
        if (nextCat == (0, $3ef527dddcdea745$export$239a3d59567c1401).Word && next.charCodeAt(0) < 128 && /[\W_]/.test(next)) nextCat = -1; // Treat word punctuation specially
        if (cat == (0, $3ef527dddcdea745$export$239a3d59567c1401).Space) cat = nextCat;
        if (cat != nextCat) return false;
        if (cat == (0, $3ef527dddcdea745$export$239a3d59567c1401).Word) {
            if (next.toLowerCase() == next) {
                if (!forward && sawUpper) return false;
                sawLower = true;
            } else if (sawLower) {
                if (forward) return false;
                done = true;
            } else {
                if (sawUpper && forward && categorize(ahead = view.state.sliceDoc(pos, pos + 1)) == (0, $3ef527dddcdea745$export$239a3d59567c1401).Word && ahead.toLowerCase() == ahead) return false;
                sawUpper = true;
            }
        }
        steps++;
        return true;
    };
    let end = view.moveByChar(range, forward, (start)=>{
        step(start);
        return step;
    });
    if ($d6ef25f90fa77b71$var$segmenter && cat == (0, $3ef527dddcdea745$export$239a3d59567c1401).Word && end.from == range.from + steps * (forward ? 1 : -1)) {
        let from = Math.min(range.head, end.head), to = Math.max(range.head, end.head);
        let skipped = view.state.sliceDoc(from, to);
        if (skipped.length > 1 && /[\u4E00-\uffff]/.test(skipped)) {
            let segments = Array.from($d6ef25f90fa77b71$var$segmenter.segment(skipped));
            if (segments.length > 1) {
                if (forward) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(range.head + segments[1].index, -1);
                return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(end.head + segments[segments.length - 1].index, 1);
            }
        }
    }
    return end;
}
function $d6ef25f90fa77b71$var$cursorBySubword(view, forward) {
    return $d6ef25f90fa77b71$var$moveSel(view, (range)=>range.empty ? $d6ef25f90fa77b71$var$moveBySubword(view, range, forward) : $d6ef25f90fa77b71$var$rangeEnd(range, forward));
}
/**
Move the selection one group or camel-case subword forward.
*/ const $d6ef25f90fa77b71$export$d969a5b0dca9c3e2 = (view)=>$d6ef25f90fa77b71$var$cursorBySubword(view, true);
/**
Move the selection one group or camel-case subword backward.
*/ const $d6ef25f90fa77b71$export$ade35f5607ad3d82 = (view)=>$d6ef25f90fa77b71$var$cursorBySubword(view, false);
function $d6ef25f90fa77b71$var$interestingNode(state, node, bracketProp) {
    if (node.type.prop(bracketProp)) return true;
    let len = node.to - node.from;
    return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function $d6ef25f90fa77b71$var$moveBySyntax(state, start, forward) {
    let pos = (0, $d245ca63c4fe5041$export$7fc98e56a4ca6be1)(state).resolveInner(start.head);
    let bracketProp = forward ? (0, $7c348856541b1efa$export$b8034b9bc18acd90).closedBy : (0, $7c348856541b1efa$export$b8034b9bc18acd90).openedBy;
    // Scan forward through child nodes to see if there's an interesting
    // node ahead.
    for(let at = start.head;;){
        let next = forward ? pos.childAfter(at) : pos.childBefore(at);
        if (!next) break;
        if ($d6ef25f90fa77b71$var$interestingNode(state, next, bracketProp)) pos = next;
        else at = forward ? next.to : next.from;
    }
    let bracket = pos.type.prop(bracketProp), match, newPos;
    if (bracket && (match = forward ? (0, $d245ca63c4fe5041$export$3391942603e90cda)(state, pos.from, 1) : (0, $d245ca63c4fe5041$export$3391942603e90cda)(state, pos.to, -1)) && match.matched) newPos = forward ? match.end.to : match.end.from;
    else newPos = forward ? pos.to : pos.from;
    return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(newPos, forward ? -1 : 1);
}
/**
Move the cursor over the next syntactic element to the left.
*/ const $d6ef25f90fa77b71$export$1e53c014543c10bb = (view)=>$d6ef25f90fa77b71$var$moveSel(view, (range)=>$d6ef25f90fa77b71$var$moveBySyntax(view.state, range, !$d6ef25f90fa77b71$var$ltrAtCursor(view)));
/**
Move the cursor over the next syntactic element to the right.
*/ const $d6ef25f90fa77b71$export$62c6dc33f5d01e39 = (view)=>$d6ef25f90fa77b71$var$moveSel(view, (range)=>$d6ef25f90fa77b71$var$moveBySyntax(view.state, range, $d6ef25f90fa77b71$var$ltrAtCursor(view)));
function $d6ef25f90fa77b71$var$cursorByLine(view, forward) {
    return $d6ef25f90fa77b71$var$moveSel(view, (range)=>{
        if (!range.empty) return $d6ef25f90fa77b71$var$rangeEnd(range, forward);
        let moved = view.moveVertically(range, forward);
        return moved.head != range.head ? moved : view.moveToLineBoundary(range, forward);
    });
}
/**
Move the selection one line up.
*/ const $d6ef25f90fa77b71$export$fe179dad0485d99d = (view)=>$d6ef25f90fa77b71$var$cursorByLine(view, false);
/**
Move the selection one line down.
*/ const $d6ef25f90fa77b71$export$75f9b75ffb1a9dc5 = (view)=>$d6ef25f90fa77b71$var$cursorByLine(view, true);
function $d6ef25f90fa77b71$var$pageInfo(view) {
    let selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
    let marginTop = 0, marginBottom = 0, height;
    if (selfScroll) {
        for (let source of view.state.facet((0, $b3e9d73db824614e$export$eece2fccabbb77c5).scrollMargins)){
            let margins = source(view);
            if (margins === null || margins === void 0 ? void 0 : margins.top) marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
            if (margins === null || margins === void 0 ? void 0 : margins.bottom) marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
        }
        height = view.scrollDOM.clientHeight - marginTop - marginBottom;
    } else height = (view.dom.ownerDocument.defaultView || window).innerHeight;
    return {
        marginTop: marginTop,
        marginBottom: marginBottom,
        selfScroll: selfScroll,
        height: Math.max(view.defaultLineHeight, height - 5)
    };
}
function $d6ef25f90fa77b71$var$cursorByPage(view, forward) {
    let page = $d6ef25f90fa77b71$var$pageInfo(view);
    let { state: state } = view, selection = $d6ef25f90fa77b71$var$updateSel(state.selection, (range)=>{
        return range.empty ? view.moveVertically(range, forward, page.height) : $d6ef25f90fa77b71$var$rangeEnd(range, forward);
    });
    if (selection.eq(state.selection)) return false;
    let effect;
    if (page.selfScroll) {
        let startPos = view.coordsAtPos(state.selection.main.head);
        let scrollRect = view.scrollDOM.getBoundingClientRect();
        let scrollTop = scrollRect.top + page.marginTop, scrollBottom = scrollRect.bottom - page.marginBottom;
        if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom) effect = (0, $b3e9d73db824614e$export$eece2fccabbb77c5).scrollIntoView(selection.main.head, {
            y: "start",
            yMargin: startPos.top - scrollTop
        });
    }
    view.dispatch($d6ef25f90fa77b71$var$setSel(state, selection), {
        effects: effect
    });
    return true;
}
/**
Move the selection one page up.
*/ const $d6ef25f90fa77b71$export$546ec71a9f854193 = (view)=>$d6ef25f90fa77b71$var$cursorByPage(view, false);
/**
Move the selection one page down.
*/ const $d6ef25f90fa77b71$export$6e407c2072d437f4 = (view)=>$d6ef25f90fa77b71$var$cursorByPage(view, true);
function $d6ef25f90fa77b71$var$moveByLineBoundary(view, start, forward) {
    let line = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
    if (moved.head == start.head && moved.head != (forward ? line.to : line.from)) moved = view.moveToLineBoundary(start, forward, false);
    if (!forward && moved.head == line.from && line.length) {
        let space = /^\s*/.exec(view.state.sliceDoc(line.from, Math.min(line.from + 100, line.to)))[0].length;
        if (space && start.head != line.from + space) moved = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(line.from + space);
    }
    return moved;
}
/**
Move the selection to the next line wrap point, or to the end of
the line if there isn't one left on this line.
*/ const $d6ef25f90fa77b71$export$b59ae3b25af6ea13 = (view)=>$d6ef25f90fa77b71$var$moveSel(view, (range)=>$d6ef25f90fa77b71$var$moveByLineBoundary(view, range, true));
/**
Move the selection to previous line wrap point, or failing that to
the start of the line. If the line is indented, and the cursor
isn't already at the end of the indentation, this will move to the
end of the indentation instead of the start of the line.
*/ const $d6ef25f90fa77b71$export$64939ebc49b03818 = (view)=>$d6ef25f90fa77b71$var$moveSel(view, (range)=>$d6ef25f90fa77b71$var$moveByLineBoundary(view, range, false));
/**
Move the selection one line wrap point to the left.
*/ const $d6ef25f90fa77b71$export$515c8c77cfbd2e73 = (view)=>$d6ef25f90fa77b71$var$moveSel(view, (range)=>$d6ef25f90fa77b71$var$moveByLineBoundary(view, range, !$d6ef25f90fa77b71$var$ltrAtCursor(view)));
/**
Move the selection one line wrap point to the right.
*/ const $d6ef25f90fa77b71$export$912e453a1e062a62 = (view)=>$d6ef25f90fa77b71$var$moveSel(view, (range)=>$d6ef25f90fa77b71$var$moveByLineBoundary(view, range, $d6ef25f90fa77b71$var$ltrAtCursor(view)));
/**
Move the selection to the start of the line.
*/ const $d6ef25f90fa77b71$export$9c7dea99650bd512 = (view)=>$d6ef25f90fa77b71$var$moveSel(view, (range)=>(0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from, 1));
/**
Move the selection to the end of the line.
*/ const $d6ef25f90fa77b71$export$2a3cdaf3ab2dcbf2 = (view)=>$d6ef25f90fa77b71$var$moveSel(view, (range)=>(0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to, -1));
function $d6ef25f90fa77b71$var$toMatchingBracket(state, dispatch, extend) {
    let found = false, selection = $d6ef25f90fa77b71$var$updateSel(state.selection, (range)=>{
        let matching = (0, $d245ca63c4fe5041$export$3391942603e90cda)(state, range.head, -1) || (0, $d245ca63c4fe5041$export$3391942603e90cda)(state, range.head, 1) || range.head > 0 && (0, $d245ca63c4fe5041$export$3391942603e90cda)(state, range.head - 1, 1) || range.head < state.doc.length && (0, $d245ca63c4fe5041$export$3391942603e90cda)(state, range.head + 1, -1);
        if (!matching || !matching.end) return range;
        found = true;
        let head = matching.start.from == range.head ? matching.end.to : matching.end.from;
        return extend ? (0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(range.anchor, head) : (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(head);
    });
    if (!found) return false;
    dispatch($d6ef25f90fa77b71$var$setSel(state, selection));
    return true;
}
/**
Move the selection to the bracket matching the one it is currently
on, if any.
*/ const $d6ef25f90fa77b71$export$e5a7e1f2d38b1f6a = ({ state: state, dispatch: dispatch })=>$d6ef25f90fa77b71$var$toMatchingBracket(state, dispatch, false);
/**
Extend the selection to the bracket matching the one the selection
head is currently on, if any.
*/ const $d6ef25f90fa77b71$export$a56168b85007a381 = ({ state: state, dispatch: dispatch })=>$d6ef25f90fa77b71$var$toMatchingBracket(state, dispatch, true);
function $d6ef25f90fa77b71$var$extendSel(target, forward, how) {
    let selection = $d6ef25f90fa77b71$var$updateSel(target.state.selection, (range)=>{
        if (range.undirectional && range.head >= range.anchor != forward) range = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(range.head, range.anchor);
        let head = how(range);
        return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(range.anchor, head.head, head.goalColumn, head.bidiLevel || undefined, head.assoc);
    });
    if (selection.eq(target.state.selection)) return false;
    target.dispatch($d6ef25f90fa77b71$var$setSel(target.state, selection));
    return true;
}
function $d6ef25f90fa77b71$var$selectByChar(view, forward) {
    return $d6ef25f90fa77b71$var$extendSel(view, forward, (range)=>view.moveByChar(range, forward));
}
/**
Move the selection head one character to the left, while leaving
the anchor in place.
*/ const $d6ef25f90fa77b71$export$639be832433387f = (view)=>$d6ef25f90fa77b71$var$selectByChar(view, !$d6ef25f90fa77b71$var$ltrAtCursor(view));
/**
Move the selection head one character to the right.
*/ const $d6ef25f90fa77b71$export$49e3d65796d89132 = (view)=>$d6ef25f90fa77b71$var$selectByChar(view, $d6ef25f90fa77b71$var$ltrAtCursor(view));
/**
Move the selection head one character forward.
*/ const $d6ef25f90fa77b71$export$6a18f0ec4e3aa4ba = (view)=>$d6ef25f90fa77b71$var$selectByChar(view, true);
/**
Move the selection head one character backward.
*/ const $d6ef25f90fa77b71$export$1132822fa6924c1d = (view)=>$d6ef25f90fa77b71$var$selectByChar(view, false);
/**
Move the selection head one character forward by logical
(non-direction aware) string index order.
*/ const $d6ef25f90fa77b71$export$74309692c7a8e2d9 = (target)=>$d6ef25f90fa77b71$var$extendSel(target, true, (range)=>$d6ef25f90fa77b71$var$byCharLogical(target.state, range, true));
/**
Move the selection head one character backward by logical string
index order.
*/ const $d6ef25f90fa77b71$export$2bfcd2df135aa168 = (target)=>$d6ef25f90fa77b71$var$extendSel(target, false, (range)=>$d6ef25f90fa77b71$var$byCharLogical(target.state, range, false));
function $d6ef25f90fa77b71$var$selectByGroup(view, forward) {
    return $d6ef25f90fa77b71$var$extendSel(view, forward, (range)=>view.moveByGroup(range, forward));
}
/**
Move the selection head one [group](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) to
the left.
*/ const $d6ef25f90fa77b71$export$ef839611b4c2ba40 = (view)=>$d6ef25f90fa77b71$var$selectByGroup(view, !$d6ef25f90fa77b71$var$ltrAtCursor(view));
/**
Move the selection head one group to the right.
*/ const $d6ef25f90fa77b71$export$5ebbb4cf65fe8a74 = (view)=>$d6ef25f90fa77b71$var$selectByGroup(view, $d6ef25f90fa77b71$var$ltrAtCursor(view));
/**
Move the selection head one group forward.
*/ const $d6ef25f90fa77b71$export$53ddb317471acf76 = (view)=>$d6ef25f90fa77b71$var$selectByGroup(view, true);
/**
Move the selection head one group backward.
*/ const $d6ef25f90fa77b71$export$65a2ce60964fa778 = (view)=>$d6ef25f90fa77b71$var$selectByGroup(view, false);
/**
Move the selection head one group forward in the default Windows
style, skipping to the start of the next group.
*/ const $d6ef25f90fa77b71$export$5ea626eef31f242e = (view)=>{
    return $d6ef25f90fa77b71$var$extendSel(view, true, (range)=>view.moveByChar(range, true, (start)=>$d6ef25f90fa77b71$var$toGroupStart(view, range.head, start)));
};
function $d6ef25f90fa77b71$var$selectBySubword(view, forward) {
    return $d6ef25f90fa77b71$var$extendSel(view, forward, (range)=>$d6ef25f90fa77b71$var$moveBySubword(view, range, forward));
}
/**
Move the selection head one group or camel-case subword forward.
*/ const $d6ef25f90fa77b71$export$c4f4d945a8760145 = (view)=>$d6ef25f90fa77b71$var$selectBySubword(view, true);
/**
Move the selection head one group or subword backward.
*/ const $d6ef25f90fa77b71$export$3a6caa1f1abce2e2 = (view)=>$d6ef25f90fa77b71$var$selectBySubword(view, false);
/**
Move the selection head over the next syntactic element to the left.
*/ const $d6ef25f90fa77b71$export$67b15be4414061b5 = (view)=>{
    let forward = !$d6ef25f90fa77b71$var$ltrAtCursor(view);
    return $d6ef25f90fa77b71$var$extendSel(view, forward, (range)=>$d6ef25f90fa77b71$var$moveBySyntax(view.state, range, forward));
};
/**
Move the selection head over the next syntactic element to the right.
*/ const $d6ef25f90fa77b71$export$74aa476df7791ce = (view)=>{
    let forward = $d6ef25f90fa77b71$var$ltrAtCursor(view);
    return $d6ef25f90fa77b71$var$extendSel(view, forward, (range)=>$d6ef25f90fa77b71$var$moveBySyntax(view.state, range, forward));
};
function $d6ef25f90fa77b71$var$selectByLine(view, forward) {
    return $d6ef25f90fa77b71$var$extendSel(view, forward, (range)=>view.moveVertically(range, forward));
}
/**
Move the selection head one line up.
*/ const $d6ef25f90fa77b71$export$92aa693a1ecd7061 = (view)=>$d6ef25f90fa77b71$var$selectByLine(view, false);
/**
Move the selection head one line down.
*/ const $d6ef25f90fa77b71$export$bf847527697a3040 = (view)=>$d6ef25f90fa77b71$var$selectByLine(view, true);
function $d6ef25f90fa77b71$var$selectByPage(view, forward) {
    return $d6ef25f90fa77b71$var$extendSel(view, forward, (range)=>view.moveVertically(range, forward, $d6ef25f90fa77b71$var$pageInfo(view).height));
}
/**
Move the selection head one page up.
*/ const $d6ef25f90fa77b71$export$61eab34d4ff5cbaf = (view)=>$d6ef25f90fa77b71$var$selectByPage(view, false);
/**
Move the selection head one page down.
*/ const $d6ef25f90fa77b71$export$a4c186a0dadaf91c = (view)=>$d6ef25f90fa77b71$var$selectByPage(view, true);
/**
Move the selection head to the next line boundary.
*/ const $d6ef25f90fa77b71$export$df223d0097d57a86 = (view)=>$d6ef25f90fa77b71$var$extendSel(view, true, (range)=>$d6ef25f90fa77b71$var$moveByLineBoundary(view, range, true));
/**
Move the selection head to the previous line boundary.
*/ const $d6ef25f90fa77b71$export$643176ee603b8e87 = (view)=>$d6ef25f90fa77b71$var$extendSel(view, false, (range)=>$d6ef25f90fa77b71$var$moveByLineBoundary(view, range, false));
/**
Move the selection head one line boundary to the left.
*/ const $d6ef25f90fa77b71$export$769cc61da74090c5 = (view)=>{
    let forward = !$d6ef25f90fa77b71$var$ltrAtCursor(view);
    return $d6ef25f90fa77b71$var$extendSel(view, forward, (range)=>$d6ef25f90fa77b71$var$moveByLineBoundary(view, range, forward));
};
/**
Move the selection head one line boundary to the right.
*/ const $d6ef25f90fa77b71$export$de427496204690a6 = (view)=>{
    let forward = $d6ef25f90fa77b71$var$ltrAtCursor(view);
    return $d6ef25f90fa77b71$var$extendSel(view, forward, (range)=>$d6ef25f90fa77b71$var$moveByLineBoundary(view, range, forward));
};
/**
Move the selection head to the start of the line.
*/ const $d6ef25f90fa77b71$export$a0e1e86f753956a4 = (view)=>$d6ef25f90fa77b71$var$extendSel(view, false, (range)=>(0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from));
/**
Move the selection head to the end of the line.
*/ const $d6ef25f90fa77b71$export$bd34a38d148e23af = (view)=>$d6ef25f90fa77b71$var$extendSel(view, true, (range)=>(0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to));
/**
Move the selection to the start of the document.
*/ const $d6ef25f90fa77b71$export$ff7ed6e6e1cb317f = ({ state: state, dispatch: dispatch })=>{
    dispatch($d6ef25f90fa77b71$var$setSel(state, {
        anchor: 0
    }));
    return true;
};
/**
Move the selection to the end of the document.
*/ const $d6ef25f90fa77b71$export$b12ef1671b2836da = ({ state: state, dispatch: dispatch })=>{
    dispatch($d6ef25f90fa77b71$var$setSel(state, {
        anchor: state.doc.length
    }));
    return true;
};
/**
Move the selection head to the start of the document.
*/ const $d6ef25f90fa77b71$export$aa525ee829cc26b = ({ state: state, dispatch: dispatch })=>{
    dispatch($d6ef25f90fa77b71$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: 0
    }));
    return true;
};
/**
Move the selection head to the end of the document.
*/ const $d6ef25f90fa77b71$export$fff0131cdd9694fe = ({ state: state, dispatch: dispatch })=>{
    dispatch($d6ef25f90fa77b71$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: state.doc.length
    }));
    return true;
};
/**
Select the entire document.
*/ const $d6ef25f90fa77b71$export$90aca4adda6ff0f5 = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update({
        selection: {
            anchor: 0,
            head: state.doc.length
        },
        userEvent: "select"
    }));
    return true;
};
/**
Expand the selection to cover entire lines.
*/ const $d6ef25f90fa77b71$export$e41c12847640c21 = ({ state: state, dispatch: dispatch })=>{
    let ranges = $d6ef25f90fa77b71$var$selectedLineBlocks(state).map(({ from: from, to: to })=>(0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(from, Math.min(to + 1, state.doc.length)));
    dispatch(state.update({
        selection: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create(ranges),
        userEvent: "select"
    }));
    return true;
};
/**
Select the next syntactic construct that is larger than the
selection. Note that this will only work insofar as the language
[provider](https://codemirror.net/6/docs/ref/#language.language) you use builds up a full
syntax tree.
*/ const $d6ef25f90fa77b71$export$f38a48fa120d50ce = ({ state: state, dispatch: dispatch })=>{
    let selection = $d6ef25f90fa77b71$var$updateSel(state.selection, (range)=>{
        let tree = (0, $d245ca63c4fe5041$export$7fc98e56a4ca6be1)(state), stack = tree.resolveStack(range.from, 1);
        if (range.empty) {
            let stackBefore = tree.resolveStack(range.from, -1);
            if (stackBefore.node.from >= stack.node.from && stackBefore.node.to <= stack.node.to) stack = stackBefore;
        }
        for(let cur = stack; cur; cur = cur.next){
            let { node: node } = cur;
            if ((node.from < range.from && node.to >= range.to || node.to > range.to && node.from <= range.from) && cur.next) return (0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(node.to, node.from);
        }
        return range;
    });
    if (selection.eq(state.selection)) return false;
    dispatch($d6ef25f90fa77b71$var$setSel(state, selection));
    return true;
};
function $d6ef25f90fa77b71$var$addCursorVertically(view, forward) {
    let { state: state } = view, sel = state.selection, ranges = state.selection.ranges.slice();
    for (let range of state.selection.ranges){
        let line = state.doc.lineAt(range.head);
        if (forward ? line.to < view.state.doc.length : line.from > 0) for(let cur = range;;){
            let next = view.moveVertically(cur, forward);
            if (next.head < line.from || next.head > line.to) {
                if (!ranges.some((r)=>r.head == next.head)) ranges.push(next);
                break;
            } else if (next.head == cur.head) break;
            else cur = next;
        }
    }
    if (ranges.length == sel.ranges.length) return false;
    view.dispatch($d6ef25f90fa77b71$var$setSel(state, (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create(ranges, ranges.length - 1)));
    return true;
}
/**
Expand the selection by adding a cursor above the heads of
currently selected ranges.
*/ const $d6ef25f90fa77b71$export$3054522ff62988dd = (view)=>$d6ef25f90fa77b71$var$addCursorVertically(view, false);
/**
Expand the selection by adding a cursor below the heads of
currently selected ranges.
*/ const $d6ef25f90fa77b71$export$83ff5bba776179f3 = (view)=>$d6ef25f90fa77b71$var$addCursorVertically(view, true);
/**
Simplify the current selection. When multiple ranges are selected,
reduce it to its main range. Otherwise, if the selection is
non-empty, convert it to a cursor selection.
*/ const $d6ef25f90fa77b71$export$2f90cebc0d40abf = ({ state: state, dispatch: dispatch })=>{
    let cur = state.selection, selection = null;
    if (cur.ranges.length > 1) selection = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create([
        cur.main
    ]);
    else if (!cur.main.empty) selection = (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create([
        (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(cur.main.head)
    ]);
    if (!selection) return false;
    dispatch($d6ef25f90fa77b71$var$setSel(state, selection));
    return true;
};
function $d6ef25f90fa77b71$var$deleteBy(target, by) {
    if (target.state.readOnly) return false;
    let event = "delete.selection", { state: state } = target;
    let changes = state.changeByRange((range)=>{
        let { from: from, to: to } = range;
        if (from == to) {
            let towards = by(range);
            if (towards < from) {
                event = "delete.backward";
                towards = $d6ef25f90fa77b71$var$skipAtomic(target, towards, false);
            } else if (towards > from) {
                event = "delete.forward";
                towards = $d6ef25f90fa77b71$var$skipAtomic(target, towards, true);
            }
            from = Math.min(from, towards);
            to = Math.max(to, towards);
        } else {
            from = $d6ef25f90fa77b71$var$skipAtomic(target, from, false);
            to = $d6ef25f90fa77b71$var$skipAtomic(target, to, true);
        }
        return from == to ? {
            range: range
        } : {
            changes: {
                from: from,
                to: to
            },
            range: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(from, from < range.head ? -1 : 1)
        };
    });
    if (changes.changes.empty) return false;
    target.dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: event,
        effects: event == "delete.selection" ? (0, $b3e9d73db824614e$export$eece2fccabbb77c5).announce.of(state.phrase("Selection deleted")) : undefined
    }));
    return true;
}
function $d6ef25f90fa77b71$var$skipAtomic(target, pos, forward) {
    if (target instanceof (0, $b3e9d73db824614e$export$eece2fccabbb77c5)) for (let ranges of target.state.facet((0, $b3e9d73db824614e$export$eece2fccabbb77c5).atomicRanges).map((f)=>f(target)))ranges.between(pos, pos, (from, to)=>{
        if (from < pos && to > pos) pos = forward ? to : from;
    });
    return pos;
}
const $d6ef25f90fa77b71$var$deleteByChar = (target, forward, byIndentUnit)=>$d6ef25f90fa77b71$var$deleteBy(target, (range)=>{
        let pos = range.from, { state: state } = target, line = state.doc.lineAt(pos), before, targetPos;
        if (byIndentUnit && !forward && pos > line.from && pos < line.from + 200 && !/[^ \t]/.test(before = line.text.slice(0, pos - line.from))) {
            if (before[before.length - 1] == "\t") return pos - 1;
            let col = (0, $3ef527dddcdea745$export$20b4ab289374d0ac)(before, state.tabSize), drop = col % (0, $d245ca63c4fe5041$export$ad3205d09311a797)(state) || (0, $d245ca63c4fe5041$export$ad3205d09311a797)(state);
            for(let i = 0; i < drop && before[before.length - 1 - i] == " "; i++)pos--;
            targetPos = pos;
        } else {
            targetPos = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward, forward) + line.from;
            if (targetPos == pos && line.number != (forward ? state.doc.lines : 1)) targetPos += forward ? 1 : -1;
            else if (!forward && /[\ufe00-\ufe0f]/.test(line.text.slice(targetPos - line.from, pos - line.from))) targetPos = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, targetPos - line.from, false, false) + line.from;
        }
        return targetPos;
    });
/**
Delete the selection, or, for cursor selections, the character or
indentation unit before the cursor.
*/ const $d6ef25f90fa77b71$export$1e8a14efe7ca9a33 = (view)=>$d6ef25f90fa77b71$var$deleteByChar(view, false, true);
/**
Delete the selection or the character before the cursor. Does not
implement any extended behavior like deleting whole indentation
units in one go.
*/ const $d6ef25f90fa77b71$export$3365c1d7b1abe7df = (view)=>$d6ef25f90fa77b71$var$deleteByChar(view, false, false);
/**
Delete the selection or the character after the cursor.
*/ const $d6ef25f90fa77b71$export$d41683a0f042cb80 = (view)=>$d6ef25f90fa77b71$var$deleteByChar(view, true, false);
const $d6ef25f90fa77b71$var$deleteByGroup = (target, forward)=>$d6ef25f90fa77b71$var$deleteBy(target, (range)=>{
        let pos = range.head, { state: state } = target, line = state.doc.lineAt(pos);
        let categorize = state.charCategorizer(pos);
        for(let cat = null;;){
            if (pos == (forward ? line.to : line.from)) {
                if (pos == range.head && line.number != (forward ? state.doc.lines : 1)) pos += forward ? 1 : -1;
                break;
            }
            let next = (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward) + line.from;
            let nextChar = line.text.slice(Math.min(pos, next) - line.from, Math.max(pos, next) - line.from);
            let nextCat = categorize(nextChar);
            if (cat != null && nextCat != cat) break;
            if (nextChar != " " || pos != range.head) cat = nextCat;
            pos = next;
        }
        return pos;
    });
/**
Delete the selection or backward until the end of the next
[group](https://codemirror.net/6/docs/ref/#view.EditorView.moveByGroup), only skipping groups of
whitespace when they consist of a single space.
*/ const $d6ef25f90fa77b71$export$3072f591ab219e94 = (target)=>$d6ef25f90fa77b71$var$deleteByGroup(target, false);
/**
Delete the selection or forward until the end of the next group.
*/ const $d6ef25f90fa77b71$export$56a4e2ef21b58242 = (target)=>$d6ef25f90fa77b71$var$deleteByGroup(target, true);
/**
Variant of [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
that uses the Windows convention of also deleting the whitespace
after a word.
*/ const $d6ef25f90fa77b71$export$94136ce5bc6ca33e = (view)=>$d6ef25f90fa77b71$var$deleteBy(view, (range)=>view.moveByChar(range, true, (start)=>$d6ef25f90fa77b71$var$toGroupStart(view, range.head, start)).head);
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line. If the cursor is directly at the end of the
line, delete the line break after it.
*/ const $d6ef25f90fa77b71$export$ae3820c4ce0e9c92 = (view)=>$d6ef25f90fa77b71$var$deleteBy(view, (range)=>{
        let lineEnd = view.lineBlockAt(range.head).to;
        return range.head < lineEnd ? lineEnd : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line. If the cursor is directly at the start of the
line, delete the line break before it.
*/ const $d6ef25f90fa77b71$export$dc80e21fb31e84a5 = (view)=>$d6ef25f90fa77b71$var$deleteBy(view, (range)=>{
        let lineStart = view.lineBlockAt(range.head).from;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line or the next line wrap before the cursor.
*/ const $d6ef25f90fa77b71$export$d1072494cede984a = (view)=>$d6ef25f90fa77b71$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, false).head;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line or the next line wrap after the cursor.
*/ const $d6ef25f90fa77b71$export$b87eb3a389c264a4 = (view)=>$d6ef25f90fa77b71$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, true).head;
        return range.head < lineStart ? lineStart : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete all whitespace directly before a line end from the
document.
*/ const $d6ef25f90fa77b71$export$8acd3a9fe3872724 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = [];
    for(let pos = 0, prev = "", iter = state.doc.iter();;){
        iter.next();
        if (iter.lineBreak || iter.done) {
            let trailing = prev.search(/\s+$/);
            if (trailing > -1) changes.push({
                from: pos - (prev.length - trailing),
                to: pos
            });
            if (iter.done) break;
            prev = "";
        } else prev = iter.value;
        pos += iter.value.length;
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        userEvent: "delete"
    }));
    return true;
};
/**
Replace each selection range with a line break, leaving the cursor
on the line before the break.
*/ const $d6ef25f90fa77b71$export$a258d4581e1d5d3c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).of([
                    "",
                    ""
                ])
            },
            range: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(range.from)
        };
    });
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Flip the characters before and after the cursor(s).
*/ const $d6ef25f90fa77b71$export$55467a37288e4063 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        if (!range.empty || range.from == 0 || range.from == state.doc.length) return {
            range: range
        };
        let pos = range.from, line = state.doc.lineAt(pos);
        let from = pos == line.from ? pos - 1 : (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, pos - line.from, false) + line.from;
        let to = pos == line.to ? pos + 1 : (0, $3ef527dddcdea745$export$a0fa439fd515e1ed)(line.text, pos - line.from, true) + line.from;
        return {
            changes: {
                from: from,
                to: to,
                insert: state.doc.slice(pos, to).append(state.doc.slice(from, pos))
            },
            range: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(to)
        };
    });
    if (changes.changes.empty) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "move.character"
    }));
    return true;
};
function $d6ef25f90fa77b71$var$selectedLineBlocks(state) {
    let blocks = [], upto = -1;
    for (let range of state.selection.ranges){
        let startLine = state.doc.lineAt(range.from), endLine = state.doc.lineAt(range.to);
        if (!range.empty && range.to == endLine.from) endLine = state.doc.lineAt(range.to - 1);
        if (upto >= startLine.number) {
            let prev = blocks[blocks.length - 1];
            prev.to = endLine.to;
            prev.ranges.push(range);
        } else blocks.push({
            from: startLine.from,
            to: endLine.to,
            ranges: [
                range
            ]
        });
        upto = endLine.number + 1;
    }
    return blocks;
}
function $d6ef25f90fa77b71$var$moveLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [], ranges = [];
    for (let block of $d6ef25f90fa77b71$var$selectedLineBlocks(state)){
        if (forward ? block.to == state.doc.length : block.from == 0) continue;
        let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
        let size = nextLine.length + 1;
        if (forward) {
            changes.push({
                from: block.to,
                to: nextLine.to
            }, {
                from: block.from,
                insert: nextLine.text + state.lineBreak
            });
            for (let r of block.ranges)ranges.push((0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(Math.min(state.doc.length, r.anchor + size), Math.min(state.doc.length, r.head + size)));
        } else {
            changes.push({
                from: nextLine.from,
                to: block.from
            }, {
                from: block.to,
                insert: state.lineBreak + nextLine.text
            });
            for (let r of block.ranges)ranges.push((0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(r.anchor - size, r.head - size));
        }
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        selection: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).create(ranges, state.selection.mainIndex),
        userEvent: "move.line"
    }));
    return true;
}
/**
Move the selected lines up one line.
*/ const $d6ef25f90fa77b71$export$c4eebaf75cfae23e = ({ state: state, dispatch: dispatch })=>$d6ef25f90fa77b71$var$moveLine(state, dispatch, false);
/**
Move the selected lines down one line.
*/ const $d6ef25f90fa77b71$export$ac19ae98a6fcd34c = ({ state: state, dispatch: dispatch })=>$d6ef25f90fa77b71$var$moveLine(state, dispatch, true);
function $d6ef25f90fa77b71$var$copyLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [];
    for (let block of $d6ef25f90fa77b71$var$selectedLineBlocks(state))if (forward) changes.push({
        from: block.from,
        insert: state.doc.slice(block.from, block.to) + state.lineBreak
    });
    else changes.push({
        from: block.to,
        insert: state.lineBreak + state.doc.slice(block.from, block.to)
    });
    let changeSet = state.changes(changes);
    dispatch(state.update({
        changes: changeSet,
        selection: state.selection.map(changeSet, forward ? 1 : -1),
        scrollIntoView: true,
        userEvent: "input.copyline"
    }));
    return true;
}
/**
Create a copy of the selected lines. Keep the selection in the top copy.
*/ const $d6ef25f90fa77b71$export$c3798d29213e527c = ({ state: state, dispatch: dispatch })=>$d6ef25f90fa77b71$var$copyLine(state, dispatch, false);
/**
Create a copy of the selected lines. Keep the selection in the bottom copy.
*/ const $d6ef25f90fa77b71$export$1ad385c375816d2f = ({ state: state, dispatch: dispatch })=>$d6ef25f90fa77b71$var$copyLine(state, dispatch, true);
/**
Delete selected lines.
*/ const $d6ef25f90fa77b71$export$aba0d4cd8923f1ae = (view)=>{
    if (view.state.readOnly) return false;
    let { state: state } = view, changes = state.changes($d6ef25f90fa77b71$var$selectedLineBlocks(state).map(({ from: from, to: to })=>{
        if (from > 0) from--;
        else if (to < state.doc.length) to++;
        return {
            from: from,
            to: to
        };
    }));
    let selection = $d6ef25f90fa77b71$var$updateSel(state.selection, (range)=>{
        let dist = undefined;
        if (view.lineWrapping) {
            let block = view.lineBlockAt(range.head), pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (pos) dist = block.bottom + view.documentTop - pos.bottom + view.defaultLineHeight / 2;
        }
        return view.moveVertically(range, true, dist);
    }).map(changes);
    view.dispatch({
        changes: changes,
        selection: selection,
        scrollIntoView: true,
        userEvent: "delete.line"
    });
    return true;
};
/**
Replace the selection with a newline.
*/ const $d6ef25f90fa77b71$export$e7e1d174affeae8d = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.replaceSelection(state.lineBreak), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Replace the selection with a newline and the same amount of
indentation as the line above.
*/ const $d6ef25f90fa77b71$export$8dc33eb9291e07ef = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.changeByRange((range)=>{
        let indent = /^\s*/.exec(state.doc.lineAt(range.from).text)[0];
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: state.lineBreak + indent
            },
            range: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(range.from + indent.length + 1)
        };
    }), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
function $d6ef25f90fa77b71$var$isBetweenBrackets(state, pos) {
    if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1))) return {
        from: pos,
        to: pos
    };
    let context = (0, $d245ca63c4fe5041$export$7fc98e56a4ca6be1)(state).resolveInner(pos);
    let before = context.childBefore(pos), after = context.childAfter(pos), closedBy;
    if (before && after && before.to <= pos && after.from >= pos && (closedBy = before.type.prop((0, $7c348856541b1efa$export$b8034b9bc18acd90).closedBy)) && closedBy.indexOf(after.name) > -1 && state.doc.lineAt(before.to).from == state.doc.lineAt(after.from).from && !/\S/.test(state.sliceDoc(before.to, after.from))) return {
        from: before.to,
        to: after.from
    };
    return null;
}
/**
Replace the selection with a newline and indent the newly created
line(s). If the current line consists only of whitespace, this
will also delete that whitespace. When the cursor is between
matching brackets, an additional newline will be inserted after
the cursor.
*/ const $d6ef25f90fa77b71$export$668310d2b1aa07d5 = /*@__PURE__*/ $d6ef25f90fa77b71$var$newlineAndIndent(false);
/**
Create a blank, indented line below the current line.
*/ const $d6ef25f90fa77b71$export$2ff1ccbcf65d0770 = /*@__PURE__*/ $d6ef25f90fa77b71$var$newlineAndIndent(true);
function $d6ef25f90fa77b71$var$newlineAndIndent(atEof) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let changes = state.changeByRange((range)=>{
            let { from: from, to: to } = range, line = state.doc.lineAt(from);
            let explode = !atEof && from == to && $d6ef25f90fa77b71$var$isBetweenBrackets(state, from);
            if (atEof) from = to = (to <= line.to ? line : state.doc.lineAt(to)).to;
            let cx = new (0, $d245ca63c4fe5041$export$eeab79349cc2f7c8)(state, {
                simulateBreak: from,
                simulateDoubleBreak: !!explode
            });
            let indent = (0, $d245ca63c4fe5041$export$a2d3c9dbce6d2211)(cx, from);
            if (indent == null) indent = (0, $3ef527dddcdea745$export$20b4ab289374d0ac)(/^\s*/.exec(state.doc.lineAt(from).text)[0], state.tabSize);
            while(to < line.to && /\s/.test(line.text[to - line.from]))to++;
            if (explode) ({ from: from, to: to } = explode);
            else if (from > line.from && from < line.from + 100 && !/\S/.test(line.text.slice(0, from))) from = line.from;
            let insert = [
                "",
                (0, $d245ca63c4fe5041$export$db5a40e207b40576)(state, indent)
            ];
            if (explode) insert.push((0, $d245ca63c4fe5041$export$db5a40e207b40576)(state, cx.lineIndent(line.from, -1)));
            return {
                changes: {
                    from: from,
                    to: to,
                    insert: (0, $3ef527dddcdea745$export$5f1af8db9871e1d6).of(insert)
                },
                range: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).cursor(from + 1 + insert[1].length)
            };
        });
        dispatch(state.update(changes, {
            scrollIntoView: true,
            userEvent: "input"
        }));
        return true;
    };
}
function $d6ef25f90fa77b71$var$changeBySelectedLine(state, f) {
    let atLine = -1;
    return state.changeByRange((range)=>{
        let changes = [];
        for(let pos = range.from; pos <= range.to;){
            let line = state.doc.lineAt(pos);
            if (line.number > atLine && (range.empty || range.to > line.from)) {
                f(line, changes, range);
                atLine = line.number;
            }
            pos = line.to + 1;
        }
        let changeSet = state.changes(changes);
        return {
            changes: changes,
            range: (0, $3ef527dddcdea745$export$3bb1bd44aee62999).range(changeSet.mapPos(range.anchor, 1), changeSet.mapPos(range.head, 1))
        };
    });
}
/**
Auto-indent the selected lines. This uses the [indentation service
facet](https://codemirror.net/6/docs/ref/#language.indentService) as source for auto-indent
information.
*/ const $d6ef25f90fa77b71$export$ffcf50534fec79c3 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let updated = Object.create(null);
    let context = new (0, $d245ca63c4fe5041$export$eeab79349cc2f7c8)(state, {
        overrideIndentation: (start)=>{
            let found = updated[start];
            return found == null ? -1 : found;
        }
    });
    let changes = $d6ef25f90fa77b71$var$changeBySelectedLine(state, (line, changes, range)=>{
        let indent = (0, $d245ca63c4fe5041$export$a2d3c9dbce6d2211)(context, line.from);
        if (indent == null) return;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = (0, $d245ca63c4fe5041$export$db5a40e207b40576)(state, indent);
        if (cur != norm || range.from < line.from + cur.length) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    });
    if (!changes.changes.empty) dispatch(state.update(changes, {
        userEvent: "indent"
    }));
    return true;
};
/**
Add a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation to all selected
lines.
*/ const $d6ef25f90fa77b71$export$a61bf6a946ffc826 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($d6ef25f90fa77b71$var$changeBySelectedLine(state, (line, changes)=>{
        changes.push({
            from: line.from,
            insert: state.facet((0, $d245ca63c4fe5041$export$9e0d0c2ce4d3ceb5))
        });
    }), {
        userEvent: "input.indent"
    }));
    return true;
};
/**
Remove a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation from all
selected lines.
*/ const $d6ef25f90fa77b71$export$e4b902122bfe67ae = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($d6ef25f90fa77b71$var$changeBySelectedLine(state, (line, changes)=>{
        let space = /^\s*/.exec(line.text)[0];
        if (!space) return;
        let col = (0, $3ef527dddcdea745$export$20b4ab289374d0ac)(space, state.tabSize), keep = 0;
        let insert = (0, $d245ca63c4fe5041$export$db5a40e207b40576)(state, Math.max(0, col - (0, $d245ca63c4fe5041$export$ad3205d09311a797)(state)));
        while(keep < space.length && keep < insert.length && space.charCodeAt(keep) == insert.charCodeAt(keep))keep++;
        changes.push({
            from: line.from + keep,
            to: line.from + space.length,
            insert: insert.slice(keep)
        });
    }), {
        userEvent: "delete.dedent"
    }));
    return true;
};
/**
Enables or disables
[tab-focus mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode). While on, this
prevents the editor's key bindings from capturing Tab or
Shift-Tab, making it possible for the user to move focus out of
the editor with the keyboard.
*/ const $d6ef25f90fa77b71$export$f118650570e71643 = (view)=>{
    view.setTabFocusMode();
    return true;
};
/**
Temporarily enables [tab-focus
mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode) for two seconds or until
another key is pressed.
*/ const $d6ef25f90fa77b71$export$1f0650d3f23682c8 = (view)=>{
    view.setTabFocusMode(2000);
    return true;
};
/**
Insert a tab character at the cursor or, if something is selected,
use [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) to indent the entire
selection.
*/ const $d6ef25f90fa77b71$export$89b2fa0b43bd10f8 = ({ state: state, dispatch: dispatch })=>{
    if (state.selection.ranges.some((r)=>!r.empty)) return $d6ef25f90fa77b71$export$a61bf6a946ffc826({
        state: state,
        dispatch: dispatch
    });
    dispatch(state.update(state.replaceSelection("\t"), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Array of key bindings containing the Emacs-style bindings that are
available on macOS by default.

 - Ctrl-b: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - Ctrl-f: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-p: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - Ctrl-n: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Ctrl-a: [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Ctrl-e: [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - Ctrl-d: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-h: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Ctrl-k: [`deleteToLineEnd`](https://codemirror.net/6/docs/ref/#commands.deleteToLineEnd)
 - Ctrl-Alt-h: [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-o: [`splitLine`](https://codemirror.net/6/docs/ref/#commands.splitLine)
 - Ctrl-t: [`transposeChars`](https://codemirror.net/6/docs/ref/#commands.transposeChars)
 - Ctrl-v: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown)
 - Alt-v: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp)
*/ const $d6ef25f90fa77b71$export$ef7c3246c722c48f = [
    {
        key: "Ctrl-b",
        run: $d6ef25f90fa77b71$export$3447f2b737925430,
        shift: $d6ef25f90fa77b71$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Ctrl-f",
        run: $d6ef25f90fa77b71$export$e45941411d098b,
        shift: $d6ef25f90fa77b71$export$49e3d65796d89132
    },
    {
        key: "Ctrl-p",
        run: $d6ef25f90fa77b71$export$fe179dad0485d99d,
        shift: $d6ef25f90fa77b71$export$92aa693a1ecd7061
    },
    {
        key: "Ctrl-n",
        run: $d6ef25f90fa77b71$export$75f9b75ffb1a9dc5,
        shift: $d6ef25f90fa77b71$export$bf847527697a3040
    },
    {
        key: "Ctrl-a",
        run: $d6ef25f90fa77b71$export$9c7dea99650bd512,
        shift: $d6ef25f90fa77b71$export$a0e1e86f753956a4
    },
    {
        key: "Ctrl-e",
        run: $d6ef25f90fa77b71$export$2a3cdaf3ab2dcbf2,
        shift: $d6ef25f90fa77b71$export$bd34a38d148e23af
    },
    {
        key: "Ctrl-d",
        run: $d6ef25f90fa77b71$export$d41683a0f042cb80
    },
    {
        key: "Ctrl-h",
        run: $d6ef25f90fa77b71$export$1e8a14efe7ca9a33
    },
    {
        key: "Ctrl-k",
        run: $d6ef25f90fa77b71$export$ae3820c4ce0e9c92
    },
    {
        key: "Ctrl-Alt-h",
        run: $d6ef25f90fa77b71$export$3072f591ab219e94
    },
    {
        key: "Ctrl-o",
        run: $d6ef25f90fa77b71$export$a258d4581e1d5d3c
    },
    {
        key: "Ctrl-t",
        run: $d6ef25f90fa77b71$export$55467a37288e4063
    },
    {
        key: "Ctrl-v",
        run: $d6ef25f90fa77b71$export$6e407c2072d437f4
    }
];
/**
An array of key bindings closely sticking to platform-standard or
widely used bindings. (This includes the bindings from
[`emacsStyleKeymap`](https://codemirror.net/6/docs/ref/#commands.emacsStyleKeymap), with their `key`
property changed to `mac`.)

 - ArrowLeft: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - ArrowRight: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-ArrowLeft (Alt-ArrowLeft on macOS): [`cursorGroupLeft`](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) ([`selectGroupLeft`](https://codemirror.net/6/docs/ref/#commands.selectGroupLeft) with Shift)
 - Ctrl-ArrowRight (Alt-ArrowRight on macOS): [`cursorGroupRight`](https://codemirror.net/6/docs/ref/#commands.cursorGroupRight) ([`selectGroupRight`](https://codemirror.net/6/docs/ref/#commands.selectGroupRight) with Shift)
 - Cmd-ArrowLeft (on macOS): [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Cmd-ArrowRight (on macOS): [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - ArrowUp: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - ArrowDown: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Cmd-ArrowUp (on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Cmd-ArrowDown (on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Ctrl-ArrowUp (on macOS): [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - Ctrl-ArrowDown (on macOS): [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - PageUp: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - PageDown: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - Home: [`cursorLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryBackward) ([`selectLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryBackward) with Shift)
 - End: [`cursorLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryForward) ([`selectLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryForward) with Shift)
 - Ctrl-Home (Cmd-Home on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Ctrl-End (Cmd-Home on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Enter and Shift-Enter: [`insertNewlineAndIndent`](https://codemirror.net/6/docs/ref/#commands.insertNewlineAndIndent)
 - Ctrl-a (Cmd-a on macOS): [`selectAll`](https://codemirror.net/6/docs/ref/#commands.selectAll)
 - Backspace: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Delete: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-Backspace (Alt-Backspace on macOS): [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-Delete (Alt-Delete on macOS): [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
 - Cmd-Backspace (macOS): [`deleteLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryBackward).
 - Cmd-Delete (macOS): [`deleteLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryForward).
*/ const $d6ef25f90fa77b71$export$ae5dfd95be821a1c = /*@__PURE__*/ [
    {
        key: "ArrowLeft",
        run: $d6ef25f90fa77b71$export$3447f2b737925430,
        shift: $d6ef25f90fa77b71$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Mod-ArrowLeft",
        mac: "Alt-ArrowLeft",
        run: $d6ef25f90fa77b71$export$137fb1611fb38377,
        shift: $d6ef25f90fa77b71$export$ef839611b4c2ba40,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowLeft",
        run: $d6ef25f90fa77b71$export$515c8c77cfbd2e73,
        shift: $d6ef25f90fa77b71$export$769cc61da74090c5,
        preventDefault: true
    },
    {
        key: "ArrowRight",
        run: $d6ef25f90fa77b71$export$e45941411d098b,
        shift: $d6ef25f90fa77b71$export$49e3d65796d89132,
        preventDefault: true
    },
    {
        key: "Mod-ArrowRight",
        mac: "Alt-ArrowRight",
        run: $d6ef25f90fa77b71$export$8fb2c619d55341b4,
        shift: $d6ef25f90fa77b71$export$5ebbb4cf65fe8a74,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowRight",
        run: $d6ef25f90fa77b71$export$912e453a1e062a62,
        shift: $d6ef25f90fa77b71$export$de427496204690a6,
        preventDefault: true
    },
    {
        key: "ArrowUp",
        run: $d6ef25f90fa77b71$export$fe179dad0485d99d,
        shift: $d6ef25f90fa77b71$export$92aa693a1ecd7061,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowUp",
        run: $d6ef25f90fa77b71$export$ff7ed6e6e1cb317f,
        shift: $d6ef25f90fa77b71$export$aa525ee829cc26b
    },
    {
        mac: "Ctrl-ArrowUp",
        run: $d6ef25f90fa77b71$export$546ec71a9f854193,
        shift: $d6ef25f90fa77b71$export$61eab34d4ff5cbaf
    },
    {
        key: "ArrowDown",
        run: $d6ef25f90fa77b71$export$75f9b75ffb1a9dc5,
        shift: $d6ef25f90fa77b71$export$bf847527697a3040,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowDown",
        run: $d6ef25f90fa77b71$export$b12ef1671b2836da,
        shift: $d6ef25f90fa77b71$export$fff0131cdd9694fe
    },
    {
        mac: "Ctrl-ArrowDown",
        run: $d6ef25f90fa77b71$export$6e407c2072d437f4,
        shift: $d6ef25f90fa77b71$export$a4c186a0dadaf91c
    },
    {
        key: "PageUp",
        run: $d6ef25f90fa77b71$export$546ec71a9f854193,
        shift: $d6ef25f90fa77b71$export$61eab34d4ff5cbaf
    },
    {
        key: "PageDown",
        run: $d6ef25f90fa77b71$export$6e407c2072d437f4,
        shift: $d6ef25f90fa77b71$export$a4c186a0dadaf91c
    },
    {
        key: "Home",
        run: $d6ef25f90fa77b71$export$64939ebc49b03818,
        shift: $d6ef25f90fa77b71$export$643176ee603b8e87,
        preventDefault: true
    },
    {
        key: "Mod-Home",
        run: $d6ef25f90fa77b71$export$ff7ed6e6e1cb317f,
        shift: $d6ef25f90fa77b71$export$aa525ee829cc26b
    },
    {
        key: "End",
        run: $d6ef25f90fa77b71$export$b59ae3b25af6ea13,
        shift: $d6ef25f90fa77b71$export$df223d0097d57a86,
        preventDefault: true
    },
    {
        key: "Mod-End",
        run: $d6ef25f90fa77b71$export$b12ef1671b2836da,
        shift: $d6ef25f90fa77b71$export$fff0131cdd9694fe
    },
    {
        key: "Enter",
        run: $d6ef25f90fa77b71$export$668310d2b1aa07d5,
        shift: $d6ef25f90fa77b71$export$668310d2b1aa07d5
    },
    {
        key: "Mod-a",
        run: $d6ef25f90fa77b71$export$90aca4adda6ff0f5
    },
    {
        key: "Backspace",
        run: $d6ef25f90fa77b71$export$1e8a14efe7ca9a33,
        shift: $d6ef25f90fa77b71$export$1e8a14efe7ca9a33,
        preventDefault: true
    },
    {
        key: "Delete",
        run: $d6ef25f90fa77b71$export$d41683a0f042cb80,
        preventDefault: true
    },
    {
        key: "Mod-Backspace",
        mac: "Alt-Backspace",
        run: $d6ef25f90fa77b71$export$3072f591ab219e94,
        preventDefault: true
    },
    {
        key: "Mod-Delete",
        mac: "Alt-Delete",
        run: $d6ef25f90fa77b71$export$56a4e2ef21b58242,
        preventDefault: true
    },
    {
        mac: "Mod-Backspace",
        run: $d6ef25f90fa77b71$export$d1072494cede984a,
        preventDefault: true
    },
    {
        mac: "Mod-Delete",
        run: $d6ef25f90fa77b71$export$b87eb3a389c264a4,
        preventDefault: true
    }
].concat(/*@__PURE__*/ $d6ef25f90fa77b71$export$ef7c3246c722c48f.map((b)=>({
        mac: b.key,
        run: b.run,
        shift: b.shift
    })));
/**
The default keymap. Includes all bindings from
[`standardKeymap`](https://codemirror.net/6/docs/ref/#commands.standardKeymap) plus the following:

- Alt-ArrowLeft (Ctrl-ArrowLeft on macOS): [`cursorSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxLeft) ([`selectSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxLeft) with Shift)
- Alt-ArrowRight (Ctrl-ArrowRight on macOS): [`cursorSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxRight) ([`selectSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxRight) with Shift)
- Alt-ArrowUp: [`moveLineUp`](https://codemirror.net/6/docs/ref/#commands.moveLineUp)
- Alt-ArrowDown: [`moveLineDown`](https://codemirror.net/6/docs/ref/#commands.moveLineDown)
- Shift-Alt-ArrowUp: [`copyLineUp`](https://codemirror.net/6/docs/ref/#commands.copyLineUp)
- Shift-Alt-ArrowDown: [`copyLineDown`](https://codemirror.net/6/docs/ref/#commands.copyLineDown)
- Ctrl-Alt-ArrowUp (Cmd-Alt-ArrowUp on macOS): [`addCursorAbove`](https://codemirror.net/6/docs/ref/#commands.addCursorAbove).
- Ctrl-Alt-ArrowDown (Cmd-Alt-ArrowDown on macOS): [`addCursorBelow`](https://codemirror.net/6/docs/ref/#commands.addCursorBelow).
- Escape: [`simplifySelection`](https://codemirror.net/6/docs/ref/#commands.simplifySelection)
- Ctrl-Enter (Cmd-Enter on macOS): [`insertBlankLine`](https://codemirror.net/6/docs/ref/#commands.insertBlankLine)
- Alt-l (Ctrl-l on macOS): [`selectLine`](https://codemirror.net/6/docs/ref/#commands.selectLine)
- Ctrl-i (Cmd-i on macOS): [`selectParentSyntax`](https://codemirror.net/6/docs/ref/#commands.selectParentSyntax)
- Ctrl-[ (Cmd-[ on macOS): [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess)
- Ctrl-] (Cmd-] on macOS): [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore)
- Ctrl-Alt-\\ (Cmd-Alt-\\ on macOS): [`indentSelection`](https://codemirror.net/6/docs/ref/#commands.indentSelection)
- Shift-Ctrl-k (Shift-Cmd-k on macOS): [`deleteLine`](https://codemirror.net/6/docs/ref/#commands.deleteLine)
- Shift-Ctrl-\\ (Shift-Cmd-\\ on macOS): [`cursorMatchingBracket`](https://codemirror.net/6/docs/ref/#commands.cursorMatchingBracket)
- Ctrl-/ (Cmd-/ on macOS): [`toggleComment`](https://codemirror.net/6/docs/ref/#commands.toggleComment).
- Shift-Alt-a: [`toggleBlockComment`](https://codemirror.net/6/docs/ref/#commands.toggleBlockComment).
- Ctrl-m (Alt-Shift-m on macOS): [`toggleTabFocusMode`](https://codemirror.net/6/docs/ref/#commands.toggleTabFocusMode).
*/ const $d6ef25f90fa77b71$export$ab2e8d0ac5d2b69e = /*@__PURE__*/ [
    {
        key: "Alt-ArrowLeft",
        mac: "Ctrl-ArrowLeft",
        run: $d6ef25f90fa77b71$export$1e53c014543c10bb,
        shift: $d6ef25f90fa77b71$export$67b15be4414061b5
    },
    {
        key: "Alt-ArrowRight",
        mac: "Ctrl-ArrowRight",
        run: $d6ef25f90fa77b71$export$62c6dc33f5d01e39,
        shift: $d6ef25f90fa77b71$export$74aa476df7791ce
    },
    {
        key: "Alt-ArrowUp",
        run: $d6ef25f90fa77b71$export$c4eebaf75cfae23e
    },
    {
        key: "Shift-Alt-ArrowUp",
        run: $d6ef25f90fa77b71$export$c3798d29213e527c
    },
    {
        key: "Alt-ArrowDown",
        run: $d6ef25f90fa77b71$export$ac19ae98a6fcd34c
    },
    {
        key: "Shift-Alt-ArrowDown",
        run: $d6ef25f90fa77b71$export$1ad385c375816d2f
    },
    {
        key: "Mod-Alt-ArrowUp",
        run: $d6ef25f90fa77b71$export$3054522ff62988dd
    },
    {
        key: "Mod-Alt-ArrowDown",
        run: $d6ef25f90fa77b71$export$83ff5bba776179f3
    },
    {
        key: "Escape",
        run: $d6ef25f90fa77b71$export$2f90cebc0d40abf
    },
    {
        key: "Mod-Enter",
        run: $d6ef25f90fa77b71$export$2ff1ccbcf65d0770
    },
    {
        key: "Alt-l",
        mac: "Ctrl-l",
        run: $d6ef25f90fa77b71$export$e41c12847640c21
    },
    {
        key: "Mod-i",
        run: $d6ef25f90fa77b71$export$f38a48fa120d50ce,
        preventDefault: true
    },
    {
        key: "Mod-[",
        run: $d6ef25f90fa77b71$export$e4b902122bfe67ae
    },
    {
        key: "Mod-]",
        run: $d6ef25f90fa77b71$export$a61bf6a946ffc826
    },
    {
        key: "Mod-Alt-\\",
        run: $d6ef25f90fa77b71$export$ffcf50534fec79c3
    },
    {
        key: "Shift-Mod-k",
        run: $d6ef25f90fa77b71$export$aba0d4cd8923f1ae
    },
    {
        key: "Shift-Mod-\\",
        run: $d6ef25f90fa77b71$export$e5a7e1f2d38b1f6a
    },
    {
        key: "Mod-/",
        run: $d6ef25f90fa77b71$export$afbcdd0bff36c567
    },
    {
        key: "Alt-A",
        run: $d6ef25f90fa77b71$export$19d6fa84ce3a55ab
    },
    {
        key: "Ctrl-m",
        mac: "Shift-Alt-m",
        run: $d6ef25f90fa77b71$export$f118650570e71643
    }
].concat($d6ef25f90fa77b71$export$ae5dfd95be821a1c);
/**
A binding that binds Tab to [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) and
Shift-Tab to [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess).
Please see the [Tab example](../../examples/tab/) before using
this.
*/ const $d6ef25f90fa77b71$export$893b77570f8af4da = {
    key: "Tab",
    run: $d6ef25f90fa77b71$export$a61bf6a946ffc826,
    shift: $d6ef25f90fa77b71$export$e4b902122bfe67ae
};





const $5493a697db18a17a$var$keywords = new Set([
    "print",
    "let",
    "if",
    "else",
    "true",
    "false",
    "and",
    "or",
    "fn",
    "return",
    "for",
    "from",
    "to",
    "st",
    "all",
    "ex",
    "yield",
    "mut",
    "null"
]);
const $5493a697db18a17a$export$f7857270615ae18f = (0, $d245ca63c4fe5041$export$5ee3cc23916207d8).define({
    token (stream) {
        if (stream.eatSpace()) return null;
        if (stream.match(/^#.*/)) return "comment";
        if (stream.match(/^[a-zA-Z_\\][a-zA-Z0-9_\\]*/)) {
            if ($5493a697db18a17a$var$keywords.has(stream.current())) return "keyword";
        } else {
            if (stream.match(/^\d+\.?\d*/)) return "number";
        }
        stream.next();
        return null;
    }
});
const $5493a697db18a17a$export$3f1472e2e2f8ef40 = (0, $d245ca63c4fe5041$export$ec1b956ff3a16361)((0, $d245ca63c4fe5041$export$4819f093bdd5b4a).define([
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).comment,
        "class": "comment"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).keyword,
        "class": "keyword"
    },
    {
        tag: (0, $f0075d67137b7b29$export$8b7a896ae75accbf).number,
        "class": "number"
    }
]));





class $ab630557a18c0042$var$SelectedDiagnostic {
    constructor(from, to, diagnostic){
        this.from = from;
        this.to = to;
        this.diagnostic = diagnostic;
    }
}
class $ab630557a18c0042$var$LintState {
    constructor(diagnostics, panel, selected){
        this.diagnostics = diagnostics;
        this.panel = panel;
        this.selected = selected;
    }
    static init(diagnostics, panel, state) {
        // Filter the list of diagnostics for which to create markers
        let diagnosticFilter = state.facet($ab630557a18c0042$var$lintConfig).markerFilter;
        if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics, state);
        let sorted = diagnostics.slice().sort((a, b)=>a.from - b.from || a.to - b.to);
        let deco = new (0, $3ef527dddcdea745$export$89e09ce03c7e8594)(), active = [], pos = 0;
        let scan = state.doc.iter(), scanPos = 0, docLen = state.doc.length;
        for(let i = 0;;){
            let next = i == sorted.length ? null : sorted[i];
            if (!next && !active.length) break;
            let from, to;
            if (active.length) {
                from = pos;
                to = active.reduce((p, d)=>Math.min(p, d.to), next && next.from > from ? next.from : 1e8);
            } else {
                from = next.from;
                if (from > docLen) break;
                to = next.to;
                active.push(next);
                i++;
            }
            while(i < sorted.length){
                let next = sorted[i];
                if (next.from == from && (next.to > next.from || next.to == from)) {
                    active.push(next);
                    i++;
                    to = Math.min(next.to, to);
                } else {
                    to = Math.min(next.from, to);
                    break;
                }
            }
            to = Math.min(to, docLen);
            let widget = false;
            if (active.some((d)=>d.from == from && (d.to == to || to == docLen))) {
                widget = from == to;
                if (!widget && to - from < 10) {
                    let behind = from - (scanPos + scan.value.length);
                    if (behind > 0) {
                        scan.next(behind);
                        scanPos = from;
                    }
                    for(let check = from;;){
                        if (check >= to) {
                            widget = true;
                            break;
                        }
                        if (!scan.lineBreak && scanPos + scan.value.length > check) break;
                        check = scanPos + scan.value.length;
                        scanPos += scan.value.length;
                        scan.next();
                    }
                }
            }
            let sev = $ab630557a18c0042$var$maxSeverity(active);
            if (widget) deco.add(from, from, (0, $b3e9d73db824614e$export$10e30b733df217ea).widget({
                widget: new $ab630557a18c0042$var$DiagnosticWidget(sev),
                diagnostics: active.slice()
            }));
            else {
                let markClass = active.reduce((c, d)=>d.markClass ? c + " " + d.markClass : c, "");
                deco.add(from, to, (0, $b3e9d73db824614e$export$10e30b733df217ea).mark({
                    class: "cm-lintRange cm-lintRange-" + sev + markClass,
                    diagnostics: active.slice(),
                    inclusiveEnd: active.some((a)=>a.to > to)
                }));
            }
            pos = to;
            if (pos == docLen) break;
            for(let i = 0; i < active.length; i++)if (active[i].to <= pos) active.splice(i--, 1);
        }
        let set = deco.finish();
        return new $ab630557a18c0042$var$LintState(set, panel, $ab630557a18c0042$var$findDiagnostic(set));
    }
}
function $ab630557a18c0042$var$findDiagnostic(diagnostics, diagnostic = null, after = 0) {
    let found = null;
    diagnostics.between(after, 1e9, (from, to, { spec: spec })=>{
        if (diagnostic && spec.diagnostics.indexOf(diagnostic) < 0) return;
        if (!found) found = new $ab630557a18c0042$var$SelectedDiagnostic(from, to, diagnostic || spec.diagnostics[0]);
        else if (spec.diagnostics.indexOf(found.diagnostic) < 0) return false;
        else found = new $ab630557a18c0042$var$SelectedDiagnostic(found.from, to, found.diagnostic);
    });
    return found;
}
function $ab630557a18c0042$var$hideTooltip(tr, tooltip) {
    let from = tooltip.pos, to = tooltip.end || from;
    let result = tr.state.facet($ab630557a18c0042$var$lintConfig).hideOn(tr, from, to);
    if (result != null) return result;
    let line = tr.startState.doc.lineAt(tooltip.pos);
    return !!(tr.effects.some((e)=>e.is($ab630557a18c0042$export$9c7976977981c7bf)) || tr.changes.touchesRange(line.from, Math.max(line.to, to)));
}
function $ab630557a18c0042$var$maybeEnableLint(state, effects) {
    return state.field($ab630557a18c0042$var$lintState, false) ? effects : effects.concat((0, $3ef527dddcdea745$export$95000d4efaa4321f).appendConfig.of($ab630557a18c0042$var$lintExtensions));
}
/**
Returns a transaction spec which updates the current set of
diagnostics, and enables the lint extension if if wasn't already
active.
*/ function $ab630557a18c0042$export$188c3c6ceeec4bb3(state, diagnostics) {
    return {
        effects: $ab630557a18c0042$var$maybeEnableLint(state, [
            $ab630557a18c0042$export$9c7976977981c7bf.of(diagnostics)
        ])
    };
}
/**
The state effect that updates the set of active diagnostics. Can
be useful when writing an extension that needs to track these.
*/ const $ab630557a18c0042$export$9c7976977981c7bf = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
const $ab630557a18c0042$var$togglePanel = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
const $ab630557a18c0042$var$movePanelSelection = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
const $ab630557a18c0042$var$lintState = /*@__PURE__*/ (0, $3ef527dddcdea745$export$34381b1ce2130245).define({
    create () {
        return new $ab630557a18c0042$var$LintState((0, $b3e9d73db824614e$export$10e30b733df217ea).none, null, null);
    },
    update (value, tr) {
        if (tr.docChanged && value.diagnostics.size) {
            let mapped = value.diagnostics.map(tr.changes), selected = null, panel = value.panel;
            if (value.selected) {
                let selPos = tr.changes.mapPos(value.selected.from, 1);
                selected = $ab630557a18c0042$var$findDiagnostic(mapped, value.selected.diagnostic, selPos) || $ab630557a18c0042$var$findDiagnostic(mapped, null, selPos);
            }
            if (!mapped.size && panel && tr.state.facet($ab630557a18c0042$var$lintConfig).autoPanel) panel = null;
            value = new $ab630557a18c0042$var$LintState(mapped, panel, selected);
        }
        for (let effect of tr.effects){
            if (effect.is($ab630557a18c0042$export$9c7976977981c7bf)) {
                let panel = !tr.state.facet($ab630557a18c0042$var$lintConfig).autoPanel ? value.panel : effect.value.length ? $ab630557a18c0042$var$LintPanel.open : null;
                value = $ab630557a18c0042$var$LintState.init(effect.value, panel, tr.state);
            } else if (effect.is($ab630557a18c0042$var$togglePanel)) value = new $ab630557a18c0042$var$LintState(value.diagnostics, effect.value ? $ab630557a18c0042$var$LintPanel.open : null, value.selected);
            else if (effect.is($ab630557a18c0042$var$movePanelSelection)) value = new $ab630557a18c0042$var$LintState(value.diagnostics, value.panel, effect.value);
        }
        return value;
    },
    provide: (f)=>[
            (0, $b3e9d73db824614e$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel),
            (0, $b3e9d73db824614e$export$eece2fccabbb77c5).decorations.from(f, (s)=>s.diagnostics)
        ]
});
/**
Returns the number of active lint diagnostics in the given state.
*/ function $ab630557a18c0042$export$31ce51ade4a789ff(state) {
    let lint = state.field($ab630557a18c0042$var$lintState, false);
    return lint ? lint.diagnostics.size : 0;
}
const $ab630557a18c0042$var$activeMark = /*@__PURE__*/ (0, $b3e9d73db824614e$export$10e30b733df217ea).mark({
    class: "cm-lintRange cm-lintRange-active"
});
function $ab630557a18c0042$var$lintTooltip(view, pos, side) {
    let { diagnostics: diagnostics } = view.state.field($ab630557a18c0042$var$lintState);
    let found, start = -1, end = -1;
    diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to, { spec: spec })=>{
        if (pos >= from && pos <= to && (from == to || (pos > from || side > 0) && (pos < to || side < 0))) {
            found = spec.diagnostics;
            start = from;
            end = to;
            return false;
        }
    });
    let diagnosticFilter = view.state.facet($ab630557a18c0042$var$lintConfig).tooltipFilter;
    if (found && diagnosticFilter) found = diagnosticFilter(found, view.state);
    if (!found) return null;
    return {
        pos: start,
        end: end,
        above: true,
        create () {
            return {
                dom: $ab630557a18c0042$var$diagnosticsTooltip(view, found)
            };
        }
    };
}
function $ab630557a18c0042$var$diagnosticsTooltip(view, diagnostics) {
    return (0, $49ddc340444673b0$export$2e2bcd8739ae039)("ul", {
        class: "cm-tooltip-lint"
    }, diagnostics.map((d)=>$ab630557a18c0042$var$renderDiagnostic(view, d, false)));
}
/**
Command to open and focus the lint panel.
*/ const $ab630557a18c0042$export$5c4e65c70e8c34a7 = (view)=>{
    let field = view.state.field($ab630557a18c0042$var$lintState, false);
    if (!field || !field.panel) view.dispatch({
        effects: $ab630557a18c0042$var$maybeEnableLint(view.state, [
            $ab630557a18c0042$var$togglePanel.of(true)
        ])
    });
    let panel = (0, $b3e9d73db824614e$export$7361ed18ff57179e)(view, $ab630557a18c0042$var$LintPanel.open);
    if (panel) panel.dom.querySelector(".cm-panel-lint ul").focus();
    return true;
};
/**
Command to close the lint panel, when open.
*/ const $ab630557a18c0042$export$2ee372c3e690e3c3 = (view)=>{
    let field = view.state.field($ab630557a18c0042$var$lintState, false);
    if (!field || !field.panel) return false;
    view.dispatch({
        effects: $ab630557a18c0042$var$togglePanel.of(false)
    });
    return true;
};
/**
Move the selection to the next diagnostic.
*/ const $ab630557a18c0042$export$79abb131646e1359 = (view)=>{
    let field = view.state.field($ab630557a18c0042$var$lintState, false);
    if (!field) return false;
    let sel = view.state.selection.main, next = $ab630557a18c0042$var$findDiagnostic(field.diagnostics, null, sel.to + 1);
    if (!next) {
        next = $ab630557a18c0042$var$findDiagnostic(field.diagnostics, null, 0);
        if (!next || next.from == sel.from && next.to == sel.to) return false;
    }
    view.dispatch({
        selection: {
            anchor: next.from,
            head: next.to
        },
        scrollIntoView: true
    });
    (0, $b3e9d73db824614e$export$a34e0ba9d4697396)(view, next.from, 1, {
        tooltip: $ab630557a18c0042$var$lintHover,
        until: (tr)=>tr.docChanged || tr.newSelection.main.head < next.from || tr.newSelection.main.head > next.to
    });
    return true;
};
/**
Move the selection to the previous diagnostic.
*/ const $ab630557a18c0042$export$f71c1dd1430b5cc1 = (view)=>{
    var _a;
    let { state: state } = view, field = state.field($ab630557a18c0042$var$lintState, false);
    if (!field) return false;
    let sel = state.selection.main;
    let prevFrom, prevTo, lastFrom, lastTo;
    field.diagnostics.between(0, state.doc.length, (from, to)=>{
        if (to < sel.to && (prevFrom == null || prevFrom < from)) {
            prevFrom = from;
            prevTo = to;
        }
        if (lastFrom == null || from > lastFrom) {
            lastFrom = from;
            lastTo = to;
        }
    });
    if (lastFrom == null || prevFrom == null && lastFrom == sel.from) return false;
    let from = prevFrom !== null && prevFrom !== void 0 ? prevFrom : lastFrom, to = (_a = prevTo !== null && prevTo !== void 0 ? prevTo : lastTo) !== null && _a !== void 0 ? _a : from;
    view.dispatch({
        selection: {
            anchor: from,
            head: to
        },
        scrollIntoView: true
    });
    (0, $b3e9d73db824614e$export$a34e0ba9d4697396)(view, from, 1, {
        tooltip: $ab630557a18c0042$var$lintHover,
        until: (tr)=>tr.docChanged || tr.newSelection.main.head < from || tr.newSelection.main.head > to
    });
    return true;
};
/**
A set of default key bindings for the lint functionality.

- Ctrl-Shift-m (Cmd-Shift-m on macOS): [`openLintPanel`](https://codemirror.net/6/docs/ref/#lint.openLintPanel)
- F8: [`nextDiagnostic`](https://codemirror.net/6/docs/ref/#lint.nextDiagnostic)
*/ const $ab630557a18c0042$export$a21d7a0cde3cbb60 = [
    {
        key: "Mod-Shift-m",
        run: $ab630557a18c0042$export$5c4e65c70e8c34a7,
        preventDefault: true
    },
    {
        key: "F8",
        run: $ab630557a18c0042$export$79abb131646e1359
    }
];
const $ab630557a18c0042$var$lintPlugin = /*@__PURE__*/ (0, $b3e9d73db824614e$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.timeout = -1;
        this.set = true;
        let { delay: delay } = view.state.facet($ab630557a18c0042$var$lintConfig);
        this.lintTime = Date.now() + delay;
        this.run = this.run.bind(this);
        this.timeout = setTimeout(this.run, delay);
    }
    run() {
        clearTimeout(this.timeout);
        let now = Date.now();
        if (now < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - now);
        else {
            this.set = false;
            let { state: state } = this.view, { sources: sources } = state.facet($ab630557a18c0042$var$lintConfig);
            if (sources.length) $ab630557a18c0042$var$batchResults(sources.map((s)=>Promise.resolve(s(this.view))), (annotations)=>{
                if (this.view.state.doc == state.doc) this.view.dispatch($ab630557a18c0042$export$188c3c6ceeec4bb3(this.view.state, annotations.reduce((a, b)=>a.concat(b))));
            }, (error)=>{
                (0, $b3e9d73db824614e$export$f86b2a1a2ce291b3)(this.view.state, error);
            });
        }
    }
    update(update) {
        let config = update.state.facet($ab630557a18c0042$var$lintConfig);
        if (update.docChanged || config != update.startState.facet($ab630557a18c0042$var$lintConfig) || config.needsRefresh && config.needsRefresh(update)) {
            this.lintTime = Date.now() + config.delay;
            if (!this.set) {
                this.set = true;
                this.timeout = setTimeout(this.run, config.delay);
            }
        }
    }
    force() {
        if (this.set) {
            this.lintTime = Date.now();
            this.run();
        }
    }
    destroy() {
        clearTimeout(this.timeout);
    }
});
function $ab630557a18c0042$var$batchResults(promises, sink, error) {
    let collected = [], timeout = -1;
    for (let p of promises)p.then((value)=>{
        collected.push(value);
        clearTimeout(timeout);
        if (collected.length == promises.length) sink(collected);
        else timeout = setTimeout(()=>sink(collected), 200);
    }, error);
}
const $ab630557a18c0042$var$lintConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (input) {
        return {
            sources: input.map((i)=>i.source).filter((x)=>x != null),
            ...(0, $3ef527dddcdea745$export$4e19c0b693794a7e)(input.map((i)=>i.config), {
                delay: 750,
                markerFilter: null,
                tooltipFilter: null,
                needsRefresh: null,
                hideOn: ()=>null
            }, {
                delay: Math.max,
                markerFilter: $ab630557a18c0042$var$combineFilter,
                tooltipFilter: $ab630557a18c0042$var$combineFilter,
                needsRefresh: (a, b)=>!a ? b : !b ? a : (u)=>a(u) || b(u),
                hideOn: (a, b)=>!a ? b : !b ? a : (t, x, y)=>a(t, x, y) || b(t, x, y),
                autoPanel: (a, b)=>a || b
            })
        };
    }
});
function $ab630557a18c0042$var$combineFilter(a, b) {
    return !a ? b : !b ? a : (d, s)=>b(a(d, s), s);
}
/**
Given a diagnostic source, this function returns an extension that
enables linting with that source. It will be called whenever the
editor is idle (after its content changed).

Note that settings given here will apply to all linters active in
the editor. If `null` is given as source, this only configures the
lint extension.
*/ function $ab630557a18c0042$export$8bb7ef7a8be4cb1c(source, config = {}) {
    return [
        $ab630557a18c0042$var$lintConfig.of({
            source: source,
            config: config
        }),
        $ab630557a18c0042$var$lintPlugin,
        $ab630557a18c0042$var$lintExtensions
    ];
}
/**
Forces any linters [configured](https://codemirror.net/6/docs/ref/#lint.linter) to run when the
editor is idle to run right away.
*/ function $ab630557a18c0042$export$e917f1893924e285(view) {
    let plugin = view.plugin($ab630557a18c0042$var$lintPlugin);
    if (plugin) plugin.force();
}
function $ab630557a18c0042$var$assignKeys(actions) {
    let assigned = [];
    if (actions) actions: for (let { name: name } of actions){
        for(let i = 0; i < name.length; i++){
            let ch = name[i];
            if (/[a-zA-Z]/.test(ch) && !assigned.some((c)=>c.toLowerCase() == ch.toLowerCase())) {
                assigned.push(ch);
                continue actions;
            }
        }
        assigned.push("");
    }
    return assigned;
}
function $ab630557a18c0042$var$renderDiagnostic(view, diagnostic, inPanel) {
    var _a;
    let keys = inPanel ? $ab630557a18c0042$var$assignKeys(diagnostic.actions) : [];
    return (0, $49ddc340444673b0$export$2e2bcd8739ae039)("li", {
        class: "cm-diagnostic cm-diagnostic-" + diagnostic.severity
    }, (0, $49ddc340444673b0$export$2e2bcd8739ae039)("span", {
        class: "cm-diagnosticText"
    }, diagnostic.renderMessage ? diagnostic.renderMessage(view) : diagnostic.message), (_a = diagnostic.actions) === null || _a === void 0 ? void 0 : _a.map((action, i)=>{
        let fired = false, click = (e)=>{
            e.preventDefault();
            if (fired) return;
            fired = true;
            let found = $ab630557a18c0042$var$findDiagnostic(view.state.field($ab630557a18c0042$var$lintState).diagnostics, diagnostic);
            if (found) action.apply(view, found.from, found.to);
        };
        let { name: name } = action, keyIndex = keys[i] ? name.indexOf(keys[i]) : -1;
        let nameElt = keyIndex < 0 ? name : [
            name.slice(0, keyIndex),
            (0, $49ddc340444673b0$export$2e2bcd8739ae039)("u", name.slice(keyIndex, keyIndex + 1)),
            name.slice(keyIndex + 1)
        ];
        let markClass = action.markClass ? " " + action.markClass : "";
        return (0, $49ddc340444673b0$export$2e2bcd8739ae039)("button", {
            type: "button",
            class: "cm-diagnosticAction" + markClass,
            onclick: click,
            onmousedown: click,
            "aria-label": ` Action: ${name}${keyIndex < 0 ? "" : ` (access key "${keys[i]})"`}.`
        }, nameElt);
    }), diagnostic.source && (0, $49ddc340444673b0$export$2e2bcd8739ae039)("div", {
        class: "cm-diagnosticSource"
    }, diagnostic.source));
}
class $ab630557a18c0042$var$DiagnosticWidget extends (0, $b3e9d73db824614e$export$95cdd842edb044c5) {
    constructor(sev){
        super();
        this.sev = sev;
    }
    eq(other) {
        return other.sev == this.sev;
    }
    toDOM() {
        return (0, $49ddc340444673b0$export$2e2bcd8739ae039)("span", {
            class: "cm-lintPoint cm-lintPoint-" + this.sev
        });
    }
}
class $ab630557a18c0042$var$PanelItem {
    constructor(view, diagnostic){
        this.diagnostic = diagnostic;
        this.id = "item_" + Math.floor(Math.random() * 0xffffffff).toString(16);
        this.dom = $ab630557a18c0042$var$renderDiagnostic(view, diagnostic, true);
        this.dom.id = this.id;
        this.dom.setAttribute("role", "option");
    }
}
class $ab630557a18c0042$var$LintPanel {
    constructor(view){
        this.view = view;
        this.items = [];
        let onkeydown = (event)=>{
            if (event.ctrlKey || event.altKey || event.metaKey) return;
            if (event.keyCode == 27) {
                $ab630557a18c0042$export$2ee372c3e690e3c3(this.view);
                this.view.focus();
            } else if (event.keyCode == 38 || event.keyCode == 33) this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
            else if (event.keyCode == 40 || event.keyCode == 34) this.moveSelection((this.selectedIndex + 1) % this.items.length);
            else if (event.keyCode == 36) this.moveSelection(0);
            else if (event.keyCode == 35) this.moveSelection(this.items.length - 1);
            else if (event.keyCode == 13) this.view.focus();
            else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
                let { diagnostic: diagnostic } = this.items[this.selectedIndex], keys = $ab630557a18c0042$var$assignKeys(diagnostic.actions);
                for(let i = 0; i < keys.length; i++)if (keys[i].toUpperCase().charCodeAt(0) == event.keyCode) {
                    let found = $ab630557a18c0042$var$findDiagnostic(this.view.state.field($ab630557a18c0042$var$lintState).diagnostics, diagnostic);
                    if (found) diagnostic.actions[i].apply(view, found.from, found.to);
                }
            } else return;
            event.preventDefault();
        };
        let onclick = (event)=>{
            for(let i = 0; i < this.items.length; i++)if (this.items[i].dom.contains(event.target)) this.moveSelection(i);
        };
        this.list = (0, $49ddc340444673b0$export$2e2bcd8739ae039)("ul", {
            tabIndex: 0,
            role: "listbox",
            "aria-label": this.view.state.phrase("Diagnostics"),
            onkeydown: onkeydown,
            onclick: onclick
        });
        this.dom = (0, $49ddc340444673b0$export$2e2bcd8739ae039)("div", {
            class: "cm-panel-lint"
        }, this.list, (0, $49ddc340444673b0$export$2e2bcd8739ae039)("button", {
            type: "button",
            name: "close",
            "aria-label": this.view.state.phrase("close"),
            onclick: ()=>$ab630557a18c0042$export$2ee372c3e690e3c3(this.view)
        }, "\xd7"));
        this.update();
    }
    get selectedIndex() {
        let selected = this.view.state.field($ab630557a18c0042$var$lintState).selected;
        if (!selected) return -1;
        for(let i = 0; i < this.items.length; i++)if (this.items[i].diagnostic == selected.diagnostic) return i;
        return -1;
    }
    update() {
        let { diagnostics: diagnostics, selected: selected } = this.view.state.field($ab630557a18c0042$var$lintState);
        let i = 0, needsSync = false, newSelectedItem = null;
        let seen = new Set();
        diagnostics.between(0, this.view.state.doc.length, (_start, _end, { spec: spec })=>{
            for (let diagnostic of spec.diagnostics){
                if (seen.has(diagnostic)) continue;
                seen.add(diagnostic);
                let found = -1, item;
                for(let j = i; j < this.items.length; j++)if (this.items[j].diagnostic == diagnostic) {
                    found = j;
                    break;
                }
                if (found < 0) {
                    item = new $ab630557a18c0042$var$PanelItem(this.view, diagnostic);
                    this.items.splice(i, 0, item);
                    needsSync = true;
                } else {
                    item = this.items[found];
                    if (found > i) {
                        this.items.splice(i, found - i);
                        needsSync = true;
                    }
                }
                if (selected && item.diagnostic == selected.diagnostic) {
                    if (!item.dom.hasAttribute("aria-selected")) {
                        item.dom.setAttribute("aria-selected", "true");
                        newSelectedItem = item;
                    }
                } else if (item.dom.hasAttribute("aria-selected")) item.dom.removeAttribute("aria-selected");
                i++;
            }
        });
        while(i < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)){
            needsSync = true;
            this.items.pop();
        }
        if (this.items.length == 0) {
            this.items.push(new $ab630557a18c0042$var$PanelItem(this.view, {
                from: -1,
                to: -1,
                severity: "info",
                message: this.view.state.phrase("No diagnostics")
            }));
            needsSync = true;
        }
        if (newSelectedItem) {
            this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
            this.view.requestMeasure({
                key: this,
                read: ()=>({
                        sel: newSelectedItem.dom.getBoundingClientRect(),
                        panel: this.list.getBoundingClientRect()
                    }),
                write: ({ sel: sel, panel: panel })=>{
                    let scaleY = panel.height / this.list.offsetHeight;
                    if (sel.top < panel.top) this.list.scrollTop -= (panel.top - sel.top) / scaleY;
                    else if (sel.bottom > panel.bottom) this.list.scrollTop += (sel.bottom - panel.bottom) / scaleY;
                }
            });
        } else if (this.selectedIndex < 0) this.list.removeAttribute("aria-activedescendant");
        if (needsSync) this.sync();
    }
    sync() {
        let domPos = this.list.firstChild;
        function rm() {
            let prev = domPos;
            domPos = prev.nextSibling;
            prev.remove();
        }
        for (let item of this.items)if (item.dom.parentNode == this.list) {
            while(domPos != item.dom)rm();
            domPos = item.dom.nextSibling;
        } else this.list.insertBefore(item.dom, domPos);
        while(domPos)rm();
    }
    moveSelection(selectedIndex) {
        if (this.selectedIndex < 0) return;
        let field = this.view.state.field($ab630557a18c0042$var$lintState);
        let selection = $ab630557a18c0042$var$findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
        if (!selection) return;
        this.view.dispatch({
            selection: {
                anchor: selection.from,
                head: selection.to
            },
            scrollIntoView: true,
            effects: $ab630557a18c0042$var$movePanelSelection.of(selection)
        });
    }
    static open(view) {
        return new $ab630557a18c0042$var$LintPanel(view);
    }
}
function $ab630557a18c0042$var$svg(content, attrs = `viewBox="0 0 40 40"`) {
    return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content)}</svg>')`;
}
function $ab630557a18c0042$var$underline(color) {
    return $ab630557a18c0042$var$svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
const $ab630557a18c0042$var$baseTheme = /*@__PURE__*/ (0, $b3e9d73db824614e$export$eece2fccabbb77c5).baseTheme({
    ".cm-diagnostic": {
        padding: "3px 6px 3px 8px",
        marginLeft: "-1px",
        display: "block",
        whiteSpace: "pre-wrap"
    },
    ".cm-diagnostic-error": {
        borderLeft: "5px solid #d11"
    },
    ".cm-diagnostic-warning": {
        borderLeft: "5px solid orange"
    },
    ".cm-diagnostic-info": {
        borderLeft: "5px solid #999"
    },
    ".cm-diagnostic-hint": {
        borderLeft: "5px solid #66d"
    },
    ".cm-diagnosticAction": {
        font: "inherit",
        border: "none",
        padding: "2px 4px",
        backgroundColor: "#444",
        color: "white",
        borderRadius: "3px",
        marginLeft: "8px",
        cursor: "pointer"
    },
    ".cm-diagnosticSource": {
        fontSize: "70%",
        opacity: .7
    },
    ".cm-lintRange": {
        backgroundPosition: "left bottom",
        backgroundRepeat: "repeat-x",
        paddingBottom: "0.7px"
    },
    ".cm-lintRange-error": {
        backgroundImage: /*@__PURE__*/ $ab630557a18c0042$var$underline("#f11")
    },
    ".cm-lintRange-warning": {
        backgroundImage: /*@__PURE__*/ $ab630557a18c0042$var$underline("orange")
    },
    ".cm-lintRange-info": {
        backgroundImage: /*@__PURE__*/ $ab630557a18c0042$var$underline("#999")
    },
    ".cm-lintRange-hint": {
        backgroundImage: /*@__PURE__*/ $ab630557a18c0042$var$underline("#66d")
    },
    ".cm-lintRange-active": {
        backgroundColor: "#ffdd9980"
    },
    ".cm-tooltip-lint": {
        padding: 0,
        margin: 0
    },
    ".cm-lintPoint": {
        position: "relative",
        "&:after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "-2px",
            borderLeft: "3px solid transparent",
            borderRight: "3px solid transparent",
            borderBottom: "4px solid #d11"
        }
    },
    ".cm-lintPoint-warning": {
        "&:after": {
            borderBottomColor: "orange"
        }
    },
    ".cm-lintPoint-info": {
        "&:after": {
            borderBottomColor: "#999"
        }
    },
    ".cm-lintPoint-hint": {
        "&:after": {
            borderBottomColor: "#66d"
        }
    },
    ".cm-panel.cm-panel-lint": {
        position: "relative",
        "& ul": {
            maxHeight: "100px",
            overflowY: "auto",
            "& [aria-selected]": {
                backgroundColor: "#ddd",
                "& u": {
                    textDecoration: "underline"
                }
            },
            "&:focus [aria-selected]": {
                background_fallback: "#bdf",
                backgroundColor: "Highlight",
                color_fallback: "white",
                color: "HighlightText"
            },
            "& u": {
                textDecoration: "none"
            },
            padding: 0,
            margin: 0
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "2px",
            background: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        }
    },
    "&dark .cm-lintRange-active": {
        backgroundColor: "#86714a80"
    },
    "&dark .cm-panel.cm-panel-lint ul": {
        "& [aria-selected]": {
            backgroundColor: "#2e343e"
        }
    }
});
function $ab630557a18c0042$var$severityWeight(sev) {
    return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
function $ab630557a18c0042$var$maxSeverity(diagnostics) {
    let sev = "hint", weight = 1;
    for (let d of diagnostics){
        let w = $ab630557a18c0042$var$severityWeight(d.severity);
        if (w > weight) {
            weight = w;
            sev = d.severity;
        }
    }
    return sev;
}
class $ab630557a18c0042$var$LintGutterMarker extends (0, $b3e9d73db824614e$export$591ab4c909549043) {
    constructor(diagnostics){
        super();
        this.diagnostics = diagnostics;
        this.severity = $ab630557a18c0042$var$maxSeverity(diagnostics);
    }
    toDOM(view) {
        let elt = document.createElement("div");
        elt.className = "cm-lint-marker cm-lint-marker-" + this.severity;
        let diagnostics = this.diagnostics;
        let diagnosticsFilter = view.state.facet($ab630557a18c0042$var$lintGutterConfig).tooltipFilter;
        if (diagnosticsFilter) diagnostics = diagnosticsFilter(diagnostics, view.state);
        if (diagnostics.length) elt.onmouseover = ()=>$ab630557a18c0042$var$gutterMarkerMouseOver(view, elt, diagnostics);
        return elt;
    }
}
function $ab630557a18c0042$var$trackHoverOn(view, marker) {
    let mousemove = (event)=>{
        let rect = marker.getBoundingClientRect();
        if (event.clientX > rect.left - 10 /* Hover.Margin */  && event.clientX < rect.right + 10 /* Hover.Margin */  && event.clientY > rect.top - 10 /* Hover.Margin */  && event.clientY < rect.bottom + 10 /* Hover.Margin */ ) return;
        for(let target = event.target; target; target = target.parentNode){
            if (target.nodeType == 1 && target.classList.contains("cm-tooltip-lint")) return;
        }
        window.removeEventListener("mousemove", mousemove);
        if (view.state.field($ab630557a18c0042$var$lintGutterTooltip)) view.dispatch({
            effects: $ab630557a18c0042$var$setLintGutterTooltip.of(null)
        });
    };
    window.addEventListener("mousemove", mousemove);
}
function $ab630557a18c0042$var$gutterMarkerMouseOver(view, marker, diagnostics) {
    function hovered() {
        let line = view.elementAtHeight(marker.getBoundingClientRect().top + 5 - view.documentTop);
        const linePos = view.coordsAtPos(line.from);
        if (linePos) view.dispatch({
            effects: $ab630557a18c0042$var$setLintGutterTooltip.of({
                pos: line.from,
                above: false,
                clip: false,
                create () {
                    return {
                        dom: $ab630557a18c0042$var$diagnosticsTooltip(view, diagnostics),
                        getCoords: ()=>marker.getBoundingClientRect()
                    };
                }
            })
        });
        marker.onmouseout = marker.onmousemove = null;
        $ab630557a18c0042$var$trackHoverOn(view, marker);
    }
    let { hoverTime: hoverTime } = view.state.facet($ab630557a18c0042$var$lintGutterConfig);
    let hoverTimeout = setTimeout(hovered, hoverTime);
    marker.onmouseout = ()=>{
        clearTimeout(hoverTimeout);
        marker.onmouseout = marker.onmousemove = null;
    };
    marker.onmousemove = ()=>{
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(hovered, hoverTime);
    };
}
function $ab630557a18c0042$var$markersForDiagnostics(doc, diagnostics) {
    let byLine = Object.create(null);
    for (let diagnostic of diagnostics){
        let line = doc.lineAt(diagnostic.from);
        (byLine[line.from] || (byLine[line.from] = [])).push(diagnostic);
    }
    let markers = [];
    for(let line in byLine)markers.push(new $ab630557a18c0042$var$LintGutterMarker(byLine[line]).range(+line));
    return (0, $3ef527dddcdea745$export$34cb5241245008dd).of(markers, true);
}
const $ab630557a18c0042$var$lintGutterExtension = /*@__PURE__*/ (0, $b3e9d73db824614e$export$f2b922cb4a245974)({
    class: "cm-gutter-lint",
    markers: (view)=>view.state.field($ab630557a18c0042$var$lintGutterMarkers),
    widgetMarker: (view, widget, block)=>{
        let diagnostics = [];
        view.state.field($ab630557a18c0042$var$lintGutterMarkers).between(block.from, block.to, (from, to, value)=>{
            if (from > block.from && from < block.to) diagnostics.push(...value.diagnostics);
        });
        return diagnostics.length ? new $ab630557a18c0042$var$LintGutterMarker(diagnostics) : null;
    }
});
const $ab630557a18c0042$var$lintGutterMarkers = /*@__PURE__*/ (0, $3ef527dddcdea745$export$34381b1ce2130245).define({
    create () {
        return (0, $3ef527dddcdea745$export$34cb5241245008dd).empty;
    },
    update (markers, tr) {
        markers = markers.map(tr.changes);
        let diagnosticFilter = tr.state.facet($ab630557a18c0042$var$lintGutterConfig).markerFilter;
        for (let effect of tr.effects)if (effect.is($ab630557a18c0042$export$9c7976977981c7bf)) {
            let diagnostics = effect.value;
            if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics || [], tr.state);
            markers = $ab630557a18c0042$var$markersForDiagnostics(tr.state.doc, diagnostics.slice(0));
        }
        return markers;
    }
});
const $ab630557a18c0042$var$setLintGutterTooltip = /*@__PURE__*/ (0, $3ef527dddcdea745$export$95000d4efaa4321f).define();
const $ab630557a18c0042$var$lintGutterTooltip = /*@__PURE__*/ (0, $3ef527dddcdea745$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (tooltip, tr) {
        if (tooltip && tr.docChanged) tooltip = $ab630557a18c0042$var$hideTooltip(tr, tooltip) ? null : {
            ...tooltip,
            pos: tr.changes.mapPos(tooltip.pos)
        };
        return tr.effects.reduce((t, e)=>e.is($ab630557a18c0042$var$setLintGutterTooltip) ? e.value : t, tooltip);
    },
    provide: (field)=>(0, $b3e9d73db824614e$export$dba11b50e1aa3c12).from(field)
});
const $ab630557a18c0042$var$lintGutterTheme = /*@__PURE__*/ (0, $b3e9d73db824614e$export$eece2fccabbb77c5).baseTheme({
    ".cm-gutter-lint": {
        width: "1.4em",
        "& .cm-gutterElement": {
            padding: ".2em"
        }
    },
    ".cm-lint-marker": {
        width: "1em",
        height: "1em"
    },
    ".cm-lint-marker-info": {
        content: /*@__PURE__*/ $ab630557a18c0042$var$svg(`<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>`)
    },
    ".cm-lint-marker-warning": {
        content: /*@__PURE__*/ $ab630557a18c0042$var$svg(`<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>`)
    },
    ".cm-lint-marker-error": {
        content: /*@__PURE__*/ $ab630557a18c0042$var$svg(`<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>`)
    }
});
const $ab630557a18c0042$var$lintHover = /*@__PURE__*/ (0, $b3e9d73db824614e$export$69f8d9e63c4aa884)($ab630557a18c0042$var$lintTooltip, {
    hideOn: $ab630557a18c0042$var$hideTooltip
});
const $ab630557a18c0042$var$lintExtensions = [
    $ab630557a18c0042$var$lintState,
    /*@__PURE__*/ (0, $b3e9d73db824614e$export$eece2fccabbb77c5).decorations.compute([
        $ab630557a18c0042$var$lintState
    ], (state)=>{
        let { selected: selected, panel: panel } = state.field($ab630557a18c0042$var$lintState);
        return !selected || !panel || selected.from == selected.to ? (0, $b3e9d73db824614e$export$10e30b733df217ea).none : (0, $b3e9d73db824614e$export$10e30b733df217ea).set([
            $ab630557a18c0042$var$activeMark.range(selected.from, selected.to)
        ]);
    }),
    $ab630557a18c0042$var$lintHover,
    $ab630557a18c0042$var$baseTheme
];
const $ab630557a18c0042$var$lintGutterConfig = /*@__PURE__*/ (0, $3ef527dddcdea745$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $3ef527dddcdea745$export$4e19c0b693794a7e)(configs, {
            hoverTime: 300 /* Hover.Time */ ,
            markerFilter: null,
            tooltipFilter: null
        });
    }
});
/**
Returns an extension that installs a gutter showing markers for
each line that has diagnostics, which can be hovered over to see
the diagnostics.
*/ function $ab630557a18c0042$export$3a68dabf7c007d32(config = {}) {
    return [
        $ab630557a18c0042$var$lintGutterConfig.of(config),
        $ab630557a18c0042$var$lintGutterMarkers,
        $ab630557a18c0042$var$lintGutterExtension,
        $ab630557a18c0042$var$lintGutterTheme,
        $ab630557a18c0042$var$lintGutterTooltip
    ];
}
/**
Iterate over the marked diagnostics for the given editor state,
calling `f` for each of them. Note that, if the document changed
since the diagnostics were created, the `Diagnostic` object will
hold the original outdated position, whereas the `to` and `from`
arguments hold the diagnostic's current position.
*/ function $ab630557a18c0042$export$7991d57589868fb2(state, f) {
    let lState = state.field($ab630557a18c0042$var$lintState, false);
    if (lState && lState.diagnostics.size) {
        let pending = [], pendingStart = [], lastEnd = -1;
        for(let iter = (0, $3ef527dddcdea745$export$34cb5241245008dd).iter([
            lState.diagnostics
        ]);; iter.next()){
            for(let i = 0; i < pending.length; i++)if (!iter.value || iter.value.spec.diagnostics.indexOf(pending[i]) < 0) {
                f(pending[i], pendingStart[i], lastEnd);
                pending.splice(i, 1);
                pendingStart.splice(i--, 1);
            }
            if (!iter.value) break;
            for (let d of iter.value.spec.diagnostics)if (pending.indexOf(d) < 0) {
                pending.push(d);
                pendingStart.push(iter.from);
            }
            lastEnd = iter.to;
        }
    }
}






var $9fdcbf522ffb007f$exports = {};
"use strict";
var $9fdcbf522ffb007f$var$__createBinding = $9fdcbf522ffb007f$exports && $9fdcbf522ffb007f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9fdcbf522ffb007f$var$__exportStar = $9fdcbf522ffb007f$exports && $9fdcbf522ffb007f$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9fdcbf522ffb007f$var$__createBinding(exports1, m, p);
};
Object.defineProperty($9fdcbf522ffb007f$exports, "__esModule", {
    value: true
});
$9fdcbf522ffb007f$exports.init = $9fdcbf522ffb007f$var$init;
var $0cfd240e8508d7bd$exports = {};
"use strict";
var $0cfd240e8508d7bd$var$__createBinding = $0cfd240e8508d7bd$exports && $0cfd240e8508d7bd$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0cfd240e8508d7bd$var$__exportStar = $0cfd240e8508d7bd$exports && $0cfd240e8508d7bd$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0cfd240e8508d7bd$var$__createBinding(exports1, m, p);
};
Object.defineProperty($0cfd240e8508d7bd$exports, "__esModule", {
    value: true
});

$0cfd240e8508d7bd$var$__exportStar((parcelRequire("jVQ79")), $0cfd240e8508d7bd$exports);

$0cfd240e8508d7bd$var$__exportStar((parcelRequire("jM2ZR")), $0cfd240e8508d7bd$exports);



var $7tXKo = parcelRequire("7tXKo");

$9fdcbf522ffb007f$var$__exportStar((parcelRequire("jM2ZR")), $9fdcbf522ffb007f$exports);

$9fdcbf522ffb007f$var$__exportStar((parcelRequire("idFre")), $9fdcbf522ffb007f$exports);
async function $9fdcbf522ffb007f$var$init(moduleOverrides = {}) {
    const initZ3 = $parcel$global.initZ3;
    if (initZ3 === undefined) throw new Error('initZ3 was not imported correctly. Please consult documentation on how to load Z3 in browser');
    const lowLevel = await (0, $7tXKo.init)(initZ3, moduleOverrides);
    const highLevel = (0, $0cfd240e8508d7bd$exports.createApi)(lowLevel.Z3, lowLevel.em);
    return {
        ...lowLevel,
        ...highLevel
    };
}


const $a45cf0d60eac537f$var$STATUS = 0, $a45cf0d60eac537f$var$SIZE = 1;
const $a45cf0d60eac537f$var$IDLE = 0, $a45cf0d60eac537f$var$CLAIMED = 1, $a45cf0d60eac537f$var$REQUEST = 2, $a45cf0d60eac537f$var$OK = 3, $a45cf0d60eac537f$var$ERR = 4, $a45cf0d60eac537f$var$OVERFLOW = 5;
let $a45cf0d60eac537f$var$z3 = null;
let $a45cf0d60eac537f$var$busy = false;
let $a45cf0d60eac537f$var$unloadListener = null;
function $a45cf0d60eac537f$export$1f95fbd68d964d36(bufSize) {
    return {
        state: new Int32Array(new SharedArrayBuffer(8)),
        buf: new Uint8Array(new SharedArrayBuffer(bufSize))
    };
}
function $a45cf0d60eac537f$export$ad36032d9eb8a5c1(channel, smt2, wakeZ3Worker, timeoutMS = 30000) {
    const inBytes = new TextEncoder().encode(smt2);
    if (inBytes.length > channel.buf.length) throw new Error(`z3 query too large: ${inBytes.length} > ${channel.buf.length}`);
    const prev = Atomics.compareExchange(channel.state, $a45cf0d60eac537f$var$STATUS, $a45cf0d60eac537f$var$IDLE, $a45cf0d60eac537f$var$CLAIMED);
    if (prev !== $a45cf0d60eac537f$var$IDLE) throw new Error(`z3 channel should be idle (found ${prev})`);
    channel.buf.set(inBytes, 0);
    Atomics.store(channel.state, $a45cf0d60eac537f$var$SIZE, inBytes.length);
    Atomics.store(channel.state, $a45cf0d60eac537f$var$STATUS, $a45cf0d60eac537f$var$REQUEST);
    wakeZ3Worker();
    const until = Date.now() + timeoutMS;
    let status;
    for(;;){
        status = Atomics.load(channel.state, $a45cf0d60eac537f$var$STATUS);
        if (status !== $a45cf0d60eac537f$var$REQUEST) break;
        const left = until - Date.now();
        if (left <= 0) {
            Atomics.store(channel.state, $a45cf0d60eac537f$var$STATUS, $a45cf0d60eac537f$var$IDLE);
            throw new Error('solver timed out');
        }
        Atomics.wait(channel.state, $a45cf0d60eac537f$var$STATUS, $a45cf0d60eac537f$var$REQUEST, left);
    }
    const size = Atomics.load(channel.state, $a45cf0d60eac537f$var$SIZE);
    const payload = new TextDecoder().decode(channel.buf.slice(0, size));
    Atomics.store(channel.state, $a45cf0d60eac537f$var$STATUS, $a45cf0d60eac537f$var$IDLE);
    switch(status){
        case $a45cf0d60eac537f$var$OK:
            return payload;
        case $a45cf0d60eac537f$var$ERR:
            throw new Error(payload);
        case $a45cf0d60eac537f$var$OVERFLOW:
            throw new Error(`z3 response too large: ${size} bytes`);
        default:
            throw new Error(`bad state ${status}`);
    }
}
async function $a45cf0d60eac537f$export$11be27ee76890f47(channel) {
    if ($a45cf0d60eac537f$var$busy || Atomics.load(channel.state, $a45cf0d60eac537f$var$STATUS) !== $a45cf0d60eac537f$var$REQUEST) return;
    $a45cf0d60eac537f$var$busy = true;
    let status = $a45cf0d60eac537f$var$ERR;
    let out = new Uint8Array(0);
    try {
        if ($a45cf0d60eac537f$var$z3 === null) $a45cf0d60eac537f$var$z3 = (await (0, $9fdcbf522ffb007f$exports.init)({
            locateFile: (file)=>`/js/z3/${file}`
        })).Z3;
        const size = Atomics.load(channel.state, $a45cf0d60eac537f$var$SIZE);
        const smt2 = new TextDecoder().decode(channel.buf.slice(0, size));
        const cfg = $a45cf0d60eac537f$var$z3.mk_config();
        const ctx = $a45cf0d60eac537f$var$z3.mk_context(cfg);
        $a45cf0d60eac537f$var$unloadListener = ()=>{
            try {
                $a45cf0d60eac537f$var$z3?.interrupt(ctx);
                $a45cf0d60eac537f$var$z3?.del_context(ctx);
            } catch (e) {}
        };
        window.addEventListener("beforeunload", $a45cf0d60eac537f$var$unloadListener);
        $a45cf0d60eac537f$var$z3.del_config(cfg);
        try {
            const response = await $a45cf0d60eac537f$var$z3.eval_smtlib2_string(ctx, smt2);
            out = new TextEncoder().encode(response);
            status = $a45cf0d60eac537f$var$OK;
        } finally{
            window.removeEventListener("beforeunload", $a45cf0d60eac537f$var$unloadListener);
            $a45cf0d60eac537f$var$z3.del_context(ctx);
        }
    } catch (e) {
        out = new TextEncoder().encode(String(e));
        status = $a45cf0d60eac537f$var$ERR;
    }
    if (status === $a45cf0d60eac537f$var$OK && out.length > channel.buf.length) {
        Atomics.store(channel.state, $a45cf0d60eac537f$var$SIZE, out.length);
        status = $a45cf0d60eac537f$var$OVERFLOW;
    } else {
        channel.buf.set(out, 0);
        Atomics.store(channel.state, $a45cf0d60eac537f$var$SIZE, out.length);
    }
    Atomics.store(channel.state, $a45cf0d60eac537f$var$STATUS, status);
    Atomics.notify(channel.state, $a45cf0d60eac537f$var$STATUS);
    $a45cf0d60eac537f$var$busy = false;
}
function $a45cf0d60eac537f$export$2ad00cf18f8d82e3() {
    if ($a45cf0d60eac537f$var$z3 !== null) $a45cf0d60eac537f$var$z3.reset_memory();
}


let $dd6eac1f9e9f4cf2$var$worker = null;
let $dd6eac1f9e9f4cf2$var$z3Channel = $a45cf0d60eac537f$export$1f95fbd68d964d36(131072);
const $dd6eac1f9e9f4cf2$var$decorationData = new Map();
var $c19a79024efd293d$exports = {};
var $93a73e6a475fe9b3$exports = {};
"use strict";
$93a73e6a475fe9b3$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $c19a79024efd293d$var$url = new URL($parcel$resolve("9UtJ4"));
$c19a79024efd293d$exports = $93a73e6a475fe9b3$exports($c19a79024efd293d$var$url.toString(), $c19a79024efd293d$var$url.origin, false);


async function $dd6eac1f9e9f4cf2$var$getWorker(status) {
    if ($dd6eac1f9e9f4cf2$var$worker === null) {
        status.loading("loading compiler");
        $dd6eac1f9e9f4cf2$var$worker = new Worker($c19a79024efd293d$exports);
    }
    $dd6eac1f9e9f4cf2$var$worker.addEventListener("message", (event)=>{
        if (event.data.message === "calling Z3") $a45cf0d60eac537f$export$11be27ee76890f47($dd6eac1f9e9f4cf2$var$z3Channel);
    });
    const p = new Promise((resolve)=>{
        function handleReady(event) {
            if (event.data.message === "ready" && $dd6eac1f9e9f4cf2$var$worker !== null) {
                $dd6eac1f9e9f4cf2$var$worker.removeEventListener("message", handleReady);
                status.finished(false);
                resolve($dd6eac1f9e9f4cf2$var$worker);
            } else if (event.data.message !== undefined) status.loading(event.data.message);
        }
        if ($dd6eac1f9e9f4cf2$var$worker !== null) $dd6eac1f9e9f4cf2$var$worker.addEventListener("message", handleReady);
    });
    $dd6eac1f9e9f4cf2$var$worker.postMessage({
        message: "poke",
        channel: $dd6eac1f9e9f4cf2$var$z3Channel
    });
    return p;
}
function $dd6eac1f9e9f4cf2$export$59b47964d5ab398(diagnostics) {
    return diagnostics.filter((v)=>v.severity != "info");
}
const $dd6eac1f9e9f4cf2$export$46bdb2de187dbc9f = (editorId)=>{
    let editNumber = 0;
    $dd6eac1f9e9f4cf2$var$decorationData.set(editorId, []);
    const compilerStatus = new $dd6eac1f9e9f4cf2$var$StatusLine();
    return (0, $ab630557a18c0042$export$8bb7ef7a8be4cb1c)(async (view)=>{
        if (!compilerStatus.root.isConnected) view.dom.insertAdjacentElement("afterend", compilerStatus.root);
        editNumber += 1;
        const editId = `${editorId}-${editNumber}`;
        let worker = await $dd6eac1f9e9f4cf2$var$getWorker(compilerStatus);
        return new Promise((resolve)=>{
            worker.addEventListener("message", function listener(event) {
                if (event.data.id === editId) {
                    worker.removeEventListener("message", listener);
                    $dd6eac1f9e9f4cf2$var$decorationData.set(editorId, event.data.diagnostics.filter((e)=>e.severity === "info"));
                    $a45cf0d60eac537f$export$2ad00cf18f8d82e3();
                    compilerStatus.finished(event.data.compiler_error);
                    resolve(event.data.diagnostics);
                }
            });
            const message = {
                id: editId,
                code: view.state.doc.toString()
            };
            compilerStatus.loading("compiling");
            worker.postMessage(message);
        });
    }, {
        tooltipFilter: $dd6eac1f9e9f4cf2$export$59b47964d5ab398,
        markerFilter: $dd6eac1f9e9f4cf2$export$59b47964d5ab398,
        autoPanel: true,
        delay: 50
    });
};
const $dd6eac1f9e9f4cf2$var$typeDecoration = (0, $b3e9d73db824614e$export$10e30b733df217ea).mark({
    class: "type"
});
class $dd6eac1f9e9f4cf2$var$TypeHighlights {
    decorations;
    editorId;
    constructor(view, editorId){
        this.editorId = editorId;
        this.decorations = this.buildDecorations(view);
    }
    update(update) {
        const lintChanged = update.transactions.some((tr)=>tr.effects.some((effect)=>effect.is((0, $ab630557a18c0042$export$9c7976977981c7bf))));
        if (update.viewportChanged || lintChanged) this.decorations = this.buildDecorations(update.view);
    }
    buildDecorations(view) {
        const builder = new (0, $3ef527dddcdea745$export$89e09ce03c7e8594)();
        for (let { from: from, to: to } of view.visibleRanges){
            for (const diagnostic of $dd6eac1f9e9f4cf2$var$decorationData.get(this.editorId) || [])if (diagnostic.from <= to && diagnostic.to >= from && diagnostic.severity === "info") builder.add(diagnostic.from, diagnostic.to, $dd6eac1f9e9f4cf2$var$typeDecoration);
        }
        return builder.finish();
    }
}
const $dd6eac1f9e9f4cf2$export$79152c18929047dc = (0, $b3e9d73db824614e$export$44d5eccfd62adda7).fromClass($dd6eac1f9e9f4cf2$var$TypeHighlights, {
    decorations: (v)=>v.decorations
});
class $dd6eac1f9e9f4cf2$var$StatusLine {
    root;
    compilerLoader;
    compilerMessage;
    constructor(){
        this.root = document.createElement("div");
        this.root.classList.add("compiler_status");
        this.compilerLoader = document.createElement("span");
        this.compilerMessage = document.createElement("span");
        this.compilerLoader.classList.add("loader");
        this.loading("loading");
        this.root.appendChild(this.compilerLoader);
        this.root.appendChild(this.compilerMessage);
    }
    finished(compiler_error) {
        this.compilerLoader.classList.remove("loading");
        this.root.classList.remove("loading");
        if (compiler_error) {
            this.root.classList.add("error");
            this.compilerMessage.textContent = "compiler crashed";
        } else this.compilerMessage.textContent = "idle";
    }
    loading(message) {
        if (message !== undefined) this.compilerMessage.textContent = message;
        this.root.classList.remove("error");
        this.compilerLoader.classList.add("loading");
        this.root.classList.add("loading");
    }
}


function $36f1ff75eae5249d$var$main() {
    console.log("what are you, some kinda hacker?");
    const extensions = [
        (0, $b3e9d73db824614e$export$1a8cf111682eaa7d)(),
        (0, $d6ef25f90fa77b71$export$55abd4691b317664)(),
        (0, $b3e9d73db824614e$export$5043418e2ef368d5).of([
            ...(0, $d6ef25f90fa77b71$export$ab2e8d0ac5d2b69e),
            ...(0, $d6ef25f90fa77b71$export$ab4a28cb63e8a670)
        ]),
        (0, $5493a697db18a17a$export$f7857270615ae18f),
        (0, $5493a697db18a17a$export$3f1472e2e2f8ef40),
        (0, $d245ca63c4fe5041$export$cef7edfd214be605)(),
        (0, $ab630557a18c0042$export$3a68dabf7c007d32)({
            markerFilter: (0, $dd6eac1f9e9f4cf2$export$59b47964d5ab398)
        })
    ];
    for (const [i, editor] of document.querySelectorAll(".editor").entries()){
        const code = editor.textContent.trimEnd();
        editor.textContent = "";
        new (0, $b3e9d73db824614e$export$eece2fccabbb77c5)({
            parent: editor,
            doc: code,
            extensions: [
                (0, $dd6eac1f9e9f4cf2$export$46bdb2de187dbc9f)(i),
                (0, $dd6eac1f9e9f4cf2$export$79152c18929047dc).of(i),
                ...extensions
            ]
        });
    }
}
if (document.readyState === "complete") $36f1ff75eae5249d$var$main();
else document.addEventListener("DOMContentLoaded", $36f1ff75eae5249d$var$main);

})();
//# sourceMappingURL=index.js.map
